import type { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    Date: { input: unknown; output: unknown };
    DateTime: { input: string; output: string };
    Hex: { input: unknown; output: unknown };
    Json: { input: unknown; output: unknown };
    Long: { input: unknown; output: unknown };
    RGBAHue: { input: unknown; output: unknown };
    RGBATransparency: { input: unknown; output: unknown };
    RichTextAST: { input: unknown; output: unknown };
};

export type Address = Entity & {
    __typename?: 'Address';
    city?: Maybe<Scalars['String']['output']>;
    houseNumber?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** System stage field */
    stage: Stage;
    street?: Maybe<Scalars['String']['output']>;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type AddressConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: AddressWhereUniqueInput;
};

/** A connection to a list of items. */
export type AddressConnection = {
    __typename?: 'AddressConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<AddressEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type AddressCreateInput = {
    city?: InputMaybe<Scalars['String']['input']>;
    houseNumber?: InputMaybe<Scalars['String']['input']>;
    street?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateManyInlineInput = {
    /** Create and connect multiple existing Address documents */
    create?: InputMaybe<Array<AddressCreateInput>>;
};

export type AddressCreateOneInlineInput = {
    /** Create and connect one Address document */
    create?: InputMaybe<AddressCreateInput>;
};

export type AddressCreateWithPositionInput = {
    /** Document to create */
    data: AddressCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type AddressEdge = {
    __typename?: 'AddressEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Address;
};

/** Identifies documents */
export type AddressManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<AddressWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<AddressWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<AddressWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    city_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    city_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    city_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    city_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    city_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    city_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    city_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    city_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    city_starts_with?: InputMaybe<Scalars['String']['input']>;
    houseNumber?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    houseNumber_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    houseNumber_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    houseNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    houseNumber_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    houseNumber_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    houseNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    houseNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    houseNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    houseNumber_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    street?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    street_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    street_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    street_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    street_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    street_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    street_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    street_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    street_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    street_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    zip?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    zip_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    zip_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    zip_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    zip_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    zip_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    zip_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    zip_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    zip_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    zip_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum AddressOrderByInput {
    CityAsc = 'city_ASC',
    CityDesc = 'city_DESC',
    HouseNumberAsc = 'houseNumber_ASC',
    HouseNumberDesc = 'houseNumber_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    StreetAsc = 'street_ASC',
    StreetDesc = 'street_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
    ZipAsc = 'zip_ASC',
    ZipDesc = 'zip_DESC',
}

export type AddressParent = Dealer;

export type AddressParentConnectInput = {
    Dealer?: InputMaybe<DealerConnectInput>;
};

export type AddressParentCreateInput = {
    Dealer?: InputMaybe<DealerCreateInput>;
};

export type AddressParentCreateManyInlineInput = {
    /** Connect multiple existing AddressParent documents */
    connect?: InputMaybe<Array<AddressParentWhereUniqueInput>>;
    /** Create and connect multiple existing AddressParent documents */
    create?: InputMaybe<Array<AddressParentCreateInput>>;
};

export type AddressParentCreateOneInlineInput = {
    /** Connect one existing AddressParent document */
    connect?: InputMaybe<AddressParentWhereUniqueInput>;
    /** Create and connect one AddressParent document */
    create?: InputMaybe<AddressParentCreateInput>;
};

export type AddressParentUpdateInput = {
    Dealer?: InputMaybe<DealerUpdateInput>;
};

export type AddressParentUpdateManyInlineInput = {
    /** Connect multiple existing AddressParent documents */
    connect?: InputMaybe<Array<AddressParentConnectInput>>;
    /** Create and connect multiple AddressParent documents */
    create?: InputMaybe<Array<AddressParentCreateInput>>;
    /** Delete multiple AddressParent documents */
    delete?: InputMaybe<Array<AddressParentWhereUniqueInput>>;
    /** Disconnect multiple AddressParent documents */
    disconnect?: InputMaybe<Array<AddressParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing AddressParent documents */
    set?: InputMaybe<Array<AddressParentWhereUniqueInput>>;
    /** Update multiple AddressParent documents */
    update?: InputMaybe<Array<AddressParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple AddressParent documents */
    upsert?: InputMaybe<Array<AddressParentUpsertWithNestedWhereUniqueInput>>;
};

export type AddressParentUpdateManyWithNestedWhereInput = {
    Dealer?: InputMaybe<DealerUpdateManyWithNestedWhereInput>;
};

export type AddressParentUpdateOneInlineInput = {
    /** Connect existing AddressParent document */
    connect?: InputMaybe<AddressParentWhereUniqueInput>;
    /** Create and connect one AddressParent document */
    create?: InputMaybe<AddressParentCreateInput>;
    /** Delete currently connected AddressParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected AddressParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single AddressParent document */
    update?: InputMaybe<AddressParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single AddressParent document */
    upsert?: InputMaybe<AddressParentUpsertWithNestedWhereUniqueInput>;
};

export type AddressParentUpdateWithNestedWhereUniqueInput = {
    Dealer?: InputMaybe<DealerUpdateWithNestedWhereUniqueInput>;
};

export type AddressParentUpsertWithNestedWhereUniqueInput = {
    Dealer?: InputMaybe<DealerUpsertWithNestedWhereUniqueInput>;
};

export type AddressParentWhereInput = {
    Dealer?: InputMaybe<DealerWhereInput>;
};

export type AddressParentWhereUniqueInput = {
    Dealer?: InputMaybe<DealerWhereUniqueInput>;
};

export type AddressUpdateInput = {
    city?: InputMaybe<Scalars['String']['input']>;
    houseNumber?: InputMaybe<Scalars['String']['input']>;
    street?: InputMaybe<Scalars['String']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdateManyInlineInput = {
    /** Create and connect multiple Address component instances */
    create?: InputMaybe<Array<AddressCreateWithPositionInput>>;
    /** Delete multiple Address documents */
    delete?: InputMaybe<Array<AddressWhereUniqueInput>>;
    /** Update multiple Address component instances */
    update?: InputMaybe<Array<AddressUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple Address component instances */
    upsert?: InputMaybe<Array<AddressUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type AddressUpdateManyInput = {
    city?: InputMaybe<Scalars['String']['input']>;
    houseNumber?: InputMaybe<Scalars['String']['input']>;
    street?: InputMaybe<Scalars['String']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: AddressUpdateManyInput;
    /** Document search */
    where: AddressWhereInput;
};

export type AddressUpdateOneInlineInput = {
    /** Create and connect one Address document */
    create?: InputMaybe<AddressCreateInput>;
    /** Delete currently connected Address document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Address document */
    update?: InputMaybe<AddressUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Address document */
    upsert?: InputMaybe<AddressUpsertWithNestedWhereUniqueInput>;
};

export type AddressUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<AddressUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: AddressWhereUniqueInput;
};

export type AddressUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: AddressUpdateInput;
    /** Unique document search */
    where: AddressWhereUniqueInput;
};

export type AddressUpsertInput = {
    /** Create document if it didn't exist */
    create: AddressCreateInput;
    /** Update document if it exists */
    update: AddressUpdateInput;
};

export type AddressUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<AddressUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: AddressWhereUniqueInput;
};

export type AddressUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: AddressUpsertInput;
    /** Unique document search */
    where: AddressWhereUniqueInput;
};

/** Identifies documents */
export type AddressWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<AddressWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<AddressWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<AddressWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    city_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    city_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    city_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    city_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    city_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    city_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    city_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    city_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    city_starts_with?: InputMaybe<Scalars['String']['input']>;
    houseNumber?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    houseNumber_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    houseNumber_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    houseNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    houseNumber_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    houseNumber_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    houseNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    houseNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    houseNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    houseNumber_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    street?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    street_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    street_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    street_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    street_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    street_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    street_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    street_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    street_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    street_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    zip?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    zip_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    zip_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    zip_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    zip_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    zip_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    zip_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    zip_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    zip_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    zip_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References Address record uniquely */
export type AddressWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type AfterSale = Entity & {
    __typename?: 'AfterSale';
    afterSalesAccesories: Array<CampaignAfterSalesAccesory>;
    afterSalesServices: Array<CampaignAfterSalesService>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Wird im hellblauen Aktions-Banner für KeyCampaigns ausgegeben */
    minimumShortTitle: Scalars['String']['output'];
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AfterSaleAfterSalesAccesoriesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<CampaignAfterSalesAccesoryOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CampaignAfterSalesAccesoryWhereInput>;
};

export type AfterSaleAfterSalesServicesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<CampaignAfterSalesServiceOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CampaignAfterSalesServiceWhereInput>;
};

export type AfterSaleConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: AfterSaleWhereUniqueInput;
};

/** A connection to a list of items. */
export type AfterSaleConnection = {
    __typename?: 'AfterSaleConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<AfterSaleEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type AfterSaleCreateInput = {
    afterSalesAccesories?: InputMaybe<CampaignAfterSalesAccesoryCreateManyInlineInput>;
    afterSalesServices?: InputMaybe<CampaignAfterSalesServiceCreateManyInlineInput>;
    minimumShortTitle: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AfterSaleCreateManyInlineInput = {
    /** Create and connect multiple existing AfterSale documents */
    create?: InputMaybe<Array<AfterSaleCreateInput>>;
};

export type AfterSaleCreateOneInlineInput = {
    /** Create and connect one AfterSale document */
    create?: InputMaybe<AfterSaleCreateInput>;
};

export type AfterSaleCreateWithPositionInput = {
    /** Document to create */
    data: AfterSaleCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type AfterSaleEdge = {
    __typename?: 'AfterSaleEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: AfterSale;
};

/** Identifies documents */
export type AfterSaleManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<AfterSaleWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<AfterSaleWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<AfterSaleWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    afterSalesAccesories_every?: InputMaybe<CampaignAfterSalesAccesoryWhereInput>;
    afterSalesAccesories_none?: InputMaybe<CampaignAfterSalesAccesoryWhereInput>;
    afterSalesAccesories_some?: InputMaybe<CampaignAfterSalesAccesoryWhereInput>;
    afterSalesServices_every?: InputMaybe<CampaignAfterSalesServiceWhereInput>;
    afterSalesServices_none?: InputMaybe<CampaignAfterSalesServiceWhereInput>;
    afterSalesServices_some?: InputMaybe<CampaignAfterSalesServiceWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    minimumShortTitle?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    minimumShortTitle_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    minimumShortTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    minimumShortTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    minimumShortTitle_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    minimumShortTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    minimumShortTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    minimumShortTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    minimumShortTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    minimumShortTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum AfterSaleOrderByInput {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    MinimumShortTitleAsc = 'minimumShortTitle_ASC',
    MinimumShortTitleDesc = 'minimumShortTitle_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type AfterSaleParent = Campaign;

export type AfterSaleParentConnectInput = {
    Campaign?: InputMaybe<CampaignConnectInput>;
};

export type AfterSaleParentCreateInput = {
    Campaign?: InputMaybe<CampaignCreateInput>;
};

export type AfterSaleParentCreateManyInlineInput = {
    /** Connect multiple existing AfterSaleParent documents */
    connect?: InputMaybe<Array<AfterSaleParentWhereUniqueInput>>;
    /** Create and connect multiple existing AfterSaleParent documents */
    create?: InputMaybe<Array<AfterSaleParentCreateInput>>;
};

export type AfterSaleParentCreateOneInlineInput = {
    /** Connect one existing AfterSaleParent document */
    connect?: InputMaybe<AfterSaleParentWhereUniqueInput>;
    /** Create and connect one AfterSaleParent document */
    create?: InputMaybe<AfterSaleParentCreateInput>;
};

export type AfterSaleParentUpdateInput = {
    Campaign?: InputMaybe<CampaignUpdateInput>;
};

export type AfterSaleParentUpdateManyInlineInput = {
    /** Connect multiple existing AfterSaleParent documents */
    connect?: InputMaybe<Array<AfterSaleParentConnectInput>>;
    /** Create and connect multiple AfterSaleParent documents */
    create?: InputMaybe<Array<AfterSaleParentCreateInput>>;
    /** Delete multiple AfterSaleParent documents */
    delete?: InputMaybe<Array<AfterSaleParentWhereUniqueInput>>;
    /** Disconnect multiple AfterSaleParent documents */
    disconnect?: InputMaybe<Array<AfterSaleParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing AfterSaleParent documents */
    set?: InputMaybe<Array<AfterSaleParentWhereUniqueInput>>;
    /** Update multiple AfterSaleParent documents */
    update?: InputMaybe<Array<AfterSaleParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple AfterSaleParent documents */
    upsert?: InputMaybe<Array<AfterSaleParentUpsertWithNestedWhereUniqueInput>>;
};

export type AfterSaleParentUpdateManyWithNestedWhereInput = {
    Campaign?: InputMaybe<CampaignUpdateManyWithNestedWhereInput>;
};

export type AfterSaleParentUpdateOneInlineInput = {
    /** Connect existing AfterSaleParent document */
    connect?: InputMaybe<AfterSaleParentWhereUniqueInput>;
    /** Create and connect one AfterSaleParent document */
    create?: InputMaybe<AfterSaleParentCreateInput>;
    /** Delete currently connected AfterSaleParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected AfterSaleParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single AfterSaleParent document */
    update?: InputMaybe<AfterSaleParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single AfterSaleParent document */
    upsert?: InputMaybe<AfterSaleParentUpsertWithNestedWhereUniqueInput>;
};

export type AfterSaleParentUpdateWithNestedWhereUniqueInput = {
    Campaign?: InputMaybe<CampaignUpdateWithNestedWhereUniqueInput>;
};

export type AfterSaleParentUpsertWithNestedWhereUniqueInput = {
    Campaign?: InputMaybe<CampaignUpsertWithNestedWhereUniqueInput>;
};

export type AfterSaleParentWhereInput = {
    Campaign?: InputMaybe<CampaignWhereInput>;
};

export type AfterSaleParentWhereUniqueInput = {
    Campaign?: InputMaybe<CampaignWhereUniqueInput>;
};

export type AfterSaleUpdateInput = {
    afterSalesAccesories?: InputMaybe<CampaignAfterSalesAccesoryUpdateManyInlineInput>;
    afterSalesServices?: InputMaybe<CampaignAfterSalesServiceUpdateManyInlineInput>;
    minimumShortTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AfterSaleUpdateManyInlineInput = {
    /** Create and connect multiple AfterSale component instances */
    create?: InputMaybe<Array<AfterSaleCreateWithPositionInput>>;
    /** Delete multiple AfterSale documents */
    delete?: InputMaybe<Array<AfterSaleWhereUniqueInput>>;
    /** Update multiple AfterSale component instances */
    update?: InputMaybe<Array<AfterSaleUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple AfterSale component instances */
    upsert?: InputMaybe<Array<AfterSaleUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type AfterSaleUpdateManyInput = {
    minimumShortTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AfterSaleUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: AfterSaleUpdateManyInput;
    /** Document search */
    where: AfterSaleWhereInput;
};

export type AfterSaleUpdateOneInlineInput = {
    /** Create and connect one AfterSale document */
    create?: InputMaybe<AfterSaleCreateInput>;
    /** Delete currently connected AfterSale document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single AfterSale document */
    update?: InputMaybe<AfterSaleUpdateWithNestedWhereUniqueInput>;
    /** Upsert single AfterSale document */
    upsert?: InputMaybe<AfterSaleUpsertWithNestedWhereUniqueInput>;
};

export type AfterSaleUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<AfterSaleUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: AfterSaleWhereUniqueInput;
};

export type AfterSaleUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: AfterSaleUpdateInput;
    /** Unique document search */
    where: AfterSaleWhereUniqueInput;
};

export type AfterSaleUpsertInput = {
    /** Create document if it didn't exist */
    create: AfterSaleCreateInput;
    /** Update document if it exists */
    update: AfterSaleUpdateInput;
};

export type AfterSaleUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<AfterSaleUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: AfterSaleWhereUniqueInput;
};

export type AfterSaleUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: AfterSaleUpsertInput;
    /** Unique document search */
    where: AfterSaleWhereUniqueInput;
};

/** Identifies documents */
export type AfterSaleWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<AfterSaleWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<AfterSaleWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<AfterSaleWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    afterSalesAccesories_every?: InputMaybe<CampaignAfterSalesAccesoryWhereInput>;
    afterSalesAccesories_none?: InputMaybe<CampaignAfterSalesAccesoryWhereInput>;
    afterSalesAccesories_some?: InputMaybe<CampaignAfterSalesAccesoryWhereInput>;
    afterSalesServices_every?: InputMaybe<CampaignAfterSalesServiceWhereInput>;
    afterSalesServices_none?: InputMaybe<CampaignAfterSalesServiceWhereInput>;
    afterSalesServices_some?: InputMaybe<CampaignAfterSalesServiceWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    minimumShortTitle?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    minimumShortTitle_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    minimumShortTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    minimumShortTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    minimumShortTitle_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    minimumShortTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    minimumShortTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    minimumShortTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    minimumShortTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    minimumShortTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References AfterSale record uniquely */
export type AfterSaleWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type Aggregate = {
    __typename?: 'Aggregate';
    count: Scalars['Int']['output'];
};

/** Asset system model */
export type Asset = Entity &
    Node & {
        __typename?: 'Asset';
        alt?: Maybe<Scalars['String']['output']>;
        businessCenterHighlight1ImagePageBusinessCustomer: Array<PageBusinessCustomer>;
        businessCenterHighlight2ImagePageBusinessCustomer: Array<PageBusinessCustomer>;
        contentImageOverlayBatteryCertificate: Array<OverlayBatteryCertificate>;
        contentImagePageHyundaiPromise: Array<PageHyundaiPromise>;
        contentImagesModel: Array<Model>;
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Get the document in other stages */
        documentInStages: Array<Asset>;
        downloadPdfWarranty: Array<Warranty>;
        employeePlaceholderPageAboutUs: Array<PageAboutUs>;
        /** The file name */
        fileName: Scalars['String']['output'];
        /** The file handle */
        handle: Scalars['String']['output'];
        hcmTeaserImagePageHome: Array<PageHome>;
        /** The height of the file */
        height?: Maybe<Scalars['Float']['output']>;
        heroImageCampaign: Array<Campaign>;
        heroImageModel: Array<Model>;
        heroImageOverlayBatteryCertificate: Array<OverlayBatteryCertificate>;
        heroImagePageAboutUs: Array<PageAboutUs>;
        heroImagePageBusinessCustomer: Array<PageBusinessCustomer>;
        heroImagePageHyundaiPromise: Array<PageHyundaiPromise>;
        heroImagePageService: Array<PageService>;
        heroImagePageWarranty: Array<PageWarranty>;
        /** List of Asset versions */
        history: Array<Version>;
        iconGeneralService: Array<GeneralService>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        imageCampaignService: Array<CampaignService>;
        imageGeneralService: Array<GeneralService>;
        imageHomeTeaser: Array<HomeTeaser>;
        imageModel: Array<Model>;
        imageWarranty: Array<Warranty>;
        jobsHeroImagePageAboutUs: Array<PageAboutUs>;
        /** System Locale field */
        locale: Locale;
        /** Get the other localizations for this document */
        localizations: Array<Asset>;
        logoDealer: Array<Dealer>;
        logoImagesModel: Array<Model>;
        menuImageDealer: Array<Dealer>;
        /** The mime type of the file */
        mimeType?: Maybe<Scalars['String']['output']>;
        partStoreTeaserImagePageService: Array<PageService>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** The file size */
        size?: Maybe<Scalars['Float']['output']>;
        /** System stage field */
        stage: Stage;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
        /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
        upload?: Maybe<AssetUpload>;
        /** Get the url for the asset with provided transformations applied. */
        url: Scalars['String']['output'];
        videoPageHyundaiPromise: Array<PageHyundaiPromise>;
        /** The file width */
        width?: Maybe<Scalars['Float']['output']>;
    };

/** Asset system model */
export type AssetBusinessCenterHighlight1ImagePageBusinessCustomerArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageBusinessCustomerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageBusinessCustomerWhereInput>;
};

/** Asset system model */
export type AssetBusinessCenterHighlight2ImagePageBusinessCustomerArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageBusinessCustomerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageBusinessCustomerWhereInput>;
};

/** Asset system model */
export type AssetContentImageOverlayBatteryCertificateArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<OverlayBatteryCertificateOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OverlayBatteryCertificateWhereInput>;
};

/** Asset system model */
export type AssetContentImagePageHyundaiPromiseArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageHyundaiPromiseOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageHyundaiPromiseWhereInput>;
};

/** Asset system model */
export type AssetContentImagesModelArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<ModelOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ModelWhereInput>;
};

/** Asset system model */
export type AssetCreatedAtArgs = {
    variation?: SystemDateTimeFieldVariation;
};

/** Asset system model */
export type AssetCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

/** Asset system model */
export type AssetDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

/** Asset system model */
export type AssetDownloadPdfWarrantyArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<WarrantyOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<WarrantyWhereInput>;
};

/** Asset system model */
export type AssetEmployeePlaceholderPageAboutUsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageAboutUsOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageAboutUsWhereInput>;
};

/** Asset system model */
export type AssetHcmTeaserImagePageHomeArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageHomeOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageHomeWhereInput>;
};

/** Asset system model */
export type AssetHeroImageCampaignArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<CampaignOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CampaignWhereInput>;
};

/** Asset system model */
export type AssetHeroImageModelArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<ModelOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ModelWhereInput>;
};

/** Asset system model */
export type AssetHeroImageOverlayBatteryCertificateArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<OverlayBatteryCertificateOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OverlayBatteryCertificateWhereInput>;
};

/** Asset system model */
export type AssetHeroImagePageAboutUsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageAboutUsOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageAboutUsWhereInput>;
};

/** Asset system model */
export type AssetHeroImagePageBusinessCustomerArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageBusinessCustomerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageBusinessCustomerWhereInput>;
};

/** Asset system model */
export type AssetHeroImagePageHyundaiPromiseArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageHyundaiPromiseOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageHyundaiPromiseWhereInput>;
};

/** Asset system model */
export type AssetHeroImagePageServiceArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageServiceOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageServiceWhereInput>;
};

/** Asset system model */
export type AssetHeroImagePageWarrantyArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageWarrantyOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageWarrantyWhereInput>;
};

/** Asset system model */
export type AssetHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

/** Asset system model */
export type AssetIconGeneralServiceArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<GeneralServiceOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GeneralServiceWhereInput>;
};

/** Asset system model */
export type AssetImageCampaignServiceArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<CampaignServiceOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CampaignServiceWhereInput>;
};

/** Asset system model */
export type AssetImageGeneralServiceArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<GeneralServiceOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GeneralServiceWhereInput>;
};

/** Asset system model */
export type AssetImageHomeTeaserArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<HomeTeaserOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HomeTeaserWhereInput>;
};

/** Asset system model */
export type AssetImageModelArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<ModelOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ModelWhereInput>;
};

/** Asset system model */
export type AssetImageWarrantyArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<WarrantyOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<WarrantyWhereInput>;
};

/** Asset system model */
export type AssetJobsHeroImagePageAboutUsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageAboutUsOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageAboutUsWhereInput>;
};

/** Asset system model */
export type AssetLocalizationsArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    locales?: Array<Locale>;
};

/** Asset system model */
export type AssetLogoDealerArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<DealerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DealerWhereInput>;
};

/** Asset system model */
export type AssetLogoImagesModelArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<ModelOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ModelWhereInput>;
};

/** Asset system model */
export type AssetMenuImageDealerArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<DealerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DealerWhereInput>;
};

/** Asset system model */
export type AssetPartStoreTeaserImagePageServiceArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageServiceOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageServiceWhereInput>;
};

/** Asset system model */
export type AssetPublishedAtArgs = {
    variation?: SystemDateTimeFieldVariation;
};

/** Asset system model */
export type AssetPublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

/** Asset system model */
export type AssetScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** Asset system model */
export type AssetUpdatedAtArgs = {
    variation?: SystemDateTimeFieldVariation;
};

/** Asset system model */
export type AssetUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

/** Asset system model */
export type AssetUrlArgs = {
    transformation?: InputMaybe<AssetTransformationInput>;
};

/** Asset system model */
export type AssetVideoPageHyundaiPromiseArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<PageHyundaiPromiseOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageHyundaiPromiseWhereInput>;
};

export type AssetConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: AssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetConnection = {
    __typename?: 'AssetConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<AssetEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type AssetCreateInput = {
    alt?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1ImagePageBusinessCustomer?: InputMaybe<PageBusinessCustomerCreateManyInlineInput>;
    businessCenterHighlight2ImagePageBusinessCustomer?: InputMaybe<PageBusinessCustomerCreateManyInlineInput>;
    contentImageOverlayBatteryCertificate?: InputMaybe<OverlayBatteryCertificateCreateManyInlineInput>;
    contentImagePageHyundaiPromise?: InputMaybe<PageHyundaiPromiseCreateManyInlineInput>;
    contentImageSalesCampaignModel?: InputMaybe<SalesCampaignModelCreateManyInlineInput>;
    contentImagesModel?: InputMaybe<ModelCreateManyInlineInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    downloadPdfWarranty?: InputMaybe<WarrantyCreateManyInlineInput>;
    employeePlaceholderPageAboutUs?: InputMaybe<PageAboutUsCreateManyInlineInput>;
    fileName?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserImagePageHome?: InputMaybe<PageHomeCreateManyInlineInput>;
    heroImageCampaign?: InputMaybe<CampaignCreateManyInlineInput>;
    heroImageModel?: InputMaybe<ModelCreateManyInlineInput>;
    heroImageOverlayBatteryCertificate?: InputMaybe<OverlayBatteryCertificateCreateManyInlineInput>;
    heroImagePageAboutUs?: InputMaybe<PageAboutUsCreateManyInlineInput>;
    heroImagePageBusinessCustomer?: InputMaybe<PageBusinessCustomerCreateManyInlineInput>;
    heroImagePageHyundaiPromise?: InputMaybe<PageHyundaiPromiseCreateManyInlineInput>;
    heroImagePageService?: InputMaybe<PageServiceCreateManyInlineInput>;
    heroImagePageWarranty?: InputMaybe<PageWarrantyCreateManyInlineInput>;
    highlightModuleAssetSalesCampaignContent?: InputMaybe<SalesCampaignContentCreateManyInlineInput>;
    highlightTeaserImageCampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryCreateManyInlineInput>;
    iconCampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryCreateManyInlineInput>;
    iconCampaignAfterSalesService?: InputMaybe<CampaignAfterSalesServiceCreateManyInlineInput>;
    iconGeneralService?: InputMaybe<GeneralServiceCreateManyInlineInput>;
    iconIconText?: InputMaybe<IconTextCreateManyInlineInput>;
    imageCampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryCreateManyInlineInput>;
    imageCampaignAfterSalesService?: InputMaybe<CampaignAfterSalesServiceCreateManyInlineInput>;
    imageCampaignService?: InputMaybe<CampaignServiceCreateManyInlineInput>;
    imageGeneralService?: InputMaybe<GeneralServiceCreateManyInlineInput>;
    imageHomeTeaser?: InputMaybe<HomeTeaserCreateManyInlineInput>;
    imageModel?: InputMaybe<ModelCreateManyInlineInput>;
    imageSalesCampaignModel?: InputMaybe<SalesCampaignModelCreateManyInlineInput>;
    imageWarranty?: InputMaybe<WarrantyCreateManyInlineInput>;
    jobsHeroImagePageAboutUs?: InputMaybe<PageAboutUsCreateManyInlineInput>;
    /** Inline mutations for managing document localizations excluding the default locale */
    localizations?: InputMaybe<AssetCreateLocalizationsInput>;
    logoDealer?: InputMaybe<DealerCreateManyInlineInput>;
    logoImagesModel?: InputMaybe<ModelCreateManyInlineInput>;
    menuImageDealer?: InputMaybe<DealerCreateManyInlineInput>;
    offerImageSalesCampaignModel?: InputMaybe<SalesCampaignModelCreateManyInlineInput>;
    partStoreTeaserImagePageService?: InputMaybe<PageServiceCreateManyInlineInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
    uploadUrl?: InputMaybe<Scalars['String']['input']>;
    videoPageHyundaiPromise?: InputMaybe<PageHyundaiPromiseCreateManyInlineInput>;
    warrantyLogo1ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentCreateManyInlineInput>;
    warrantyLogo1SalesCampaignContent?: InputMaybe<SalesCampaignContentCreateManyInlineInput>;
    warrantyLogo2ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentCreateManyInlineInput>;
    warrantyLogo2SalesCampaignContent?: InputMaybe<SalesCampaignContentCreateManyInlineInput>;
    warrantyLogo3ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentCreateManyInlineInput>;
    warrantyLogo3SalesCampaignContent?: InputMaybe<SalesCampaignContentCreateManyInlineInput>;
};

export type AssetCreateLocalizationDataInput = {
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    fileName?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
    uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationInput = {
    /** Localization input */
    data: AssetCreateLocalizationDataInput;
    locale: Locale;
};

export type AssetCreateLocalizationsInput = {
    /** Create localizations for the newly-created document */
    create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateManyInlineInput = {
    /** Connect multiple existing Asset documents */
    connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
    /** Create and connect multiple existing Asset documents */
    create?: InputMaybe<Array<AssetCreateInput>>;
};

export type AssetCreateOneInlineInput = {
    /** Connect one existing Asset document */
    connect?: InputMaybe<AssetWhereUniqueInput>;
    /** Create and connect one Asset document */
    create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
    __typename?: 'AssetEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<AssetWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<AssetWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<AssetWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    alt?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    alt_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    alt_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    alt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    alt_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    alt_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    alt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    alt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    alt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    alt_starts_with?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1ImagePageBusinessCustomer_every?: InputMaybe<PageBusinessCustomerWhereInput>;
    businessCenterHighlight1ImagePageBusinessCustomer_none?: InputMaybe<PageBusinessCustomerWhereInput>;
    businessCenterHighlight1ImagePageBusinessCustomer_some?: InputMaybe<PageBusinessCustomerWhereInput>;
    businessCenterHighlight2ImagePageBusinessCustomer_every?: InputMaybe<PageBusinessCustomerWhereInput>;
    businessCenterHighlight2ImagePageBusinessCustomer_none?: InputMaybe<PageBusinessCustomerWhereInput>;
    businessCenterHighlight2ImagePageBusinessCustomer_some?: InputMaybe<PageBusinessCustomerWhereInput>;
    contentImageOverlayBatteryCertificate_every?: InputMaybe<OverlayBatteryCertificateWhereInput>;
    contentImageOverlayBatteryCertificate_none?: InputMaybe<OverlayBatteryCertificateWhereInput>;
    contentImageOverlayBatteryCertificate_some?: InputMaybe<OverlayBatteryCertificateWhereInput>;
    contentImagePageHyundaiPromise_every?: InputMaybe<PageHyundaiPromiseWhereInput>;
    contentImagePageHyundaiPromise_none?: InputMaybe<PageHyundaiPromiseWhereInput>;
    contentImagePageHyundaiPromise_some?: InputMaybe<PageHyundaiPromiseWhereInput>;
    contentImagesModel_every?: InputMaybe<ModelWhereInput>;
    contentImagesModel_none?: InputMaybe<ModelWhereInput>;
    contentImagesModel_some?: InputMaybe<ModelWhereInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<AssetWhereStageInput>;
    documentInStages_none?: InputMaybe<AssetWhereStageInput>;
    documentInStages_some?: InputMaybe<AssetWhereStageInput>;
    downloadPdfWarranty_every?: InputMaybe<WarrantyWhereInput>;
    downloadPdfWarranty_none?: InputMaybe<WarrantyWhereInput>;
    downloadPdfWarranty_some?: InputMaybe<WarrantyWhereInput>;
    employeePlaceholderPageAboutUs_every?: InputMaybe<PageAboutUsWhereInput>;
    employeePlaceholderPageAboutUs_none?: InputMaybe<PageAboutUsWhereInput>;
    employeePlaceholderPageAboutUs_some?: InputMaybe<PageAboutUsWhereInput>;
    hcmTeaserImagePageHome_every?: InputMaybe<PageHomeWhereInput>;
    hcmTeaserImagePageHome_none?: InputMaybe<PageHomeWhereInput>;
    hcmTeaserImagePageHome_some?: InputMaybe<PageHomeWhereInput>;
    heroImageCampaign_every?: InputMaybe<CampaignWhereInput>;
    heroImageCampaign_none?: InputMaybe<CampaignWhereInput>;
    heroImageCampaign_some?: InputMaybe<CampaignWhereInput>;
    heroImageModel_every?: InputMaybe<ModelWhereInput>;
    heroImageModel_none?: InputMaybe<ModelWhereInput>;
    heroImageModel_some?: InputMaybe<ModelWhereInput>;
    heroImageOverlayBatteryCertificate_every?: InputMaybe<OverlayBatteryCertificateWhereInput>;
    heroImageOverlayBatteryCertificate_none?: InputMaybe<OverlayBatteryCertificateWhereInput>;
    heroImageOverlayBatteryCertificate_some?: InputMaybe<OverlayBatteryCertificateWhereInput>;
    heroImagePageAboutUs_every?: InputMaybe<PageAboutUsWhereInput>;
    heroImagePageAboutUs_none?: InputMaybe<PageAboutUsWhereInput>;
    heroImagePageAboutUs_some?: InputMaybe<PageAboutUsWhereInput>;
    heroImagePageBusinessCustomer_every?: InputMaybe<PageBusinessCustomerWhereInput>;
    heroImagePageBusinessCustomer_none?: InputMaybe<PageBusinessCustomerWhereInput>;
    heroImagePageBusinessCustomer_some?: InputMaybe<PageBusinessCustomerWhereInput>;
    heroImagePageHyundaiPromise_every?: InputMaybe<PageHyundaiPromiseWhereInput>;
    heroImagePageHyundaiPromise_none?: InputMaybe<PageHyundaiPromiseWhereInput>;
    heroImagePageHyundaiPromise_some?: InputMaybe<PageHyundaiPromiseWhereInput>;
    heroImagePageService_every?: InputMaybe<PageServiceWhereInput>;
    heroImagePageService_none?: InputMaybe<PageServiceWhereInput>;
    heroImagePageService_some?: InputMaybe<PageServiceWhereInput>;
    heroImagePageWarranty_every?: InputMaybe<PageWarrantyWhereInput>;
    heroImagePageWarranty_none?: InputMaybe<PageWarrantyWhereInput>;
    heroImagePageWarranty_some?: InputMaybe<PageWarrantyWhereInput>;
    iconGeneralService_every?: InputMaybe<GeneralServiceWhereInput>;
    iconGeneralService_none?: InputMaybe<GeneralServiceWhereInput>;
    iconGeneralService_some?: InputMaybe<GeneralServiceWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    imageCampaignService_every?: InputMaybe<CampaignServiceWhereInput>;
    imageCampaignService_none?: InputMaybe<CampaignServiceWhereInput>;
    imageCampaignService_some?: InputMaybe<CampaignServiceWhereInput>;
    imageGeneralService_every?: InputMaybe<GeneralServiceWhereInput>;
    imageGeneralService_none?: InputMaybe<GeneralServiceWhereInput>;
    imageGeneralService_some?: InputMaybe<GeneralServiceWhereInput>;
    imageHomeTeaser_every?: InputMaybe<HomeTeaserWhereInput>;
    imageHomeTeaser_none?: InputMaybe<HomeTeaserWhereInput>;
    imageHomeTeaser_some?: InputMaybe<HomeTeaserWhereInput>;
    imageModel_every?: InputMaybe<ModelWhereInput>;
    imageModel_none?: InputMaybe<ModelWhereInput>;
    imageModel_some?: InputMaybe<ModelWhereInput>;
    imageWarranty_every?: InputMaybe<WarrantyWhereInput>;
    imageWarranty_none?: InputMaybe<WarrantyWhereInput>;
    imageWarranty_some?: InputMaybe<WarrantyWhereInput>;
    jobsHeroImagePageAboutUs_every?: InputMaybe<PageAboutUsWhereInput>;
    jobsHeroImagePageAboutUs_none?: InputMaybe<PageAboutUsWhereInput>;
    jobsHeroImagePageAboutUs_some?: InputMaybe<PageAboutUsWhereInput>;
    logoDealer_every?: InputMaybe<DealerWhereInput>;
    logoDealer_none?: InputMaybe<DealerWhereInput>;
    logoDealer_some?: InputMaybe<DealerWhereInput>;
    logoImagesModel_every?: InputMaybe<ModelWhereInput>;
    logoImagesModel_none?: InputMaybe<ModelWhereInput>;
    logoImagesModel_some?: InputMaybe<ModelWhereInput>;
    menuImageDealer_every?: InputMaybe<DealerWhereInput>;
    menuImageDealer_none?: InputMaybe<DealerWhereInput>;
    menuImageDealer_some?: InputMaybe<DealerWhereInput>;
    partStoreTeaserImagePageService_every?: InputMaybe<PageServiceWhereInput>;
    partStoreTeaserImagePageService_none?: InputMaybe<PageServiceWhereInput>;
    partStoreTeaserImagePageService_some?: InputMaybe<PageServiceWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    upload?: InputMaybe<AssetUploadWhereInput>;
    videoPageHyundaiPromise_every?: InputMaybe<PageHyundaiPromiseWhereInput>;
    videoPageHyundaiPromise_none?: InputMaybe<PageHyundaiPromiseWhereInput>;
    videoPageHyundaiPromise_some?: InputMaybe<PageHyundaiPromiseWhereInput>;
};

export enum AssetOrderByInput {
    AltAsc = 'alt_ASC',
    AltDesc = 'alt_DESC',
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    FileNameAsc = 'fileName_ASC',
    FileNameDesc = 'fileName_DESC',
    HandleAsc = 'handle_ASC',
    HandleDesc = 'handle_DESC',
    HeightAsc = 'height_ASC',
    HeightDesc = 'height_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    MimeTypeAsc = 'mimeType_ASC',
    MimeTypeDesc = 'mimeType_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    SizeAsc = 'size_ASC',
    SizeDesc = 'size_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
    WidthAsc = 'width_ASC',
    WidthDesc = 'width_DESC',
}

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
    upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
    document?: InputMaybe<DocumentTransformationInput>;
    image?: InputMaybe<ImageTransformationInput>;
    /** Pass true if you want to validate the passed transformation parameters */
    validateOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetUpdateInput = {
    alt?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1ImagePageBusinessCustomer?: InputMaybe<PageBusinessCustomerUpdateManyInlineInput>;
    businessCenterHighlight2ImagePageBusinessCustomer?: InputMaybe<PageBusinessCustomerUpdateManyInlineInput>;
    contentImageOverlayBatteryCertificate?: InputMaybe<OverlayBatteryCertificateUpdateManyInlineInput>;
    contentImagePageHyundaiPromise?: InputMaybe<PageHyundaiPromiseUpdateManyInlineInput>;
    contentImageSalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateManyInlineInput>;
    contentImagesModel?: InputMaybe<ModelUpdateManyInlineInput>;
    downloadPdfWarranty?: InputMaybe<WarrantyUpdateManyInlineInput>;
    employeePlaceholderPageAboutUs?: InputMaybe<PageAboutUsUpdateManyInlineInput>;
    fileName?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserImagePageHome?: InputMaybe<PageHomeUpdateManyInlineInput>;
    heroImageCampaign?: InputMaybe<CampaignUpdateManyInlineInput>;
    heroImageModel?: InputMaybe<ModelUpdateManyInlineInput>;
    heroImageOverlayBatteryCertificate?: InputMaybe<OverlayBatteryCertificateUpdateManyInlineInput>;
    heroImagePageAboutUs?: InputMaybe<PageAboutUsUpdateManyInlineInput>;
    heroImagePageBusinessCustomer?: InputMaybe<PageBusinessCustomerUpdateManyInlineInput>;
    heroImagePageHyundaiPromise?: InputMaybe<PageHyundaiPromiseUpdateManyInlineInput>;
    heroImagePageService?: InputMaybe<PageServiceUpdateManyInlineInput>;
    heroImagePageWarranty?: InputMaybe<PageWarrantyUpdateManyInlineInput>;
    highlightModuleAssetSalesCampaignContent?: InputMaybe<SalesCampaignContentUpdateManyInlineInput>;
    highlightTeaserImageCampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryUpdateManyInlineInput>;
    iconCampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryUpdateManyInlineInput>;
    iconCampaignAfterSalesService?: InputMaybe<CampaignAfterSalesServiceUpdateManyInlineInput>;
    iconGeneralService?: InputMaybe<GeneralServiceUpdateManyInlineInput>;
    iconIconText?: InputMaybe<IconTextUpdateManyInlineInput>;
    imageCampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryUpdateManyInlineInput>;
    imageCampaignAfterSalesService?: InputMaybe<CampaignAfterSalesServiceUpdateManyInlineInput>;
    imageCampaignService?: InputMaybe<CampaignServiceUpdateManyInlineInput>;
    imageGeneralService?: InputMaybe<GeneralServiceUpdateManyInlineInput>;
    imageHomeTeaser?: InputMaybe<HomeTeaserUpdateManyInlineInput>;
    imageModel?: InputMaybe<ModelUpdateManyInlineInput>;
    imageSalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateManyInlineInput>;
    imageWarranty?: InputMaybe<WarrantyUpdateManyInlineInput>;
    jobsHeroImagePageAboutUs?: InputMaybe<PageAboutUsUpdateManyInlineInput>;
    /** Manage document localizations */
    localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
    logoDealer?: InputMaybe<DealerUpdateManyInlineInput>;
    logoImagesModel?: InputMaybe<ModelUpdateManyInlineInput>;
    menuImageDealer?: InputMaybe<DealerUpdateManyInlineInput>;
    offerImageSalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateManyInlineInput>;
    partStoreTeaserImagePageService?: InputMaybe<PageServiceUpdateManyInlineInput>;
    /** Use this to define if its a reupload for the asset */
    reUpload?: InputMaybe<Scalars['Boolean']['input']>;
    /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
    uploadUrl?: InputMaybe<Scalars['String']['input']>;
    videoPageHyundaiPromise?: InputMaybe<PageHyundaiPromiseUpdateManyInlineInput>;
    warrantyLogo1ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentUpdateManyInlineInput>;
    warrantyLogo1SalesCampaignContent?: InputMaybe<SalesCampaignContentUpdateManyInlineInput>;
    warrantyLogo2ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentUpdateManyInlineInput>;
    warrantyLogo2SalesCampaignContent?: InputMaybe<SalesCampaignContentUpdateManyInlineInput>;
    warrantyLogo3ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentUpdateManyInlineInput>;
    warrantyLogo3SalesCampaignContent?: InputMaybe<SalesCampaignContentUpdateManyInlineInput>;
};

export type AssetUpdateLocalizationDataInput = {
    fileName?: InputMaybe<Scalars['String']['input']>;
    /** Use this to define if its a reupload for the asset */
    reUpload?: InputMaybe<Scalars['Boolean']['input']>;
    /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
    uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationInput = {
    data: AssetUpdateLocalizationDataInput;
    locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
    /** Localizations to create */
    create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
    /** Localizations to delete */
    delete?: InputMaybe<Array<Locale>>;
    /** Localizations to update */
    update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
    upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInlineInput = {
    /** Connect multiple existing Asset documents */
    connect?: InputMaybe<Array<AssetConnectInput>>;
    /** Create and connect multiple Asset documents */
    create?: InputMaybe<Array<AssetCreateInput>>;
    /** Delete multiple Asset documents */
    delete?: InputMaybe<Array<AssetWhereUniqueInput>>;
    /** Disconnect multiple Asset documents */
    disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing Asset documents */
    set?: InputMaybe<Array<AssetWhereUniqueInput>>;
    /** Update multiple Asset documents */
    update?: InputMaybe<Array<AssetUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple Asset documents */
    upsert?: InputMaybe<Array<AssetUpsertWithNestedWhereUniqueInput>>;
};

export type AssetUpdateManyInput = {
    alt?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: AssetUpdateManyInput;
    /** Document search */
    where: AssetWhereInput;
};

export type AssetUpdateOneInlineInput = {
    /** Connect existing Asset document */
    connect?: InputMaybe<AssetWhereUniqueInput>;
    /** Create and connect one Asset document */
    create?: InputMaybe<AssetCreateInput>;
    /** Delete currently connected Asset document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected Asset document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Asset document */
    update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Asset document */
    upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: AssetUpdateInput;
    /** Unique document search */
    where: AssetWhereUniqueInput;
};

/** Asset Upload */
export type AssetUpload = {
    __typename?: 'AssetUpload';
    /** Asset Upload Error */
    error?: Maybe<AssetUploadError>;
    /** Expiry Timestamp */
    expiresAt?: Maybe<Scalars['DateTime']['output']>;
    /** Asset Request Data for upload */
    requestPostData?: Maybe<AssetUploadRequestPostData>;
    /** Asset Request Data for upload */
    status?: Maybe<AssetUploadStatus>;
};

/** Represents asset upload error */
export type AssetUploadError = {
    __typename?: 'AssetUploadError';
    code: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
    __typename?: 'AssetUploadRequestPostData';
    /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
    algorithm: Scalars['String']['output'];
    /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
    credential: Scalars['String']['output'];
    /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
    date: Scalars['String']['output'];
    /** The key to use in the form field. This value should be passed in the `Key` form field. */
    key: Scalars['String']['output'];
    /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
    policy: Scalars['String']['output'];
    /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
    securityToken?: Maybe<Scalars['String']['output']>;
    /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
    signature: Scalars['String']['output'];
    /** The URL to which the file should be uploaded with a POST request. */
    url: Scalars['String']['output'];
};

/** System Asset Upload Status */
export enum AssetUploadStatus {
    AssetCreatePending = 'ASSET_CREATE_PENDING',
    AssetErrorUpload = 'ASSET_ERROR_UPLOAD',
    AssetUpdatePending = 'ASSET_UPDATE_PENDING',
    AssetUploadComplete = 'ASSET_UPLOAD_COMPLETE',
}

/** Identifies documents */
export type AssetUploadWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<AssetUploadWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<AssetUploadWhereInput>>;
    expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    status?: InputMaybe<AssetUploadStatus>;
    /** All values that are contained in given list. */
    status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
    /** Any other value that exists and is not equal to the given value. */
    status_not?: InputMaybe<AssetUploadStatus>;
    /** All values that are not contained in given list. */
    status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

/** Identifies documents */
export type AssetUploadWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<AssetUploadWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<AssetUploadWhereInput>>;
    expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    status?: InputMaybe<AssetUploadStatus>;
    /** All values that are contained in given list. */
    status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
    /** Any other value that exists and is not equal to the given value. */
    status_not?: InputMaybe<AssetUploadStatus>;
    /** All values that are not contained in given list. */
    status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

export type AssetUpsertInput = {
    /** Create document if it didn't exist */
    create: AssetCreateInput;
    /** Update document if it exists */
    update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
    create: AssetCreateLocalizationDataInput;
    locale: Locale;
    update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: AssetUpsertInput;
    /** Unique document search */
    where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AssetWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<AssetWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<AssetWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<AssetWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    alt?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    alt_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    alt_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    alt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    alt_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    alt_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    alt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    alt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    alt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    alt_starts_with?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1ImagePageBusinessCustomer_every?: InputMaybe<PageBusinessCustomerWhereInput>;
    businessCenterHighlight1ImagePageBusinessCustomer_none?: InputMaybe<PageBusinessCustomerWhereInput>;
    businessCenterHighlight1ImagePageBusinessCustomer_some?: InputMaybe<PageBusinessCustomerWhereInput>;
    businessCenterHighlight2ImagePageBusinessCustomer_every?: InputMaybe<PageBusinessCustomerWhereInput>;
    businessCenterHighlight2ImagePageBusinessCustomer_none?: InputMaybe<PageBusinessCustomerWhereInput>;
    businessCenterHighlight2ImagePageBusinessCustomer_some?: InputMaybe<PageBusinessCustomerWhereInput>;
    contentImageOverlayBatteryCertificate_every?: InputMaybe<OverlayBatteryCertificateWhereInput>;
    contentImageOverlayBatteryCertificate_none?: InputMaybe<OverlayBatteryCertificateWhereInput>;
    contentImageOverlayBatteryCertificate_some?: InputMaybe<OverlayBatteryCertificateWhereInput>;
    contentImagePageHyundaiPromise_every?: InputMaybe<PageHyundaiPromiseWhereInput>;
    contentImagePageHyundaiPromise_none?: InputMaybe<PageHyundaiPromiseWhereInput>;
    contentImagePageHyundaiPromise_some?: InputMaybe<PageHyundaiPromiseWhereInput>;
    contentImagesModel_every?: InputMaybe<ModelWhereInput>;
    contentImagesModel_none?: InputMaybe<ModelWhereInput>;
    contentImagesModel_some?: InputMaybe<ModelWhereInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<AssetWhereStageInput>;
    documentInStages_none?: InputMaybe<AssetWhereStageInput>;
    documentInStages_some?: InputMaybe<AssetWhereStageInput>;
    downloadPdfWarranty_every?: InputMaybe<WarrantyWhereInput>;
    downloadPdfWarranty_none?: InputMaybe<WarrantyWhereInput>;
    downloadPdfWarranty_some?: InputMaybe<WarrantyWhereInput>;
    employeePlaceholderPageAboutUs_every?: InputMaybe<PageAboutUsWhereInput>;
    employeePlaceholderPageAboutUs_none?: InputMaybe<PageAboutUsWhereInput>;
    employeePlaceholderPageAboutUs_some?: InputMaybe<PageAboutUsWhereInput>;
    fileName?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    fileName_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    fileName_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    fileName_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    fileName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    fileName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    fileName_starts_with?: InputMaybe<Scalars['String']['input']>;
    handle?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    handle_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    handle_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    handle_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    handle_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    handle_starts_with?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserImagePageHome_every?: InputMaybe<PageHomeWhereInput>;
    hcmTeaserImagePageHome_none?: InputMaybe<PageHomeWhereInput>;
    hcmTeaserImagePageHome_some?: InputMaybe<PageHomeWhereInput>;
    height?: InputMaybe<Scalars['Float']['input']>;
    /** All values greater than the given value. */
    height_gt?: InputMaybe<Scalars['Float']['input']>;
    /** All values greater than or equal the given value. */
    height_gte?: InputMaybe<Scalars['Float']['input']>;
    /** All values that are contained in given list. */
    height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
    /** All values less than the given value. */
    height_lt?: InputMaybe<Scalars['Float']['input']>;
    /** All values less than or equal the given value. */
    height_lte?: InputMaybe<Scalars['Float']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    height_not?: InputMaybe<Scalars['Float']['input']>;
    /** All values that are not contained in given list. */
    height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
    heroImageCampaign_every?: InputMaybe<CampaignWhereInput>;
    heroImageCampaign_none?: InputMaybe<CampaignWhereInput>;
    heroImageCampaign_some?: InputMaybe<CampaignWhereInput>;
    heroImageModel_every?: InputMaybe<ModelWhereInput>;
    heroImageModel_none?: InputMaybe<ModelWhereInput>;
    heroImageModel_some?: InputMaybe<ModelWhereInput>;
    heroImageOverlayBatteryCertificate_every?: InputMaybe<OverlayBatteryCertificateWhereInput>;
    heroImageOverlayBatteryCertificate_none?: InputMaybe<OverlayBatteryCertificateWhereInput>;
    heroImageOverlayBatteryCertificate_some?: InputMaybe<OverlayBatteryCertificateWhereInput>;
    heroImagePageAboutUs_every?: InputMaybe<PageAboutUsWhereInput>;
    heroImagePageAboutUs_none?: InputMaybe<PageAboutUsWhereInput>;
    heroImagePageAboutUs_some?: InputMaybe<PageAboutUsWhereInput>;
    heroImagePageBusinessCustomer_every?: InputMaybe<PageBusinessCustomerWhereInput>;
    heroImagePageBusinessCustomer_none?: InputMaybe<PageBusinessCustomerWhereInput>;
    heroImagePageBusinessCustomer_some?: InputMaybe<PageBusinessCustomerWhereInput>;
    heroImagePageHyundaiPromise_every?: InputMaybe<PageHyundaiPromiseWhereInput>;
    heroImagePageHyundaiPromise_none?: InputMaybe<PageHyundaiPromiseWhereInput>;
    heroImagePageHyundaiPromise_some?: InputMaybe<PageHyundaiPromiseWhereInput>;
    heroImagePageService_every?: InputMaybe<PageServiceWhereInput>;
    heroImagePageService_none?: InputMaybe<PageServiceWhereInput>;
    heroImagePageService_some?: InputMaybe<PageServiceWhereInput>;
    heroImagePageWarranty_every?: InputMaybe<PageWarrantyWhereInput>;
    heroImagePageWarranty_none?: InputMaybe<PageWarrantyWhereInput>;
    heroImagePageWarranty_some?: InputMaybe<PageWarrantyWhereInput>;
    iconGeneralService_every?: InputMaybe<GeneralServiceWhereInput>;
    iconGeneralService_none?: InputMaybe<GeneralServiceWhereInput>;
    iconGeneralService_some?: InputMaybe<GeneralServiceWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    imageCampaignService_every?: InputMaybe<CampaignServiceWhereInput>;
    imageCampaignService_none?: InputMaybe<CampaignServiceWhereInput>;
    imageCampaignService_some?: InputMaybe<CampaignServiceWhereInput>;
    imageGeneralService_every?: InputMaybe<GeneralServiceWhereInput>;
    imageGeneralService_none?: InputMaybe<GeneralServiceWhereInput>;
    imageGeneralService_some?: InputMaybe<GeneralServiceWhereInput>;
    imageHomeTeaser_every?: InputMaybe<HomeTeaserWhereInput>;
    imageHomeTeaser_none?: InputMaybe<HomeTeaserWhereInput>;
    imageHomeTeaser_some?: InputMaybe<HomeTeaserWhereInput>;
    imageModel_every?: InputMaybe<ModelWhereInput>;
    imageModel_none?: InputMaybe<ModelWhereInput>;
    imageModel_some?: InputMaybe<ModelWhereInput>;
    imageWarranty_every?: InputMaybe<WarrantyWhereInput>;
    imageWarranty_none?: InputMaybe<WarrantyWhereInput>;
    imageWarranty_some?: InputMaybe<WarrantyWhereInput>;
    jobsHeroImagePageAboutUs_every?: InputMaybe<PageAboutUsWhereInput>;
    jobsHeroImagePageAboutUs_none?: InputMaybe<PageAboutUsWhereInput>;
    jobsHeroImagePageAboutUs_some?: InputMaybe<PageAboutUsWhereInput>;
    logoDealer_every?: InputMaybe<DealerWhereInput>;
    logoDealer_none?: InputMaybe<DealerWhereInput>;
    logoDealer_some?: InputMaybe<DealerWhereInput>;
    logoImagesModel_every?: InputMaybe<ModelWhereInput>;
    logoImagesModel_none?: InputMaybe<ModelWhereInput>;
    logoImagesModel_some?: InputMaybe<ModelWhereInput>;
    menuImageDealer_every?: InputMaybe<DealerWhereInput>;
    menuImageDealer_none?: InputMaybe<DealerWhereInput>;
    menuImageDealer_some?: InputMaybe<DealerWhereInput>;
    mimeType?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mimeType_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mimeType_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mimeType_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mimeType_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mimeType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mimeType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mimeType_starts_with?: InputMaybe<Scalars['String']['input']>;
    partStoreTeaserImagePageService_every?: InputMaybe<PageServiceWhereInput>;
    partStoreTeaserImagePageService_none?: InputMaybe<PageServiceWhereInput>;
    partStoreTeaserImagePageService_some?: InputMaybe<PageServiceWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    size?: InputMaybe<Scalars['Float']['input']>;
    /** All values greater than the given value. */
    size_gt?: InputMaybe<Scalars['Float']['input']>;
    /** All values greater than or equal the given value. */
    size_gte?: InputMaybe<Scalars['Float']['input']>;
    /** All values that are contained in given list. */
    size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
    /** All values less than the given value. */
    size_lt?: InputMaybe<Scalars['Float']['input']>;
    /** All values less than or equal the given value. */
    size_lte?: InputMaybe<Scalars['Float']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    size_not?: InputMaybe<Scalars['Float']['input']>;
    /** All values that are not contained in given list. */
    size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    upload?: InputMaybe<AssetUploadWhereInput>;
    videoPageHyundaiPromise_every?: InputMaybe<PageHyundaiPromiseWhereInput>;
    videoPageHyundaiPromise_none?: InputMaybe<PageHyundaiPromiseWhereInput>;
    videoPageHyundaiPromise_some?: InputMaybe<PageHyundaiPromiseWhereInput>;
    width?: InputMaybe<Scalars['Float']['input']>;
    /** All values greater than the given value. */
    width_gt?: InputMaybe<Scalars['Float']['input']>;
    /** All values greater than or equal the given value. */
    width_gte?: InputMaybe<Scalars['Float']['input']>;
    /** All values that are contained in given list. */
    width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
    /** All values less than the given value. */
    width_lt?: InputMaybe<Scalars['Float']['input']>;
    /** All values less than or equal the given value. */
    width_lte?: InputMaybe<Scalars['Float']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    width_not?: InputMaybe<Scalars['Float']['input']>;
    /** All values that are not contained in given list. */
    width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<AssetWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<AssetWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<AssetWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type Auth0User = Entity &
    Node & {
        __typename?: 'Auth0User';
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        dealer?: Maybe<Dealer>;
        /** Get the document in other stages */
        documentInStages: Array<Auth0User>;
        email: Scalars['String']['output'];
        /** List of Auth0User versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        isAdmin: Scalars['Boolean']['output'];
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

export type Auth0UserCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type Auth0UserDealerArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type Auth0UserDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type Auth0UserHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type Auth0UserPublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type Auth0UserScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type Auth0UserUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type Auth0UserConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: Auth0UserWhereUniqueInput;
};

/** A connection to a list of items. */
export type Auth0UserConnection = {
    __typename?: 'Auth0UserConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<Auth0UserEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type Auth0UserCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    dealer?: InputMaybe<DealerCreateOneInlineInput>;
    email: Scalars['String']['input'];
    isAdmin: Scalars['Boolean']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Auth0UserCreateManyInlineInput = {
    /** Connect multiple existing Auth0User documents */
    connect?: InputMaybe<Array<Auth0UserWhereUniqueInput>>;
    /** Create and connect multiple existing Auth0User documents */
    create?: InputMaybe<Array<Auth0UserCreateInput>>;
};

export type Auth0UserCreateOneInlineInput = {
    /** Connect one existing Auth0User document */
    connect?: InputMaybe<Auth0UserWhereUniqueInput>;
    /** Create and connect one Auth0User document */
    create?: InputMaybe<Auth0UserCreateInput>;
};

/** An edge in a connection. */
export type Auth0UserEdge = {
    __typename?: 'Auth0UserEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Auth0User;
};

/** Identifies documents */
export type Auth0UserManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<Auth0UserWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<Auth0UserWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<Auth0UserWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    dealer?: InputMaybe<DealerWhereInput>;
    documentInStages_every?: InputMaybe<Auth0UserWhereStageInput>;
    documentInStages_none?: InputMaybe<Auth0UserWhereStageInput>;
    documentInStages_some?: InputMaybe<Auth0UserWhereStageInput>;
    email?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    email_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    email_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    email_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    email_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    email_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    email_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    email_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    isAdmin_not?: InputMaybe<Scalars['Boolean']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum Auth0UserOrderByInput {
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    EmailAsc = 'email_ASC',
    EmailDesc = 'email_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    IsAdminAsc = 'isAdmin_ASC',
    IsAdminDesc = 'isAdmin_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type Auth0UserUpdateInput = {
    dealer?: InputMaybe<DealerUpdateOneInlineInput>;
    email?: InputMaybe<Scalars['String']['input']>;
    isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Auth0UserUpdateManyInlineInput = {
    /** Connect multiple existing Auth0User documents */
    connect?: InputMaybe<Array<Auth0UserConnectInput>>;
    /** Create and connect multiple Auth0User documents */
    create?: InputMaybe<Array<Auth0UserCreateInput>>;
    /** Delete multiple Auth0User documents */
    delete?: InputMaybe<Array<Auth0UserWhereUniqueInput>>;
    /** Disconnect multiple Auth0User documents */
    disconnect?: InputMaybe<Array<Auth0UserWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing Auth0User documents */
    set?: InputMaybe<Array<Auth0UserWhereUniqueInput>>;
    /** Update multiple Auth0User documents */
    update?: InputMaybe<Array<Auth0UserUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple Auth0User documents */
    upsert?: InputMaybe<Array<Auth0UserUpsertWithNestedWhereUniqueInput>>;
};

export type Auth0UserUpdateManyInput = {
    isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Auth0UserUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: Auth0UserUpdateManyInput;
    /** Document search */
    where: Auth0UserWhereInput;
};

export type Auth0UserUpdateOneInlineInput = {
    /** Connect existing Auth0User document */
    connect?: InputMaybe<Auth0UserWhereUniqueInput>;
    /** Create and connect one Auth0User document */
    create?: InputMaybe<Auth0UserCreateInput>;
    /** Delete currently connected Auth0User document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected Auth0User document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Auth0User document */
    update?: InputMaybe<Auth0UserUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Auth0User document */
    upsert?: InputMaybe<Auth0UserUpsertWithNestedWhereUniqueInput>;
};

export type Auth0UserUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: Auth0UserUpdateInput;
    /** Unique document search */
    where: Auth0UserWhereUniqueInput;
};

export type Auth0UserUpsertInput = {
    /** Create document if it didn't exist */
    create: Auth0UserCreateInput;
    /** Update document if it exists */
    update: Auth0UserUpdateInput;
};

export type Auth0UserUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: Auth0UserUpsertInput;
    /** Unique document search */
    where: Auth0UserWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type Auth0UserWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type Auth0UserWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<Auth0UserWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<Auth0UserWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<Auth0UserWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    dealer?: InputMaybe<DealerWhereInput>;
    documentInStages_every?: InputMaybe<Auth0UserWhereStageInput>;
    documentInStages_none?: InputMaybe<Auth0UserWhereStageInput>;
    documentInStages_some?: InputMaybe<Auth0UserWhereStageInput>;
    email?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    email_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    email_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    email_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    email_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    email_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    email_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    email_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    isAdmin_not?: InputMaybe<Scalars['Boolean']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type Auth0UserWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<Auth0UserWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<Auth0UserWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<Auth0UserWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<Auth0UserWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References Auth0User record uniquely */
export type Auth0UserWhereUniqueInput = {
    email?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type BankCode = Entity & {
    __typename?: 'BankCode';
    code?: Maybe<Scalars['String']['output']>;
    footnoteContent?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BankCodeConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: BankCodeWhereUniqueInput;
};

/** A connection to a list of items. */
export type BankCodeConnection = {
    __typename?: 'BankCodeConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<BankCodeEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type BankCodeCreateInput = {
    code?: InputMaybe<Scalars['String']['input']>;
    footnoteContent?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BankCodeCreateManyInlineInput = {
    /** Create and connect multiple existing BankCode documents */
    create?: InputMaybe<Array<BankCodeCreateInput>>;
};

export type BankCodeCreateOneInlineInput = {
    /** Create and connect one BankCode document */
    create?: InputMaybe<BankCodeCreateInput>;
};

export type BankCodeCreateWithPositionInput = {
    /** Document to create */
    data: BankCodeCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type BankCodeEdge = {
    __typename?: 'BankCodeEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: BankCode;
};

/** Identifies documents */
export type BankCodeManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<BankCodeWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<BankCodeWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<BankCodeWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    code?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    code_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    code_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    code_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    code_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    code_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    code_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    code_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    code_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    code_starts_with?: InputMaybe<Scalars['String']['input']>;
    footnoteContent?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    footnoteContent_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    footnoteContent_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    footnoteContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    footnoteContent_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    footnoteContent_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    footnoteContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    footnoteContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    footnoteContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    footnoteContent_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum BankCodeOrderByInput {
    CodeAsc = 'code_ASC',
    CodeDesc = 'code_DESC',
    FootnoteContentAsc = 'footnoteContent_ASC',
    FootnoteContentDesc = 'footnoteContent_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type BankCodeParent = SalesCampaignModel;

export type BankCodeParentConnectInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelConnectInput>;
};

export type BankCodeParentCreateInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelCreateInput>;
};

export type BankCodeParentCreateManyInlineInput = {
    /** Create and connect multiple existing BankCodeParent documents */
    create?: InputMaybe<Array<BankCodeParentCreateInput>>;
};

export type BankCodeParentCreateOneInlineInput = {
    /** Create and connect one BankCodeParent document */
    create?: InputMaybe<BankCodeParentCreateInput>;
};

export type BankCodeParentCreateWithPositionInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelCreateWithPositionInput>;
};

export type BankCodeParentUpdateInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateInput>;
};

export type BankCodeParentUpdateManyInlineInput = {
    /** Create and connect multiple BankCodeParent component instances */
    create?: InputMaybe<Array<BankCodeParentCreateWithPositionInput>>;
    /** Delete multiple BankCodeParent documents */
    delete?: InputMaybe<Array<BankCodeParentWhereUniqueInput>>;
    /** Update multiple BankCodeParent component instances */
    update?: InputMaybe<Array<BankCodeParentUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple BankCodeParent component instances */
    upsert?: InputMaybe<Array<BankCodeParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type BankCodeParentUpdateManyWithNestedWhereInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateManyWithNestedWhereInput>;
};

export type BankCodeParentUpdateOneInlineInput = {
    /** Create and connect one BankCodeParent document */
    create?: InputMaybe<BankCodeParentCreateInput>;
    /** Delete currently connected BankCodeParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single BankCodeParent document */
    update?: InputMaybe<BankCodeParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single BankCodeParent document */
    upsert?: InputMaybe<BankCodeParentUpsertWithNestedWhereUniqueInput>;
};

export type BankCodeParentUpdateWithNestedWhereUniqueAndPositionInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type BankCodeParentUpdateWithNestedWhereUniqueInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateWithNestedWhereUniqueInput>;
};

export type BankCodeParentUpsertWithNestedWhereUniqueAndPositionInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type BankCodeParentUpsertWithNestedWhereUniqueInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpsertWithNestedWhereUniqueInput>;
};

export type BankCodeParentWhereInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelWhereInput>;
};

export type BankCodeParentWhereUniqueInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelWhereUniqueInput>;
};

export type BankCodeUpdateInput = {
    code?: InputMaybe<Scalars['String']['input']>;
    footnoteContent?: InputMaybe<Scalars['String']['input']>;
};

export type BankCodeUpdateManyInlineInput = {
    /** Create and connect multiple BankCode component instances */
    create?: InputMaybe<Array<BankCodeCreateWithPositionInput>>;
    /** Delete multiple BankCode documents */
    delete?: InputMaybe<Array<BankCodeWhereUniqueInput>>;
    /** Update multiple BankCode component instances */
    update?: InputMaybe<Array<BankCodeUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple BankCode component instances */
    upsert?: InputMaybe<Array<BankCodeUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type BankCodeUpdateManyInput = {
    code?: InputMaybe<Scalars['String']['input']>;
    footnoteContent?: InputMaybe<Scalars['String']['input']>;
};

export type BankCodeUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: BankCodeUpdateManyInput;
    /** Document search */
    where: BankCodeWhereInput;
};

export type BankCodeUpdateOneInlineInput = {
    /** Create and connect one BankCode document */
    create?: InputMaybe<BankCodeCreateInput>;
    /** Delete currently connected BankCode document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single BankCode document */
    update?: InputMaybe<BankCodeUpdateWithNestedWhereUniqueInput>;
    /** Upsert single BankCode document */
    upsert?: InputMaybe<BankCodeUpsertWithNestedWhereUniqueInput>;
};

export type BankCodeUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<BankCodeUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: BankCodeWhereUniqueInput;
};

export type BankCodeUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: BankCodeUpdateInput;
    /** Unique document search */
    where: BankCodeWhereUniqueInput;
};

export type BankCodeUpsertInput = {
    /** Create document if it didn't exist */
    create: BankCodeCreateInput;
    /** Update document if it exists */
    update: BankCodeUpdateInput;
};

export type BankCodeUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<BankCodeUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: BankCodeWhereUniqueInput;
};

export type BankCodeUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: BankCodeUpsertInput;
    /** Unique document search */
    where: BankCodeWhereUniqueInput;
};

/** Identifies documents */
export type BankCodeWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<BankCodeWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<BankCodeWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<BankCodeWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    code?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    code_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    code_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    code_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    code_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    code_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    code_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    code_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    code_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    code_starts_with?: InputMaybe<Scalars['String']['input']>;
    footnoteContent?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    footnoteContent_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    footnoteContent_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    footnoteContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    footnoteContent_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    footnoteContent_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    footnoteContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    footnoteContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    footnoteContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    footnoteContent_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References BankCode record uniquely */
export type BankCodeWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type BatchPayload = {
    __typename?: 'BatchPayload';
    /** The number of nodes that have been affected by the Batch operation. */
    count: Scalars['Long']['output'];
};

export type Campaign = Entity &
    Node & {
        __typename?: 'Campaign';
        campaignType: CampaignType;
        content?: Maybe<CampaigncontentUnion>;
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Aktiviert den blauen Aktions-Banner auf Home und in der Main-Nav. */
        dealersKeyCampaigns: Array<Dealer>;
        dealersRegularCampaigns: Array<Dealer>;
        /** Get the document in other stages */
        documentInStages: Array<Campaign>;
        /** Keine Funktion an diesem Datum - Steuert nicht die Ausgabe der Aktion auf live!    */
        endDate?: Maybe<Scalars['Date']['output']>;
        /** Ausgabe aktuell nur auf der Detailseite bei Sales Aktionen! Bei anderen Aktionstypen wird es nicht genutzt */
        heroHeadline?: Maybe<Scalars['String']['output']>;
        /** Erscheint an div. Stellen als Key Visual  */
        heroImage: Asset;
        /** Ausgabe nur bei After-Sales-Aktionspages */
        heroImageCaption?: Maybe<Scalars['String']['output']>;
        /** List of Campaign versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        importCode?: Maybe<Scalars['String']['output']>;
        /** Nur für interne Zwecke - wird nicht im FE ausgegeben. Bsp: Q1 2026 Aktion B2C  */
        internerKmpName?: Maybe<Scalars['String']['output']>;
        /** Erhalten wir von HMD/MRM. Nur erforderlich für Sales-Aktionen! */
        kmpCode?: Maybe<Scalars['String']['output']>;
        /** Text, welcher als Aktionshinweis / Rechtstext angezeigt wird. */
        legalLines?: Maybe<Scalars['String']['output']>;
        metaDescriptionOverride?: Maybe<Scalars['String']['output']>;
        /** Für Aktionstyp "Modellankündigung" */
        modelForAnnouncement?: Maybe<Model>;
        /** Bestimmt auf der Modellübersicht und im Modellteaser auf Home den Störer "Aktion" im Freisteller und aktiviert den hellblauen Aktions-Banner auf der jeweiligen Modellpage. */
        models: Array<Model>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** Aktionstitel: /aktionen/XXXXXX */
        slug: Scalars['String']['output'];
        /** System stage field */
        stage: Stage;
        /** Keine Funktion an diesem Datum - Steuert nicht die Ausgabe der Aktion auf live!    */
        startDate?: Maybe<Scalars['Date']['output']>;
        /**
         * Keine max. Zahl, wird ausgepunktet, wenn zu lang.
         *
         * Nur sichtbar auf Aktionsübersichts-Seite und bei After-Sales auf der Service-Seite. Wird nicht auf der Startseite angezeigt.
         */
        teaserCopy?: Maybe<Scalars['String']['output']>;
        /**
         * max. 60 Zeichen.
         *
         * Sales: Wird verwendet als Teaser-HL auf der Startseite und Aktionsübersicht.
         *
         * After-Sales: Wird verwendet als Hero-HL auf der Aktionsseite und als Teaser-HL auf der Startseite, Aktionsübersicht und Service-Seite
         */
        teaserHeadline: Scalars['String']['output'];
        /** Name der Kampagne im Page Title */
        title: Scalars['String']['output'];
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
        utmMapping: Array<UtmMapping>;
    };

export type CampaignContentArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type CampaignCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type CampaignDealersKeyCampaignsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<DealerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DealerWhereInput>;
};

export type CampaignDealersRegularCampaignsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<DealerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DealerWhereInput>;
};

export type CampaignDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type CampaignHeroImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type CampaignHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type CampaignModelForAnnouncementArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type CampaignModelsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<ModelOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ModelWhereInput>;
};

export type CampaignPublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type CampaignScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type CampaignUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type CampaignUtmMappingArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<UtmMappingOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UtmMappingWhereInput>;
};

export type CampaignAfterSalesAccesory = Entity & {
    __typename?: 'CampaignAfterSalesAccesory';
    /** Von HMD erhalten wir die Teilenummer (bspw. 9999Z057124). Diese nicht direkt hier eintragen! Zuerst in einem Zubehörshop eines Händlers nach dieser Teilenummer suchen -> Dann das entsprechende Produkt auswählen und aus dem URL-Slug die Nummer hinter /product/XXXXX nehmen. Diese als AccessoryID verwenden! */
    accesoryId?: Maybe<Scalars['String']['output']>;
    articleNumber?: Maybe<Scalars['String']['output']>;
    /** Wird nicht ausgegeben! */
    bulletlist: Array<IconText>;
    /** Fußnote für Preisangabe */
    footnote?: Maybe<Footnote>;
    highlightTeaserImage?: Maybe<Asset>;
    /** Wird nicht ausgegeben! */
    icon?: Maybe<Asset>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** Format 1:1 */
    image?: Maybe<Asset>;
    longDescription?: Maybe<Scalars['String']['output']>;
    /** Hat ein Händler keinen Zubehörshop, öffnet sich der hinterlegte Mailto-Link */
    mailToLink?: Maybe<Scalars['String']['output']>;
    shopSearchTerm?: Maybe<Scalars['String']['output']>;
    shortDescription?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    tag?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
    utmCreativeFormatParam?: Maybe<Scalars['String']['output']>;
};

export type CampaignAfterSalesAccesoryBulletlistArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<IconTextOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IconTextWhereInput>;
};

export type CampaignAfterSalesAccesoryFootnoteArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type CampaignAfterSalesAccesoryHighlightTeaserImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type CampaignAfterSalesAccesoryIconArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type CampaignAfterSalesAccesoryImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type CampaignAfterSalesAccesoryConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: CampaignAfterSalesAccesoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type CampaignAfterSalesAccesoryConnection = {
    __typename?: 'CampaignAfterSalesAccesoryConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<CampaignAfterSalesAccesoryEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type CampaignAfterSalesAccesoryCreateInput = {
    accesoryId?: InputMaybe<Scalars['String']['input']>;
    articleNumber?: InputMaybe<Scalars['String']['input']>;
    bulletlist?: InputMaybe<IconTextCreateManyInlineInput>;
    footnote?: InputMaybe<FootnoteCreateOneInlineInput>;
    highlightTeaserImage?: InputMaybe<AssetCreateOneInlineInput>;
    icon?: InputMaybe<AssetCreateOneInlineInput>;
    image?: InputMaybe<AssetCreateOneInlineInput>;
    longDescription?: InputMaybe<Scalars['String']['input']>;
    mailToLink?: InputMaybe<Scalars['String']['input']>;
    shopSearchTerm?: InputMaybe<Scalars['String']['input']>;
    shortDescription?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    utmCreativeFormatParam?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignAfterSalesAccesoryCreateManyInlineInput = {
    /** Create and connect multiple existing CampaignAfterSalesAccesory documents */
    create?: InputMaybe<Array<CampaignAfterSalesAccesoryCreateInput>>;
};

export type CampaignAfterSalesAccesoryCreateOneInlineInput = {
    /** Create and connect one CampaignAfterSalesAccesory document */
    create?: InputMaybe<CampaignAfterSalesAccesoryCreateInput>;
};

export type CampaignAfterSalesAccesoryCreateWithPositionInput = {
    /** Document to create */
    data: CampaignAfterSalesAccesoryCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CampaignAfterSalesAccesoryEdge = {
    __typename?: 'CampaignAfterSalesAccesoryEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: CampaignAfterSalesAccesory;
};

/** Identifies documents */
export type CampaignAfterSalesAccesoryManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<CampaignAfterSalesAccesoryWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<CampaignAfterSalesAccesoryWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<CampaignAfterSalesAccesoryWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    accesoryId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    accesoryId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    accesoryId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    accesoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    accesoryId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    accesoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    accesoryId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    accesoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    accesoryId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    accesoryId_starts_with?: InputMaybe<Scalars['String']['input']>;
    articleNumber?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    articleNumber_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    articleNumber_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    articleNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    articleNumber_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    articleNumber_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    articleNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    articleNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    articleNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    articleNumber_starts_with?: InputMaybe<Scalars['String']['input']>;
    bulletlist_every?: InputMaybe<IconTextWhereInput>;
    bulletlist_none?: InputMaybe<IconTextWhereInput>;
    bulletlist_some?: InputMaybe<IconTextWhereInput>;
    footnote?: InputMaybe<FootnoteWhereInput>;
    highlightTeaserImage?: InputMaybe<AssetWhereInput>;
    icon?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    longDescription?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    longDescription_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    longDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    longDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    longDescription_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    longDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    longDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    longDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    longDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    longDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
    mailToLink?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mailToLink_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mailToLink_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mailToLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mailToLink_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mailToLink_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mailToLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mailToLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mailToLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mailToLink_starts_with?: InputMaybe<Scalars['String']['input']>;
    shopSearchTerm?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    shopSearchTerm_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    shopSearchTerm_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    shopSearchTerm_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    shopSearchTerm_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    shopSearchTerm_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    shopSearchTerm_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    shopSearchTerm_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    shopSearchTerm_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    shopSearchTerm_starts_with?: InputMaybe<Scalars['String']['input']>;
    shortDescription?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    shortDescription_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    tag_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    tag_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    tag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    tag_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    tag_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    tag_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    tag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    tag_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    tag_starts_with?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    title_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    title_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    title_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    title_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    utmCreativeFormatParam?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    utmCreativeFormatParam_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    utmCreativeFormatParam_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    utmCreativeFormatParam_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    utmCreativeFormatParam_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    utmCreativeFormatParam_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    utmCreativeFormatParam_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    utmCreativeFormatParam_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    utmCreativeFormatParam_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    utmCreativeFormatParam_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum CampaignAfterSalesAccesoryOrderByInput {
    AccesoryIdAsc = 'accesoryId_ASC',
    AccesoryIdDesc = 'accesoryId_DESC',
    ArticleNumberAsc = 'articleNumber_ASC',
    ArticleNumberDesc = 'articleNumber_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    LongDescriptionAsc = 'longDescription_ASC',
    LongDescriptionDesc = 'longDescription_DESC',
    MailToLinkAsc = 'mailToLink_ASC',
    MailToLinkDesc = 'mailToLink_DESC',
    ShopSearchTermAsc = 'shopSearchTerm_ASC',
    ShopSearchTermDesc = 'shopSearchTerm_DESC',
    ShortDescriptionAsc = 'shortDescription_ASC',
    ShortDescriptionDesc = 'shortDescription_DESC',
    TagAsc = 'tag_ASC',
    TagDesc = 'tag_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
    UtmCreativeFormatParamAsc = 'utmCreativeFormatParam_ASC',
    UtmCreativeFormatParamDesc = 'utmCreativeFormatParam_DESC',
}

export type CampaignAfterSalesAccesoryParent = AfterSale;

export type CampaignAfterSalesAccesoryParentConnectInput = {
    AfterSale?: InputMaybe<AfterSaleConnectInput>;
};

export type CampaignAfterSalesAccesoryParentCreateInput = {
    AfterSale?: InputMaybe<AfterSaleCreateInput>;
};

export type CampaignAfterSalesAccesoryParentCreateManyInlineInput = {
    /** Create and connect multiple existing CampaignAfterSalesAccesoryParent documents */
    create?: InputMaybe<Array<CampaignAfterSalesAccesoryParentCreateInput>>;
};

export type CampaignAfterSalesAccesoryParentCreateOneInlineInput = {
    /** Create and connect one CampaignAfterSalesAccesoryParent document */
    create?: InputMaybe<CampaignAfterSalesAccesoryParentCreateInput>;
};

export type CampaignAfterSalesAccesoryParentCreateWithPositionInput = {
    AfterSale?: InputMaybe<AfterSaleCreateWithPositionInput>;
};

export type CampaignAfterSalesAccesoryParentUpdateInput = {
    AfterSale?: InputMaybe<AfterSaleUpdateInput>;
};

export type CampaignAfterSalesAccesoryParentUpdateManyInlineInput = {
    /** Create and connect multiple CampaignAfterSalesAccesoryParent component instances */
    create?: InputMaybe<Array<CampaignAfterSalesAccesoryParentCreateWithPositionInput>>;
    /** Delete multiple CampaignAfterSalesAccesoryParent documents */
    delete?: InputMaybe<Array<CampaignAfterSalesAccesoryParentWhereUniqueInput>>;
    /** Update multiple CampaignAfterSalesAccesoryParent component instances */
    update?: InputMaybe<Array<CampaignAfterSalesAccesoryParentUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple CampaignAfterSalesAccesoryParent component instances */
    upsert?: InputMaybe<Array<CampaignAfterSalesAccesoryParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CampaignAfterSalesAccesoryParentUpdateManyWithNestedWhereInput = {
    AfterSale?: InputMaybe<AfterSaleUpdateManyWithNestedWhereInput>;
};

export type CampaignAfterSalesAccesoryParentUpdateOneInlineInput = {
    /** Create and connect one CampaignAfterSalesAccesoryParent document */
    create?: InputMaybe<CampaignAfterSalesAccesoryParentCreateInput>;
    /** Delete currently connected CampaignAfterSalesAccesoryParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single CampaignAfterSalesAccesoryParent document */
    update?: InputMaybe<CampaignAfterSalesAccesoryParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single CampaignAfterSalesAccesoryParent document */
    upsert?: InputMaybe<CampaignAfterSalesAccesoryParentUpsertWithNestedWhereUniqueInput>;
};

export type CampaignAfterSalesAccesoryParentUpdateWithNestedWhereUniqueAndPositionInput = {
    AfterSale?: InputMaybe<AfterSaleUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CampaignAfterSalesAccesoryParentUpdateWithNestedWhereUniqueInput = {
    AfterSale?: InputMaybe<AfterSaleUpdateWithNestedWhereUniqueInput>;
};

export type CampaignAfterSalesAccesoryParentUpsertWithNestedWhereUniqueAndPositionInput = {
    AfterSale?: InputMaybe<AfterSaleUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CampaignAfterSalesAccesoryParentUpsertWithNestedWhereUniqueInput = {
    AfterSale?: InputMaybe<AfterSaleUpsertWithNestedWhereUniqueInput>;
};

export type CampaignAfterSalesAccesoryParentWhereInput = {
    AfterSale?: InputMaybe<AfterSaleWhereInput>;
};

export type CampaignAfterSalesAccesoryParentWhereUniqueInput = {
    AfterSale?: InputMaybe<AfterSaleWhereUniqueInput>;
};

export type CampaignAfterSalesAccesoryUpdateInput = {
    accesoryId?: InputMaybe<Scalars['String']['input']>;
    articleNumber?: InputMaybe<Scalars['String']['input']>;
    bulletlist?: InputMaybe<IconTextUpdateManyInlineInput>;
    footnote?: InputMaybe<FootnoteUpdateOneInlineInput>;
    highlightTeaserImage?: InputMaybe<AssetUpdateOneInlineInput>;
    icon?: InputMaybe<AssetUpdateOneInlineInput>;
    image?: InputMaybe<AssetUpdateOneInlineInput>;
    longDescription?: InputMaybe<Scalars['String']['input']>;
    mailToLink?: InputMaybe<Scalars['String']['input']>;
    shopSearchTerm?: InputMaybe<Scalars['String']['input']>;
    shortDescription?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    utmCreativeFormatParam?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignAfterSalesAccesoryUpdateManyInlineInput = {
    /** Create and connect multiple CampaignAfterSalesAccesory component instances */
    create?: InputMaybe<Array<CampaignAfterSalesAccesoryCreateWithPositionInput>>;
    /** Delete multiple CampaignAfterSalesAccesory documents */
    delete?: InputMaybe<Array<CampaignAfterSalesAccesoryWhereUniqueInput>>;
    /** Update multiple CampaignAfterSalesAccesory component instances */
    update?: InputMaybe<Array<CampaignAfterSalesAccesoryUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple CampaignAfterSalesAccesory component instances */
    upsert?: InputMaybe<Array<CampaignAfterSalesAccesoryUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CampaignAfterSalesAccesoryUpdateManyInput = {
    accesoryId?: InputMaybe<Scalars['String']['input']>;
    articleNumber?: InputMaybe<Scalars['String']['input']>;
    longDescription?: InputMaybe<Scalars['String']['input']>;
    mailToLink?: InputMaybe<Scalars['String']['input']>;
    shopSearchTerm?: InputMaybe<Scalars['String']['input']>;
    shortDescription?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    utmCreativeFormatParam?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignAfterSalesAccesoryUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: CampaignAfterSalesAccesoryUpdateManyInput;
    /** Document search */
    where: CampaignAfterSalesAccesoryWhereInput;
};

export type CampaignAfterSalesAccesoryUpdateOneInlineInput = {
    /** Create and connect one CampaignAfterSalesAccesory document */
    create?: InputMaybe<CampaignAfterSalesAccesoryCreateInput>;
    /** Delete currently connected CampaignAfterSalesAccesory document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single CampaignAfterSalesAccesory document */
    update?: InputMaybe<CampaignAfterSalesAccesoryUpdateWithNestedWhereUniqueInput>;
    /** Upsert single CampaignAfterSalesAccesory document */
    upsert?: InputMaybe<CampaignAfterSalesAccesoryUpsertWithNestedWhereUniqueInput>;
};

export type CampaignAfterSalesAccesoryUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<CampaignAfterSalesAccesoryUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: CampaignAfterSalesAccesoryWhereUniqueInput;
};

export type CampaignAfterSalesAccesoryUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: CampaignAfterSalesAccesoryUpdateInput;
    /** Unique document search */
    where: CampaignAfterSalesAccesoryWhereUniqueInput;
};

export type CampaignAfterSalesAccesoryUpsertInput = {
    /** Create document if it didn't exist */
    create: CampaignAfterSalesAccesoryCreateInput;
    /** Update document if it exists */
    update: CampaignAfterSalesAccesoryUpdateInput;
};

export type CampaignAfterSalesAccesoryUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<CampaignAfterSalesAccesoryUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: CampaignAfterSalesAccesoryWhereUniqueInput;
};

export type CampaignAfterSalesAccesoryUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: CampaignAfterSalesAccesoryUpsertInput;
    /** Unique document search */
    where: CampaignAfterSalesAccesoryWhereUniqueInput;
};

/** Identifies documents */
export type CampaignAfterSalesAccesoryWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<CampaignAfterSalesAccesoryWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<CampaignAfterSalesAccesoryWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<CampaignAfterSalesAccesoryWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    accesoryId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    accesoryId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    accesoryId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    accesoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    accesoryId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    accesoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    accesoryId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    accesoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    accesoryId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    accesoryId_starts_with?: InputMaybe<Scalars['String']['input']>;
    articleNumber?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    articleNumber_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    articleNumber_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    articleNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    articleNumber_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    articleNumber_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    articleNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    articleNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    articleNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    articleNumber_starts_with?: InputMaybe<Scalars['String']['input']>;
    bulletlist_every?: InputMaybe<IconTextWhereInput>;
    bulletlist_none?: InputMaybe<IconTextWhereInput>;
    bulletlist_some?: InputMaybe<IconTextWhereInput>;
    footnote?: InputMaybe<FootnoteWhereInput>;
    highlightTeaserImage?: InputMaybe<AssetWhereInput>;
    icon?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    longDescription?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    longDescription_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    longDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    longDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    longDescription_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    longDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    longDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    longDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    longDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    longDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
    mailToLink?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mailToLink_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mailToLink_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mailToLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mailToLink_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mailToLink_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mailToLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mailToLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mailToLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mailToLink_starts_with?: InputMaybe<Scalars['String']['input']>;
    shopSearchTerm?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    shopSearchTerm_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    shopSearchTerm_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    shopSearchTerm_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    shopSearchTerm_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    shopSearchTerm_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    shopSearchTerm_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    shopSearchTerm_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    shopSearchTerm_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    shopSearchTerm_starts_with?: InputMaybe<Scalars['String']['input']>;
    shortDescription?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    shortDescription_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    tag_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    tag_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    tag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    tag_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    tag_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    tag_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    tag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    tag_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    tag_starts_with?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    title_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    title_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    title_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    title_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    utmCreativeFormatParam?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    utmCreativeFormatParam_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    utmCreativeFormatParam_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    utmCreativeFormatParam_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    utmCreativeFormatParam_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    utmCreativeFormatParam_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    utmCreativeFormatParam_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    utmCreativeFormatParam_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    utmCreativeFormatParam_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    utmCreativeFormatParam_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References CampaignAfterSalesAccesory record uniquely */
export type CampaignAfterSalesAccesoryWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type CampaignAfterSalesService = Entity & {
    __typename?: 'CampaignAfterSalesService';
    /** Wird nicht ausgegeben. */
    bulletlist: Array<IconText>;
    /** Fußnote für die Preisangabe */
    footnote?: Maybe<Footnote>;
    /** Wird nicht ausgegeben.  */
    icon?: Maybe<Asset>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /**
     * Format 16:9
     * Ausgabesteuerung durch UTM-Parameter. Siehe Feld ServiceID.
     * Der erste angelegte Service ist der Default-Highlight-Teaser der auch angezeigt wird, wenn kein utm-parameter übergeben wird.
     */
    image?: Maybe<Asset>;
    longDescription?: Maybe<Scalars['String']['output']>;
    /** Hat nach Release2.0 keine Funktion mehr, da Service-Teaser entweder ins Service-Formular des Händlers linken oder nur rein informativ sind, ohne CTA.  */
    mailToLink?: Maybe<Scalars['String']['output']>;
    /** Bestimmt ob ein Service-Teaser ins Service-Formular des Händlers führt. */
    serviceCheckout: Scalars['Boolean']['output'];
    /** Hier werden zur Templatesteuerung des Highlight-Teasers die UTM-Parameter der Service-Teaser hinterlegt. Moccamedia übergibt diese an PXC als utm_creative-format. */
    serviceId?: Maybe<Scalars['String']['output']>;
    shortDescription?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    tag?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    /** Bezeichnung des Service-Teasers für das GA4-Tracking. Bitte kurze, englische Bezeichnungen verwenden! */
    trackingName?: Maybe<Scalars['String']['output']>;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CampaignAfterSalesServiceBulletlistArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<IconTextOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IconTextWhereInput>;
};

export type CampaignAfterSalesServiceFootnoteArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type CampaignAfterSalesServiceIconArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type CampaignAfterSalesServiceImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type CampaignAfterSalesServiceConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: CampaignAfterSalesServiceWhereUniqueInput;
};

/** A connection to a list of items. */
export type CampaignAfterSalesServiceConnection = {
    __typename?: 'CampaignAfterSalesServiceConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<CampaignAfterSalesServiceEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type CampaignAfterSalesServiceCreateInput = {
    bulletlist?: InputMaybe<IconTextCreateManyInlineInput>;
    footnote?: InputMaybe<FootnoteCreateOneInlineInput>;
    icon?: InputMaybe<AssetCreateOneInlineInput>;
    image?: InputMaybe<AssetCreateOneInlineInput>;
    longDescription?: InputMaybe<Scalars['String']['input']>;
    mailToLink?: InputMaybe<Scalars['String']['input']>;
    serviceCheckout: Scalars['Boolean']['input'];
    serviceId?: InputMaybe<Scalars['String']['input']>;
    shortDescription?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    trackingName?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CampaignAfterSalesServiceCreateManyInlineInput = {
    /** Create and connect multiple existing CampaignAfterSalesService documents */
    create?: InputMaybe<Array<CampaignAfterSalesServiceCreateInput>>;
};

export type CampaignAfterSalesServiceCreateOneInlineInput = {
    /** Create and connect one CampaignAfterSalesService document */
    create?: InputMaybe<CampaignAfterSalesServiceCreateInput>;
};

export type CampaignAfterSalesServiceCreateWithPositionInput = {
    /** Document to create */
    data: CampaignAfterSalesServiceCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CampaignAfterSalesServiceEdge = {
    __typename?: 'CampaignAfterSalesServiceEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: CampaignAfterSalesService;
};

/** Identifies documents */
export type CampaignAfterSalesServiceManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<CampaignAfterSalesServiceWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<CampaignAfterSalesServiceWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<CampaignAfterSalesServiceWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    bulletlist_every?: InputMaybe<IconTextWhereInput>;
    bulletlist_none?: InputMaybe<IconTextWhereInput>;
    bulletlist_some?: InputMaybe<IconTextWhereInput>;
    footnote?: InputMaybe<FootnoteWhereInput>;
    icon?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    longDescription?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    longDescription_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    longDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    longDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    longDescription_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    longDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    longDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    longDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    longDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    longDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
    mailToLink?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mailToLink_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mailToLink_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mailToLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mailToLink_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mailToLink_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mailToLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mailToLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mailToLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mailToLink_starts_with?: InputMaybe<Scalars['String']['input']>;
    serviceCheckout?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    serviceCheckout_not?: InputMaybe<Scalars['Boolean']['input']>;
    serviceId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    serviceId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    serviceId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    serviceId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    serviceId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    serviceId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    serviceId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    serviceId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    serviceId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    serviceId_starts_with?: InputMaybe<Scalars['String']['input']>;
    shortDescription?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    shortDescription_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    tag_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    tag_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    tag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    tag_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    tag_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    tag_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    tag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    tag_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    tag_starts_with?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    title_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    title_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    title_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    title_starts_with?: InputMaybe<Scalars['String']['input']>;
    trackingName?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    trackingName_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    trackingName_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    trackingName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    trackingName_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    trackingName_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    trackingName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    trackingName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    trackingName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    trackingName_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CampaignAfterSalesServiceOrderByInput {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    LongDescriptionAsc = 'longDescription_ASC',
    LongDescriptionDesc = 'longDescription_DESC',
    MailToLinkAsc = 'mailToLink_ASC',
    MailToLinkDesc = 'mailToLink_DESC',
    ServiceCheckoutAsc = 'serviceCheckout_ASC',
    ServiceCheckoutDesc = 'serviceCheckout_DESC',
    ServiceIdAsc = 'serviceId_ASC',
    ServiceIdDesc = 'serviceId_DESC',
    ShortDescriptionAsc = 'shortDescription_ASC',
    ShortDescriptionDesc = 'shortDescription_DESC',
    TagAsc = 'tag_ASC',
    TagDesc = 'tag_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    TrackingNameAsc = 'trackingName_ASC',
    TrackingNameDesc = 'trackingName_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type CampaignAfterSalesServiceParent = AfterSale;

export type CampaignAfterSalesServiceParentConnectInput = {
    AfterSale?: InputMaybe<AfterSaleConnectInput>;
};

export type CampaignAfterSalesServiceParentCreateInput = {
    AfterSale?: InputMaybe<AfterSaleCreateInput>;
};

export type CampaignAfterSalesServiceParentCreateManyInlineInput = {
    /** Create and connect multiple existing CampaignAfterSalesServiceParent documents */
    create?: InputMaybe<Array<CampaignAfterSalesServiceParentCreateInput>>;
};

export type CampaignAfterSalesServiceParentCreateOneInlineInput = {
    /** Create and connect one CampaignAfterSalesServiceParent document */
    create?: InputMaybe<CampaignAfterSalesServiceParentCreateInput>;
};

export type CampaignAfterSalesServiceParentCreateWithPositionInput = {
    AfterSale?: InputMaybe<AfterSaleCreateWithPositionInput>;
};

export type CampaignAfterSalesServiceParentUpdateInput = {
    AfterSale?: InputMaybe<AfterSaleUpdateInput>;
};

export type CampaignAfterSalesServiceParentUpdateManyInlineInput = {
    /** Create and connect multiple CampaignAfterSalesServiceParent component instances */
    create?: InputMaybe<Array<CampaignAfterSalesServiceParentCreateWithPositionInput>>;
    /** Delete multiple CampaignAfterSalesServiceParent documents */
    delete?: InputMaybe<Array<CampaignAfterSalesServiceParentWhereUniqueInput>>;
    /** Update multiple CampaignAfterSalesServiceParent component instances */
    update?: InputMaybe<Array<CampaignAfterSalesServiceParentUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple CampaignAfterSalesServiceParent component instances */
    upsert?: InputMaybe<Array<CampaignAfterSalesServiceParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CampaignAfterSalesServiceParentUpdateManyWithNestedWhereInput = {
    AfterSale?: InputMaybe<AfterSaleUpdateManyWithNestedWhereInput>;
};

export type CampaignAfterSalesServiceParentUpdateOneInlineInput = {
    /** Create and connect one CampaignAfterSalesServiceParent document */
    create?: InputMaybe<CampaignAfterSalesServiceParentCreateInput>;
    /** Delete currently connected CampaignAfterSalesServiceParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single CampaignAfterSalesServiceParent document */
    update?: InputMaybe<CampaignAfterSalesServiceParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single CampaignAfterSalesServiceParent document */
    upsert?: InputMaybe<CampaignAfterSalesServiceParentUpsertWithNestedWhereUniqueInput>;
};

export type CampaignAfterSalesServiceParentUpdateWithNestedWhereUniqueAndPositionInput = {
    AfterSale?: InputMaybe<AfterSaleUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CampaignAfterSalesServiceParentUpdateWithNestedWhereUniqueInput = {
    AfterSale?: InputMaybe<AfterSaleUpdateWithNestedWhereUniqueInput>;
};

export type CampaignAfterSalesServiceParentUpsertWithNestedWhereUniqueAndPositionInput = {
    AfterSale?: InputMaybe<AfterSaleUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CampaignAfterSalesServiceParentUpsertWithNestedWhereUniqueInput = {
    AfterSale?: InputMaybe<AfterSaleUpsertWithNestedWhereUniqueInput>;
};

export type CampaignAfterSalesServiceParentWhereInput = {
    AfterSale?: InputMaybe<AfterSaleWhereInput>;
};

export type CampaignAfterSalesServiceParentWhereUniqueInput = {
    AfterSale?: InputMaybe<AfterSaleWhereUniqueInput>;
};

export type CampaignAfterSalesServiceUpdateInput = {
    bulletlist?: InputMaybe<IconTextUpdateManyInlineInput>;
    footnote?: InputMaybe<FootnoteUpdateOneInlineInput>;
    icon?: InputMaybe<AssetUpdateOneInlineInput>;
    image?: InputMaybe<AssetUpdateOneInlineInput>;
    longDescription?: InputMaybe<Scalars['String']['input']>;
    mailToLink?: InputMaybe<Scalars['String']['input']>;
    serviceCheckout?: InputMaybe<Scalars['Boolean']['input']>;
    serviceId?: InputMaybe<Scalars['String']['input']>;
    shortDescription?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    trackingName?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignAfterSalesServiceUpdateManyInlineInput = {
    /** Create and connect multiple CampaignAfterSalesService component instances */
    create?: InputMaybe<Array<CampaignAfterSalesServiceCreateWithPositionInput>>;
    /** Delete multiple CampaignAfterSalesService documents */
    delete?: InputMaybe<Array<CampaignAfterSalesServiceWhereUniqueInput>>;
    /** Update multiple CampaignAfterSalesService component instances */
    update?: InputMaybe<Array<CampaignAfterSalesServiceUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple CampaignAfterSalesService component instances */
    upsert?: InputMaybe<Array<CampaignAfterSalesServiceUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CampaignAfterSalesServiceUpdateManyInput = {
    longDescription?: InputMaybe<Scalars['String']['input']>;
    mailToLink?: InputMaybe<Scalars['String']['input']>;
    serviceCheckout?: InputMaybe<Scalars['Boolean']['input']>;
    serviceId?: InputMaybe<Scalars['String']['input']>;
    shortDescription?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    trackingName?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignAfterSalesServiceUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: CampaignAfterSalesServiceUpdateManyInput;
    /** Document search */
    where: CampaignAfterSalesServiceWhereInput;
};

export type CampaignAfterSalesServiceUpdateOneInlineInput = {
    /** Create and connect one CampaignAfterSalesService document */
    create?: InputMaybe<CampaignAfterSalesServiceCreateInput>;
    /** Delete currently connected CampaignAfterSalesService document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single CampaignAfterSalesService document */
    update?: InputMaybe<CampaignAfterSalesServiceUpdateWithNestedWhereUniqueInput>;
    /** Upsert single CampaignAfterSalesService document */
    upsert?: InputMaybe<CampaignAfterSalesServiceUpsertWithNestedWhereUniqueInput>;
};

export type CampaignAfterSalesServiceUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<CampaignAfterSalesServiceUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: CampaignAfterSalesServiceWhereUniqueInput;
};

export type CampaignAfterSalesServiceUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: CampaignAfterSalesServiceUpdateInput;
    /** Unique document search */
    where: CampaignAfterSalesServiceWhereUniqueInput;
};

export type CampaignAfterSalesServiceUpsertInput = {
    /** Create document if it didn't exist */
    create: CampaignAfterSalesServiceCreateInput;
    /** Update document if it exists */
    update: CampaignAfterSalesServiceUpdateInput;
};

export type CampaignAfterSalesServiceUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<CampaignAfterSalesServiceUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: CampaignAfterSalesServiceWhereUniqueInput;
};

export type CampaignAfterSalesServiceUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: CampaignAfterSalesServiceUpsertInput;
    /** Unique document search */
    where: CampaignAfterSalesServiceWhereUniqueInput;
};

/** Identifies documents */
export type CampaignAfterSalesServiceWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<CampaignAfterSalesServiceWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<CampaignAfterSalesServiceWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<CampaignAfterSalesServiceWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    bulletlist_every?: InputMaybe<IconTextWhereInput>;
    bulletlist_none?: InputMaybe<IconTextWhereInput>;
    bulletlist_some?: InputMaybe<IconTextWhereInput>;
    footnote?: InputMaybe<FootnoteWhereInput>;
    icon?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    longDescription?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    longDescription_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    longDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    longDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    longDescription_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    longDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    longDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    longDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    longDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    longDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
    mailToLink?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mailToLink_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mailToLink_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mailToLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mailToLink_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mailToLink_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mailToLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mailToLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mailToLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mailToLink_starts_with?: InputMaybe<Scalars['String']['input']>;
    serviceCheckout?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    serviceCheckout_not?: InputMaybe<Scalars['Boolean']['input']>;
    serviceId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    serviceId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    serviceId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    serviceId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    serviceId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    serviceId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    serviceId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    serviceId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    serviceId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    serviceId_starts_with?: InputMaybe<Scalars['String']['input']>;
    shortDescription?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    shortDescription_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    tag_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    tag_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    tag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    tag_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    tag_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    tag_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    tag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    tag_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    tag_starts_with?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    title_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    title_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    title_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    title_starts_with?: InputMaybe<Scalars['String']['input']>;
    trackingName?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    trackingName_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    trackingName_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    trackingName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    trackingName_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    trackingName_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    trackingName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    trackingName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    trackingName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    trackingName_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CampaignAfterSalesService record uniquely */
export type CampaignAfterSalesServiceWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type CampaignConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: CampaignWhereUniqueInput;
};

/** A connection to a list of items. */
export type CampaignConnection = {
    __typename?: 'CampaignConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<CampaignEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type CampaignCreateInput = {
    campaignType: CampaignType;
    content?: InputMaybe<CampaigncontentUnionCreateOneInlineInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    dealersKeyCampaigns?: InputMaybe<DealerCreateManyInlineInput>;
    dealersRegularCampaigns?: InputMaybe<DealerCreateManyInlineInput>;
    endDate?: InputMaybe<Scalars['Date']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    heroImage: AssetCreateOneInlineInput;
    heroImageCaption?: InputMaybe<Scalars['String']['input']>;
    importCode?: InputMaybe<Scalars['String']['input']>;
    internerKmpName?: InputMaybe<Scalars['String']['input']>;
    kmpCode?: InputMaybe<Scalars['String']['input']>;
    legalLines?: InputMaybe<Scalars['String']['input']>;
    metaDescriptionOverride?: InputMaybe<Scalars['String']['input']>;
    modelForAnnouncement?: InputMaybe<ModelCreateOneInlineInput>;
    models?: InputMaybe<ModelCreateManyInlineInput>;
    slug: Scalars['String']['input'];
    startDate?: InputMaybe<Scalars['Date']['input']>;
    teaserCopy?: InputMaybe<Scalars['String']['input']>;
    teaserHeadline: Scalars['String']['input'];
    title: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    utmMapping?: InputMaybe<UtmMappingCreateManyInlineInput>;
};

export type CampaignCreateManyInlineInput = {
    /** Connect multiple existing Campaign documents */
    connect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
    /** Create and connect multiple existing Campaign documents */
    create?: InputMaybe<Array<CampaignCreateInput>>;
};

export type CampaignCreateOneInlineInput = {
    /** Connect one existing Campaign document */
    connect?: InputMaybe<CampaignWhereUniqueInput>;
    /** Create and connect one Campaign document */
    create?: InputMaybe<CampaignCreateInput>;
};

/** An edge in a connection. */
export type CampaignEdge = {
    __typename?: 'CampaignEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Campaign;
};

/** Identifies documents */
export type CampaignManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<CampaignWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<CampaignWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<CampaignWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    campaignType?: InputMaybe<CampaignType>;
    /** All values that are contained in given list. */
    campaignType_in?: InputMaybe<Array<InputMaybe<CampaignType>>>;
    /** Any other value that exists and is not equal to the given value. */
    campaignType_not?: InputMaybe<CampaignType>;
    /** All values that are not contained in given list. */
    campaignType_not_in?: InputMaybe<Array<InputMaybe<CampaignType>>>;
    /** All values in which the modular component is connected to the given models */
    content?: InputMaybe<CampaigncontentUnionWhereInput>;
    /** All values in which the union is empty. */
    content_empty?: InputMaybe<Scalars['Boolean']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    dealersKeyCampaigns_every?: InputMaybe<DealerWhereInput>;
    dealersKeyCampaigns_none?: InputMaybe<DealerWhereInput>;
    dealersKeyCampaigns_some?: InputMaybe<DealerWhereInput>;
    dealersRegularCampaigns_every?: InputMaybe<DealerWhereInput>;
    dealersRegularCampaigns_none?: InputMaybe<DealerWhereInput>;
    dealersRegularCampaigns_some?: InputMaybe<DealerWhereInput>;
    documentInStages_every?: InputMaybe<CampaignWhereStageInput>;
    documentInStages_none?: InputMaybe<CampaignWhereStageInput>;
    documentInStages_some?: InputMaybe<CampaignWhereStageInput>;
    endDate?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than the given value. */
    endDate_gt?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than or equal the given value. */
    endDate_gte?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are contained in given list. */
    endDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    /** All values less than the given value. */
    endDate_lt?: InputMaybe<Scalars['Date']['input']>;
    /** All values less than or equal the given value. */
    endDate_lte?: InputMaybe<Scalars['Date']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    endDate_not?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are not contained in given list. */
    endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    heroImageCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroImageCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroImageCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroImageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroImageCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroImageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroImageCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroImageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroImageCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroImageCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    importCode?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    importCode_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    importCode_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    importCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    importCode_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    importCode_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    importCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    importCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    importCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    importCode_starts_with?: InputMaybe<Scalars['String']['input']>;
    internerKmpName?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    internerKmpName_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    internerKmpName_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    internerKmpName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    internerKmpName_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    internerKmpName_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    internerKmpName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    internerKmpName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    internerKmpName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    internerKmpName_starts_with?: InputMaybe<Scalars['String']['input']>;
    kmpCode?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    kmpCode_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    kmpCode_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    kmpCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    kmpCode_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    kmpCode_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    kmpCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    kmpCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    kmpCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    kmpCode_starts_with?: InputMaybe<Scalars['String']['input']>;
    legalLines?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    legalLines_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    legalLines_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    legalLines_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    legalLines_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    legalLines_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    legalLines_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    legalLines_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    legalLines_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    legalLines_starts_with?: InputMaybe<Scalars['String']['input']>;
    metaDescriptionOverride?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    metaDescriptionOverride_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    metaDescriptionOverride_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    metaDescriptionOverride_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    metaDescriptionOverride_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    metaDescriptionOverride_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    metaDescriptionOverride_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    metaDescriptionOverride_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    metaDescriptionOverride_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    metaDescriptionOverride_starts_with?: InputMaybe<Scalars['String']['input']>;
    modelForAnnouncement?: InputMaybe<ModelWhereInput>;
    models_every?: InputMaybe<ModelWhereInput>;
    models_none?: InputMaybe<ModelWhereInput>;
    models_some?: InputMaybe<ModelWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    slug?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    slug_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    slug_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    slug_starts_with?: InputMaybe<Scalars['String']['input']>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than the given value. */
    startDate_gt?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than or equal the given value. */
    startDate_gte?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are contained in given list. */
    startDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    /** All values less than the given value. */
    startDate_lt?: InputMaybe<Scalars['Date']['input']>;
    /** All values less than or equal the given value. */
    startDate_lte?: InputMaybe<Scalars['Date']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    startDate_not?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are not contained in given list. */
    startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    teaserCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    teaserCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    teaserCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    teaserCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    teaserCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    teaserCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    teaserCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    teaserCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    teaserCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    teaserCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    teaserHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    teaserHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    teaserHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    teaserHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    teaserHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    teaserHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    teaserHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    teaserHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    teaserHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    teaserHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    title_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    title_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    title_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    title_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    utmMapping_every?: InputMaybe<UtmMappingWhereInput>;
    utmMapping_none?: InputMaybe<UtmMappingWhereInput>;
    utmMapping_some?: InputMaybe<UtmMappingWhereInput>;
};

export enum CampaignOrderByInput {
    CampaignTypeAsc = 'campaignType_ASC',
    CampaignTypeDesc = 'campaignType_DESC',
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    EndDateAsc = 'endDate_ASC',
    EndDateDesc = 'endDate_DESC',
    HeroHeadlineAsc = 'heroHeadline_ASC',
    HeroHeadlineDesc = 'heroHeadline_DESC',
    HeroImageCaptionAsc = 'heroImageCaption_ASC',
    HeroImageCaptionDesc = 'heroImageCaption_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    ImportCodeAsc = 'importCode_ASC',
    ImportCodeDesc = 'importCode_DESC',
    InternerKmpNameAsc = 'internerKmpName_ASC',
    InternerKmpNameDesc = 'internerKmpName_DESC',
    KmpCodeAsc = 'kmpCode_ASC',
    KmpCodeDesc = 'kmpCode_DESC',
    LegalLinesAsc = 'legalLines_ASC',
    LegalLinesDesc = 'legalLines_DESC',
    MetaDescriptionOverrideAsc = 'metaDescriptionOverride_ASC',
    MetaDescriptionOverrideDesc = 'metaDescriptionOverride_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    StartDateAsc = 'startDate_ASC',
    StartDateDesc = 'startDate_DESC',
    TeaserCopyAsc = 'teaserCopy_ASC',
    TeaserCopyDesc = 'teaserCopy_DESC',
    TeaserHeadlineAsc = 'teaserHeadline_ASC',
    TeaserHeadlineDesc = 'teaserHeadline_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export enum CampaignPricingType {
    Cash = 'cash',
    Financing = 'financing',
    Leasing = 'leasing',
}

export type CampaignService = Entity &
    Node & {
        __typename?: 'CampaignService';
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Get the document in other stages */
        documentInStages: Array<CampaignService>;
        /** List of CampaignService versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        image: Asset;
        longDescription: RichText;
        price: Scalars['String']['output'];
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        seoIdentifier?: Maybe<Scalars['String']['output']>;
        /** System stage field */
        stage: Stage;
        tag?: Maybe<Scalars['String']['output']>;
        title: Scalars['String']['output'];
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

export type CampaignServiceCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type CampaignServiceDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type CampaignServiceHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type CampaignServiceImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type CampaignServicePublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type CampaignServiceScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type CampaignServiceUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type CampaignServiceConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: CampaignServiceWhereUniqueInput;
};

/** A connection to a list of items. */
export type CampaignServiceConnection = {
    __typename?: 'CampaignServiceConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<CampaignServiceEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type CampaignServiceCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    image: AssetCreateOneInlineInput;
    longDescription: Scalars['RichTextAST']['input'];
    price: Scalars['String']['input'];
    seoIdentifier?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    title: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CampaignServiceCreateManyInlineInput = {
    /** Connect multiple existing CampaignService documents */
    connect?: InputMaybe<Array<CampaignServiceWhereUniqueInput>>;
    /** Create and connect multiple existing CampaignService documents */
    create?: InputMaybe<Array<CampaignServiceCreateInput>>;
};

export type CampaignServiceCreateOneInlineInput = {
    /** Connect one existing CampaignService document */
    connect?: InputMaybe<CampaignServiceWhereUniqueInput>;
    /** Create and connect one CampaignService document */
    create?: InputMaybe<CampaignServiceCreateInput>;
};

/** An edge in a connection. */
export type CampaignServiceEdge = {
    __typename?: 'CampaignServiceEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: CampaignService;
};

/** Identifies documents */
export type CampaignServiceManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<CampaignServiceWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<CampaignServiceWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<CampaignServiceWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<CampaignServiceWhereStageInput>;
    documentInStages_none?: InputMaybe<CampaignServiceWhereStageInput>;
    documentInStages_some?: InputMaybe<CampaignServiceWhereStageInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    price?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    price_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    price_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    price_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    price_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    price_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    price_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    price_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    price_starts_with?: InputMaybe<Scalars['String']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    seoIdentifier?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    seoIdentifier_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    seoIdentifier_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    seoIdentifier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    seoIdentifier_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    seoIdentifier_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    seoIdentifier_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    seoIdentifier_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    seoIdentifier_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    seoIdentifier_starts_with?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    tag_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    tag_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    tag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    tag_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    tag_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    tag_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    tag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    tag_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    tag_starts_with?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    title_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    title_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    title_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    title_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CampaignServiceOrderByInput {
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    PriceAsc = 'price_ASC',
    PriceDesc = 'price_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    SeoIdentifierAsc = 'seoIdentifier_ASC',
    SeoIdentifierDesc = 'seoIdentifier_DESC',
    TagAsc = 'tag_ASC',
    TagDesc = 'tag_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type CampaignServiceUpdateInput = {
    image?: InputMaybe<AssetUpdateOneInlineInput>;
    longDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
    price?: InputMaybe<Scalars['String']['input']>;
    seoIdentifier?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignServiceUpdateManyInlineInput = {
    /** Connect multiple existing CampaignService documents */
    connect?: InputMaybe<Array<CampaignServiceConnectInput>>;
    /** Create and connect multiple CampaignService documents */
    create?: InputMaybe<Array<CampaignServiceCreateInput>>;
    /** Delete multiple CampaignService documents */
    delete?: InputMaybe<Array<CampaignServiceWhereUniqueInput>>;
    /** Disconnect multiple CampaignService documents */
    disconnect?: InputMaybe<Array<CampaignServiceWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing CampaignService documents */
    set?: InputMaybe<Array<CampaignServiceWhereUniqueInput>>;
    /** Update multiple CampaignService documents */
    update?: InputMaybe<Array<CampaignServiceUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple CampaignService documents */
    upsert?: InputMaybe<Array<CampaignServiceUpsertWithNestedWhereUniqueInput>>;
};

export type CampaignServiceUpdateManyInput = {
    longDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
    price?: InputMaybe<Scalars['String']['input']>;
    seoIdentifier?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignServiceUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: CampaignServiceUpdateManyInput;
    /** Document search */
    where: CampaignServiceWhereInput;
};

export type CampaignServiceUpdateOneInlineInput = {
    /** Connect existing CampaignService document */
    connect?: InputMaybe<CampaignServiceWhereUniqueInput>;
    /** Create and connect one CampaignService document */
    create?: InputMaybe<CampaignServiceCreateInput>;
    /** Delete currently connected CampaignService document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected CampaignService document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single CampaignService document */
    update?: InputMaybe<CampaignServiceUpdateWithNestedWhereUniqueInput>;
    /** Upsert single CampaignService document */
    upsert?: InputMaybe<CampaignServiceUpsertWithNestedWhereUniqueInput>;
};

export type CampaignServiceUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: CampaignServiceUpdateInput;
    /** Unique document search */
    where: CampaignServiceWhereUniqueInput;
};

export type CampaignServiceUpsertInput = {
    /** Create document if it didn't exist */
    create: CampaignServiceCreateInput;
    /** Update document if it exists */
    update: CampaignServiceUpdateInput;
};

export type CampaignServiceUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: CampaignServiceUpsertInput;
    /** Unique document search */
    where: CampaignServiceWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CampaignServiceWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CampaignServiceWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<CampaignServiceWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<CampaignServiceWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<CampaignServiceWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<CampaignServiceWhereStageInput>;
    documentInStages_none?: InputMaybe<CampaignServiceWhereStageInput>;
    documentInStages_some?: InputMaybe<CampaignServiceWhereStageInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    price?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    price_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    price_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    price_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    price_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    price_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    price_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    price_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    price_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    price_starts_with?: InputMaybe<Scalars['String']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    seoIdentifier?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    seoIdentifier_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    seoIdentifier_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    seoIdentifier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    seoIdentifier_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    seoIdentifier_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    seoIdentifier_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    seoIdentifier_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    seoIdentifier_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    seoIdentifier_starts_with?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    tag_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    tag_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    tag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    tag_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    tag_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    tag_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    tag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    tag_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    tag_starts_with?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    title_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    title_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    title_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    title_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CampaignServiceWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<CampaignServiceWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<CampaignServiceWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<CampaignServiceWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<CampaignServiceWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References CampaignService record uniquely */
export type CampaignServiceWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export enum CampaignType {
    AfterSales = 'AfterSales',
    Modellankuendigung = 'Modellankuendigung',
    VertriebGewerbe = 'VertriebGewerbe',
    VertriebPrivat = 'VertriebPrivat',
}

export type CampaignUpdateInput = {
    campaignType?: InputMaybe<CampaignType>;
    content?: InputMaybe<CampaigncontentUnionUpdateOneInlineInput>;
    dealersKeyCampaigns?: InputMaybe<DealerUpdateManyInlineInput>;
    dealersRegularCampaigns?: InputMaybe<DealerUpdateManyInlineInput>;
    endDate?: InputMaybe<Scalars['Date']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetUpdateOneInlineInput>;
    heroImageCaption?: InputMaybe<Scalars['String']['input']>;
    importCode?: InputMaybe<Scalars['String']['input']>;
    internerKmpName?: InputMaybe<Scalars['String']['input']>;
    kmpCode?: InputMaybe<Scalars['String']['input']>;
    legalLines?: InputMaybe<Scalars['String']['input']>;
    metaDescriptionOverride?: InputMaybe<Scalars['String']['input']>;
    modelForAnnouncement?: InputMaybe<ModelUpdateOneInlineInput>;
    models?: InputMaybe<ModelUpdateManyInlineInput>;
    slug?: InputMaybe<Scalars['String']['input']>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
    teaserCopy?: InputMaybe<Scalars['String']['input']>;
    teaserHeadline?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    utmMapping?: InputMaybe<UtmMappingUpdateManyInlineInput>;
};

export type CampaignUpdateManyInlineInput = {
    /** Connect multiple existing Campaign documents */
    connect?: InputMaybe<Array<CampaignConnectInput>>;
    /** Create and connect multiple Campaign documents */
    create?: InputMaybe<Array<CampaignCreateInput>>;
    /** Delete multiple Campaign documents */
    delete?: InputMaybe<Array<CampaignWhereUniqueInput>>;
    /** Disconnect multiple Campaign documents */
    disconnect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing Campaign documents */
    set?: InputMaybe<Array<CampaignWhereUniqueInput>>;
    /** Update multiple Campaign documents */
    update?: InputMaybe<Array<CampaignUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple Campaign documents */
    upsert?: InputMaybe<Array<CampaignUpsertWithNestedWhereUniqueInput>>;
};

export type CampaignUpdateManyInput = {
    campaignType?: InputMaybe<CampaignType>;
    endDate?: InputMaybe<Scalars['Date']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    heroImageCaption?: InputMaybe<Scalars['String']['input']>;
    importCode?: InputMaybe<Scalars['String']['input']>;
    internerKmpName?: InputMaybe<Scalars['String']['input']>;
    kmpCode?: InputMaybe<Scalars['String']['input']>;
    legalLines?: InputMaybe<Scalars['String']['input']>;
    metaDescriptionOverride?: InputMaybe<Scalars['String']['input']>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
    teaserCopy?: InputMaybe<Scalars['String']['input']>;
    teaserHeadline?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: CampaignUpdateManyInput;
    /** Document search */
    where: CampaignWhereInput;
};

export type CampaignUpdateOneInlineInput = {
    /** Connect existing Campaign document */
    connect?: InputMaybe<CampaignWhereUniqueInput>;
    /** Create and connect one Campaign document */
    create?: InputMaybe<CampaignCreateInput>;
    /** Delete currently connected Campaign document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected Campaign document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Campaign document */
    update?: InputMaybe<CampaignUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Campaign document */
    upsert?: InputMaybe<CampaignUpsertWithNestedWhereUniqueInput>;
};

export type CampaignUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: CampaignUpdateInput;
    /** Unique document search */
    where: CampaignWhereUniqueInput;
};

export type CampaignUpsertInput = {
    /** Create document if it didn't exist */
    create: CampaignCreateInput;
    /** Update document if it exists */
    update: CampaignUpdateInput;
};

export type CampaignUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: CampaignUpsertInput;
    /** Unique document search */
    where: CampaignWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CampaignWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CampaignWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<CampaignWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<CampaignWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<CampaignWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    campaignType?: InputMaybe<CampaignType>;
    /** All values that are contained in given list. */
    campaignType_in?: InputMaybe<Array<InputMaybe<CampaignType>>>;
    /** Any other value that exists and is not equal to the given value. */
    campaignType_not?: InputMaybe<CampaignType>;
    /** All values that are not contained in given list. */
    campaignType_not_in?: InputMaybe<Array<InputMaybe<CampaignType>>>;
    /** All values in which the modular component is connected to the given models */
    content?: InputMaybe<CampaigncontentUnionWhereInput>;
    /** All values in which the union is empty. */
    content_empty?: InputMaybe<Scalars['Boolean']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    dealersKeyCampaigns_every?: InputMaybe<DealerWhereInput>;
    dealersKeyCampaigns_none?: InputMaybe<DealerWhereInput>;
    dealersKeyCampaigns_some?: InputMaybe<DealerWhereInput>;
    dealersRegularCampaigns_every?: InputMaybe<DealerWhereInput>;
    dealersRegularCampaigns_none?: InputMaybe<DealerWhereInput>;
    dealersRegularCampaigns_some?: InputMaybe<DealerWhereInput>;
    documentInStages_every?: InputMaybe<CampaignWhereStageInput>;
    documentInStages_none?: InputMaybe<CampaignWhereStageInput>;
    documentInStages_some?: InputMaybe<CampaignWhereStageInput>;
    endDate?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than the given value. */
    endDate_gt?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than or equal the given value. */
    endDate_gte?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are contained in given list. */
    endDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    /** All values less than the given value. */
    endDate_lt?: InputMaybe<Scalars['Date']['input']>;
    /** All values less than or equal the given value. */
    endDate_lte?: InputMaybe<Scalars['Date']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    endDate_not?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are not contained in given list. */
    endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    heroImageCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroImageCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroImageCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroImageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroImageCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroImageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroImageCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroImageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroImageCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroImageCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    importCode?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    importCode_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    importCode_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    importCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    importCode_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    importCode_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    importCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    importCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    importCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    importCode_starts_with?: InputMaybe<Scalars['String']['input']>;
    internerKmpName?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    internerKmpName_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    internerKmpName_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    internerKmpName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    internerKmpName_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    internerKmpName_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    internerKmpName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    internerKmpName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    internerKmpName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    internerKmpName_starts_with?: InputMaybe<Scalars['String']['input']>;
    kmpCode?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    kmpCode_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    kmpCode_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    kmpCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    kmpCode_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    kmpCode_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    kmpCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    kmpCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    kmpCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    kmpCode_starts_with?: InputMaybe<Scalars['String']['input']>;
    legalLines?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    legalLines_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    legalLines_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    legalLines_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    legalLines_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    legalLines_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    legalLines_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    legalLines_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    legalLines_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    legalLines_starts_with?: InputMaybe<Scalars['String']['input']>;
    metaDescriptionOverride?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    metaDescriptionOverride_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    metaDescriptionOverride_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    metaDescriptionOverride_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    metaDescriptionOverride_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    metaDescriptionOverride_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    metaDescriptionOverride_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    metaDescriptionOverride_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    metaDescriptionOverride_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    metaDescriptionOverride_starts_with?: InputMaybe<Scalars['String']['input']>;
    modelForAnnouncement?: InputMaybe<ModelWhereInput>;
    models_every?: InputMaybe<ModelWhereInput>;
    models_none?: InputMaybe<ModelWhereInput>;
    models_some?: InputMaybe<ModelWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    slug?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    slug_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    slug_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    slug_starts_with?: InputMaybe<Scalars['String']['input']>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than the given value. */
    startDate_gt?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than or equal the given value. */
    startDate_gte?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are contained in given list. */
    startDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    /** All values less than the given value. */
    startDate_lt?: InputMaybe<Scalars['Date']['input']>;
    /** All values less than or equal the given value. */
    startDate_lte?: InputMaybe<Scalars['Date']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    startDate_not?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are not contained in given list. */
    startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    teaserCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    teaserCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    teaserCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    teaserCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    teaserCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    teaserCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    teaserCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    teaserCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    teaserCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    teaserCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    teaserHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    teaserHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    teaserHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    teaserHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    teaserHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    teaserHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    teaserHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    teaserHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    teaserHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    teaserHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    title_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    title_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    title_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    title_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    utmMapping_every?: InputMaybe<UtmMappingWhereInput>;
    utmMapping_none?: InputMaybe<UtmMappingWhereInput>;
    utmMapping_some?: InputMaybe<UtmMappingWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CampaignWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<CampaignWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<CampaignWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<CampaignWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<CampaignWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References Campaign record uniquely */
export type CampaignWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
};

export type CampaigncontentUnion = AfterSale | ModellAnkuendigungContent | SalesCampaignContent;

export type CampaigncontentUnionConnectInput = {
    AfterSale?: InputMaybe<AfterSaleConnectInput>;
    ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentConnectInput>;
    SalesCampaignContent?: InputMaybe<SalesCampaignContentConnectInput>;
};

export type CampaigncontentUnionCreateInput = {
    AfterSale?: InputMaybe<AfterSaleCreateInput>;
    ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentCreateInput>;
    SalesCampaignContent?: InputMaybe<SalesCampaignContentCreateInput>;
};

export type CampaigncontentUnionCreateManyInlineInput = {
    /** Create and connect multiple existing CampaigncontentUnion documents */
    create?: InputMaybe<Array<CampaigncontentUnionCreateInput>>;
};

export type CampaigncontentUnionCreateOneInlineInput = {
    /** Create and connect one CampaigncontentUnion document */
    create?: InputMaybe<CampaigncontentUnionCreateInput>;
};

export type CampaigncontentUnionCreateWithPositionInput = {
    AfterSale?: InputMaybe<AfterSaleCreateWithPositionInput>;
    ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentCreateWithPositionInput>;
    SalesCampaignContent?: InputMaybe<SalesCampaignContentCreateWithPositionInput>;
};

export type CampaigncontentUnionUpdateInput = {
    AfterSale?: InputMaybe<AfterSaleUpdateInput>;
    ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentUpdateInput>;
    SalesCampaignContent?: InputMaybe<SalesCampaignContentUpdateInput>;
};

export type CampaigncontentUnionUpdateManyInlineInput = {
    /** Create and connect multiple CampaigncontentUnion component instances */
    create?: InputMaybe<Array<CampaigncontentUnionCreateWithPositionInput>>;
    /** Delete multiple CampaigncontentUnion documents */
    delete?: InputMaybe<Array<CampaigncontentUnionWhereUniqueInput>>;
    /** Update multiple CampaigncontentUnion component instances */
    update?: InputMaybe<Array<CampaigncontentUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple CampaigncontentUnion component instances */
    upsert?: InputMaybe<Array<CampaigncontentUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CampaigncontentUnionUpdateManyWithNestedWhereInput = {
    AfterSale?: InputMaybe<AfterSaleUpdateManyWithNestedWhereInput>;
    ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentUpdateManyWithNestedWhereInput>;
    SalesCampaignContent?: InputMaybe<SalesCampaignContentUpdateManyWithNestedWhereInput>;
};

export type CampaigncontentUnionUpdateOneInlineInput = {
    /** Create and connect one CampaigncontentUnion document */
    create?: InputMaybe<CampaigncontentUnionCreateInput>;
    /** Delete currently connected CampaigncontentUnion document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single CampaigncontentUnion document */
    update?: InputMaybe<CampaigncontentUnionUpdateWithNestedWhereUniqueInput>;
    /** Upsert single CampaigncontentUnion document */
    upsert?: InputMaybe<CampaigncontentUnionUpsertWithNestedWhereUniqueInput>;
};

export type CampaigncontentUnionUpdateWithNestedWhereUniqueAndPositionInput = {
    AfterSale?: InputMaybe<AfterSaleUpdateWithNestedWhereUniqueAndPositionInput>;
    ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentUpdateWithNestedWhereUniqueAndPositionInput>;
    SalesCampaignContent?: InputMaybe<SalesCampaignContentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CampaigncontentUnionUpdateWithNestedWhereUniqueInput = {
    AfterSale?: InputMaybe<AfterSaleUpdateWithNestedWhereUniqueInput>;
    ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentUpdateWithNestedWhereUniqueInput>;
    SalesCampaignContent?: InputMaybe<SalesCampaignContentUpdateWithNestedWhereUniqueInput>;
};

export type CampaigncontentUnionUpsertWithNestedWhereUniqueAndPositionInput = {
    AfterSale?: InputMaybe<AfterSaleUpsertWithNestedWhereUniqueAndPositionInput>;
    ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentUpsertWithNestedWhereUniqueAndPositionInput>;
    SalesCampaignContent?: InputMaybe<SalesCampaignContentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CampaigncontentUnionUpsertWithNestedWhereUniqueInput = {
    AfterSale?: InputMaybe<AfterSaleUpsertWithNestedWhereUniqueInput>;
    ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentUpsertWithNestedWhereUniqueInput>;
    SalesCampaignContent?: InputMaybe<SalesCampaignContentUpsertWithNestedWhereUniqueInput>;
};

export type CampaigncontentUnionWhereInput = {
    AfterSale?: InputMaybe<AfterSaleWhereInput>;
    ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentWhereInput>;
    SalesCampaignContent?: InputMaybe<SalesCampaignContentWhereInput>;
};

export type CampaigncontentUnionWhereUniqueInput = {
    AfterSale?: InputMaybe<AfterSaleWhereUniqueInput>;
    ModellAnkuendigungContent?: InputMaybe<ModellAnkuendigungContentWhereUniqueInput>;
    SalesCampaignContent?: InputMaybe<SalesCampaignContentWhereUniqueInput>;
};

export enum Co2Class {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
    F = 'F',
    G = 'G',
}

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
    __typename?: 'Color';
    css: Scalars['String']['output'];
    hex: Scalars['Hex']['output'];
    rgba: Rgba;
};

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
    hex?: InputMaybe<Scalars['Hex']['input']>;
    rgba?: InputMaybe<RgbaInput>;
};

export type ConnectPositionInput = {
    /** Connect document after specified document */
    after?: InputMaybe<Scalars['ID']['input']>;
    /** Connect document before specified document */
    before?: InputMaybe<Scalars['ID']['input']>;
    /** Connect document at last position */
    end?: InputMaybe<Scalars['Boolean']['input']>;
    /** Connect document at first position */
    start?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Contact = Entity & {
    __typename?: 'Contact';
    email?: Maybe<Scalars['String']['output']>;
    fax?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    phone?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: ContactWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContactConnection = {
    __typename?: 'ContactConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<ContactEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type ContactCreateInput = {
    email?: InputMaybe<Scalars['String']['input']>;
    fax?: InputMaybe<Scalars['String']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContactCreateManyInlineInput = {
    /** Create and connect multiple existing Contact documents */
    create?: InputMaybe<Array<ContactCreateInput>>;
};

export type ContactCreateOneInlineInput = {
    /** Create and connect one Contact document */
    create?: InputMaybe<ContactCreateInput>;
};

export type ContactCreateWithPositionInput = {
    /** Document to create */
    data: ContactCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ContactEdge = {
    __typename?: 'ContactEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Contact;
};

/** Identifies documents */
export type ContactManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<ContactWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<ContactWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<ContactWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    email_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    email_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    email_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    email_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    email_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    email_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    email_starts_with?: InputMaybe<Scalars['String']['input']>;
    fax?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    fax_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    fax_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    fax_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    fax_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    fax_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    fax_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    fax_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    fax_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    fax_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    phone_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    phone_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    phone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    phone_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    phone_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    phone_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    phone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    phone_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    phone_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ContactOrderByInput {
    EmailAsc = 'email_ASC',
    EmailDesc = 'email_DESC',
    FaxAsc = 'fax_ASC',
    FaxDesc = 'fax_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    PhoneAsc = 'phone_ASC',
    PhoneDesc = 'phone_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type ContactParent = Dealer;

export type ContactParentConnectInput = {
    Dealer?: InputMaybe<DealerConnectInput>;
};

export type ContactParentCreateInput = {
    Dealer?: InputMaybe<DealerCreateInput>;
};

export type ContactParentCreateManyInlineInput = {
    /** Connect multiple existing ContactParent documents */
    connect?: InputMaybe<Array<ContactParentWhereUniqueInput>>;
    /** Create and connect multiple existing ContactParent documents */
    create?: InputMaybe<Array<ContactParentCreateInput>>;
};

export type ContactParentCreateOneInlineInput = {
    /** Connect one existing ContactParent document */
    connect?: InputMaybe<ContactParentWhereUniqueInput>;
    /** Create and connect one ContactParent document */
    create?: InputMaybe<ContactParentCreateInput>;
};

export type ContactParentUpdateInput = {
    Dealer?: InputMaybe<DealerUpdateInput>;
};

export type ContactParentUpdateManyInlineInput = {
    /** Connect multiple existing ContactParent documents */
    connect?: InputMaybe<Array<ContactParentConnectInput>>;
    /** Create and connect multiple ContactParent documents */
    create?: InputMaybe<Array<ContactParentCreateInput>>;
    /** Delete multiple ContactParent documents */
    delete?: InputMaybe<Array<ContactParentWhereUniqueInput>>;
    /** Disconnect multiple ContactParent documents */
    disconnect?: InputMaybe<Array<ContactParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing ContactParent documents */
    set?: InputMaybe<Array<ContactParentWhereUniqueInput>>;
    /** Update multiple ContactParent documents */
    update?: InputMaybe<Array<ContactParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple ContactParent documents */
    upsert?: InputMaybe<Array<ContactParentUpsertWithNestedWhereUniqueInput>>;
};

export type ContactParentUpdateManyWithNestedWhereInput = {
    Dealer?: InputMaybe<DealerUpdateManyWithNestedWhereInput>;
};

export type ContactParentUpdateOneInlineInput = {
    /** Connect existing ContactParent document */
    connect?: InputMaybe<ContactParentWhereUniqueInput>;
    /** Create and connect one ContactParent document */
    create?: InputMaybe<ContactParentCreateInput>;
    /** Delete currently connected ContactParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected ContactParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single ContactParent document */
    update?: InputMaybe<ContactParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single ContactParent document */
    upsert?: InputMaybe<ContactParentUpsertWithNestedWhereUniqueInput>;
};

export type ContactParentUpdateWithNestedWhereUniqueInput = {
    Dealer?: InputMaybe<DealerUpdateWithNestedWhereUniqueInput>;
};

export type ContactParentUpsertWithNestedWhereUniqueInput = {
    Dealer?: InputMaybe<DealerUpsertWithNestedWhereUniqueInput>;
};

export type ContactParentWhereInput = {
    Dealer?: InputMaybe<DealerWhereInput>;
};

export type ContactParentWhereUniqueInput = {
    Dealer?: InputMaybe<DealerWhereUniqueInput>;
};

export type ContactUpdateInput = {
    email?: InputMaybe<Scalars['String']['input']>;
    fax?: InputMaybe<Scalars['String']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactUpdateManyInlineInput = {
    /** Create and connect multiple Contact component instances */
    create?: InputMaybe<Array<ContactCreateWithPositionInput>>;
    /** Delete multiple Contact documents */
    delete?: InputMaybe<Array<ContactWhereUniqueInput>>;
    /** Update multiple Contact component instances */
    update?: InputMaybe<Array<ContactUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple Contact component instances */
    upsert?: InputMaybe<Array<ContactUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ContactUpdateManyInput = {
    email?: InputMaybe<Scalars['String']['input']>;
    fax?: InputMaybe<Scalars['String']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: ContactUpdateManyInput;
    /** Document search */
    where: ContactWhereInput;
};

export type ContactUpdateOneInlineInput = {
    /** Create and connect one Contact document */
    create?: InputMaybe<ContactCreateInput>;
    /** Delete currently connected Contact document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Contact document */
    update?: InputMaybe<ContactUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Contact document */
    upsert?: InputMaybe<ContactUpsertWithNestedWhereUniqueInput>;
};

export type ContactUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<ContactUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: ContactWhereUniqueInput;
};

export type ContactUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: ContactUpdateInput;
    /** Unique document search */
    where: ContactWhereUniqueInput;
};

export type ContactUpsertInput = {
    /** Create document if it didn't exist */
    create: ContactCreateInput;
    /** Update document if it exists */
    update: ContactUpdateInput;
};

export type ContactUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<ContactUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: ContactWhereUniqueInput;
};

export type ContactUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: ContactUpsertInput;
    /** Unique document search */
    where: ContactWhereUniqueInput;
};

/** Identifies documents */
export type ContactWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<ContactWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<ContactWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<ContactWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    email_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    email_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    email_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    email_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    email_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    email_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    email_starts_with?: InputMaybe<Scalars['String']['input']>;
    fax?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    fax_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    fax_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    fax_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    fax_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    fax_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    fax_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    fax_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    fax_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    fax_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    phone_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    phone_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    phone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    phone_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    phone_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    phone_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    phone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    phone_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    phone_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Contact record uniquely */
export type ContactWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export enum CtaType {
    Angebot = 'angebot',
    Probefahrt = 'probefahrt',
}

export enum Day {
    Friday = 'Friday',
    Monday = 'Monday',
    Saturday = 'Saturday',
    Sunday = 'Sunday',
    Thursday = 'Thursday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
}

export type Dealer = Entity &
    Node & {
        __typename?: 'Dealer';
        address?: Maybe<Address>;
        auth0User: Array<Auth0User>;
        businessCenter: Scalars['Boolean']['output'];
        campaignKey?: Maybe<Campaign>;
        campaignsRegular: Array<Campaign>;
        careerUrl?: Maybe<Scalars['String']['output']>;
        contact?: Maybe<Contact>;
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        dealerId: Scalars['String']['output'];
        dealerType: DealerType;
        /** Get the document in other stages */
        documentInStages: Array<Dealer>;
        firstBillingMonth?: Maybe<Scalars['Date']['output']>;
        hPromise: Scalars['Boolean']['output'];
        hasHcm?: Maybe<Scalars['Boolean']['output']>;
        hasHws: Scalars['Boolean']['output'];
        hcmUrl?: Maybe<Scalars['String']['output']>;
        /** List of Dealer versions */
        history: Array<Version>;
        hwsEndDate?: Maybe<Scalars['Date']['output']>;
        /** Bestelleingang für eine neue HWS.  */
        hwsOrderDate?: Maybe<Scalars['Date']['output']>;
        hwsStartDate?: Maybe<Scalars['Date']['output']>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        inseratMailRecipients: Array<Scalars['String']['output']>;
        logo?: Maybe<Asset>;
        managingDirector?: Maybe<Scalars['String']['output']>;
        menuImage?: Maybe<Asset>;
        mobileSellerId?: Maybe<Scalars['String']['output']>;
        name?: Maybe<Scalars['String']['output']>;
        name2?: Maybe<Scalars['String']['output']>;
        name3?: Maybe<Scalars['String']['output']>;
        /** Nur für interne Nutzung */
        notiz?: Maybe<Scalars['String']['output']>;
        oldSlugs: Array<Scalars['String']['output']>;
        openingTimesParts: Array<Opening>;
        openingTimesSales: Array<Opening>;
        openingTimesService: Array<Opening>;
        parentDealer?: Maybe<Dealer>;
        partsStore: Scalars['Boolean']['output'];
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        regionsnummerDlv?: Maybe<Scalars['Int']['output']>;
        requireLogin: Scalars['Boolean']['output'];
        sapId: Scalars['String']['output'];
        scheduledIn: Array<ScheduledOperation>;
        slug?: Maybe<Scalars['String']['output']>;
        socialFacebook?: Maybe<Scalars['String']['output']>;
        socialInstagram?: Maybe<Scalars['String']['output']>;
        socialLinkedIn?: Maybe<Scalars['String']['output']>;
        socialTikTok?: Maybe<Scalars['String']['output']>;
        socialX?: Maybe<Scalars['String']['output']>;
        socialYouTube?: Maybe<Scalars['String']['output']>;
        /** System stage field */
        stage: Stage;
        state: State;
        subDealers: Array<Dealer>;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
        whatsappNumber?: Maybe<Scalars['String']['output']>;
    };

export type DealerAddressArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type DealerAuth0UserArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<Auth0UserOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<Auth0UserWhereInput>;
};

export type DealerCampaignKeyArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type DealerCampaignsRegularArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<CampaignOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CampaignWhereInput>;
};

export type DealerContactArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type DealerCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type DealerDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type DealerHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type DealerLogoArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type DealerMenuImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type DealerOpeningTimesPartsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<OpeningOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OpeningWhereInput>;
};

export type DealerOpeningTimesSalesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<OpeningOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OpeningWhereInput>;
};

export type DealerOpeningTimesServiceArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<OpeningOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OpeningWhereInput>;
};

export type DealerParentDealerArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type DealerPublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type DealerScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type DealerSubDealersArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<DealerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DealerWhereInput>;
};

export type DealerUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type DealerConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: DealerWhereUniqueInput;
};

/** A connection to a list of items. */
export type DealerConnection = {
    __typename?: 'DealerConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<DealerEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type DealerCreateInput = {
    address?: InputMaybe<AddressCreateOneInlineInput>;
    auth0User?: InputMaybe<Auth0UserCreateManyInlineInput>;
    businessCenter: Scalars['Boolean']['input'];
    campaignKey?: InputMaybe<CampaignCreateOneInlineInput>;
    campaignsRegular?: InputMaybe<CampaignCreateManyInlineInput>;
    careerUrl?: InputMaybe<Scalars['String']['input']>;
    contact?: InputMaybe<ContactCreateOneInlineInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    dealerId: Scalars['String']['input'];
    dealerType: DealerType;
    firstBillingMonth?: InputMaybe<Scalars['Date']['input']>;
    hPromise: Scalars['Boolean']['input'];
    hasHcm?: InputMaybe<Scalars['Boolean']['input']>;
    hasHws: Scalars['Boolean']['input'];
    hcmUrl?: InputMaybe<Scalars['String']['input']>;
    hwsEndDate?: InputMaybe<Scalars['Date']['input']>;
    hwsOrderDate?: InputMaybe<Scalars['Date']['input']>;
    hwsStartDate?: InputMaybe<Scalars['Date']['input']>;
    inseratMailRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
    logo?: InputMaybe<AssetCreateOneInlineInput>;
    managingDirector?: InputMaybe<Scalars['String']['input']>;
    menuImage?: InputMaybe<AssetCreateOneInlineInput>;
    mobileSellerId?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    name2?: InputMaybe<Scalars['String']['input']>;
    name3?: InputMaybe<Scalars['String']['input']>;
    notiz?: InputMaybe<Scalars['String']['input']>;
    oldSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
    openingTimesParts?: InputMaybe<OpeningCreateManyInlineInput>;
    openingTimesSales?: InputMaybe<OpeningCreateManyInlineInput>;
    openingTimesService?: InputMaybe<OpeningCreateManyInlineInput>;
    parentDealer?: InputMaybe<DealerCreateOneInlineInput>;
    partsStore: Scalars['Boolean']['input'];
    regionsnummerDlv?: InputMaybe<Scalars['Int']['input']>;
    requireLogin: Scalars['Boolean']['input'];
    sapId: Scalars['String']['input'];
    slug?: InputMaybe<Scalars['String']['input']>;
    socialFacebook?: InputMaybe<Scalars['String']['input']>;
    socialInstagram?: InputMaybe<Scalars['String']['input']>;
    socialLinkedIn?: InputMaybe<Scalars['String']['input']>;
    socialTikTok?: InputMaybe<Scalars['String']['input']>;
    socialX?: InputMaybe<Scalars['String']['input']>;
    socialYouTube?: InputMaybe<Scalars['String']['input']>;
    state: State;
    subDealers?: InputMaybe<DealerCreateManyInlineInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DealerCreateManyInlineInput = {
    /** Connect multiple existing Dealer documents */
    connect?: InputMaybe<Array<DealerWhereUniqueInput>>;
    /** Create and connect multiple existing Dealer documents */
    create?: InputMaybe<Array<DealerCreateInput>>;
};

export type DealerCreateOneInlineInput = {
    /** Connect one existing Dealer document */
    connect?: InputMaybe<DealerWhereUniqueInput>;
    /** Create and connect one Dealer document */
    create?: InputMaybe<DealerCreateInput>;
};

/** An edge in a connection. */
export type DealerEdge = {
    __typename?: 'DealerEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Dealer;
};

/** Identifies documents */
export type DealerManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<DealerWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<DealerWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<DealerWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    address?: InputMaybe<AddressWhereInput>;
    auth0User_every?: InputMaybe<Auth0UserWhereInput>;
    auth0User_none?: InputMaybe<Auth0UserWhereInput>;
    auth0User_some?: InputMaybe<Auth0UserWhereInput>;
    businessCenter?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenter_not?: InputMaybe<Scalars['Boolean']['input']>;
    campaignKey?: InputMaybe<CampaignWhereInput>;
    campaignsRegular_every?: InputMaybe<CampaignWhereInput>;
    campaignsRegular_none?: InputMaybe<CampaignWhereInput>;
    campaignsRegular_some?: InputMaybe<CampaignWhereInput>;
    careerUrl?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    careerUrl_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    careerUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    careerUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    careerUrl_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    careerUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    careerUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    careerUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    careerUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    careerUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
    contact?: InputMaybe<ContactWhereInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    dealerId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    dealerId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    dealerId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    dealerId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    dealerId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    dealerId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    dealerId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    dealerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    dealerId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    dealerId_starts_with?: InputMaybe<Scalars['String']['input']>;
    dealerType?: InputMaybe<DealerType>;
    /** All values that are contained in given list. */
    dealerType_in?: InputMaybe<Array<InputMaybe<DealerType>>>;
    /** Any other value that exists and is not equal to the given value. */
    dealerType_not?: InputMaybe<DealerType>;
    /** All values that are not contained in given list. */
    dealerType_not_in?: InputMaybe<Array<InputMaybe<DealerType>>>;
    documentInStages_every?: InputMaybe<DealerWhereStageInput>;
    documentInStages_none?: InputMaybe<DealerWhereStageInput>;
    documentInStages_some?: InputMaybe<DealerWhereStageInput>;
    firstBillingMonth?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than the given value. */
    firstBillingMonth_gt?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than or equal the given value. */
    firstBillingMonth_gte?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are contained in given list. */
    firstBillingMonth_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    /** All values less than the given value. */
    firstBillingMonth_lt?: InputMaybe<Scalars['Date']['input']>;
    /** All values less than or equal the given value. */
    firstBillingMonth_lte?: InputMaybe<Scalars['Date']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    firstBillingMonth_not?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are not contained in given list. */
    firstBillingMonth_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    hPromise?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hPromise_not?: InputMaybe<Scalars['Boolean']['input']>;
    hasHcm?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hasHcm_not?: InputMaybe<Scalars['Boolean']['input']>;
    hasHws?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hasHws_not?: InputMaybe<Scalars['Boolean']['input']>;
    hcmUrl?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    hcmUrl_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    hcmUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    hcmUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    hcmUrl_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    hcmUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    hcmUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    hcmUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    hcmUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    hcmUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
    hwsEndDate?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than the given value. */
    hwsEndDate_gt?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than or equal the given value. */
    hwsEndDate_gte?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are contained in given list. */
    hwsEndDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    /** All values less than the given value. */
    hwsEndDate_lt?: InputMaybe<Scalars['Date']['input']>;
    /** All values less than or equal the given value. */
    hwsEndDate_lte?: InputMaybe<Scalars['Date']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hwsEndDate_not?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are not contained in given list. */
    hwsEndDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    hwsOrderDate?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than the given value. */
    hwsOrderDate_gt?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than or equal the given value. */
    hwsOrderDate_gte?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are contained in given list. */
    hwsOrderDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    /** All values less than the given value. */
    hwsOrderDate_lt?: InputMaybe<Scalars['Date']['input']>;
    /** All values less than or equal the given value. */
    hwsOrderDate_lte?: InputMaybe<Scalars['Date']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hwsOrderDate_not?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are not contained in given list. */
    hwsOrderDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    hwsStartDate?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than the given value. */
    hwsStartDate_gt?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than or equal the given value. */
    hwsStartDate_gte?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are contained in given list. */
    hwsStartDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    /** All values less than the given value. */
    hwsStartDate_lt?: InputMaybe<Scalars['Date']['input']>;
    /** All values less than or equal the given value. */
    hwsStartDate_lte?: InputMaybe<Scalars['Date']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hwsStartDate_not?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are not contained in given list. */
    hwsStartDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** Matches if the field array contains *all* items provided to the filter and order does match */
    inseratMailRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array contains *all* items provided to the filter */
    inseratMailRecipients_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array does not contain any of the items provided to the filter */
    inseratMailRecipients_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array contains at least one item provided to the filter */
    inseratMailRecipients_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
    inseratMailRecipients_not?: InputMaybe<Array<Scalars['String']['input']>>;
    logo?: InputMaybe<AssetWhereInput>;
    managingDirector?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    managingDirector_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    managingDirector_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    managingDirector_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    managingDirector_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    managingDirector_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    managingDirector_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    managingDirector_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    managingDirector_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    managingDirector_starts_with?: InputMaybe<Scalars['String']['input']>;
    menuImage?: InputMaybe<AssetWhereInput>;
    mobileSellerId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mobileSellerId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mobileSellerId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mobileSellerId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mobileSellerId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mobileSellerId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mobileSellerId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mobileSellerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mobileSellerId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mobileSellerId_starts_with?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    name2?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name2_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name2_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name2_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name2_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name2_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name2_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name2_starts_with?: InputMaybe<Scalars['String']['input']>;
    name3?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name3_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name3_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name3_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name3_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name3_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name3_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name3_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name3_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name3_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name_starts_with?: InputMaybe<Scalars['String']['input']>;
    notiz?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    notiz_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    notiz_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    notiz_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    notiz_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    notiz_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    notiz_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    notiz_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    notiz_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    notiz_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** Matches if the field array contains *all* items provided to the filter and order does match */
    oldSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array contains *all* items provided to the filter */
    oldSlugs_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array does not contain any of the items provided to the filter */
    oldSlugs_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array contains at least one item provided to the filter */
    oldSlugs_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
    oldSlugs_not?: InputMaybe<Array<Scalars['String']['input']>>;
    openingTimesParts_every?: InputMaybe<OpeningWhereInput>;
    openingTimesParts_none?: InputMaybe<OpeningWhereInput>;
    openingTimesParts_some?: InputMaybe<OpeningWhereInput>;
    openingTimesSales_every?: InputMaybe<OpeningWhereInput>;
    openingTimesSales_none?: InputMaybe<OpeningWhereInput>;
    openingTimesSales_some?: InputMaybe<OpeningWhereInput>;
    openingTimesService_every?: InputMaybe<OpeningWhereInput>;
    openingTimesService_none?: InputMaybe<OpeningWhereInput>;
    openingTimesService_some?: InputMaybe<OpeningWhereInput>;
    parentDealer?: InputMaybe<DealerWhereInput>;
    partsStore?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    partsStore_not?: InputMaybe<Scalars['Boolean']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    regionsnummerDlv?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than the given value. */
    regionsnummerDlv_gt?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than or equal the given value. */
    regionsnummerDlv_gte?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are contained in given list. */
    regionsnummerDlv_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    /** All values less than the given value. */
    regionsnummerDlv_lt?: InputMaybe<Scalars['Int']['input']>;
    /** All values less than or equal the given value. */
    regionsnummerDlv_lte?: InputMaybe<Scalars['Int']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    regionsnummerDlv_not?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are not contained in given list. */
    regionsnummerDlv_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    requireLogin_not?: InputMaybe<Scalars['Boolean']['input']>;
    sapId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    sapId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    sapId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    sapId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    sapId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    sapId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    sapId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    sapId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    sapId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    sapId_starts_with?: InputMaybe<Scalars['String']['input']>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    slug?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    slug_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    slug_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    slug_starts_with?: InputMaybe<Scalars['String']['input']>;
    socialFacebook?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    socialFacebook_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    socialFacebook_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    socialFacebook_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    socialFacebook_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    socialFacebook_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    socialFacebook_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    socialFacebook_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    socialFacebook_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    socialFacebook_starts_with?: InputMaybe<Scalars['String']['input']>;
    socialInstagram?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    socialInstagram_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    socialInstagram_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    socialInstagram_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    socialInstagram_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    socialInstagram_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    socialInstagram_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    socialInstagram_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    socialInstagram_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    socialInstagram_starts_with?: InputMaybe<Scalars['String']['input']>;
    socialLinkedIn?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    socialLinkedIn_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    socialLinkedIn_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    socialLinkedIn_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    socialLinkedIn_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    socialLinkedIn_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    socialLinkedIn_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    socialLinkedIn_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    socialLinkedIn_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    socialLinkedIn_starts_with?: InputMaybe<Scalars['String']['input']>;
    socialTikTok?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    socialTikTok_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    socialTikTok_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    socialTikTok_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    socialTikTok_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    socialTikTok_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    socialTikTok_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    socialTikTok_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    socialTikTok_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    socialTikTok_starts_with?: InputMaybe<Scalars['String']['input']>;
    socialX?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    socialX_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    socialX_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    socialX_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    socialX_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    socialX_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    socialX_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    socialX_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    socialX_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    socialX_starts_with?: InputMaybe<Scalars['String']['input']>;
    socialYouTube?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    socialYouTube_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    socialYouTube_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    socialYouTube_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    socialYouTube_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    socialYouTube_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    socialYouTube_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    socialYouTube_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    socialYouTube_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    socialYouTube_starts_with?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<State>;
    /** All values that are contained in given list. */
    state_in?: InputMaybe<Array<InputMaybe<State>>>;
    /** Any other value that exists and is not equal to the given value. */
    state_not?: InputMaybe<State>;
    /** All values that are not contained in given list. */
    state_not_in?: InputMaybe<Array<InputMaybe<State>>>;
    subDealers_every?: InputMaybe<DealerWhereInput>;
    subDealers_none?: InputMaybe<DealerWhereInput>;
    subDealers_some?: InputMaybe<DealerWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    whatsappNumber?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    whatsappNumber_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    whatsappNumber_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    whatsappNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    whatsappNumber_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    whatsappNumber_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    whatsappNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    whatsappNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    whatsappNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    whatsappNumber_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum DealerOrderByInput {
    BusinessCenterAsc = 'businessCenter_ASC',
    BusinessCenterDesc = 'businessCenter_DESC',
    CareerUrlAsc = 'careerUrl_ASC',
    CareerUrlDesc = 'careerUrl_DESC',
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    DealerIdAsc = 'dealerId_ASC',
    DealerIdDesc = 'dealerId_DESC',
    DealerTypeAsc = 'dealerType_ASC',
    DealerTypeDesc = 'dealerType_DESC',
    FirstBillingMonthAsc = 'firstBillingMonth_ASC',
    FirstBillingMonthDesc = 'firstBillingMonth_DESC',
    HPromiseAsc = 'hPromise_ASC',
    HPromiseDesc = 'hPromise_DESC',
    HasHcmAsc = 'hasHcm_ASC',
    HasHcmDesc = 'hasHcm_DESC',
    HasHwsAsc = 'hasHws_ASC',
    HasHwsDesc = 'hasHws_DESC',
    HcmUrlAsc = 'hcmUrl_ASC',
    HcmUrlDesc = 'hcmUrl_DESC',
    HwsEndDateAsc = 'hwsEndDate_ASC',
    HwsEndDateDesc = 'hwsEndDate_DESC',
    HwsOrderDateAsc = 'hwsOrderDate_ASC',
    HwsOrderDateDesc = 'hwsOrderDate_DESC',
    HwsStartDateAsc = 'hwsStartDate_ASC',
    HwsStartDateDesc = 'hwsStartDate_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    InseratMailRecipientsAsc = 'inseratMailRecipients_ASC',
    InseratMailRecipientsDesc = 'inseratMailRecipients_DESC',
    ManagingDirectorAsc = 'managingDirector_ASC',
    ManagingDirectorDesc = 'managingDirector_DESC',
    MobileSellerIdAsc = 'mobileSellerId_ASC',
    MobileSellerIdDesc = 'mobileSellerId_DESC',
    Name2Asc = 'name2_ASC',
    Name2Desc = 'name2_DESC',
    Name3Asc = 'name3_ASC',
    Name3Desc = 'name3_DESC',
    NameAsc = 'name_ASC',
    NameDesc = 'name_DESC',
    NotizAsc = 'notiz_ASC',
    NotizDesc = 'notiz_DESC',
    OldSlugsAsc = 'oldSlugs_ASC',
    OldSlugsDesc = 'oldSlugs_DESC',
    PartsStoreAsc = 'partsStore_ASC',
    PartsStoreDesc = 'partsStore_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    RegionsnummerDlvAsc = 'regionsnummerDlv_ASC',
    RegionsnummerDlvDesc = 'regionsnummerDlv_DESC',
    RequireLoginAsc = 'requireLogin_ASC',
    RequireLoginDesc = 'requireLogin_DESC',
    SapIdAsc = 'sapId_ASC',
    SapIdDesc = 'sapId_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SocialFacebookAsc = 'socialFacebook_ASC',
    SocialFacebookDesc = 'socialFacebook_DESC',
    SocialInstagramAsc = 'socialInstagram_ASC',
    SocialInstagramDesc = 'socialInstagram_DESC',
    SocialLinkedInAsc = 'socialLinkedIn_ASC',
    SocialLinkedInDesc = 'socialLinkedIn_DESC',
    SocialTikTokAsc = 'socialTikTok_ASC',
    SocialTikTokDesc = 'socialTikTok_DESC',
    SocialXAsc = 'socialX_ASC',
    SocialXDesc = 'socialX_DESC',
    SocialYouTubeAsc = 'socialYouTube_ASC',
    SocialYouTubeDesc = 'socialYouTube_DESC',
    StateAsc = 'state_ASC',
    StateDesc = 'state_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
    WhatsappNumberAsc = 'whatsappNumber_ASC',
    WhatsappNumberDesc = 'whatsappNumber_DESC',
}

export enum DealerType {
    Sales = 'Sales',
    SalesService = 'SalesService',
    Service = 'Service',
}

export type DealerUpdateInput = {
    address?: InputMaybe<AddressUpdateOneInlineInput>;
    auth0User?: InputMaybe<Auth0UserUpdateManyInlineInput>;
    businessCenter?: InputMaybe<Scalars['Boolean']['input']>;
    campaignKey?: InputMaybe<CampaignUpdateOneInlineInput>;
    campaignsRegular?: InputMaybe<CampaignUpdateManyInlineInput>;
    careerUrl?: InputMaybe<Scalars['String']['input']>;
    contact?: InputMaybe<ContactUpdateOneInlineInput>;
    dealerId?: InputMaybe<Scalars['String']['input']>;
    dealerType?: InputMaybe<DealerType>;
    firstBillingMonth?: InputMaybe<Scalars['Date']['input']>;
    hPromise?: InputMaybe<Scalars['Boolean']['input']>;
    hasHcm?: InputMaybe<Scalars['Boolean']['input']>;
    hasHws?: InputMaybe<Scalars['Boolean']['input']>;
    hcmUrl?: InputMaybe<Scalars['String']['input']>;
    hwsEndDate?: InputMaybe<Scalars['Date']['input']>;
    hwsOrderDate?: InputMaybe<Scalars['Date']['input']>;
    hwsStartDate?: InputMaybe<Scalars['Date']['input']>;
    inseratMailRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
    logo?: InputMaybe<AssetUpdateOneInlineInput>;
    managingDirector?: InputMaybe<Scalars['String']['input']>;
    menuImage?: InputMaybe<AssetUpdateOneInlineInput>;
    mobileSellerId?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    name2?: InputMaybe<Scalars['String']['input']>;
    name3?: InputMaybe<Scalars['String']['input']>;
    notiz?: InputMaybe<Scalars['String']['input']>;
    oldSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
    openingTimesParts?: InputMaybe<OpeningUpdateManyInlineInput>;
    openingTimesSales?: InputMaybe<OpeningUpdateManyInlineInput>;
    openingTimesService?: InputMaybe<OpeningUpdateManyInlineInput>;
    parentDealer?: InputMaybe<DealerUpdateOneInlineInput>;
    partsStore?: InputMaybe<Scalars['Boolean']['input']>;
    regionsnummerDlv?: InputMaybe<Scalars['Int']['input']>;
    requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
    sapId?: InputMaybe<Scalars['String']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    socialFacebook?: InputMaybe<Scalars['String']['input']>;
    socialInstagram?: InputMaybe<Scalars['String']['input']>;
    socialLinkedIn?: InputMaybe<Scalars['String']['input']>;
    socialTikTok?: InputMaybe<Scalars['String']['input']>;
    socialX?: InputMaybe<Scalars['String']['input']>;
    socialYouTube?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<State>;
    subDealers?: InputMaybe<DealerUpdateManyInlineInput>;
    whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DealerUpdateManyInlineInput = {
    /** Connect multiple existing Dealer documents */
    connect?: InputMaybe<Array<DealerConnectInput>>;
    /** Create and connect multiple Dealer documents */
    create?: InputMaybe<Array<DealerCreateInput>>;
    /** Delete multiple Dealer documents */
    delete?: InputMaybe<Array<DealerWhereUniqueInput>>;
    /** Disconnect multiple Dealer documents */
    disconnect?: InputMaybe<Array<DealerWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing Dealer documents */
    set?: InputMaybe<Array<DealerWhereUniqueInput>>;
    /** Update multiple Dealer documents */
    update?: InputMaybe<Array<DealerUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple Dealer documents */
    upsert?: InputMaybe<Array<DealerUpsertWithNestedWhereUniqueInput>>;
};

export type DealerUpdateManyInput = {
    businessCenter?: InputMaybe<Scalars['Boolean']['input']>;
    careerUrl?: InputMaybe<Scalars['String']['input']>;
    dealerType?: InputMaybe<DealerType>;
    firstBillingMonth?: InputMaybe<Scalars['Date']['input']>;
    hPromise?: InputMaybe<Scalars['Boolean']['input']>;
    hasHcm?: InputMaybe<Scalars['Boolean']['input']>;
    hasHws?: InputMaybe<Scalars['Boolean']['input']>;
    hcmUrl?: InputMaybe<Scalars['String']['input']>;
    hwsEndDate?: InputMaybe<Scalars['Date']['input']>;
    hwsOrderDate?: InputMaybe<Scalars['Date']['input']>;
    hwsStartDate?: InputMaybe<Scalars['Date']['input']>;
    inseratMailRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
    managingDirector?: InputMaybe<Scalars['String']['input']>;
    mobileSellerId?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    name2?: InputMaybe<Scalars['String']['input']>;
    name3?: InputMaybe<Scalars['String']['input']>;
    notiz?: InputMaybe<Scalars['String']['input']>;
    oldSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
    partsStore?: InputMaybe<Scalars['Boolean']['input']>;
    regionsnummerDlv?: InputMaybe<Scalars['Int']['input']>;
    requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
    sapId?: InputMaybe<Scalars['String']['input']>;
    socialFacebook?: InputMaybe<Scalars['String']['input']>;
    socialInstagram?: InputMaybe<Scalars['String']['input']>;
    socialLinkedIn?: InputMaybe<Scalars['String']['input']>;
    socialTikTok?: InputMaybe<Scalars['String']['input']>;
    socialX?: InputMaybe<Scalars['String']['input']>;
    socialYouTube?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<State>;
    whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DealerUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: DealerUpdateManyInput;
    /** Document search */
    where: DealerWhereInput;
};

export type DealerUpdateOneInlineInput = {
    /** Connect existing Dealer document */
    connect?: InputMaybe<DealerWhereUniqueInput>;
    /** Create and connect one Dealer document */
    create?: InputMaybe<DealerCreateInput>;
    /** Delete currently connected Dealer document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected Dealer document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Dealer document */
    update?: InputMaybe<DealerUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Dealer document */
    upsert?: InputMaybe<DealerUpsertWithNestedWhereUniqueInput>;
};

export type DealerUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: DealerUpdateInput;
    /** Unique document search */
    where: DealerWhereUniqueInput;
};

export type DealerUpsertInput = {
    /** Create document if it didn't exist */
    create: DealerCreateInput;
    /** Update document if it exists */
    update: DealerUpdateInput;
};

export type DealerUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: DealerUpsertInput;
    /** Unique document search */
    where: DealerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DealerWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DealerWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<DealerWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<DealerWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<DealerWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    address?: InputMaybe<AddressWhereInput>;
    auth0User_every?: InputMaybe<Auth0UserWhereInput>;
    auth0User_none?: InputMaybe<Auth0UserWhereInput>;
    auth0User_some?: InputMaybe<Auth0UserWhereInput>;
    businessCenter?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenter_not?: InputMaybe<Scalars['Boolean']['input']>;
    campaignKey?: InputMaybe<CampaignWhereInput>;
    campaignsRegular_every?: InputMaybe<CampaignWhereInput>;
    campaignsRegular_none?: InputMaybe<CampaignWhereInput>;
    campaignsRegular_some?: InputMaybe<CampaignWhereInput>;
    careerUrl?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    careerUrl_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    careerUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    careerUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    careerUrl_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    careerUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    careerUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    careerUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    careerUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    careerUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
    contact?: InputMaybe<ContactWhereInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    dealerId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    dealerId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    dealerId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    dealerId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    dealerId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    dealerId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    dealerId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    dealerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    dealerId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    dealerId_starts_with?: InputMaybe<Scalars['String']['input']>;
    dealerType?: InputMaybe<DealerType>;
    /** All values that are contained in given list. */
    dealerType_in?: InputMaybe<Array<InputMaybe<DealerType>>>;
    /** Any other value that exists and is not equal to the given value. */
    dealerType_not?: InputMaybe<DealerType>;
    /** All values that are not contained in given list. */
    dealerType_not_in?: InputMaybe<Array<InputMaybe<DealerType>>>;
    documentInStages_every?: InputMaybe<DealerWhereStageInput>;
    documentInStages_none?: InputMaybe<DealerWhereStageInput>;
    documentInStages_some?: InputMaybe<DealerWhereStageInput>;
    firstBillingMonth?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than the given value. */
    firstBillingMonth_gt?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than or equal the given value. */
    firstBillingMonth_gte?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are contained in given list. */
    firstBillingMonth_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    /** All values less than the given value. */
    firstBillingMonth_lt?: InputMaybe<Scalars['Date']['input']>;
    /** All values less than or equal the given value. */
    firstBillingMonth_lte?: InputMaybe<Scalars['Date']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    firstBillingMonth_not?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are not contained in given list. */
    firstBillingMonth_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    hPromise?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hPromise_not?: InputMaybe<Scalars['Boolean']['input']>;
    hasHcm?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hasHcm_not?: InputMaybe<Scalars['Boolean']['input']>;
    hasHws?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hasHws_not?: InputMaybe<Scalars['Boolean']['input']>;
    hcmUrl?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    hcmUrl_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    hcmUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    hcmUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    hcmUrl_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    hcmUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    hcmUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    hcmUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    hcmUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    hcmUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
    hwsEndDate?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than the given value. */
    hwsEndDate_gt?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than or equal the given value. */
    hwsEndDate_gte?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are contained in given list. */
    hwsEndDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    /** All values less than the given value. */
    hwsEndDate_lt?: InputMaybe<Scalars['Date']['input']>;
    /** All values less than or equal the given value. */
    hwsEndDate_lte?: InputMaybe<Scalars['Date']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hwsEndDate_not?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are not contained in given list. */
    hwsEndDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    hwsOrderDate?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than the given value. */
    hwsOrderDate_gt?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than or equal the given value. */
    hwsOrderDate_gte?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are contained in given list. */
    hwsOrderDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    /** All values less than the given value. */
    hwsOrderDate_lt?: InputMaybe<Scalars['Date']['input']>;
    /** All values less than or equal the given value. */
    hwsOrderDate_lte?: InputMaybe<Scalars['Date']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hwsOrderDate_not?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are not contained in given list. */
    hwsOrderDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    hwsStartDate?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than the given value. */
    hwsStartDate_gt?: InputMaybe<Scalars['Date']['input']>;
    /** All values greater than or equal the given value. */
    hwsStartDate_gte?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are contained in given list. */
    hwsStartDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    /** All values less than the given value. */
    hwsStartDate_lt?: InputMaybe<Scalars['Date']['input']>;
    /** All values less than or equal the given value. */
    hwsStartDate_lte?: InputMaybe<Scalars['Date']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hwsStartDate_not?: InputMaybe<Scalars['Date']['input']>;
    /** All values that are not contained in given list. */
    hwsStartDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** Matches if the field array contains *all* items provided to the filter and order does match */
    inseratMailRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array contains *all* items provided to the filter */
    inseratMailRecipients_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array does not contain any of the items provided to the filter */
    inseratMailRecipients_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array contains at least one item provided to the filter */
    inseratMailRecipients_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
    inseratMailRecipients_not?: InputMaybe<Array<Scalars['String']['input']>>;
    logo?: InputMaybe<AssetWhereInput>;
    managingDirector?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    managingDirector_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    managingDirector_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    managingDirector_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    managingDirector_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    managingDirector_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    managingDirector_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    managingDirector_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    managingDirector_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    managingDirector_starts_with?: InputMaybe<Scalars['String']['input']>;
    menuImage?: InputMaybe<AssetWhereInput>;
    mobileSellerId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mobileSellerId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mobileSellerId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mobileSellerId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mobileSellerId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mobileSellerId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mobileSellerId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mobileSellerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mobileSellerId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mobileSellerId_starts_with?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    name2?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name2_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name2_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name2_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name2_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name2_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name2_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name2_starts_with?: InputMaybe<Scalars['String']['input']>;
    name3?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name3_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name3_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name3_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name3_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name3_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name3_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name3_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name3_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name3_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name_starts_with?: InputMaybe<Scalars['String']['input']>;
    notiz?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    notiz_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    notiz_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    notiz_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    notiz_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    notiz_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    notiz_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    notiz_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    notiz_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    notiz_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** Matches if the field array contains *all* items provided to the filter and order does match */
    oldSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array contains *all* items provided to the filter */
    oldSlugs_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array does not contain any of the items provided to the filter */
    oldSlugs_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array contains at least one item provided to the filter */
    oldSlugs_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
    /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
    oldSlugs_not?: InputMaybe<Array<Scalars['String']['input']>>;
    openingTimesParts_every?: InputMaybe<OpeningWhereInput>;
    openingTimesParts_none?: InputMaybe<OpeningWhereInput>;
    openingTimesParts_some?: InputMaybe<OpeningWhereInput>;
    openingTimesSales_every?: InputMaybe<OpeningWhereInput>;
    openingTimesSales_none?: InputMaybe<OpeningWhereInput>;
    openingTimesSales_some?: InputMaybe<OpeningWhereInput>;
    openingTimesService_every?: InputMaybe<OpeningWhereInput>;
    openingTimesService_none?: InputMaybe<OpeningWhereInput>;
    openingTimesService_some?: InputMaybe<OpeningWhereInput>;
    parentDealer?: InputMaybe<DealerWhereInput>;
    partsStore?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    partsStore_not?: InputMaybe<Scalars['Boolean']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    regionsnummerDlv?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than the given value. */
    regionsnummerDlv_gt?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than or equal the given value. */
    regionsnummerDlv_gte?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are contained in given list. */
    regionsnummerDlv_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    /** All values less than the given value. */
    regionsnummerDlv_lt?: InputMaybe<Scalars['Int']['input']>;
    /** All values less than or equal the given value. */
    regionsnummerDlv_lte?: InputMaybe<Scalars['Int']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    regionsnummerDlv_not?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are not contained in given list. */
    regionsnummerDlv_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    requireLogin_not?: InputMaybe<Scalars['Boolean']['input']>;
    sapId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    sapId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    sapId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    sapId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    sapId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    sapId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    sapId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    sapId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    sapId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    sapId_starts_with?: InputMaybe<Scalars['String']['input']>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    slug?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    slug_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    slug_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    slug_starts_with?: InputMaybe<Scalars['String']['input']>;
    socialFacebook?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    socialFacebook_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    socialFacebook_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    socialFacebook_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    socialFacebook_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    socialFacebook_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    socialFacebook_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    socialFacebook_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    socialFacebook_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    socialFacebook_starts_with?: InputMaybe<Scalars['String']['input']>;
    socialInstagram?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    socialInstagram_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    socialInstagram_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    socialInstagram_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    socialInstagram_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    socialInstagram_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    socialInstagram_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    socialInstagram_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    socialInstagram_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    socialInstagram_starts_with?: InputMaybe<Scalars['String']['input']>;
    socialLinkedIn?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    socialLinkedIn_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    socialLinkedIn_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    socialLinkedIn_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    socialLinkedIn_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    socialLinkedIn_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    socialLinkedIn_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    socialLinkedIn_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    socialLinkedIn_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    socialLinkedIn_starts_with?: InputMaybe<Scalars['String']['input']>;
    socialTikTok?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    socialTikTok_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    socialTikTok_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    socialTikTok_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    socialTikTok_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    socialTikTok_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    socialTikTok_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    socialTikTok_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    socialTikTok_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    socialTikTok_starts_with?: InputMaybe<Scalars['String']['input']>;
    socialX?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    socialX_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    socialX_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    socialX_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    socialX_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    socialX_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    socialX_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    socialX_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    socialX_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    socialX_starts_with?: InputMaybe<Scalars['String']['input']>;
    socialYouTube?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    socialYouTube_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    socialYouTube_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    socialYouTube_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    socialYouTube_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    socialYouTube_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    socialYouTube_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    socialYouTube_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    socialYouTube_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    socialYouTube_starts_with?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<State>;
    /** All values that are contained in given list. */
    state_in?: InputMaybe<Array<InputMaybe<State>>>;
    /** Any other value that exists and is not equal to the given value. */
    state_not?: InputMaybe<State>;
    /** All values that are not contained in given list. */
    state_not_in?: InputMaybe<Array<InputMaybe<State>>>;
    subDealers_every?: InputMaybe<DealerWhereInput>;
    subDealers_none?: InputMaybe<DealerWhereInput>;
    subDealers_some?: InputMaybe<DealerWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    whatsappNumber?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    whatsappNumber_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    whatsappNumber_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    whatsappNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    whatsappNumber_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    whatsappNumber_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    whatsappNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    whatsappNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    whatsappNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    whatsappNumber_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DealerWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<DealerWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<DealerWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<DealerWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<DealerWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References Dealer record uniquely */
export type DealerWhereUniqueInput = {
    dealerId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
};

export type Department = Entity &
    Node & {
        __typename?: 'Department';
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Get the document in other stages */
        documentInStages: Array<Department>;
        /** List of Department versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        name: Scalars['String']['output'];
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

export type DepartmentCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type DepartmentDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type DepartmentHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type DepartmentPublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type DepartmentScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type DepartmentUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type DepartmentConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: DepartmentWhereUniqueInput;
};

/** A connection to a list of items. */
export type DepartmentConnection = {
    __typename?: 'DepartmentConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<DepartmentEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type DepartmentCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    name: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DepartmentCreateManyInlineInput = {
    /** Connect multiple existing Department documents */
    connect?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
    /** Create and connect multiple existing Department documents */
    create?: InputMaybe<Array<DepartmentCreateInput>>;
};

export type DepartmentCreateOneInlineInput = {
    /** Connect one existing Department document */
    connect?: InputMaybe<DepartmentWhereUniqueInput>;
    /** Create and connect one Department document */
    create?: InputMaybe<DepartmentCreateInput>;
};

/** An edge in a connection. */
export type DepartmentEdge = {
    __typename?: 'DepartmentEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Department;
};

/** Identifies documents */
export type DepartmentManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<DepartmentWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<DepartmentWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<DepartmentWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<DepartmentWhereStageInput>;
    documentInStages_none?: InputMaybe<DepartmentWhereStageInput>;
    documentInStages_some?: InputMaybe<DepartmentWhereStageInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name_starts_with?: InputMaybe<Scalars['String']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DepartmentOrderByInput {
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    NameAsc = 'name_ASC',
    NameDesc = 'name_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type DepartmentUpdateInput = {
    name?: InputMaybe<Scalars['String']['input']>;
};

export type DepartmentUpdateManyInlineInput = {
    /** Connect multiple existing Department documents */
    connect?: InputMaybe<Array<DepartmentConnectInput>>;
    /** Create and connect multiple Department documents */
    create?: InputMaybe<Array<DepartmentCreateInput>>;
    /** Delete multiple Department documents */
    delete?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
    /** Disconnect multiple Department documents */
    disconnect?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing Department documents */
    set?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
    /** Update multiple Department documents */
    update?: InputMaybe<Array<DepartmentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple Department documents */
    upsert?: InputMaybe<Array<DepartmentUpsertWithNestedWhereUniqueInput>>;
};

export type DepartmentUpdateManyInput = {
    /** No fields in updateMany data input */
    _?: InputMaybe<Scalars['String']['input']>;
};

export type DepartmentUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: DepartmentUpdateManyInput;
    /** Document search */
    where: DepartmentWhereInput;
};

export type DepartmentUpdateOneInlineInput = {
    /** Connect existing Department document */
    connect?: InputMaybe<DepartmentWhereUniqueInput>;
    /** Create and connect one Department document */
    create?: InputMaybe<DepartmentCreateInput>;
    /** Delete currently connected Department document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected Department document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Department document */
    update?: InputMaybe<DepartmentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Department document */
    upsert?: InputMaybe<DepartmentUpsertWithNestedWhereUniqueInput>;
};

export type DepartmentUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: DepartmentUpdateInput;
    /** Unique document search */
    where: DepartmentWhereUniqueInput;
};

export type DepartmentUpsertInput = {
    /** Create document if it didn't exist */
    create: DepartmentCreateInput;
    /** Update document if it exists */
    update: DepartmentUpdateInput;
};

export type DepartmentUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: DepartmentUpsertInput;
    /** Unique document search */
    where: DepartmentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DepartmentWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DepartmentWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<DepartmentWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<DepartmentWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<DepartmentWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<DepartmentWhereStageInput>;
    documentInStages_none?: InputMaybe<DepartmentWhereStageInput>;
    documentInStages_some?: InputMaybe<DepartmentWhereStageInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name_starts_with?: InputMaybe<Scalars['String']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DepartmentWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<DepartmentWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<DepartmentWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<DepartmentWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<DepartmentWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References Department record uniquely */
export type DepartmentWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
};

export enum DocumentFileTypes {
    /** Automatically selects the best format for the image based on the browser's capabilities. */
    AutoImage = 'autoImage',
    Avif = 'avif',
    Bmp = 'bmp',
    Gif = 'gif',
    Heic = 'heic',
    Jpg = 'jpg',
    Png = 'png',
    Svg = 'svg',
    Tiff = 'tiff',
    Webp = 'webp',
}

export type DocumentOutputInput = {
    /**
     * Transforms a document into a desired file type.
     * See this matrix for format support:
     *
     * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
     * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
     * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
     * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
     * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
     * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
     * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
     * PDF: 	autoImage, gif, jpg, png, webp, tiff
     *
     */
    format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
    /** Changes the output for the file. */
    output?: InputMaybe<DocumentOutputInput>;
};

export type DocumentVersion = {
    __typename?: 'DocumentVersion';
    createdAt: Scalars['DateTime']['output'];
    data?: Maybe<Scalars['Json']['output']>;
    id: Scalars['ID']['output'];
    revision: Scalars['Int']['output'];
    stage: Stage;
};

export type EnVkvElektro = Entity & {
    __typename?: 'EnVkvElektro';
    additionalTransmissionPerformance?: Maybe<Scalars['String']['output']>;
    co2Combined: Scalars['String']['output'];
    consumptionCombined: Scalars['String']['output'];
    headline: Scalars['String']['output'];
    /** The unique identifier */
    id: Scalars['ID']['output'];
    rangeElectric: Scalars['String']['output'];
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EnVkvElektroConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: EnVkvElektroWhereUniqueInput;
};

/** A connection to a list of items. */
export type EnVkvElektroConnection = {
    __typename?: 'EnVkvElektroConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<EnVkvElektroEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type EnVkvElektroCreateInput = {
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    co2Combined: Scalars['String']['input'];
    consumptionCombined: Scalars['String']['input'];
    headline: Scalars['String']['input'];
    rangeElectric: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EnVkvElektroCreateManyInlineInput = {
    /** Create and connect multiple existing EnVkvElektro documents */
    create?: InputMaybe<Array<EnVkvElektroCreateInput>>;
};

export type EnVkvElektroCreateOneInlineInput = {
    /** Create and connect one EnVkvElektro document */
    create?: InputMaybe<EnVkvElektroCreateInput>;
};

export type EnVkvElektroCreateWithPositionInput = {
    /** Document to create */
    data: EnVkvElektroCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type EnVkvElektroEdge = {
    __typename?: 'EnVkvElektroEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: EnVkvElektro;
};

/** Identifies documents */
export type EnVkvElektroManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<EnVkvElektroWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<EnVkvElektroWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<EnVkvElektroWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    additionalTransmissionPerformance_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    additionalTransmissionPerformance_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    additionalTransmissionPerformance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    additionalTransmissionPerformance_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    additionalTransmissionPerformance_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    additionalTransmissionPerformance_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    additionalTransmissionPerformance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    additionalTransmissionPerformance_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    additionalTransmissionPerformance_starts_with?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2Combined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2Combined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2Combined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2Combined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2Combined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2Combined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2Combined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2Combined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2Combined_starts_with?: InputMaybe<Scalars['String']['input']>;
    consumptionCombined?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    consumptionCombined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    consumptionCombined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    consumptionCombined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    consumptionCombined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    consumptionCombined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    consumptionCombined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    consumptionCombined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    consumptionCombined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    consumptionCombined_starts_with?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    rangeElectric?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    rangeElectric_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    rangeElectric_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    rangeElectric_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    rangeElectric_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    rangeElectric_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    rangeElectric_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    rangeElectric_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    rangeElectric_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    rangeElectric_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum EnVkvElektroOrderByInput {
    AdditionalTransmissionPerformanceAsc = 'additionalTransmissionPerformance_ASC',
    AdditionalTransmissionPerformanceDesc = 'additionalTransmissionPerformance_DESC',
    Co2CombinedAsc = 'co2Combined_ASC',
    Co2CombinedDesc = 'co2Combined_DESC',
    ConsumptionCombinedAsc = 'consumptionCombined_ASC',
    ConsumptionCombinedDesc = 'consumptionCombined_DESC',
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    RangeElectricAsc = 'rangeElectric_ASC',
    RangeElectricDesc = 'rangeElectric_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type EnVkvElektroParent = Model | Vehicle;

export type EnVkvElektroParentConnectInput = {
    Model?: InputMaybe<ModelConnectInput>;
    Vehicle?: InputMaybe<VehicleConnectInput>;
};

export type EnVkvElektroParentCreateInput = {
    Model?: InputMaybe<ModelCreateInput>;
    Vehicle?: InputMaybe<VehicleCreateInput>;
};

export type EnVkvElektroParentCreateManyInlineInput = {
    /** Connect multiple existing EnVkvElektroParent documents */
    connect?: InputMaybe<Array<EnVkvElektroParentWhereUniqueInput>>;
    /** Create and connect multiple existing EnVkvElektroParent documents */
    create?: InputMaybe<Array<EnVkvElektroParentCreateInput>>;
};

export type EnVkvElektroParentCreateOneInlineInput = {
    /** Connect one existing EnVkvElektroParent document */
    connect?: InputMaybe<EnVkvElektroParentWhereUniqueInput>;
    /** Create and connect one EnVkvElektroParent document */
    create?: InputMaybe<EnVkvElektroParentCreateInput>;
};

export type EnVkvElektroParentUpdateInput = {
    Model?: InputMaybe<ModelUpdateInput>;
    Vehicle?: InputMaybe<VehicleUpdateInput>;
};

export type EnVkvElektroParentUpdateManyInlineInput = {
    /** Connect multiple existing EnVkvElektroParent documents */
    connect?: InputMaybe<Array<EnVkvElektroParentConnectInput>>;
    /** Create and connect multiple EnVkvElektroParent documents */
    create?: InputMaybe<Array<EnVkvElektroParentCreateInput>>;
    /** Delete multiple EnVkvElektroParent documents */
    delete?: InputMaybe<Array<EnVkvElektroParentWhereUniqueInput>>;
    /** Disconnect multiple EnVkvElektroParent documents */
    disconnect?: InputMaybe<Array<EnVkvElektroParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing EnVkvElektroParent documents */
    set?: InputMaybe<Array<EnVkvElektroParentWhereUniqueInput>>;
    /** Update multiple EnVkvElektroParent documents */
    update?: InputMaybe<Array<EnVkvElektroParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple EnVkvElektroParent documents */
    upsert?: InputMaybe<Array<EnVkvElektroParentUpsertWithNestedWhereUniqueInput>>;
};

export type EnVkvElektroParentUpdateManyWithNestedWhereInput = {
    Model?: InputMaybe<ModelUpdateManyWithNestedWhereInput>;
    Vehicle?: InputMaybe<VehicleUpdateManyWithNestedWhereInput>;
};

export type EnVkvElektroParentUpdateOneInlineInput = {
    /** Connect existing EnVkvElektroParent document */
    connect?: InputMaybe<EnVkvElektroParentWhereUniqueInput>;
    /** Create and connect one EnVkvElektroParent document */
    create?: InputMaybe<EnVkvElektroParentCreateInput>;
    /** Delete currently connected EnVkvElektroParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected EnVkvElektroParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single EnVkvElektroParent document */
    update?: InputMaybe<EnVkvElektroParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single EnVkvElektroParent document */
    upsert?: InputMaybe<EnVkvElektroParentUpsertWithNestedWhereUniqueInput>;
};

export type EnVkvElektroParentUpdateWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpdateWithNestedWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleUpdateWithNestedWhereUniqueInput>;
};

export type EnVkvElektroParentUpsertWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpsertWithNestedWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleUpsertWithNestedWhereUniqueInput>;
};

export type EnVkvElektroParentWhereInput = {
    Model?: InputMaybe<ModelWhereInput>;
    Vehicle?: InputMaybe<VehicleWhereInput>;
};

export type EnVkvElektroParentWhereUniqueInput = {
    Model?: InputMaybe<ModelWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleWhereUniqueInput>;
};

export type EnVkvElektroUpdateInput = {
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    consumptionCombined?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    rangeElectric?: InputMaybe<Scalars['String']['input']>;
};

export type EnVkvElektroUpdateManyInlineInput = {
    /** Create and connect multiple EnVkvElektro component instances */
    create?: InputMaybe<Array<EnVkvElektroCreateWithPositionInput>>;
    /** Delete multiple EnVkvElektro documents */
    delete?: InputMaybe<Array<EnVkvElektroWhereUniqueInput>>;
    /** Update multiple EnVkvElektro component instances */
    update?: InputMaybe<Array<EnVkvElektroUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple EnVkvElektro component instances */
    upsert?: InputMaybe<Array<EnVkvElektroUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type EnVkvElektroUpdateManyInput = {
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    consumptionCombined?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    rangeElectric?: InputMaybe<Scalars['String']['input']>;
};

export type EnVkvElektroUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: EnVkvElektroUpdateManyInput;
    /** Document search */
    where: EnVkvElektroWhereInput;
};

export type EnVkvElektroUpdateOneInlineInput = {
    /** Create and connect one EnVkvElektro document */
    create?: InputMaybe<EnVkvElektroCreateInput>;
    /** Delete currently connected EnVkvElektro document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single EnVkvElektro document */
    update?: InputMaybe<EnVkvElektroUpdateWithNestedWhereUniqueInput>;
    /** Upsert single EnVkvElektro document */
    upsert?: InputMaybe<EnVkvElektroUpsertWithNestedWhereUniqueInput>;
};

export type EnVkvElektroUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<EnVkvElektroUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: EnVkvElektroWhereUniqueInput;
};

export type EnVkvElektroUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: EnVkvElektroUpdateInput;
    /** Unique document search */
    where: EnVkvElektroWhereUniqueInput;
};

export type EnVkvElektroUpsertInput = {
    /** Create document if it didn't exist */
    create: EnVkvElektroCreateInput;
    /** Update document if it exists */
    update: EnVkvElektroUpdateInput;
};

export type EnVkvElektroUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<EnVkvElektroUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: EnVkvElektroWhereUniqueInput;
};

export type EnVkvElektroUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: EnVkvElektroUpsertInput;
    /** Unique document search */
    where: EnVkvElektroWhereUniqueInput;
};

/** Identifies documents */
export type EnVkvElektroWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<EnVkvElektroWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<EnVkvElektroWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<EnVkvElektroWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    additionalTransmissionPerformance_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    additionalTransmissionPerformance_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    additionalTransmissionPerformance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    additionalTransmissionPerformance_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    additionalTransmissionPerformance_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    additionalTransmissionPerformance_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    additionalTransmissionPerformance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    additionalTransmissionPerformance_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    additionalTransmissionPerformance_starts_with?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2Combined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2Combined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2Combined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2Combined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2Combined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2Combined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2Combined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2Combined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2Combined_starts_with?: InputMaybe<Scalars['String']['input']>;
    consumptionCombined?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    consumptionCombined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    consumptionCombined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    consumptionCombined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    consumptionCombined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    consumptionCombined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    consumptionCombined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    consumptionCombined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    consumptionCombined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    consumptionCombined_starts_with?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    rangeElectric?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    rangeElectric_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    rangeElectric_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    rangeElectric_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    rangeElectric_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    rangeElectric_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    rangeElectric_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    rangeElectric_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    rangeElectric_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    rangeElectric_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References EnVkvElektro record uniquely */
export type EnVkvElektroWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type EnVkvPlugInHybrid = Entity & {
    __typename?: 'EnVkvPlugInHybrid';
    additionalTransmissionPerformance?: Maybe<Scalars['String']['output']>;
    co2ClassDischargedBattery: Scalars['String']['output'];
    co2Combined: Scalars['String']['output'];
    co2CombinedDischargedBattery: Scalars['String']['output'];
    consumptionCombinedDischargedBattery: Scalars['String']['output'];
    consumptionCombinedElectric: Scalars['String']['output'];
    consumptionCombinedLitres: Scalars['String']['output'];
    headline: Scalars['String']['output'];
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EnVkvPlugInHybridConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: EnVkvPlugInHybridWhereUniqueInput;
};

/** A connection to a list of items. */
export type EnVkvPlugInHybridConnection = {
    __typename?: 'EnVkvPlugInHybridConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<EnVkvPlugInHybridEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type EnVkvPlugInHybridCreateInput = {
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    co2ClassDischargedBattery: Scalars['String']['input'];
    co2Combined: Scalars['String']['input'];
    co2CombinedDischargedBattery: Scalars['String']['input'];
    consumptionCombinedDischargedBattery: Scalars['String']['input'];
    consumptionCombinedElectric: Scalars['String']['input'];
    consumptionCombinedLitres: Scalars['String']['input'];
    headline: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EnVkvPlugInHybridCreateManyInlineInput = {
    /** Create and connect multiple existing EnVkvPlugInHybrid documents */
    create?: InputMaybe<Array<EnVkvPlugInHybridCreateInput>>;
};

export type EnVkvPlugInHybridCreateOneInlineInput = {
    /** Create and connect one EnVkvPlugInHybrid document */
    create?: InputMaybe<EnVkvPlugInHybridCreateInput>;
};

export type EnVkvPlugInHybridCreateWithPositionInput = {
    /** Document to create */
    data: EnVkvPlugInHybridCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type EnVkvPlugInHybridEdge = {
    __typename?: 'EnVkvPlugInHybridEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: EnVkvPlugInHybrid;
};

/** Identifies documents */
export type EnVkvPlugInHybridManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<EnVkvPlugInHybridWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<EnVkvPlugInHybridWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<EnVkvPlugInHybridWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    additionalTransmissionPerformance_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    additionalTransmissionPerformance_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    additionalTransmissionPerformance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    additionalTransmissionPerformance_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    additionalTransmissionPerformance_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    additionalTransmissionPerformance_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    additionalTransmissionPerformance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    additionalTransmissionPerformance_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    additionalTransmissionPerformance_starts_with?: InputMaybe<Scalars['String']['input']>;
    co2ClassDischargedBattery?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2ClassDischargedBattery_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2ClassDischargedBattery_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2ClassDischargedBattery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2ClassDischargedBattery_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2ClassDischargedBattery_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2ClassDischargedBattery_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2ClassDischargedBattery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2ClassDischargedBattery_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2ClassDischargedBattery_starts_with?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    co2CombinedDischargedBattery?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2CombinedDischargedBattery_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2CombinedDischargedBattery_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2CombinedDischargedBattery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2CombinedDischargedBattery_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2CombinedDischargedBattery_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2CombinedDischargedBattery_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2CombinedDischargedBattery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2CombinedDischargedBattery_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2CombinedDischargedBattery_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2Combined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2Combined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2Combined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2Combined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2Combined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2Combined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2Combined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2Combined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2Combined_starts_with?: InputMaybe<Scalars['String']['input']>;
    consumptionCombinedDischargedBattery?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    consumptionCombinedDischargedBattery_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    consumptionCombinedDischargedBattery_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    consumptionCombinedDischargedBattery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    consumptionCombinedDischargedBattery_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    consumptionCombinedDischargedBattery_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    consumptionCombinedDischargedBattery_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    consumptionCombinedDischargedBattery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    consumptionCombinedDischargedBattery_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    consumptionCombinedDischargedBattery_starts_with?: InputMaybe<Scalars['String']['input']>;
    consumptionCombinedElectric?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    consumptionCombinedElectric_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    consumptionCombinedElectric_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    consumptionCombinedElectric_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    consumptionCombinedElectric_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    consumptionCombinedElectric_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    consumptionCombinedElectric_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    consumptionCombinedElectric_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    consumptionCombinedElectric_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    consumptionCombinedElectric_starts_with?: InputMaybe<Scalars['String']['input']>;
    consumptionCombinedLitres?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    consumptionCombinedLitres_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    consumptionCombinedLitres_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    consumptionCombinedLitres_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    consumptionCombinedLitres_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    consumptionCombinedLitres_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    consumptionCombinedLitres_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    consumptionCombinedLitres_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    consumptionCombinedLitres_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    consumptionCombinedLitres_starts_with?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum EnVkvPlugInHybridOrderByInput {
    AdditionalTransmissionPerformanceAsc = 'additionalTransmissionPerformance_ASC',
    AdditionalTransmissionPerformanceDesc = 'additionalTransmissionPerformance_DESC',
    Co2ClassDischargedBatteryAsc = 'co2ClassDischargedBattery_ASC',
    Co2ClassDischargedBatteryDesc = 'co2ClassDischargedBattery_DESC',
    Co2CombinedDischargedBatteryAsc = 'co2CombinedDischargedBattery_ASC',
    Co2CombinedDischargedBatteryDesc = 'co2CombinedDischargedBattery_DESC',
    Co2CombinedAsc = 'co2Combined_ASC',
    Co2CombinedDesc = 'co2Combined_DESC',
    ConsumptionCombinedDischargedBatteryAsc = 'consumptionCombinedDischargedBattery_ASC',
    ConsumptionCombinedDischargedBatteryDesc = 'consumptionCombinedDischargedBattery_DESC',
    ConsumptionCombinedElectricAsc = 'consumptionCombinedElectric_ASC',
    ConsumptionCombinedElectricDesc = 'consumptionCombinedElectric_DESC',
    ConsumptionCombinedLitresAsc = 'consumptionCombinedLitres_ASC',
    ConsumptionCombinedLitresDesc = 'consumptionCombinedLitres_DESC',
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type EnVkvPlugInHybridParent = Model | Vehicle;

export type EnVkvPlugInHybridParentConnectInput = {
    Model?: InputMaybe<ModelConnectInput>;
    Vehicle?: InputMaybe<VehicleConnectInput>;
};

export type EnVkvPlugInHybridParentCreateInput = {
    Model?: InputMaybe<ModelCreateInput>;
    Vehicle?: InputMaybe<VehicleCreateInput>;
};

export type EnVkvPlugInHybridParentCreateManyInlineInput = {
    /** Connect multiple existing EnVkvPlugInHybridParent documents */
    connect?: InputMaybe<Array<EnVkvPlugInHybridParentWhereUniqueInput>>;
    /** Create and connect multiple existing EnVkvPlugInHybridParent documents */
    create?: InputMaybe<Array<EnVkvPlugInHybridParentCreateInput>>;
};

export type EnVkvPlugInHybridParentCreateOneInlineInput = {
    /** Connect one existing EnVkvPlugInHybridParent document */
    connect?: InputMaybe<EnVkvPlugInHybridParentWhereUniqueInput>;
    /** Create and connect one EnVkvPlugInHybridParent document */
    create?: InputMaybe<EnVkvPlugInHybridParentCreateInput>;
};

export type EnVkvPlugInHybridParentUpdateInput = {
    Model?: InputMaybe<ModelUpdateInput>;
    Vehicle?: InputMaybe<VehicleUpdateInput>;
};

export type EnVkvPlugInHybridParentUpdateManyInlineInput = {
    /** Connect multiple existing EnVkvPlugInHybridParent documents */
    connect?: InputMaybe<Array<EnVkvPlugInHybridParentConnectInput>>;
    /** Create and connect multiple EnVkvPlugInHybridParent documents */
    create?: InputMaybe<Array<EnVkvPlugInHybridParentCreateInput>>;
    /** Delete multiple EnVkvPlugInHybridParent documents */
    delete?: InputMaybe<Array<EnVkvPlugInHybridParentWhereUniqueInput>>;
    /** Disconnect multiple EnVkvPlugInHybridParent documents */
    disconnect?: InputMaybe<Array<EnVkvPlugInHybridParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing EnVkvPlugInHybridParent documents */
    set?: InputMaybe<Array<EnVkvPlugInHybridParentWhereUniqueInput>>;
    /** Update multiple EnVkvPlugInHybridParent documents */
    update?: InputMaybe<Array<EnVkvPlugInHybridParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple EnVkvPlugInHybridParent documents */
    upsert?: InputMaybe<Array<EnVkvPlugInHybridParentUpsertWithNestedWhereUniqueInput>>;
};

export type EnVkvPlugInHybridParentUpdateManyWithNestedWhereInput = {
    Model?: InputMaybe<ModelUpdateManyWithNestedWhereInput>;
    Vehicle?: InputMaybe<VehicleUpdateManyWithNestedWhereInput>;
};

export type EnVkvPlugInHybridParentUpdateOneInlineInput = {
    /** Connect existing EnVkvPlugInHybridParent document */
    connect?: InputMaybe<EnVkvPlugInHybridParentWhereUniqueInput>;
    /** Create and connect one EnVkvPlugInHybridParent document */
    create?: InputMaybe<EnVkvPlugInHybridParentCreateInput>;
    /** Delete currently connected EnVkvPlugInHybridParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected EnVkvPlugInHybridParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single EnVkvPlugInHybridParent document */
    update?: InputMaybe<EnVkvPlugInHybridParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single EnVkvPlugInHybridParent document */
    upsert?: InputMaybe<EnVkvPlugInHybridParentUpsertWithNestedWhereUniqueInput>;
};

export type EnVkvPlugInHybridParentUpdateWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpdateWithNestedWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleUpdateWithNestedWhereUniqueInput>;
};

export type EnVkvPlugInHybridParentUpsertWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpsertWithNestedWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleUpsertWithNestedWhereUniqueInput>;
};

export type EnVkvPlugInHybridParentWhereInput = {
    Model?: InputMaybe<ModelWhereInput>;
    Vehicle?: InputMaybe<VehicleWhereInput>;
};

export type EnVkvPlugInHybridParentWhereUniqueInput = {
    Model?: InputMaybe<ModelWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleWhereUniqueInput>;
};

export type EnVkvPlugInHybridUpdateInput = {
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    co2ClassDischargedBattery?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    co2CombinedDischargedBattery?: InputMaybe<Scalars['String']['input']>;
    consumptionCombinedDischargedBattery?: InputMaybe<Scalars['String']['input']>;
    consumptionCombinedElectric?: InputMaybe<Scalars['String']['input']>;
    consumptionCombinedLitres?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
};

export type EnVkvPlugInHybridUpdateManyInlineInput = {
    /** Create and connect multiple EnVkvPlugInHybrid component instances */
    create?: InputMaybe<Array<EnVkvPlugInHybridCreateWithPositionInput>>;
    /** Delete multiple EnVkvPlugInHybrid documents */
    delete?: InputMaybe<Array<EnVkvPlugInHybridWhereUniqueInput>>;
    /** Update multiple EnVkvPlugInHybrid component instances */
    update?: InputMaybe<Array<EnVkvPlugInHybridUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple EnVkvPlugInHybrid component instances */
    upsert?: InputMaybe<Array<EnVkvPlugInHybridUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type EnVkvPlugInHybridUpdateManyInput = {
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    co2ClassDischargedBattery?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    co2CombinedDischargedBattery?: InputMaybe<Scalars['String']['input']>;
    consumptionCombinedDischargedBattery?: InputMaybe<Scalars['String']['input']>;
    consumptionCombinedElectric?: InputMaybe<Scalars['String']['input']>;
    consumptionCombinedLitres?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
};

export type EnVkvPlugInHybridUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: EnVkvPlugInHybridUpdateManyInput;
    /** Document search */
    where: EnVkvPlugInHybridWhereInput;
};

export type EnVkvPlugInHybridUpdateOneInlineInput = {
    /** Create and connect one EnVkvPlugInHybrid document */
    create?: InputMaybe<EnVkvPlugInHybridCreateInput>;
    /** Delete currently connected EnVkvPlugInHybrid document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single EnVkvPlugInHybrid document */
    update?: InputMaybe<EnVkvPlugInHybridUpdateWithNestedWhereUniqueInput>;
    /** Upsert single EnVkvPlugInHybrid document */
    upsert?: InputMaybe<EnVkvPlugInHybridUpsertWithNestedWhereUniqueInput>;
};

export type EnVkvPlugInHybridUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<EnVkvPlugInHybridUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: EnVkvPlugInHybridWhereUniqueInput;
};

export type EnVkvPlugInHybridUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: EnVkvPlugInHybridUpdateInput;
    /** Unique document search */
    where: EnVkvPlugInHybridWhereUniqueInput;
};

export type EnVkvPlugInHybridUpsertInput = {
    /** Create document if it didn't exist */
    create: EnVkvPlugInHybridCreateInput;
    /** Update document if it exists */
    update: EnVkvPlugInHybridUpdateInput;
};

export type EnVkvPlugInHybridUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<EnVkvPlugInHybridUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: EnVkvPlugInHybridWhereUniqueInput;
};

export type EnVkvPlugInHybridUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: EnVkvPlugInHybridUpsertInput;
    /** Unique document search */
    where: EnVkvPlugInHybridWhereUniqueInput;
};

/** Identifies documents */
export type EnVkvPlugInHybridWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<EnVkvPlugInHybridWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<EnVkvPlugInHybridWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<EnVkvPlugInHybridWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    additionalTransmissionPerformance_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    additionalTransmissionPerformance_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    additionalTransmissionPerformance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    additionalTransmissionPerformance_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    additionalTransmissionPerformance_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    additionalTransmissionPerformance_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    additionalTransmissionPerformance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    additionalTransmissionPerformance_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    additionalTransmissionPerformance_starts_with?: InputMaybe<Scalars['String']['input']>;
    co2ClassDischargedBattery?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2ClassDischargedBattery_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2ClassDischargedBattery_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2ClassDischargedBattery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2ClassDischargedBattery_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2ClassDischargedBattery_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2ClassDischargedBattery_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2ClassDischargedBattery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2ClassDischargedBattery_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2ClassDischargedBattery_starts_with?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    co2CombinedDischargedBattery?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2CombinedDischargedBattery_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2CombinedDischargedBattery_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2CombinedDischargedBattery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2CombinedDischargedBattery_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2CombinedDischargedBattery_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2CombinedDischargedBattery_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2CombinedDischargedBattery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2CombinedDischargedBattery_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2CombinedDischargedBattery_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2Combined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2Combined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2Combined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2Combined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2Combined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2Combined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2Combined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2Combined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2Combined_starts_with?: InputMaybe<Scalars['String']['input']>;
    consumptionCombinedDischargedBattery?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    consumptionCombinedDischargedBattery_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    consumptionCombinedDischargedBattery_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    consumptionCombinedDischargedBattery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    consumptionCombinedDischargedBattery_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    consumptionCombinedDischargedBattery_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    consumptionCombinedDischargedBattery_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    consumptionCombinedDischargedBattery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    consumptionCombinedDischargedBattery_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    consumptionCombinedDischargedBattery_starts_with?: InputMaybe<Scalars['String']['input']>;
    consumptionCombinedElectric?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    consumptionCombinedElectric_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    consumptionCombinedElectric_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    consumptionCombinedElectric_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    consumptionCombinedElectric_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    consumptionCombinedElectric_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    consumptionCombinedElectric_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    consumptionCombinedElectric_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    consumptionCombinedElectric_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    consumptionCombinedElectric_starts_with?: InputMaybe<Scalars['String']['input']>;
    consumptionCombinedLitres?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    consumptionCombinedLitres_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    consumptionCombinedLitres_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    consumptionCombinedLitres_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    consumptionCombinedLitres_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    consumptionCombinedLitres_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    consumptionCombinedLitres_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    consumptionCombinedLitres_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    consumptionCombinedLitres_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    consumptionCombinedLitres_starts_with?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References EnVkvPlugInHybrid record uniquely */
export type EnVkvPlugInHybridWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type EnVkvVerbrennerHybrid = Entity & {
    __typename?: 'EnVkvVerbrennerHybrid';
    additionalTransmissionPerformance?: Maybe<Scalars['String']['output']>;
    co2Combined: Scalars['String']['output'];
    consumptionCombined: Scalars['String']['output'];
    headline: Scalars['String']['output'];
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EnVkvVerbrennerHybridConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: EnVkvVerbrennerHybridWhereUniqueInput;
};

/** A connection to a list of items. */
export type EnVkvVerbrennerHybridConnection = {
    __typename?: 'EnVkvVerbrennerHybridConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<EnVkvVerbrennerHybridEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type EnVkvVerbrennerHybridCreateInput = {
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    co2Combined: Scalars['String']['input'];
    consumptionCombined: Scalars['String']['input'];
    headline: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EnVkvVerbrennerHybridCreateManyInlineInput = {
    /** Create and connect multiple existing EnVkvVerbrennerHybrid documents */
    create?: InputMaybe<Array<EnVkvVerbrennerHybridCreateInput>>;
};

export type EnVkvVerbrennerHybridCreateOneInlineInput = {
    /** Create and connect one EnVkvVerbrennerHybrid document */
    create?: InputMaybe<EnVkvVerbrennerHybridCreateInput>;
};

export type EnVkvVerbrennerHybridCreateWithPositionInput = {
    /** Document to create */
    data: EnVkvVerbrennerHybridCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type EnVkvVerbrennerHybridEdge = {
    __typename?: 'EnVkvVerbrennerHybridEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: EnVkvVerbrennerHybrid;
};

/** Identifies documents */
export type EnVkvVerbrennerHybridManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<EnVkvVerbrennerHybridWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<EnVkvVerbrennerHybridWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<EnVkvVerbrennerHybridWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    additionalTransmissionPerformance_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    additionalTransmissionPerformance_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    additionalTransmissionPerformance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    additionalTransmissionPerformance_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    additionalTransmissionPerformance_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    additionalTransmissionPerformance_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    additionalTransmissionPerformance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    additionalTransmissionPerformance_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    additionalTransmissionPerformance_starts_with?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2Combined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2Combined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2Combined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2Combined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2Combined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2Combined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2Combined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2Combined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2Combined_starts_with?: InputMaybe<Scalars['String']['input']>;
    consumptionCombined?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    consumptionCombined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    consumptionCombined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    consumptionCombined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    consumptionCombined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    consumptionCombined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    consumptionCombined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    consumptionCombined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    consumptionCombined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    consumptionCombined_starts_with?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum EnVkvVerbrennerHybridOrderByInput {
    AdditionalTransmissionPerformanceAsc = 'additionalTransmissionPerformance_ASC',
    AdditionalTransmissionPerformanceDesc = 'additionalTransmissionPerformance_DESC',
    Co2CombinedAsc = 'co2Combined_ASC',
    Co2CombinedDesc = 'co2Combined_DESC',
    ConsumptionCombinedAsc = 'consumptionCombined_ASC',
    ConsumptionCombinedDesc = 'consumptionCombined_DESC',
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type EnVkvVerbrennerHybridParent = Model | Vehicle;

export type EnVkvVerbrennerHybridParentConnectInput = {
    Model?: InputMaybe<ModelConnectInput>;
    Vehicle?: InputMaybe<VehicleConnectInput>;
};

export type EnVkvVerbrennerHybridParentCreateInput = {
    Model?: InputMaybe<ModelCreateInput>;
    Vehicle?: InputMaybe<VehicleCreateInput>;
};

export type EnVkvVerbrennerHybridParentCreateManyInlineInput = {
    /** Connect multiple existing EnVkvVerbrennerHybridParent documents */
    connect?: InputMaybe<Array<EnVkvVerbrennerHybridParentWhereUniqueInput>>;
    /** Create and connect multiple existing EnVkvVerbrennerHybridParent documents */
    create?: InputMaybe<Array<EnVkvVerbrennerHybridParentCreateInput>>;
};

export type EnVkvVerbrennerHybridParentCreateOneInlineInput = {
    /** Connect one existing EnVkvVerbrennerHybridParent document */
    connect?: InputMaybe<EnVkvVerbrennerHybridParentWhereUniqueInput>;
    /** Create and connect one EnVkvVerbrennerHybridParent document */
    create?: InputMaybe<EnVkvVerbrennerHybridParentCreateInput>;
};

export type EnVkvVerbrennerHybridParentUpdateInput = {
    Model?: InputMaybe<ModelUpdateInput>;
    Vehicle?: InputMaybe<VehicleUpdateInput>;
};

export type EnVkvVerbrennerHybridParentUpdateManyInlineInput = {
    /** Connect multiple existing EnVkvVerbrennerHybridParent documents */
    connect?: InputMaybe<Array<EnVkvVerbrennerHybridParentConnectInput>>;
    /** Create and connect multiple EnVkvVerbrennerHybridParent documents */
    create?: InputMaybe<Array<EnVkvVerbrennerHybridParentCreateInput>>;
    /** Delete multiple EnVkvVerbrennerHybridParent documents */
    delete?: InputMaybe<Array<EnVkvVerbrennerHybridParentWhereUniqueInput>>;
    /** Disconnect multiple EnVkvVerbrennerHybridParent documents */
    disconnect?: InputMaybe<Array<EnVkvVerbrennerHybridParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing EnVkvVerbrennerHybridParent documents */
    set?: InputMaybe<Array<EnVkvVerbrennerHybridParentWhereUniqueInput>>;
    /** Update multiple EnVkvVerbrennerHybridParent documents */
    update?: InputMaybe<Array<EnVkvVerbrennerHybridParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple EnVkvVerbrennerHybridParent documents */
    upsert?: InputMaybe<Array<EnVkvVerbrennerHybridParentUpsertWithNestedWhereUniqueInput>>;
};

export type EnVkvVerbrennerHybridParentUpdateManyWithNestedWhereInput = {
    Model?: InputMaybe<ModelUpdateManyWithNestedWhereInput>;
    Vehicle?: InputMaybe<VehicleUpdateManyWithNestedWhereInput>;
};

export type EnVkvVerbrennerHybridParentUpdateOneInlineInput = {
    /** Connect existing EnVkvVerbrennerHybridParent document */
    connect?: InputMaybe<EnVkvVerbrennerHybridParentWhereUniqueInput>;
    /** Create and connect one EnVkvVerbrennerHybridParent document */
    create?: InputMaybe<EnVkvVerbrennerHybridParentCreateInput>;
    /** Delete currently connected EnVkvVerbrennerHybridParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected EnVkvVerbrennerHybridParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single EnVkvVerbrennerHybridParent document */
    update?: InputMaybe<EnVkvVerbrennerHybridParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single EnVkvVerbrennerHybridParent document */
    upsert?: InputMaybe<EnVkvVerbrennerHybridParentUpsertWithNestedWhereUniqueInput>;
};

export type EnVkvVerbrennerHybridParentUpdateWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpdateWithNestedWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleUpdateWithNestedWhereUniqueInput>;
};

export type EnVkvVerbrennerHybridParentUpsertWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpsertWithNestedWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleUpsertWithNestedWhereUniqueInput>;
};

export type EnVkvVerbrennerHybridParentWhereInput = {
    Model?: InputMaybe<ModelWhereInput>;
    Vehicle?: InputMaybe<VehicleWhereInput>;
};

export type EnVkvVerbrennerHybridParentWhereUniqueInput = {
    Model?: InputMaybe<ModelWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleWhereUniqueInput>;
};

export type EnVkvVerbrennerHybridUpdateInput = {
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    consumptionCombined?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
};

export type EnVkvVerbrennerHybridUpdateManyInlineInput = {
    /** Create and connect multiple EnVkvVerbrennerHybrid component instances */
    create?: InputMaybe<Array<EnVkvVerbrennerHybridCreateWithPositionInput>>;
    /** Delete multiple EnVkvVerbrennerHybrid documents */
    delete?: InputMaybe<Array<EnVkvVerbrennerHybridWhereUniqueInput>>;
    /** Update multiple EnVkvVerbrennerHybrid component instances */
    update?: InputMaybe<Array<EnVkvVerbrennerHybridUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple EnVkvVerbrennerHybrid component instances */
    upsert?: InputMaybe<Array<EnVkvVerbrennerHybridUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type EnVkvVerbrennerHybridUpdateManyInput = {
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    consumptionCombined?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
};

export type EnVkvVerbrennerHybridUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: EnVkvVerbrennerHybridUpdateManyInput;
    /** Document search */
    where: EnVkvVerbrennerHybridWhereInput;
};

export type EnVkvVerbrennerHybridUpdateOneInlineInput = {
    /** Create and connect one EnVkvVerbrennerHybrid document */
    create?: InputMaybe<EnVkvVerbrennerHybridCreateInput>;
    /** Delete currently connected EnVkvVerbrennerHybrid document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single EnVkvVerbrennerHybrid document */
    update?: InputMaybe<EnVkvVerbrennerHybridUpdateWithNestedWhereUniqueInput>;
    /** Upsert single EnVkvVerbrennerHybrid document */
    upsert?: InputMaybe<EnVkvVerbrennerHybridUpsertWithNestedWhereUniqueInput>;
};

export type EnVkvVerbrennerHybridUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<EnVkvVerbrennerHybridUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: EnVkvVerbrennerHybridWhereUniqueInput;
};

export type EnVkvVerbrennerHybridUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: EnVkvVerbrennerHybridUpdateInput;
    /** Unique document search */
    where: EnVkvVerbrennerHybridWhereUniqueInput;
};

export type EnVkvVerbrennerHybridUpsertInput = {
    /** Create document if it didn't exist */
    create: EnVkvVerbrennerHybridCreateInput;
    /** Update document if it exists */
    update: EnVkvVerbrennerHybridUpdateInput;
};

export type EnVkvVerbrennerHybridUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<EnVkvVerbrennerHybridUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: EnVkvVerbrennerHybridWhereUniqueInput;
};

export type EnVkvVerbrennerHybridUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: EnVkvVerbrennerHybridUpsertInput;
    /** Unique document search */
    where: EnVkvVerbrennerHybridWhereUniqueInput;
};

/** Identifies documents */
export type EnVkvVerbrennerHybridWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<EnVkvVerbrennerHybridWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<EnVkvVerbrennerHybridWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<EnVkvVerbrennerHybridWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    additionalTransmissionPerformance_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    additionalTransmissionPerformance_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    additionalTransmissionPerformance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    additionalTransmissionPerformance_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    additionalTransmissionPerformance_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    additionalTransmissionPerformance_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    additionalTransmissionPerformance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    additionalTransmissionPerformance_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    additionalTransmissionPerformance_starts_with?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2Combined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2Combined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2Combined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2Combined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2Combined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2Combined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2Combined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2Combined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2Combined_starts_with?: InputMaybe<Scalars['String']['input']>;
    consumptionCombined?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    consumptionCombined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    consumptionCombined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    consumptionCombined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    consumptionCombined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    consumptionCombined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    consumptionCombined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    consumptionCombined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    consumptionCombined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    consumptionCombined_starts_with?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References EnVkvVerbrennerHybrid record uniquely */
export type EnVkvVerbrennerHybridWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type EnVkvWasserstoff = Entity & {
    __typename?: 'EnVkvWasserstoff';
    additionalTransmissionPerformance?: Maybe<Scalars['String']['output']>;
    co2Combined: Scalars['String']['output'];
    energyCombined: Scalars['String']['output'];
    headline: Scalars['String']['output'];
    /** The unique identifier */
    id: Scalars['ID']['output'];
    range: Scalars['String']['output'];
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EnVkvWasserstoffConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: EnVkvWasserstoffWhereUniqueInput;
};

/** A connection to a list of items. */
export type EnVkvWasserstoffConnection = {
    __typename?: 'EnVkvWasserstoffConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<EnVkvWasserstoffEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type EnVkvWasserstoffCreateInput = {
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    co2Combined: Scalars['String']['input'];
    energyCombined: Scalars['String']['input'];
    headline: Scalars['String']['input'];
    range: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EnVkvWasserstoffCreateManyInlineInput = {
    /** Create and connect multiple existing EnVkvWasserstoff documents */
    create?: InputMaybe<Array<EnVkvWasserstoffCreateInput>>;
};

export type EnVkvWasserstoffCreateOneInlineInput = {
    /** Create and connect one EnVkvWasserstoff document */
    create?: InputMaybe<EnVkvWasserstoffCreateInput>;
};

export type EnVkvWasserstoffCreateWithPositionInput = {
    /** Document to create */
    data: EnVkvWasserstoffCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type EnVkvWasserstoffEdge = {
    __typename?: 'EnVkvWasserstoffEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: EnVkvWasserstoff;
};

/** Identifies documents */
export type EnVkvWasserstoffManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<EnVkvWasserstoffWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<EnVkvWasserstoffWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<EnVkvWasserstoffWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    additionalTransmissionPerformance_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    additionalTransmissionPerformance_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    additionalTransmissionPerformance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    additionalTransmissionPerformance_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    additionalTransmissionPerformance_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    additionalTransmissionPerformance_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    additionalTransmissionPerformance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    additionalTransmissionPerformance_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    additionalTransmissionPerformance_starts_with?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2Combined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2Combined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2Combined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2Combined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2Combined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2Combined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2Combined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2Combined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2Combined_starts_with?: InputMaybe<Scalars['String']['input']>;
    energyCombined?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    energyCombined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    energyCombined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    energyCombined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    energyCombined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    energyCombined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    energyCombined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    energyCombined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    energyCombined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    energyCombined_starts_with?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    range?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    range_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    range_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    range_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    range_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    range_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    range_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    range_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    range_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    range_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum EnVkvWasserstoffOrderByInput {
    AdditionalTransmissionPerformanceAsc = 'additionalTransmissionPerformance_ASC',
    AdditionalTransmissionPerformanceDesc = 'additionalTransmissionPerformance_DESC',
    Co2CombinedAsc = 'co2Combined_ASC',
    Co2CombinedDesc = 'co2Combined_DESC',
    EnergyCombinedAsc = 'energyCombined_ASC',
    EnergyCombinedDesc = 'energyCombined_DESC',
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    RangeAsc = 'range_ASC',
    RangeDesc = 'range_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type EnVkvWasserstoffParent = Model;

export type EnVkvWasserstoffParentConnectInput = {
    Model?: InputMaybe<ModelConnectInput>;
};

export type EnVkvWasserstoffParentCreateInput = {
    Model?: InputMaybe<ModelCreateInput>;
};

export type EnVkvWasserstoffParentCreateManyInlineInput = {
    /** Connect multiple existing EnVkvWasserstoffParent documents */
    connect?: InputMaybe<Array<EnVkvWasserstoffParentWhereUniqueInput>>;
    /** Create and connect multiple existing EnVkvWasserstoffParent documents */
    create?: InputMaybe<Array<EnVkvWasserstoffParentCreateInput>>;
};

export type EnVkvWasserstoffParentCreateOneInlineInput = {
    /** Connect one existing EnVkvWasserstoffParent document */
    connect?: InputMaybe<EnVkvWasserstoffParentWhereUniqueInput>;
    /** Create and connect one EnVkvWasserstoffParent document */
    create?: InputMaybe<EnVkvWasserstoffParentCreateInput>;
};

export type EnVkvWasserstoffParentUpdateInput = {
    Model?: InputMaybe<ModelUpdateInput>;
};

export type EnVkvWasserstoffParentUpdateManyInlineInput = {
    /** Connect multiple existing EnVkvWasserstoffParent documents */
    connect?: InputMaybe<Array<EnVkvWasserstoffParentConnectInput>>;
    /** Create and connect multiple EnVkvWasserstoffParent documents */
    create?: InputMaybe<Array<EnVkvWasserstoffParentCreateInput>>;
    /** Delete multiple EnVkvWasserstoffParent documents */
    delete?: InputMaybe<Array<EnVkvWasserstoffParentWhereUniqueInput>>;
    /** Disconnect multiple EnVkvWasserstoffParent documents */
    disconnect?: InputMaybe<Array<EnVkvWasserstoffParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing EnVkvWasserstoffParent documents */
    set?: InputMaybe<Array<EnVkvWasserstoffParentWhereUniqueInput>>;
    /** Update multiple EnVkvWasserstoffParent documents */
    update?: InputMaybe<Array<EnVkvWasserstoffParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple EnVkvWasserstoffParent documents */
    upsert?: InputMaybe<Array<EnVkvWasserstoffParentUpsertWithNestedWhereUniqueInput>>;
};

export type EnVkvWasserstoffParentUpdateManyWithNestedWhereInput = {
    Model?: InputMaybe<ModelUpdateManyWithNestedWhereInput>;
};

export type EnVkvWasserstoffParentUpdateOneInlineInput = {
    /** Connect existing EnVkvWasserstoffParent document */
    connect?: InputMaybe<EnVkvWasserstoffParentWhereUniqueInput>;
    /** Create and connect one EnVkvWasserstoffParent document */
    create?: InputMaybe<EnVkvWasserstoffParentCreateInput>;
    /** Delete currently connected EnVkvWasserstoffParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected EnVkvWasserstoffParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single EnVkvWasserstoffParent document */
    update?: InputMaybe<EnVkvWasserstoffParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single EnVkvWasserstoffParent document */
    upsert?: InputMaybe<EnVkvWasserstoffParentUpsertWithNestedWhereUniqueInput>;
};

export type EnVkvWasserstoffParentUpdateWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpdateWithNestedWhereUniqueInput>;
};

export type EnVkvWasserstoffParentUpsertWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpsertWithNestedWhereUniqueInput>;
};

export type EnVkvWasserstoffParentWhereInput = {
    Model?: InputMaybe<ModelWhereInput>;
};

export type EnVkvWasserstoffParentWhereUniqueInput = {
    Model?: InputMaybe<ModelWhereUniqueInput>;
};

export type EnVkvWasserstoffUpdateInput = {
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    energyCombined?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    range?: InputMaybe<Scalars['String']['input']>;
};

export type EnVkvWasserstoffUpdateManyInlineInput = {
    /** Create and connect multiple EnVkvWasserstoff component instances */
    create?: InputMaybe<Array<EnVkvWasserstoffCreateWithPositionInput>>;
    /** Delete multiple EnVkvWasserstoff documents */
    delete?: InputMaybe<Array<EnVkvWasserstoffWhereUniqueInput>>;
    /** Update multiple EnVkvWasserstoff component instances */
    update?: InputMaybe<Array<EnVkvWasserstoffUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple EnVkvWasserstoff component instances */
    upsert?: InputMaybe<Array<EnVkvWasserstoffUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type EnVkvWasserstoffUpdateManyInput = {
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    energyCombined?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    range?: InputMaybe<Scalars['String']['input']>;
};

export type EnVkvWasserstoffUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: EnVkvWasserstoffUpdateManyInput;
    /** Document search */
    where: EnVkvWasserstoffWhereInput;
};

export type EnVkvWasserstoffUpdateOneInlineInput = {
    /** Create and connect one EnVkvWasserstoff document */
    create?: InputMaybe<EnVkvWasserstoffCreateInput>;
    /** Delete currently connected EnVkvWasserstoff document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single EnVkvWasserstoff document */
    update?: InputMaybe<EnVkvWasserstoffUpdateWithNestedWhereUniqueInput>;
    /** Upsert single EnVkvWasserstoff document */
    upsert?: InputMaybe<EnVkvWasserstoffUpsertWithNestedWhereUniqueInput>;
};

export type EnVkvWasserstoffUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<EnVkvWasserstoffUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: EnVkvWasserstoffWhereUniqueInput;
};

export type EnVkvWasserstoffUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: EnVkvWasserstoffUpdateInput;
    /** Unique document search */
    where: EnVkvWasserstoffWhereUniqueInput;
};

export type EnVkvWasserstoffUpsertInput = {
    /** Create document if it didn't exist */
    create: EnVkvWasserstoffCreateInput;
    /** Update document if it exists */
    update: EnVkvWasserstoffUpdateInput;
};

export type EnVkvWasserstoffUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<EnVkvWasserstoffUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: EnVkvWasserstoffWhereUniqueInput;
};

export type EnVkvWasserstoffUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: EnVkvWasserstoffUpsertInput;
    /** Unique document search */
    where: EnVkvWasserstoffWhereUniqueInput;
};

/** Identifies documents */
export type EnVkvWasserstoffWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<EnVkvWasserstoffWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<EnVkvWasserstoffWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<EnVkvWasserstoffWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    additionalTransmissionPerformance?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    additionalTransmissionPerformance_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    additionalTransmissionPerformance_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    additionalTransmissionPerformance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    additionalTransmissionPerformance_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    additionalTransmissionPerformance_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    additionalTransmissionPerformance_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    additionalTransmissionPerformance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    additionalTransmissionPerformance_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    additionalTransmissionPerformance_starts_with?: InputMaybe<Scalars['String']['input']>;
    co2Combined?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2Combined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2Combined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2Combined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2Combined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2Combined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2Combined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2Combined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2Combined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2Combined_starts_with?: InputMaybe<Scalars['String']['input']>;
    energyCombined?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    energyCombined_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    energyCombined_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    energyCombined_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    energyCombined_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    energyCombined_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    energyCombined_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    energyCombined_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    energyCombined_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    energyCombined_starts_with?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    range?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    range_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    range_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    range_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    range_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    range_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    range_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    range_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    range_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    range_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References EnVkvWasserstoff record uniquely */
export type EnVkvWasserstoffWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

/** An object with an ID */
export type Entity = {
    /** The id of the object. */
    id: Scalars['ID']['output'];
    /** The Stage of an object */
    stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
    Address = 'Address',
    AfterSale = 'AfterSale',
    /** Asset system model */
    Asset = 'Asset',
    Auth0User = 'Auth0User',
    BankCode = 'BankCode',
    Campaign = 'Campaign',
    CampaignAfterSalesAccesory = 'CampaignAfterSalesAccesory',
    CampaignAfterSalesService = 'CampaignAfterSalesService',
    CampaignService = 'CampaignService',
    Contact = 'Contact',
    Dealer = 'Dealer',
    Department = 'Department',
    EnVkvElektro = 'EnVkvElektro',
    EnVkvPlugInHybrid = 'EnVkvPlugInHybrid',
    EnVkvVerbrennerHybrid = 'EnVkvVerbrennerHybrid',
    EnVkvWasserstoff = 'EnVkvWasserstoff',
    Faq = 'Faq',
    Footnote = 'Footnote',
    GeneralService = 'GeneralService',
    HeadlineText = 'HeadlineText',
    HomeTeaser = 'HomeTeaser',
    IconText = 'IconText',
    KeyFact = 'KeyFact',
    Link = 'Link',
    Model = 'Model',
    ModellAnkuendigungContent = 'ModellAnkuendigungContent',
    Opening = 'Opening',
    OverlayBatteryCertificate = 'OverlayBatteryCertificate',
    PageAboutUs = 'PageAboutUs',
    PageBusinessCustomer = 'PageBusinessCustomer',
    PageHome = 'PageHome',
    PageHyundaiPromise = 'PageHyundaiPromise',
    PageService = 'PageService',
    PageWarranty = 'PageWarranty',
    QuestionAnswer = 'QuestionAnswer',
    SalesCampaignContent = 'SalesCampaignContent',
    SalesCampaignModel = 'SalesCampaignModel',
    /** Scheduled Operation system model */
    ScheduledOperation = 'ScheduledOperation',
    /** Scheduled Release system model */
    ScheduledRelease = 'ScheduledRelease',
    TimeRange = 'TimeRange',
    /** User system model */
    User = 'User',
    UtmMapping = 'UtmMapping',
    Vehicle = 'Vehicle',
    VertriebBusinessContent = 'VertriebBusinessContent',
    VertriebPrivateContent = 'VertriebPrivateContent',
    Warranty = 'Warranty',
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
    /** The ID of an object */
    id: Scalars['ID']['input'];
    locale?: InputMaybe<Locale>;
    stage: Stage;
    /** The Type name of an object */
    typename: EntityTypeName;
};

export type Faq = Entity & {
    __typename?: 'Faq';
    headline?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    questions: Array<QuestionAnswer>;
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FaqQuestionsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<QuestionAnswerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<QuestionAnswerWhereInput>;
};

export type FaqConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: FaqWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqConnection = {
    __typename?: 'FaqConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<FaqEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type FaqCreateInput = {
    headline?: InputMaybe<Scalars['String']['input']>;
    questions?: InputMaybe<QuestionAnswerCreateManyInlineInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqCreateManyInlineInput = {
    /** Create and connect multiple existing Faq documents */
    create?: InputMaybe<Array<FaqCreateInput>>;
};

export type FaqCreateOneInlineInput = {
    /** Create and connect one Faq document */
    create?: InputMaybe<FaqCreateInput>;
};

export type FaqCreateWithPositionInput = {
    /** Document to create */
    data: FaqCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type FaqEdge = {
    __typename?: 'FaqEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Faq;
};

/** Identifies documents */
export type FaqManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<FaqWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<FaqWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<FaqWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    questions_every?: InputMaybe<QuestionAnswerWhereInput>;
    questions_none?: InputMaybe<QuestionAnswerWhereInput>;
    questions_some?: InputMaybe<QuestionAnswerWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum FaqOrderByInput {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type FaqParent = Model | PageBusinessCustomer | PageHyundaiPromise | PageService | PageWarranty;

export type FaqParentConnectInput = {
    Model?: InputMaybe<ModelConnectInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerConnectInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseConnectInput>;
    PageService?: InputMaybe<PageServiceConnectInput>;
    PageWarranty?: InputMaybe<PageWarrantyConnectInput>;
};

export type FaqParentCreateInput = {
    Model?: InputMaybe<ModelCreateInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerCreateInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseCreateInput>;
    PageService?: InputMaybe<PageServiceCreateInput>;
    PageWarranty?: InputMaybe<PageWarrantyCreateInput>;
};

export type FaqParentCreateManyInlineInput = {
    /** Connect multiple existing FaqParent documents */
    connect?: InputMaybe<Array<FaqParentWhereUniqueInput>>;
    /** Create and connect multiple existing FaqParent documents */
    create?: InputMaybe<Array<FaqParentCreateInput>>;
};

export type FaqParentCreateOneInlineInput = {
    /** Connect one existing FaqParent document */
    connect?: InputMaybe<FaqParentWhereUniqueInput>;
    /** Create and connect one FaqParent document */
    create?: InputMaybe<FaqParentCreateInput>;
};

export type FaqParentUpdateInput = {
    Model?: InputMaybe<ModelUpdateInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerUpdateInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseUpdateInput>;
    PageService?: InputMaybe<PageServiceUpdateInput>;
    PageWarranty?: InputMaybe<PageWarrantyUpdateInput>;
};

export type FaqParentUpdateManyInlineInput = {
    /** Connect multiple existing FaqParent documents */
    connect?: InputMaybe<Array<FaqParentConnectInput>>;
    /** Create and connect multiple FaqParent documents */
    create?: InputMaybe<Array<FaqParentCreateInput>>;
    /** Delete multiple FaqParent documents */
    delete?: InputMaybe<Array<FaqParentWhereUniqueInput>>;
    /** Disconnect multiple FaqParent documents */
    disconnect?: InputMaybe<Array<FaqParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing FaqParent documents */
    set?: InputMaybe<Array<FaqParentWhereUniqueInput>>;
    /** Update multiple FaqParent documents */
    update?: InputMaybe<Array<FaqParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple FaqParent documents */
    upsert?: InputMaybe<Array<FaqParentUpsertWithNestedWhereUniqueInput>>;
};

export type FaqParentUpdateManyWithNestedWhereInput = {
    Model?: InputMaybe<ModelUpdateManyWithNestedWhereInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerUpdateManyWithNestedWhereInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseUpdateManyWithNestedWhereInput>;
    PageService?: InputMaybe<PageServiceUpdateManyWithNestedWhereInput>;
    PageWarranty?: InputMaybe<PageWarrantyUpdateManyWithNestedWhereInput>;
};

export type FaqParentUpdateOneInlineInput = {
    /** Connect existing FaqParent document */
    connect?: InputMaybe<FaqParentWhereUniqueInput>;
    /** Create and connect one FaqParent document */
    create?: InputMaybe<FaqParentCreateInput>;
    /** Delete currently connected FaqParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected FaqParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single FaqParent document */
    update?: InputMaybe<FaqParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single FaqParent document */
    upsert?: InputMaybe<FaqParentUpsertWithNestedWhereUniqueInput>;
};

export type FaqParentUpdateWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpdateWithNestedWhereUniqueInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerUpdateWithNestedWhereUniqueInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseUpdateWithNestedWhereUniqueInput>;
    PageService?: InputMaybe<PageServiceUpdateWithNestedWhereUniqueInput>;
    PageWarranty?: InputMaybe<PageWarrantyUpdateWithNestedWhereUniqueInput>;
};

export type FaqParentUpsertWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpsertWithNestedWhereUniqueInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerUpsertWithNestedWhereUniqueInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseUpsertWithNestedWhereUniqueInput>;
    PageService?: InputMaybe<PageServiceUpsertWithNestedWhereUniqueInput>;
    PageWarranty?: InputMaybe<PageWarrantyUpsertWithNestedWhereUniqueInput>;
};

export type FaqParentWhereInput = {
    Model?: InputMaybe<ModelWhereInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerWhereInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseWhereInput>;
    PageService?: InputMaybe<PageServiceWhereInput>;
    PageWarranty?: InputMaybe<PageWarrantyWhereInput>;
};

export type FaqParentWhereUniqueInput = {
    Model?: InputMaybe<ModelWhereUniqueInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerWhereUniqueInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseWhereUniqueInput>;
    PageService?: InputMaybe<PageServiceWhereUniqueInput>;
    PageWarranty?: InputMaybe<PageWarrantyWhereUniqueInput>;
};

export type FaqUpdateInput = {
    headline?: InputMaybe<Scalars['String']['input']>;
    questions?: InputMaybe<QuestionAnswerUpdateManyInlineInput>;
};

export type FaqUpdateManyInlineInput = {
    /** Create and connect multiple Faq component instances */
    create?: InputMaybe<Array<FaqCreateWithPositionInput>>;
    /** Delete multiple Faq documents */
    delete?: InputMaybe<Array<FaqWhereUniqueInput>>;
    /** Update multiple Faq component instances */
    update?: InputMaybe<Array<FaqUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple Faq component instances */
    upsert?: InputMaybe<Array<FaqUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FaqUpdateManyInput = {
    headline?: InputMaybe<Scalars['String']['input']>;
};

export type FaqUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: FaqUpdateManyInput;
    /** Document search */
    where: FaqWhereInput;
};

export type FaqUpdateOneInlineInput = {
    /** Create and connect one Faq document */
    create?: InputMaybe<FaqCreateInput>;
    /** Delete currently connected Faq document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Faq document */
    update?: InputMaybe<FaqUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Faq document */
    upsert?: InputMaybe<FaqUpsertWithNestedWhereUniqueInput>;
};

export type FaqUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<FaqUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: FaqWhereUniqueInput;
};

export type FaqUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: FaqUpdateInput;
    /** Unique document search */
    where: FaqWhereUniqueInput;
};

export type FaqUpsertInput = {
    /** Create document if it didn't exist */
    create: FaqCreateInput;
    /** Update document if it exists */
    update: FaqUpdateInput;
};

export type FaqUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<FaqUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: FaqWhereUniqueInput;
};

export type FaqUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: FaqUpsertInput;
    /** Unique document search */
    where: FaqWhereUniqueInput;
};

/** Identifies documents */
export type FaqWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<FaqWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<FaqWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<FaqWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    questions_every?: InputMaybe<QuestionAnswerWhereInput>;
    questions_none?: InputMaybe<QuestionAnswerWhereInput>;
    questions_some?: InputMaybe<QuestionAnswerWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Faq record uniquely */
export type FaqWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type Footnote = Entity &
    Node & {
        __typename?: 'Footnote';
        content: RichText;
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Get the document in other stages */
        documentInStages: Array<Footnote>;
        fixedSign?: Maybe<Scalars['String']['output']>;
        /** List of Footnote versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        kommentar?: Maybe<Scalars['String']['output']>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

export type FootnoteCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type FootnoteDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type FootnoteHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type FootnotePublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type FootnoteScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type FootnoteUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type FootnoteConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: FootnoteWhereUniqueInput;
};

/** A connection to a list of items. */
export type FootnoteConnection = {
    __typename?: 'FootnoteConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<FootnoteEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type FootnoteCreateInput = {
    cm1era28v0lwm07vybmo03fbi?: InputMaybe<CampaignAfterSalesAccesoryCreateManyInlineInput>;
    cm1erclo00lra07uqd7pmhedl?: InputMaybe<CampaignAfterSalesServiceCreateManyInlineInput>;
    cm1erghed0m2a07vy1abi623t?: InputMaybe<SalesCampaignModelCreateManyInlineInput>;
    cm6kqiwog09ok07w0ejzh1vxj?: InputMaybe<SalesCampaignModelCreateManyInlineInput>;
    cm6kqjn2f09ow07w06ddv2xyd?: InputMaybe<SalesCampaignModelCreateManyInlineInput>;
    cm6kqkaw409p907w01i9z7zkn?: InputMaybe<SalesCampaignModelCreateManyInlineInput>;
    cm6kqtsi309s907w0bbr68zd4?: InputMaybe<SalesCampaignModelCreateManyInlineInput>;
    cm6kqv0c609si07w08o6achqe?: InputMaybe<SalesCampaignModelCreateManyInlineInput>;
    cmnwwrvuj0hep06te11dfgf02?: InputMaybe<SalesCampaignModelCreateManyInlineInput>;
    cmnwwub7o0hf006te5z2b20ea?: InputMaybe<SalesCampaignModelCreateManyInlineInput>;
    content: Scalars['RichTextAST']['input'];
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    fixedSign?: InputMaybe<Scalars['String']['input']>;
    kommentar?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FootnoteCreateManyInlineInput = {
    /** Connect multiple existing Footnote documents */
    connect?: InputMaybe<Array<FootnoteWhereUniqueInput>>;
    /** Create and connect multiple existing Footnote documents */
    create?: InputMaybe<Array<FootnoteCreateInput>>;
};

export type FootnoteCreateOneInlineInput = {
    /** Connect one existing Footnote document */
    connect?: InputMaybe<FootnoteWhereUniqueInput>;
    /** Create and connect one Footnote document */
    create?: InputMaybe<FootnoteCreateInput>;
};

/** An edge in a connection. */
export type FootnoteEdge = {
    __typename?: 'FootnoteEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Footnote;
};

/** Identifies documents */
export type FootnoteManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<FootnoteWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<FootnoteWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<FootnoteWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<FootnoteWhereStageInput>;
    documentInStages_none?: InputMaybe<FootnoteWhereStageInput>;
    documentInStages_some?: InputMaybe<FootnoteWhereStageInput>;
    fixedSign?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    fixedSign_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    fixedSign_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    fixedSign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    fixedSign_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    fixedSign_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    fixedSign_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    fixedSign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    fixedSign_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    fixedSign_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    kommentar?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    kommentar_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    kommentar_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    kommentar_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    kommentar_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    kommentar_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    kommentar_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    kommentar_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    kommentar_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    kommentar_starts_with?: InputMaybe<Scalars['String']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FootnoteOrderByInput {
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    FixedSignAsc = 'fixedSign_ASC',
    FixedSignDesc = 'fixedSign_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    KommentarAsc = 'kommentar_ASC',
    KommentarDesc = 'kommentar_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type FootnoteUpdateInput = {
    cm1era28v0lwm07vybmo03fbi?: InputMaybe<CampaignAfterSalesAccesoryUpdateManyInlineInput>;
    cm1erclo00lra07uqd7pmhedl?: InputMaybe<CampaignAfterSalesServiceUpdateManyInlineInput>;
    cm1erghed0m2a07vy1abi623t?: InputMaybe<SalesCampaignModelUpdateManyInlineInput>;
    cm6kqiwog09ok07w0ejzh1vxj?: InputMaybe<SalesCampaignModelUpdateManyInlineInput>;
    cm6kqjn2f09ow07w06ddv2xyd?: InputMaybe<SalesCampaignModelUpdateManyInlineInput>;
    cm6kqkaw409p907w01i9z7zkn?: InputMaybe<SalesCampaignModelUpdateManyInlineInput>;
    cm6kqtsi309s907w0bbr68zd4?: InputMaybe<SalesCampaignModelUpdateManyInlineInput>;
    cm6kqv0c609si07w08o6achqe?: InputMaybe<SalesCampaignModelUpdateManyInlineInput>;
    cmnwwrvuj0hep06te11dfgf02?: InputMaybe<SalesCampaignModelUpdateManyInlineInput>;
    cmnwwub7o0hf006te5z2b20ea?: InputMaybe<SalesCampaignModelUpdateManyInlineInput>;
    content?: InputMaybe<Scalars['RichTextAST']['input']>;
    fixedSign?: InputMaybe<Scalars['String']['input']>;
    kommentar?: InputMaybe<Scalars['String']['input']>;
};

export type FootnoteUpdateManyInlineInput = {
    /** Connect multiple existing Footnote documents */
    connect?: InputMaybe<Array<FootnoteConnectInput>>;
    /** Create and connect multiple Footnote documents */
    create?: InputMaybe<Array<FootnoteCreateInput>>;
    /** Delete multiple Footnote documents */
    delete?: InputMaybe<Array<FootnoteWhereUniqueInput>>;
    /** Disconnect multiple Footnote documents */
    disconnect?: InputMaybe<Array<FootnoteWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing Footnote documents */
    set?: InputMaybe<Array<FootnoteWhereUniqueInput>>;
    /** Update multiple Footnote documents */
    update?: InputMaybe<Array<FootnoteUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple Footnote documents */
    upsert?: InputMaybe<Array<FootnoteUpsertWithNestedWhereUniqueInput>>;
};

export type FootnoteUpdateManyInput = {
    content?: InputMaybe<Scalars['RichTextAST']['input']>;
    fixedSign?: InputMaybe<Scalars['String']['input']>;
    kommentar?: InputMaybe<Scalars['String']['input']>;
};

export type FootnoteUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: FootnoteUpdateManyInput;
    /** Document search */
    where: FootnoteWhereInput;
};

export type FootnoteUpdateOneInlineInput = {
    /** Connect existing Footnote document */
    connect?: InputMaybe<FootnoteWhereUniqueInput>;
    /** Create and connect one Footnote document */
    create?: InputMaybe<FootnoteCreateInput>;
    /** Delete currently connected Footnote document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected Footnote document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Footnote document */
    update?: InputMaybe<FootnoteUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Footnote document */
    upsert?: InputMaybe<FootnoteUpsertWithNestedWhereUniqueInput>;
};

export type FootnoteUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: FootnoteUpdateInput;
    /** Unique document search */
    where: FootnoteWhereUniqueInput;
};

export type FootnoteUpsertInput = {
    /** Create document if it didn't exist */
    create: FootnoteCreateInput;
    /** Update document if it exists */
    update: FootnoteUpdateInput;
};

export type FootnoteUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: FootnoteUpsertInput;
    /** Unique document search */
    where: FootnoteWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FootnoteWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FootnoteWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<FootnoteWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<FootnoteWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<FootnoteWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<FootnoteWhereStageInput>;
    documentInStages_none?: InputMaybe<FootnoteWhereStageInput>;
    documentInStages_some?: InputMaybe<FootnoteWhereStageInput>;
    fixedSign?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    fixedSign_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    fixedSign_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    fixedSign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    fixedSign_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    fixedSign_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    fixedSign_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    fixedSign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    fixedSign_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    fixedSign_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    kommentar?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    kommentar_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    kommentar_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    kommentar_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    kommentar_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    kommentar_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    kommentar_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    kommentar_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    kommentar_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    kommentar_starts_with?: InputMaybe<Scalars['String']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FootnoteWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<FootnoteWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<FootnoteWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<FootnoteWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<FootnoteWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References Footnote record uniquely */
export type FootnoteWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export enum FuelType {
    Electro = 'electro',
    Gasoline = 'gasoline',
    Hybrid = 'hybrid',
    Hydrogen = 'hydrogen',
}

export type GeneralService = Entity &
    Node & {
        __typename?: 'GeneralService';
        copy?: Maybe<Scalars['String']['output']>;
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Default */
        default: Scalars['Boolean']['output'];
        /** Get the document in other stages */
        documentInStages: Array<GeneralService>;
        headline: Scalars['String']['output'];
        /** List of GeneralService versions */
        history: Array<Version>;
        icon?: Maybe<Asset>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        image: Asset;
        link?: Maybe<Link>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        trackingName?: Maybe<Scalars['String']['output']>;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

export type GeneralServiceCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type GeneralServiceDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type GeneralServiceHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type GeneralServiceIconArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type GeneralServiceImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type GeneralServiceLinkArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type GeneralServicePublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type GeneralServiceScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type GeneralServiceUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type GeneralServiceConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: GeneralServiceWhereUniqueInput;
};

/** A connection to a list of items. */
export type GeneralServiceConnection = {
    __typename?: 'GeneralServiceConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<GeneralServiceEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type GeneralServiceCreateInput = {
    copy?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    default: Scalars['Boolean']['input'];
    headline: Scalars['String']['input'];
    icon?: InputMaybe<AssetCreateOneInlineInput>;
    image: AssetCreateOneInlineInput;
    link?: InputMaybe<LinkCreateOneInlineInput>;
    trackingName?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GeneralServiceCreateManyInlineInput = {
    /** Connect multiple existing GeneralService documents */
    connect?: InputMaybe<Array<GeneralServiceWhereUniqueInput>>;
    /** Create and connect multiple existing GeneralService documents */
    create?: InputMaybe<Array<GeneralServiceCreateInput>>;
};

export type GeneralServiceCreateOneInlineInput = {
    /** Connect one existing GeneralService document */
    connect?: InputMaybe<GeneralServiceWhereUniqueInput>;
    /** Create and connect one GeneralService document */
    create?: InputMaybe<GeneralServiceCreateInput>;
};

/** An edge in a connection. */
export type GeneralServiceEdge = {
    __typename?: 'GeneralServiceEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: GeneralService;
};

/** Identifies documents */
export type GeneralServiceManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<GeneralServiceWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<GeneralServiceWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<GeneralServiceWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    copy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    copy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    copy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    copy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    copy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    copy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    copy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    copy_starts_with?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    default?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    default_not?: InputMaybe<Scalars['Boolean']['input']>;
    documentInStages_every?: InputMaybe<GeneralServiceWhereStageInput>;
    documentInStages_none?: InputMaybe<GeneralServiceWhereStageInput>;
    documentInStages_some?: InputMaybe<GeneralServiceWhereStageInput>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    icon?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    link?: InputMaybe<LinkWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    trackingName?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    trackingName_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    trackingName_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    trackingName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    trackingName_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    trackingName_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    trackingName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    trackingName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    trackingName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    trackingName_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GeneralServiceOrderByInput {
    CopyAsc = 'copy_ASC',
    CopyDesc = 'copy_DESC',
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    DefaultAsc = 'default_ASC',
    DefaultDesc = 'default_DESC',
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    TrackingNameAsc = 'trackingName_ASC',
    TrackingNameDesc = 'trackingName_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type GeneralServiceUpdateInput = {
    copy?: InputMaybe<Scalars['String']['input']>;
    default?: InputMaybe<Scalars['Boolean']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    icon?: InputMaybe<AssetUpdateOneInlineInput>;
    image?: InputMaybe<AssetUpdateOneInlineInput>;
    link?: InputMaybe<LinkUpdateOneInlineInput>;
    trackingName?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralServiceUpdateManyInlineInput = {
    /** Connect multiple existing GeneralService documents */
    connect?: InputMaybe<Array<GeneralServiceConnectInput>>;
    /** Create and connect multiple GeneralService documents */
    create?: InputMaybe<Array<GeneralServiceCreateInput>>;
    /** Delete multiple GeneralService documents */
    delete?: InputMaybe<Array<GeneralServiceWhereUniqueInput>>;
    /** Disconnect multiple GeneralService documents */
    disconnect?: InputMaybe<Array<GeneralServiceWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing GeneralService documents */
    set?: InputMaybe<Array<GeneralServiceWhereUniqueInput>>;
    /** Update multiple GeneralService documents */
    update?: InputMaybe<Array<GeneralServiceUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple GeneralService documents */
    upsert?: InputMaybe<Array<GeneralServiceUpsertWithNestedWhereUniqueInput>>;
};

export type GeneralServiceUpdateManyInput = {
    copy?: InputMaybe<Scalars['String']['input']>;
    default?: InputMaybe<Scalars['Boolean']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    trackingName?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralServiceUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: GeneralServiceUpdateManyInput;
    /** Document search */
    where: GeneralServiceWhereInput;
};

export type GeneralServiceUpdateOneInlineInput = {
    /** Connect existing GeneralService document */
    connect?: InputMaybe<GeneralServiceWhereUniqueInput>;
    /** Create and connect one GeneralService document */
    create?: InputMaybe<GeneralServiceCreateInput>;
    /** Delete currently connected GeneralService document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected GeneralService document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single GeneralService document */
    update?: InputMaybe<GeneralServiceUpdateWithNestedWhereUniqueInput>;
    /** Upsert single GeneralService document */
    upsert?: InputMaybe<GeneralServiceUpsertWithNestedWhereUniqueInput>;
};

export type GeneralServiceUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: GeneralServiceUpdateInput;
    /** Unique document search */
    where: GeneralServiceWhereUniqueInput;
};

export type GeneralServiceUpsertInput = {
    /** Create document if it didn't exist */
    create: GeneralServiceCreateInput;
    /** Update document if it exists */
    update: GeneralServiceUpdateInput;
};

export type GeneralServiceUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: GeneralServiceUpsertInput;
    /** Unique document search */
    where: GeneralServiceWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GeneralServiceWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GeneralServiceWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<GeneralServiceWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<GeneralServiceWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<GeneralServiceWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    copy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    copy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    copy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    copy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    copy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    copy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    copy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    copy_starts_with?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    default?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    default_not?: InputMaybe<Scalars['Boolean']['input']>;
    documentInStages_every?: InputMaybe<GeneralServiceWhereStageInput>;
    documentInStages_none?: InputMaybe<GeneralServiceWhereStageInput>;
    documentInStages_some?: InputMaybe<GeneralServiceWhereStageInput>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    icon?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    link?: InputMaybe<LinkWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    trackingName?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    trackingName_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    trackingName_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    trackingName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    trackingName_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    trackingName_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    trackingName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    trackingName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    trackingName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    trackingName_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GeneralServiceWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<GeneralServiceWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<GeneralServiceWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<GeneralServiceWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<GeneralServiceWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References GeneralService record uniquely */
export type GeneralServiceWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type HeadlineText = Entity & {
    __typename?: 'HeadlineText';
    headline?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** System stage field */
    stage: Stage;
    text?: Maybe<Scalars['String']['output']>;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HeadlineTextConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: HeadlineTextWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeadlineTextConnection = {
    __typename?: 'HeadlineTextConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<HeadlineTextEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type HeadlineTextCreateInput = {
    headline?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HeadlineTextCreateManyInlineInput = {
    /** Create and connect multiple existing HeadlineText documents */
    create?: InputMaybe<Array<HeadlineTextCreateInput>>;
};

export type HeadlineTextCreateOneInlineInput = {
    /** Create and connect one HeadlineText document */
    create?: InputMaybe<HeadlineTextCreateInput>;
};

export type HeadlineTextCreateWithPositionInput = {
    /** Document to create */
    data: HeadlineTextCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type HeadlineTextEdge = {
    __typename?: 'HeadlineTextEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: HeadlineText;
};

/** Identifies documents */
export type HeadlineTextManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<HeadlineTextWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<HeadlineTextWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<HeadlineTextWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    text_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    text_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    text_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    text_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    text_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum HeadlineTextOrderByInput {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    TextAsc = 'text_ASC',
    TextDesc = 'text_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type HeadlineTextParent = OverlayBatteryCertificate;

export type HeadlineTextParentConnectInput = {
    OverlayBatteryCertificate?: InputMaybe<OverlayBatteryCertificateConnectInput>;
};

export type HeadlineTextParentCreateInput = {
    OverlayBatteryCertificate?: InputMaybe<OverlayBatteryCertificateCreateInput>;
};

export type HeadlineTextParentCreateManyInlineInput = {
    /** Connect multiple existing HeadlineTextParent documents */
    connect?: InputMaybe<Array<HeadlineTextParentWhereUniqueInput>>;
    /** Create and connect multiple existing HeadlineTextParent documents */
    create?: InputMaybe<Array<HeadlineTextParentCreateInput>>;
};

export type HeadlineTextParentCreateOneInlineInput = {
    /** Connect one existing HeadlineTextParent document */
    connect?: InputMaybe<HeadlineTextParentWhereUniqueInput>;
    /** Create and connect one HeadlineTextParent document */
    create?: InputMaybe<HeadlineTextParentCreateInput>;
};

export type HeadlineTextParentUpdateInput = {
    OverlayBatteryCertificate?: InputMaybe<OverlayBatteryCertificateUpdateInput>;
};

export type HeadlineTextParentUpdateManyInlineInput = {
    /** Connect multiple existing HeadlineTextParent documents */
    connect?: InputMaybe<Array<HeadlineTextParentConnectInput>>;
    /** Create and connect multiple HeadlineTextParent documents */
    create?: InputMaybe<Array<HeadlineTextParentCreateInput>>;
    /** Delete multiple HeadlineTextParent documents */
    delete?: InputMaybe<Array<HeadlineTextParentWhereUniqueInput>>;
    /** Disconnect multiple HeadlineTextParent documents */
    disconnect?: InputMaybe<Array<HeadlineTextParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing HeadlineTextParent documents */
    set?: InputMaybe<Array<HeadlineTextParentWhereUniqueInput>>;
    /** Update multiple HeadlineTextParent documents */
    update?: InputMaybe<Array<HeadlineTextParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple HeadlineTextParent documents */
    upsert?: InputMaybe<Array<HeadlineTextParentUpsertWithNestedWhereUniqueInput>>;
};

export type HeadlineTextParentUpdateManyWithNestedWhereInput = {
    OverlayBatteryCertificate?: InputMaybe<OverlayBatteryCertificateUpdateManyWithNestedWhereInput>;
};

export type HeadlineTextParentUpdateOneInlineInput = {
    /** Connect existing HeadlineTextParent document */
    connect?: InputMaybe<HeadlineTextParentWhereUniqueInput>;
    /** Create and connect one HeadlineTextParent document */
    create?: InputMaybe<HeadlineTextParentCreateInput>;
    /** Delete currently connected HeadlineTextParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected HeadlineTextParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single HeadlineTextParent document */
    update?: InputMaybe<HeadlineTextParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single HeadlineTextParent document */
    upsert?: InputMaybe<HeadlineTextParentUpsertWithNestedWhereUniqueInput>;
};

export type HeadlineTextParentUpdateWithNestedWhereUniqueInput = {
    OverlayBatteryCertificate?: InputMaybe<OverlayBatteryCertificateUpdateWithNestedWhereUniqueInput>;
};

export type HeadlineTextParentUpsertWithNestedWhereUniqueInput = {
    OverlayBatteryCertificate?: InputMaybe<OverlayBatteryCertificateUpsertWithNestedWhereUniqueInput>;
};

export type HeadlineTextParentWhereInput = {
    OverlayBatteryCertificate?: InputMaybe<OverlayBatteryCertificateWhereInput>;
};

export type HeadlineTextParentWhereUniqueInput = {
    OverlayBatteryCertificate?: InputMaybe<OverlayBatteryCertificateWhereUniqueInput>;
};

export type HeadlineTextUpdateInput = {
    headline?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export type HeadlineTextUpdateManyInlineInput = {
    /** Create and connect multiple HeadlineText component instances */
    create?: InputMaybe<Array<HeadlineTextCreateWithPositionInput>>;
    /** Delete multiple HeadlineText documents */
    delete?: InputMaybe<Array<HeadlineTextWhereUniqueInput>>;
    /** Update multiple HeadlineText component instances */
    update?: InputMaybe<Array<HeadlineTextUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple HeadlineText component instances */
    upsert?: InputMaybe<Array<HeadlineTextUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HeadlineTextUpdateManyInput = {
    headline?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export type HeadlineTextUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: HeadlineTextUpdateManyInput;
    /** Document search */
    where: HeadlineTextWhereInput;
};

export type HeadlineTextUpdateOneInlineInput = {
    /** Create and connect one HeadlineText document */
    create?: InputMaybe<HeadlineTextCreateInput>;
    /** Delete currently connected HeadlineText document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single HeadlineText document */
    update?: InputMaybe<HeadlineTextUpdateWithNestedWhereUniqueInput>;
    /** Upsert single HeadlineText document */
    upsert?: InputMaybe<HeadlineTextUpsertWithNestedWhereUniqueInput>;
};

export type HeadlineTextUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<HeadlineTextUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: HeadlineTextWhereUniqueInput;
};

export type HeadlineTextUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: HeadlineTextUpdateInput;
    /** Unique document search */
    where: HeadlineTextWhereUniqueInput;
};

export type HeadlineTextUpsertInput = {
    /** Create document if it didn't exist */
    create: HeadlineTextCreateInput;
    /** Update document if it exists */
    update: HeadlineTextUpdateInput;
};

export type HeadlineTextUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<HeadlineTextUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: HeadlineTextWhereUniqueInput;
};

export type HeadlineTextUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: HeadlineTextUpsertInput;
    /** Unique document search */
    where: HeadlineTextWhereUniqueInput;
};

/** Identifies documents */
export type HeadlineTextWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<HeadlineTextWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<HeadlineTextWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<HeadlineTextWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    text_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    text_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    text_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    text_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    text_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References HeadlineText record uniquely */
export type HeadlineTextWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type HomeTeaser = Entity &
    Node & {
        __typename?: 'HomeTeaser';
        businessCenter: Scalars['Boolean']['output'];
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        dealerType: DealerType;
        /** Get the document in other stages */
        documentInStages: Array<HomeTeaser>;
        hPromise: Scalars['Boolean']['output'];
        /** List of HomeTeaser versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        image: Asset;
        partsStore: Scalars['Boolean']['output'];
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        targetSlug: Scalars['String']['output'];
        text: Scalars['String']['output'];
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

export type HomeTeaserCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type HomeTeaserDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type HomeTeaserHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type HomeTeaserImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type HomeTeaserPublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type HomeTeaserScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type HomeTeaserUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type HomeTeaserConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: HomeTeaserWhereUniqueInput;
};

/** A connection to a list of items. */
export type HomeTeaserConnection = {
    __typename?: 'HomeTeaserConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<HomeTeaserEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type HomeTeaserCreateInput = {
    businessCenter: Scalars['Boolean']['input'];
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    dealerType: DealerType;
    hPromise: Scalars['Boolean']['input'];
    image: AssetCreateOneInlineInput;
    partsStore: Scalars['Boolean']['input'];
    targetSlug: Scalars['String']['input'];
    text: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HomeTeaserCreateManyInlineInput = {
    /** Connect multiple existing HomeTeaser documents */
    connect?: InputMaybe<Array<HomeTeaserWhereUniqueInput>>;
    /** Create and connect multiple existing HomeTeaser documents */
    create?: InputMaybe<Array<HomeTeaserCreateInput>>;
};

export type HomeTeaserCreateOneInlineInput = {
    /** Connect one existing HomeTeaser document */
    connect?: InputMaybe<HomeTeaserWhereUniqueInput>;
    /** Create and connect one HomeTeaser document */
    create?: InputMaybe<HomeTeaserCreateInput>;
};

/** An edge in a connection. */
export type HomeTeaserEdge = {
    __typename?: 'HomeTeaserEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: HomeTeaser;
};

/** Identifies documents */
export type HomeTeaserManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<HomeTeaserWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<HomeTeaserWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<HomeTeaserWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    businessCenter?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenter_not?: InputMaybe<Scalars['Boolean']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    dealerType?: InputMaybe<DealerType>;
    /** All values that are contained in given list. */
    dealerType_in?: InputMaybe<Array<InputMaybe<DealerType>>>;
    /** Any other value that exists and is not equal to the given value. */
    dealerType_not?: InputMaybe<DealerType>;
    /** All values that are not contained in given list. */
    dealerType_not_in?: InputMaybe<Array<InputMaybe<DealerType>>>;
    documentInStages_every?: InputMaybe<HomeTeaserWhereStageInput>;
    documentInStages_none?: InputMaybe<HomeTeaserWhereStageInput>;
    documentInStages_some?: InputMaybe<HomeTeaserWhereStageInput>;
    hPromise?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hPromise_not?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    partsStore?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    partsStore_not?: InputMaybe<Scalars['Boolean']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    targetSlug?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    targetSlug_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    targetSlug_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    targetSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    targetSlug_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    targetSlug_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    targetSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    targetSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    targetSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    targetSlug_starts_with?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    text_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    text_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    text_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    text_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    text_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum HomeTeaserOrderByInput {
    BusinessCenterAsc = 'businessCenter_ASC',
    BusinessCenterDesc = 'businessCenter_DESC',
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    DealerTypeAsc = 'dealerType_ASC',
    DealerTypeDesc = 'dealerType_DESC',
    HPromiseAsc = 'hPromise_ASC',
    HPromiseDesc = 'hPromise_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    PartsStoreAsc = 'partsStore_ASC',
    PartsStoreDesc = 'partsStore_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    TargetSlugAsc = 'targetSlug_ASC',
    TargetSlugDesc = 'targetSlug_DESC',
    TextAsc = 'text_ASC',
    TextDesc = 'text_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type HomeTeaserUpdateInput = {
    businessCenter?: InputMaybe<Scalars['Boolean']['input']>;
    dealerType?: InputMaybe<DealerType>;
    hPromise?: InputMaybe<Scalars['Boolean']['input']>;
    image?: InputMaybe<AssetUpdateOneInlineInput>;
    partsStore?: InputMaybe<Scalars['Boolean']['input']>;
    targetSlug?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export type HomeTeaserUpdateManyInlineInput = {
    /** Connect multiple existing HomeTeaser documents */
    connect?: InputMaybe<Array<HomeTeaserConnectInput>>;
    /** Create and connect multiple HomeTeaser documents */
    create?: InputMaybe<Array<HomeTeaserCreateInput>>;
    /** Delete multiple HomeTeaser documents */
    delete?: InputMaybe<Array<HomeTeaserWhereUniqueInput>>;
    /** Disconnect multiple HomeTeaser documents */
    disconnect?: InputMaybe<Array<HomeTeaserWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing HomeTeaser documents */
    set?: InputMaybe<Array<HomeTeaserWhereUniqueInput>>;
    /** Update multiple HomeTeaser documents */
    update?: InputMaybe<Array<HomeTeaserUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple HomeTeaser documents */
    upsert?: InputMaybe<Array<HomeTeaserUpsertWithNestedWhereUniqueInput>>;
};

export type HomeTeaserUpdateManyInput = {
    businessCenter?: InputMaybe<Scalars['Boolean']['input']>;
    dealerType?: InputMaybe<DealerType>;
    hPromise?: InputMaybe<Scalars['Boolean']['input']>;
    partsStore?: InputMaybe<Scalars['Boolean']['input']>;
    targetSlug?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export type HomeTeaserUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: HomeTeaserUpdateManyInput;
    /** Document search */
    where: HomeTeaserWhereInput;
};

export type HomeTeaserUpdateOneInlineInput = {
    /** Connect existing HomeTeaser document */
    connect?: InputMaybe<HomeTeaserWhereUniqueInput>;
    /** Create and connect one HomeTeaser document */
    create?: InputMaybe<HomeTeaserCreateInput>;
    /** Delete currently connected HomeTeaser document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected HomeTeaser document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single HomeTeaser document */
    update?: InputMaybe<HomeTeaserUpdateWithNestedWhereUniqueInput>;
    /** Upsert single HomeTeaser document */
    upsert?: InputMaybe<HomeTeaserUpsertWithNestedWhereUniqueInput>;
};

export type HomeTeaserUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: HomeTeaserUpdateInput;
    /** Unique document search */
    where: HomeTeaserWhereUniqueInput;
};

export type HomeTeaserUpsertInput = {
    /** Create document if it didn't exist */
    create: HomeTeaserCreateInput;
    /** Update document if it exists */
    update: HomeTeaserUpdateInput;
};

export type HomeTeaserUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: HomeTeaserUpsertInput;
    /** Unique document search */
    where: HomeTeaserWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HomeTeaserWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HomeTeaserWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<HomeTeaserWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<HomeTeaserWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<HomeTeaserWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    businessCenter?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenter_not?: InputMaybe<Scalars['Boolean']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    dealerType?: InputMaybe<DealerType>;
    /** All values that are contained in given list. */
    dealerType_in?: InputMaybe<Array<InputMaybe<DealerType>>>;
    /** Any other value that exists and is not equal to the given value. */
    dealerType_not?: InputMaybe<DealerType>;
    /** All values that are not contained in given list. */
    dealerType_not_in?: InputMaybe<Array<InputMaybe<DealerType>>>;
    documentInStages_every?: InputMaybe<HomeTeaserWhereStageInput>;
    documentInStages_none?: InputMaybe<HomeTeaserWhereStageInput>;
    documentInStages_some?: InputMaybe<HomeTeaserWhereStageInput>;
    hPromise?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    hPromise_not?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    partsStore?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    partsStore_not?: InputMaybe<Scalars['Boolean']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    targetSlug?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    targetSlug_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    targetSlug_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    targetSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    targetSlug_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    targetSlug_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    targetSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    targetSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    targetSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    targetSlug_starts_with?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    text_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    text_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    text_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    text_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    text_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HomeTeaserWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<HomeTeaserWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<HomeTeaserWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<HomeTeaserWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<HomeTeaserWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References HomeTeaser record uniquely */
export type HomeTeaserWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type IconText = Entity & {
    __typename?: 'IconText';
    /** Default */
    default: Scalars['Boolean']['output'];
    icon?: Maybe<Asset>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** System stage field */
    stage: Stage;
    text: Scalars['String']['output'];
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IconTextIconArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type IconTextConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: IconTextWhereUniqueInput;
};

/** A connection to a list of items. */
export type IconTextConnection = {
    __typename?: 'IconTextConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<IconTextEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type IconTextCreateInput = {
    default: Scalars['Boolean']['input'];
    icon?: InputMaybe<AssetCreateOneInlineInput>;
    text: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IconTextCreateManyInlineInput = {
    /** Create and connect multiple existing IconText documents */
    create?: InputMaybe<Array<IconTextCreateInput>>;
};

export type IconTextCreateOneInlineInput = {
    /** Create and connect one IconText document */
    create?: InputMaybe<IconTextCreateInput>;
};

export type IconTextCreateWithPositionInput = {
    /** Document to create */
    data: IconTextCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type IconTextEdge = {
    __typename?: 'IconTextEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: IconText;
};

/** Identifies documents */
export type IconTextManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<IconTextWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<IconTextWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<IconTextWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    default?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    default_not?: InputMaybe<Scalars['Boolean']['input']>;
    icon?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    text_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    text_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    text_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    text_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    text_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum IconTextOrderByInput {
    DefaultAsc = 'default_ASC',
    DefaultDesc = 'default_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    TextAsc = 'text_ASC',
    TextDesc = 'text_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type IconTextParent =
    | CampaignAfterSalesAccesory
    | CampaignAfterSalesService
    | PageAboutUs
    | PageBusinessCustomer
    | PageHyundaiPromise
    | PageService
    | Warranty;

export type IconTextParentConnectInput = {
    CampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryConnectInput>;
    CampaignAfterSalesService?: InputMaybe<CampaignAfterSalesServiceConnectInput>;
    PageAboutUs?: InputMaybe<PageAboutUsConnectInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerConnectInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseConnectInput>;
    PageService?: InputMaybe<PageServiceConnectInput>;
    Warranty?: InputMaybe<WarrantyConnectInput>;
};

export type IconTextParentCreateInput = {
    CampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryCreateInput>;
    CampaignAfterSalesService?: InputMaybe<CampaignAfterSalesServiceCreateInput>;
    PageAboutUs?: InputMaybe<PageAboutUsCreateInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerCreateInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseCreateInput>;
    PageService?: InputMaybe<PageServiceCreateInput>;
    Warranty?: InputMaybe<WarrantyCreateInput>;
};

export type IconTextParentCreateManyInlineInput = {
    /** Connect multiple existing IconTextParent documents */
    connect?: InputMaybe<Array<IconTextParentWhereUniqueInput>>;
    /** Create and connect multiple existing IconTextParent documents */
    create?: InputMaybe<Array<IconTextParentCreateInput>>;
};

export type IconTextParentCreateOneInlineInput = {
    /** Connect one existing IconTextParent document */
    connect?: InputMaybe<IconTextParentWhereUniqueInput>;
    /** Create and connect one IconTextParent document */
    create?: InputMaybe<IconTextParentCreateInput>;
};

export type IconTextParentUpdateInput = {
    CampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryUpdateInput>;
    CampaignAfterSalesService?: InputMaybe<CampaignAfterSalesServiceUpdateInput>;
    PageAboutUs?: InputMaybe<PageAboutUsUpdateInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerUpdateInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseUpdateInput>;
    PageService?: InputMaybe<PageServiceUpdateInput>;
    Warranty?: InputMaybe<WarrantyUpdateInput>;
};

export type IconTextParentUpdateManyInlineInput = {
    /** Connect multiple existing IconTextParent documents */
    connect?: InputMaybe<Array<IconTextParentConnectInput>>;
    /** Create and connect multiple IconTextParent documents */
    create?: InputMaybe<Array<IconTextParentCreateInput>>;
    /** Delete multiple IconTextParent documents */
    delete?: InputMaybe<Array<IconTextParentWhereUniqueInput>>;
    /** Disconnect multiple IconTextParent documents */
    disconnect?: InputMaybe<Array<IconTextParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing IconTextParent documents */
    set?: InputMaybe<Array<IconTextParentWhereUniqueInput>>;
    /** Update multiple IconTextParent documents */
    update?: InputMaybe<Array<IconTextParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple IconTextParent documents */
    upsert?: InputMaybe<Array<IconTextParentUpsertWithNestedWhereUniqueInput>>;
};

export type IconTextParentUpdateManyWithNestedWhereInput = {
    CampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryUpdateManyWithNestedWhereInput>;
    CampaignAfterSalesService?: InputMaybe<CampaignAfterSalesServiceUpdateManyWithNestedWhereInput>;
    PageAboutUs?: InputMaybe<PageAboutUsUpdateManyWithNestedWhereInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerUpdateManyWithNestedWhereInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseUpdateManyWithNestedWhereInput>;
    PageService?: InputMaybe<PageServiceUpdateManyWithNestedWhereInput>;
    Warranty?: InputMaybe<WarrantyUpdateManyWithNestedWhereInput>;
};

export type IconTextParentUpdateOneInlineInput = {
    /** Connect existing IconTextParent document */
    connect?: InputMaybe<IconTextParentWhereUniqueInput>;
    /** Create and connect one IconTextParent document */
    create?: InputMaybe<IconTextParentCreateInput>;
    /** Delete currently connected IconTextParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected IconTextParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single IconTextParent document */
    update?: InputMaybe<IconTextParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single IconTextParent document */
    upsert?: InputMaybe<IconTextParentUpsertWithNestedWhereUniqueInput>;
};

export type IconTextParentUpdateWithNestedWhereUniqueInput = {
    CampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryUpdateWithNestedWhereUniqueInput>;
    CampaignAfterSalesService?: InputMaybe<CampaignAfterSalesServiceUpdateWithNestedWhereUniqueInput>;
    PageAboutUs?: InputMaybe<PageAboutUsUpdateWithNestedWhereUniqueInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerUpdateWithNestedWhereUniqueInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseUpdateWithNestedWhereUniqueInput>;
    PageService?: InputMaybe<PageServiceUpdateWithNestedWhereUniqueInput>;
    Warranty?: InputMaybe<WarrantyUpdateWithNestedWhereUniqueInput>;
};

export type IconTextParentUpsertWithNestedWhereUniqueInput = {
    CampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryUpsertWithNestedWhereUniqueInput>;
    CampaignAfterSalesService?: InputMaybe<CampaignAfterSalesServiceUpsertWithNestedWhereUniqueInput>;
    PageAboutUs?: InputMaybe<PageAboutUsUpsertWithNestedWhereUniqueInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerUpsertWithNestedWhereUniqueInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseUpsertWithNestedWhereUniqueInput>;
    PageService?: InputMaybe<PageServiceUpsertWithNestedWhereUniqueInput>;
    Warranty?: InputMaybe<WarrantyUpsertWithNestedWhereUniqueInput>;
};

export type IconTextParentWhereInput = {
    CampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryWhereInput>;
    CampaignAfterSalesService?: InputMaybe<CampaignAfterSalesServiceWhereInput>;
    PageAboutUs?: InputMaybe<PageAboutUsWhereInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerWhereInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseWhereInput>;
    PageService?: InputMaybe<PageServiceWhereInput>;
    Warranty?: InputMaybe<WarrantyWhereInput>;
};

export type IconTextParentWhereUniqueInput = {
    CampaignAfterSalesAccesory?: InputMaybe<CampaignAfterSalesAccesoryWhereUniqueInput>;
    CampaignAfterSalesService?: InputMaybe<CampaignAfterSalesServiceWhereUniqueInput>;
    PageAboutUs?: InputMaybe<PageAboutUsWhereUniqueInput>;
    PageBusinessCustomer?: InputMaybe<PageBusinessCustomerWhereUniqueInput>;
    PageHyundaiPromise?: InputMaybe<PageHyundaiPromiseWhereUniqueInput>;
    PageService?: InputMaybe<PageServiceWhereUniqueInput>;
    Warranty?: InputMaybe<WarrantyWhereUniqueInput>;
};

export type IconTextUpdateInput = {
    default?: InputMaybe<Scalars['Boolean']['input']>;
    icon?: InputMaybe<AssetUpdateOneInlineInput>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export type IconTextUpdateManyInlineInput = {
    /** Create and connect multiple IconText component instances */
    create?: InputMaybe<Array<IconTextCreateWithPositionInput>>;
    /** Delete multiple IconText documents */
    delete?: InputMaybe<Array<IconTextWhereUniqueInput>>;
    /** Update multiple IconText component instances */
    update?: InputMaybe<Array<IconTextUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple IconText component instances */
    upsert?: InputMaybe<Array<IconTextUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type IconTextUpdateManyInput = {
    default?: InputMaybe<Scalars['Boolean']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export type IconTextUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: IconTextUpdateManyInput;
    /** Document search */
    where: IconTextWhereInput;
};

export type IconTextUpdateOneInlineInput = {
    /** Create and connect one IconText document */
    create?: InputMaybe<IconTextCreateInput>;
    /** Delete currently connected IconText document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single IconText document */
    update?: InputMaybe<IconTextUpdateWithNestedWhereUniqueInput>;
    /** Upsert single IconText document */
    upsert?: InputMaybe<IconTextUpsertWithNestedWhereUniqueInput>;
};

export type IconTextUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<IconTextUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: IconTextWhereUniqueInput;
};

export type IconTextUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: IconTextUpdateInput;
    /** Unique document search */
    where: IconTextWhereUniqueInput;
};

export type IconTextUpsertInput = {
    /** Create document if it didn't exist */
    create: IconTextCreateInput;
    /** Update document if it exists */
    update: IconTextUpdateInput;
};

export type IconTextUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<IconTextUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: IconTextWhereUniqueInput;
};

export type IconTextUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: IconTextUpsertInput;
    /** Unique document search */
    where: IconTextWhereUniqueInput;
};

/** Identifies documents */
export type IconTextWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<IconTextWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<IconTextWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<IconTextWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    default?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    default_not?: InputMaybe<Scalars['Boolean']['input']>;
    icon?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    text_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    text_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    text_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    text_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    text_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References IconText record uniquely */
export type IconTextWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type ImageBlurInput = {
    /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
    amount: Scalars['Int']['input'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
    /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
    background: Scalars['String']['input'];
    /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
    color: Scalars['String']['input'];
    /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
    width: Scalars['Int']['input'];
};

export type ImageCompressInput = {
    /** Preserves the metadata of the image. */
    metadata: Scalars['Boolean']['input'];
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
    /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
    height: Scalars['Int']['input'];
    /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
    width: Scalars['Int']['input'];
    /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
    x: Scalars['Int']['input'];
    /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
    y: Scalars['Int']['input'];
};

export enum ImageFit {
    /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
    Clip = 'clip',
    /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
    Crop = 'crop',
    /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
    Max = 'max',
    /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
    Scale = 'scale',
}

export type ImageQualityInput = {
    /** The quality of the image. The value must be an integer from 1 to 100. */
    value: Scalars['Int']['input'];
};

export type ImageResizeInput = {
    /** The default value for the fit parameter is fit:clip. */
    fit?: InputMaybe<ImageFit>;
    /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
    height?: InputMaybe<Scalars['Int']['input']>;
    /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
    width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSharpenInput = {
    /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
    amount: Scalars['Int']['input'];
};

/** Transformations for Images */
export type ImageTransformationInput = {
    /** Blurs the image. */
    blur?: InputMaybe<ImageBlurInput>;
    /** Adds a border to the image. */
    border?: InputMaybe<ImageBorderInput>;
    /** Compresses the image. */
    compress?: InputMaybe<ImageCompressInput>;
    /** Crops the image to the specified dimensions. */
    crop?: InputMaybe<ImageCropInput>;
    /**
     * Changes the quality of the image. The value must be an integer from 1 to 100.
     * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
     */
    quality?: InputMaybe<ImageQualityInput>;
    /** Resizes the image */
    resize?: InputMaybe<ImageResizeInput>;
    /** Sharpens the image. */
    sharpen?: InputMaybe<ImageSharpenInput>;
};

export type KeyFact = Entity & {
    __typename?: 'KeyFact';
    /** The unique identifier */
    id: Scalars['ID']['output'];
    label: Scalars['String']['output'];
    /** System stage field */
    stage: Stage;
    unit: Scalars['String']['output'];
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
    value: Scalars['String']['output'];
};

export type KeyFactConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: KeyFactWhereUniqueInput;
};

/** A connection to a list of items. */
export type KeyFactConnection = {
    __typename?: 'KeyFactConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<KeyFactEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type KeyFactCreateInput = {
    label: Scalars['String']['input'];
    unit: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    value: Scalars['String']['input'];
};

export type KeyFactCreateManyInlineInput = {
    /** Create and connect multiple existing KeyFact documents */
    create?: InputMaybe<Array<KeyFactCreateInput>>;
};

export type KeyFactCreateOneInlineInput = {
    /** Create and connect one KeyFact document */
    create?: InputMaybe<KeyFactCreateInput>;
};

export type KeyFactCreateWithPositionInput = {
    /** Document to create */
    data: KeyFactCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type KeyFactEdge = {
    __typename?: 'KeyFactEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: KeyFact;
};

/** Identifies documents */
export type KeyFactManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<KeyFactWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<KeyFactWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<KeyFactWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    label?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    label_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    label_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    label_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    label_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    label_starts_with?: InputMaybe<Scalars['String']['input']>;
    unit?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    unit_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    unit_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    unit_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    unit_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    unit_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    unit_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    unit_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    unit_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    unit_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    value?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    value_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    value_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    value_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    value_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum KeyFactOrderByInput {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    LabelAsc = 'label_ASC',
    LabelDesc = 'label_DESC',
    UnitAsc = 'unit_ASC',
    UnitDesc = 'unit_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
    ValueAsc = 'value_ASC',
    ValueDesc = 'value_DESC',
}

export type KeyFactParent = Model | SalesCampaignModel;

export type KeyFactParentConnectInput = {
    Model?: InputMaybe<ModelConnectInput>;
    SalesCampaignModel?: InputMaybe<SalesCampaignModelConnectInput>;
};

export type KeyFactParentCreateInput = {
    Model?: InputMaybe<ModelCreateInput>;
    SalesCampaignModel?: InputMaybe<SalesCampaignModelCreateInput>;
};

export type KeyFactParentCreateManyInlineInput = {
    /** Connect multiple existing KeyFactParent documents */
    connect?: InputMaybe<Array<KeyFactParentWhereUniqueInput>>;
    /** Create and connect multiple existing KeyFactParent documents */
    create?: InputMaybe<Array<KeyFactParentCreateInput>>;
};

export type KeyFactParentCreateOneInlineInput = {
    /** Connect one existing KeyFactParent document */
    connect?: InputMaybe<KeyFactParentWhereUniqueInput>;
    /** Create and connect one KeyFactParent document */
    create?: InputMaybe<KeyFactParentCreateInput>;
};

export type KeyFactParentUpdateInput = {
    Model?: InputMaybe<ModelUpdateInput>;
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateInput>;
};

export type KeyFactParentUpdateManyInlineInput = {
    /** Connect multiple existing KeyFactParent documents */
    connect?: InputMaybe<Array<KeyFactParentConnectInput>>;
    /** Create and connect multiple KeyFactParent documents */
    create?: InputMaybe<Array<KeyFactParentCreateInput>>;
    /** Delete multiple KeyFactParent documents */
    delete?: InputMaybe<Array<KeyFactParentWhereUniqueInput>>;
    /** Disconnect multiple KeyFactParent documents */
    disconnect?: InputMaybe<Array<KeyFactParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing KeyFactParent documents */
    set?: InputMaybe<Array<KeyFactParentWhereUniqueInput>>;
    /** Update multiple KeyFactParent documents */
    update?: InputMaybe<Array<KeyFactParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple KeyFactParent documents */
    upsert?: InputMaybe<Array<KeyFactParentUpsertWithNestedWhereUniqueInput>>;
};

export type KeyFactParentUpdateManyWithNestedWhereInput = {
    Model?: InputMaybe<ModelUpdateManyWithNestedWhereInput>;
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateManyWithNestedWhereInput>;
};

export type KeyFactParentUpdateOneInlineInput = {
    /** Connect existing KeyFactParent document */
    connect?: InputMaybe<KeyFactParentWhereUniqueInput>;
    /** Create and connect one KeyFactParent document */
    create?: InputMaybe<KeyFactParentCreateInput>;
    /** Delete currently connected KeyFactParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected KeyFactParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single KeyFactParent document */
    update?: InputMaybe<KeyFactParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single KeyFactParent document */
    upsert?: InputMaybe<KeyFactParentUpsertWithNestedWhereUniqueInput>;
};

export type KeyFactParentUpdateWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpdateWithNestedWhereUniqueInput>;
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateWithNestedWhereUniqueInput>;
};

export type KeyFactParentUpsertWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpsertWithNestedWhereUniqueInput>;
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpsertWithNestedWhereUniqueInput>;
};

export type KeyFactParentWhereInput = {
    Model?: InputMaybe<ModelWhereInput>;
    SalesCampaignModel?: InputMaybe<SalesCampaignModelWhereInput>;
};

export type KeyFactParentWhereUniqueInput = {
    Model?: InputMaybe<ModelWhereUniqueInput>;
    SalesCampaignModel?: InputMaybe<SalesCampaignModelWhereUniqueInput>;
};

export type KeyFactUpdateInput = {
    label?: InputMaybe<Scalars['String']['input']>;
    unit?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
};

export type KeyFactUpdateManyInlineInput = {
    /** Create and connect multiple KeyFact component instances */
    create?: InputMaybe<Array<KeyFactCreateWithPositionInput>>;
    /** Delete multiple KeyFact documents */
    delete?: InputMaybe<Array<KeyFactWhereUniqueInput>>;
    /** Update multiple KeyFact component instances */
    update?: InputMaybe<Array<KeyFactUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple KeyFact component instances */
    upsert?: InputMaybe<Array<KeyFactUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type KeyFactUpdateManyInput = {
    label?: InputMaybe<Scalars['String']['input']>;
    unit?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
};

export type KeyFactUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: KeyFactUpdateManyInput;
    /** Document search */
    where: KeyFactWhereInput;
};

export type KeyFactUpdateOneInlineInput = {
    /** Create and connect one KeyFact document */
    create?: InputMaybe<KeyFactCreateInput>;
    /** Delete currently connected KeyFact document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single KeyFact document */
    update?: InputMaybe<KeyFactUpdateWithNestedWhereUniqueInput>;
    /** Upsert single KeyFact document */
    upsert?: InputMaybe<KeyFactUpsertWithNestedWhereUniqueInput>;
};

export type KeyFactUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<KeyFactUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: KeyFactWhereUniqueInput;
};

export type KeyFactUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: KeyFactUpdateInput;
    /** Unique document search */
    where: KeyFactWhereUniqueInput;
};

export type KeyFactUpsertInput = {
    /** Create document if it didn't exist */
    create: KeyFactCreateInput;
    /** Update document if it exists */
    update: KeyFactUpdateInput;
};

export type KeyFactUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<KeyFactUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: KeyFactWhereUniqueInput;
};

export type KeyFactUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: KeyFactUpsertInput;
    /** Unique document search */
    where: KeyFactWhereUniqueInput;
};

/** Identifies documents */
export type KeyFactWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<KeyFactWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<KeyFactWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<KeyFactWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    label?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    label_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    label_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    label_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    label_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    label_starts_with?: InputMaybe<Scalars['String']['input']>;
    unit?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    unit_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    unit_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    unit_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    unit_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    unit_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    unit_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    unit_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    unit_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    unit_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    value?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    value_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    value_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    value_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    value_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References KeyFact record uniquely */
export type KeyFactWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type Link = Entity & {
    __typename?: 'Link';
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** System stage field */
    stage: Stage;
    title: Scalars['String']['output'];
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
    url: Scalars['String']['output'];
};

export type LinkConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: LinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type LinkConnection = {
    __typename?: 'LinkConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<LinkEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type LinkCreateInput = {
    title: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    url: Scalars['String']['input'];
};

export type LinkCreateManyInlineInput = {
    /** Create and connect multiple existing Link documents */
    create?: InputMaybe<Array<LinkCreateInput>>;
};

export type LinkCreateOneInlineInput = {
    /** Create and connect one Link document */
    create?: InputMaybe<LinkCreateInput>;
};

export type LinkCreateWithPositionInput = {
    /** Document to create */
    data: LinkCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type LinkEdge = {
    __typename?: 'LinkEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Link;
};

/** Identifies documents */
export type LinkManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<LinkWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<LinkWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<LinkWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    title_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    title_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    title_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    title_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    url?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    url_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    url_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    url_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    url_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum LinkOrderByInput {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
    UrlAsc = 'url_ASC',
    UrlDesc = 'url_DESC',
}

export type LinkParent = GeneralService;

export type LinkParentConnectInput = {
    GeneralService?: InputMaybe<GeneralServiceConnectInput>;
};

export type LinkParentCreateInput = {
    GeneralService?: InputMaybe<GeneralServiceCreateInput>;
};

export type LinkParentCreateManyInlineInput = {
    /** Connect multiple existing LinkParent documents */
    connect?: InputMaybe<Array<LinkParentWhereUniqueInput>>;
    /** Create and connect multiple existing LinkParent documents */
    create?: InputMaybe<Array<LinkParentCreateInput>>;
};

export type LinkParentCreateOneInlineInput = {
    /** Connect one existing LinkParent document */
    connect?: InputMaybe<LinkParentWhereUniqueInput>;
    /** Create and connect one LinkParent document */
    create?: InputMaybe<LinkParentCreateInput>;
};

export type LinkParentUpdateInput = {
    GeneralService?: InputMaybe<GeneralServiceUpdateInput>;
};

export type LinkParentUpdateManyInlineInput = {
    /** Connect multiple existing LinkParent documents */
    connect?: InputMaybe<Array<LinkParentConnectInput>>;
    /** Create and connect multiple LinkParent documents */
    create?: InputMaybe<Array<LinkParentCreateInput>>;
    /** Delete multiple LinkParent documents */
    delete?: InputMaybe<Array<LinkParentWhereUniqueInput>>;
    /** Disconnect multiple LinkParent documents */
    disconnect?: InputMaybe<Array<LinkParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing LinkParent documents */
    set?: InputMaybe<Array<LinkParentWhereUniqueInput>>;
    /** Update multiple LinkParent documents */
    update?: InputMaybe<Array<LinkParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple LinkParent documents */
    upsert?: InputMaybe<Array<LinkParentUpsertWithNestedWhereUniqueInput>>;
};

export type LinkParentUpdateManyWithNestedWhereInput = {
    GeneralService?: InputMaybe<GeneralServiceUpdateManyWithNestedWhereInput>;
};

export type LinkParentUpdateOneInlineInput = {
    /** Connect existing LinkParent document */
    connect?: InputMaybe<LinkParentWhereUniqueInput>;
    /** Create and connect one LinkParent document */
    create?: InputMaybe<LinkParentCreateInput>;
    /** Delete currently connected LinkParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected LinkParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single LinkParent document */
    update?: InputMaybe<LinkParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single LinkParent document */
    upsert?: InputMaybe<LinkParentUpsertWithNestedWhereUniqueInput>;
};

export type LinkParentUpdateWithNestedWhereUniqueInput = {
    GeneralService?: InputMaybe<GeneralServiceUpdateWithNestedWhereUniqueInput>;
};

export type LinkParentUpsertWithNestedWhereUniqueInput = {
    GeneralService?: InputMaybe<GeneralServiceUpsertWithNestedWhereUniqueInput>;
};

export type LinkParentWhereInput = {
    GeneralService?: InputMaybe<GeneralServiceWhereInput>;
};

export type LinkParentWhereUniqueInput = {
    GeneralService?: InputMaybe<GeneralServiceWhereUniqueInput>;
};

export type LinkUpdateInput = {
    title?: InputMaybe<Scalars['String']['input']>;
    url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkUpdateManyInlineInput = {
    /** Create and connect multiple Link component instances */
    create?: InputMaybe<Array<LinkCreateWithPositionInput>>;
    /** Delete multiple Link documents */
    delete?: InputMaybe<Array<LinkWhereUniqueInput>>;
    /** Update multiple Link component instances */
    update?: InputMaybe<Array<LinkUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple Link component instances */
    upsert?: InputMaybe<Array<LinkUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type LinkUpdateManyInput = {
    title?: InputMaybe<Scalars['String']['input']>;
    url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: LinkUpdateManyInput;
    /** Document search */
    where: LinkWhereInput;
};

export type LinkUpdateOneInlineInput = {
    /** Create and connect one Link document */
    create?: InputMaybe<LinkCreateInput>;
    /** Delete currently connected Link document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Link document */
    update?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Link document */
    upsert?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type LinkUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<LinkUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: LinkWhereUniqueInput;
};

export type LinkUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: LinkUpdateInput;
    /** Unique document search */
    where: LinkWhereUniqueInput;
};

export type LinkUpsertInput = {
    /** Create document if it didn't exist */
    create: LinkCreateInput;
    /** Update document if it exists */
    update: LinkUpdateInput;
};

export type LinkUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<LinkUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: LinkWhereUniqueInput;
};

export type LinkUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: LinkUpsertInput;
    /** Unique document search */
    where: LinkWhereUniqueInput;
};

/** Identifies documents */
export type LinkWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<LinkWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<LinkWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<LinkWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    title_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    title_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    title_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    title_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    url?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    url_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    url_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    url_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    url_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References Link record uniquely */
export type LinkWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

/** Locale system enumeration */
export enum Locale {
    /** System locale */
    DeDe = 'de_DE',
}

/** Representing a geolocation point with latitude and longitude */
export type Location = {
    __typename?: 'Location';
    distance: Scalars['Float']['output'];
    latitude: Scalars['Float']['output'];
    longitude: Scalars['Float']['output'];
};

/** Representing a geolocation point with latitude and longitude */
export type LocationDistanceArgs = {
    from: LocationInput;
};

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
    latitude: Scalars['Float']['input'];
    longitude: Scalars['Float']['input'];
};

export type Model = Entity &
    Node & {
        __typename?: 'Model';
        alternativeEnvkvVehicle?: Maybe<Vehicle>;
        /**
         * ID20 - Alternativer Modelname für die Modellpage; Standard: Den neuen Hyundai [Modellname]
         * Wird auf Modellpage zu "Den neuen Hyundai [Modellname] probefahren" bzw. "Jetzt Angebot für den neuen Hyundai [Modellname] anfragen."
         */
        alternativeModelDetailName?: Maybe<Scalars['String']['output']>;
        /**
         * ID20 - "Der neue [Modellname]"
         * Alternative Modelname der in der Liste der Modelle angezeigt werden soll. (Standardmäßig wird der name genutzt )
         */
        alternativerModelListName?: Maybe<Scalars['String']['output']>;
        campaigns: Array<Campaign>;
        /** ID40 */
        categories: Array<ModelCategory>;
        /** ID140 */
        co2Class: Scalars['String']['output'];
        /** ID120 */
        contentCopy?: Maybe<RichText>;
        /** ID110 */
        contentHeadline?: Maybe<Scalars['String']['output']>;
        /** ID90 */
        contentImages: Array<Asset>;
        /** ID100 */
        contentImagesCaption?: Maybe<Scalars['String']['output']>;
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        cwModelUrl?: Maybe<Scalars['String']['output']>;
        /** ID160 */
        disableTestdrive?: Maybe<Scalars['Boolean']['output']>;
        /** Get the document in other stages */
        documentInStages: Array<Model>;
        /** ID140 */
        envkv?: Maybe<ModelenvkvUnion>;
        faq?: Maybe<Faq>;
        /** Keine Funktion. Hier kann XXX eingetragen werden. */
        formBodyId: Scalars['String']['output'];
        /** Keine Funktion. Hier kann XXX eingetragen werden. */
        formGenerationId: Scalars['String']['output'];
        /** Dient als Modellname-Parameter bei der Weitergabe in das Lead-Formular auf hyundai.de - falls abweichend vom Slug (ID30) */
        formIdentifier?: Maybe<Scalars['String']['output']>;
        /** Keine Funktion. Hier kann XXX eingetragen werden. */
        formModelId: Scalars['String']['output'];
        /** ID60 */
        heroImage: Asset;
        /** ID70 */
        heroImageCaption?: Maybe<Scalars['String']['output']>;
        /**
         * ID60a - Video für Header auf Modelpage
         * Anleitung: Videodatei muss unter "Assets" in HG hochgeladen werden. Unter "Edit Asset" kann die URL der hochgeladenene Videodatei kopiert werden, die hier im Feld übernommen werden kann. Pro Modellpage entweder ein Bild-Asset oder ein Video möglich.
         */
        heroVideoUrl?: Maybe<Scalars['String']['output']>;
        /** List of Model versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        /** ID50 - png oder anderes Format mit transp. Background */
        image: Asset;
        /** ID130 */
        keyFacts: Array<KeyFact>;
        leasingHeadline?: Maybe<Scalars['String']['output']>;
        leasingSubheadline?: Maybe<Scalars['String']['output']>;
        legalTexts?: Maybe<RichText>;
        /** ID80 */
        logoImages: Array<Asset>;
        /** Keine Funktion! */
        mobileId: Scalars['String']['output'];
        /** Kampagne für die Modellankündigung */
        modelAnnouncementCampaign?: Maybe<Campaign>;
        modelCode?: Maybe<Scalars['String']['output']>;
        /** Keine Funktion */
        msrLink?: Maybe<Scalars['String']['output']>;
        /**
         * ID10
         * (Eingabe ohne "Hyundai")
         */
        name: Scalars['String']['output'];
        /**
         * ID150
         * Reihenfolge in der die Modelle in der Modellübersicht angezeigt werden soll
         */
        order?: Maybe<Scalars['Int']['output']>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** ID30 */
        slug: Scalars['String']['output'];
        /** System stage field */
        stage: Stage;
        /** Freitextfeld für Gesamtangabe des Modell-Namen + PKWEnVKV-Angaben mit Range-Werten */
        trimAndEnvkvString?: Maybe<Scalars['String']['output']>;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
        /** WICHTIG! Modellname muss exakt der Schreibweise aus Mobile.de entsprechen! */
        vehicleMarketFilterParams?: Maybe<Scalars['String']['output']>;
        vehicles: Array<Vehicle>;
    };

export type ModelAlternativeEnvkvVehicleArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type ModelCampaignsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<CampaignOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CampaignWhereInput>;
};

export type ModelContentImagesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<AssetOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AssetWhereInput>;
};

export type ModelCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type ModelDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type ModelEnvkvArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type ModelFaqArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type ModelHeroImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ModelHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type ModelImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ModelKeyFactsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<KeyFactOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<KeyFactWhereInput>;
};

export type ModelLogoImagesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<AssetOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AssetWhereInput>;
};

export type ModelModelAnnouncementCampaignArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type ModelPublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type ModelScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type ModelUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type ModelVehiclesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<VehicleOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<VehicleWhereInput>;
};

export enum ModelCategory {
    Elektro = 'Elektro',
    Klein = 'Klein',
    Kompakt = 'Kompakt',
    Suv = 'SUV',
    Sport = 'Sport',
    Van = 'Van',
}

export type ModelConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: ModelWhereUniqueInput;
};

/** A connection to a list of items. */
export type ModelConnection = {
    __typename?: 'ModelConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<ModelEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type ModelCreateInput = {
    alternativeEnvkvVehicle?: InputMaybe<VehicleCreateOneInlineInput>;
    alternativeModelDetailName?: InputMaybe<Scalars['String']['input']>;
    alternativerModelListName?: InputMaybe<Scalars['String']['input']>;
    campaigns?: InputMaybe<CampaignCreateManyInlineInput>;
    categories?: InputMaybe<Array<ModelCategory>>;
    clwgbyzjx01q406w4dk4r2ywo?: InputMaybe<VertriebPrivateContentCreateManyInlineInput>;
    clwgfocju06au06w4at7s2jz0?: InputMaybe<VertriebBusinessContentCreateManyInlineInput>;
    clxd4pc5203lk07wb6wov2a60?: InputMaybe<ModellAnkuendigungContentCreateManyInlineInput>;
    cmlv2moc806su07vzaeiub9rt?: InputMaybe<SalesCampaignModelCreateManyInlineInput>;
    co2Class: Scalars['String']['input'];
    contentCopy?: InputMaybe<Scalars['RichTextAST']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    contentImages?: InputMaybe<AssetCreateManyInlineInput>;
    contentImagesCaption?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    cwModelUrl?: InputMaybe<Scalars['String']['input']>;
    disableTestdrive?: InputMaybe<Scalars['Boolean']['input']>;
    envkv?: InputMaybe<ModelenvkvUnionCreateOneInlineInput>;
    faq?: InputMaybe<FaqCreateOneInlineInput>;
    formBodyId: Scalars['String']['input'];
    formGenerationId: Scalars['String']['input'];
    formIdentifier?: InputMaybe<Scalars['String']['input']>;
    formModelId: Scalars['String']['input'];
    heroImage: AssetCreateOneInlineInput;
    heroImageCaption?: InputMaybe<Scalars['String']['input']>;
    heroVideoUrl?: InputMaybe<Scalars['String']['input']>;
    image: AssetCreateOneInlineInput;
    keyFacts?: InputMaybe<KeyFactCreateManyInlineInput>;
    leasingHeadline?: InputMaybe<Scalars['String']['input']>;
    leasingSubheadline?: InputMaybe<Scalars['String']['input']>;
    legalTexts?: InputMaybe<Scalars['RichTextAST']['input']>;
    logoImages?: InputMaybe<AssetCreateManyInlineInput>;
    mobileId: Scalars['String']['input'];
    modelAnnouncementCampaign?: InputMaybe<CampaignCreateOneInlineInput>;
    modelCode?: InputMaybe<Scalars['String']['input']>;
    msrLink?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    order?: InputMaybe<Scalars['Int']['input']>;
    slug: Scalars['String']['input'];
    trimAndEnvkvString?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    vehicleMarketFilterParams?: InputMaybe<Scalars['String']['input']>;
    vehicles?: InputMaybe<VehicleCreateManyInlineInput>;
};

export type ModelCreateManyInlineInput = {
    /** Connect multiple existing Model documents */
    connect?: InputMaybe<Array<ModelWhereUniqueInput>>;
    /** Create and connect multiple existing Model documents */
    create?: InputMaybe<Array<ModelCreateInput>>;
};

export type ModelCreateOneInlineInput = {
    /** Connect one existing Model document */
    connect?: InputMaybe<ModelWhereUniqueInput>;
    /** Create and connect one Model document */
    create?: InputMaybe<ModelCreateInput>;
};

/** An edge in a connection. */
export type ModelEdge = {
    __typename?: 'ModelEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Model;
};

/** Identifies documents */
export type ModelManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<ModelWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<ModelWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<ModelWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    alternativeEnvkvVehicle?: InputMaybe<VehicleWhereInput>;
    alternativeModelDetailName?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    alternativeModelDetailName_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    alternativeModelDetailName_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    alternativeModelDetailName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    alternativeModelDetailName_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    alternativeModelDetailName_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    alternativeModelDetailName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    alternativeModelDetailName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    alternativeModelDetailName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    alternativeModelDetailName_starts_with?: InputMaybe<Scalars['String']['input']>;
    alternativerModelListName?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    alternativerModelListName_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    alternativerModelListName_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    alternativerModelListName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    alternativerModelListName_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    alternativerModelListName_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    alternativerModelListName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    alternativerModelListName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    alternativerModelListName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    alternativerModelListName_starts_with?: InputMaybe<Scalars['String']['input']>;
    campaigns_every?: InputMaybe<CampaignWhereInput>;
    campaigns_none?: InputMaybe<CampaignWhereInput>;
    campaigns_some?: InputMaybe<CampaignWhereInput>;
    /** Matches if the field array contains *all* items provided to the filter and order does match */
    categories?: InputMaybe<Array<ModelCategory>>;
    /** Matches if the field array contains *all* items provided to the filter */
    categories_contains_all?: InputMaybe<Array<ModelCategory>>;
    /** Matches if the field array does not contain any of the items provided to the filter */
    categories_contains_none?: InputMaybe<Array<ModelCategory>>;
    /** Matches if the field array contains at least one item provided to the filter */
    categories_contains_some?: InputMaybe<Array<ModelCategory>>;
    /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
    categories_not?: InputMaybe<Array<ModelCategory>>;
    co2Class?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2Class_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2Class_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2Class_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2Class_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2Class_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2Class_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2Class_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2Class_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2Class_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentImagesCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentImagesCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentImagesCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentImagesCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentImagesCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentImagesCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentImagesCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentImagesCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentImagesCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentImagesCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentImages_every?: InputMaybe<AssetWhereInput>;
    contentImages_none?: InputMaybe<AssetWhereInput>;
    contentImages_some?: InputMaybe<AssetWhereInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    cwModelUrl?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    cwModelUrl_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    cwModelUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    cwModelUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    cwModelUrl_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    cwModelUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    cwModelUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    cwModelUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    cwModelUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    cwModelUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
    disableTestdrive?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    disableTestdrive_not?: InputMaybe<Scalars['Boolean']['input']>;
    documentInStages_every?: InputMaybe<ModelWhereStageInput>;
    documentInStages_none?: InputMaybe<ModelWhereStageInput>;
    documentInStages_some?: InputMaybe<ModelWhereStageInput>;
    /** All values in which the modular component is connected to the given models */
    envkv?: InputMaybe<ModelenvkvUnionWhereInput>;
    /** All values in which the union is empty. */
    envkv_empty?: InputMaybe<Scalars['Boolean']['input']>;
    faq?: InputMaybe<FaqWhereInput>;
    formBodyId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    formBodyId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    formBodyId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    formBodyId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    formBodyId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    formBodyId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    formBodyId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    formBodyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    formBodyId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    formBodyId_starts_with?: InputMaybe<Scalars['String']['input']>;
    formGenerationId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    formGenerationId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    formGenerationId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    formGenerationId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    formGenerationId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    formGenerationId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    formGenerationId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    formGenerationId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    formGenerationId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    formGenerationId_starts_with?: InputMaybe<Scalars['String']['input']>;
    formIdentifier?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    formIdentifier_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    formIdentifier_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    formIdentifier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    formIdentifier_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    formIdentifier_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    formIdentifier_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    formIdentifier_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    formIdentifier_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    formIdentifier_starts_with?: InputMaybe<Scalars['String']['input']>;
    formModelId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    formModelId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    formModelId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    formModelId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    formModelId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    formModelId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    formModelId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    formModelId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    formModelId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    formModelId_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    heroImageCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroImageCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroImageCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroImageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroImageCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroImageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroImageCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroImageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroImageCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroImageCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroVideoUrl?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroVideoUrl_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroVideoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroVideoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroVideoUrl_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroVideoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroVideoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroVideoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroVideoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroVideoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    keyFacts_every?: InputMaybe<KeyFactWhereInput>;
    keyFacts_none?: InputMaybe<KeyFactWhereInput>;
    keyFacts_some?: InputMaybe<KeyFactWhereInput>;
    leasingHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    leasingHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    leasingHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    leasingHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    leasingHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    leasingHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    leasingHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    leasingHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    leasingHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    leasingHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    leasingSubheadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    leasingSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    leasingSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    leasingSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    leasingSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    leasingSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    leasingSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    leasingSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    leasingSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    leasingSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    logoImages_every?: InputMaybe<AssetWhereInput>;
    logoImages_none?: InputMaybe<AssetWhereInput>;
    logoImages_some?: InputMaybe<AssetWhereInput>;
    mobileId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mobileId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mobileId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mobileId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mobileId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mobileId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mobileId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mobileId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mobileId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mobileId_starts_with?: InputMaybe<Scalars['String']['input']>;
    modelAnnouncementCampaign?: InputMaybe<CampaignWhereInput>;
    modelCode?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    modelCode_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    modelCode_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    modelCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    modelCode_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    modelCode_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    modelCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    modelCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    modelCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    modelCode_starts_with?: InputMaybe<Scalars['String']['input']>;
    msrLink?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    msrLink_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    msrLink_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    msrLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    msrLink_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    msrLink_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    msrLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    msrLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    msrLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    msrLink_starts_with?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name_starts_with?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than the given value. */
    order_gt?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than or equal the given value. */
    order_gte?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are contained in given list. */
    order_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    /** All values less than the given value. */
    order_lt?: InputMaybe<Scalars['Int']['input']>;
    /** All values less than or equal the given value. */
    order_lte?: InputMaybe<Scalars['Int']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    order_not?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are not contained in given list. */
    order_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    slug?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    slug_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    slug_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    slug_starts_with?: InputMaybe<Scalars['String']['input']>;
    trimAndEnvkvString?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    trimAndEnvkvString_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    trimAndEnvkvString_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    trimAndEnvkvString_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    trimAndEnvkvString_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    trimAndEnvkvString_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    trimAndEnvkvString_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    trimAndEnvkvString_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    trimAndEnvkvString_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    trimAndEnvkvString_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    vehicleMarketFilterParams?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    vehicleMarketFilterParams_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    vehicleMarketFilterParams_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    vehicleMarketFilterParams_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    vehicleMarketFilterParams_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    vehicleMarketFilterParams_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    vehicleMarketFilterParams_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    vehicleMarketFilterParams_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    vehicleMarketFilterParams_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    vehicleMarketFilterParams_starts_with?: InputMaybe<Scalars['String']['input']>;
    vehicles_every?: InputMaybe<VehicleWhereInput>;
    vehicles_none?: InputMaybe<VehicleWhereInput>;
    vehicles_some?: InputMaybe<VehicleWhereInput>;
};

export enum ModelOrderByInput {
    AlternativeModelDetailNameAsc = 'alternativeModelDetailName_ASC',
    AlternativeModelDetailNameDesc = 'alternativeModelDetailName_DESC',
    AlternativerModelListNameAsc = 'alternativerModelListName_ASC',
    AlternativerModelListNameDesc = 'alternativerModelListName_DESC',
    CategoriesAsc = 'categories_ASC',
    CategoriesDesc = 'categories_DESC',
    Co2ClassAsc = 'co2Class_ASC',
    Co2ClassDesc = 'co2Class_DESC',
    ContentHeadlineAsc = 'contentHeadline_ASC',
    ContentHeadlineDesc = 'contentHeadline_DESC',
    ContentImagesCaptionAsc = 'contentImagesCaption_ASC',
    ContentImagesCaptionDesc = 'contentImagesCaption_DESC',
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    CwModelUrlAsc = 'cwModelUrl_ASC',
    CwModelUrlDesc = 'cwModelUrl_DESC',
    DisableTestdriveAsc = 'disableTestdrive_ASC',
    DisableTestdriveDesc = 'disableTestdrive_DESC',
    FormBodyIdAsc = 'formBodyId_ASC',
    FormBodyIdDesc = 'formBodyId_DESC',
    FormGenerationIdAsc = 'formGenerationId_ASC',
    FormGenerationIdDesc = 'formGenerationId_DESC',
    FormIdentifierAsc = 'formIdentifier_ASC',
    FormIdentifierDesc = 'formIdentifier_DESC',
    FormModelIdAsc = 'formModelId_ASC',
    FormModelIdDesc = 'formModelId_DESC',
    HeroImageCaptionAsc = 'heroImageCaption_ASC',
    HeroImageCaptionDesc = 'heroImageCaption_DESC',
    HeroVideoUrlAsc = 'heroVideoUrl_ASC',
    HeroVideoUrlDesc = 'heroVideoUrl_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    LeasingHeadlineAsc = 'leasingHeadline_ASC',
    LeasingHeadlineDesc = 'leasingHeadline_DESC',
    LeasingSubheadlineAsc = 'leasingSubheadline_ASC',
    LeasingSubheadlineDesc = 'leasingSubheadline_DESC',
    MobileIdAsc = 'mobileId_ASC',
    MobileIdDesc = 'mobileId_DESC',
    ModelCodeAsc = 'modelCode_ASC',
    ModelCodeDesc = 'modelCode_DESC',
    MsrLinkAsc = 'msrLink_ASC',
    MsrLinkDesc = 'msrLink_DESC',
    NameAsc = 'name_ASC',
    NameDesc = 'name_DESC',
    OrderAsc = 'order_ASC',
    OrderDesc = 'order_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    TrimAndEnvkvStringAsc = 'trimAndEnvkvString_ASC',
    TrimAndEnvkvStringDesc = 'trimAndEnvkvString_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
    VehicleMarketFilterParamsAsc = 'vehicleMarketFilterParams_ASC',
    VehicleMarketFilterParamsDesc = 'vehicleMarketFilterParams_DESC',
}

export type ModelUpdateInput = {
    alternativeEnvkvVehicle?: InputMaybe<VehicleUpdateOneInlineInput>;
    alternativeModelDetailName?: InputMaybe<Scalars['String']['input']>;
    alternativerModelListName?: InputMaybe<Scalars['String']['input']>;
    campaigns?: InputMaybe<CampaignUpdateManyInlineInput>;
    categories?: InputMaybe<Array<ModelCategory>>;
    clwgbyzjx01q406w4dk4r2ywo?: InputMaybe<VertriebPrivateContentUpdateManyInlineInput>;
    clwgfocju06au06w4at7s2jz0?: InputMaybe<VertriebBusinessContentUpdateManyInlineInput>;
    clxd4pc5203lk07wb6wov2a60?: InputMaybe<ModellAnkuendigungContentUpdateManyInlineInput>;
    cmlv2moc806su07vzaeiub9rt?: InputMaybe<SalesCampaignModelUpdateManyInlineInput>;
    co2Class?: InputMaybe<Scalars['String']['input']>;
    contentCopy?: InputMaybe<Scalars['RichTextAST']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    contentImages?: InputMaybe<AssetUpdateManyInlineInput>;
    contentImagesCaption?: InputMaybe<Scalars['String']['input']>;
    cwModelUrl?: InputMaybe<Scalars['String']['input']>;
    disableTestdrive?: InputMaybe<Scalars['Boolean']['input']>;
    envkv?: InputMaybe<ModelenvkvUnionUpdateOneInlineInput>;
    faq?: InputMaybe<FaqUpdateOneInlineInput>;
    formBodyId?: InputMaybe<Scalars['String']['input']>;
    formGenerationId?: InputMaybe<Scalars['String']['input']>;
    formIdentifier?: InputMaybe<Scalars['String']['input']>;
    formModelId?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetUpdateOneInlineInput>;
    heroImageCaption?: InputMaybe<Scalars['String']['input']>;
    heroVideoUrl?: InputMaybe<Scalars['String']['input']>;
    image?: InputMaybe<AssetUpdateOneInlineInput>;
    keyFacts?: InputMaybe<KeyFactUpdateManyInlineInput>;
    leasingHeadline?: InputMaybe<Scalars['String']['input']>;
    leasingSubheadline?: InputMaybe<Scalars['String']['input']>;
    legalTexts?: InputMaybe<Scalars['RichTextAST']['input']>;
    logoImages?: InputMaybe<AssetUpdateManyInlineInput>;
    mobileId?: InputMaybe<Scalars['String']['input']>;
    modelAnnouncementCampaign?: InputMaybe<CampaignUpdateOneInlineInput>;
    modelCode?: InputMaybe<Scalars['String']['input']>;
    msrLink?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Scalars['Int']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    trimAndEnvkvString?: InputMaybe<Scalars['String']['input']>;
    vehicleMarketFilterParams?: InputMaybe<Scalars['String']['input']>;
    vehicles?: InputMaybe<VehicleUpdateManyInlineInput>;
};

export type ModelUpdateManyInlineInput = {
    /** Connect multiple existing Model documents */
    connect?: InputMaybe<Array<ModelConnectInput>>;
    /** Create and connect multiple Model documents */
    create?: InputMaybe<Array<ModelCreateInput>>;
    /** Delete multiple Model documents */
    delete?: InputMaybe<Array<ModelWhereUniqueInput>>;
    /** Disconnect multiple Model documents */
    disconnect?: InputMaybe<Array<ModelWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing Model documents */
    set?: InputMaybe<Array<ModelWhereUniqueInput>>;
    /** Update multiple Model documents */
    update?: InputMaybe<Array<ModelUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple Model documents */
    upsert?: InputMaybe<Array<ModelUpsertWithNestedWhereUniqueInput>>;
};

export type ModelUpdateManyInput = {
    alternativeModelDetailName?: InputMaybe<Scalars['String']['input']>;
    alternativerModelListName?: InputMaybe<Scalars['String']['input']>;
    categories?: InputMaybe<Array<ModelCategory>>;
    co2Class?: InputMaybe<Scalars['String']['input']>;
    contentCopy?: InputMaybe<Scalars['RichTextAST']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    contentImagesCaption?: InputMaybe<Scalars['String']['input']>;
    cwModelUrl?: InputMaybe<Scalars['String']['input']>;
    disableTestdrive?: InputMaybe<Scalars['Boolean']['input']>;
    formBodyId?: InputMaybe<Scalars['String']['input']>;
    formGenerationId?: InputMaybe<Scalars['String']['input']>;
    formIdentifier?: InputMaybe<Scalars['String']['input']>;
    formModelId?: InputMaybe<Scalars['String']['input']>;
    heroImageCaption?: InputMaybe<Scalars['String']['input']>;
    heroVideoUrl?: InputMaybe<Scalars['String']['input']>;
    leasingHeadline?: InputMaybe<Scalars['String']['input']>;
    leasingSubheadline?: InputMaybe<Scalars['String']['input']>;
    legalTexts?: InputMaybe<Scalars['RichTextAST']['input']>;
    mobileId?: InputMaybe<Scalars['String']['input']>;
    msrLink?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    trimAndEnvkvString?: InputMaybe<Scalars['String']['input']>;
    vehicleMarketFilterParams?: InputMaybe<Scalars['String']['input']>;
};

export type ModelUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: ModelUpdateManyInput;
    /** Document search */
    where: ModelWhereInput;
};

export type ModelUpdateOneInlineInput = {
    /** Connect existing Model document */
    connect?: InputMaybe<ModelWhereUniqueInput>;
    /** Create and connect one Model document */
    create?: InputMaybe<ModelCreateInput>;
    /** Delete currently connected Model document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected Model document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Model document */
    update?: InputMaybe<ModelUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Model document */
    upsert?: InputMaybe<ModelUpsertWithNestedWhereUniqueInput>;
};

export type ModelUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: ModelUpdateInput;
    /** Unique document search */
    where: ModelWhereUniqueInput;
};

export type ModelUpsertInput = {
    /** Create document if it didn't exist */
    create: ModelCreateInput;
    /** Update document if it exists */
    update: ModelUpdateInput;
};

export type ModelUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: ModelUpsertInput;
    /** Unique document search */
    where: ModelWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ModelWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ModelWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<ModelWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<ModelWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<ModelWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    alternativeEnvkvVehicle?: InputMaybe<VehicleWhereInput>;
    alternativeModelDetailName?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    alternativeModelDetailName_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    alternativeModelDetailName_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    alternativeModelDetailName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    alternativeModelDetailName_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    alternativeModelDetailName_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    alternativeModelDetailName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    alternativeModelDetailName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    alternativeModelDetailName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    alternativeModelDetailName_starts_with?: InputMaybe<Scalars['String']['input']>;
    alternativerModelListName?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    alternativerModelListName_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    alternativerModelListName_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    alternativerModelListName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    alternativerModelListName_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    alternativerModelListName_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    alternativerModelListName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    alternativerModelListName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    alternativerModelListName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    alternativerModelListName_starts_with?: InputMaybe<Scalars['String']['input']>;
    campaigns_every?: InputMaybe<CampaignWhereInput>;
    campaigns_none?: InputMaybe<CampaignWhereInput>;
    campaigns_some?: InputMaybe<CampaignWhereInput>;
    /** Matches if the field array contains *all* items provided to the filter and order does match */
    categories?: InputMaybe<Array<ModelCategory>>;
    /** Matches if the field array contains *all* items provided to the filter */
    categories_contains_all?: InputMaybe<Array<ModelCategory>>;
    /** Matches if the field array does not contain any of the items provided to the filter */
    categories_contains_none?: InputMaybe<Array<ModelCategory>>;
    /** Matches if the field array contains at least one item provided to the filter */
    categories_contains_some?: InputMaybe<Array<ModelCategory>>;
    /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
    categories_not?: InputMaybe<Array<ModelCategory>>;
    co2Class?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    co2Class_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    co2Class_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    co2Class_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2Class_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    co2Class_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    co2Class_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    co2Class_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    co2Class_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    co2Class_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentImagesCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentImagesCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentImagesCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentImagesCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentImagesCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentImagesCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentImagesCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentImagesCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentImagesCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentImagesCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentImages_every?: InputMaybe<AssetWhereInput>;
    contentImages_none?: InputMaybe<AssetWhereInput>;
    contentImages_some?: InputMaybe<AssetWhereInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    cwModelUrl?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    cwModelUrl_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    cwModelUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    cwModelUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    cwModelUrl_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    cwModelUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    cwModelUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    cwModelUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    cwModelUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    cwModelUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
    disableTestdrive?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    disableTestdrive_not?: InputMaybe<Scalars['Boolean']['input']>;
    documentInStages_every?: InputMaybe<ModelWhereStageInput>;
    documentInStages_none?: InputMaybe<ModelWhereStageInput>;
    documentInStages_some?: InputMaybe<ModelWhereStageInput>;
    /** All values in which the modular component is connected to the given models */
    envkv?: InputMaybe<ModelenvkvUnionWhereInput>;
    /** All values in which the union is empty. */
    envkv_empty?: InputMaybe<Scalars['Boolean']['input']>;
    faq?: InputMaybe<FaqWhereInput>;
    formBodyId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    formBodyId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    formBodyId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    formBodyId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    formBodyId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    formBodyId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    formBodyId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    formBodyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    formBodyId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    formBodyId_starts_with?: InputMaybe<Scalars['String']['input']>;
    formGenerationId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    formGenerationId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    formGenerationId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    formGenerationId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    formGenerationId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    formGenerationId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    formGenerationId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    formGenerationId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    formGenerationId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    formGenerationId_starts_with?: InputMaybe<Scalars['String']['input']>;
    formIdentifier?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    formIdentifier_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    formIdentifier_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    formIdentifier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    formIdentifier_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    formIdentifier_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    formIdentifier_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    formIdentifier_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    formIdentifier_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    formIdentifier_starts_with?: InputMaybe<Scalars['String']['input']>;
    formModelId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    formModelId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    formModelId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    formModelId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    formModelId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    formModelId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    formModelId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    formModelId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    formModelId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    formModelId_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    heroImageCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroImageCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroImageCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroImageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroImageCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroImageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroImageCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroImageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroImageCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroImageCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroVideoUrl?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroVideoUrl_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroVideoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroVideoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroVideoUrl_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroVideoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroVideoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroVideoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroVideoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroVideoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    keyFacts_every?: InputMaybe<KeyFactWhereInput>;
    keyFacts_none?: InputMaybe<KeyFactWhereInput>;
    keyFacts_some?: InputMaybe<KeyFactWhereInput>;
    leasingHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    leasingHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    leasingHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    leasingHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    leasingHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    leasingHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    leasingHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    leasingHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    leasingHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    leasingHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    leasingSubheadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    leasingSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    leasingSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    leasingSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    leasingSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    leasingSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    leasingSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    leasingSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    leasingSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    leasingSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    logoImages_every?: InputMaybe<AssetWhereInput>;
    logoImages_none?: InputMaybe<AssetWhereInput>;
    logoImages_some?: InputMaybe<AssetWhereInput>;
    mobileId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mobileId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mobileId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mobileId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mobileId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mobileId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mobileId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mobileId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mobileId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mobileId_starts_with?: InputMaybe<Scalars['String']['input']>;
    modelAnnouncementCampaign?: InputMaybe<CampaignWhereInput>;
    modelCode?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    modelCode_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    modelCode_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    modelCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    modelCode_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    modelCode_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    modelCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    modelCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    modelCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    modelCode_starts_with?: InputMaybe<Scalars['String']['input']>;
    msrLink?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    msrLink_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    msrLink_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    msrLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    msrLink_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    msrLink_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    msrLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    msrLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    msrLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    msrLink_starts_with?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name_starts_with?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than the given value. */
    order_gt?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than or equal the given value. */
    order_gte?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are contained in given list. */
    order_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    /** All values less than the given value. */
    order_lt?: InputMaybe<Scalars['Int']['input']>;
    /** All values less than or equal the given value. */
    order_lte?: InputMaybe<Scalars['Int']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    order_not?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are not contained in given list. */
    order_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    slug?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    slug_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    slug_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    slug_starts_with?: InputMaybe<Scalars['String']['input']>;
    trimAndEnvkvString?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    trimAndEnvkvString_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    trimAndEnvkvString_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    trimAndEnvkvString_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    trimAndEnvkvString_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    trimAndEnvkvString_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    trimAndEnvkvString_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    trimAndEnvkvString_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    trimAndEnvkvString_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    trimAndEnvkvString_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    vehicleMarketFilterParams?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    vehicleMarketFilterParams_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    vehicleMarketFilterParams_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    vehicleMarketFilterParams_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    vehicleMarketFilterParams_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    vehicleMarketFilterParams_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    vehicleMarketFilterParams_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    vehicleMarketFilterParams_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    vehicleMarketFilterParams_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    vehicleMarketFilterParams_starts_with?: InputMaybe<Scalars['String']['input']>;
    vehicles_every?: InputMaybe<VehicleWhereInput>;
    vehicles_none?: InputMaybe<VehicleWhereInput>;
    vehicles_some?: InputMaybe<VehicleWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ModelWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<ModelWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<ModelWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<ModelWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<ModelWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References Model record uniquely */
export type ModelWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
    modelCode?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Scalars['Int']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
};

export type ModelenvkvUnion = EnVkvElektro | EnVkvPlugInHybrid | EnVkvVerbrennerHybrid | EnVkvWasserstoff;

export type ModelenvkvUnionConnectInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroConnectInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridConnectInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridConnectInput>;
    EnVkvWasserstoff?: InputMaybe<EnVkvWasserstoffConnectInput>;
};

export type ModelenvkvUnionCreateInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroCreateInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridCreateInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridCreateInput>;
    EnVkvWasserstoff?: InputMaybe<EnVkvWasserstoffCreateInput>;
};

export type ModelenvkvUnionCreateManyInlineInput = {
    /** Create and connect multiple existing ModelenvkvUnion documents */
    create?: InputMaybe<Array<ModelenvkvUnionCreateInput>>;
};

export type ModelenvkvUnionCreateOneInlineInput = {
    /** Create and connect one ModelenvkvUnion document */
    create?: InputMaybe<ModelenvkvUnionCreateInput>;
};

export type ModelenvkvUnionCreateWithPositionInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroCreateWithPositionInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridCreateWithPositionInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridCreateWithPositionInput>;
    EnVkvWasserstoff?: InputMaybe<EnVkvWasserstoffCreateWithPositionInput>;
};

export type ModelenvkvUnionUpdateInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroUpdateInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridUpdateInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridUpdateInput>;
    EnVkvWasserstoff?: InputMaybe<EnVkvWasserstoffUpdateInput>;
};

export type ModelenvkvUnionUpdateManyInlineInput = {
    /** Create and connect multiple ModelenvkvUnion component instances */
    create?: InputMaybe<Array<ModelenvkvUnionCreateWithPositionInput>>;
    /** Delete multiple ModelenvkvUnion documents */
    delete?: InputMaybe<Array<ModelenvkvUnionWhereUniqueInput>>;
    /** Update multiple ModelenvkvUnion component instances */
    update?: InputMaybe<Array<ModelenvkvUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple ModelenvkvUnion component instances */
    upsert?: InputMaybe<Array<ModelenvkvUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ModelenvkvUnionUpdateManyWithNestedWhereInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroUpdateManyWithNestedWhereInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridUpdateManyWithNestedWhereInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridUpdateManyWithNestedWhereInput>;
    EnVkvWasserstoff?: InputMaybe<EnVkvWasserstoffUpdateManyWithNestedWhereInput>;
};

export type ModelenvkvUnionUpdateOneInlineInput = {
    /** Create and connect one ModelenvkvUnion document */
    create?: InputMaybe<ModelenvkvUnionCreateInput>;
    /** Delete currently connected ModelenvkvUnion document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single ModelenvkvUnion document */
    update?: InputMaybe<ModelenvkvUnionUpdateWithNestedWhereUniqueInput>;
    /** Upsert single ModelenvkvUnion document */
    upsert?: InputMaybe<ModelenvkvUnionUpsertWithNestedWhereUniqueInput>;
};

export type ModelenvkvUnionUpdateWithNestedWhereUniqueAndPositionInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroUpdateWithNestedWhereUniqueAndPositionInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridUpdateWithNestedWhereUniqueAndPositionInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridUpdateWithNestedWhereUniqueAndPositionInput>;
    EnVkvWasserstoff?: InputMaybe<EnVkvWasserstoffUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ModelenvkvUnionUpdateWithNestedWhereUniqueInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroUpdateWithNestedWhereUniqueInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridUpdateWithNestedWhereUniqueInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridUpdateWithNestedWhereUniqueInput>;
    EnVkvWasserstoff?: InputMaybe<EnVkvWasserstoffUpdateWithNestedWhereUniqueInput>;
};

export type ModelenvkvUnionUpsertWithNestedWhereUniqueAndPositionInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroUpsertWithNestedWhereUniqueAndPositionInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridUpsertWithNestedWhereUniqueAndPositionInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridUpsertWithNestedWhereUniqueAndPositionInput>;
    EnVkvWasserstoff?: InputMaybe<EnVkvWasserstoffUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ModelenvkvUnionUpsertWithNestedWhereUniqueInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroUpsertWithNestedWhereUniqueInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridUpsertWithNestedWhereUniqueInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridUpsertWithNestedWhereUniqueInput>;
    EnVkvWasserstoff?: InputMaybe<EnVkvWasserstoffUpsertWithNestedWhereUniqueInput>;
};

export type ModelenvkvUnionWhereInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroWhereInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridWhereInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridWhereInput>;
    EnVkvWasserstoff?: InputMaybe<EnVkvWasserstoffWhereInput>;
};

export type ModelenvkvUnionWhereUniqueInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroWhereUniqueInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridWhereUniqueInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridWhereUniqueInput>;
    EnVkvWasserstoff?: InputMaybe<EnVkvWasserstoffWhereUniqueInput>;
};

export type ModellAnkuendigungContent = Entity & {
    __typename?: 'ModellAnkuendigungContent';
    /** "Jetzt Angebot anfragen" oder "Jetzt Probefahrt vereinbaren". Steuert, welcher Text über der Rufnummer angezeigt wird und welches Formular hinter dem CTA liegt.  */
    ctaType?: Maybe<CtaType>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    minimumShortTitle: Scalars['String']['output'];
    model?: Maybe<Model>;
    promotionInModellPalette?: Maybe<Scalars['Boolean']['output']>;
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
    warrantyLogo1?: Maybe<Asset>;
    warrantyLogo2?: Maybe<Asset>;
    warrantyLogo3?: Maybe<Asset>;
};

export type ModellAnkuendigungContentModelArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type ModellAnkuendigungContentWarrantyLogo1Args = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ModellAnkuendigungContentWarrantyLogo2Args = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ModellAnkuendigungContentWarrantyLogo3Args = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ModellAnkuendigungContentConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: ModellAnkuendigungContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type ModellAnkuendigungContentConnection = {
    __typename?: 'ModellAnkuendigungContentConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<ModellAnkuendigungContentEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type ModellAnkuendigungContentCreateInput = {
    ctaType?: InputMaybe<CtaType>;
    minimumShortTitle: Scalars['String']['input'];
    model?: InputMaybe<ModelCreateOneInlineInput>;
    promotionInModellPalette?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    warrantyLogo1?: InputMaybe<AssetCreateOneInlineInput>;
    warrantyLogo2?: InputMaybe<AssetCreateOneInlineInput>;
    warrantyLogo3?: InputMaybe<AssetCreateOneInlineInput>;
};

export type ModellAnkuendigungContentCreateManyInlineInput = {
    /** Create and connect multiple existing ModellAnkuendigungContent documents */
    create?: InputMaybe<Array<ModellAnkuendigungContentCreateInput>>;
};

export type ModellAnkuendigungContentCreateOneInlineInput = {
    /** Create and connect one ModellAnkuendigungContent document */
    create?: InputMaybe<ModellAnkuendigungContentCreateInput>;
};

export type ModellAnkuendigungContentCreateWithPositionInput = {
    /** Document to create */
    data: ModellAnkuendigungContentCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ModellAnkuendigungContentEdge = {
    __typename?: 'ModellAnkuendigungContentEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: ModellAnkuendigungContent;
};

/** Identifies documents */
export type ModellAnkuendigungContentManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<ModellAnkuendigungContentWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<ModellAnkuendigungContentWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<ModellAnkuendigungContentWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    ctaType?: InputMaybe<CtaType>;
    /** All values that are contained in given list. */
    ctaType_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    /** Any other value that exists and is not equal to the given value. */
    ctaType_not?: InputMaybe<CtaType>;
    /** All values that are not contained in given list. */
    ctaType_not_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    minimumShortTitle?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    minimumShortTitle_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    minimumShortTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    minimumShortTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    minimumShortTitle_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    minimumShortTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    minimumShortTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    minimumShortTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    minimumShortTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    minimumShortTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
    model?: InputMaybe<ModelWhereInput>;
    promotionInModellPalette?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    promotionInModellPalette_not?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    warrantyLogo1?: InputMaybe<AssetWhereInput>;
    warrantyLogo2?: InputMaybe<AssetWhereInput>;
    warrantyLogo3?: InputMaybe<AssetWhereInput>;
};

export enum ModellAnkuendigungContentOrderByInput {
    CtaTypeAsc = 'ctaType_ASC',
    CtaTypeDesc = 'ctaType_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    MinimumShortTitleAsc = 'minimumShortTitle_ASC',
    MinimumShortTitleDesc = 'minimumShortTitle_DESC',
    PromotionInModellPaletteAsc = 'promotionInModellPalette_ASC',
    PromotionInModellPaletteDesc = 'promotionInModellPalette_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type ModellAnkuendigungContentParent = Campaign;

export type ModellAnkuendigungContentParentConnectInput = {
    Campaign?: InputMaybe<CampaignConnectInput>;
};

export type ModellAnkuendigungContentParentCreateInput = {
    Campaign?: InputMaybe<CampaignCreateInput>;
};

export type ModellAnkuendigungContentParentCreateManyInlineInput = {
    /** Connect multiple existing ModellAnkuendigungContentParent documents */
    connect?: InputMaybe<Array<ModellAnkuendigungContentParentWhereUniqueInput>>;
    /** Create and connect multiple existing ModellAnkuendigungContentParent documents */
    create?: InputMaybe<Array<ModellAnkuendigungContentParentCreateInput>>;
};

export type ModellAnkuendigungContentParentCreateOneInlineInput = {
    /** Connect one existing ModellAnkuendigungContentParent document */
    connect?: InputMaybe<ModellAnkuendigungContentParentWhereUniqueInput>;
    /** Create and connect one ModellAnkuendigungContentParent document */
    create?: InputMaybe<ModellAnkuendigungContentParentCreateInput>;
};

export type ModellAnkuendigungContentParentUpdateInput = {
    Campaign?: InputMaybe<CampaignUpdateInput>;
};

export type ModellAnkuendigungContentParentUpdateManyInlineInput = {
    /** Connect multiple existing ModellAnkuendigungContentParent documents */
    connect?: InputMaybe<Array<ModellAnkuendigungContentParentConnectInput>>;
    /** Create and connect multiple ModellAnkuendigungContentParent documents */
    create?: InputMaybe<Array<ModellAnkuendigungContentParentCreateInput>>;
    /** Delete multiple ModellAnkuendigungContentParent documents */
    delete?: InputMaybe<Array<ModellAnkuendigungContentParentWhereUniqueInput>>;
    /** Disconnect multiple ModellAnkuendigungContentParent documents */
    disconnect?: InputMaybe<Array<ModellAnkuendigungContentParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing ModellAnkuendigungContentParent documents */
    set?: InputMaybe<Array<ModellAnkuendigungContentParentWhereUniqueInput>>;
    /** Update multiple ModellAnkuendigungContentParent documents */
    update?: InputMaybe<Array<ModellAnkuendigungContentParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple ModellAnkuendigungContentParent documents */
    upsert?: InputMaybe<Array<ModellAnkuendigungContentParentUpsertWithNestedWhereUniqueInput>>;
};

export type ModellAnkuendigungContentParentUpdateManyWithNestedWhereInput = {
    Campaign?: InputMaybe<CampaignUpdateManyWithNestedWhereInput>;
};

export type ModellAnkuendigungContentParentUpdateOneInlineInput = {
    /** Connect existing ModellAnkuendigungContentParent document */
    connect?: InputMaybe<ModellAnkuendigungContentParentWhereUniqueInput>;
    /** Create and connect one ModellAnkuendigungContentParent document */
    create?: InputMaybe<ModellAnkuendigungContentParentCreateInput>;
    /** Delete currently connected ModellAnkuendigungContentParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected ModellAnkuendigungContentParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single ModellAnkuendigungContentParent document */
    update?: InputMaybe<ModellAnkuendigungContentParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single ModellAnkuendigungContentParent document */
    upsert?: InputMaybe<ModellAnkuendigungContentParentUpsertWithNestedWhereUniqueInput>;
};

export type ModellAnkuendigungContentParentUpdateWithNestedWhereUniqueInput = {
    Campaign?: InputMaybe<CampaignUpdateWithNestedWhereUniqueInput>;
};

export type ModellAnkuendigungContentParentUpsertWithNestedWhereUniqueInput = {
    Campaign?: InputMaybe<CampaignUpsertWithNestedWhereUniqueInput>;
};

export type ModellAnkuendigungContentParentWhereInput = {
    Campaign?: InputMaybe<CampaignWhereInput>;
};

export type ModellAnkuendigungContentParentWhereUniqueInput = {
    Campaign?: InputMaybe<CampaignWhereUniqueInput>;
};

export type ModellAnkuendigungContentUpdateInput = {
    ctaType?: InputMaybe<CtaType>;
    minimumShortTitle?: InputMaybe<Scalars['String']['input']>;
    model?: InputMaybe<ModelUpdateOneInlineInput>;
    promotionInModellPalette?: InputMaybe<Scalars['Boolean']['input']>;
    warrantyLogo1?: InputMaybe<AssetUpdateOneInlineInput>;
    warrantyLogo2?: InputMaybe<AssetUpdateOneInlineInput>;
    warrantyLogo3?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type ModellAnkuendigungContentUpdateManyInlineInput = {
    /** Create and connect multiple ModellAnkuendigungContent component instances */
    create?: InputMaybe<Array<ModellAnkuendigungContentCreateWithPositionInput>>;
    /** Delete multiple ModellAnkuendigungContent documents */
    delete?: InputMaybe<Array<ModellAnkuendigungContentWhereUniqueInput>>;
    /** Update multiple ModellAnkuendigungContent component instances */
    update?: InputMaybe<Array<ModellAnkuendigungContentUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple ModellAnkuendigungContent component instances */
    upsert?: InputMaybe<Array<ModellAnkuendigungContentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ModellAnkuendigungContentUpdateManyInput = {
    ctaType?: InputMaybe<CtaType>;
    minimumShortTitle?: InputMaybe<Scalars['String']['input']>;
    promotionInModellPalette?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModellAnkuendigungContentUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: ModellAnkuendigungContentUpdateManyInput;
    /** Document search */
    where: ModellAnkuendigungContentWhereInput;
};

export type ModellAnkuendigungContentUpdateOneInlineInput = {
    /** Create and connect one ModellAnkuendigungContent document */
    create?: InputMaybe<ModellAnkuendigungContentCreateInput>;
    /** Delete currently connected ModellAnkuendigungContent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single ModellAnkuendigungContent document */
    update?: InputMaybe<ModellAnkuendigungContentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single ModellAnkuendigungContent document */
    upsert?: InputMaybe<ModellAnkuendigungContentUpsertWithNestedWhereUniqueInput>;
};

export type ModellAnkuendigungContentUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<ModellAnkuendigungContentUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: ModellAnkuendigungContentWhereUniqueInput;
};

export type ModellAnkuendigungContentUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: ModellAnkuendigungContentUpdateInput;
    /** Unique document search */
    where: ModellAnkuendigungContentWhereUniqueInput;
};

export type ModellAnkuendigungContentUpsertInput = {
    /** Create document if it didn't exist */
    create: ModellAnkuendigungContentCreateInput;
    /** Update document if it exists */
    update: ModellAnkuendigungContentUpdateInput;
};

export type ModellAnkuendigungContentUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<ModellAnkuendigungContentUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: ModellAnkuendigungContentWhereUniqueInput;
};

export type ModellAnkuendigungContentUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: ModellAnkuendigungContentUpsertInput;
    /** Unique document search */
    where: ModellAnkuendigungContentWhereUniqueInput;
};

/** Identifies documents */
export type ModellAnkuendigungContentWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<ModellAnkuendigungContentWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<ModellAnkuendigungContentWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<ModellAnkuendigungContentWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    ctaType?: InputMaybe<CtaType>;
    /** All values that are contained in given list. */
    ctaType_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    /** Any other value that exists and is not equal to the given value. */
    ctaType_not?: InputMaybe<CtaType>;
    /** All values that are not contained in given list. */
    ctaType_not_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    minimumShortTitle?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    minimumShortTitle_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    minimumShortTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    minimumShortTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    minimumShortTitle_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    minimumShortTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    minimumShortTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    minimumShortTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    minimumShortTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    minimumShortTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
    model?: InputMaybe<ModelWhereInput>;
    promotionInModellPalette?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    promotionInModellPalette_not?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    warrantyLogo1?: InputMaybe<AssetWhereInput>;
    warrantyLogo2?: InputMaybe<AssetWhereInput>;
    warrantyLogo3?: InputMaybe<AssetWhereInput>;
};

/** References ModellAnkuendigungContent record uniquely */
export type ModellAnkuendigungContentWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
    __typename?: 'Mutation';
    /** Create an asset. Use the returned info to finish the creation process by uploading the asset. */
    createAsset?: Maybe<Asset>;
    /** Create one auth0User */
    createAuth0User?: Maybe<Auth0User>;
    /** Create one campaign */
    createCampaign?: Maybe<Campaign>;
    /** Create one campaignService */
    createCampaignService?: Maybe<CampaignService>;
    /** Create one dealer */
    createDealer?: Maybe<Dealer>;
    /** Create one department */
    createDepartment?: Maybe<Department>;
    /** Create one footnote */
    createFootnote?: Maybe<Footnote>;
    /** Create one generalService */
    createGeneralService?: Maybe<GeneralService>;
    /** Create one homeTeaser */
    createHomeTeaser?: Maybe<HomeTeaser>;
    /** Create one model */
    createModel?: Maybe<Model>;
    /** Create one overlayBatteryCertificate */
    createOverlayBatteryCertificate?: Maybe<OverlayBatteryCertificate>;
    /** Create one pageAboutUs */
    createPageAboutUs?: Maybe<PageAboutUs>;
    /** Create one pageBusinessCustomer */
    createPageBusinessCustomer?: Maybe<PageBusinessCustomer>;
    /** Create one pageHome */
    createPageHome?: Maybe<PageHome>;
    /** Create one pageHyundaiPromise */
    createPageHyundaiPromise?: Maybe<PageHyundaiPromise>;
    /** Create one pageService */
    createPageService?: Maybe<PageService>;
    /** Create one pageWarranty */
    createPageWarranty?: Maybe<PageWarranty>;
    /** Create one scheduledRelease */
    createScheduledRelease?: Maybe<ScheduledRelease>;
    /** Create one vehicle */
    createVehicle?: Maybe<Vehicle>;
    /** Create one warranty */
    createWarranty?: Maybe<Warranty>;
    /** Delete one asset from _all_ existing stages. Returns deleted document. */
    deleteAsset?: Maybe<Asset>;
    /** Delete one auth0User from _all_ existing stages. Returns deleted document. */
    deleteAuth0User?: Maybe<Auth0User>;
    /** Delete one campaign from _all_ existing stages. Returns deleted document. */
    deleteCampaign?: Maybe<Campaign>;
    /** Delete one campaignService from _all_ existing stages. Returns deleted document. */
    deleteCampaignService?: Maybe<CampaignService>;
    /** Delete one dealer from _all_ existing stages. Returns deleted document. */
    deleteDealer?: Maybe<Dealer>;
    /** Delete one department from _all_ existing stages. Returns deleted document. */
    deleteDepartment?: Maybe<Department>;
    /** Delete one footnote from _all_ existing stages. Returns deleted document. */
    deleteFootnote?: Maybe<Footnote>;
    /** Delete one generalService from _all_ existing stages. Returns deleted document. */
    deleteGeneralService?: Maybe<GeneralService>;
    /** Delete one homeTeaser from _all_ existing stages. Returns deleted document. */
    deleteHomeTeaser?: Maybe<HomeTeaser>;
    /**
     * Delete many Asset documents
     * @deprecated Please use the new paginated many mutation (deleteManyAssetsConnection)
     */
    deleteManyAssets: BatchPayload;
    /** Delete many Asset documents, return deleted documents */
    deleteManyAssetsConnection: AssetConnection;
    /**
     * Delete many Auth0User documents
     * @deprecated Please use the new paginated many mutation (deleteManyAuth0UsersConnection)
     */
    deleteManyAuth0Users: BatchPayload;
    /** Delete many Auth0User documents, return deleted documents */
    deleteManyAuth0UsersConnection: Auth0UserConnection;
    /**
     * Delete many CampaignService documents
     * @deprecated Please use the new paginated many mutation (deleteManyCampaignServicesConnection)
     */
    deleteManyCampaignServices: BatchPayload;
    /** Delete many CampaignService documents, return deleted documents */
    deleteManyCampaignServicesConnection: CampaignServiceConnection;
    /**
     * Delete many Campaign documents
     * @deprecated Please use the new paginated many mutation (deleteManyCampaignsConnection)
     */
    deleteManyCampaigns: BatchPayload;
    /** Delete many Campaign documents, return deleted documents */
    deleteManyCampaignsConnection: CampaignConnection;
    /**
     * Delete many Dealer documents
     * @deprecated Please use the new paginated many mutation (deleteManyDealersConnection)
     */
    deleteManyDealers: BatchPayload;
    /** Delete many Dealer documents, return deleted documents */
    deleteManyDealersConnection: DealerConnection;
    /**
     * Delete many Department documents
     * @deprecated Please use the new paginated many mutation (deleteManyDepartmentsConnection)
     */
    deleteManyDepartments: BatchPayload;
    /** Delete many Department documents, return deleted documents */
    deleteManyDepartmentsConnection: DepartmentConnection;
    /**
     * Delete many Footnote documents
     * @deprecated Please use the new paginated many mutation (deleteManyFootnotesConnection)
     */
    deleteManyFootnotes: BatchPayload;
    /** Delete many Footnote documents, return deleted documents */
    deleteManyFootnotesConnection: FootnoteConnection;
    /**
     * Delete many GeneralService documents
     * @deprecated Please use the new paginated many mutation (deleteManyGeneralServicesConnection)
     */
    deleteManyGeneralServices: BatchPayload;
    /** Delete many GeneralService documents, return deleted documents */
    deleteManyGeneralServicesConnection: GeneralServiceConnection;
    /**
     * Delete many HomeTeaser documents
     * @deprecated Please use the new paginated many mutation (deleteManyHomeTeasersConnection)
     */
    deleteManyHomeTeasers: BatchPayload;
    /** Delete many HomeTeaser documents, return deleted documents */
    deleteManyHomeTeasersConnection: HomeTeaserConnection;
    /**
     * Delete many Model documents
     * @deprecated Please use the new paginated many mutation (deleteManyModelsConnection)
     */
    deleteManyModels: BatchPayload;
    /** Delete many Model documents, return deleted documents */
    deleteManyModelsConnection: ModelConnection;
    /**
     * Delete many OverlayBatteryCertificate documents
     * @deprecated Please use the new paginated many mutation (deleteManyOverlayBatteryCertificatesConnection)
     */
    deleteManyOverlayBatteryCertificates: BatchPayload;
    /** Delete many OverlayBatteryCertificate documents, return deleted documents */
    deleteManyOverlayBatteryCertificatesConnection: OverlayBatteryCertificateConnection;
    /**
     * Delete many PageAboutUs documents
     * @deprecated Please use the new paginated many mutation (deleteManyPageAboutUsesConnection)
     */
    deleteManyPageAboutUses: BatchPayload;
    /** Delete many PageAboutUs documents, return deleted documents */
    deleteManyPageAboutUsesConnection: PageAboutUsConnection;
    /**
     * Delete many PageBusinessCustomer documents
     * @deprecated Please use the new paginated many mutation (deleteManyPageBusinessCustomersConnection)
     */
    deleteManyPageBusinessCustomers: BatchPayload;
    /** Delete many PageBusinessCustomer documents, return deleted documents */
    deleteManyPageBusinessCustomersConnection: PageBusinessCustomerConnection;
    /**
     * Delete many PageHome documents
     * @deprecated Please use the new paginated many mutation (deleteManyPageHomesConnection)
     */
    deleteManyPageHomes: BatchPayload;
    /** Delete many PageHome documents, return deleted documents */
    deleteManyPageHomesConnection: PageHomeConnection;
    /**
     * Delete many PageHyundaiPromise documents
     * @deprecated Please use the new paginated many mutation (deleteManyPageHyundaiPromisesConnection)
     */
    deleteManyPageHyundaiPromises: BatchPayload;
    /** Delete many PageHyundaiPromise documents, return deleted documents */
    deleteManyPageHyundaiPromisesConnection: PageHyundaiPromiseConnection;
    /**
     * Delete many PageService documents
     * @deprecated Please use the new paginated many mutation (deleteManyPageServicesConnection)
     */
    deleteManyPageServices: BatchPayload;
    /** Delete many PageService documents, return deleted documents */
    deleteManyPageServicesConnection: PageServiceConnection;
    /**
     * Delete many PageWarranty documents
     * @deprecated Please use the new paginated many mutation (deleteManyPageWarrantiesConnection)
     */
    deleteManyPageWarranties: BatchPayload;
    /** Delete many PageWarranty documents, return deleted documents */
    deleteManyPageWarrantiesConnection: PageWarrantyConnection;
    /**
     * Delete many Vehicle documents
     * @deprecated Please use the new paginated many mutation (deleteManyVehiclesConnection)
     */
    deleteManyVehicles: BatchPayload;
    /** Delete many Vehicle documents, return deleted documents */
    deleteManyVehiclesConnection: VehicleConnection;
    /**
     * Delete many Warranty documents
     * @deprecated Please use the new paginated many mutation (deleteManyWarrantiesConnection)
     */
    deleteManyWarranties: BatchPayload;
    /** Delete many Warranty documents, return deleted documents */
    deleteManyWarrantiesConnection: WarrantyConnection;
    /** Delete one model from _all_ existing stages. Returns deleted document. */
    deleteModel?: Maybe<Model>;
    /** Delete one overlayBatteryCertificate from _all_ existing stages. Returns deleted document. */
    deleteOverlayBatteryCertificate?: Maybe<OverlayBatteryCertificate>;
    /** Delete one pageAboutUs from _all_ existing stages. Returns deleted document. */
    deletePageAboutUs?: Maybe<PageAboutUs>;
    /** Delete one pageBusinessCustomer from _all_ existing stages. Returns deleted document. */
    deletePageBusinessCustomer?: Maybe<PageBusinessCustomer>;
    /** Delete one pageHome from _all_ existing stages. Returns deleted document. */
    deletePageHome?: Maybe<PageHome>;
    /** Delete one pageHyundaiPromise from _all_ existing stages. Returns deleted document. */
    deletePageHyundaiPromise?: Maybe<PageHyundaiPromise>;
    /** Delete one pageService from _all_ existing stages. Returns deleted document. */
    deletePageService?: Maybe<PageService>;
    /** Delete one pageWarranty from _all_ existing stages. Returns deleted document. */
    deletePageWarranty?: Maybe<PageWarranty>;
    /** Delete and return scheduled operation */
    deleteScheduledOperation?: Maybe<ScheduledOperation>;
    /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
    deleteScheduledRelease?: Maybe<ScheduledRelease>;
    /** Delete one vehicle from _all_ existing stages. Returns deleted document. */
    deleteVehicle?: Maybe<Vehicle>;
    /** Delete one warranty from _all_ existing stages. Returns deleted document. */
    deleteWarranty?: Maybe<Warranty>;
    /** Publish one asset */
    publishAsset?: Maybe<Asset>;
    /** Publish one auth0User */
    publishAuth0User?: Maybe<Auth0User>;
    /** Publish one campaign */
    publishCampaign?: Maybe<Campaign>;
    /** Publish one campaignService */
    publishCampaignService?: Maybe<CampaignService>;
    /** Publish one dealer */
    publishDealer?: Maybe<Dealer>;
    /** Publish one department */
    publishDepartment?: Maybe<Department>;
    /** Publish one footnote */
    publishFootnote?: Maybe<Footnote>;
    /** Publish one generalService */
    publishGeneralService?: Maybe<GeneralService>;
    /** Publish one homeTeaser */
    publishHomeTeaser?: Maybe<HomeTeaser>;
    /**
     * Publish many Asset documents
     * @deprecated Please use the new paginated many mutation (publishManyAssetsConnection)
     */
    publishManyAssets: BatchPayload;
    /** Publish many Asset documents */
    publishManyAssetsConnection: AssetConnection;
    /**
     * Publish many Auth0User documents
     * @deprecated Please use the new paginated many mutation (publishManyAuth0UsersConnection)
     */
    publishManyAuth0Users: BatchPayload;
    /** Publish many Auth0User documents */
    publishManyAuth0UsersConnection: Auth0UserConnection;
    /**
     * Publish many CampaignService documents
     * @deprecated Please use the new paginated many mutation (publishManyCampaignServicesConnection)
     */
    publishManyCampaignServices: BatchPayload;
    /** Publish many CampaignService documents */
    publishManyCampaignServicesConnection: CampaignServiceConnection;
    /**
     * Publish many Campaign documents
     * @deprecated Please use the new paginated many mutation (publishManyCampaignsConnection)
     */
    publishManyCampaigns: BatchPayload;
    /** Publish many Campaign documents */
    publishManyCampaignsConnection: CampaignConnection;
    /**
     * Publish many Dealer documents
     * @deprecated Please use the new paginated many mutation (publishManyDealersConnection)
     */
    publishManyDealers: BatchPayload;
    /** Publish many Dealer documents */
    publishManyDealersConnection: DealerConnection;
    /**
     * Publish many Department documents
     * @deprecated Please use the new paginated many mutation (publishManyDepartmentsConnection)
     */
    publishManyDepartments: BatchPayload;
    /** Publish many Department documents */
    publishManyDepartmentsConnection: DepartmentConnection;
    /**
     * Publish many Footnote documents
     * @deprecated Please use the new paginated many mutation (publishManyFootnotesConnection)
     */
    publishManyFootnotes: BatchPayload;
    /** Publish many Footnote documents */
    publishManyFootnotesConnection: FootnoteConnection;
    /**
     * Publish many GeneralService documents
     * @deprecated Please use the new paginated many mutation (publishManyGeneralServicesConnection)
     */
    publishManyGeneralServices: BatchPayload;
    /** Publish many GeneralService documents */
    publishManyGeneralServicesConnection: GeneralServiceConnection;
    /**
     * Publish many HomeTeaser documents
     * @deprecated Please use the new paginated many mutation (publishManyHomeTeasersConnection)
     */
    publishManyHomeTeasers: BatchPayload;
    /** Publish many HomeTeaser documents */
    publishManyHomeTeasersConnection: HomeTeaserConnection;
    /**
     * Publish many Model documents
     * @deprecated Please use the new paginated many mutation (publishManyModelsConnection)
     */
    publishManyModels: BatchPayload;
    /** Publish many Model documents */
    publishManyModelsConnection: ModelConnection;
    /**
     * Publish many OverlayBatteryCertificate documents
     * @deprecated Please use the new paginated many mutation (publishManyOverlayBatteryCertificatesConnection)
     */
    publishManyOverlayBatteryCertificates: BatchPayload;
    /** Publish many OverlayBatteryCertificate documents */
    publishManyOverlayBatteryCertificatesConnection: OverlayBatteryCertificateConnection;
    /**
     * Publish many PageAboutUs documents
     * @deprecated Please use the new paginated many mutation (publishManyPageAboutUsesConnection)
     */
    publishManyPageAboutUses: BatchPayload;
    /** Publish many PageAboutUs documents */
    publishManyPageAboutUsesConnection: PageAboutUsConnection;
    /**
     * Publish many PageBusinessCustomer documents
     * @deprecated Please use the new paginated many mutation (publishManyPageBusinessCustomersConnection)
     */
    publishManyPageBusinessCustomers: BatchPayload;
    /** Publish many PageBusinessCustomer documents */
    publishManyPageBusinessCustomersConnection: PageBusinessCustomerConnection;
    /**
     * Publish many PageHome documents
     * @deprecated Please use the new paginated many mutation (publishManyPageHomesConnection)
     */
    publishManyPageHomes: BatchPayload;
    /** Publish many PageHome documents */
    publishManyPageHomesConnection: PageHomeConnection;
    /**
     * Publish many PageHyundaiPromise documents
     * @deprecated Please use the new paginated many mutation (publishManyPageHyundaiPromisesConnection)
     */
    publishManyPageHyundaiPromises: BatchPayload;
    /** Publish many PageHyundaiPromise documents */
    publishManyPageHyundaiPromisesConnection: PageHyundaiPromiseConnection;
    /**
     * Publish many PageService documents
     * @deprecated Please use the new paginated many mutation (publishManyPageServicesConnection)
     */
    publishManyPageServices: BatchPayload;
    /** Publish many PageService documents */
    publishManyPageServicesConnection: PageServiceConnection;
    /**
     * Publish many PageWarranty documents
     * @deprecated Please use the new paginated many mutation (publishManyPageWarrantiesConnection)
     */
    publishManyPageWarranties: BatchPayload;
    /** Publish many PageWarranty documents */
    publishManyPageWarrantiesConnection: PageWarrantyConnection;
    /**
     * Publish many Vehicle documents
     * @deprecated Please use the new paginated many mutation (publishManyVehiclesConnection)
     */
    publishManyVehicles: BatchPayload;
    /** Publish many Vehicle documents */
    publishManyVehiclesConnection: VehicleConnection;
    /**
     * Publish many Warranty documents
     * @deprecated Please use the new paginated many mutation (publishManyWarrantiesConnection)
     */
    publishManyWarranties: BatchPayload;
    /** Publish many Warranty documents */
    publishManyWarrantiesConnection: WarrantyConnection;
    /** Publish one model */
    publishModel?: Maybe<Model>;
    /** Publish one overlayBatteryCertificate */
    publishOverlayBatteryCertificate?: Maybe<OverlayBatteryCertificate>;
    /** Publish one pageAboutUs */
    publishPageAboutUs?: Maybe<PageAboutUs>;
    /** Publish one pageBusinessCustomer */
    publishPageBusinessCustomer?: Maybe<PageBusinessCustomer>;
    /** Publish one pageHome */
    publishPageHome?: Maybe<PageHome>;
    /** Publish one pageHyundaiPromise */
    publishPageHyundaiPromise?: Maybe<PageHyundaiPromise>;
    /** Publish one pageService */
    publishPageService?: Maybe<PageService>;
    /** Publish one pageWarranty */
    publishPageWarranty?: Maybe<PageWarranty>;
    /** Publish one vehicle */
    publishVehicle?: Maybe<Vehicle>;
    /** Publish one warranty */
    publishWarranty?: Maybe<Warranty>;
    /** Schedule to publish one asset */
    schedulePublishAsset?: Maybe<Asset>;
    /** Schedule to publish one auth0User */
    schedulePublishAuth0User?: Maybe<Auth0User>;
    /** Schedule to publish one campaign */
    schedulePublishCampaign?: Maybe<Campaign>;
    /** Schedule to publish one campaignService */
    schedulePublishCampaignService?: Maybe<CampaignService>;
    /** Schedule to publish one dealer */
    schedulePublishDealer?: Maybe<Dealer>;
    /** Schedule to publish one department */
    schedulePublishDepartment?: Maybe<Department>;
    /** Schedule to publish one footnote */
    schedulePublishFootnote?: Maybe<Footnote>;
    /** Schedule to publish one generalService */
    schedulePublishGeneralService?: Maybe<GeneralService>;
    /** Schedule to publish one homeTeaser */
    schedulePublishHomeTeaser?: Maybe<HomeTeaser>;
    /** Schedule to publish one model */
    schedulePublishModel?: Maybe<Model>;
    /** Schedule to publish one overlayBatteryCertificate */
    schedulePublishOverlayBatteryCertificate?: Maybe<OverlayBatteryCertificate>;
    /** Schedule to publish one pageAboutUs */
    schedulePublishPageAboutUs?: Maybe<PageAboutUs>;
    /** Schedule to publish one pageBusinessCustomer */
    schedulePublishPageBusinessCustomer?: Maybe<PageBusinessCustomer>;
    /** Schedule to publish one pageHome */
    schedulePublishPageHome?: Maybe<PageHome>;
    /** Schedule to publish one pageHyundaiPromise */
    schedulePublishPageHyundaiPromise?: Maybe<PageHyundaiPromise>;
    /** Schedule to publish one pageService */
    schedulePublishPageService?: Maybe<PageService>;
    /** Schedule to publish one pageWarranty */
    schedulePublishPageWarranty?: Maybe<PageWarranty>;
    /** Schedule to publish one vehicle */
    schedulePublishVehicle?: Maybe<Vehicle>;
    /** Schedule to publish one warranty */
    schedulePublishWarranty?: Maybe<Warranty>;
    /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishAsset?: Maybe<Asset>;
    /** Unpublish one auth0User from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishAuth0User?: Maybe<Auth0User>;
    /** Unpublish one campaign from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishCampaign?: Maybe<Campaign>;
    /** Unpublish one campaignService from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishCampaignService?: Maybe<CampaignService>;
    /** Unpublish one dealer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishDealer?: Maybe<Dealer>;
    /** Unpublish one department from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishDepartment?: Maybe<Department>;
    /** Unpublish one footnote from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishFootnote?: Maybe<Footnote>;
    /** Unpublish one generalService from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishGeneralService?: Maybe<GeneralService>;
    /** Unpublish one homeTeaser from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishHomeTeaser?: Maybe<HomeTeaser>;
    /** Unpublish one model from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishModel?: Maybe<Model>;
    /** Unpublish one overlayBatteryCertificate from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishOverlayBatteryCertificate?: Maybe<OverlayBatteryCertificate>;
    /** Unpublish one pageAboutUs from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishPageAboutUs?: Maybe<PageAboutUs>;
    /** Unpublish one pageBusinessCustomer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishPageBusinessCustomer?: Maybe<PageBusinessCustomer>;
    /** Unpublish one pageHome from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishPageHome?: Maybe<PageHome>;
    /** Unpublish one pageHyundaiPromise from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishPageHyundaiPromise?: Maybe<PageHyundaiPromise>;
    /** Unpublish one pageService from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishPageService?: Maybe<PageService>;
    /** Unpublish one pageWarranty from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishPageWarranty?: Maybe<PageWarranty>;
    /** Unpublish one vehicle from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishVehicle?: Maybe<Vehicle>;
    /** Unpublish one warranty from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    scheduleUnpublishWarranty?: Maybe<Warranty>;
    /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishAsset?: Maybe<Asset>;
    /** Unpublish one auth0User from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishAuth0User?: Maybe<Auth0User>;
    /** Unpublish one campaign from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishCampaign?: Maybe<Campaign>;
    /** Unpublish one campaignService from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishCampaignService?: Maybe<CampaignService>;
    /** Unpublish one dealer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishDealer?: Maybe<Dealer>;
    /** Unpublish one department from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishDepartment?: Maybe<Department>;
    /** Unpublish one footnote from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishFootnote?: Maybe<Footnote>;
    /** Unpublish one generalService from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishGeneralService?: Maybe<GeneralService>;
    /** Unpublish one homeTeaser from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishHomeTeaser?: Maybe<HomeTeaser>;
    /**
     * Unpublish many Asset documents
     * @deprecated Please use the new paginated many mutation (unpublishManyAssetsConnection)
     */
    unpublishManyAssets: BatchPayload;
    /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyAssetsConnection: AssetConnection;
    /**
     * Unpublish many Auth0User documents
     * @deprecated Please use the new paginated many mutation (unpublishManyAuth0UsersConnection)
     */
    unpublishManyAuth0Users: BatchPayload;
    /** Find many Auth0User documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyAuth0UsersConnection: Auth0UserConnection;
    /**
     * Unpublish many CampaignService documents
     * @deprecated Please use the new paginated many mutation (unpublishManyCampaignServicesConnection)
     */
    unpublishManyCampaignServices: BatchPayload;
    /** Find many CampaignService documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyCampaignServicesConnection: CampaignServiceConnection;
    /**
     * Unpublish many Campaign documents
     * @deprecated Please use the new paginated many mutation (unpublishManyCampaignsConnection)
     */
    unpublishManyCampaigns: BatchPayload;
    /** Find many Campaign documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyCampaignsConnection: CampaignConnection;
    /**
     * Unpublish many Dealer documents
     * @deprecated Please use the new paginated many mutation (unpublishManyDealersConnection)
     */
    unpublishManyDealers: BatchPayload;
    /** Find many Dealer documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyDealersConnection: DealerConnection;
    /**
     * Unpublish many Department documents
     * @deprecated Please use the new paginated many mutation (unpublishManyDepartmentsConnection)
     */
    unpublishManyDepartments: BatchPayload;
    /** Find many Department documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyDepartmentsConnection: DepartmentConnection;
    /**
     * Unpublish many Footnote documents
     * @deprecated Please use the new paginated many mutation (unpublishManyFootnotesConnection)
     */
    unpublishManyFootnotes: BatchPayload;
    /** Find many Footnote documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyFootnotesConnection: FootnoteConnection;
    /**
     * Unpublish many GeneralService documents
     * @deprecated Please use the new paginated many mutation (unpublishManyGeneralServicesConnection)
     */
    unpublishManyGeneralServices: BatchPayload;
    /** Find many GeneralService documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyGeneralServicesConnection: GeneralServiceConnection;
    /**
     * Unpublish many HomeTeaser documents
     * @deprecated Please use the new paginated many mutation (unpublishManyHomeTeasersConnection)
     */
    unpublishManyHomeTeasers: BatchPayload;
    /** Find many HomeTeaser documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyHomeTeasersConnection: HomeTeaserConnection;
    /**
     * Unpublish many Model documents
     * @deprecated Please use the new paginated many mutation (unpublishManyModelsConnection)
     */
    unpublishManyModels: BatchPayload;
    /** Find many Model documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyModelsConnection: ModelConnection;
    /**
     * Unpublish many OverlayBatteryCertificate documents
     * @deprecated Please use the new paginated many mutation (unpublishManyOverlayBatteryCertificatesConnection)
     */
    unpublishManyOverlayBatteryCertificates: BatchPayload;
    /** Find many OverlayBatteryCertificate documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyOverlayBatteryCertificatesConnection: OverlayBatteryCertificateConnection;
    /**
     * Unpublish many PageAboutUs documents
     * @deprecated Please use the new paginated many mutation (unpublishManyPageAboutUsesConnection)
     */
    unpublishManyPageAboutUses: BatchPayload;
    /** Find many PageAboutUs documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyPageAboutUsesConnection: PageAboutUsConnection;
    /**
     * Unpublish many PageBusinessCustomer documents
     * @deprecated Please use the new paginated many mutation (unpublishManyPageBusinessCustomersConnection)
     */
    unpublishManyPageBusinessCustomers: BatchPayload;
    /** Find many PageBusinessCustomer documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyPageBusinessCustomersConnection: PageBusinessCustomerConnection;
    /**
     * Unpublish many PageHome documents
     * @deprecated Please use the new paginated many mutation (unpublishManyPageHomesConnection)
     */
    unpublishManyPageHomes: BatchPayload;
    /** Find many PageHome documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyPageHomesConnection: PageHomeConnection;
    /**
     * Unpublish many PageHyundaiPromise documents
     * @deprecated Please use the new paginated many mutation (unpublishManyPageHyundaiPromisesConnection)
     */
    unpublishManyPageHyundaiPromises: BatchPayload;
    /** Find many PageHyundaiPromise documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyPageHyundaiPromisesConnection: PageHyundaiPromiseConnection;
    /**
     * Unpublish many PageService documents
     * @deprecated Please use the new paginated many mutation (unpublishManyPageServicesConnection)
     */
    unpublishManyPageServices: BatchPayload;
    /** Find many PageService documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyPageServicesConnection: PageServiceConnection;
    /**
     * Unpublish many PageWarranty documents
     * @deprecated Please use the new paginated many mutation (unpublishManyPageWarrantiesConnection)
     */
    unpublishManyPageWarranties: BatchPayload;
    /** Find many PageWarranty documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyPageWarrantiesConnection: PageWarrantyConnection;
    /**
     * Unpublish many Vehicle documents
     * @deprecated Please use the new paginated many mutation (unpublishManyVehiclesConnection)
     */
    unpublishManyVehicles: BatchPayload;
    /** Find many Vehicle documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyVehiclesConnection: VehicleConnection;
    /**
     * Unpublish many Warranty documents
     * @deprecated Please use the new paginated many mutation (unpublishManyWarrantiesConnection)
     */
    unpublishManyWarranties: BatchPayload;
    /** Find many Warranty documents that match criteria in specified stage and unpublish from target stages */
    unpublishManyWarrantiesConnection: WarrantyConnection;
    /** Unpublish one model from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishModel?: Maybe<Model>;
    /** Unpublish one overlayBatteryCertificate from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishOverlayBatteryCertificate?: Maybe<OverlayBatteryCertificate>;
    /** Unpublish one pageAboutUs from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishPageAboutUs?: Maybe<PageAboutUs>;
    /** Unpublish one pageBusinessCustomer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishPageBusinessCustomer?: Maybe<PageBusinessCustomer>;
    /** Unpublish one pageHome from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishPageHome?: Maybe<PageHome>;
    /** Unpublish one pageHyundaiPromise from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishPageHyundaiPromise?: Maybe<PageHyundaiPromise>;
    /** Unpublish one pageService from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishPageService?: Maybe<PageService>;
    /** Unpublish one pageWarranty from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishPageWarranty?: Maybe<PageWarranty>;
    /** Unpublish one vehicle from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishVehicle?: Maybe<Vehicle>;
    /** Unpublish one warranty from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
    unpublishWarranty?: Maybe<Warranty>;
    /** Update one asset */
    updateAsset?: Maybe<Asset>;
    /** Update one auth0User */
    updateAuth0User?: Maybe<Auth0User>;
    /** Update one campaign */
    updateCampaign?: Maybe<Campaign>;
    /** Update one campaignService */
    updateCampaignService?: Maybe<CampaignService>;
    /** Update one dealer */
    updateDealer?: Maybe<Dealer>;
    /** Update one department */
    updateDepartment?: Maybe<Department>;
    /** Update one footnote */
    updateFootnote?: Maybe<Footnote>;
    /** Update one generalService */
    updateGeneralService?: Maybe<GeneralService>;
    /** Update one homeTeaser */
    updateHomeTeaser?: Maybe<HomeTeaser>;
    /**
     * Update many assets
     * @deprecated Please use the new paginated many mutation (updateManyAssetsConnection)
     */
    updateManyAssets: BatchPayload;
    /** Update many Asset documents */
    updateManyAssetsConnection: AssetConnection;
    /**
     * Update many auth0Users
     * @deprecated Please use the new paginated many mutation (updateManyAuth0UsersConnection)
     */
    updateManyAuth0Users: BatchPayload;
    /** Update many Auth0User documents */
    updateManyAuth0UsersConnection: Auth0UserConnection;
    /**
     * Update many campaignServices
     * @deprecated Please use the new paginated many mutation (updateManyCampaignServicesConnection)
     */
    updateManyCampaignServices: BatchPayload;
    /** Update many CampaignService documents */
    updateManyCampaignServicesConnection: CampaignServiceConnection;
    /**
     * Update many campaigns
     * @deprecated Please use the new paginated many mutation (updateManyCampaignsConnection)
     */
    updateManyCampaigns: BatchPayload;
    /** Update many Campaign documents */
    updateManyCampaignsConnection: CampaignConnection;
    /**
     * Update many dealers
     * @deprecated Please use the new paginated many mutation (updateManyDealersConnection)
     */
    updateManyDealers: BatchPayload;
    /** Update many Dealer documents */
    updateManyDealersConnection: DealerConnection;
    /**
     * Update many departments
     * @deprecated Please use the new paginated many mutation (updateManyDepartmentsConnection)
     */
    updateManyDepartments: BatchPayload;
    /** Update many Department documents */
    updateManyDepartmentsConnection: DepartmentConnection;
    /**
     * Update many footnotes
     * @deprecated Please use the new paginated many mutation (updateManyFootnotesConnection)
     */
    updateManyFootnotes: BatchPayload;
    /** Update many Footnote documents */
    updateManyFootnotesConnection: FootnoteConnection;
    /**
     * Update many generalServices
     * @deprecated Please use the new paginated many mutation (updateManyGeneralServicesConnection)
     */
    updateManyGeneralServices: BatchPayload;
    /** Update many GeneralService documents */
    updateManyGeneralServicesConnection: GeneralServiceConnection;
    /**
     * Update many homeTeasers
     * @deprecated Please use the new paginated many mutation (updateManyHomeTeasersConnection)
     */
    updateManyHomeTeasers: BatchPayload;
    /** Update many HomeTeaser documents */
    updateManyHomeTeasersConnection: HomeTeaserConnection;
    /**
     * Update many models
     * @deprecated Please use the new paginated many mutation (updateManyModelsConnection)
     */
    updateManyModels: BatchPayload;
    /** Update many Model documents */
    updateManyModelsConnection: ModelConnection;
    /**
     * Update many overlayBatteryCertificates
     * @deprecated Please use the new paginated many mutation (updateManyOverlayBatteryCertificatesConnection)
     */
    updateManyOverlayBatteryCertificates: BatchPayload;
    /** Update many OverlayBatteryCertificate documents */
    updateManyOverlayBatteryCertificatesConnection: OverlayBatteryCertificateConnection;
    /**
     * Update many pageAboutUses
     * @deprecated Please use the new paginated many mutation (updateManyPageAboutUsesConnection)
     */
    updateManyPageAboutUses: BatchPayload;
    /** Update many PageAboutUs documents */
    updateManyPageAboutUsesConnection: PageAboutUsConnection;
    /**
     * Update many pageBusinessCustomers
     * @deprecated Please use the new paginated many mutation (updateManyPageBusinessCustomersConnection)
     */
    updateManyPageBusinessCustomers: BatchPayload;
    /** Update many PageBusinessCustomer documents */
    updateManyPageBusinessCustomersConnection: PageBusinessCustomerConnection;
    /**
     * Update many pageHomes
     * @deprecated Please use the new paginated many mutation (updateManyPageHomesConnection)
     */
    updateManyPageHomes: BatchPayload;
    /** Update many PageHome documents */
    updateManyPageHomesConnection: PageHomeConnection;
    /**
     * Update many pageHyundaiPromises
     * @deprecated Please use the new paginated many mutation (updateManyPageHyundaiPromisesConnection)
     */
    updateManyPageHyundaiPromises: BatchPayload;
    /** Update many PageHyundaiPromise documents */
    updateManyPageHyundaiPromisesConnection: PageHyundaiPromiseConnection;
    /**
     * Update many pageServices
     * @deprecated Please use the new paginated many mutation (updateManyPageServicesConnection)
     */
    updateManyPageServices: BatchPayload;
    /** Update many PageService documents */
    updateManyPageServicesConnection: PageServiceConnection;
    /**
     * Update many pageWarranties
     * @deprecated Please use the new paginated many mutation (updateManyPageWarrantiesConnection)
     */
    updateManyPageWarranties: BatchPayload;
    /** Update many PageWarranty documents */
    updateManyPageWarrantiesConnection: PageWarrantyConnection;
    /**
     * Update many vehicles
     * @deprecated Please use the new paginated many mutation (updateManyVehiclesConnection)
     */
    updateManyVehicles: BatchPayload;
    /** Update many Vehicle documents */
    updateManyVehiclesConnection: VehicleConnection;
    /**
     * Update many warranties
     * @deprecated Please use the new paginated many mutation (updateManyWarrantiesConnection)
     */
    updateManyWarranties: BatchPayload;
    /** Update many Warranty documents */
    updateManyWarrantiesConnection: WarrantyConnection;
    /** Update one model */
    updateModel?: Maybe<Model>;
    /** Update one overlayBatteryCertificate */
    updateOverlayBatteryCertificate?: Maybe<OverlayBatteryCertificate>;
    /** Update one pageAboutUs */
    updatePageAboutUs?: Maybe<PageAboutUs>;
    /** Update one pageBusinessCustomer */
    updatePageBusinessCustomer?: Maybe<PageBusinessCustomer>;
    /** Update one pageHome */
    updatePageHome?: Maybe<PageHome>;
    /** Update one pageHyundaiPromise */
    updatePageHyundaiPromise?: Maybe<PageHyundaiPromise>;
    /** Update one pageService */
    updatePageService?: Maybe<PageService>;
    /** Update one pageWarranty */
    updatePageWarranty?: Maybe<PageWarranty>;
    /** Update one scheduledRelease */
    updateScheduledRelease?: Maybe<ScheduledRelease>;
    /** Update one vehicle */
    updateVehicle?: Maybe<Vehicle>;
    /** Update one warranty */
    updateWarranty?: Maybe<Warranty>;
    /** Upsert one asset */
    upsertAsset?: Maybe<Asset>;
    /** Upsert one auth0User */
    upsertAuth0User?: Maybe<Auth0User>;
    /** Upsert one campaign */
    upsertCampaign?: Maybe<Campaign>;
    /** Upsert one campaignService */
    upsertCampaignService?: Maybe<CampaignService>;
    /** Upsert one dealer */
    upsertDealer?: Maybe<Dealer>;
    /** Upsert one department */
    upsertDepartment?: Maybe<Department>;
    /** Upsert one footnote */
    upsertFootnote?: Maybe<Footnote>;
    /** Upsert one generalService */
    upsertGeneralService?: Maybe<GeneralService>;
    /** Upsert one homeTeaser */
    upsertHomeTeaser?: Maybe<HomeTeaser>;
    /** Upsert one model */
    upsertModel?: Maybe<Model>;
    /** Upsert one overlayBatteryCertificate */
    upsertOverlayBatteryCertificate?: Maybe<OverlayBatteryCertificate>;
    /** Upsert one pageAboutUs */
    upsertPageAboutUs?: Maybe<PageAboutUs>;
    /** Upsert one pageBusinessCustomer */
    upsertPageBusinessCustomer?: Maybe<PageBusinessCustomer>;
    /** Upsert one pageHome */
    upsertPageHome?: Maybe<PageHome>;
    /** Upsert one pageHyundaiPromise */
    upsertPageHyundaiPromise?: Maybe<PageHyundaiPromise>;
    /** Upsert one pageService */
    upsertPageService?: Maybe<PageService>;
    /** Upsert one pageWarranty */
    upsertPageWarranty?: Maybe<PageWarranty>;
    /** Upsert one vehicle */
    upsertVehicle?: Maybe<Vehicle>;
    /** Upsert one warranty */
    upsertWarranty?: Maybe<Warranty>;
};

export type MutationCreateAssetArgs = {
    data: AssetCreateInput;
};

export type MutationCreateAuth0UserArgs = {
    data: Auth0UserCreateInput;
};

export type MutationCreateCampaignArgs = {
    data: CampaignCreateInput;
};

export type MutationCreateCampaignServiceArgs = {
    data: CampaignServiceCreateInput;
};

export type MutationCreateDealerArgs = {
    data: DealerCreateInput;
};

export type MutationCreateDepartmentArgs = {
    data: DepartmentCreateInput;
};

export type MutationCreateFootnoteArgs = {
    data: FootnoteCreateInput;
};

export type MutationCreateGeneralServiceArgs = {
    data: GeneralServiceCreateInput;
};

export type MutationCreateHomeTeaserArgs = {
    data: HomeTeaserCreateInput;
};

export type MutationCreateModelArgs = {
    data: ModelCreateInput;
};

export type MutationCreateOverlayBatteryCertificateArgs = {
    data: OverlayBatteryCertificateCreateInput;
};

export type MutationCreatePageAboutUsArgs = {
    data: PageAboutUsCreateInput;
};

export type MutationCreatePageBusinessCustomerArgs = {
    data: PageBusinessCustomerCreateInput;
};

export type MutationCreatePageHomeArgs = {
    data: PageHomeCreateInput;
};

export type MutationCreatePageHyundaiPromiseArgs = {
    data: PageHyundaiPromiseCreateInput;
};

export type MutationCreatePageServiceArgs = {
    data: PageServiceCreateInput;
};

export type MutationCreatePageWarrantyArgs = {
    data: PageWarrantyCreateInput;
};

export type MutationCreateScheduledReleaseArgs = {
    data: ScheduledReleaseCreateInput;
};

export type MutationCreateVehicleArgs = {
    data: VehicleCreateInput;
};

export type MutationCreateWarrantyArgs = {
    data: WarrantyCreateInput;
};

export type MutationDeleteAssetArgs = {
    where: AssetWhereUniqueInput;
};

export type MutationDeleteAuth0UserArgs = {
    where: Auth0UserWhereUniqueInput;
};

export type MutationDeleteCampaignArgs = {
    where: CampaignWhereUniqueInput;
};

export type MutationDeleteCampaignServiceArgs = {
    where: CampaignServiceWhereUniqueInput;
};

export type MutationDeleteDealerArgs = {
    where: DealerWhereUniqueInput;
};

export type MutationDeleteDepartmentArgs = {
    where: DepartmentWhereUniqueInput;
};

export type MutationDeleteFootnoteArgs = {
    where: FootnoteWhereUniqueInput;
};

export type MutationDeleteGeneralServiceArgs = {
    where: GeneralServiceWhereUniqueInput;
};

export type MutationDeleteHomeTeaserArgs = {
    where: HomeTeaserWhereUniqueInput;
};

export type MutationDeleteManyAssetsArgs = {
    where?: InputMaybe<AssetManyWhereInput>;
};

export type MutationDeleteManyAssetsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AssetManyWhereInput>;
};

export type MutationDeleteManyAuth0UsersArgs = {
    where?: InputMaybe<Auth0UserManyWhereInput>;
};

export type MutationDeleteManyAuth0UsersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<Auth0UserManyWhereInput>;
};

export type MutationDeleteManyCampaignServicesArgs = {
    where?: InputMaybe<CampaignServiceManyWhereInput>;
};

export type MutationDeleteManyCampaignServicesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CampaignServiceManyWhereInput>;
};

export type MutationDeleteManyCampaignsArgs = {
    where?: InputMaybe<CampaignManyWhereInput>;
};

export type MutationDeleteManyCampaignsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CampaignManyWhereInput>;
};

export type MutationDeleteManyDealersArgs = {
    where?: InputMaybe<DealerManyWhereInput>;
};

export type MutationDeleteManyDealersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DealerManyWhereInput>;
};

export type MutationDeleteManyDepartmentsArgs = {
    where?: InputMaybe<DepartmentManyWhereInput>;
};

export type MutationDeleteManyDepartmentsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DepartmentManyWhereInput>;
};

export type MutationDeleteManyFootnotesArgs = {
    where?: InputMaybe<FootnoteManyWhereInput>;
};

export type MutationDeleteManyFootnotesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FootnoteManyWhereInput>;
};

export type MutationDeleteManyGeneralServicesArgs = {
    where?: InputMaybe<GeneralServiceManyWhereInput>;
};

export type MutationDeleteManyGeneralServicesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GeneralServiceManyWhereInput>;
};

export type MutationDeleteManyHomeTeasersArgs = {
    where?: InputMaybe<HomeTeaserManyWhereInput>;
};

export type MutationDeleteManyHomeTeasersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HomeTeaserManyWhereInput>;
};

export type MutationDeleteManyModelsArgs = {
    where?: InputMaybe<ModelManyWhereInput>;
};

export type MutationDeleteManyModelsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ModelManyWhereInput>;
};

export type MutationDeleteManyOverlayBatteryCertificatesArgs = {
    where?: InputMaybe<OverlayBatteryCertificateManyWhereInput>;
};

export type MutationDeleteManyOverlayBatteryCertificatesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OverlayBatteryCertificateManyWhereInput>;
};

export type MutationDeleteManyPageAboutUsesArgs = {
    where?: InputMaybe<PageAboutUsManyWhereInput>;
};

export type MutationDeleteManyPageAboutUsesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageAboutUsManyWhereInput>;
};

export type MutationDeleteManyPageBusinessCustomersArgs = {
    where?: InputMaybe<PageBusinessCustomerManyWhereInput>;
};

export type MutationDeleteManyPageBusinessCustomersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageBusinessCustomerManyWhereInput>;
};

export type MutationDeleteManyPageHomesArgs = {
    where?: InputMaybe<PageHomeManyWhereInput>;
};

export type MutationDeleteManyPageHomesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageHomeManyWhereInput>;
};

export type MutationDeleteManyPageHyundaiPromisesArgs = {
    where?: InputMaybe<PageHyundaiPromiseManyWhereInput>;
};

export type MutationDeleteManyPageHyundaiPromisesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageHyundaiPromiseManyWhereInput>;
};

export type MutationDeleteManyPageServicesArgs = {
    where?: InputMaybe<PageServiceManyWhereInput>;
};

export type MutationDeleteManyPageServicesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageServiceManyWhereInput>;
};

export type MutationDeleteManyPageWarrantiesArgs = {
    where?: InputMaybe<PageWarrantyManyWhereInput>;
};

export type MutationDeleteManyPageWarrantiesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageWarrantyManyWhereInput>;
};

export type MutationDeleteManyVehiclesArgs = {
    where?: InputMaybe<VehicleManyWhereInput>;
};

export type MutationDeleteManyVehiclesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<VehicleManyWhereInput>;
};

export type MutationDeleteManyWarrantiesArgs = {
    where?: InputMaybe<WarrantyManyWhereInput>;
};

export type MutationDeleteManyWarrantiesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<WarrantyManyWhereInput>;
};

export type MutationDeleteModelArgs = {
    where: ModelWhereUniqueInput;
};

export type MutationDeleteOverlayBatteryCertificateArgs = {
    where: OverlayBatteryCertificateWhereUniqueInput;
};

export type MutationDeletePageAboutUsArgs = {
    where: PageAboutUsWhereUniqueInput;
};

export type MutationDeletePageBusinessCustomerArgs = {
    where: PageBusinessCustomerWhereUniqueInput;
};

export type MutationDeletePageHomeArgs = {
    where: PageHomeWhereUniqueInput;
};

export type MutationDeletePageHyundaiPromiseArgs = {
    where: PageHyundaiPromiseWhereUniqueInput;
};

export type MutationDeletePageServiceArgs = {
    where: PageServiceWhereUniqueInput;
};

export type MutationDeletePageWarrantyArgs = {
    where: PageWarrantyWhereUniqueInput;
};

export type MutationDeleteScheduledOperationArgs = {
    where: ScheduledOperationWhereUniqueInput;
};

export type MutationDeleteScheduledReleaseArgs = {
    where: ScheduledReleaseWhereUniqueInput;
};

export type MutationDeleteVehicleArgs = {
    where: VehicleWhereUniqueInput;
};

export type MutationDeleteWarrantyArgs = {
    where: WarrantyWhereUniqueInput;
};

export type MutationPublishAssetArgs = {
    locales?: InputMaybe<Array<Locale>>;
    publishBase?: InputMaybe<Scalars['Boolean']['input']>;
    to?: Array<Stage>;
    where: AssetWhereUniqueInput;
    withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationPublishAuth0UserArgs = {
    to?: Array<Stage>;
    where: Auth0UserWhereUniqueInput;
};

export type MutationPublishCampaignArgs = {
    to?: Array<Stage>;
    where: CampaignWhereUniqueInput;
};

export type MutationPublishCampaignServiceArgs = {
    to?: Array<Stage>;
    where: CampaignServiceWhereUniqueInput;
};

export type MutationPublishDealerArgs = {
    to?: Array<Stage>;
    where: DealerWhereUniqueInput;
};

export type MutationPublishDepartmentArgs = {
    to?: Array<Stage>;
    where: DepartmentWhereUniqueInput;
};

export type MutationPublishFootnoteArgs = {
    to?: Array<Stage>;
    where: FootnoteWhereUniqueInput;
};

export type MutationPublishGeneralServiceArgs = {
    to?: Array<Stage>;
    where: GeneralServiceWhereUniqueInput;
};

export type MutationPublishHomeTeaserArgs = {
    to?: Array<Stage>;
    where: HomeTeaserWhereUniqueInput;
};

export type MutationPublishManyAssetsArgs = {
    locales?: InputMaybe<Array<Locale>>;
    publishBase?: InputMaybe<Scalars['Boolean']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<AssetManyWhereInput>;
    withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationPublishManyAssetsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    publishBase?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<AssetManyWhereInput>;
    withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationPublishManyAuth0UsersArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<Auth0UserManyWhereInput>;
};

export type MutationPublishManyAuth0UsersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<Auth0UserManyWhereInput>;
};

export type MutationPublishManyCampaignServicesArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<CampaignServiceManyWhereInput>;
};

export type MutationPublishManyCampaignServicesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<CampaignServiceManyWhereInput>;
};

export type MutationPublishManyCampaignsArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<CampaignManyWhereInput>;
};

export type MutationPublishManyCampaignsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<CampaignManyWhereInput>;
};

export type MutationPublishManyDealersArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<DealerManyWhereInput>;
};

export type MutationPublishManyDealersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<DealerManyWhereInput>;
};

export type MutationPublishManyDepartmentsArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<DepartmentManyWhereInput>;
};

export type MutationPublishManyDepartmentsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<DepartmentManyWhereInput>;
};

export type MutationPublishManyFootnotesArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<FootnoteManyWhereInput>;
};

export type MutationPublishManyFootnotesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<FootnoteManyWhereInput>;
};

export type MutationPublishManyGeneralServicesArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<GeneralServiceManyWhereInput>;
};

export type MutationPublishManyGeneralServicesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<GeneralServiceManyWhereInput>;
};

export type MutationPublishManyHomeTeasersArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<HomeTeaserManyWhereInput>;
};

export type MutationPublishManyHomeTeasersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<HomeTeaserManyWhereInput>;
};

export type MutationPublishManyModelsArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<ModelManyWhereInput>;
};

export type MutationPublishManyModelsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<ModelManyWhereInput>;
};

export type MutationPublishManyOverlayBatteryCertificatesArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<OverlayBatteryCertificateManyWhereInput>;
};

export type MutationPublishManyOverlayBatteryCertificatesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<OverlayBatteryCertificateManyWhereInput>;
};

export type MutationPublishManyPageAboutUsesArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<PageAboutUsManyWhereInput>;
};

export type MutationPublishManyPageAboutUsesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<PageAboutUsManyWhereInput>;
};

export type MutationPublishManyPageBusinessCustomersArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<PageBusinessCustomerManyWhereInput>;
};

export type MutationPublishManyPageBusinessCustomersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<PageBusinessCustomerManyWhereInput>;
};

export type MutationPublishManyPageHomesArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<PageHomeManyWhereInput>;
};

export type MutationPublishManyPageHomesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<PageHomeManyWhereInput>;
};

export type MutationPublishManyPageHyundaiPromisesArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<PageHyundaiPromiseManyWhereInput>;
};

export type MutationPublishManyPageHyundaiPromisesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<PageHyundaiPromiseManyWhereInput>;
};

export type MutationPublishManyPageServicesArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<PageServiceManyWhereInput>;
};

export type MutationPublishManyPageServicesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<PageServiceManyWhereInput>;
};

export type MutationPublishManyPageWarrantiesArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<PageWarrantyManyWhereInput>;
};

export type MutationPublishManyPageWarrantiesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<PageWarrantyManyWhereInput>;
};

export type MutationPublishManyVehiclesArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<VehicleManyWhereInput>;
};

export type MutationPublishManyVehiclesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<VehicleManyWhereInput>;
};

export type MutationPublishManyWarrantiesArgs = {
    to?: Array<Stage>;
    where?: InputMaybe<WarrantyManyWhereInput>;
};

export type MutationPublishManyWarrantiesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    to?: Array<Stage>;
    where?: InputMaybe<WarrantyManyWhereInput>;
};

export type MutationPublishModelArgs = {
    to?: Array<Stage>;
    where: ModelWhereUniqueInput;
};

export type MutationPublishOverlayBatteryCertificateArgs = {
    to?: Array<Stage>;
    where: OverlayBatteryCertificateWhereUniqueInput;
};

export type MutationPublishPageAboutUsArgs = {
    to?: Array<Stage>;
    where: PageAboutUsWhereUniqueInput;
};

export type MutationPublishPageBusinessCustomerArgs = {
    to?: Array<Stage>;
    where: PageBusinessCustomerWhereUniqueInput;
};

export type MutationPublishPageHomeArgs = {
    to?: Array<Stage>;
    where: PageHomeWhereUniqueInput;
};

export type MutationPublishPageHyundaiPromiseArgs = {
    to?: Array<Stage>;
    where: PageHyundaiPromiseWhereUniqueInput;
};

export type MutationPublishPageServiceArgs = {
    to?: Array<Stage>;
    where: PageServiceWhereUniqueInput;
};

export type MutationPublishPageWarrantyArgs = {
    to?: Array<Stage>;
    where: PageWarrantyWhereUniqueInput;
};

export type MutationPublishVehicleArgs = {
    to?: Array<Stage>;
    where: VehicleWhereUniqueInput;
};

export type MutationPublishWarrantyArgs = {
    to?: Array<Stage>;
    where: WarrantyWhereUniqueInput;
};

export type MutationSchedulePublishAssetArgs = {
    locales?: InputMaybe<Array<Locale>>;
    publishBase?: InputMaybe<Scalars['Boolean']['input']>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: AssetWhereUniqueInput;
    withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationSchedulePublishAuth0UserArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: Auth0UserWhereUniqueInput;
};

export type MutationSchedulePublishCampaignArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: CampaignWhereUniqueInput;
};

export type MutationSchedulePublishCampaignServiceArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: CampaignServiceWhereUniqueInput;
};

export type MutationSchedulePublishDealerArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: DealerWhereUniqueInput;
};

export type MutationSchedulePublishDepartmentArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: DepartmentWhereUniqueInput;
};

export type MutationSchedulePublishFootnoteArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: FootnoteWhereUniqueInput;
};

export type MutationSchedulePublishGeneralServiceArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: GeneralServiceWhereUniqueInput;
};

export type MutationSchedulePublishHomeTeaserArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: HomeTeaserWhereUniqueInput;
};

export type MutationSchedulePublishModelArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: ModelWhereUniqueInput;
};

export type MutationSchedulePublishOverlayBatteryCertificateArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: OverlayBatteryCertificateWhereUniqueInput;
};

export type MutationSchedulePublishPageAboutUsArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: PageAboutUsWhereUniqueInput;
};

export type MutationSchedulePublishPageBusinessCustomerArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: PageBusinessCustomerWhereUniqueInput;
};

export type MutationSchedulePublishPageHomeArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: PageHomeWhereUniqueInput;
};

export type MutationSchedulePublishPageHyundaiPromiseArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: PageHyundaiPromiseWhereUniqueInput;
};

export type MutationSchedulePublishPageServiceArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: PageServiceWhereUniqueInput;
};

export type MutationSchedulePublishPageWarrantyArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: PageWarrantyWhereUniqueInput;
};

export type MutationSchedulePublishVehicleArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: VehicleWhereUniqueInput;
};

export type MutationSchedulePublishWarrantyArgs = {
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    to?: Array<Stage>;
    where: WarrantyWhereUniqueInput;
};

export type MutationScheduleUnpublishAssetArgs = {
    from?: Array<Stage>;
    locales?: InputMaybe<Array<Locale>>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
    where: AssetWhereUniqueInput;
};

export type MutationScheduleUnpublishAuth0UserArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: Auth0UserWhereUniqueInput;
};

export type MutationScheduleUnpublishCampaignArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: CampaignWhereUniqueInput;
};

export type MutationScheduleUnpublishCampaignServiceArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: CampaignServiceWhereUniqueInput;
};

export type MutationScheduleUnpublishDealerArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: DealerWhereUniqueInput;
};

export type MutationScheduleUnpublishDepartmentArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: DepartmentWhereUniqueInput;
};

export type MutationScheduleUnpublishFootnoteArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: FootnoteWhereUniqueInput;
};

export type MutationScheduleUnpublishGeneralServiceArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: GeneralServiceWhereUniqueInput;
};

export type MutationScheduleUnpublishHomeTeaserArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: HomeTeaserWhereUniqueInput;
};

export type MutationScheduleUnpublishModelArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: ModelWhereUniqueInput;
};

export type MutationScheduleUnpublishOverlayBatteryCertificateArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: OverlayBatteryCertificateWhereUniqueInput;
};

export type MutationScheduleUnpublishPageAboutUsArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: PageAboutUsWhereUniqueInput;
};

export type MutationScheduleUnpublishPageBusinessCustomerArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: PageBusinessCustomerWhereUniqueInput;
};

export type MutationScheduleUnpublishPageHomeArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: PageHomeWhereUniqueInput;
};

export type MutationScheduleUnpublishPageHyundaiPromiseArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: PageHyundaiPromiseWhereUniqueInput;
};

export type MutationScheduleUnpublishPageServiceArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: PageServiceWhereUniqueInput;
};

export type MutationScheduleUnpublishPageWarrantyArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: PageWarrantyWhereUniqueInput;
};

export type MutationScheduleUnpublishVehicleArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: VehicleWhereUniqueInput;
};

export type MutationScheduleUnpublishWarrantyArgs = {
    from?: Array<Stage>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    releaseId?: InputMaybe<Scalars['String']['input']>;
    where: WarrantyWhereUniqueInput;
};

export type MutationUnpublishAssetArgs = {
    from?: Array<Stage>;
    locales?: InputMaybe<Array<Locale>>;
    unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
    where: AssetWhereUniqueInput;
};

export type MutationUnpublishAuth0UserArgs = {
    from?: Array<Stage>;
    where: Auth0UserWhereUniqueInput;
};

export type MutationUnpublishCampaignArgs = {
    from?: Array<Stage>;
    where: CampaignWhereUniqueInput;
};

export type MutationUnpublishCampaignServiceArgs = {
    from?: Array<Stage>;
    where: CampaignServiceWhereUniqueInput;
};

export type MutationUnpublishDealerArgs = {
    from?: Array<Stage>;
    where: DealerWhereUniqueInput;
};

export type MutationUnpublishDepartmentArgs = {
    from?: Array<Stage>;
    where: DepartmentWhereUniqueInput;
};

export type MutationUnpublishFootnoteArgs = {
    from?: Array<Stage>;
    where: FootnoteWhereUniqueInput;
};

export type MutationUnpublishGeneralServiceArgs = {
    from?: Array<Stage>;
    where: GeneralServiceWhereUniqueInput;
};

export type MutationUnpublishHomeTeaserArgs = {
    from?: Array<Stage>;
    where: HomeTeaserWhereUniqueInput;
};

export type MutationUnpublishManyAssetsArgs = {
    from?: Array<Stage>;
    locales?: InputMaybe<Array<Locale>>;
    unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<AssetManyWhereInput>;
};

export type MutationUnpublishManyAssetsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<AssetManyWhereInput>;
};

export type MutationUnpublishManyAuth0UsersArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<Auth0UserManyWhereInput>;
};

export type MutationUnpublishManyAuth0UsersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<Auth0UserManyWhereInput>;
};

export type MutationUnpublishManyCampaignServicesArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<CampaignServiceManyWhereInput>;
};

export type MutationUnpublishManyCampaignServicesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<CampaignServiceManyWhereInput>;
};

export type MutationUnpublishManyCampaignsArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<CampaignManyWhereInput>;
};

export type MutationUnpublishManyCampaignsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<CampaignManyWhereInput>;
};

export type MutationUnpublishManyDealersArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<DealerManyWhereInput>;
};

export type MutationUnpublishManyDealersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<DealerManyWhereInput>;
};

export type MutationUnpublishManyDepartmentsArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<DepartmentManyWhereInput>;
};

export type MutationUnpublishManyDepartmentsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<DepartmentManyWhereInput>;
};

export type MutationUnpublishManyFootnotesArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<FootnoteManyWhereInput>;
};

export type MutationUnpublishManyFootnotesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<FootnoteManyWhereInput>;
};

export type MutationUnpublishManyGeneralServicesArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<GeneralServiceManyWhereInput>;
};

export type MutationUnpublishManyGeneralServicesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<GeneralServiceManyWhereInput>;
};

export type MutationUnpublishManyHomeTeasersArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<HomeTeaserManyWhereInput>;
};

export type MutationUnpublishManyHomeTeasersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<HomeTeaserManyWhereInput>;
};

export type MutationUnpublishManyModelsArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<ModelManyWhereInput>;
};

export type MutationUnpublishManyModelsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<ModelManyWhereInput>;
};

export type MutationUnpublishManyOverlayBatteryCertificatesArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<OverlayBatteryCertificateManyWhereInput>;
};

export type MutationUnpublishManyOverlayBatteryCertificatesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<OverlayBatteryCertificateManyWhereInput>;
};

export type MutationUnpublishManyPageAboutUsesArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<PageAboutUsManyWhereInput>;
};

export type MutationUnpublishManyPageAboutUsesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<PageAboutUsManyWhereInput>;
};

export type MutationUnpublishManyPageBusinessCustomersArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<PageBusinessCustomerManyWhereInput>;
};

export type MutationUnpublishManyPageBusinessCustomersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<PageBusinessCustomerManyWhereInput>;
};

export type MutationUnpublishManyPageHomesArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<PageHomeManyWhereInput>;
};

export type MutationUnpublishManyPageHomesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<PageHomeManyWhereInput>;
};

export type MutationUnpublishManyPageHyundaiPromisesArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<PageHyundaiPromiseManyWhereInput>;
};

export type MutationUnpublishManyPageHyundaiPromisesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<PageHyundaiPromiseManyWhereInput>;
};

export type MutationUnpublishManyPageServicesArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<PageServiceManyWhereInput>;
};

export type MutationUnpublishManyPageServicesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<PageServiceManyWhereInput>;
};

export type MutationUnpublishManyPageWarrantiesArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<PageWarrantyManyWhereInput>;
};

export type MutationUnpublishManyPageWarrantiesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<PageWarrantyManyWhereInput>;
};

export type MutationUnpublishManyVehiclesArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<VehicleManyWhereInput>;
};

export type MutationUnpublishManyVehiclesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<VehicleManyWhereInput>;
};

export type MutationUnpublishManyWarrantiesArgs = {
    from?: Array<Stage>;
    where?: InputMaybe<WarrantyManyWhereInput>;
};

export type MutationUnpublishManyWarrantiesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from?: Array<Stage>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: InputMaybe<Stage>;
    where?: InputMaybe<WarrantyManyWhereInput>;
};

export type MutationUnpublishModelArgs = {
    from?: Array<Stage>;
    where: ModelWhereUniqueInput;
};

export type MutationUnpublishOverlayBatteryCertificateArgs = {
    from?: Array<Stage>;
    where: OverlayBatteryCertificateWhereUniqueInput;
};

export type MutationUnpublishPageAboutUsArgs = {
    from?: Array<Stage>;
    where: PageAboutUsWhereUniqueInput;
};

export type MutationUnpublishPageBusinessCustomerArgs = {
    from?: Array<Stage>;
    where: PageBusinessCustomerWhereUniqueInput;
};

export type MutationUnpublishPageHomeArgs = {
    from?: Array<Stage>;
    where: PageHomeWhereUniqueInput;
};

export type MutationUnpublishPageHyundaiPromiseArgs = {
    from?: Array<Stage>;
    where: PageHyundaiPromiseWhereUniqueInput;
};

export type MutationUnpublishPageServiceArgs = {
    from?: Array<Stage>;
    where: PageServiceWhereUniqueInput;
};

export type MutationUnpublishPageWarrantyArgs = {
    from?: Array<Stage>;
    where: PageWarrantyWhereUniqueInput;
};

export type MutationUnpublishVehicleArgs = {
    from?: Array<Stage>;
    where: VehicleWhereUniqueInput;
};

export type MutationUnpublishWarrantyArgs = {
    from?: Array<Stage>;
    where: WarrantyWhereUniqueInput;
};

export type MutationUpdateAssetArgs = {
    data: AssetUpdateInput;
    where: AssetWhereUniqueInput;
};

export type MutationUpdateAuth0UserArgs = {
    data: Auth0UserUpdateInput;
    where: Auth0UserWhereUniqueInput;
};

export type MutationUpdateCampaignArgs = {
    data: CampaignUpdateInput;
    where: CampaignWhereUniqueInput;
};

export type MutationUpdateCampaignServiceArgs = {
    data: CampaignServiceUpdateInput;
    where: CampaignServiceWhereUniqueInput;
};

export type MutationUpdateDealerArgs = {
    data: DealerUpdateInput;
    where: DealerWhereUniqueInput;
};

export type MutationUpdateDepartmentArgs = {
    data: DepartmentUpdateInput;
    where: DepartmentWhereUniqueInput;
};

export type MutationUpdateFootnoteArgs = {
    data: FootnoteUpdateInput;
    where: FootnoteWhereUniqueInput;
};

export type MutationUpdateGeneralServiceArgs = {
    data: GeneralServiceUpdateInput;
    where: GeneralServiceWhereUniqueInput;
};

export type MutationUpdateHomeTeaserArgs = {
    data: HomeTeaserUpdateInput;
    where: HomeTeaserWhereUniqueInput;
};

export type MutationUpdateManyAssetsArgs = {
    data: AssetUpdateManyInput;
    where?: InputMaybe<AssetManyWhereInput>;
};

export type MutationUpdateManyAssetsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: AssetUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AssetManyWhereInput>;
};

export type MutationUpdateManyAuth0UsersArgs = {
    data: Auth0UserUpdateManyInput;
    where?: InputMaybe<Auth0UserManyWhereInput>;
};

export type MutationUpdateManyAuth0UsersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: Auth0UserUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<Auth0UserManyWhereInput>;
};

export type MutationUpdateManyCampaignServicesArgs = {
    data: CampaignServiceUpdateManyInput;
    where?: InputMaybe<CampaignServiceManyWhereInput>;
};

export type MutationUpdateManyCampaignServicesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: CampaignServiceUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CampaignServiceManyWhereInput>;
};

export type MutationUpdateManyCampaignsArgs = {
    data: CampaignUpdateManyInput;
    where?: InputMaybe<CampaignManyWhereInput>;
};

export type MutationUpdateManyCampaignsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: CampaignUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CampaignManyWhereInput>;
};

export type MutationUpdateManyDealersArgs = {
    data: DealerUpdateManyInput;
    where?: InputMaybe<DealerManyWhereInput>;
};

export type MutationUpdateManyDealersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: DealerUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DealerManyWhereInput>;
};

export type MutationUpdateManyDepartmentsArgs = {
    data: DepartmentUpdateManyInput;
    where?: InputMaybe<DepartmentManyWhereInput>;
};

export type MutationUpdateManyDepartmentsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: DepartmentUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DepartmentManyWhereInput>;
};

export type MutationUpdateManyFootnotesArgs = {
    data: FootnoteUpdateManyInput;
    where?: InputMaybe<FootnoteManyWhereInput>;
};

export type MutationUpdateManyFootnotesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: FootnoteUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FootnoteManyWhereInput>;
};

export type MutationUpdateManyGeneralServicesArgs = {
    data: GeneralServiceUpdateManyInput;
    where?: InputMaybe<GeneralServiceManyWhereInput>;
};

export type MutationUpdateManyGeneralServicesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: GeneralServiceUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GeneralServiceManyWhereInput>;
};

export type MutationUpdateManyHomeTeasersArgs = {
    data: HomeTeaserUpdateManyInput;
    where?: InputMaybe<HomeTeaserManyWhereInput>;
};

export type MutationUpdateManyHomeTeasersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: HomeTeaserUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HomeTeaserManyWhereInput>;
};

export type MutationUpdateManyModelsArgs = {
    data: ModelUpdateManyInput;
    where?: InputMaybe<ModelManyWhereInput>;
};

export type MutationUpdateManyModelsConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: ModelUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ModelManyWhereInput>;
};

export type MutationUpdateManyOverlayBatteryCertificatesArgs = {
    data: OverlayBatteryCertificateUpdateManyInput;
    where?: InputMaybe<OverlayBatteryCertificateManyWhereInput>;
};

export type MutationUpdateManyOverlayBatteryCertificatesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: OverlayBatteryCertificateUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OverlayBatteryCertificateManyWhereInput>;
};

export type MutationUpdateManyPageAboutUsesArgs = {
    data: PageAboutUsUpdateManyInput;
    where?: InputMaybe<PageAboutUsManyWhereInput>;
};

export type MutationUpdateManyPageAboutUsesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: PageAboutUsUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageAboutUsManyWhereInput>;
};

export type MutationUpdateManyPageBusinessCustomersArgs = {
    data: PageBusinessCustomerUpdateManyInput;
    where?: InputMaybe<PageBusinessCustomerManyWhereInput>;
};

export type MutationUpdateManyPageBusinessCustomersConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: PageBusinessCustomerUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageBusinessCustomerManyWhereInput>;
};

export type MutationUpdateManyPageHomesArgs = {
    data: PageHomeUpdateManyInput;
    where?: InputMaybe<PageHomeManyWhereInput>;
};

export type MutationUpdateManyPageHomesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: PageHomeUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageHomeManyWhereInput>;
};

export type MutationUpdateManyPageHyundaiPromisesArgs = {
    data: PageHyundaiPromiseUpdateManyInput;
    where?: InputMaybe<PageHyundaiPromiseManyWhereInput>;
};

export type MutationUpdateManyPageHyundaiPromisesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: PageHyundaiPromiseUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageHyundaiPromiseManyWhereInput>;
};

export type MutationUpdateManyPageServicesArgs = {
    data: PageServiceUpdateManyInput;
    where?: InputMaybe<PageServiceManyWhereInput>;
};

export type MutationUpdateManyPageServicesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: PageServiceUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageServiceManyWhereInput>;
};

export type MutationUpdateManyPageWarrantiesArgs = {
    data: PageWarrantyUpdateManyInput;
    where?: InputMaybe<PageWarrantyManyWhereInput>;
};

export type MutationUpdateManyPageWarrantiesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: PageWarrantyUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PageWarrantyManyWhereInput>;
};

export type MutationUpdateManyVehiclesArgs = {
    data: VehicleUpdateManyInput;
    where?: InputMaybe<VehicleManyWhereInput>;
};

export type MutationUpdateManyVehiclesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: VehicleUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<VehicleManyWhereInput>;
};

export type MutationUpdateManyWarrantiesArgs = {
    data: WarrantyUpdateManyInput;
    where?: InputMaybe<WarrantyManyWhereInput>;
};

export type MutationUpdateManyWarrantiesConnectionArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    before?: InputMaybe<Scalars['ID']['input']>;
    data: WarrantyUpdateManyInput;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<WarrantyManyWhereInput>;
};

export type MutationUpdateModelArgs = {
    data: ModelUpdateInput;
    where: ModelWhereUniqueInput;
};

export type MutationUpdateOverlayBatteryCertificateArgs = {
    data: OverlayBatteryCertificateUpdateInput;
    where: OverlayBatteryCertificateWhereUniqueInput;
};

export type MutationUpdatePageAboutUsArgs = {
    data: PageAboutUsUpdateInput;
    where: PageAboutUsWhereUniqueInput;
};

export type MutationUpdatePageBusinessCustomerArgs = {
    data: PageBusinessCustomerUpdateInput;
    where: PageBusinessCustomerWhereUniqueInput;
};

export type MutationUpdatePageHomeArgs = {
    data: PageHomeUpdateInput;
    where: PageHomeWhereUniqueInput;
};

export type MutationUpdatePageHyundaiPromiseArgs = {
    data: PageHyundaiPromiseUpdateInput;
    where: PageHyundaiPromiseWhereUniqueInput;
};

export type MutationUpdatePageServiceArgs = {
    data: PageServiceUpdateInput;
    where: PageServiceWhereUniqueInput;
};

export type MutationUpdatePageWarrantyArgs = {
    data: PageWarrantyUpdateInput;
    where: PageWarrantyWhereUniqueInput;
};

export type MutationUpdateScheduledReleaseArgs = {
    data: ScheduledReleaseUpdateInput;
    where: ScheduledReleaseWhereUniqueInput;
};

export type MutationUpdateVehicleArgs = {
    data: VehicleUpdateInput;
    where: VehicleWhereUniqueInput;
};

export type MutationUpdateWarrantyArgs = {
    data: WarrantyUpdateInput;
    where: WarrantyWhereUniqueInput;
};

export type MutationUpsertAssetArgs = {
    upsert: AssetUpsertInput;
    where: AssetWhereUniqueInput;
};

export type MutationUpsertAuth0UserArgs = {
    upsert: Auth0UserUpsertInput;
    where: Auth0UserWhereUniqueInput;
};

export type MutationUpsertCampaignArgs = {
    upsert: CampaignUpsertInput;
    where: CampaignWhereUniqueInput;
};

export type MutationUpsertCampaignServiceArgs = {
    upsert: CampaignServiceUpsertInput;
    where: CampaignServiceWhereUniqueInput;
};

export type MutationUpsertDealerArgs = {
    upsert: DealerUpsertInput;
    where: DealerWhereUniqueInput;
};

export type MutationUpsertDepartmentArgs = {
    upsert: DepartmentUpsertInput;
    where: DepartmentWhereUniqueInput;
};

export type MutationUpsertFootnoteArgs = {
    upsert: FootnoteUpsertInput;
    where: FootnoteWhereUniqueInput;
};

export type MutationUpsertGeneralServiceArgs = {
    upsert: GeneralServiceUpsertInput;
    where: GeneralServiceWhereUniqueInput;
};

export type MutationUpsertHomeTeaserArgs = {
    upsert: HomeTeaserUpsertInput;
    where: HomeTeaserWhereUniqueInput;
};

export type MutationUpsertModelArgs = {
    upsert: ModelUpsertInput;
    where: ModelWhereUniqueInput;
};

export type MutationUpsertOverlayBatteryCertificateArgs = {
    upsert: OverlayBatteryCertificateUpsertInput;
    where: OverlayBatteryCertificateWhereUniqueInput;
};

export type MutationUpsertPageAboutUsArgs = {
    upsert: PageAboutUsUpsertInput;
    where: PageAboutUsWhereUniqueInput;
};

export type MutationUpsertPageBusinessCustomerArgs = {
    upsert: PageBusinessCustomerUpsertInput;
    where: PageBusinessCustomerWhereUniqueInput;
};

export type MutationUpsertPageHomeArgs = {
    upsert: PageHomeUpsertInput;
    where: PageHomeWhereUniqueInput;
};

export type MutationUpsertPageHyundaiPromiseArgs = {
    upsert: PageHyundaiPromiseUpsertInput;
    where: PageHyundaiPromiseWhereUniqueInput;
};

export type MutationUpsertPageServiceArgs = {
    upsert: PageServiceUpsertInput;
    where: PageServiceWhereUniqueInput;
};

export type MutationUpsertPageWarrantyArgs = {
    upsert: PageWarrantyUpsertInput;
    where: PageWarrantyWhereUniqueInput;
};

export type MutationUpsertVehicleArgs = {
    upsert: VehicleUpsertInput;
    where: VehicleWhereUniqueInput;
};

export type MutationUpsertWarrantyArgs = {
    upsert: WarrantyUpsertInput;
    where: WarrantyWhereUniqueInput;
};

/** An object with an ID */
export type Node = {
    /** The id of the object. */
    id: Scalars['ID']['output'];
    /** The Stage of an object */
    stage: Stage;
};

export type Opening = Entity & {
    __typename?: 'Opening';
    from: Day;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    ranges: Array<TimeRange>;
    /** System stage field */
    stage: Stage;
    to: Day;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OpeningRangesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<TimeRangeOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TimeRangeWhereInput>;
};

export type OpeningConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: OpeningWhereUniqueInput;
};

/** A connection to a list of items. */
export type OpeningConnection = {
    __typename?: 'OpeningConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<OpeningEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type OpeningCreateInput = {
    from: Day;
    ranges?: InputMaybe<TimeRangeCreateManyInlineInput>;
    to: Day;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OpeningCreateManyInlineInput = {
    /** Create and connect multiple existing Opening documents */
    create?: InputMaybe<Array<OpeningCreateInput>>;
};

export type OpeningCreateOneInlineInput = {
    /** Create and connect one Opening document */
    create?: InputMaybe<OpeningCreateInput>;
};

export type OpeningCreateWithPositionInput = {
    /** Document to create */
    data: OpeningCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type OpeningEdge = {
    __typename?: 'OpeningEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Opening;
};

/** Identifies documents */
export type OpeningManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<OpeningWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<OpeningWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<OpeningWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    from?: InputMaybe<Day>;
    /** All values that are contained in given list. */
    from_in?: InputMaybe<Array<InputMaybe<Day>>>;
    /** Any other value that exists and is not equal to the given value. */
    from_not?: InputMaybe<Day>;
    /** All values that are not contained in given list. */
    from_not_in?: InputMaybe<Array<InputMaybe<Day>>>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    ranges_every?: InputMaybe<TimeRangeWhereInput>;
    ranges_none?: InputMaybe<TimeRangeWhereInput>;
    ranges_some?: InputMaybe<TimeRangeWhereInput>;
    to?: InputMaybe<Day>;
    /** All values that are contained in given list. */
    to_in?: InputMaybe<Array<InputMaybe<Day>>>;
    /** Any other value that exists and is not equal to the given value. */
    to_not?: InputMaybe<Day>;
    /** All values that are not contained in given list. */
    to_not_in?: InputMaybe<Array<InputMaybe<Day>>>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum OpeningOrderByInput {
    FromAsc = 'from_ASC',
    FromDesc = 'from_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    ToAsc = 'to_ASC',
    ToDesc = 'to_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type OpeningParent = Dealer;

export type OpeningParentConnectInput = {
    Dealer?: InputMaybe<DealerConnectInput>;
};

export type OpeningParentCreateInput = {
    Dealer?: InputMaybe<DealerCreateInput>;
};

export type OpeningParentCreateManyInlineInput = {
    /** Connect multiple existing OpeningParent documents */
    connect?: InputMaybe<Array<OpeningParentWhereUniqueInput>>;
    /** Create and connect multiple existing OpeningParent documents */
    create?: InputMaybe<Array<OpeningParentCreateInput>>;
};

export type OpeningParentCreateOneInlineInput = {
    /** Connect one existing OpeningParent document */
    connect?: InputMaybe<OpeningParentWhereUniqueInput>;
    /** Create and connect one OpeningParent document */
    create?: InputMaybe<OpeningParentCreateInput>;
};

export type OpeningParentUpdateInput = {
    Dealer?: InputMaybe<DealerUpdateInput>;
};

export type OpeningParentUpdateManyInlineInput = {
    /** Connect multiple existing OpeningParent documents */
    connect?: InputMaybe<Array<OpeningParentConnectInput>>;
    /** Create and connect multiple OpeningParent documents */
    create?: InputMaybe<Array<OpeningParentCreateInput>>;
    /** Delete multiple OpeningParent documents */
    delete?: InputMaybe<Array<OpeningParentWhereUniqueInput>>;
    /** Disconnect multiple OpeningParent documents */
    disconnect?: InputMaybe<Array<OpeningParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing OpeningParent documents */
    set?: InputMaybe<Array<OpeningParentWhereUniqueInput>>;
    /** Update multiple OpeningParent documents */
    update?: InputMaybe<Array<OpeningParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple OpeningParent documents */
    upsert?: InputMaybe<Array<OpeningParentUpsertWithNestedWhereUniqueInput>>;
};

export type OpeningParentUpdateManyWithNestedWhereInput = {
    Dealer?: InputMaybe<DealerUpdateManyWithNestedWhereInput>;
};

export type OpeningParentUpdateOneInlineInput = {
    /** Connect existing OpeningParent document */
    connect?: InputMaybe<OpeningParentWhereUniqueInput>;
    /** Create and connect one OpeningParent document */
    create?: InputMaybe<OpeningParentCreateInput>;
    /** Delete currently connected OpeningParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected OpeningParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single OpeningParent document */
    update?: InputMaybe<OpeningParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single OpeningParent document */
    upsert?: InputMaybe<OpeningParentUpsertWithNestedWhereUniqueInput>;
};

export type OpeningParentUpdateWithNestedWhereUniqueInput = {
    Dealer?: InputMaybe<DealerUpdateWithNestedWhereUniqueInput>;
};

export type OpeningParentUpsertWithNestedWhereUniqueInput = {
    Dealer?: InputMaybe<DealerUpsertWithNestedWhereUniqueInput>;
};

export type OpeningParentWhereInput = {
    Dealer?: InputMaybe<DealerWhereInput>;
};

export type OpeningParentWhereUniqueInput = {
    Dealer?: InputMaybe<DealerWhereUniqueInput>;
};

export type OpeningUpdateInput = {
    from?: InputMaybe<Day>;
    ranges?: InputMaybe<TimeRangeUpdateManyInlineInput>;
    to?: InputMaybe<Day>;
};

export type OpeningUpdateManyInlineInput = {
    /** Create and connect multiple Opening component instances */
    create?: InputMaybe<Array<OpeningCreateWithPositionInput>>;
    /** Delete multiple Opening documents */
    delete?: InputMaybe<Array<OpeningWhereUniqueInput>>;
    /** Update multiple Opening component instances */
    update?: InputMaybe<Array<OpeningUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple Opening component instances */
    upsert?: InputMaybe<Array<OpeningUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type OpeningUpdateManyInput = {
    from?: InputMaybe<Day>;
    to?: InputMaybe<Day>;
};

export type OpeningUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: OpeningUpdateManyInput;
    /** Document search */
    where: OpeningWhereInput;
};

export type OpeningUpdateOneInlineInput = {
    /** Create and connect one Opening document */
    create?: InputMaybe<OpeningCreateInput>;
    /** Delete currently connected Opening document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Opening document */
    update?: InputMaybe<OpeningUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Opening document */
    upsert?: InputMaybe<OpeningUpsertWithNestedWhereUniqueInput>;
};

export type OpeningUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<OpeningUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: OpeningWhereUniqueInput;
};

export type OpeningUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: OpeningUpdateInput;
    /** Unique document search */
    where: OpeningWhereUniqueInput;
};

export type OpeningUpsertInput = {
    /** Create document if it didn't exist */
    create: OpeningCreateInput;
    /** Update document if it exists */
    update: OpeningUpdateInput;
};

export type OpeningUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<OpeningUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: OpeningWhereUniqueInput;
};

export type OpeningUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: OpeningUpsertInput;
    /** Unique document search */
    where: OpeningWhereUniqueInput;
};

/** Identifies documents */
export type OpeningWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<OpeningWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<OpeningWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<OpeningWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    from?: InputMaybe<Day>;
    /** All values that are contained in given list. */
    from_in?: InputMaybe<Array<InputMaybe<Day>>>;
    /** Any other value that exists and is not equal to the given value. */
    from_not?: InputMaybe<Day>;
    /** All values that are not contained in given list. */
    from_not_in?: InputMaybe<Array<InputMaybe<Day>>>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    ranges_every?: InputMaybe<TimeRangeWhereInput>;
    ranges_none?: InputMaybe<TimeRangeWhereInput>;
    ranges_some?: InputMaybe<TimeRangeWhereInput>;
    to?: InputMaybe<Day>;
    /** All values that are contained in given list. */
    to_in?: InputMaybe<Array<InputMaybe<Day>>>;
    /** Any other value that exists and is not equal to the given value. */
    to_not?: InputMaybe<Day>;
    /** All values that are not contained in given list. */
    to_not_in?: InputMaybe<Array<InputMaybe<Day>>>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Opening record uniquely */
export type OpeningWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type OverlayBatteryCertificate = Entity &
    Node & {
        __typename?: 'OverlayBatteryCertificate';
        boxHeadline: Scalars['String']['output'];
        boxList: Array<HeadlineText>;
        contentHeadline: Scalars['String']['output'];
        contentImage: Asset;
        contentList: Array<HeadlineText>;
        contentSubheadline?: Maybe<Scalars['String']['output']>;
        contentText?: Maybe<RichText>;
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Get the document in other stages */
        documentInStages: Array<OverlayBatteryCertificate>;
        heroHeadline: Scalars['String']['output'];
        heroImage: Asset;
        heroSubheadline?: Maybe<Scalars['String']['output']>;
        heroText: Scalars['String']['output'];
        /** List of OverlayBatteryCertificate versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        legalLines?: Maybe<RichText>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

export type OverlayBatteryCertificateBoxListArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<HeadlineTextOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HeadlineTextWhereInput>;
};

export type OverlayBatteryCertificateContentImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type OverlayBatteryCertificateContentListArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<HeadlineTextOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HeadlineTextWhereInput>;
};

export type OverlayBatteryCertificateCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type OverlayBatteryCertificateDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type OverlayBatteryCertificateHeroImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type OverlayBatteryCertificateHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type OverlayBatteryCertificatePublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type OverlayBatteryCertificateScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type OverlayBatteryCertificateUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type OverlayBatteryCertificateConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: OverlayBatteryCertificateWhereUniqueInput;
};

/** A connection to a list of items. */
export type OverlayBatteryCertificateConnection = {
    __typename?: 'OverlayBatteryCertificateConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<OverlayBatteryCertificateEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type OverlayBatteryCertificateCreateInput = {
    boxHeadline: Scalars['String']['input'];
    boxList?: InputMaybe<HeadlineTextCreateManyInlineInput>;
    contentHeadline: Scalars['String']['input'];
    contentImage: AssetCreateOneInlineInput;
    contentList?: InputMaybe<HeadlineTextCreateManyInlineInput>;
    contentSubheadline?: InputMaybe<Scalars['String']['input']>;
    contentText?: InputMaybe<Scalars['RichTextAST']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    heroHeadline: Scalars['String']['input'];
    heroImage: AssetCreateOneInlineInput;
    heroSubheadline?: InputMaybe<Scalars['String']['input']>;
    heroText: Scalars['String']['input'];
    legalLines?: InputMaybe<Scalars['RichTextAST']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OverlayBatteryCertificateCreateManyInlineInput = {
    /** Connect multiple existing OverlayBatteryCertificate documents */
    connect?: InputMaybe<Array<OverlayBatteryCertificateWhereUniqueInput>>;
    /** Create and connect multiple existing OverlayBatteryCertificate documents */
    create?: InputMaybe<Array<OverlayBatteryCertificateCreateInput>>;
};

export type OverlayBatteryCertificateCreateOneInlineInput = {
    /** Connect one existing OverlayBatteryCertificate document */
    connect?: InputMaybe<OverlayBatteryCertificateWhereUniqueInput>;
    /** Create and connect one OverlayBatteryCertificate document */
    create?: InputMaybe<OverlayBatteryCertificateCreateInput>;
};

/** An edge in a connection. */
export type OverlayBatteryCertificateEdge = {
    __typename?: 'OverlayBatteryCertificateEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: OverlayBatteryCertificate;
};

/** Identifies documents */
export type OverlayBatteryCertificateManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<OverlayBatteryCertificateWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<OverlayBatteryCertificateWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<OverlayBatteryCertificateWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    boxHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    boxHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    boxHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    boxHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    boxHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    boxHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    boxHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    boxHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    boxHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    boxHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    boxList_every?: InputMaybe<HeadlineTextWhereInput>;
    boxList_none?: InputMaybe<HeadlineTextWhereInput>;
    boxList_some?: InputMaybe<HeadlineTextWhereInput>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentImage?: InputMaybe<AssetWhereInput>;
    contentList_every?: InputMaybe<HeadlineTextWhereInput>;
    contentList_none?: InputMaybe<HeadlineTextWhereInput>;
    contentList_some?: InputMaybe<HeadlineTextWhereInput>;
    contentSubheadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<OverlayBatteryCertificateWhereStageInput>;
    documentInStages_none?: InputMaybe<OverlayBatteryCertificateWhereStageInput>;
    documentInStages_some?: InputMaybe<OverlayBatteryCertificateWhereStageInput>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    heroSubheadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroText_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum OverlayBatteryCertificateOrderByInput {
    BoxHeadlineAsc = 'boxHeadline_ASC',
    BoxHeadlineDesc = 'boxHeadline_DESC',
    ContentHeadlineAsc = 'contentHeadline_ASC',
    ContentHeadlineDesc = 'contentHeadline_DESC',
    ContentSubheadlineAsc = 'contentSubheadline_ASC',
    ContentSubheadlineDesc = 'contentSubheadline_DESC',
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    HeroHeadlineAsc = 'heroHeadline_ASC',
    HeroHeadlineDesc = 'heroHeadline_DESC',
    HeroSubheadlineAsc = 'heroSubheadline_ASC',
    HeroSubheadlineDesc = 'heroSubheadline_DESC',
    HeroTextAsc = 'heroText_ASC',
    HeroTextDesc = 'heroText_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type OverlayBatteryCertificateUpdateInput = {
    boxHeadline?: InputMaybe<Scalars['String']['input']>;
    boxList?: InputMaybe<HeadlineTextUpdateManyInlineInput>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    contentImage?: InputMaybe<AssetUpdateOneInlineInput>;
    contentList?: InputMaybe<HeadlineTextUpdateManyInlineInput>;
    contentSubheadline?: InputMaybe<Scalars['String']['input']>;
    contentText?: InputMaybe<Scalars['RichTextAST']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetUpdateOneInlineInput>;
    heroSubheadline?: InputMaybe<Scalars['String']['input']>;
    heroText?: InputMaybe<Scalars['String']['input']>;
    legalLines?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type OverlayBatteryCertificateUpdateManyInlineInput = {
    /** Connect multiple existing OverlayBatteryCertificate documents */
    connect?: InputMaybe<Array<OverlayBatteryCertificateConnectInput>>;
    /** Create and connect multiple OverlayBatteryCertificate documents */
    create?: InputMaybe<Array<OverlayBatteryCertificateCreateInput>>;
    /** Delete multiple OverlayBatteryCertificate documents */
    delete?: InputMaybe<Array<OverlayBatteryCertificateWhereUniqueInput>>;
    /** Disconnect multiple OverlayBatteryCertificate documents */
    disconnect?: InputMaybe<Array<OverlayBatteryCertificateWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing OverlayBatteryCertificate documents */
    set?: InputMaybe<Array<OverlayBatteryCertificateWhereUniqueInput>>;
    /** Update multiple OverlayBatteryCertificate documents */
    update?: InputMaybe<Array<OverlayBatteryCertificateUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple OverlayBatteryCertificate documents */
    upsert?: InputMaybe<Array<OverlayBatteryCertificateUpsertWithNestedWhereUniqueInput>>;
};

export type OverlayBatteryCertificateUpdateManyInput = {
    boxHeadline?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    contentSubheadline?: InputMaybe<Scalars['String']['input']>;
    contentText?: InputMaybe<Scalars['RichTextAST']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    heroSubheadline?: InputMaybe<Scalars['String']['input']>;
    heroText?: InputMaybe<Scalars['String']['input']>;
    legalLines?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type OverlayBatteryCertificateUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: OverlayBatteryCertificateUpdateManyInput;
    /** Document search */
    where: OverlayBatteryCertificateWhereInput;
};

export type OverlayBatteryCertificateUpdateOneInlineInput = {
    /** Connect existing OverlayBatteryCertificate document */
    connect?: InputMaybe<OverlayBatteryCertificateWhereUniqueInput>;
    /** Create and connect one OverlayBatteryCertificate document */
    create?: InputMaybe<OverlayBatteryCertificateCreateInput>;
    /** Delete currently connected OverlayBatteryCertificate document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected OverlayBatteryCertificate document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single OverlayBatteryCertificate document */
    update?: InputMaybe<OverlayBatteryCertificateUpdateWithNestedWhereUniqueInput>;
    /** Upsert single OverlayBatteryCertificate document */
    upsert?: InputMaybe<OverlayBatteryCertificateUpsertWithNestedWhereUniqueInput>;
};

export type OverlayBatteryCertificateUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: OverlayBatteryCertificateUpdateInput;
    /** Unique document search */
    where: OverlayBatteryCertificateWhereUniqueInput;
};

export type OverlayBatteryCertificateUpsertInput = {
    /** Create document if it didn't exist */
    create: OverlayBatteryCertificateCreateInput;
    /** Update document if it exists */
    update: OverlayBatteryCertificateUpdateInput;
};

export type OverlayBatteryCertificateUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: OverlayBatteryCertificateUpsertInput;
    /** Unique document search */
    where: OverlayBatteryCertificateWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type OverlayBatteryCertificateWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type OverlayBatteryCertificateWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<OverlayBatteryCertificateWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<OverlayBatteryCertificateWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<OverlayBatteryCertificateWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    boxHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    boxHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    boxHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    boxHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    boxHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    boxHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    boxHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    boxHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    boxHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    boxHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    boxList_every?: InputMaybe<HeadlineTextWhereInput>;
    boxList_none?: InputMaybe<HeadlineTextWhereInput>;
    boxList_some?: InputMaybe<HeadlineTextWhereInput>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentImage?: InputMaybe<AssetWhereInput>;
    contentList_every?: InputMaybe<HeadlineTextWhereInput>;
    contentList_none?: InputMaybe<HeadlineTextWhereInput>;
    contentList_some?: InputMaybe<HeadlineTextWhereInput>;
    contentSubheadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<OverlayBatteryCertificateWhereStageInput>;
    documentInStages_none?: InputMaybe<OverlayBatteryCertificateWhereStageInput>;
    documentInStages_some?: InputMaybe<OverlayBatteryCertificateWhereStageInput>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    heroSubheadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroText_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type OverlayBatteryCertificateWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<OverlayBatteryCertificateWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<OverlayBatteryCertificateWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<OverlayBatteryCertificateWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<OverlayBatteryCertificateWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References OverlayBatteryCertificate record uniquely */
export type OverlayBatteryCertificateWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageAboutUs = Entity &
    Node & {
        __typename?: 'PageAboutUs';
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Get the document in other stages */
        documentInStages: Array<PageAboutUs>;
        employeePlaceholder?: Maybe<Asset>;
        heroImage?: Maybe<Asset>;
        /** List of PageAboutUs versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        jobsDefaultBullets: Array<IconText>;
        jobsHeadline?: Maybe<Scalars['String']['output']>;
        jobsHeroImage?: Maybe<Asset>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

export type PageAboutUsCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageAboutUsDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type PageAboutUsEmployeePlaceholderArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageAboutUsHeroImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageAboutUsHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type PageAboutUsJobsDefaultBulletsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<IconTextOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IconTextWhereInput>;
};

export type PageAboutUsJobsHeroImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageAboutUsPublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageAboutUsScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type PageAboutUsUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageAboutUsConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: PageAboutUsWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageAboutUsConnection = {
    __typename?: 'PageAboutUsConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<PageAboutUsEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type PageAboutUsCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    employeePlaceholder?: InputMaybe<AssetCreateOneInlineInput>;
    heroImage?: InputMaybe<AssetCreateOneInlineInput>;
    jobsDefaultBullets?: InputMaybe<IconTextCreateManyInlineInput>;
    jobsHeadline?: InputMaybe<Scalars['String']['input']>;
    jobsHeroImage?: InputMaybe<AssetCreateOneInlineInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageAboutUsCreateManyInlineInput = {
    /** Connect multiple existing PageAboutUs documents */
    connect?: InputMaybe<Array<PageAboutUsWhereUniqueInput>>;
    /** Create and connect multiple existing PageAboutUs documents */
    create?: InputMaybe<Array<PageAboutUsCreateInput>>;
};

export type PageAboutUsCreateOneInlineInput = {
    /** Connect one existing PageAboutUs document */
    connect?: InputMaybe<PageAboutUsWhereUniqueInput>;
    /** Create and connect one PageAboutUs document */
    create?: InputMaybe<PageAboutUsCreateInput>;
};

/** An edge in a connection. */
export type PageAboutUsEdge = {
    __typename?: 'PageAboutUsEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: PageAboutUs;
};

/** Identifies documents */
export type PageAboutUsManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageAboutUsWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageAboutUsWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageAboutUsWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<PageAboutUsWhereStageInput>;
    documentInStages_none?: InputMaybe<PageAboutUsWhereStageInput>;
    documentInStages_some?: InputMaybe<PageAboutUsWhereStageInput>;
    employeePlaceholder?: InputMaybe<AssetWhereInput>;
    heroImage?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    jobsDefaultBullets_every?: InputMaybe<IconTextWhereInput>;
    jobsDefaultBullets_none?: InputMaybe<IconTextWhereInput>;
    jobsDefaultBullets_some?: InputMaybe<IconTextWhereInput>;
    jobsHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    jobsHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    jobsHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    jobsHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    jobsHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    jobsHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    jobsHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    jobsHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    jobsHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    jobsHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    jobsHeroImage?: InputMaybe<AssetWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PageAboutUsOrderByInput {
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    JobsHeadlineAsc = 'jobsHeadline_ASC',
    JobsHeadlineDesc = 'jobsHeadline_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type PageAboutUsUpdateInput = {
    employeePlaceholder?: InputMaybe<AssetUpdateOneInlineInput>;
    heroImage?: InputMaybe<AssetUpdateOneInlineInput>;
    jobsDefaultBullets?: InputMaybe<IconTextUpdateManyInlineInput>;
    jobsHeadline?: InputMaybe<Scalars['String']['input']>;
    jobsHeroImage?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type PageAboutUsUpdateManyInlineInput = {
    /** Connect multiple existing PageAboutUs documents */
    connect?: InputMaybe<Array<PageAboutUsConnectInput>>;
    /** Create and connect multiple PageAboutUs documents */
    create?: InputMaybe<Array<PageAboutUsCreateInput>>;
    /** Delete multiple PageAboutUs documents */
    delete?: InputMaybe<Array<PageAboutUsWhereUniqueInput>>;
    /** Disconnect multiple PageAboutUs documents */
    disconnect?: InputMaybe<Array<PageAboutUsWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing PageAboutUs documents */
    set?: InputMaybe<Array<PageAboutUsWhereUniqueInput>>;
    /** Update multiple PageAboutUs documents */
    update?: InputMaybe<Array<PageAboutUsUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple PageAboutUs documents */
    upsert?: InputMaybe<Array<PageAboutUsUpsertWithNestedWhereUniqueInput>>;
};

export type PageAboutUsUpdateManyInput = {
    jobsHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type PageAboutUsUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: PageAboutUsUpdateManyInput;
    /** Document search */
    where: PageAboutUsWhereInput;
};

export type PageAboutUsUpdateOneInlineInput = {
    /** Connect existing PageAboutUs document */
    connect?: InputMaybe<PageAboutUsWhereUniqueInput>;
    /** Create and connect one PageAboutUs document */
    create?: InputMaybe<PageAboutUsCreateInput>;
    /** Delete currently connected PageAboutUs document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected PageAboutUs document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single PageAboutUs document */
    update?: InputMaybe<PageAboutUsUpdateWithNestedWhereUniqueInput>;
    /** Upsert single PageAboutUs document */
    upsert?: InputMaybe<PageAboutUsUpsertWithNestedWhereUniqueInput>;
};

export type PageAboutUsUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: PageAboutUsUpdateInput;
    /** Unique document search */
    where: PageAboutUsWhereUniqueInput;
};

export type PageAboutUsUpsertInput = {
    /** Create document if it didn't exist */
    create: PageAboutUsCreateInput;
    /** Update document if it exists */
    update: PageAboutUsUpdateInput;
};

export type PageAboutUsUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: PageAboutUsUpsertInput;
    /** Unique document search */
    where: PageAboutUsWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageAboutUsWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageAboutUsWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageAboutUsWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageAboutUsWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageAboutUsWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<PageAboutUsWhereStageInput>;
    documentInStages_none?: InputMaybe<PageAboutUsWhereStageInput>;
    documentInStages_some?: InputMaybe<PageAboutUsWhereStageInput>;
    employeePlaceholder?: InputMaybe<AssetWhereInput>;
    heroImage?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    jobsDefaultBullets_every?: InputMaybe<IconTextWhereInput>;
    jobsDefaultBullets_none?: InputMaybe<IconTextWhereInput>;
    jobsDefaultBullets_some?: InputMaybe<IconTextWhereInput>;
    jobsHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    jobsHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    jobsHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    jobsHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    jobsHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    jobsHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    jobsHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    jobsHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    jobsHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    jobsHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    jobsHeroImage?: InputMaybe<AssetWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageAboutUsWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageAboutUsWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageAboutUsWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageAboutUsWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<PageAboutUsWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References PageAboutUs record uniquely */
export type PageAboutUsWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageBusinessCustomer = Entity &
    Node & {
        __typename?: 'PageBusinessCustomer';
        businessCenterBulletList: Array<IconText>;
        businessCenterBulletListHeadline?: Maybe<Scalars['String']['output']>;
        businessCenterHighlight1Copy?: Maybe<Scalars['String']['output']>;
        businessCenterHighlight1Headline?: Maybe<Scalars['String']['output']>;
        businessCenterHighlight1Image?: Maybe<Asset>;
        businessCenterHighlight2Copy?: Maybe<Scalars['String']['output']>;
        businessCenterHighlight2Headline?: Maybe<Scalars['String']['output']>;
        businessCenterHighlight2Image?: Maybe<Asset>;
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Get the document in other stages */
        documentInStages: Array<PageBusinessCustomer>;
        faq?: Maybe<Faq>;
        heroBulletList: Array<IconText>;
        heroBulletListCtaText?: Maybe<Scalars['String']['output']>;
        heroBulletListHeadline?: Maybe<Scalars['String']['output']>;
        heroBulletListLinkText?: Maybe<Scalars['String']['output']>;
        heroHeadline?: Maybe<Scalars['String']['output']>;
        heroImage?: Maybe<Asset>;
        /** List of PageBusinessCustomer versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        legalLines?: Maybe<RichText>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
        warranty1?: Maybe<Warranty>;
        warranty2?: Maybe<Warranty>;
    };

export type PageBusinessCustomerBusinessCenterBulletListArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<IconTextOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IconTextWhereInput>;
};

export type PageBusinessCustomerBusinessCenterHighlight1ImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageBusinessCustomerBusinessCenterHighlight2ImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageBusinessCustomerCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageBusinessCustomerDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type PageBusinessCustomerFaqArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageBusinessCustomerHeroBulletListArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<IconTextOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IconTextWhereInput>;
};

export type PageBusinessCustomerHeroImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageBusinessCustomerHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type PageBusinessCustomerPublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageBusinessCustomerScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type PageBusinessCustomerUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageBusinessCustomerWarranty1Args = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageBusinessCustomerWarranty2Args = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageBusinessCustomerConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: PageBusinessCustomerWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageBusinessCustomerConnection = {
    __typename?: 'PageBusinessCustomerConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<PageBusinessCustomerEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type PageBusinessCustomerCreateInput = {
    businessCenterBulletList?: InputMaybe<IconTextCreateManyInlineInput>;
    businessCenterBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1Copy?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1Headline?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1Image?: InputMaybe<AssetCreateOneInlineInput>;
    businessCenterHighlight2Copy?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight2Headline?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight2Image?: InputMaybe<AssetCreateOneInlineInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    faq?: InputMaybe<FaqCreateOneInlineInput>;
    heroBulletList?: InputMaybe<IconTextCreateManyInlineInput>;
    heroBulletListCtaText?: InputMaybe<Scalars['String']['input']>;
    heroBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    heroBulletListLinkText?: InputMaybe<Scalars['String']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetCreateOneInlineInput>;
    legalLines?: InputMaybe<Scalars['RichTextAST']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    warranty1?: InputMaybe<WarrantyCreateOneInlineInput>;
    warranty2?: InputMaybe<WarrantyCreateOneInlineInput>;
};

export type PageBusinessCustomerCreateManyInlineInput = {
    /** Connect multiple existing PageBusinessCustomer documents */
    connect?: InputMaybe<Array<PageBusinessCustomerWhereUniqueInput>>;
    /** Create and connect multiple existing PageBusinessCustomer documents */
    create?: InputMaybe<Array<PageBusinessCustomerCreateInput>>;
};

export type PageBusinessCustomerCreateOneInlineInput = {
    /** Connect one existing PageBusinessCustomer document */
    connect?: InputMaybe<PageBusinessCustomerWhereUniqueInput>;
    /** Create and connect one PageBusinessCustomer document */
    create?: InputMaybe<PageBusinessCustomerCreateInput>;
};

/** An edge in a connection. */
export type PageBusinessCustomerEdge = {
    __typename?: 'PageBusinessCustomerEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: PageBusinessCustomer;
};

/** Identifies documents */
export type PageBusinessCustomerManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageBusinessCustomerWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageBusinessCustomerWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageBusinessCustomerWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    businessCenterBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    businessCenterBulletListHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    businessCenterBulletListHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    businessCenterBulletListHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenterBulletListHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    businessCenterBulletListHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    businessCenterBulletListHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    businessCenterBulletListHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    businessCenterBulletListHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    businessCenterBulletListHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    businessCenterBulletList_every?: InputMaybe<IconTextWhereInput>;
    businessCenterBulletList_none?: InputMaybe<IconTextWhereInput>;
    businessCenterBulletList_some?: InputMaybe<IconTextWhereInput>;
    businessCenterHighlight1Copy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    businessCenterHighlight1Copy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    businessCenterHighlight1Copy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    businessCenterHighlight1Copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenterHighlight1Copy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    businessCenterHighlight1Copy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    businessCenterHighlight1Copy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    businessCenterHighlight1Copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    businessCenterHighlight1Copy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    businessCenterHighlight1Copy_starts_with?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1Headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    businessCenterHighlight1Headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    businessCenterHighlight1Headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    businessCenterHighlight1Headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenterHighlight1Headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    businessCenterHighlight1Headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    businessCenterHighlight1Headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    businessCenterHighlight1Headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    businessCenterHighlight1Headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    businessCenterHighlight1Headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1Image?: InputMaybe<AssetWhereInput>;
    businessCenterHighlight2Copy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    businessCenterHighlight2Copy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    businessCenterHighlight2Copy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    businessCenterHighlight2Copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenterHighlight2Copy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    businessCenterHighlight2Copy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    businessCenterHighlight2Copy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    businessCenterHighlight2Copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    businessCenterHighlight2Copy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    businessCenterHighlight2Copy_starts_with?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight2Headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    businessCenterHighlight2Headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    businessCenterHighlight2Headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    businessCenterHighlight2Headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenterHighlight2Headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    businessCenterHighlight2Headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    businessCenterHighlight2Headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    businessCenterHighlight2Headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    businessCenterHighlight2Headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    businessCenterHighlight2Headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight2Image?: InputMaybe<AssetWhereInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<PageBusinessCustomerWhereStageInput>;
    documentInStages_none?: InputMaybe<PageBusinessCustomerWhereStageInput>;
    documentInStages_some?: InputMaybe<PageBusinessCustomerWhereStageInput>;
    faq?: InputMaybe<FaqWhereInput>;
    heroBulletListCtaText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroBulletListCtaText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroBulletListCtaText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroBulletListCtaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroBulletListCtaText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroBulletListCtaText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroBulletListCtaText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroBulletListCtaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroBulletListCtaText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroBulletListCtaText_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroBulletListHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroBulletListHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroBulletListHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroBulletListHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroBulletListHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroBulletListHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroBulletListHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroBulletListHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroBulletListHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroBulletListLinkText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroBulletListLinkText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroBulletListLinkText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroBulletListLinkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroBulletListLinkText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroBulletListLinkText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroBulletListLinkText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroBulletListLinkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroBulletListLinkText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroBulletListLinkText_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroBulletList_every?: InputMaybe<IconTextWhereInput>;
    heroBulletList_none?: InputMaybe<IconTextWhereInput>;
    heroBulletList_some?: InputMaybe<IconTextWhereInput>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    warranty1?: InputMaybe<WarrantyWhereInput>;
    warranty2?: InputMaybe<WarrantyWhereInput>;
};

export enum PageBusinessCustomerOrderByInput {
    BusinessCenterBulletListHeadlineAsc = 'businessCenterBulletListHeadline_ASC',
    BusinessCenterBulletListHeadlineDesc = 'businessCenterBulletListHeadline_DESC',
    BusinessCenterHighlight1CopyAsc = 'businessCenterHighlight1Copy_ASC',
    BusinessCenterHighlight1CopyDesc = 'businessCenterHighlight1Copy_DESC',
    BusinessCenterHighlight1HeadlineAsc = 'businessCenterHighlight1Headline_ASC',
    BusinessCenterHighlight1HeadlineDesc = 'businessCenterHighlight1Headline_DESC',
    BusinessCenterHighlight2CopyAsc = 'businessCenterHighlight2Copy_ASC',
    BusinessCenterHighlight2CopyDesc = 'businessCenterHighlight2Copy_DESC',
    BusinessCenterHighlight2HeadlineAsc = 'businessCenterHighlight2Headline_ASC',
    BusinessCenterHighlight2HeadlineDesc = 'businessCenterHighlight2Headline_DESC',
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    HeroBulletListCtaTextAsc = 'heroBulletListCtaText_ASC',
    HeroBulletListCtaTextDesc = 'heroBulletListCtaText_DESC',
    HeroBulletListHeadlineAsc = 'heroBulletListHeadline_ASC',
    HeroBulletListHeadlineDesc = 'heroBulletListHeadline_DESC',
    HeroBulletListLinkTextAsc = 'heroBulletListLinkText_ASC',
    HeroBulletListLinkTextDesc = 'heroBulletListLinkText_DESC',
    HeroHeadlineAsc = 'heroHeadline_ASC',
    HeroHeadlineDesc = 'heroHeadline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type PageBusinessCustomerUpdateInput = {
    businessCenterBulletList?: InputMaybe<IconTextUpdateManyInlineInput>;
    businessCenterBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1Copy?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1Headline?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1Image?: InputMaybe<AssetUpdateOneInlineInput>;
    businessCenterHighlight2Copy?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight2Headline?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight2Image?: InputMaybe<AssetUpdateOneInlineInput>;
    faq?: InputMaybe<FaqUpdateOneInlineInput>;
    heroBulletList?: InputMaybe<IconTextUpdateManyInlineInput>;
    heroBulletListCtaText?: InputMaybe<Scalars['String']['input']>;
    heroBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    heroBulletListLinkText?: InputMaybe<Scalars['String']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetUpdateOneInlineInput>;
    legalLines?: InputMaybe<Scalars['RichTextAST']['input']>;
    warranty1?: InputMaybe<WarrantyUpdateOneInlineInput>;
    warranty2?: InputMaybe<WarrantyUpdateOneInlineInput>;
};

export type PageBusinessCustomerUpdateManyInlineInput = {
    /** Connect multiple existing PageBusinessCustomer documents */
    connect?: InputMaybe<Array<PageBusinessCustomerConnectInput>>;
    /** Create and connect multiple PageBusinessCustomer documents */
    create?: InputMaybe<Array<PageBusinessCustomerCreateInput>>;
    /** Delete multiple PageBusinessCustomer documents */
    delete?: InputMaybe<Array<PageBusinessCustomerWhereUniqueInput>>;
    /** Disconnect multiple PageBusinessCustomer documents */
    disconnect?: InputMaybe<Array<PageBusinessCustomerWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing PageBusinessCustomer documents */
    set?: InputMaybe<Array<PageBusinessCustomerWhereUniqueInput>>;
    /** Update multiple PageBusinessCustomer documents */
    update?: InputMaybe<Array<PageBusinessCustomerUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple PageBusinessCustomer documents */
    upsert?: InputMaybe<Array<PageBusinessCustomerUpsertWithNestedWhereUniqueInput>>;
};

export type PageBusinessCustomerUpdateManyInput = {
    businessCenterBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1Copy?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1Headline?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight2Copy?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight2Headline?: InputMaybe<Scalars['String']['input']>;
    heroBulletListCtaText?: InputMaybe<Scalars['String']['input']>;
    heroBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    heroBulletListLinkText?: InputMaybe<Scalars['String']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    legalLines?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type PageBusinessCustomerUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: PageBusinessCustomerUpdateManyInput;
    /** Document search */
    where: PageBusinessCustomerWhereInput;
};

export type PageBusinessCustomerUpdateOneInlineInput = {
    /** Connect existing PageBusinessCustomer document */
    connect?: InputMaybe<PageBusinessCustomerWhereUniqueInput>;
    /** Create and connect one PageBusinessCustomer document */
    create?: InputMaybe<PageBusinessCustomerCreateInput>;
    /** Delete currently connected PageBusinessCustomer document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected PageBusinessCustomer document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single PageBusinessCustomer document */
    update?: InputMaybe<PageBusinessCustomerUpdateWithNestedWhereUniqueInput>;
    /** Upsert single PageBusinessCustomer document */
    upsert?: InputMaybe<PageBusinessCustomerUpsertWithNestedWhereUniqueInput>;
};

export type PageBusinessCustomerUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: PageBusinessCustomerUpdateInput;
    /** Unique document search */
    where: PageBusinessCustomerWhereUniqueInput;
};

export type PageBusinessCustomerUpsertInput = {
    /** Create document if it didn't exist */
    create: PageBusinessCustomerCreateInput;
    /** Update document if it exists */
    update: PageBusinessCustomerUpdateInput;
};

export type PageBusinessCustomerUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: PageBusinessCustomerUpsertInput;
    /** Unique document search */
    where: PageBusinessCustomerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageBusinessCustomerWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageBusinessCustomerWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageBusinessCustomerWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageBusinessCustomerWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageBusinessCustomerWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    businessCenterBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    businessCenterBulletListHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    businessCenterBulletListHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    businessCenterBulletListHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenterBulletListHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    businessCenterBulletListHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    businessCenterBulletListHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    businessCenterBulletListHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    businessCenterBulletListHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    businessCenterBulletListHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    businessCenterBulletList_every?: InputMaybe<IconTextWhereInput>;
    businessCenterBulletList_none?: InputMaybe<IconTextWhereInput>;
    businessCenterBulletList_some?: InputMaybe<IconTextWhereInput>;
    businessCenterHighlight1Copy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    businessCenterHighlight1Copy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    businessCenterHighlight1Copy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    businessCenterHighlight1Copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenterHighlight1Copy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    businessCenterHighlight1Copy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    businessCenterHighlight1Copy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    businessCenterHighlight1Copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    businessCenterHighlight1Copy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    businessCenterHighlight1Copy_starts_with?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1Headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    businessCenterHighlight1Headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    businessCenterHighlight1Headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    businessCenterHighlight1Headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenterHighlight1Headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    businessCenterHighlight1Headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    businessCenterHighlight1Headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    businessCenterHighlight1Headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    businessCenterHighlight1Headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    businessCenterHighlight1Headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight1Image?: InputMaybe<AssetWhereInput>;
    businessCenterHighlight2Copy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    businessCenterHighlight2Copy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    businessCenterHighlight2Copy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    businessCenterHighlight2Copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenterHighlight2Copy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    businessCenterHighlight2Copy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    businessCenterHighlight2Copy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    businessCenterHighlight2Copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    businessCenterHighlight2Copy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    businessCenterHighlight2Copy_starts_with?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight2Headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    businessCenterHighlight2Headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    businessCenterHighlight2Headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    businessCenterHighlight2Headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    businessCenterHighlight2Headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    businessCenterHighlight2Headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    businessCenterHighlight2Headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    businessCenterHighlight2Headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    businessCenterHighlight2Headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    businessCenterHighlight2Headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    businessCenterHighlight2Image?: InputMaybe<AssetWhereInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<PageBusinessCustomerWhereStageInput>;
    documentInStages_none?: InputMaybe<PageBusinessCustomerWhereStageInput>;
    documentInStages_some?: InputMaybe<PageBusinessCustomerWhereStageInput>;
    faq?: InputMaybe<FaqWhereInput>;
    heroBulletListCtaText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroBulletListCtaText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroBulletListCtaText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroBulletListCtaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroBulletListCtaText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroBulletListCtaText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroBulletListCtaText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroBulletListCtaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroBulletListCtaText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroBulletListCtaText_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroBulletListHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroBulletListHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroBulletListHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroBulletListHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroBulletListHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroBulletListHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroBulletListHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroBulletListHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroBulletListHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroBulletListLinkText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroBulletListLinkText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroBulletListLinkText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroBulletListLinkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroBulletListLinkText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroBulletListLinkText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroBulletListLinkText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroBulletListLinkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroBulletListLinkText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroBulletListLinkText_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroBulletList_every?: InputMaybe<IconTextWhereInput>;
    heroBulletList_none?: InputMaybe<IconTextWhereInput>;
    heroBulletList_some?: InputMaybe<IconTextWhereInput>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    warranty1?: InputMaybe<WarrantyWhereInput>;
    warranty2?: InputMaybe<WarrantyWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageBusinessCustomerWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageBusinessCustomerWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageBusinessCustomerWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageBusinessCustomerWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<PageBusinessCustomerWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References PageBusinessCustomer record uniquely */
export type PageBusinessCustomerWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageHome = Entity &
    Node & {
        __typename?: 'PageHome';
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Get the document in other stages */
        documentInStages: Array<PageHome>;
        hcmTeaserCopy: Scalars['String']['output'];
        hcmTeaserCtaLabel: Scalars['String']['output'];
        hcmTeaserHeadline: Scalars['String']['output'];
        hcmTeaserImage: Asset;
        /** List of PageHome versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

export type PageHomeCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageHomeDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type PageHomeHcmTeaserImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageHomeHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type PageHomePublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageHomeScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type PageHomeUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageHomeConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: PageHomeWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageHomeConnection = {
    __typename?: 'PageHomeConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<PageHomeEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type PageHomeCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    hcmTeaserCopy: Scalars['String']['input'];
    hcmTeaserCtaLabel: Scalars['String']['input'];
    hcmTeaserHeadline: Scalars['String']['input'];
    hcmTeaserImage: AssetCreateOneInlineInput;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageHomeCreateManyInlineInput = {
    /** Connect multiple existing PageHome documents */
    connect?: InputMaybe<Array<PageHomeWhereUniqueInput>>;
    /** Create and connect multiple existing PageHome documents */
    create?: InputMaybe<Array<PageHomeCreateInput>>;
};

export type PageHomeCreateOneInlineInput = {
    /** Connect one existing PageHome document */
    connect?: InputMaybe<PageHomeWhereUniqueInput>;
    /** Create and connect one PageHome document */
    create?: InputMaybe<PageHomeCreateInput>;
};

/** An edge in a connection. */
export type PageHomeEdge = {
    __typename?: 'PageHomeEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: PageHome;
};

/** Identifies documents */
export type PageHomeManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageHomeWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageHomeWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageHomeWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<PageHomeWhereStageInput>;
    documentInStages_none?: InputMaybe<PageHomeWhereStageInput>;
    documentInStages_some?: InputMaybe<PageHomeWhereStageInput>;
    hcmTeaserCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    hcmTeaserCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    hcmTeaserCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    hcmTeaserCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    hcmTeaserCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    hcmTeaserCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    hcmTeaserCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    hcmTeaserCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    hcmTeaserCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    hcmTeaserCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserCtaLabel?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    hcmTeaserCtaLabel_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    hcmTeaserCtaLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    hcmTeaserCtaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    hcmTeaserCtaLabel_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    hcmTeaserCtaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    hcmTeaserCtaLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    hcmTeaserCtaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    hcmTeaserCtaLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    hcmTeaserCtaLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    hcmTeaserHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    hcmTeaserHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    hcmTeaserHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    hcmTeaserHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    hcmTeaserHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    hcmTeaserHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    hcmTeaserHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    hcmTeaserHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    hcmTeaserHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserImage?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PageHomeOrderByInput {
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    HcmTeaserCopyAsc = 'hcmTeaserCopy_ASC',
    HcmTeaserCopyDesc = 'hcmTeaserCopy_DESC',
    HcmTeaserCtaLabelAsc = 'hcmTeaserCtaLabel_ASC',
    HcmTeaserCtaLabelDesc = 'hcmTeaserCtaLabel_DESC',
    HcmTeaserHeadlineAsc = 'hcmTeaserHeadline_ASC',
    HcmTeaserHeadlineDesc = 'hcmTeaserHeadline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type PageHomeUpdateInput = {
    hcmTeaserCopy?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserCtaLabel?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserHeadline?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserImage?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type PageHomeUpdateManyInlineInput = {
    /** Connect multiple existing PageHome documents */
    connect?: InputMaybe<Array<PageHomeConnectInput>>;
    /** Create and connect multiple PageHome documents */
    create?: InputMaybe<Array<PageHomeCreateInput>>;
    /** Delete multiple PageHome documents */
    delete?: InputMaybe<Array<PageHomeWhereUniqueInput>>;
    /** Disconnect multiple PageHome documents */
    disconnect?: InputMaybe<Array<PageHomeWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing PageHome documents */
    set?: InputMaybe<Array<PageHomeWhereUniqueInput>>;
    /** Update multiple PageHome documents */
    update?: InputMaybe<Array<PageHomeUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple PageHome documents */
    upsert?: InputMaybe<Array<PageHomeUpsertWithNestedWhereUniqueInput>>;
};

export type PageHomeUpdateManyInput = {
    hcmTeaserCopy?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserCtaLabel?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type PageHomeUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: PageHomeUpdateManyInput;
    /** Document search */
    where: PageHomeWhereInput;
};

export type PageHomeUpdateOneInlineInput = {
    /** Connect existing PageHome document */
    connect?: InputMaybe<PageHomeWhereUniqueInput>;
    /** Create and connect one PageHome document */
    create?: InputMaybe<PageHomeCreateInput>;
    /** Delete currently connected PageHome document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected PageHome document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single PageHome document */
    update?: InputMaybe<PageHomeUpdateWithNestedWhereUniqueInput>;
    /** Upsert single PageHome document */
    upsert?: InputMaybe<PageHomeUpsertWithNestedWhereUniqueInput>;
};

export type PageHomeUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: PageHomeUpdateInput;
    /** Unique document search */
    where: PageHomeWhereUniqueInput;
};

export type PageHomeUpsertInput = {
    /** Create document if it didn't exist */
    create: PageHomeCreateInput;
    /** Update document if it exists */
    update: PageHomeUpdateInput;
};

export type PageHomeUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: PageHomeUpsertInput;
    /** Unique document search */
    where: PageHomeWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageHomeWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageHomeWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageHomeWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageHomeWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageHomeWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<PageHomeWhereStageInput>;
    documentInStages_none?: InputMaybe<PageHomeWhereStageInput>;
    documentInStages_some?: InputMaybe<PageHomeWhereStageInput>;
    hcmTeaserCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    hcmTeaserCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    hcmTeaserCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    hcmTeaserCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    hcmTeaserCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    hcmTeaserCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    hcmTeaserCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    hcmTeaserCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    hcmTeaserCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    hcmTeaserCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserCtaLabel?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    hcmTeaserCtaLabel_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    hcmTeaserCtaLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    hcmTeaserCtaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    hcmTeaserCtaLabel_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    hcmTeaserCtaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    hcmTeaserCtaLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    hcmTeaserCtaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    hcmTeaserCtaLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    hcmTeaserCtaLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    hcmTeaserHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    hcmTeaserHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    hcmTeaserHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    hcmTeaserHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    hcmTeaserHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    hcmTeaserHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    hcmTeaserHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    hcmTeaserHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    hcmTeaserHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    hcmTeaserImage?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageHomeWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageHomeWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageHomeWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageHomeWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<PageHomeWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References PageHome record uniquely */
export type PageHomeWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageHyundaiPromise = Entity &
    Node & {
        __typename?: 'PageHyundaiPromise';
        contentBulletList: Array<IconText>;
        contentBulletListHeadline?: Maybe<Scalars['String']['output']>;
        contentCopy?: Maybe<Scalars['String']['output']>;
        contentCtaTarget?: Maybe<Scalars['String']['output']>;
        contentCtaText?: Maybe<Scalars['String']['output']>;
        contentHeadline?: Maybe<Scalars['String']['output']>;
        contentImage?: Maybe<Asset>;
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Get the document in other stages */
        documentInStages: Array<PageHyundaiPromise>;
        faq?: Maybe<Faq>;
        heroBulletListHeadline?: Maybe<Scalars['String']['output']>;
        heroBulletListItems: Array<IconText>;
        heroBulletListLinkText?: Maybe<Scalars['String']['output']>;
        heroCtaTarget?: Maybe<Scalars['String']['output']>;
        heroCtaText?: Maybe<Scalars['String']['output']>;
        heroHeadline?: Maybe<Scalars['String']['output']>;
        heroImage?: Maybe<Asset>;
        /** List of PageHyundaiPromise versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        legalLines?: Maybe<RichText>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
        video?: Maybe<Asset>;
        videoCopy?: Maybe<Scalars['String']['output']>;
        videoCtaTarget?: Maybe<Scalars['String']['output']>;
        videoCtaText?: Maybe<Scalars['String']['output']>;
        videoHeadline?: Maybe<Scalars['String']['output']>;
    };

export type PageHyundaiPromiseContentBulletListArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<IconTextOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IconTextWhereInput>;
};

export type PageHyundaiPromiseContentImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageHyundaiPromiseCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageHyundaiPromiseDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type PageHyundaiPromiseFaqArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageHyundaiPromiseHeroBulletListItemsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<IconTextOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IconTextWhereInput>;
};

export type PageHyundaiPromiseHeroImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageHyundaiPromiseHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type PageHyundaiPromisePublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageHyundaiPromiseScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type PageHyundaiPromiseUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageHyundaiPromiseVideoArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageHyundaiPromiseConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: PageHyundaiPromiseWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageHyundaiPromiseConnection = {
    __typename?: 'PageHyundaiPromiseConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<PageHyundaiPromiseEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type PageHyundaiPromiseCreateInput = {
    contentBulletList?: InputMaybe<IconTextCreateManyInlineInput>;
    contentBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    contentCopy?: InputMaybe<Scalars['String']['input']>;
    contentCtaTarget?: InputMaybe<Scalars['String']['input']>;
    contentCtaText?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    contentImage?: InputMaybe<AssetCreateOneInlineInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    faq?: InputMaybe<FaqCreateOneInlineInput>;
    heroBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    heroBulletListItems?: InputMaybe<IconTextCreateManyInlineInput>;
    heroBulletListLinkText?: InputMaybe<Scalars['String']['input']>;
    heroCtaTarget?: InputMaybe<Scalars['String']['input']>;
    heroCtaText?: InputMaybe<Scalars['String']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetCreateOneInlineInput>;
    legalLines?: InputMaybe<Scalars['RichTextAST']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    video?: InputMaybe<AssetCreateOneInlineInput>;
    videoCopy?: InputMaybe<Scalars['String']['input']>;
    videoCtaTarget?: InputMaybe<Scalars['String']['input']>;
    videoCtaText?: InputMaybe<Scalars['String']['input']>;
    videoHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type PageHyundaiPromiseCreateManyInlineInput = {
    /** Connect multiple existing PageHyundaiPromise documents */
    connect?: InputMaybe<Array<PageHyundaiPromiseWhereUniqueInput>>;
    /** Create and connect multiple existing PageHyundaiPromise documents */
    create?: InputMaybe<Array<PageHyundaiPromiseCreateInput>>;
};

export type PageHyundaiPromiseCreateOneInlineInput = {
    /** Connect one existing PageHyundaiPromise document */
    connect?: InputMaybe<PageHyundaiPromiseWhereUniqueInput>;
    /** Create and connect one PageHyundaiPromise document */
    create?: InputMaybe<PageHyundaiPromiseCreateInput>;
};

/** An edge in a connection. */
export type PageHyundaiPromiseEdge = {
    __typename?: 'PageHyundaiPromiseEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: PageHyundaiPromise;
};

/** Identifies documents */
export type PageHyundaiPromiseManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageHyundaiPromiseWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageHyundaiPromiseWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageHyundaiPromiseWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    contentBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentBulletListHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentBulletListHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentBulletListHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentBulletListHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentBulletListHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentBulletListHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentBulletListHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentBulletListHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentBulletListHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentBulletList_every?: InputMaybe<IconTextWhereInput>;
    contentBulletList_none?: InputMaybe<IconTextWhereInput>;
    contentBulletList_some?: InputMaybe<IconTextWhereInput>;
    contentCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentCtaTarget?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentCtaTarget_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentCtaTarget_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentCtaTarget_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentCtaTarget_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentCtaTarget_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentCtaTarget_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentCtaTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentCtaTarget_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentCtaTarget_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentCtaText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentCtaText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentCtaText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentCtaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentCtaText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentCtaText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentCtaText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentCtaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentCtaText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentCtaText_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentImage?: InputMaybe<AssetWhereInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<PageHyundaiPromiseWhereStageInput>;
    documentInStages_none?: InputMaybe<PageHyundaiPromiseWhereStageInput>;
    documentInStages_some?: InputMaybe<PageHyundaiPromiseWhereStageInput>;
    faq?: InputMaybe<FaqWhereInput>;
    heroBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroBulletListHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroBulletListHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroBulletListHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroBulletListHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroBulletListHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroBulletListHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroBulletListHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroBulletListHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroBulletListHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroBulletListItems_every?: InputMaybe<IconTextWhereInput>;
    heroBulletListItems_none?: InputMaybe<IconTextWhereInput>;
    heroBulletListItems_some?: InputMaybe<IconTextWhereInput>;
    heroBulletListLinkText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroBulletListLinkText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroBulletListLinkText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroBulletListLinkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroBulletListLinkText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroBulletListLinkText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroBulletListLinkText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroBulletListLinkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroBulletListLinkText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroBulletListLinkText_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroCtaTarget?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroCtaTarget_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroCtaTarget_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroCtaTarget_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroCtaTarget_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroCtaTarget_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroCtaTarget_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroCtaTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroCtaTarget_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroCtaTarget_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroCtaText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroCtaText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroCtaText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroCtaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroCtaText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroCtaText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroCtaText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroCtaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroCtaText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroCtaText_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    video?: InputMaybe<AssetWhereInput>;
    videoCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    videoCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    videoCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    videoCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    videoCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    videoCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    videoCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    videoCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    videoCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    videoCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    videoCtaTarget?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    videoCtaTarget_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    videoCtaTarget_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    videoCtaTarget_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    videoCtaTarget_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    videoCtaTarget_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    videoCtaTarget_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    videoCtaTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    videoCtaTarget_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    videoCtaTarget_starts_with?: InputMaybe<Scalars['String']['input']>;
    videoCtaText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    videoCtaText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    videoCtaText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    videoCtaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    videoCtaText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    videoCtaText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    videoCtaText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    videoCtaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    videoCtaText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    videoCtaText_starts_with?: InputMaybe<Scalars['String']['input']>;
    videoHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    videoHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    videoHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    videoHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    videoHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    videoHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    videoHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    videoHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    videoHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    videoHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum PageHyundaiPromiseOrderByInput {
    ContentBulletListHeadlineAsc = 'contentBulletListHeadline_ASC',
    ContentBulletListHeadlineDesc = 'contentBulletListHeadline_DESC',
    ContentCopyAsc = 'contentCopy_ASC',
    ContentCopyDesc = 'contentCopy_DESC',
    ContentCtaTargetAsc = 'contentCtaTarget_ASC',
    ContentCtaTargetDesc = 'contentCtaTarget_DESC',
    ContentCtaTextAsc = 'contentCtaText_ASC',
    ContentCtaTextDesc = 'contentCtaText_DESC',
    ContentHeadlineAsc = 'contentHeadline_ASC',
    ContentHeadlineDesc = 'contentHeadline_DESC',
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    HeroBulletListHeadlineAsc = 'heroBulletListHeadline_ASC',
    HeroBulletListHeadlineDesc = 'heroBulletListHeadline_DESC',
    HeroBulletListLinkTextAsc = 'heroBulletListLinkText_ASC',
    HeroBulletListLinkTextDesc = 'heroBulletListLinkText_DESC',
    HeroCtaTargetAsc = 'heroCtaTarget_ASC',
    HeroCtaTargetDesc = 'heroCtaTarget_DESC',
    HeroCtaTextAsc = 'heroCtaText_ASC',
    HeroCtaTextDesc = 'heroCtaText_DESC',
    HeroHeadlineAsc = 'heroHeadline_ASC',
    HeroHeadlineDesc = 'heroHeadline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
    VideoCopyAsc = 'videoCopy_ASC',
    VideoCopyDesc = 'videoCopy_DESC',
    VideoCtaTargetAsc = 'videoCtaTarget_ASC',
    VideoCtaTargetDesc = 'videoCtaTarget_DESC',
    VideoCtaTextAsc = 'videoCtaText_ASC',
    VideoCtaTextDesc = 'videoCtaText_DESC',
    VideoHeadlineAsc = 'videoHeadline_ASC',
    VideoHeadlineDesc = 'videoHeadline_DESC',
}

export type PageHyundaiPromiseUpdateInput = {
    contentBulletList?: InputMaybe<IconTextUpdateManyInlineInput>;
    contentBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    contentCopy?: InputMaybe<Scalars['String']['input']>;
    contentCtaTarget?: InputMaybe<Scalars['String']['input']>;
    contentCtaText?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    contentImage?: InputMaybe<AssetUpdateOneInlineInput>;
    faq?: InputMaybe<FaqUpdateOneInlineInput>;
    heroBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    heroBulletListItems?: InputMaybe<IconTextUpdateManyInlineInput>;
    heroBulletListLinkText?: InputMaybe<Scalars['String']['input']>;
    heroCtaTarget?: InputMaybe<Scalars['String']['input']>;
    heroCtaText?: InputMaybe<Scalars['String']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetUpdateOneInlineInput>;
    legalLines?: InputMaybe<Scalars['RichTextAST']['input']>;
    video?: InputMaybe<AssetUpdateOneInlineInput>;
    videoCopy?: InputMaybe<Scalars['String']['input']>;
    videoCtaTarget?: InputMaybe<Scalars['String']['input']>;
    videoCtaText?: InputMaybe<Scalars['String']['input']>;
    videoHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type PageHyundaiPromiseUpdateManyInlineInput = {
    /** Connect multiple existing PageHyundaiPromise documents */
    connect?: InputMaybe<Array<PageHyundaiPromiseConnectInput>>;
    /** Create and connect multiple PageHyundaiPromise documents */
    create?: InputMaybe<Array<PageHyundaiPromiseCreateInput>>;
    /** Delete multiple PageHyundaiPromise documents */
    delete?: InputMaybe<Array<PageHyundaiPromiseWhereUniqueInput>>;
    /** Disconnect multiple PageHyundaiPromise documents */
    disconnect?: InputMaybe<Array<PageHyundaiPromiseWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing PageHyundaiPromise documents */
    set?: InputMaybe<Array<PageHyundaiPromiseWhereUniqueInput>>;
    /** Update multiple PageHyundaiPromise documents */
    update?: InputMaybe<Array<PageHyundaiPromiseUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple PageHyundaiPromise documents */
    upsert?: InputMaybe<Array<PageHyundaiPromiseUpsertWithNestedWhereUniqueInput>>;
};

export type PageHyundaiPromiseUpdateManyInput = {
    contentBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    contentCopy?: InputMaybe<Scalars['String']['input']>;
    contentCtaTarget?: InputMaybe<Scalars['String']['input']>;
    contentCtaText?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    heroBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    heroBulletListLinkText?: InputMaybe<Scalars['String']['input']>;
    heroCtaTarget?: InputMaybe<Scalars['String']['input']>;
    heroCtaText?: InputMaybe<Scalars['String']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    legalLines?: InputMaybe<Scalars['RichTextAST']['input']>;
    videoCopy?: InputMaybe<Scalars['String']['input']>;
    videoCtaTarget?: InputMaybe<Scalars['String']['input']>;
    videoCtaText?: InputMaybe<Scalars['String']['input']>;
    videoHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type PageHyundaiPromiseUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: PageHyundaiPromiseUpdateManyInput;
    /** Document search */
    where: PageHyundaiPromiseWhereInput;
};

export type PageHyundaiPromiseUpdateOneInlineInput = {
    /** Connect existing PageHyundaiPromise document */
    connect?: InputMaybe<PageHyundaiPromiseWhereUniqueInput>;
    /** Create and connect one PageHyundaiPromise document */
    create?: InputMaybe<PageHyundaiPromiseCreateInput>;
    /** Delete currently connected PageHyundaiPromise document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected PageHyundaiPromise document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single PageHyundaiPromise document */
    update?: InputMaybe<PageHyundaiPromiseUpdateWithNestedWhereUniqueInput>;
    /** Upsert single PageHyundaiPromise document */
    upsert?: InputMaybe<PageHyundaiPromiseUpsertWithNestedWhereUniqueInput>;
};

export type PageHyundaiPromiseUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: PageHyundaiPromiseUpdateInput;
    /** Unique document search */
    where: PageHyundaiPromiseWhereUniqueInput;
};

export type PageHyundaiPromiseUpsertInput = {
    /** Create document if it didn't exist */
    create: PageHyundaiPromiseCreateInput;
    /** Update document if it exists */
    update: PageHyundaiPromiseUpdateInput;
};

export type PageHyundaiPromiseUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: PageHyundaiPromiseUpsertInput;
    /** Unique document search */
    where: PageHyundaiPromiseWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageHyundaiPromiseWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageHyundaiPromiseWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageHyundaiPromiseWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageHyundaiPromiseWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageHyundaiPromiseWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    contentBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentBulletListHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentBulletListHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentBulletListHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentBulletListHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentBulletListHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentBulletListHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentBulletListHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentBulletListHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentBulletListHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentBulletList_every?: InputMaybe<IconTextWhereInput>;
    contentBulletList_none?: InputMaybe<IconTextWhereInput>;
    contentBulletList_some?: InputMaybe<IconTextWhereInput>;
    contentCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentCtaTarget?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentCtaTarget_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentCtaTarget_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentCtaTarget_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentCtaTarget_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentCtaTarget_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentCtaTarget_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentCtaTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentCtaTarget_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentCtaTarget_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentCtaText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentCtaText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentCtaText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentCtaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentCtaText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentCtaText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentCtaText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentCtaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentCtaText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentCtaText_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentImage?: InputMaybe<AssetWhereInput>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<PageHyundaiPromiseWhereStageInput>;
    documentInStages_none?: InputMaybe<PageHyundaiPromiseWhereStageInput>;
    documentInStages_some?: InputMaybe<PageHyundaiPromiseWhereStageInput>;
    faq?: InputMaybe<FaqWhereInput>;
    heroBulletListHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroBulletListHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroBulletListHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroBulletListHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroBulletListHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroBulletListHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroBulletListHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroBulletListHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroBulletListHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroBulletListHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroBulletListItems_every?: InputMaybe<IconTextWhereInput>;
    heroBulletListItems_none?: InputMaybe<IconTextWhereInput>;
    heroBulletListItems_some?: InputMaybe<IconTextWhereInput>;
    heroBulletListLinkText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroBulletListLinkText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroBulletListLinkText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroBulletListLinkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroBulletListLinkText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroBulletListLinkText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroBulletListLinkText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroBulletListLinkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroBulletListLinkText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroBulletListLinkText_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroCtaTarget?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroCtaTarget_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroCtaTarget_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroCtaTarget_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroCtaTarget_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroCtaTarget_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroCtaTarget_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroCtaTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroCtaTarget_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroCtaTarget_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroCtaText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroCtaText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroCtaText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroCtaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroCtaText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroCtaText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroCtaText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroCtaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroCtaText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroCtaText_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    video?: InputMaybe<AssetWhereInput>;
    videoCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    videoCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    videoCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    videoCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    videoCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    videoCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    videoCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    videoCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    videoCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    videoCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    videoCtaTarget?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    videoCtaTarget_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    videoCtaTarget_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    videoCtaTarget_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    videoCtaTarget_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    videoCtaTarget_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    videoCtaTarget_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    videoCtaTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    videoCtaTarget_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    videoCtaTarget_starts_with?: InputMaybe<Scalars['String']['input']>;
    videoCtaText?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    videoCtaText_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    videoCtaText_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    videoCtaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    videoCtaText_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    videoCtaText_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    videoCtaText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    videoCtaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    videoCtaText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    videoCtaText_starts_with?: InputMaybe<Scalars['String']['input']>;
    videoHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    videoHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    videoHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    videoHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    videoHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    videoHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    videoHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    videoHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    videoHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    videoHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageHyundaiPromiseWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageHyundaiPromiseWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageHyundaiPromiseWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageHyundaiPromiseWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<PageHyundaiPromiseWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References PageHyundaiPromise record uniquely */
export type PageHyundaiPromiseWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
    __typename?: 'PageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor?: Maybe<Scalars['String']['output']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean']['output'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean']['output'];
    /** Number of items in the current page. */
    pageSize?: Maybe<Scalars['Int']['output']>;
    /** When paginating backwards, the cursor to continue. */
    startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageService = Entity &
    Node & {
        __typename?: 'PageService';
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        defaultBullets: Array<IconText>;
        /** Get the document in other stages */
        documentInStages: Array<PageService>;
        faq?: Maybe<Faq>;
        headline: Scalars['String']['output'];
        heroImage: Asset;
        /** List of PageService versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        partStoreTeaserImage: Asset;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        subHeadline: Scalars['String']['output'];
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

export type PageServiceCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageServiceDefaultBulletsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<IconTextOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IconTextWhereInput>;
};

export type PageServiceDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type PageServiceFaqArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageServiceHeroImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageServiceHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type PageServicePartStoreTeaserImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageServicePublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageServiceScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type PageServiceUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageServiceConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: PageServiceWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageServiceConnection = {
    __typename?: 'PageServiceConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<PageServiceEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type PageServiceCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    defaultBullets?: InputMaybe<IconTextCreateManyInlineInput>;
    faq?: InputMaybe<FaqCreateOneInlineInput>;
    headline: Scalars['String']['input'];
    heroImage: AssetCreateOneInlineInput;
    partStoreTeaserImage: AssetCreateOneInlineInput;
    subHeadline: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageServiceCreateManyInlineInput = {
    /** Connect multiple existing PageService documents */
    connect?: InputMaybe<Array<PageServiceWhereUniqueInput>>;
    /** Create and connect multiple existing PageService documents */
    create?: InputMaybe<Array<PageServiceCreateInput>>;
};

export type PageServiceCreateOneInlineInput = {
    /** Connect one existing PageService document */
    connect?: InputMaybe<PageServiceWhereUniqueInput>;
    /** Create and connect one PageService document */
    create?: InputMaybe<PageServiceCreateInput>;
};

/** An edge in a connection. */
export type PageServiceEdge = {
    __typename?: 'PageServiceEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: PageService;
};

/** Identifies documents */
export type PageServiceManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageServiceWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageServiceWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageServiceWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    defaultBullets_every?: InputMaybe<IconTextWhereInput>;
    defaultBullets_none?: InputMaybe<IconTextWhereInput>;
    defaultBullets_some?: InputMaybe<IconTextWhereInput>;
    documentInStages_every?: InputMaybe<PageServiceWhereStageInput>;
    documentInStages_none?: InputMaybe<PageServiceWhereStageInput>;
    documentInStages_some?: InputMaybe<PageServiceWhereStageInput>;
    faq?: InputMaybe<FaqWhereInput>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    partStoreTeaserImage?: InputMaybe<AssetWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    subHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    subHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    subHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    subHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    subHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    subHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    subHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    subHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    subHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    subHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PageServiceOrderByInput {
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    SubHeadlineAsc = 'subHeadline_ASC',
    SubHeadlineDesc = 'subHeadline_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type PageServiceUpdateInput = {
    defaultBullets?: InputMaybe<IconTextUpdateManyInlineInput>;
    faq?: InputMaybe<FaqUpdateOneInlineInput>;
    headline?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetUpdateOneInlineInput>;
    partStoreTeaserImage?: InputMaybe<AssetUpdateOneInlineInput>;
    subHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type PageServiceUpdateManyInlineInput = {
    /** Connect multiple existing PageService documents */
    connect?: InputMaybe<Array<PageServiceConnectInput>>;
    /** Create and connect multiple PageService documents */
    create?: InputMaybe<Array<PageServiceCreateInput>>;
    /** Delete multiple PageService documents */
    delete?: InputMaybe<Array<PageServiceWhereUniqueInput>>;
    /** Disconnect multiple PageService documents */
    disconnect?: InputMaybe<Array<PageServiceWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing PageService documents */
    set?: InputMaybe<Array<PageServiceWhereUniqueInput>>;
    /** Update multiple PageService documents */
    update?: InputMaybe<Array<PageServiceUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple PageService documents */
    upsert?: InputMaybe<Array<PageServiceUpsertWithNestedWhereUniqueInput>>;
};

export type PageServiceUpdateManyInput = {
    headline?: InputMaybe<Scalars['String']['input']>;
    subHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type PageServiceUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: PageServiceUpdateManyInput;
    /** Document search */
    where: PageServiceWhereInput;
};

export type PageServiceUpdateOneInlineInput = {
    /** Connect existing PageService document */
    connect?: InputMaybe<PageServiceWhereUniqueInput>;
    /** Create and connect one PageService document */
    create?: InputMaybe<PageServiceCreateInput>;
    /** Delete currently connected PageService document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected PageService document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single PageService document */
    update?: InputMaybe<PageServiceUpdateWithNestedWhereUniqueInput>;
    /** Upsert single PageService document */
    upsert?: InputMaybe<PageServiceUpsertWithNestedWhereUniqueInput>;
};

export type PageServiceUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: PageServiceUpdateInput;
    /** Unique document search */
    where: PageServiceWhereUniqueInput;
};

export type PageServiceUpsertInput = {
    /** Create document if it didn't exist */
    create: PageServiceCreateInput;
    /** Update document if it exists */
    update: PageServiceUpdateInput;
};

export type PageServiceUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: PageServiceUpsertInput;
    /** Unique document search */
    where: PageServiceWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageServiceWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageServiceWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageServiceWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageServiceWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageServiceWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    defaultBullets_every?: InputMaybe<IconTextWhereInput>;
    defaultBullets_none?: InputMaybe<IconTextWhereInput>;
    defaultBullets_some?: InputMaybe<IconTextWhereInput>;
    documentInStages_every?: InputMaybe<PageServiceWhereStageInput>;
    documentInStages_none?: InputMaybe<PageServiceWhereStageInput>;
    documentInStages_some?: InputMaybe<PageServiceWhereStageInput>;
    faq?: InputMaybe<FaqWhereInput>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    partStoreTeaserImage?: InputMaybe<AssetWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    subHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    subHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    subHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    subHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    subHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    subHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    subHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    subHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    subHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    subHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageServiceWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageServiceWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageServiceWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageServiceWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<PageServiceWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References PageService record uniquely */
export type PageServiceWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

/** Page Type Enum for Typecasting Page Content */
export enum PageType {
    Warranty = 'warranty',
}

export type PageWarranty = Entity &
    Node & {
        __typename?: 'PageWarranty';
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Get the document in other stages */
        documentInStages: Array<PageWarranty>;
        faq?: Maybe<Faq>;
        heroCopy?: Maybe<Scalars['String']['output']>;
        heroHeadline: Scalars['String']['output'];
        heroImage?: Maybe<Asset>;
        heroSubHeadline?: Maybe<Scalars['String']['output']>;
        /** List of PageWarranty versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        legalLines?: Maybe<RichText>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
        warranty1?: Maybe<Warranty>;
        warranty2?: Maybe<Warranty>;
        warrantyHeadline?: Maybe<Scalars['String']['output']>;
    };

export type PageWarrantyCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageWarrantyDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type PageWarrantyFaqArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageWarrantyHeroImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type PageWarrantyHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type PageWarrantyPublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageWarrantyScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type PageWarrantyUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageWarrantyWarranty1Args = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageWarrantyWarranty2Args = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type PageWarrantyConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: PageWarrantyWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageWarrantyConnection = {
    __typename?: 'PageWarrantyConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<PageWarrantyEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type PageWarrantyCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    faq?: InputMaybe<FaqCreateOneInlineInput>;
    heroCopy?: InputMaybe<Scalars['String']['input']>;
    heroHeadline: Scalars['String']['input'];
    heroImage?: InputMaybe<AssetCreateOneInlineInput>;
    heroSubHeadline?: InputMaybe<Scalars['String']['input']>;
    legalLines?: InputMaybe<Scalars['RichTextAST']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    warranty1?: InputMaybe<WarrantyCreateOneInlineInput>;
    warranty2?: InputMaybe<WarrantyCreateOneInlineInput>;
    warrantyHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type PageWarrantyCreateManyInlineInput = {
    /** Connect multiple existing PageWarranty documents */
    connect?: InputMaybe<Array<PageWarrantyWhereUniqueInput>>;
    /** Create and connect multiple existing PageWarranty documents */
    create?: InputMaybe<Array<PageWarrantyCreateInput>>;
};

export type PageWarrantyCreateOneInlineInput = {
    /** Connect one existing PageWarranty document */
    connect?: InputMaybe<PageWarrantyWhereUniqueInput>;
    /** Create and connect one PageWarranty document */
    create?: InputMaybe<PageWarrantyCreateInput>;
};

/** An edge in a connection. */
export type PageWarrantyEdge = {
    __typename?: 'PageWarrantyEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: PageWarranty;
};

/** Identifies documents */
export type PageWarrantyManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageWarrantyWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageWarrantyWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageWarrantyWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<PageWarrantyWhereStageInput>;
    documentInStages_none?: InputMaybe<PageWarrantyWhereStageInput>;
    documentInStages_some?: InputMaybe<PageWarrantyWhereStageInput>;
    faq?: InputMaybe<FaqWhereInput>;
    heroCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    heroSubHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroSubHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroSubHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroSubHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroSubHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroSubHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroSubHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroSubHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroSubHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroSubHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    warranty1?: InputMaybe<WarrantyWhereInput>;
    warranty2?: InputMaybe<WarrantyWhereInput>;
    warrantyHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    warrantyHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    warrantyHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    warrantyHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    warrantyHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    warrantyHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    warrantyHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    warrantyHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    warrantyHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    warrantyHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum PageWarrantyOrderByInput {
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    HeroCopyAsc = 'heroCopy_ASC',
    HeroCopyDesc = 'heroCopy_DESC',
    HeroHeadlineAsc = 'heroHeadline_ASC',
    HeroHeadlineDesc = 'heroHeadline_DESC',
    HeroSubHeadlineAsc = 'heroSubHeadline_ASC',
    HeroSubHeadlineDesc = 'heroSubHeadline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
    WarrantyHeadlineAsc = 'warrantyHeadline_ASC',
    WarrantyHeadlineDesc = 'warrantyHeadline_DESC',
}

export type PageWarrantyUpdateInput = {
    faq?: InputMaybe<FaqUpdateOneInlineInput>;
    heroCopy?: InputMaybe<Scalars['String']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetUpdateOneInlineInput>;
    heroSubHeadline?: InputMaybe<Scalars['String']['input']>;
    legalLines?: InputMaybe<Scalars['RichTextAST']['input']>;
    warranty1?: InputMaybe<WarrantyUpdateOneInlineInput>;
    warranty2?: InputMaybe<WarrantyUpdateOneInlineInput>;
    warrantyHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type PageWarrantyUpdateManyInlineInput = {
    /** Connect multiple existing PageWarranty documents */
    connect?: InputMaybe<Array<PageWarrantyConnectInput>>;
    /** Create and connect multiple PageWarranty documents */
    create?: InputMaybe<Array<PageWarrantyCreateInput>>;
    /** Delete multiple PageWarranty documents */
    delete?: InputMaybe<Array<PageWarrantyWhereUniqueInput>>;
    /** Disconnect multiple PageWarranty documents */
    disconnect?: InputMaybe<Array<PageWarrantyWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing PageWarranty documents */
    set?: InputMaybe<Array<PageWarrantyWhereUniqueInput>>;
    /** Update multiple PageWarranty documents */
    update?: InputMaybe<Array<PageWarrantyUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple PageWarranty documents */
    upsert?: InputMaybe<Array<PageWarrantyUpsertWithNestedWhereUniqueInput>>;
};

export type PageWarrantyUpdateManyInput = {
    heroCopy?: InputMaybe<Scalars['String']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    heroSubHeadline?: InputMaybe<Scalars['String']['input']>;
    legalLines?: InputMaybe<Scalars['RichTextAST']['input']>;
    warrantyHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type PageWarrantyUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: PageWarrantyUpdateManyInput;
    /** Document search */
    where: PageWarrantyWhereInput;
};

export type PageWarrantyUpdateOneInlineInput = {
    /** Connect existing PageWarranty document */
    connect?: InputMaybe<PageWarrantyWhereUniqueInput>;
    /** Create and connect one PageWarranty document */
    create?: InputMaybe<PageWarrantyCreateInput>;
    /** Delete currently connected PageWarranty document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected PageWarranty document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single PageWarranty document */
    update?: InputMaybe<PageWarrantyUpdateWithNestedWhereUniqueInput>;
    /** Upsert single PageWarranty document */
    upsert?: InputMaybe<PageWarrantyUpsertWithNestedWhereUniqueInput>;
};

export type PageWarrantyUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: PageWarrantyUpdateInput;
    /** Unique document search */
    where: PageWarrantyWhereUniqueInput;
};

export type PageWarrantyUpsertInput = {
    /** Create document if it didn't exist */
    create: PageWarrantyCreateInput;
    /** Update document if it exists */
    update: PageWarrantyUpdateInput;
};

export type PageWarrantyUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: PageWarrantyUpsertInput;
    /** Unique document search */
    where: PageWarrantyWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageWarrantyWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageWarrantyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageWarrantyWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageWarrantyWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageWarrantyWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<PageWarrantyWhereStageInput>;
    documentInStages_none?: InputMaybe<PageWarrantyWhereStageInput>;
    documentInStages_some?: InputMaybe<PageWarrantyWhereStageInput>;
    faq?: InputMaybe<FaqWhereInput>;
    heroCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    heroImage?: InputMaybe<AssetWhereInput>;
    heroSubHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    heroSubHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    heroSubHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    heroSubHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    heroSubHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    heroSubHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    heroSubHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    heroSubHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    heroSubHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    heroSubHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    warranty1?: InputMaybe<WarrantyWhereInput>;
    warranty2?: InputMaybe<WarrantyWhereInput>;
    warrantyHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    warrantyHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    warrantyHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    warrantyHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    warrantyHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    warrantyHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    warrantyHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    warrantyHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    warrantyHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    warrantyHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageWarrantyWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<PageWarrantyWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<PageWarrantyWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<PageWarrantyWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<PageWarrantyWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References PageWarranty record uniquely */
export type PageWarrantyWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type PublishLocaleInput = {
    /** Locales to publish */
    locale: Locale;
    /** Stages to publish selected locales to */
    stages: Array<Stage>;
};

export type Query = {
    __typename?: 'Query';
    /** Retrieve a single asset */
    asset?: Maybe<Asset>;
    /** Retrieve document version */
    assetVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple assets */
    assets: Array<Asset>;
    /** Retrieve multiple assets using the Relay connection interface */
    assetsConnection: AssetConnection;
    /** Retrieve a single auth0User */
    auth0User?: Maybe<Auth0User>;
    /** Retrieve document version */
    auth0UserVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple auth0Users */
    auth0Users: Array<Auth0User>;
    /** Retrieve multiple auth0Users using the Relay connection interface */
    auth0UsersConnection: Auth0UserConnection;
    /** Retrieve a single campaign */
    campaign?: Maybe<Campaign>;
    /** Retrieve a single campaignService */
    campaignService?: Maybe<CampaignService>;
    /** Retrieve document version */
    campaignServiceVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple campaignServices */
    campaignServices: Array<CampaignService>;
    /** Retrieve multiple campaignServices using the Relay connection interface */
    campaignServicesConnection: CampaignServiceConnection;
    /** Retrieve document version */
    campaignVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple campaigns */
    campaigns: Array<Campaign>;
    /** Retrieve multiple campaigns using the Relay connection interface */
    campaignsConnection: CampaignConnection;
    /** Retrieve a single dealer */
    dealer?: Maybe<Dealer>;
    /** Retrieve document version */
    dealerVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple dealers */
    dealers: Array<Dealer>;
    /** Retrieve multiple dealers using the Relay connection interface */
    dealersConnection: DealerConnection;
    /** Retrieve a single department */
    department?: Maybe<Department>;
    /** Retrieve document version */
    departmentVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple departments */
    departments: Array<Department>;
    /** Retrieve multiple departments using the Relay connection interface */
    departmentsConnection: DepartmentConnection;
    /** Fetches an object given its ID */
    entities?: Maybe<Array<Entity>>;
    /** Retrieve a single footnote */
    footnote?: Maybe<Footnote>;
    /** Retrieve document version */
    footnoteVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple footnotes */
    footnotes: Array<Footnote>;
    /** Retrieve multiple footnotes using the Relay connection interface */
    footnotesConnection: FootnoteConnection;
    /** Retrieve a single generalService */
    generalService?: Maybe<GeneralService>;
    /** Retrieve document version */
    generalServiceVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple generalServices */
    generalServices: Array<GeneralService>;
    /** Retrieve multiple generalServices using the Relay connection interface */
    generalServicesConnection: GeneralServiceConnection;
    /** Retrieve a single homeTeaser */
    homeTeaser?: Maybe<HomeTeaser>;
    /** Retrieve document version */
    homeTeaserVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple homeTeasers */
    homeTeasers: Array<HomeTeaser>;
    /** Retrieve multiple homeTeasers using the Relay connection interface */
    homeTeasersConnection: HomeTeaserConnection;
    /** Retrieve a single model */
    model?: Maybe<Model>;
    /** Retrieve document version */
    modelVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple models */
    models: Array<Model>;
    /** Retrieve multiple models using the Relay connection interface */
    modelsConnection: ModelConnection;
    /** Fetches an object given its ID */
    node?: Maybe<Node>;
    /** Retrieve a single overlayBatteryCertificate */
    overlayBatteryCertificate?: Maybe<OverlayBatteryCertificate>;
    /** Retrieve document version */
    overlayBatteryCertificateVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple overlayBatteryCertificates */
    overlayBatteryCertificates: Array<OverlayBatteryCertificate>;
    /** Retrieve multiple overlayBatteryCertificates using the Relay connection interface */
    overlayBatteryCertificatesConnection: OverlayBatteryCertificateConnection;
    /** Retrieve a single pageAboutUs */
    pageAboutUs?: Maybe<PageAboutUs>;
    /** Retrieve document version */
    pageAboutUsVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple pageAboutUses */
    pageAboutUses: Array<PageAboutUs>;
    /** Retrieve multiple pageAboutUses using the Relay connection interface */
    pageAboutUsesConnection: PageAboutUsConnection;
    /** Retrieve a single pageBusinessCustomer */
    pageBusinessCustomer?: Maybe<PageBusinessCustomer>;
    /** Retrieve document version */
    pageBusinessCustomerVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple pageBusinessCustomers */
    pageBusinessCustomers: Array<PageBusinessCustomer>;
    /** Retrieve multiple pageBusinessCustomers using the Relay connection interface */
    pageBusinessCustomersConnection: PageBusinessCustomerConnection;
    /** Retrieve a single pageHome */
    pageHome?: Maybe<PageHome>;
    /** Retrieve document version */
    pageHomeVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple pageHomes */
    pageHomes: Array<PageHome>;
    /** Retrieve multiple pageHomes using the Relay connection interface */
    pageHomesConnection: PageHomeConnection;
    /** Retrieve a single pageHyundaiPromise */
    pageHyundaiPromise?: Maybe<PageHyundaiPromise>;
    /** Retrieve document version */
    pageHyundaiPromiseVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple pageHyundaiPromises */
    pageHyundaiPromises: Array<PageHyundaiPromise>;
    /** Retrieve multiple pageHyundaiPromises using the Relay connection interface */
    pageHyundaiPromisesConnection: PageHyundaiPromiseConnection;
    /** Retrieve a single pageService */
    pageService?: Maybe<PageService>;
    /** Retrieve document version */
    pageServiceVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple pageServices */
    pageServices: Array<PageService>;
    /** Retrieve multiple pageServices using the Relay connection interface */
    pageServicesConnection: PageServiceConnection;
    /** Retrieve multiple pageWarranties */
    pageWarranties: Array<PageWarranty>;
    /** Retrieve multiple pageWarranties using the Relay connection interface */
    pageWarrantiesConnection: PageWarrantyConnection;
    /** Retrieve a single pageWarranty */
    pageWarranty?: Maybe<PageWarranty>;
    /** Retrieve document version */
    pageWarrantyVersion?: Maybe<DocumentVersion>;
    /** Retrieve a single scheduledOperation */
    scheduledOperation?: Maybe<ScheduledOperation>;
    /** Retrieve multiple scheduledOperations */
    scheduledOperations: Array<ScheduledOperation>;
    /** Retrieve multiple scheduledOperations using the Relay connection interface */
    scheduledOperationsConnection: ScheduledOperationConnection;
    /** Retrieve a single scheduledRelease */
    scheduledRelease?: Maybe<ScheduledRelease>;
    /** Retrieve multiple scheduledReleases */
    scheduledReleases: Array<ScheduledRelease>;
    /** Retrieve multiple scheduledReleases using the Relay connection interface */
    scheduledReleasesConnection: ScheduledReleaseConnection;
    /** Retrieve a single user */
    user?: Maybe<User>;
    /** Retrieve multiple users */
    users: Array<User>;
    /** Retrieve multiple users using the Relay connection interface */
    usersConnection: UserConnection;
    /** Retrieve a single vehicle */
    vehicle?: Maybe<Vehicle>;
    /** Retrieve document version */
    vehicleVersion?: Maybe<DocumentVersion>;
    /** Retrieve multiple vehicles */
    vehicles: Array<Vehicle>;
    /** Retrieve multiple vehicles using the Relay connection interface */
    vehiclesConnection: VehicleConnection;
    /** Retrieve multiple warranties */
    warranties: Array<Warranty>;
    /** Retrieve multiple warranties using the Relay connection interface */
    warrantiesConnection: WarrantyConnection;
    /** Retrieve a single warranty */
    warranty?: Maybe<Warranty>;
    /** Retrieve document version */
    warrantyVersion?: Maybe<DocumentVersion>;
};

export type QueryAssetArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: AssetWhereUniqueInput;
};

export type QueryAssetVersionArgs = {
    where: VersionWhereInput;
};

export type QueryAssetsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<AssetOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<AssetWhereInput>;
};

export type QueryAssetsConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<AssetOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<AssetWhereInput>;
};

export type QueryAuth0UserArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: Auth0UserWhereUniqueInput;
};

export type QueryAuth0UserVersionArgs = {
    where: VersionWhereInput;
};

export type QueryAuth0UsersArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<Auth0UserOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<Auth0UserWhereInput>;
};

export type QueryAuth0UsersConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<Auth0UserOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<Auth0UserWhereInput>;
};

export type QueryCampaignArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: CampaignWhereUniqueInput;
};

export type QueryCampaignServiceArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: CampaignServiceWhereUniqueInput;
};

export type QueryCampaignServiceVersionArgs = {
    where: VersionWhereInput;
};

export type QueryCampaignServicesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<CampaignServiceOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<CampaignServiceWhereInput>;
};

export type QueryCampaignServicesConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<CampaignServiceOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<CampaignServiceWhereInput>;
};

export type QueryCampaignVersionArgs = {
    where: VersionWhereInput;
};

export type QueryCampaignsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<CampaignOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<CampaignWhereInput>;
};

export type QueryCampaignsConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<CampaignOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<CampaignWhereInput>;
};

export type QueryDealerArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: DealerWhereUniqueInput;
};

export type QueryDealerVersionArgs = {
    where: VersionWhereInput;
};

export type QueryDealersArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<DealerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<DealerWhereInput>;
};

export type QueryDealersConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<DealerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<DealerWhereInput>;
};

export type QueryDepartmentArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: DepartmentWhereUniqueInput;
};

export type QueryDepartmentVersionArgs = {
    where: VersionWhereInput;
};

export type QueryDepartmentsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<DepartmentOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<DepartmentWhereInput>;
};

export type QueryDepartmentsConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<DepartmentOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<DepartmentWhereInput>;
};

export type QueryEntitiesArgs = {
    locales?: InputMaybe<Array<Locale>>;
    where: Array<EntityWhereInput>;
};

export type QueryFootnoteArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: FootnoteWhereUniqueInput;
};

export type QueryFootnoteVersionArgs = {
    where: VersionWhereInput;
};

export type QueryFootnotesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<FootnoteOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<FootnoteWhereInput>;
};

export type QueryFootnotesConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<FootnoteOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<FootnoteWhereInput>;
};

export type QueryGeneralServiceArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: GeneralServiceWhereUniqueInput;
};

export type QueryGeneralServiceVersionArgs = {
    where: VersionWhereInput;
};

export type QueryGeneralServicesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<GeneralServiceOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<GeneralServiceWhereInput>;
};

export type QueryGeneralServicesConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<GeneralServiceOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<GeneralServiceWhereInput>;
};

export type QueryHomeTeaserArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: HomeTeaserWhereUniqueInput;
};

export type QueryHomeTeaserVersionArgs = {
    where: VersionWhereInput;
};

export type QueryHomeTeasersArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<HomeTeaserOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<HomeTeaserWhereInput>;
};

export type QueryHomeTeasersConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<HomeTeaserOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<HomeTeaserWhereInput>;
};

export type QueryModelArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: ModelWhereUniqueInput;
};

export type QueryModelVersionArgs = {
    where: VersionWhereInput;
};

export type QueryModelsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<ModelOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<ModelWhereInput>;
};

export type QueryModelsConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<ModelOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<ModelWhereInput>;
};

export type QueryNodeArgs = {
    id: Scalars['ID']['input'];
    locales?: Array<Locale>;
    stage?: Stage;
};

export type QueryOverlayBatteryCertificateArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: OverlayBatteryCertificateWhereUniqueInput;
};

export type QueryOverlayBatteryCertificateVersionArgs = {
    where: VersionWhereInput;
};

export type QueryOverlayBatteryCertificatesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<OverlayBatteryCertificateOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<OverlayBatteryCertificateWhereInput>;
};

export type QueryOverlayBatteryCertificatesConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<OverlayBatteryCertificateOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<OverlayBatteryCertificateWhereInput>;
};

export type QueryPageAboutUsArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: PageAboutUsWhereUniqueInput;
};

export type QueryPageAboutUsVersionArgs = {
    where: VersionWhereInput;
};

export type QueryPageAboutUsesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<PageAboutUsOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<PageAboutUsWhereInput>;
};

export type QueryPageAboutUsesConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<PageAboutUsOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<PageAboutUsWhereInput>;
};

export type QueryPageBusinessCustomerArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: PageBusinessCustomerWhereUniqueInput;
};

export type QueryPageBusinessCustomerVersionArgs = {
    where: VersionWhereInput;
};

export type QueryPageBusinessCustomersArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<PageBusinessCustomerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<PageBusinessCustomerWhereInput>;
};

export type QueryPageBusinessCustomersConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<PageBusinessCustomerOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<PageBusinessCustomerWhereInput>;
};

export type QueryPageHomeArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: PageHomeWhereUniqueInput;
};

export type QueryPageHomeVersionArgs = {
    where: VersionWhereInput;
};

export type QueryPageHomesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<PageHomeOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<PageHomeWhereInput>;
};

export type QueryPageHomesConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<PageHomeOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<PageHomeWhereInput>;
};

export type QueryPageHyundaiPromiseArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: PageHyundaiPromiseWhereUniqueInput;
};

export type QueryPageHyundaiPromiseVersionArgs = {
    where: VersionWhereInput;
};

export type QueryPageHyundaiPromisesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<PageHyundaiPromiseOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<PageHyundaiPromiseWhereInput>;
};

export type QueryPageHyundaiPromisesConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<PageHyundaiPromiseOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<PageHyundaiPromiseWhereInput>;
};

export type QueryPageServiceArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: PageServiceWhereUniqueInput;
};

export type QueryPageServiceVersionArgs = {
    where: VersionWhereInput;
};

export type QueryPageServicesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<PageServiceOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<PageServiceWhereInput>;
};

export type QueryPageServicesConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<PageServiceOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<PageServiceWhereInput>;
};

export type QueryPageWarrantiesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<PageWarrantyOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<PageWarrantyWhereInput>;
};

export type QueryPageWarrantiesConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<PageWarrantyOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<PageWarrantyWhereInput>;
};

export type QueryPageWarrantyArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: PageWarrantyWhereUniqueInput;
};

export type QueryPageWarrantyVersionArgs = {
    where: VersionWhereInput;
};

export type QueryScheduledOperationArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: ScheduledOperationWhereUniqueInput;
};

export type QueryScheduledOperationsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type QueryScheduledOperationsConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type QueryScheduledReleaseArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: ScheduledReleaseWhereUniqueInput;
};

export type QueryScheduledReleasesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<ScheduledReleaseWhereInput>;
};

export type QueryScheduledReleasesConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<ScheduledReleaseWhereInput>;
};

export type QueryUserArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: UserWhereUniqueInput;
};

export type QueryUsersArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<UserOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<UserWhereInput>;
};

export type QueryUsersConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<UserOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<UserWhereInput>;
};

export type QueryVehicleArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: VehicleWhereUniqueInput;
};

export type QueryVehicleVersionArgs = {
    where: VersionWhereInput;
};

export type QueryVehiclesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<VehicleOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<VehicleWhereInput>;
};

export type QueryVehiclesConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<VehicleOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<VehicleWhereInput>;
};

export type QueryWarrantiesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<WarrantyOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<WarrantyWhereInput>;
};

export type QueryWarrantiesConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: Array<Locale>;
    orderBy?: InputMaybe<WarrantyOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    stage?: Stage;
    where?: InputMaybe<WarrantyWhereInput>;
};

export type QueryWarrantyArgs = {
    locales?: Array<Locale>;
    stage?: Stage;
    where: WarrantyWhereUniqueInput;
};

export type QueryWarrantyVersionArgs = {
    where: VersionWhereInput;
};

export type QuestionAnswer = Entity & {
    __typename?: 'QuestionAnswer';
    answer?: Maybe<RichText>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    question?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuestionAnswerConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: QuestionAnswerWhereUniqueInput;
};

/** A connection to a list of items. */
export type QuestionAnswerConnection = {
    __typename?: 'QuestionAnswerConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<QuestionAnswerEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type QuestionAnswerCreateInput = {
    answer?: InputMaybe<Scalars['RichTextAST']['input']>;
    question?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionAnswerCreateManyInlineInput = {
    /** Create and connect multiple existing QuestionAnswer documents */
    create?: InputMaybe<Array<QuestionAnswerCreateInput>>;
};

export type QuestionAnswerCreateOneInlineInput = {
    /** Create and connect one QuestionAnswer document */
    create?: InputMaybe<QuestionAnswerCreateInput>;
};

export type QuestionAnswerCreateWithPositionInput = {
    /** Document to create */
    data: QuestionAnswerCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type QuestionAnswerEdge = {
    __typename?: 'QuestionAnswerEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: QuestionAnswer;
};

/** Identifies documents */
export type QuestionAnswerManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<QuestionAnswerWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<QuestionAnswerWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<QuestionAnswerWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    question?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    question_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    question_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    question_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    question_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    question_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    question_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    question_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum QuestionAnswerOrderByInput {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    QuestionAsc = 'question_ASC',
    QuestionDesc = 'question_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type QuestionAnswerParent = Faq;

export type QuestionAnswerParentConnectInput = {
    Faq?: InputMaybe<FaqConnectInput>;
};

export type QuestionAnswerParentCreateInput = {
    Faq?: InputMaybe<FaqCreateInput>;
};

export type QuestionAnswerParentCreateManyInlineInput = {
    /** Create and connect multiple existing QuestionAnswerParent documents */
    create?: InputMaybe<Array<QuestionAnswerParentCreateInput>>;
};

export type QuestionAnswerParentCreateOneInlineInput = {
    /** Create and connect one QuestionAnswerParent document */
    create?: InputMaybe<QuestionAnswerParentCreateInput>;
};

export type QuestionAnswerParentCreateWithPositionInput = {
    Faq?: InputMaybe<FaqCreateWithPositionInput>;
};

export type QuestionAnswerParentUpdateInput = {
    Faq?: InputMaybe<FaqUpdateInput>;
};

export type QuestionAnswerParentUpdateManyInlineInput = {
    /** Create and connect multiple QuestionAnswerParent component instances */
    create?: InputMaybe<Array<QuestionAnswerParentCreateWithPositionInput>>;
    /** Delete multiple QuestionAnswerParent documents */
    delete?: InputMaybe<Array<QuestionAnswerParentWhereUniqueInput>>;
    /** Update multiple QuestionAnswerParent component instances */
    update?: InputMaybe<Array<QuestionAnswerParentUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple QuestionAnswerParent component instances */
    upsert?: InputMaybe<Array<QuestionAnswerParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type QuestionAnswerParentUpdateManyWithNestedWhereInput = {
    Faq?: InputMaybe<FaqUpdateManyWithNestedWhereInput>;
};

export type QuestionAnswerParentUpdateOneInlineInput = {
    /** Create and connect one QuestionAnswerParent document */
    create?: InputMaybe<QuestionAnswerParentCreateInput>;
    /** Delete currently connected QuestionAnswerParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single QuestionAnswerParent document */
    update?: InputMaybe<QuestionAnswerParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single QuestionAnswerParent document */
    upsert?: InputMaybe<QuestionAnswerParentUpsertWithNestedWhereUniqueInput>;
};

export type QuestionAnswerParentUpdateWithNestedWhereUniqueAndPositionInput = {
    Faq?: InputMaybe<FaqUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type QuestionAnswerParentUpdateWithNestedWhereUniqueInput = {
    Faq?: InputMaybe<FaqUpdateWithNestedWhereUniqueInput>;
};

export type QuestionAnswerParentUpsertWithNestedWhereUniqueAndPositionInput = {
    Faq?: InputMaybe<FaqUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type QuestionAnswerParentUpsertWithNestedWhereUniqueInput = {
    Faq?: InputMaybe<FaqUpsertWithNestedWhereUniqueInput>;
};

export type QuestionAnswerParentWhereInput = {
    Faq?: InputMaybe<FaqWhereInput>;
};

export type QuestionAnswerParentWhereUniqueInput = {
    Faq?: InputMaybe<FaqWhereUniqueInput>;
};

export type QuestionAnswerUpdateInput = {
    answer?: InputMaybe<Scalars['RichTextAST']['input']>;
    question?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionAnswerUpdateManyInlineInput = {
    /** Create and connect multiple QuestionAnswer component instances */
    create?: InputMaybe<Array<QuestionAnswerCreateWithPositionInput>>;
    /** Delete multiple QuestionAnswer documents */
    delete?: InputMaybe<Array<QuestionAnswerWhereUniqueInput>>;
    /** Update multiple QuestionAnswer component instances */
    update?: InputMaybe<Array<QuestionAnswerUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple QuestionAnswer component instances */
    upsert?: InputMaybe<Array<QuestionAnswerUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type QuestionAnswerUpdateManyInput = {
    answer?: InputMaybe<Scalars['RichTextAST']['input']>;
    question?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionAnswerUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: QuestionAnswerUpdateManyInput;
    /** Document search */
    where: QuestionAnswerWhereInput;
};

export type QuestionAnswerUpdateOneInlineInput = {
    /** Create and connect one QuestionAnswer document */
    create?: InputMaybe<QuestionAnswerCreateInput>;
    /** Delete currently connected QuestionAnswer document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single QuestionAnswer document */
    update?: InputMaybe<QuestionAnswerUpdateWithNestedWhereUniqueInput>;
    /** Upsert single QuestionAnswer document */
    upsert?: InputMaybe<QuestionAnswerUpsertWithNestedWhereUniqueInput>;
};

export type QuestionAnswerUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<QuestionAnswerUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: QuestionAnswerWhereUniqueInput;
};

export type QuestionAnswerUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: QuestionAnswerUpdateInput;
    /** Unique document search */
    where: QuestionAnswerWhereUniqueInput;
};

export type QuestionAnswerUpsertInput = {
    /** Create document if it didn't exist */
    create: QuestionAnswerCreateInput;
    /** Update document if it exists */
    update: QuestionAnswerUpdateInput;
};

export type QuestionAnswerUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<QuestionAnswerUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: QuestionAnswerWhereUniqueInput;
};

export type QuestionAnswerUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: QuestionAnswerUpsertInput;
    /** Unique document search */
    where: QuestionAnswerWhereUniqueInput;
};

/** Identifies documents */
export type QuestionAnswerWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<QuestionAnswerWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<QuestionAnswerWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<QuestionAnswerWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    question?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    question_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    question_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    question_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    question_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    question_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    question_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    question_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References QuestionAnswer record uniquely */
export type QuestionAnswerWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type Rgba = {
    __typename?: 'RGBA';
    a: Scalars['RGBATransparency']['output'];
    b: Scalars['RGBAHue']['output'];
    g: Scalars['RGBAHue']['output'];
    r: Scalars['RGBAHue']['output'];
};

/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RgbaInput = {
    a: Scalars['RGBATransparency']['input'];
    b: Scalars['RGBAHue']['input'];
    g: Scalars['RGBAHue']['input'];
    r: Scalars['RGBAHue']['input'];
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
    __typename?: 'RichText';
    /** Returns HTMl representation */
    html: Scalars['String']['output'];
    /** Returns Markdown representation */
    markdown: Scalars['String']['output'];
    /** Returns AST representation */
    raw: Scalars['RichTextAST']['output'];
    /** Returns plain-text contents of RichText */
    text: Scalars['String']['output'];
};

export type SalesCampaignContent = Entity & {
    __typename?: 'SalesCampaignContent';
    /** Angebots-CTA: Für neue Modelle, für die es noch kein PF-Formular gibt.  Blendet alle PF-CTAs aus. CTA führt dann zum Angebotsform auf CW. */
    ctaType: CtaType;
    highlightBannerHeadline?: Maybe<Scalars['String']['output']>;
    highlightBannerHeadlinePersonalized?: Maybe<Scalars['String']['output']>;
    highlightBannerSubheadline?: Maybe<Scalars['String']['output']>;
    highlightBannerSubheadlinePersonalized?: Maybe<Scalars['String']['output']>;
    highlightModuleAsset?: Maybe<Asset>;
    highlightModuleBadge?: Maybe<Scalars['String']['output']>;
    highlightModuleBadgePersonalized?: Maybe<Scalars['String']['output']>;
    highlightModuleCopy?: Maybe<Scalars['String']['output']>;
    highlightModuleCopy2?: Maybe<Scalars['String']['output']>;
    highlightModuleCopy2Personalized?: Maybe<Scalars['String']['output']>;
    highlightModuleCopyPersonalized?: Maybe<Scalars['String']['output']>;
    highlightModuleHeadline?: Maybe<Scalars['String']['output']>;
    highlightModuleHeadlinePersonalized?: Maybe<Scalars['String']['output']>;
    highlightModuleImageCaption?: Maybe<Scalars['String']['output']>;
    highlightModuleSubheadline?: Maybe<Scalars['String']['output']>;
    highlightModuleSubheadlinePersonalized?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    isBusinessCampaign?: Maybe<Scalars['Boolean']['output']>;
    /** Wird im hellblauen Aktions-Banner für KeyCampaigns ausgegeben */
    minimumShortTitle: Scalars['String']['output'];
    offerformUrlOverride?: Maybe<Scalars['String']['output']>;
    salesCampaignSpecificModels: Array<SalesCampaignContentsalesCampaignSpecificModelsUnion>;
    /** System stage field */
    stage: Stage;
    testdriveUrlOverride?: Maybe<Scalars['String']['output']>;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
    warrantyLogo1?: Maybe<Asset>;
    warrantyLogo2?: Maybe<Asset>;
    warrantyLogo3?: Maybe<Asset>;
};

export type SalesCampaignContentHighlightModuleAssetArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type SalesCampaignContentSalesCampaignSpecificModelsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SalesCampaignContentWarrantyLogo1Args = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type SalesCampaignContentWarrantyLogo2Args = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type SalesCampaignContentWarrantyLogo3Args = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type SalesCampaignContentConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: SalesCampaignContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type SalesCampaignContentConnection = {
    __typename?: 'SalesCampaignContentConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<SalesCampaignContentEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type SalesCampaignContentCreateInput = {
    ctaType: CtaType;
    highlightBannerHeadline?: InputMaybe<Scalars['String']['input']>;
    highlightBannerHeadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightBannerSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightBannerSubheadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleAsset?: InputMaybe<AssetCreateOneInlineInput>;
    highlightModuleBadge?: InputMaybe<Scalars['String']['input']>;
    highlightModuleBadgePersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy2?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy2Personalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopyPersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleHeadline?: InputMaybe<Scalars['String']['input']>;
    highlightModuleHeadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleImageCaption?: InputMaybe<Scalars['String']['input']>;
    highlightModuleSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightModuleSubheadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    isBusinessCampaign?: InputMaybe<Scalars['Boolean']['input']>;
    minimumShortTitle: Scalars['String']['input'];
    offerformUrlOverride?: InputMaybe<Scalars['String']['input']>;
    salesCampaignSpecificModels?: InputMaybe<SalesCampaignContentsalesCampaignSpecificModelsUnionCreateManyInlineInput>;
    testdriveUrlOverride?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    warrantyLogo1?: InputMaybe<AssetCreateOneInlineInput>;
    warrantyLogo2?: InputMaybe<AssetCreateOneInlineInput>;
    warrantyLogo3?: InputMaybe<AssetCreateOneInlineInput>;
};

export type SalesCampaignContentCreateManyInlineInput = {
    /** Create and connect multiple existing SalesCampaignContent documents */
    create?: InputMaybe<Array<SalesCampaignContentCreateInput>>;
};

export type SalesCampaignContentCreateOneInlineInput = {
    /** Create and connect one SalesCampaignContent document */
    create?: InputMaybe<SalesCampaignContentCreateInput>;
};

export type SalesCampaignContentCreateWithPositionInput = {
    /** Document to create */
    data: SalesCampaignContentCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type SalesCampaignContentEdge = {
    __typename?: 'SalesCampaignContentEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: SalesCampaignContent;
};

/** Identifies documents */
export type SalesCampaignContentManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<SalesCampaignContentWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<SalesCampaignContentWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<SalesCampaignContentWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    ctaType?: InputMaybe<CtaType>;
    /** All values that are contained in given list. */
    ctaType_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    /** Any other value that exists and is not equal to the given value. */
    ctaType_not?: InputMaybe<CtaType>;
    /** All values that are not contained in given list. */
    ctaType_not_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    highlightBannerHeadline?: InputMaybe<Scalars['String']['input']>;
    highlightBannerHeadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBannerHeadlinePersonalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBannerHeadlinePersonalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBannerHeadlinePersonalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBannerHeadlinePersonalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBannerHeadlinePersonalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBannerHeadlinePersonalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBannerHeadlinePersonalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBannerHeadlinePersonalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBannerHeadlinePersonalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBannerHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBannerHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBannerHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBannerHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBannerHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBannerHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBannerHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBannerHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBannerHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightBannerSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightBannerSubheadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBannerSubheadlinePersonalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBannerSubheadlinePersonalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBannerSubheadlinePersonalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBannerSubheadlinePersonalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBannerSubheadlinePersonalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBannerSubheadlinePersonalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBannerSubheadlinePersonalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBannerSubheadlinePersonalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBannerSubheadlinePersonalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBannerSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBannerSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBannerSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBannerSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBannerSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBannerSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBannerSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBannerSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBannerSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightModuleAsset?: InputMaybe<AssetWhereInput>;
    highlightModuleBadge?: InputMaybe<Scalars['String']['input']>;
    highlightModuleBadgePersonalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleBadgePersonalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleBadgePersonalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleBadgePersonalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleBadgePersonalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleBadgePersonalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleBadgePersonalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleBadgePersonalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleBadgePersonalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleBadgePersonalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleBadge_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleBadge_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleBadge_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleBadge_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleBadge_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleBadge_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleBadge_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleBadge_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleBadge_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy2?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy2Personalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleCopy2Personalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleCopy2Personalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleCopy2Personalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleCopy2Personalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleCopy2Personalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleCopy2Personalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleCopy2Personalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleCopy2Personalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleCopy2Personalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleCopy2_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleCopy2_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleCopy2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleCopy2_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleCopy2_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleCopy2_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleCopy2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleCopy2_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleCopy2_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopyPersonalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleCopyPersonalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleCopyPersonalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleCopyPersonalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleCopyPersonalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleCopyPersonalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleCopyPersonalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleCopyPersonalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleCopyPersonalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleCopyPersonalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightModuleHeadline?: InputMaybe<Scalars['String']['input']>;
    highlightModuleHeadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleHeadlinePersonalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleHeadlinePersonalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleHeadlinePersonalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleHeadlinePersonalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleHeadlinePersonalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleHeadlinePersonalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleHeadlinePersonalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleHeadlinePersonalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleHeadlinePersonalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightModuleImageCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleImageCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleImageCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleImageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleImageCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleImageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleImageCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleImageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleImageCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleImageCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightModuleSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightModuleSubheadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleSubheadlinePersonalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleSubheadlinePersonalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleSubheadlinePersonalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleSubheadlinePersonalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleSubheadlinePersonalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleSubheadlinePersonalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleSubheadlinePersonalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleSubheadlinePersonalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleSubheadlinePersonalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    isBusinessCampaign?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    isBusinessCampaign_not?: InputMaybe<Scalars['Boolean']['input']>;
    minimumShortTitle?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    minimumShortTitle_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    minimumShortTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    minimumShortTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    minimumShortTitle_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    minimumShortTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    minimumShortTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    minimumShortTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    minimumShortTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    minimumShortTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
    offerformUrlOverride?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    offerformUrlOverride_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    offerformUrlOverride_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    offerformUrlOverride_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    offerformUrlOverride_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    offerformUrlOverride_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    offerformUrlOverride_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    offerformUrlOverride_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    offerformUrlOverride_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    offerformUrlOverride_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values in which the union is empty. */
    salesCampaignSpecificModels_empty?: InputMaybe<Scalars['Boolean']['input']>;
    /** Matches if the modular component contains at least one connection to the item provided to the filter */
    salesCampaignSpecificModels_some?: InputMaybe<SalesCampaignContentsalesCampaignSpecificModelsUnionWhereInput>;
    testdriveUrlOverride?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    testdriveUrlOverride_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    testdriveUrlOverride_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    testdriveUrlOverride_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    testdriveUrlOverride_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    testdriveUrlOverride_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    testdriveUrlOverride_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    testdriveUrlOverride_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    testdriveUrlOverride_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    testdriveUrlOverride_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    warrantyLogo1?: InputMaybe<AssetWhereInput>;
    warrantyLogo2?: InputMaybe<AssetWhereInput>;
    warrantyLogo3?: InputMaybe<AssetWhereInput>;
};

export enum SalesCampaignContentOrderByInput {
    CtaTypeAsc = 'ctaType_ASC',
    CtaTypeDesc = 'ctaType_DESC',
    HighlightBannerHeadlinePersonalizedAsc = 'highlightBannerHeadlinePersonalized_ASC',
    HighlightBannerHeadlinePersonalizedDesc = 'highlightBannerHeadlinePersonalized_DESC',
    HighlightBannerHeadlineAsc = 'highlightBannerHeadline_ASC',
    HighlightBannerHeadlineDesc = 'highlightBannerHeadline_DESC',
    HighlightBannerSubheadlinePersonalizedAsc = 'highlightBannerSubheadlinePersonalized_ASC',
    HighlightBannerSubheadlinePersonalizedDesc = 'highlightBannerSubheadlinePersonalized_DESC',
    HighlightBannerSubheadlineAsc = 'highlightBannerSubheadline_ASC',
    HighlightBannerSubheadlineDesc = 'highlightBannerSubheadline_DESC',
    HighlightModuleBadgePersonalizedAsc = 'highlightModuleBadgePersonalized_ASC',
    HighlightModuleBadgePersonalizedDesc = 'highlightModuleBadgePersonalized_DESC',
    HighlightModuleBadgeAsc = 'highlightModuleBadge_ASC',
    HighlightModuleBadgeDesc = 'highlightModuleBadge_DESC',
    HighlightModuleCopy2PersonalizedAsc = 'highlightModuleCopy2Personalized_ASC',
    HighlightModuleCopy2PersonalizedDesc = 'highlightModuleCopy2Personalized_DESC',
    HighlightModuleCopy2Asc = 'highlightModuleCopy2_ASC',
    HighlightModuleCopy2Desc = 'highlightModuleCopy2_DESC',
    HighlightModuleCopyPersonalizedAsc = 'highlightModuleCopyPersonalized_ASC',
    HighlightModuleCopyPersonalizedDesc = 'highlightModuleCopyPersonalized_DESC',
    HighlightModuleCopyAsc = 'highlightModuleCopy_ASC',
    HighlightModuleCopyDesc = 'highlightModuleCopy_DESC',
    HighlightModuleHeadlinePersonalizedAsc = 'highlightModuleHeadlinePersonalized_ASC',
    HighlightModuleHeadlinePersonalizedDesc = 'highlightModuleHeadlinePersonalized_DESC',
    HighlightModuleHeadlineAsc = 'highlightModuleHeadline_ASC',
    HighlightModuleHeadlineDesc = 'highlightModuleHeadline_DESC',
    HighlightModuleImageCaptionAsc = 'highlightModuleImageCaption_ASC',
    HighlightModuleImageCaptionDesc = 'highlightModuleImageCaption_DESC',
    HighlightModuleSubheadlinePersonalizedAsc = 'highlightModuleSubheadlinePersonalized_ASC',
    HighlightModuleSubheadlinePersonalizedDesc = 'highlightModuleSubheadlinePersonalized_DESC',
    HighlightModuleSubheadlineAsc = 'highlightModuleSubheadline_ASC',
    HighlightModuleSubheadlineDesc = 'highlightModuleSubheadline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    IsBusinessCampaignAsc = 'isBusinessCampaign_ASC',
    IsBusinessCampaignDesc = 'isBusinessCampaign_DESC',
    MinimumShortTitleAsc = 'minimumShortTitle_ASC',
    MinimumShortTitleDesc = 'minimumShortTitle_DESC',
    OfferformUrlOverrideAsc = 'offerformUrlOverride_ASC',
    OfferformUrlOverrideDesc = 'offerformUrlOverride_DESC',
    TestdriveUrlOverrideAsc = 'testdriveUrlOverride_ASC',
    TestdriveUrlOverrideDesc = 'testdriveUrlOverride_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type SalesCampaignContentParent = Campaign;

export type SalesCampaignContentParentConnectInput = {
    Campaign?: InputMaybe<CampaignConnectInput>;
};

export type SalesCampaignContentParentCreateInput = {
    Campaign?: InputMaybe<CampaignCreateInput>;
};

export type SalesCampaignContentParentCreateManyInlineInput = {
    /** Connect multiple existing SalesCampaignContentParent documents */
    connect?: InputMaybe<Array<SalesCampaignContentParentWhereUniqueInput>>;
    /** Create and connect multiple existing SalesCampaignContentParent documents */
    create?: InputMaybe<Array<SalesCampaignContentParentCreateInput>>;
};

export type SalesCampaignContentParentCreateOneInlineInput = {
    /** Connect one existing SalesCampaignContentParent document */
    connect?: InputMaybe<SalesCampaignContentParentWhereUniqueInput>;
    /** Create and connect one SalesCampaignContentParent document */
    create?: InputMaybe<SalesCampaignContentParentCreateInput>;
};

export type SalesCampaignContentParentUpdateInput = {
    Campaign?: InputMaybe<CampaignUpdateInput>;
};

export type SalesCampaignContentParentUpdateManyInlineInput = {
    /** Connect multiple existing SalesCampaignContentParent documents */
    connect?: InputMaybe<Array<SalesCampaignContentParentConnectInput>>;
    /** Create and connect multiple SalesCampaignContentParent documents */
    create?: InputMaybe<Array<SalesCampaignContentParentCreateInput>>;
    /** Delete multiple SalesCampaignContentParent documents */
    delete?: InputMaybe<Array<SalesCampaignContentParentWhereUniqueInput>>;
    /** Disconnect multiple SalesCampaignContentParent documents */
    disconnect?: InputMaybe<Array<SalesCampaignContentParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing SalesCampaignContentParent documents */
    set?: InputMaybe<Array<SalesCampaignContentParentWhereUniqueInput>>;
    /** Update multiple SalesCampaignContentParent documents */
    update?: InputMaybe<Array<SalesCampaignContentParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple SalesCampaignContentParent documents */
    upsert?: InputMaybe<Array<SalesCampaignContentParentUpsertWithNestedWhereUniqueInput>>;
};

export type SalesCampaignContentParentUpdateManyWithNestedWhereInput = {
    Campaign?: InputMaybe<CampaignUpdateManyWithNestedWhereInput>;
};

export type SalesCampaignContentParentUpdateOneInlineInput = {
    /** Connect existing SalesCampaignContentParent document */
    connect?: InputMaybe<SalesCampaignContentParentWhereUniqueInput>;
    /** Create and connect one SalesCampaignContentParent document */
    create?: InputMaybe<SalesCampaignContentParentCreateInput>;
    /** Delete currently connected SalesCampaignContentParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected SalesCampaignContentParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single SalesCampaignContentParent document */
    update?: InputMaybe<SalesCampaignContentParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single SalesCampaignContentParent document */
    upsert?: InputMaybe<SalesCampaignContentParentUpsertWithNestedWhereUniqueInput>;
};

export type SalesCampaignContentParentUpdateWithNestedWhereUniqueInput = {
    Campaign?: InputMaybe<CampaignUpdateWithNestedWhereUniqueInput>;
};

export type SalesCampaignContentParentUpsertWithNestedWhereUniqueInput = {
    Campaign?: InputMaybe<CampaignUpsertWithNestedWhereUniqueInput>;
};

export type SalesCampaignContentParentWhereInput = {
    Campaign?: InputMaybe<CampaignWhereInput>;
};

export type SalesCampaignContentParentWhereUniqueInput = {
    Campaign?: InputMaybe<CampaignWhereUniqueInput>;
};

export type SalesCampaignContentUpdateInput = {
    ctaType?: InputMaybe<CtaType>;
    highlightBannerHeadline?: InputMaybe<Scalars['String']['input']>;
    highlightBannerHeadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightBannerSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightBannerSubheadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleAsset?: InputMaybe<AssetUpdateOneInlineInput>;
    highlightModuleBadge?: InputMaybe<Scalars['String']['input']>;
    highlightModuleBadgePersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy2?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy2Personalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopyPersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleHeadline?: InputMaybe<Scalars['String']['input']>;
    highlightModuleHeadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleImageCaption?: InputMaybe<Scalars['String']['input']>;
    highlightModuleSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightModuleSubheadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    isBusinessCampaign?: InputMaybe<Scalars['Boolean']['input']>;
    minimumShortTitle?: InputMaybe<Scalars['String']['input']>;
    offerformUrlOverride?: InputMaybe<Scalars['String']['input']>;
    salesCampaignSpecificModels?: InputMaybe<SalesCampaignContentsalesCampaignSpecificModelsUnionUpdateManyInlineInput>;
    testdriveUrlOverride?: InputMaybe<Scalars['String']['input']>;
    warrantyLogo1?: InputMaybe<AssetUpdateOneInlineInput>;
    warrantyLogo2?: InputMaybe<AssetUpdateOneInlineInput>;
    warrantyLogo3?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type SalesCampaignContentUpdateManyInlineInput = {
    /** Create and connect multiple SalesCampaignContent component instances */
    create?: InputMaybe<Array<SalesCampaignContentCreateWithPositionInput>>;
    /** Delete multiple SalesCampaignContent documents */
    delete?: InputMaybe<Array<SalesCampaignContentWhereUniqueInput>>;
    /** Update multiple SalesCampaignContent component instances */
    update?: InputMaybe<Array<SalesCampaignContentUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple SalesCampaignContent component instances */
    upsert?: InputMaybe<Array<SalesCampaignContentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SalesCampaignContentUpdateManyInput = {
    ctaType?: InputMaybe<CtaType>;
    highlightBannerHeadline?: InputMaybe<Scalars['String']['input']>;
    highlightBannerHeadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightBannerSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightBannerSubheadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleBadge?: InputMaybe<Scalars['String']['input']>;
    highlightModuleBadgePersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy2?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy2Personalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopyPersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleHeadline?: InputMaybe<Scalars['String']['input']>;
    highlightModuleHeadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    highlightModuleImageCaption?: InputMaybe<Scalars['String']['input']>;
    highlightModuleSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightModuleSubheadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    isBusinessCampaign?: InputMaybe<Scalars['Boolean']['input']>;
    minimumShortTitle?: InputMaybe<Scalars['String']['input']>;
    offerformUrlOverride?: InputMaybe<Scalars['String']['input']>;
    testdriveUrlOverride?: InputMaybe<Scalars['String']['input']>;
};

export type SalesCampaignContentUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: SalesCampaignContentUpdateManyInput;
    /** Document search */
    where: SalesCampaignContentWhereInput;
};

export type SalesCampaignContentUpdateOneInlineInput = {
    /** Create and connect one SalesCampaignContent document */
    create?: InputMaybe<SalesCampaignContentCreateInput>;
    /** Delete currently connected SalesCampaignContent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single SalesCampaignContent document */
    update?: InputMaybe<SalesCampaignContentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single SalesCampaignContent document */
    upsert?: InputMaybe<SalesCampaignContentUpsertWithNestedWhereUniqueInput>;
};

export type SalesCampaignContentUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<SalesCampaignContentUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: SalesCampaignContentWhereUniqueInput;
};

export type SalesCampaignContentUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: SalesCampaignContentUpdateInput;
    /** Unique document search */
    where: SalesCampaignContentWhereUniqueInput;
};

export type SalesCampaignContentUpsertInput = {
    /** Create document if it didn't exist */
    create: SalesCampaignContentCreateInput;
    /** Update document if it exists */
    update: SalesCampaignContentUpdateInput;
};

export type SalesCampaignContentUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<SalesCampaignContentUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: SalesCampaignContentWhereUniqueInput;
};

export type SalesCampaignContentUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: SalesCampaignContentUpsertInput;
    /** Unique document search */
    where: SalesCampaignContentWhereUniqueInput;
};

/** Identifies documents */
export type SalesCampaignContentWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<SalesCampaignContentWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<SalesCampaignContentWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<SalesCampaignContentWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    ctaType?: InputMaybe<CtaType>;
    /** All values that are contained in given list. */
    ctaType_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    /** Any other value that exists and is not equal to the given value. */
    ctaType_not?: InputMaybe<CtaType>;
    /** All values that are not contained in given list. */
    ctaType_not_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    highlightBannerHeadline?: InputMaybe<Scalars['String']['input']>;
    highlightBannerHeadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBannerHeadlinePersonalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBannerHeadlinePersonalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBannerHeadlinePersonalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBannerHeadlinePersonalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBannerHeadlinePersonalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBannerHeadlinePersonalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBannerHeadlinePersonalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBannerHeadlinePersonalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBannerHeadlinePersonalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBannerHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBannerHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBannerHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBannerHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBannerHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBannerHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBannerHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBannerHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBannerHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightBannerSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightBannerSubheadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBannerSubheadlinePersonalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBannerSubheadlinePersonalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBannerSubheadlinePersonalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBannerSubheadlinePersonalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBannerSubheadlinePersonalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBannerSubheadlinePersonalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBannerSubheadlinePersonalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBannerSubheadlinePersonalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBannerSubheadlinePersonalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBannerSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBannerSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBannerSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBannerSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBannerSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBannerSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBannerSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBannerSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBannerSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightModuleAsset?: InputMaybe<AssetWhereInput>;
    highlightModuleBadge?: InputMaybe<Scalars['String']['input']>;
    highlightModuleBadgePersonalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleBadgePersonalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleBadgePersonalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleBadgePersonalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleBadgePersonalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleBadgePersonalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleBadgePersonalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleBadgePersonalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleBadgePersonalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleBadgePersonalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleBadge_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleBadge_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleBadge_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleBadge_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleBadge_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleBadge_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleBadge_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleBadge_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleBadge_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy2?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopy2Personalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleCopy2Personalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleCopy2Personalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleCopy2Personalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleCopy2Personalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleCopy2Personalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleCopy2Personalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleCopy2Personalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleCopy2Personalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleCopy2Personalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleCopy2_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleCopy2_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleCopy2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleCopy2_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleCopy2_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleCopy2_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleCopy2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleCopy2_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleCopy2_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightModuleCopyPersonalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleCopyPersonalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleCopyPersonalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleCopyPersonalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleCopyPersonalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleCopyPersonalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleCopyPersonalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleCopyPersonalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleCopyPersonalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleCopyPersonalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightModuleHeadline?: InputMaybe<Scalars['String']['input']>;
    highlightModuleHeadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleHeadlinePersonalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleHeadlinePersonalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleHeadlinePersonalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleHeadlinePersonalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleHeadlinePersonalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleHeadlinePersonalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleHeadlinePersonalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleHeadlinePersonalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleHeadlinePersonalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightModuleImageCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleImageCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleImageCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleImageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleImageCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleImageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleImageCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleImageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleImageCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleImageCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightModuleSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightModuleSubheadlinePersonalized?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleSubheadlinePersonalized_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleSubheadlinePersonalized_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleSubheadlinePersonalized_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleSubheadlinePersonalized_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleSubheadlinePersonalized_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleSubheadlinePersonalized_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleSubheadlinePersonalized_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleSubheadlinePersonalized_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleSubheadlinePersonalized_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightModuleSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightModuleSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightModuleSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightModuleSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightModuleSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightModuleSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightModuleSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightModuleSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightModuleSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    isBusinessCampaign?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    isBusinessCampaign_not?: InputMaybe<Scalars['Boolean']['input']>;
    minimumShortTitle?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    minimumShortTitle_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    minimumShortTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    minimumShortTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    minimumShortTitle_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    minimumShortTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    minimumShortTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    minimumShortTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    minimumShortTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    minimumShortTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
    offerformUrlOverride?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    offerformUrlOverride_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    offerformUrlOverride_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    offerformUrlOverride_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    offerformUrlOverride_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    offerformUrlOverride_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    offerformUrlOverride_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    offerformUrlOverride_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    offerformUrlOverride_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    offerformUrlOverride_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values in which the union is empty. */
    salesCampaignSpecificModels_empty?: InputMaybe<Scalars['Boolean']['input']>;
    /** Matches if the modular component contains at least one connection to the item provided to the filter */
    salesCampaignSpecificModels_some?: InputMaybe<SalesCampaignContentsalesCampaignSpecificModelsUnionWhereInput>;
    testdriveUrlOverride?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    testdriveUrlOverride_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    testdriveUrlOverride_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    testdriveUrlOverride_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    testdriveUrlOverride_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    testdriveUrlOverride_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    testdriveUrlOverride_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    testdriveUrlOverride_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    testdriveUrlOverride_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    testdriveUrlOverride_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    warrantyLogo1?: InputMaybe<AssetWhereInput>;
    warrantyLogo2?: InputMaybe<AssetWhereInput>;
    warrantyLogo3?: InputMaybe<AssetWhereInput>;
};

/** References SalesCampaignContent record uniquely */
export type SalesCampaignContentWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnion = SalesCampaignModel;

export type SalesCampaignContentsalesCampaignSpecificModelsUnionConnectInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelConnectInput>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionCreateInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelCreateInput>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionCreateManyInlineInput = {
    /** Create and connect multiple existing SalesCampaignContentsalesCampaignSpecificModelsUnion documents */
    create?: InputMaybe<Array<SalesCampaignContentsalesCampaignSpecificModelsUnionCreateInput>>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionCreateOneInlineInput = {
    /** Create and connect one SalesCampaignContentsalesCampaignSpecificModelsUnion document */
    create?: InputMaybe<SalesCampaignContentsalesCampaignSpecificModelsUnionCreateInput>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionCreateWithPositionInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelCreateWithPositionInput>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionUpdateInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateInput>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionUpdateManyInlineInput = {
    /** Create and connect multiple SalesCampaignContentsalesCampaignSpecificModelsUnion component instances */
    create?: InputMaybe<Array<SalesCampaignContentsalesCampaignSpecificModelsUnionCreateWithPositionInput>>;
    /** Delete multiple SalesCampaignContentsalesCampaignSpecificModelsUnion documents */
    delete?: InputMaybe<Array<SalesCampaignContentsalesCampaignSpecificModelsUnionWhereUniqueInput>>;
    /** Update multiple SalesCampaignContentsalesCampaignSpecificModelsUnion component instances */
    update?: InputMaybe<
        Array<SalesCampaignContentsalesCampaignSpecificModelsUnionUpdateWithNestedWhereUniqueAndPositionInput>
    >;
    /** Upsert multiple SalesCampaignContentsalesCampaignSpecificModelsUnion component instances */
    upsert?: InputMaybe<
        Array<SalesCampaignContentsalesCampaignSpecificModelsUnionUpsertWithNestedWhereUniqueAndPositionInput>
    >;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionUpdateManyWithNestedWhereInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateManyWithNestedWhereInput>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionUpdateOneInlineInput = {
    /** Create and connect one SalesCampaignContentsalesCampaignSpecificModelsUnion document */
    create?: InputMaybe<SalesCampaignContentsalesCampaignSpecificModelsUnionCreateInput>;
    /** Delete currently connected SalesCampaignContentsalesCampaignSpecificModelsUnion document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single SalesCampaignContentsalesCampaignSpecificModelsUnion document */
    update?: InputMaybe<SalesCampaignContentsalesCampaignSpecificModelsUnionUpdateWithNestedWhereUniqueInput>;
    /** Upsert single SalesCampaignContentsalesCampaignSpecificModelsUnion document */
    upsert?: InputMaybe<SalesCampaignContentsalesCampaignSpecificModelsUnionUpsertWithNestedWhereUniqueInput>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionUpdateWithNestedWhereUniqueInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpdateWithNestedWhereUniqueInput>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionUpsertWithNestedWhereUniqueInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelUpsertWithNestedWhereUniqueInput>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionWhereInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelWhereInput>;
};

export type SalesCampaignContentsalesCampaignSpecificModelsUnionWhereUniqueInput = {
    SalesCampaignModel?: InputMaybe<SalesCampaignModelWhereUniqueInput>;
};

export type SalesCampaignModel = Entity & {
    __typename?: 'SalesCampaignModel';
    bankCodes: Array<BankCode>;
    cashPriceCopy?: Maybe<Scalars['String']['output']>;
    cashPriceHeadline?: Maybe<Scalars['String']['output']>;
    cashPriceSubheadline?: Maybe<Scalars['String']['output']>;
    contentCopy?: Maybe<Scalars['String']['output']>;
    contentHeadline?: Maybe<Scalars['String']['output']>;
    contentImage?: Maybe<Asset>;
    contentImageCaption?: Maybe<Scalars['String']['output']>;
    /** Fußnote für Händlerrate wenn Preistyp Barpreis ist */
    dealerPriceFootnoteCash?: Maybe<Footnote>;
    /** Fußnote für Händlerrate wenn Preistyp Finanzierung ist */
    dealerPriceFootnoteFinance?: Maybe<Footnote>;
    /** Fußnote für Händlerraten wenn Preistyp Leasing ist */
    dealerPriceFootnoteLeasing?: Maybe<Footnote>;
    /** Moccamedia übergibt die Modelle im utm_creative-format und die Modell-Bezeichnungen werden durch Bindestriche getrennt, also bspw. utm_creative-format=tucson oder utm_creative_format=tuscon-hybrid */
    deepLinkUtmCreativeValue?: Maybe<Scalars['String']['output']>;
    /** Mit diesem Flag kann man die Ausgabe der Envkv Daten im Teaser ausschalten */
    disableEnvkvDataTeaser?: Maybe<Scalars['Boolean']['output']>;
    /** Angabe der Kraftstoffverbrauchswerte für nationale Raten. Sollte immer befüllt sein, da dieses Feld auch zur Modellzuweisung zur Aktion dient!  */
    envkvDataSource?: Maybe<SalesCampaignModelEnvkvDataSource>;
    /** Mit diesem Feld kann die Envkv Ausgabe im Teaser überschrieben werden */
    envkvDataSourceTeaser?: Maybe<SalesCampaignModelEnvkvDataSourceTeaser>;
    financingHeadline?: Maybe<Scalars['String']['output']>;
    financingSubheadline?: Maybe<Scalars['String']['output']>;
    /** Kurztext / Vorteilstext.  Max. Zeichenanzahl tbd */
    highlightBadgeKurztext?: Maybe<Scalars['String']['output']>;
    /** Präfix-Text für nationale Inhalte. Max. 7 Zeichen. Optional. Kurze Textfragmente wie „bis zu“, „ab“, „jetzt“ etc. */
    highlightBadgePrefix?: Maybe<Scalars['String']['output']>;
    /**
     * Präfix-Text für händlerpersonaloiserte Raten Inhalte. Max. 7 Zeichen. Optional.
     * Kurze Textfragmente wie „bis zu“, „ab“, „jetzt“ etc.
     */
    highlightBadgePrefixDealer?: Maybe<Scalars['String']['output']>;
    /** max. 4 Zeichen. Feste Fußnote, die händlerindividuell oder national definiert werden kann */
    highlightBadgeUnit?: Maybe<Scalars['String']['output']>;
    highlightBadgeUnitDealerFootnote?: Maybe<Footnote>;
    highlightBadgeUnitNationalFootnote?: Maybe<Footnote>;
    /**
     * max. 5-stellig EUR-Betrag oder Datum TT.MM.JJJJ
     *
     * Kann national oder händlerindividuell definiert werden
     * Kann händlerindividuell überschrieben werden und wird dynamisch je Händler ausgespielt
     */
    highlightBadgeValue?: Maybe<Scalars['String']['output']>;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    image: Asset;
    imageCaption?: Maybe<Scalars['String']['output']>;
    keyFact1?: Maybe<KeyFact>;
    keyFact2?: Maybe<KeyFact>;
    leasingHeadline?: Maybe<Scalars['String']['output']>;
    leasingSubheadline?: Maybe<Scalars['String']['output']>;
    /** Keine Funktion, da Modellzuweisung über das Feld envkv-source stattfindet! */
    mobileId: Scalars['String']['output'];
    model?: Maybe<Model>;
    modelCode?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    /** Barpreis für Nationale Raten */
    nationalCashPrice?: Maybe<Scalars['String']['output']>;
    /** Finanzierung: Anzahlung */
    nationalDownPaymentFinance?: Maybe<Scalars['String']['output']>;
    /** Leasing & Finanzierung: Laufzeit */
    nationalDuration?: Maybe<Scalars['String']['output']>;
    /** Finanzierung: Effektiver Jahreszins */
    nationalEffectiveAnnualRate?: Maybe<Scalars['String']['output']>;
    /** Finanzierung: Schlussrate */
    nationalFinalRate?: Maybe<Scalars['String']['output']>;
    /** Finanzierung: Gebundener Sollzinssatz p.a. */
    nationalFixedDebitRate?: Maybe<Scalars['String']['output']>;
    /** Leasing: Monatliche Rate */
    nationalLeasingRate?: Maybe<Scalars['String']['output']>;
    /** Leasing: Einmalige Leasingsonderzahlung  */
    nationalLeasingSpecialPayment?: Maybe<Scalars['String']['output']>;
    /** Finanzierung: Monatliche Rate */
    nationalMonthlyRate?: Maybe<Scalars['String']['output']>;
    /** Finanzierung: Nettodarlehensbetrag */
    nationalNetLoanAmount?: Maybe<Scalars['String']['output']>;
    /** Fußnote für nationale Raten für alle Angebotstypen */
    nationalPriceFootnote?: Maybe<Footnote>;
    /** Fußnote für nationale Raten wenn Preistyp Barpreis ist */
    nationalPriceFootnoteCash?: Maybe<Footnote>;
    /** Fußnote für nationale Raten wenn Preistyp Finanzierung ist */
    nationalPriceFootnoteFinance?: Maybe<Footnote>;
    /** Das ist der Disclaimer Text für den nationalen Preis. Z.B.: "Eine Werbung der Hyundai Motor Deutschland GmbH." */
    nationalPricesDisclaimer?: Maybe<Scalars['String']['output']>;
    nationalPricingType: CampaignPricingType;
    /** Finanzierung: Gesamtbetrag */
    nationalTotalAmount?: Maybe<Scalars['String']['output']>;
    /** Leasing & Finanzierung: Gesamtfahrleistung */
    nationalTotalMileage?: Maybe<Scalars['String']['output']>;
    /** Finanzierung: Fahrzeugpreis */
    nationalVehiclePriceFinance?: Maybe<Scalars['String']['output']>;
    /** Individuelles Bild für die Musterangebotsrechnung */
    offerImage?: Maybe<Asset>;
    /** Bildunterschrift für das individuelle Bild für die Musterangebotsrechnung */
    offerImageCaption?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SalesCampaignModelBankCodesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<BankCodeOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BankCodeWhereInput>;
};

export type SalesCampaignModelContentImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type SalesCampaignModelDealerPriceFootnoteCashArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelDealerPriceFootnoteFinanceArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelDealerPriceFootnoteLeasingArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelEnvkvDataSourceArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelEnvkvDataSourceTeaserArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelHighlightBadgeUnitDealerFootnoteArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelHighlightBadgeUnitNationalFootnoteArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type SalesCampaignModelKeyFact1Args = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelKeyFact2Args = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelModelArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelNationalPriceFootnoteArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelNationalPriceFootnoteCashArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelNationalPriceFootnoteFinanceArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type SalesCampaignModelOfferImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type SalesCampaignModelConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: SalesCampaignModelWhereUniqueInput;
};

/** A connection to a list of items. */
export type SalesCampaignModelConnection = {
    __typename?: 'SalesCampaignModelConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<SalesCampaignModelEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type SalesCampaignModelCreateInput = {
    bankCodes?: InputMaybe<BankCodeCreateManyInlineInput>;
    cashPriceCopy?: InputMaybe<Scalars['String']['input']>;
    cashPriceHeadline?: InputMaybe<Scalars['String']['input']>;
    cashPriceSubheadline?: InputMaybe<Scalars['String']['input']>;
    contentCopy?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    contentImage?: InputMaybe<AssetCreateOneInlineInput>;
    contentImageCaption?: InputMaybe<Scalars['String']['input']>;
    dealerPriceFootnoteCash?: InputMaybe<FootnoteCreateOneInlineInput>;
    dealerPriceFootnoteFinance?: InputMaybe<FootnoteCreateOneInlineInput>;
    dealerPriceFootnoteLeasing?: InputMaybe<FootnoteCreateOneInlineInput>;
    deepLinkUtmCreativeValue?: InputMaybe<Scalars['String']['input']>;
    disableEnvkvDataTeaser?: InputMaybe<Scalars['Boolean']['input']>;
    envkvDataSource?: InputMaybe<SalesCampaignModelEnvkvDataSourceCreateOneInlineInput>;
    envkvDataSourceTeaser?: InputMaybe<SalesCampaignModelEnvkvDataSourceTeaserCreateOneInlineInput>;
    financingHeadline?: InputMaybe<Scalars['String']['input']>;
    financingSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeKurztext?: InputMaybe<Scalars['String']['input']>;
    highlightBadgePrefix?: InputMaybe<Scalars['String']['input']>;
    highlightBadgePrefixDealer?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeUnit?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeUnitDealerFootnote?: InputMaybe<FootnoteCreateOneInlineInput>;
    highlightBadgeUnitNationalFootnote?: InputMaybe<FootnoteCreateOneInlineInput>;
    highlightBadgeValue?: InputMaybe<Scalars['String']['input']>;
    image: AssetCreateOneInlineInput;
    imageCaption?: InputMaybe<Scalars['String']['input']>;
    keyFact1?: InputMaybe<KeyFactCreateOneInlineInput>;
    keyFact2?: InputMaybe<KeyFactCreateOneInlineInput>;
    leasingHeadline?: InputMaybe<Scalars['String']['input']>;
    leasingSubheadline?: InputMaybe<Scalars['String']['input']>;
    mobileId: Scalars['String']['input'];
    model?: InputMaybe<ModelCreateOneInlineInput>;
    modelCode?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    nationalCashPrice?: InputMaybe<Scalars['String']['input']>;
    nationalDownPaymentFinance?: InputMaybe<Scalars['String']['input']>;
    nationalDuration?: InputMaybe<Scalars['String']['input']>;
    nationalEffectiveAnnualRate?: InputMaybe<Scalars['String']['input']>;
    nationalFinalRate?: InputMaybe<Scalars['String']['input']>;
    nationalFixedDebitRate?: InputMaybe<Scalars['String']['input']>;
    nationalLeasingRate?: InputMaybe<Scalars['String']['input']>;
    nationalLeasingSpecialPayment?: InputMaybe<Scalars['String']['input']>;
    nationalMonthlyRate?: InputMaybe<Scalars['String']['input']>;
    nationalNetLoanAmount?: InputMaybe<Scalars['String']['input']>;
    nationalPriceFootnote?: InputMaybe<FootnoteCreateOneInlineInput>;
    nationalPriceFootnoteCash?: InputMaybe<FootnoteCreateOneInlineInput>;
    nationalPriceFootnoteFinance?: InputMaybe<FootnoteCreateOneInlineInput>;
    nationalPricesDisclaimer?: InputMaybe<Scalars['String']['input']>;
    nationalPricingType: CampaignPricingType;
    nationalTotalAmount?: InputMaybe<Scalars['String']['input']>;
    nationalTotalMileage?: InputMaybe<Scalars['String']['input']>;
    nationalVehiclePriceFinance?: InputMaybe<Scalars['String']['input']>;
    offerImage?: InputMaybe<AssetCreateOneInlineInput>;
    offerImageCaption?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SalesCampaignModelCreateManyInlineInput = {
    /** Create and connect multiple existing SalesCampaignModel documents */
    create?: InputMaybe<Array<SalesCampaignModelCreateInput>>;
};

export type SalesCampaignModelCreateOneInlineInput = {
    /** Create and connect one SalesCampaignModel document */
    create?: InputMaybe<SalesCampaignModelCreateInput>;
};

export type SalesCampaignModelCreateWithPositionInput = {
    /** Document to create */
    data: SalesCampaignModelCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type SalesCampaignModelEdge = {
    __typename?: 'SalesCampaignModelEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: SalesCampaignModel;
};

export type SalesCampaignModelEnvkvDataSource = Model | Vehicle;

export type SalesCampaignModelEnvkvDataSourceConnectInput = {
    Model?: InputMaybe<ModelConnectInput>;
    Vehicle?: InputMaybe<VehicleConnectInput>;
};

export type SalesCampaignModelEnvkvDataSourceCreateInput = {
    Model?: InputMaybe<ModelCreateInput>;
    Vehicle?: InputMaybe<VehicleCreateInput>;
};

export type SalesCampaignModelEnvkvDataSourceCreateManyInlineInput = {
    /** Connect multiple existing SalesCampaignModelEnvkvDataSource documents */
    connect?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceWhereUniqueInput>>;
    /** Create and connect multiple existing SalesCampaignModelEnvkvDataSource documents */
    create?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceCreateInput>>;
};

export type SalesCampaignModelEnvkvDataSourceCreateOneInlineInput = {
    /** Connect one existing SalesCampaignModelEnvkvDataSource document */
    connect?: InputMaybe<SalesCampaignModelEnvkvDataSourceWhereUniqueInput>;
    /** Create and connect one SalesCampaignModelEnvkvDataSource document */
    create?: InputMaybe<SalesCampaignModelEnvkvDataSourceCreateInput>;
};

export type SalesCampaignModelEnvkvDataSourceUpdateInput = {
    Model?: InputMaybe<ModelUpdateInput>;
    Vehicle?: InputMaybe<VehicleUpdateInput>;
};

export type SalesCampaignModelEnvkvDataSourceUpdateManyInlineInput = {
    /** Connect multiple existing SalesCampaignModelEnvkvDataSource documents */
    connect?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceConnectInput>>;
    /** Create and connect multiple SalesCampaignModelEnvkvDataSource documents */
    create?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceCreateInput>>;
    /** Delete multiple SalesCampaignModelEnvkvDataSource documents */
    delete?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceWhereUniqueInput>>;
    /** Disconnect multiple SalesCampaignModelEnvkvDataSource documents */
    disconnect?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing SalesCampaignModelEnvkvDataSource documents */
    set?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceWhereUniqueInput>>;
    /** Update multiple SalesCampaignModelEnvkvDataSource documents */
    update?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple SalesCampaignModelEnvkvDataSource documents */
    upsert?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceUpsertWithNestedWhereUniqueInput>>;
};

export type SalesCampaignModelEnvkvDataSourceUpdateManyWithNestedWhereInput = {
    Model?: InputMaybe<ModelUpdateManyWithNestedWhereInput>;
    Vehicle?: InputMaybe<VehicleUpdateManyWithNestedWhereInput>;
};

export type SalesCampaignModelEnvkvDataSourceUpdateOneInlineInput = {
    /** Connect existing SalesCampaignModelEnvkvDataSource document */
    connect?: InputMaybe<SalesCampaignModelEnvkvDataSourceWhereUniqueInput>;
    /** Create and connect one SalesCampaignModelEnvkvDataSource document */
    create?: InputMaybe<SalesCampaignModelEnvkvDataSourceCreateInput>;
    /** Delete currently connected SalesCampaignModelEnvkvDataSource document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected SalesCampaignModelEnvkvDataSource document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single SalesCampaignModelEnvkvDataSource document */
    update?: InputMaybe<SalesCampaignModelEnvkvDataSourceUpdateWithNestedWhereUniqueInput>;
    /** Upsert single SalesCampaignModelEnvkvDataSource document */
    upsert?: InputMaybe<SalesCampaignModelEnvkvDataSourceUpsertWithNestedWhereUniqueInput>;
};

export type SalesCampaignModelEnvkvDataSourceUpdateWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpdateWithNestedWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleUpdateWithNestedWhereUniqueInput>;
};

export type SalesCampaignModelEnvkvDataSourceUpsertWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpsertWithNestedWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleUpsertWithNestedWhereUniqueInput>;
};

export type SalesCampaignModelEnvkvDataSourceWhereInput = {
    Model?: InputMaybe<ModelWhereInput>;
    Vehicle?: InputMaybe<VehicleWhereInput>;
};

export type SalesCampaignModelEnvkvDataSourceWhereUniqueInput = {
    Model?: InputMaybe<ModelWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleWhereUniqueInput>;
};

/** Identifies documents */
export type SalesCampaignModelManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<SalesCampaignModelWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<SalesCampaignModelWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<SalesCampaignModelWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    bankCodes_every?: InputMaybe<BankCodeWhereInput>;
    bankCodes_none?: InputMaybe<BankCodeWhereInput>;
    bankCodes_some?: InputMaybe<BankCodeWhereInput>;
    cashPriceCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    cashPriceCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    cashPriceCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    cashPriceCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    cashPriceCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    cashPriceCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    cashPriceCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    cashPriceCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    cashPriceCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    cashPriceCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    cashPriceHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    cashPriceHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    cashPriceHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    cashPriceHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    cashPriceHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    cashPriceHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    cashPriceHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    cashPriceHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    cashPriceHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    cashPriceHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    cashPriceSubheadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    cashPriceSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    cashPriceSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    cashPriceSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    cashPriceSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    cashPriceSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    cashPriceSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    cashPriceSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    cashPriceSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    cashPriceSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentImage?: InputMaybe<AssetWhereInput>;
    contentImageCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentImageCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentImageCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentImageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentImageCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentImageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentImageCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentImageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentImageCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentImageCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    dealerPriceFootnoteCash?: InputMaybe<FootnoteWhereInput>;
    dealerPriceFootnoteFinance?: InputMaybe<FootnoteWhereInput>;
    dealerPriceFootnoteLeasing?: InputMaybe<FootnoteWhereInput>;
    deepLinkUtmCreativeValue?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    deepLinkUtmCreativeValue_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    deepLinkUtmCreativeValue_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    deepLinkUtmCreativeValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    deepLinkUtmCreativeValue_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    deepLinkUtmCreativeValue_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    deepLinkUtmCreativeValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    deepLinkUtmCreativeValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    deepLinkUtmCreativeValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    deepLinkUtmCreativeValue_starts_with?: InputMaybe<Scalars['String']['input']>;
    disableEnvkvDataTeaser?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    disableEnvkvDataTeaser_not?: InputMaybe<Scalars['Boolean']['input']>;
    /** All values in which the union is connected to the given models */
    envkvDataSource?: InputMaybe<SalesCampaignModelEnvkvDataSourceWhereInput>;
    /** All values in which the union is connected to the given models */
    envkvDataSourceTeaser?: InputMaybe<SalesCampaignModelEnvkvDataSourceTeaserWhereInput>;
    /** All values in which the union is empty */
    envkvDataSourceTeaser_empty?: InputMaybe<Scalars['Boolean']['input']>;
    /** All values in which the union is empty */
    envkvDataSource_empty?: InputMaybe<Scalars['Boolean']['input']>;
    financingHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    financingHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    financingHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    financingHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    financingHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    financingHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    financingHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    financingHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    financingHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    financingHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    financingSubheadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    financingSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    financingSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    financingSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    financingSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    financingSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    financingSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    financingSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    financingSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    financingSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeKurztext?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBadgeKurztext_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBadgeKurztext_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBadgeKurztext_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBadgeKurztext_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBadgeKurztext_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBadgeKurztext_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBadgeKurztext_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBadgeKurztext_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBadgeKurztext_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightBadgePrefix?: InputMaybe<Scalars['String']['input']>;
    highlightBadgePrefixDealer?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBadgePrefixDealer_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBadgePrefixDealer_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBadgePrefixDealer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBadgePrefixDealer_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBadgePrefixDealer_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBadgePrefixDealer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBadgePrefixDealer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBadgePrefixDealer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBadgePrefixDealer_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBadgePrefix_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBadgePrefix_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBadgePrefix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBadgePrefix_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBadgePrefix_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBadgePrefix_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBadgePrefix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBadgePrefix_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBadgePrefix_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeUnit?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeUnitDealerFootnote?: InputMaybe<FootnoteWhereInput>;
    highlightBadgeUnitNationalFootnote?: InputMaybe<FootnoteWhereInput>;
    /** All values containing the given string. */
    highlightBadgeUnit_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBadgeUnit_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBadgeUnit_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBadgeUnit_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBadgeUnit_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBadgeUnit_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBadgeUnit_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBadgeUnit_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBadgeUnit_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeValue?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBadgeValue_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBadgeValue_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBadgeValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBadgeValue_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBadgeValue_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBadgeValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBadgeValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBadgeValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBadgeValue_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    imageCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    imageCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    imageCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    imageCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    imageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    imageCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    imageCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    imageCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    keyFact1?: InputMaybe<KeyFactWhereInput>;
    keyFact2?: InputMaybe<KeyFactWhereInput>;
    leasingHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    leasingHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    leasingHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    leasingHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    leasingHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    leasingHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    leasingHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    leasingHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    leasingHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    leasingHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    leasingSubheadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    leasingSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    leasingSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    leasingSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    leasingSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    leasingSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    leasingSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    leasingSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    leasingSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    leasingSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    mobileId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mobileId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mobileId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mobileId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mobileId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mobileId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mobileId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mobileId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mobileId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mobileId_starts_with?: InputMaybe<Scalars['String']['input']>;
    model?: InputMaybe<ModelWhereInput>;
    modelCode?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    modelCode_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    modelCode_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    modelCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    modelCode_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    modelCode_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    modelCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    modelCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    modelCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    modelCode_starts_with?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalCashPrice?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalCashPrice_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalCashPrice_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalCashPrice_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalCashPrice_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalCashPrice_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalCashPrice_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalCashPrice_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalCashPrice_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalCashPrice_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalDownPaymentFinance?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalDownPaymentFinance_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalDownPaymentFinance_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalDownPaymentFinance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalDownPaymentFinance_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalDownPaymentFinance_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalDownPaymentFinance_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalDownPaymentFinance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalDownPaymentFinance_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalDownPaymentFinance_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalDuration?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalDuration_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalDuration_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalDuration_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalDuration_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalDuration_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalDuration_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalDuration_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalDuration_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalDuration_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalEffectiveAnnualRate?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalEffectiveAnnualRate_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalEffectiveAnnualRate_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalEffectiveAnnualRate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalEffectiveAnnualRate_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalEffectiveAnnualRate_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalEffectiveAnnualRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalEffectiveAnnualRate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalEffectiveAnnualRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalEffectiveAnnualRate_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalFinalRate?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalFinalRate_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalFinalRate_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalFinalRate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalFinalRate_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalFinalRate_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalFinalRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalFinalRate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalFinalRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalFinalRate_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalFixedDebitRate?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalFixedDebitRate_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalFixedDebitRate_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalFixedDebitRate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalFixedDebitRate_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalFixedDebitRate_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalFixedDebitRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalFixedDebitRate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalFixedDebitRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalFixedDebitRate_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalLeasingRate?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalLeasingRate_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalLeasingRate_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalLeasingRate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalLeasingRate_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalLeasingRate_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalLeasingRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalLeasingRate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalLeasingRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalLeasingRate_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalLeasingSpecialPayment?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalLeasingSpecialPayment_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalLeasingSpecialPayment_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalLeasingSpecialPayment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalLeasingSpecialPayment_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalLeasingSpecialPayment_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalLeasingSpecialPayment_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalLeasingSpecialPayment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalLeasingSpecialPayment_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalLeasingSpecialPayment_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalMonthlyRate?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalMonthlyRate_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalMonthlyRate_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalMonthlyRate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalMonthlyRate_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalMonthlyRate_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalMonthlyRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalMonthlyRate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalMonthlyRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalMonthlyRate_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalNetLoanAmount?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalNetLoanAmount_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalNetLoanAmount_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalNetLoanAmount_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalNetLoanAmount_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalNetLoanAmount_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalNetLoanAmount_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalNetLoanAmount_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalNetLoanAmount_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalNetLoanAmount_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalPriceFootnote?: InputMaybe<FootnoteWhereInput>;
    nationalPriceFootnoteCash?: InputMaybe<FootnoteWhereInput>;
    nationalPriceFootnoteFinance?: InputMaybe<FootnoteWhereInput>;
    nationalPricesDisclaimer?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalPricesDisclaimer_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalPricesDisclaimer_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalPricesDisclaimer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalPricesDisclaimer_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalPricesDisclaimer_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalPricesDisclaimer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalPricesDisclaimer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalPricesDisclaimer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalPricesDisclaimer_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalPricingType?: InputMaybe<CampaignPricingType>;
    /** All values that are contained in given list. */
    nationalPricingType_in?: InputMaybe<Array<InputMaybe<CampaignPricingType>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalPricingType_not?: InputMaybe<CampaignPricingType>;
    /** All values that are not contained in given list. */
    nationalPricingType_not_in?: InputMaybe<Array<InputMaybe<CampaignPricingType>>>;
    nationalTotalAmount?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalTotalAmount_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalTotalAmount_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalTotalAmount_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalTotalAmount_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalTotalAmount_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalTotalAmount_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalTotalAmount_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalTotalAmount_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalTotalAmount_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalTotalMileage?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalTotalMileage_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalTotalMileage_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalTotalMileage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalTotalMileage_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalTotalMileage_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalTotalMileage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalTotalMileage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalTotalMileage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalTotalMileage_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalVehiclePriceFinance?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalVehiclePriceFinance_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalVehiclePriceFinance_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalVehiclePriceFinance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalVehiclePriceFinance_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalVehiclePriceFinance_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalVehiclePriceFinance_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalVehiclePriceFinance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalVehiclePriceFinance_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalVehiclePriceFinance_starts_with?: InputMaybe<Scalars['String']['input']>;
    offerImage?: InputMaybe<AssetWhereInput>;
    offerImageCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    offerImageCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    offerImageCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    offerImageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    offerImageCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    offerImageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    offerImageCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    offerImageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    offerImageCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    offerImageCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum SalesCampaignModelOrderByInput {
    CashPriceCopyAsc = 'cashPriceCopy_ASC',
    CashPriceCopyDesc = 'cashPriceCopy_DESC',
    CashPriceHeadlineAsc = 'cashPriceHeadline_ASC',
    CashPriceHeadlineDesc = 'cashPriceHeadline_DESC',
    CashPriceSubheadlineAsc = 'cashPriceSubheadline_ASC',
    CashPriceSubheadlineDesc = 'cashPriceSubheadline_DESC',
    ContentCopyAsc = 'contentCopy_ASC',
    ContentCopyDesc = 'contentCopy_DESC',
    ContentHeadlineAsc = 'contentHeadline_ASC',
    ContentHeadlineDesc = 'contentHeadline_DESC',
    ContentImageCaptionAsc = 'contentImageCaption_ASC',
    ContentImageCaptionDesc = 'contentImageCaption_DESC',
    DeepLinkUtmCreativeValueAsc = 'deepLinkUtmCreativeValue_ASC',
    DeepLinkUtmCreativeValueDesc = 'deepLinkUtmCreativeValue_DESC',
    DisableEnvkvDataTeaserAsc = 'disableEnvkvDataTeaser_ASC',
    DisableEnvkvDataTeaserDesc = 'disableEnvkvDataTeaser_DESC',
    FinancingHeadlineAsc = 'financingHeadline_ASC',
    FinancingHeadlineDesc = 'financingHeadline_DESC',
    FinancingSubheadlineAsc = 'financingSubheadline_ASC',
    FinancingSubheadlineDesc = 'financingSubheadline_DESC',
    HighlightBadgeKurztextAsc = 'highlightBadgeKurztext_ASC',
    HighlightBadgeKurztextDesc = 'highlightBadgeKurztext_DESC',
    HighlightBadgePrefixDealerAsc = 'highlightBadgePrefixDealer_ASC',
    HighlightBadgePrefixDealerDesc = 'highlightBadgePrefixDealer_DESC',
    HighlightBadgePrefixAsc = 'highlightBadgePrefix_ASC',
    HighlightBadgePrefixDesc = 'highlightBadgePrefix_DESC',
    HighlightBadgeUnitAsc = 'highlightBadgeUnit_ASC',
    HighlightBadgeUnitDesc = 'highlightBadgeUnit_DESC',
    HighlightBadgeValueAsc = 'highlightBadgeValue_ASC',
    HighlightBadgeValueDesc = 'highlightBadgeValue_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    ImageCaptionAsc = 'imageCaption_ASC',
    ImageCaptionDesc = 'imageCaption_DESC',
    LeasingHeadlineAsc = 'leasingHeadline_ASC',
    LeasingHeadlineDesc = 'leasingHeadline_DESC',
    LeasingSubheadlineAsc = 'leasingSubheadline_ASC',
    LeasingSubheadlineDesc = 'leasingSubheadline_DESC',
    MobileIdAsc = 'mobileId_ASC',
    MobileIdDesc = 'mobileId_DESC',
    ModelCodeAsc = 'modelCode_ASC',
    ModelCodeDesc = 'modelCode_DESC',
    NameAsc = 'name_ASC',
    NameDesc = 'name_DESC',
    NationalCashPriceAsc = 'nationalCashPrice_ASC',
    NationalCashPriceDesc = 'nationalCashPrice_DESC',
    NationalDownPaymentFinanceAsc = 'nationalDownPaymentFinance_ASC',
    NationalDownPaymentFinanceDesc = 'nationalDownPaymentFinance_DESC',
    NationalDurationAsc = 'nationalDuration_ASC',
    NationalDurationDesc = 'nationalDuration_DESC',
    NationalEffectiveAnnualRateAsc = 'nationalEffectiveAnnualRate_ASC',
    NationalEffectiveAnnualRateDesc = 'nationalEffectiveAnnualRate_DESC',
    NationalFinalRateAsc = 'nationalFinalRate_ASC',
    NationalFinalRateDesc = 'nationalFinalRate_DESC',
    NationalFixedDebitRateAsc = 'nationalFixedDebitRate_ASC',
    NationalFixedDebitRateDesc = 'nationalFixedDebitRate_DESC',
    NationalLeasingRateAsc = 'nationalLeasingRate_ASC',
    NationalLeasingRateDesc = 'nationalLeasingRate_DESC',
    NationalLeasingSpecialPaymentAsc = 'nationalLeasingSpecialPayment_ASC',
    NationalLeasingSpecialPaymentDesc = 'nationalLeasingSpecialPayment_DESC',
    NationalMonthlyRateAsc = 'nationalMonthlyRate_ASC',
    NationalMonthlyRateDesc = 'nationalMonthlyRate_DESC',
    NationalNetLoanAmountAsc = 'nationalNetLoanAmount_ASC',
    NationalNetLoanAmountDesc = 'nationalNetLoanAmount_DESC',
    NationalPricesDisclaimerAsc = 'nationalPricesDisclaimer_ASC',
    NationalPricesDisclaimerDesc = 'nationalPricesDisclaimer_DESC',
    NationalPricingTypeAsc = 'nationalPricingType_ASC',
    NationalPricingTypeDesc = 'nationalPricingType_DESC',
    NationalTotalAmountAsc = 'nationalTotalAmount_ASC',
    NationalTotalAmountDesc = 'nationalTotalAmount_DESC',
    NationalTotalMileageAsc = 'nationalTotalMileage_ASC',
    NationalTotalMileageDesc = 'nationalTotalMileage_DESC',
    NationalVehiclePriceFinanceAsc = 'nationalVehiclePriceFinance_ASC',
    NationalVehiclePriceFinanceDesc = 'nationalVehiclePriceFinance_DESC',
    OfferImageCaptionAsc = 'offerImageCaption_ASC',
    OfferImageCaptionDesc = 'offerImageCaption_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type SalesCampaignModelParent = SalesCampaignContent;

export type SalesCampaignModelParentConnectInput = {
    SalesCampaignContent?: InputMaybe<SalesCampaignContentConnectInput>;
};

export type SalesCampaignModelParentCreateInput = {
    SalesCampaignContent?: InputMaybe<SalesCampaignContentCreateInput>;
};

export type SalesCampaignModelParentCreateManyInlineInput = {
    /** Create and connect multiple existing SalesCampaignModelParent documents */
    create?: InputMaybe<Array<SalesCampaignModelParentCreateInput>>;
};

export type SalesCampaignModelParentCreateOneInlineInput = {
    /** Create and connect one SalesCampaignModelParent document */
    create?: InputMaybe<SalesCampaignModelParentCreateInput>;
};

export type SalesCampaignModelParentCreateWithPositionInput = {
    SalesCampaignContent?: InputMaybe<SalesCampaignContentCreateWithPositionInput>;
};

export type SalesCampaignModelParentUpdateInput = {
    SalesCampaignContent?: InputMaybe<SalesCampaignContentUpdateInput>;
};

export type SalesCampaignModelParentUpdateManyInlineInput = {
    /** Create and connect multiple SalesCampaignModelParent component instances */
    create?: InputMaybe<Array<SalesCampaignModelParentCreateWithPositionInput>>;
    /** Delete multiple SalesCampaignModelParent documents */
    delete?: InputMaybe<Array<SalesCampaignModelParentWhereUniqueInput>>;
    /** Update multiple SalesCampaignModelParent component instances */
    update?: InputMaybe<Array<SalesCampaignModelParentUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple SalesCampaignModelParent component instances */
    upsert?: InputMaybe<Array<SalesCampaignModelParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SalesCampaignModelParentUpdateManyWithNestedWhereInput = {
    SalesCampaignContent?: InputMaybe<SalesCampaignContentUpdateManyWithNestedWhereInput>;
};

export type SalesCampaignModelParentUpdateOneInlineInput = {
    /** Create and connect one SalesCampaignModelParent document */
    create?: InputMaybe<SalesCampaignModelParentCreateInput>;
    /** Delete currently connected SalesCampaignModelParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single SalesCampaignModelParent document */
    update?: InputMaybe<SalesCampaignModelParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single SalesCampaignModelParent document */
    upsert?: InputMaybe<SalesCampaignModelParentUpsertWithNestedWhereUniqueInput>;
};

export type SalesCampaignModelParentUpdateWithNestedWhereUniqueAndPositionInput = {
    SalesCampaignContent?: InputMaybe<SalesCampaignContentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type SalesCampaignModelParentUpdateWithNestedWhereUniqueInput = {
    SalesCampaignContent?: InputMaybe<SalesCampaignContentUpdateWithNestedWhereUniqueInput>;
};

export type SalesCampaignModelParentUpsertWithNestedWhereUniqueAndPositionInput = {
    SalesCampaignContent?: InputMaybe<SalesCampaignContentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type SalesCampaignModelParentUpsertWithNestedWhereUniqueInput = {
    SalesCampaignContent?: InputMaybe<SalesCampaignContentUpsertWithNestedWhereUniqueInput>;
};

export type SalesCampaignModelParentWhereInput = {
    SalesCampaignContent?: InputMaybe<SalesCampaignContentWhereInput>;
};

export type SalesCampaignModelParentWhereUniqueInput = {
    SalesCampaignContent?: InputMaybe<SalesCampaignContentWhereUniqueInput>;
};

export type SalesCampaignModelUpdateInput = {
    bankCodes?: InputMaybe<BankCodeUpdateManyInlineInput>;
    cashPriceCopy?: InputMaybe<Scalars['String']['input']>;
    cashPriceHeadline?: InputMaybe<Scalars['String']['input']>;
    cashPriceSubheadline?: InputMaybe<Scalars['String']['input']>;
    contentCopy?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    contentImage?: InputMaybe<AssetUpdateOneInlineInput>;
    contentImageCaption?: InputMaybe<Scalars['String']['input']>;
    dealerPriceFootnoteCash?: InputMaybe<FootnoteUpdateOneInlineInput>;
    dealerPriceFootnoteFinance?: InputMaybe<FootnoteUpdateOneInlineInput>;
    dealerPriceFootnoteLeasing?: InputMaybe<FootnoteUpdateOneInlineInput>;
    deepLinkUtmCreativeValue?: InputMaybe<Scalars['String']['input']>;
    disableEnvkvDataTeaser?: InputMaybe<Scalars['Boolean']['input']>;
    envkvDataSource?: InputMaybe<SalesCampaignModelEnvkvDataSourceUpdateOneInlineInput>;
    envkvDataSourceTeaser?: InputMaybe<SalesCampaignModelEnvkvDataSourceTeaserUpdateOneInlineInput>;
    financingHeadline?: InputMaybe<Scalars['String']['input']>;
    financingSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeKurztext?: InputMaybe<Scalars['String']['input']>;
    highlightBadgePrefix?: InputMaybe<Scalars['String']['input']>;
    highlightBadgePrefixDealer?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeUnit?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeUnitDealerFootnote?: InputMaybe<FootnoteUpdateOneInlineInput>;
    highlightBadgeUnitNationalFootnote?: InputMaybe<FootnoteUpdateOneInlineInput>;
    highlightBadgeValue?: InputMaybe<Scalars['String']['input']>;
    image?: InputMaybe<AssetUpdateOneInlineInput>;
    imageCaption?: InputMaybe<Scalars['String']['input']>;
    keyFact1?: InputMaybe<KeyFactUpdateOneInlineInput>;
    keyFact2?: InputMaybe<KeyFactUpdateOneInlineInput>;
    leasingHeadline?: InputMaybe<Scalars['String']['input']>;
    leasingSubheadline?: InputMaybe<Scalars['String']['input']>;
    mobileId?: InputMaybe<Scalars['String']['input']>;
    model?: InputMaybe<ModelUpdateOneInlineInput>;
    modelCode?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    nationalCashPrice?: InputMaybe<Scalars['String']['input']>;
    nationalDownPaymentFinance?: InputMaybe<Scalars['String']['input']>;
    nationalDuration?: InputMaybe<Scalars['String']['input']>;
    nationalEffectiveAnnualRate?: InputMaybe<Scalars['String']['input']>;
    nationalFinalRate?: InputMaybe<Scalars['String']['input']>;
    nationalFixedDebitRate?: InputMaybe<Scalars['String']['input']>;
    nationalLeasingRate?: InputMaybe<Scalars['String']['input']>;
    nationalLeasingSpecialPayment?: InputMaybe<Scalars['String']['input']>;
    nationalMonthlyRate?: InputMaybe<Scalars['String']['input']>;
    nationalNetLoanAmount?: InputMaybe<Scalars['String']['input']>;
    nationalPriceFootnote?: InputMaybe<FootnoteUpdateOneInlineInput>;
    nationalPriceFootnoteCash?: InputMaybe<FootnoteUpdateOneInlineInput>;
    nationalPriceFootnoteFinance?: InputMaybe<FootnoteUpdateOneInlineInput>;
    nationalPricesDisclaimer?: InputMaybe<Scalars['String']['input']>;
    nationalPricingType?: InputMaybe<CampaignPricingType>;
    nationalTotalAmount?: InputMaybe<Scalars['String']['input']>;
    nationalTotalMileage?: InputMaybe<Scalars['String']['input']>;
    nationalVehiclePriceFinance?: InputMaybe<Scalars['String']['input']>;
    offerImage?: InputMaybe<AssetUpdateOneInlineInput>;
    offerImageCaption?: InputMaybe<Scalars['String']['input']>;
};

export type SalesCampaignModelUpdateManyInlineInput = {
    /** Create and connect multiple SalesCampaignModel component instances */
    create?: InputMaybe<Array<SalesCampaignModelCreateWithPositionInput>>;
    /** Delete multiple SalesCampaignModel documents */
    delete?: InputMaybe<Array<SalesCampaignModelWhereUniqueInput>>;
    /** Update multiple SalesCampaignModel component instances */
    update?: InputMaybe<Array<SalesCampaignModelUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple SalesCampaignModel component instances */
    upsert?: InputMaybe<Array<SalesCampaignModelUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SalesCampaignModelUpdateManyInput = {
    cashPriceCopy?: InputMaybe<Scalars['String']['input']>;
    cashPriceHeadline?: InputMaybe<Scalars['String']['input']>;
    cashPriceSubheadline?: InputMaybe<Scalars['String']['input']>;
    contentCopy?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    contentImageCaption?: InputMaybe<Scalars['String']['input']>;
    deepLinkUtmCreativeValue?: InputMaybe<Scalars['String']['input']>;
    disableEnvkvDataTeaser?: InputMaybe<Scalars['Boolean']['input']>;
    financingHeadline?: InputMaybe<Scalars['String']['input']>;
    financingSubheadline?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeKurztext?: InputMaybe<Scalars['String']['input']>;
    highlightBadgePrefix?: InputMaybe<Scalars['String']['input']>;
    highlightBadgePrefixDealer?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeUnit?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeValue?: InputMaybe<Scalars['String']['input']>;
    imageCaption?: InputMaybe<Scalars['String']['input']>;
    leasingHeadline?: InputMaybe<Scalars['String']['input']>;
    leasingSubheadline?: InputMaybe<Scalars['String']['input']>;
    mobileId?: InputMaybe<Scalars['String']['input']>;
    modelCode?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    nationalCashPrice?: InputMaybe<Scalars['String']['input']>;
    nationalDownPaymentFinance?: InputMaybe<Scalars['String']['input']>;
    nationalDuration?: InputMaybe<Scalars['String']['input']>;
    nationalEffectiveAnnualRate?: InputMaybe<Scalars['String']['input']>;
    nationalFinalRate?: InputMaybe<Scalars['String']['input']>;
    nationalFixedDebitRate?: InputMaybe<Scalars['String']['input']>;
    nationalLeasingRate?: InputMaybe<Scalars['String']['input']>;
    nationalLeasingSpecialPayment?: InputMaybe<Scalars['String']['input']>;
    nationalMonthlyRate?: InputMaybe<Scalars['String']['input']>;
    nationalNetLoanAmount?: InputMaybe<Scalars['String']['input']>;
    nationalPricesDisclaimer?: InputMaybe<Scalars['String']['input']>;
    nationalPricingType?: InputMaybe<CampaignPricingType>;
    nationalTotalAmount?: InputMaybe<Scalars['String']['input']>;
    nationalTotalMileage?: InputMaybe<Scalars['String']['input']>;
    nationalVehiclePriceFinance?: InputMaybe<Scalars['String']['input']>;
    offerImageCaption?: InputMaybe<Scalars['String']['input']>;
};

export type SalesCampaignModelUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: SalesCampaignModelUpdateManyInput;
    /** Document search */
    where: SalesCampaignModelWhereInput;
};

export type SalesCampaignModelUpdateOneInlineInput = {
    /** Create and connect one SalesCampaignModel document */
    create?: InputMaybe<SalesCampaignModelCreateInput>;
    /** Delete currently connected SalesCampaignModel document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single SalesCampaignModel document */
    update?: InputMaybe<SalesCampaignModelUpdateWithNestedWhereUniqueInput>;
    /** Upsert single SalesCampaignModel document */
    upsert?: InputMaybe<SalesCampaignModelUpsertWithNestedWhereUniqueInput>;
};

export type SalesCampaignModelUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<SalesCampaignModelUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: SalesCampaignModelWhereUniqueInput;
};

export type SalesCampaignModelUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: SalesCampaignModelUpdateInput;
    /** Unique document search */
    where: SalesCampaignModelWhereUniqueInput;
};

export type SalesCampaignModelUpsertInput = {
    /** Create document if it didn't exist */
    create: SalesCampaignModelCreateInput;
    /** Update document if it exists */
    update: SalesCampaignModelUpdateInput;
};

export type SalesCampaignModelUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<SalesCampaignModelUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: SalesCampaignModelWhereUniqueInput;
};

export type SalesCampaignModelUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: SalesCampaignModelUpsertInput;
    /** Unique document search */
    where: SalesCampaignModelWhereUniqueInput;
};

/** Identifies documents */
export type SalesCampaignModelWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<SalesCampaignModelWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<SalesCampaignModelWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<SalesCampaignModelWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    bankCodes_every?: InputMaybe<BankCodeWhereInput>;
    bankCodes_none?: InputMaybe<BankCodeWhereInput>;
    bankCodes_some?: InputMaybe<BankCodeWhereInput>;
    cashPriceCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    cashPriceCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    cashPriceCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    cashPriceCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    cashPriceCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    cashPriceCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    cashPriceCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    cashPriceCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    cashPriceCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    cashPriceCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    cashPriceHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    cashPriceHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    cashPriceHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    cashPriceHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    cashPriceHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    cashPriceHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    cashPriceHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    cashPriceHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    cashPriceHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    cashPriceHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    cashPriceSubheadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    cashPriceSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    cashPriceSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    cashPriceSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    cashPriceSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    cashPriceSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    cashPriceSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    cashPriceSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    cashPriceSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    cashPriceSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentCopy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentCopy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentCopy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    contentImage?: InputMaybe<AssetWhereInput>;
    contentImageCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    contentImageCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    contentImageCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    contentImageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    contentImageCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    contentImageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    contentImageCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    contentImageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    contentImageCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    contentImageCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    dealerPriceFootnoteCash?: InputMaybe<FootnoteWhereInput>;
    dealerPriceFootnoteFinance?: InputMaybe<FootnoteWhereInput>;
    dealerPriceFootnoteLeasing?: InputMaybe<FootnoteWhereInput>;
    deepLinkUtmCreativeValue?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    deepLinkUtmCreativeValue_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    deepLinkUtmCreativeValue_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    deepLinkUtmCreativeValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    deepLinkUtmCreativeValue_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    deepLinkUtmCreativeValue_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    deepLinkUtmCreativeValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    deepLinkUtmCreativeValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    deepLinkUtmCreativeValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    deepLinkUtmCreativeValue_starts_with?: InputMaybe<Scalars['String']['input']>;
    disableEnvkvDataTeaser?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    disableEnvkvDataTeaser_not?: InputMaybe<Scalars['Boolean']['input']>;
    /** All values in which the union is connected to the given models */
    envkvDataSource?: InputMaybe<SalesCampaignModelEnvkvDataSourceWhereInput>;
    /** All values in which the union is connected to the given models */
    envkvDataSourceTeaser?: InputMaybe<SalesCampaignModelEnvkvDataSourceTeaserWhereInput>;
    /** All values in which the union is empty */
    envkvDataSourceTeaser_empty?: InputMaybe<Scalars['Boolean']['input']>;
    /** All values in which the union is empty */
    envkvDataSource_empty?: InputMaybe<Scalars['Boolean']['input']>;
    financingHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    financingHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    financingHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    financingHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    financingHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    financingHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    financingHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    financingHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    financingHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    financingHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    financingSubheadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    financingSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    financingSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    financingSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    financingSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    financingSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    financingSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    financingSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    financingSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    financingSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeKurztext?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBadgeKurztext_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBadgeKurztext_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBadgeKurztext_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBadgeKurztext_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBadgeKurztext_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBadgeKurztext_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBadgeKurztext_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBadgeKurztext_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBadgeKurztext_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightBadgePrefix?: InputMaybe<Scalars['String']['input']>;
    highlightBadgePrefixDealer?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBadgePrefixDealer_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBadgePrefixDealer_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBadgePrefixDealer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBadgePrefixDealer_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBadgePrefixDealer_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBadgePrefixDealer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBadgePrefixDealer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBadgePrefixDealer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBadgePrefixDealer_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBadgePrefix_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBadgePrefix_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBadgePrefix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBadgePrefix_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBadgePrefix_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBadgePrefix_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBadgePrefix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBadgePrefix_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBadgePrefix_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeUnit?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeUnitDealerFootnote?: InputMaybe<FootnoteWhereInput>;
    highlightBadgeUnitNationalFootnote?: InputMaybe<FootnoteWhereInput>;
    /** All values containing the given string. */
    highlightBadgeUnit_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBadgeUnit_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBadgeUnit_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBadgeUnit_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBadgeUnit_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBadgeUnit_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBadgeUnit_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBadgeUnit_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBadgeUnit_starts_with?: InputMaybe<Scalars['String']['input']>;
    highlightBadgeValue?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    highlightBadgeValue_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    highlightBadgeValue_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    highlightBadgeValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    highlightBadgeValue_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    highlightBadgeValue_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    highlightBadgeValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    highlightBadgeValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    highlightBadgeValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    highlightBadgeValue_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    imageCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    imageCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    imageCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    imageCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    imageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    imageCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    imageCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    imageCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    keyFact1?: InputMaybe<KeyFactWhereInput>;
    keyFact2?: InputMaybe<KeyFactWhereInput>;
    leasingHeadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    leasingHeadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    leasingHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    leasingHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    leasingHeadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    leasingHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    leasingHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    leasingHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    leasingHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    leasingHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    leasingSubheadline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    leasingSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    leasingSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    leasingSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    leasingSubheadline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    leasingSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    leasingSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    leasingSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    leasingSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    leasingSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
    mobileId?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mobileId_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mobileId_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mobileId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mobileId_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mobileId_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mobileId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mobileId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mobileId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mobileId_starts_with?: InputMaybe<Scalars['String']['input']>;
    model?: InputMaybe<ModelWhereInput>;
    modelCode?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    modelCode_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    modelCode_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    modelCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    modelCode_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    modelCode_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    modelCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    modelCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    modelCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    modelCode_starts_with?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalCashPrice?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalCashPrice_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalCashPrice_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalCashPrice_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalCashPrice_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalCashPrice_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalCashPrice_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalCashPrice_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalCashPrice_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalCashPrice_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalDownPaymentFinance?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalDownPaymentFinance_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalDownPaymentFinance_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalDownPaymentFinance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalDownPaymentFinance_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalDownPaymentFinance_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalDownPaymentFinance_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalDownPaymentFinance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalDownPaymentFinance_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalDownPaymentFinance_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalDuration?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalDuration_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalDuration_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalDuration_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalDuration_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalDuration_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalDuration_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalDuration_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalDuration_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalDuration_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalEffectiveAnnualRate?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalEffectiveAnnualRate_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalEffectiveAnnualRate_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalEffectiveAnnualRate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalEffectiveAnnualRate_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalEffectiveAnnualRate_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalEffectiveAnnualRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalEffectiveAnnualRate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalEffectiveAnnualRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalEffectiveAnnualRate_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalFinalRate?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalFinalRate_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalFinalRate_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalFinalRate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalFinalRate_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalFinalRate_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalFinalRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalFinalRate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalFinalRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalFinalRate_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalFixedDebitRate?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalFixedDebitRate_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalFixedDebitRate_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalFixedDebitRate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalFixedDebitRate_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalFixedDebitRate_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalFixedDebitRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalFixedDebitRate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalFixedDebitRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalFixedDebitRate_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalLeasingRate?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalLeasingRate_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalLeasingRate_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalLeasingRate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalLeasingRate_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalLeasingRate_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalLeasingRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalLeasingRate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalLeasingRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalLeasingRate_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalLeasingSpecialPayment?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalLeasingSpecialPayment_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalLeasingSpecialPayment_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalLeasingSpecialPayment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalLeasingSpecialPayment_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalLeasingSpecialPayment_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalLeasingSpecialPayment_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalLeasingSpecialPayment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalLeasingSpecialPayment_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalLeasingSpecialPayment_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalMonthlyRate?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalMonthlyRate_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalMonthlyRate_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalMonthlyRate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalMonthlyRate_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalMonthlyRate_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalMonthlyRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalMonthlyRate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalMonthlyRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalMonthlyRate_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalNetLoanAmount?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalNetLoanAmount_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalNetLoanAmount_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalNetLoanAmount_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalNetLoanAmount_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalNetLoanAmount_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalNetLoanAmount_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalNetLoanAmount_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalNetLoanAmount_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalNetLoanAmount_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalPriceFootnote?: InputMaybe<FootnoteWhereInput>;
    nationalPriceFootnoteCash?: InputMaybe<FootnoteWhereInput>;
    nationalPriceFootnoteFinance?: InputMaybe<FootnoteWhereInput>;
    nationalPricesDisclaimer?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalPricesDisclaimer_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalPricesDisclaimer_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalPricesDisclaimer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalPricesDisclaimer_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalPricesDisclaimer_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalPricesDisclaimer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalPricesDisclaimer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalPricesDisclaimer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalPricesDisclaimer_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalPricingType?: InputMaybe<CampaignPricingType>;
    /** All values that are contained in given list. */
    nationalPricingType_in?: InputMaybe<Array<InputMaybe<CampaignPricingType>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalPricingType_not?: InputMaybe<CampaignPricingType>;
    /** All values that are not contained in given list. */
    nationalPricingType_not_in?: InputMaybe<Array<InputMaybe<CampaignPricingType>>>;
    nationalTotalAmount?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalTotalAmount_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalTotalAmount_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalTotalAmount_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalTotalAmount_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalTotalAmount_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalTotalAmount_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalTotalAmount_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalTotalAmount_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalTotalAmount_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalTotalMileage?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalTotalMileage_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalTotalMileage_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalTotalMileage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalTotalMileage_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalTotalMileage_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalTotalMileage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalTotalMileage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalTotalMileage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalTotalMileage_starts_with?: InputMaybe<Scalars['String']['input']>;
    nationalVehiclePriceFinance?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    nationalVehiclePriceFinance_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    nationalVehiclePriceFinance_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    nationalVehiclePriceFinance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    nationalVehiclePriceFinance_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    nationalVehiclePriceFinance_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    nationalVehiclePriceFinance_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    nationalVehiclePriceFinance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    nationalVehiclePriceFinance_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    nationalVehiclePriceFinance_starts_with?: InputMaybe<Scalars['String']['input']>;
    offerImage?: InputMaybe<AssetWhereInput>;
    offerImageCaption?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    offerImageCaption_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    offerImageCaption_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    offerImageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    offerImageCaption_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    offerImageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    offerImageCaption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    offerImageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    offerImageCaption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    offerImageCaption_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References SalesCampaignModel record uniquely */
export type SalesCampaignModelWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity &
    Node & {
        __typename?: 'ScheduledOperation';
        affectedDocuments: Array<ScheduledOperationAffectedDocument>;
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Operation description */
        description?: Maybe<Scalars['String']['output']>;
        /** Get the document in other stages */
        documentInStages: Array<ScheduledOperation>;
        /** Operation error message */
        errorMessage?: Maybe<Scalars['String']['output']>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        /** Raw operation payload including all details, this field is subject to change */
        rawPayload: Scalars['Json']['output'];
        /** The release this operation is scheduled for */
        release?: Maybe<ScheduledRelease>;
        /** System stage field */
        stage: Stage;
        /** operation Status */
        status: ScheduledOperationStatus;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
};

/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument =
    | Asset
    | Auth0User
    | Campaign
    | CampaignService
    | Dealer
    | Department
    | Footnote
    | GeneralService
    | HomeTeaser
    | Model
    | OverlayBatteryCertificate
    | PageAboutUs
    | PageBusinessCustomer
    | PageHome
    | PageHyundaiPromise
    | PageService
    | PageWarranty
    | Vehicle
    | Warranty;

export type ScheduledOperationConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: ScheduledOperationWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
    __typename?: 'ScheduledOperationConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<ScheduledOperationEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type ScheduledOperationCreateManyInlineInput = {
    /** Connect multiple existing ScheduledOperation documents */
    connect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationCreateOneInlineInput = {
    /** Connect one existing ScheduledOperation document */
    connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
    __typename?: 'ScheduledOperationEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: ScheduledOperation;
};

/** Identifies documents */
export type ScheduledOperationManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    description?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    description_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    description_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    description_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    description_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    description_starts_with?: InputMaybe<Scalars['String']['input']>;
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    errorMessage_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    /** All values containing the given json path. */
    rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
    /**
     * Recursively tries to find the provided JSON scalar value inside the field.
     * It does use an exact match when comparing values.
     * If you pass `null` as value the filter will be ignored.
     * Note: This filter fails if you try to look for a non scalar JSON value!
     */
    rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
    release?: InputMaybe<ScheduledReleaseWhereInput>;
    status?: InputMaybe<ScheduledOperationStatus>;
    /** All values that are contained in given list. */
    status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
    /** Any other value that exists and is not equal to the given value. */
    status_not?: InputMaybe<ScheduledOperationStatus>;
    /** All values that are not contained in given list. */
    status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledOperationOrderByInput {
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    DescriptionAsc = 'description_ASC',
    DescriptionDesc = 'description_DESC',
    ErrorMessageAsc = 'errorMessage_ASC',
    ErrorMessageDesc = 'errorMessage_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    StatusAsc = 'status_ASC',
    StatusDesc = 'status_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
    Canceled = 'CANCELED',
    Completed = 'COMPLETED',
    Failed = 'FAILED',
    InProgress = 'IN_PROGRESS',
    Pending = 'PENDING',
}

export type ScheduledOperationUpdateManyInlineInput = {
    /** Connect multiple existing ScheduledOperation documents */
    connect?: InputMaybe<Array<ScheduledOperationConnectInput>>;
    /** Disconnect multiple ScheduledOperation documents */
    disconnect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing ScheduledOperation documents */
    set?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationUpdateOneInlineInput = {
    /** Connect existing ScheduledOperation document */
    connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
    /** Disconnect currently connected ScheduledOperation document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ScheduledOperationWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    description?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    description_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    description_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    description_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    description_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    description_starts_with?: InputMaybe<Scalars['String']['input']>;
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    errorMessage_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    /** All values containing the given json path. */
    rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
    /**
     * Recursively tries to find the provided JSON scalar value inside the field.
     * It does use an exact match when comparing values.
     * If you pass `null` as value the filter will be ignored.
     * Note: This filter fails if you try to look for a non scalar JSON value!
     */
    rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
    release?: InputMaybe<ScheduledReleaseWhereInput>;
    status?: InputMaybe<ScheduledOperationStatus>;
    /** All values that are contained in given list. */
    status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
    /** Any other value that exists and is not equal to the given value. */
    status_not?: InputMaybe<ScheduledOperationStatus>;
    /** All values that are not contained in given list. */
    status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity &
    Node & {
        __typename?: 'ScheduledRelease';
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Release description */
        description?: Maybe<Scalars['String']['output']>;
        /** Get the document in other stages */
        documentInStages: Array<ScheduledRelease>;
        /** Release error message */
        errorMessage?: Maybe<Scalars['String']['output']>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        /** Whether scheduled release should be run */
        isActive: Scalars['Boolean']['output'];
        /** Whether scheduled release is implicit */
        isImplicit: Scalars['Boolean']['output'];
        /** Operations to run with this release */
        operations: Array<ScheduledOperation>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        /** Release date and time */
        releaseAt?: Maybe<Scalars['DateTime']['output']>;
        /** System stage field */
        stage: Stage;
        /** Release Status */
        status: ScheduledReleaseStatus;
        /** Release Title */
        title?: Maybe<Scalars['String']['output']>;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledReleaseConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: ScheduledReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
    __typename?: 'ScheduledReleaseConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<ScheduledReleaseEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScheduledReleaseCreateManyInlineInput = {
    /** Connect multiple existing ScheduledRelease documents */
    connect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
    /** Create and connect multiple existing ScheduledRelease documents */
    create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
};

export type ScheduledReleaseCreateOneInlineInput = {
    /** Connect one existing ScheduledRelease document */
    connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
    /** Create and connect one ScheduledRelease document */
    create?: InputMaybe<ScheduledReleaseCreateInput>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
    __typename?: 'ScheduledReleaseEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: ScheduledRelease;
};

/** Identifies documents */
export type ScheduledReleaseManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    description?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    description_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    description_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    description_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    description_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    description_starts_with?: InputMaybe<Scalars['String']['input']>;
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    errorMessage_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
    isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
    operations_every?: InputMaybe<ScheduledOperationWhereInput>;
    operations_none?: InputMaybe<ScheduledOperationWhereInput>;
    operations_some?: InputMaybe<ScheduledOperationWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    status?: InputMaybe<ScheduledReleaseStatus>;
    /** All values that are contained in given list. */
    status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
    /** Any other value that exists and is not equal to the given value. */
    status_not?: InputMaybe<ScheduledReleaseStatus>;
    /** All values that are not contained in given list. */
    status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
    title?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    title_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    title_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    title_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    title_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledReleaseOrderByInput {
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    DescriptionAsc = 'description_ASC',
    DescriptionDesc = 'description_DESC',
    ErrorMessageAsc = 'errorMessage_ASC',
    ErrorMessageDesc = 'errorMessage_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    IsActiveAsc = 'isActive_ASC',
    IsActiveDesc = 'isActive_DESC',
    IsImplicitAsc = 'isImplicit_ASC',
    IsImplicitDesc = 'isImplicit_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    ReleaseAtAsc = 'releaseAt_ASC',
    ReleaseAtDesc = 'releaseAt_DESC',
    StatusAsc = 'status_ASC',
    StatusDesc = 'status_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
    Completed = 'COMPLETED',
    Failed = 'FAILED',
    InProgress = 'IN_PROGRESS',
    Pending = 'PENDING',
}

export type ScheduledReleaseUpdateInput = {
    description?: InputMaybe<Scalars['String']['input']>;
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyInlineInput = {
    /** Connect multiple existing ScheduledRelease documents */
    connect?: InputMaybe<Array<ScheduledReleaseConnectInput>>;
    /** Create and connect multiple ScheduledRelease documents */
    create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
    /** Delete multiple ScheduledRelease documents */
    delete?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
    /** Disconnect multiple ScheduledRelease documents */
    disconnect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing ScheduledRelease documents */
    set?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
    /** Update multiple ScheduledRelease documents */
    update?: InputMaybe<Array<ScheduledReleaseUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple ScheduledRelease documents */
    upsert?: InputMaybe<Array<ScheduledReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type ScheduledReleaseUpdateManyInput = {
    description?: InputMaybe<Scalars['String']['input']>;
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: ScheduledReleaseUpdateManyInput;
    /** Document search */
    where: ScheduledReleaseWhereInput;
};

export type ScheduledReleaseUpdateOneInlineInput = {
    /** Connect existing ScheduledRelease document */
    connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
    /** Create and connect one ScheduledRelease document */
    create?: InputMaybe<ScheduledReleaseCreateInput>;
    /** Delete currently connected ScheduledRelease document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected ScheduledRelease document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single ScheduledRelease document */
    update?: InputMaybe<ScheduledReleaseUpdateWithNestedWhereUniqueInput>;
    /** Upsert single ScheduledRelease document */
    upsert?: InputMaybe<ScheduledReleaseUpsertWithNestedWhereUniqueInput>;
};

export type ScheduledReleaseUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: ScheduledReleaseUpdateInput;
    /** Unique document search */
    where: ScheduledReleaseWhereUniqueInput;
};

export type ScheduledReleaseUpsertInput = {
    /** Create document if it didn't exist */
    create: ScheduledReleaseCreateInput;
    /** Update document if it exists */
    update: ScheduledReleaseUpdateInput;
};

export type ScheduledReleaseUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: ScheduledReleaseUpsertInput;
    /** Unique document search */
    where: ScheduledReleaseWhereUniqueInput;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    description?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    description_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    description_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    description_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    description_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    description_starts_with?: InputMaybe<Scalars['String']['input']>;
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    errorMessage_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
    isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
    operations_every?: InputMaybe<ScheduledOperationWhereInput>;
    operations_none?: InputMaybe<ScheduledOperationWhereInput>;
    operations_some?: InputMaybe<ScheduledOperationWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    status?: InputMaybe<ScheduledReleaseStatus>;
    /** All values that are contained in given list. */
    status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
    /** Any other value that exists and is not equal to the given value. */
    status_not?: InputMaybe<ScheduledReleaseStatus>;
    /** All values that are not contained in given list. */
    status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
    title?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    title_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    title_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    title_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    title_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

/** Stage system enumeration */
export enum Stage {
    /** The Draft is the default stage for all your content. */
    Draft = 'DRAFT',
    /** The Published stage is where you can publish your content to. */
    Published = 'PUBLISHED',
}

/** Bundesland */
export enum State {
    Bb = 'BB',
    Be = 'BE',
    Bw = 'BW',
    By = 'BY',
    Hb = 'HB',
    He = 'HE',
    Hh = 'HH',
    Mv = 'MV',
    Ni = 'NI',
    Nw = 'NW',
    Rp = 'RP',
    Sh = 'SH',
    Sl = 'SL',
    Sn = 'SN',
    St = 'ST',
    Th = 'TH',
}

export enum SystemDateTimeFieldVariation {
    Base = 'BASE',
    Combined = 'COMBINED',
    Localization = 'LOCALIZATION',
}

export type TimeRange = Entity & {
    __typename?: 'TimeRange';
    /** Format: 17:30 */
    end: Scalars['String']['output'];
    /** The unique identifier */
    id: Scalars['ID']['output'];
    /** System stage field */
    stage: Stage;
    /** Format: 08:30 */
    start: Scalars['String']['output'];
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TimeRangeConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: TimeRangeWhereUniqueInput;
};

/** A connection to a list of items. */
export type TimeRangeConnection = {
    __typename?: 'TimeRangeConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<TimeRangeEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type TimeRangeCreateInput = {
    end: Scalars['String']['input'];
    start: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimeRangeCreateManyInlineInput = {
    /** Create and connect multiple existing TimeRange documents */
    create?: InputMaybe<Array<TimeRangeCreateInput>>;
};

export type TimeRangeCreateOneInlineInput = {
    /** Create and connect one TimeRange document */
    create?: InputMaybe<TimeRangeCreateInput>;
};

export type TimeRangeCreateWithPositionInput = {
    /** Document to create */
    data: TimeRangeCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type TimeRangeEdge = {
    __typename?: 'TimeRangeEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: TimeRange;
};

/** Identifies documents */
export type TimeRangeManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<TimeRangeWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<TimeRangeWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<TimeRangeWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    end?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    end_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    end_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    end_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    end_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    end_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    end_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    end_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    end_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    end_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    start?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    start_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    start_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    start_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    start_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    start_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    start_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    start_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    start_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    start_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum TimeRangeOrderByInput {
    EndAsc = 'end_ASC',
    EndDesc = 'end_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    StartAsc = 'start_ASC',
    StartDesc = 'start_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type TimeRangeParent = Opening;

export type TimeRangeParentConnectInput = {
    Opening?: InputMaybe<OpeningConnectInput>;
};

export type TimeRangeParentCreateInput = {
    Opening?: InputMaybe<OpeningCreateInput>;
};

export type TimeRangeParentCreateManyInlineInput = {
    /** Create and connect multiple existing TimeRangeParent documents */
    create?: InputMaybe<Array<TimeRangeParentCreateInput>>;
};

export type TimeRangeParentCreateOneInlineInput = {
    /** Create and connect one TimeRangeParent document */
    create?: InputMaybe<TimeRangeParentCreateInput>;
};

export type TimeRangeParentCreateWithPositionInput = {
    Opening?: InputMaybe<OpeningCreateWithPositionInput>;
};

export type TimeRangeParentUpdateInput = {
    Opening?: InputMaybe<OpeningUpdateInput>;
};

export type TimeRangeParentUpdateManyInlineInput = {
    /** Create and connect multiple TimeRangeParent component instances */
    create?: InputMaybe<Array<TimeRangeParentCreateWithPositionInput>>;
    /** Delete multiple TimeRangeParent documents */
    delete?: InputMaybe<Array<TimeRangeParentWhereUniqueInput>>;
    /** Update multiple TimeRangeParent component instances */
    update?: InputMaybe<Array<TimeRangeParentUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple TimeRangeParent component instances */
    upsert?: InputMaybe<Array<TimeRangeParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type TimeRangeParentUpdateManyWithNestedWhereInput = {
    Opening?: InputMaybe<OpeningUpdateManyWithNestedWhereInput>;
};

export type TimeRangeParentUpdateOneInlineInput = {
    /** Create and connect one TimeRangeParent document */
    create?: InputMaybe<TimeRangeParentCreateInput>;
    /** Delete currently connected TimeRangeParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single TimeRangeParent document */
    update?: InputMaybe<TimeRangeParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single TimeRangeParent document */
    upsert?: InputMaybe<TimeRangeParentUpsertWithNestedWhereUniqueInput>;
};

export type TimeRangeParentUpdateWithNestedWhereUniqueAndPositionInput = {
    Opening?: InputMaybe<OpeningUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type TimeRangeParentUpdateWithNestedWhereUniqueInput = {
    Opening?: InputMaybe<OpeningUpdateWithNestedWhereUniqueInput>;
};

export type TimeRangeParentUpsertWithNestedWhereUniqueAndPositionInput = {
    Opening?: InputMaybe<OpeningUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type TimeRangeParentUpsertWithNestedWhereUniqueInput = {
    Opening?: InputMaybe<OpeningUpsertWithNestedWhereUniqueInput>;
};

export type TimeRangeParentWhereInput = {
    Opening?: InputMaybe<OpeningWhereInput>;
};

export type TimeRangeParentWhereUniqueInput = {
    Opening?: InputMaybe<OpeningWhereUniqueInput>;
};

export type TimeRangeUpdateInput = {
    end?: InputMaybe<Scalars['String']['input']>;
    start?: InputMaybe<Scalars['String']['input']>;
};

export type TimeRangeUpdateManyInlineInput = {
    /** Create and connect multiple TimeRange component instances */
    create?: InputMaybe<Array<TimeRangeCreateWithPositionInput>>;
    /** Delete multiple TimeRange documents */
    delete?: InputMaybe<Array<TimeRangeWhereUniqueInput>>;
    /** Update multiple TimeRange component instances */
    update?: InputMaybe<Array<TimeRangeUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple TimeRange component instances */
    upsert?: InputMaybe<Array<TimeRangeUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type TimeRangeUpdateManyInput = {
    end?: InputMaybe<Scalars['String']['input']>;
    start?: InputMaybe<Scalars['String']['input']>;
};

export type TimeRangeUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: TimeRangeUpdateManyInput;
    /** Document search */
    where: TimeRangeWhereInput;
};

export type TimeRangeUpdateOneInlineInput = {
    /** Create and connect one TimeRange document */
    create?: InputMaybe<TimeRangeCreateInput>;
    /** Delete currently connected TimeRange document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single TimeRange document */
    update?: InputMaybe<TimeRangeUpdateWithNestedWhereUniqueInput>;
    /** Upsert single TimeRange document */
    upsert?: InputMaybe<TimeRangeUpsertWithNestedWhereUniqueInput>;
};

export type TimeRangeUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<TimeRangeUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: TimeRangeWhereUniqueInput;
};

export type TimeRangeUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: TimeRangeUpdateInput;
    /** Unique document search */
    where: TimeRangeWhereUniqueInput;
};

export type TimeRangeUpsertInput = {
    /** Create document if it didn't exist */
    create: TimeRangeCreateInput;
    /** Update document if it exists */
    update: TimeRangeUpdateInput;
};

export type TimeRangeUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<TimeRangeUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: TimeRangeWhereUniqueInput;
};

export type TimeRangeUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: TimeRangeUpsertInput;
    /** Unique document search */
    where: TimeRangeWhereUniqueInput;
};

/** Identifies documents */
export type TimeRangeWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<TimeRangeWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<TimeRangeWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<TimeRangeWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    end?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    end_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    end_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    end_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    end_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    end_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    end_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    end_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    end_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    end_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    start?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    start_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    start_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    start_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    start_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    start_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    start_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    start_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    start_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    start_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References TimeRange record uniquely */
export type TimeRangeWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type UnpublishLocaleInput = {
    /** Locales to unpublish */
    locale: Locale;
    /** Stages to unpublish selected locales from */
    stages: Array<Stage>;
};

/** User system model */
export type User = Entity &
    Node & {
        __typename?: 'User';
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** Get the document in other stages */
        documentInStages: Array<User>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        /** Flag to determine if user is active or not */
        isActive: Scalars['Boolean']['output'];
        /** User Kind. Can be either MEMBER, PAT or PUBLIC */
        kind: UserKind;
        /** The username */
        name: Scalars['String']['output'];
        /** Profile Picture url */
        picture?: Maybe<Scalars['String']['output']>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** System stage field */
        stage: Stage;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
    };

/** User system model */
export type UserDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type UserConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: UserWhereUniqueInput;
};

/** A connection to a list of items. */
export type UserConnection = {
    __typename?: 'UserConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<UserEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type UserCreateManyInlineInput = {
    /** Connect multiple existing User documents */
    connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateOneInlineInput = {
    /** Connect one existing User document */
    connect?: InputMaybe<UserWhereUniqueInput>;
};

/** An edge in a connection. */
export type UserEdge = {
    __typename?: 'UserEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: User;
};

/** System User Kind */
export enum UserKind {
    AppToken = 'APP_TOKEN',
    Member = 'MEMBER',
    Pat = 'PAT',
    Public = 'PUBLIC',
    Webhook = 'WEBHOOK',
}

/** Identifies documents */
export type UserManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<UserWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<UserWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<UserWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    documentInStages_every?: InputMaybe<UserWhereStageInput>;
    documentInStages_none?: InputMaybe<UserWhereStageInput>;
    documentInStages_some?: InputMaybe<UserWhereStageInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
    kind?: InputMaybe<UserKind>;
    /** All values that are contained in given list. */
    kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
    /** Any other value that exists and is not equal to the given value. */
    kind_not?: InputMaybe<UserKind>;
    /** All values that are not contained in given list. */
    kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
    name?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name_starts_with?: InputMaybe<Scalars['String']['input']>;
    picture?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    picture_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    picture_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    picture_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    picture_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    picture_starts_with?: InputMaybe<Scalars['String']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum UserOrderByInput {
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    IsActiveAsc = 'isActive_ASC',
    IsActiveDesc = 'isActive_DESC',
    KindAsc = 'kind_ASC',
    KindDesc = 'kind_DESC',
    NameAsc = 'name_ASC',
    NameDesc = 'name_DESC',
    PictureAsc = 'picture_ASC',
    PictureDesc = 'picture_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type UserUpdateManyInlineInput = {
    /** Connect multiple existing User documents */
    connect?: InputMaybe<Array<UserConnectInput>>;
    /** Disconnect multiple User documents */
    disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing User documents */
    set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateOneInlineInput = {
    /** Connect existing User document */
    connect?: InputMaybe<UserWhereUniqueInput>;
    /** Disconnect currently connected User document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type UserWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<UserWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<UserWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<UserWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    documentInStages_every?: InputMaybe<UserWhereStageInput>;
    documentInStages_none?: InputMaybe<UserWhereStageInput>;
    documentInStages_some?: InputMaybe<UserWhereStageInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
    kind?: InputMaybe<UserKind>;
    /** All values that are contained in given list. */
    kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
    /** Any other value that exists and is not equal to the given value. */
    kind_not?: InputMaybe<UserKind>;
    /** All values that are not contained in given list. */
    kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
    name?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    name_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    name_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    name_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    name_starts_with?: InputMaybe<Scalars['String']['input']>;
    picture?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    picture_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    picture_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    picture_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    picture_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    picture_starts_with?: InputMaybe<Scalars['String']['input']>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<UserWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<UserWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<UserWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<UserWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type UtmMapping = Entity & {
    __typename?: 'UtmMapping';
    /** The unique identifier */
    id: Scalars['ID']['output'];
    mappingValue?: Maybe<Scalars['String']['output']>;
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
    utmTerm?: Maybe<Scalars['String']['output']>;
};

export type UtmMappingConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: UtmMappingWhereUniqueInput;
};

/** A connection to a list of items. */
export type UtmMappingConnection = {
    __typename?: 'UtmMappingConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<UtmMappingEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type UtmMappingCreateInput = {
    mappingValue?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type UtmMappingCreateManyInlineInput = {
    /** Create and connect multiple existing UtmMapping documents */
    create?: InputMaybe<Array<UtmMappingCreateInput>>;
};

export type UtmMappingCreateOneInlineInput = {
    /** Create and connect one UtmMapping document */
    create?: InputMaybe<UtmMappingCreateInput>;
};

export type UtmMappingCreateWithPositionInput = {
    /** Document to create */
    data: UtmMappingCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type UtmMappingEdge = {
    __typename?: 'UtmMappingEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: UtmMapping;
};

/** Identifies documents */
export type UtmMappingManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<UtmMappingWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<UtmMappingWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<UtmMappingWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    mappingValue?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mappingValue_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mappingValue_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mappingValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mappingValue_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mappingValue_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mappingValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mappingValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mappingValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mappingValue_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    utmTerm?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    utmTerm_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    utmTerm_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    utmTerm_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    utmTerm_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    utmTerm_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    utmTerm_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    utmTerm_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    utmTerm_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    utmTerm_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum UtmMappingOrderByInput {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    MappingValueAsc = 'mappingValue_ASC',
    MappingValueDesc = 'mappingValue_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
    UtmTermAsc = 'utmTerm_ASC',
    UtmTermDesc = 'utmTerm_DESC',
}

export type UtmMappingParent = Campaign;

export type UtmMappingParentConnectInput = {
    Campaign?: InputMaybe<CampaignConnectInput>;
};

export type UtmMappingParentCreateInput = {
    Campaign?: InputMaybe<CampaignCreateInput>;
};

export type UtmMappingParentCreateManyInlineInput = {
    /** Connect multiple existing UtmMappingParent documents */
    connect?: InputMaybe<Array<UtmMappingParentWhereUniqueInput>>;
    /** Create and connect multiple existing UtmMappingParent documents */
    create?: InputMaybe<Array<UtmMappingParentCreateInput>>;
};

export type UtmMappingParentCreateOneInlineInput = {
    /** Connect one existing UtmMappingParent document */
    connect?: InputMaybe<UtmMappingParentWhereUniqueInput>;
    /** Create and connect one UtmMappingParent document */
    create?: InputMaybe<UtmMappingParentCreateInput>;
};

export type UtmMappingParentUpdateInput = {
    Campaign?: InputMaybe<CampaignUpdateInput>;
};

export type UtmMappingParentUpdateManyInlineInput = {
    /** Connect multiple existing UtmMappingParent documents */
    connect?: InputMaybe<Array<UtmMappingParentConnectInput>>;
    /** Create and connect multiple UtmMappingParent documents */
    create?: InputMaybe<Array<UtmMappingParentCreateInput>>;
    /** Delete multiple UtmMappingParent documents */
    delete?: InputMaybe<Array<UtmMappingParentWhereUniqueInput>>;
    /** Disconnect multiple UtmMappingParent documents */
    disconnect?: InputMaybe<Array<UtmMappingParentWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing UtmMappingParent documents */
    set?: InputMaybe<Array<UtmMappingParentWhereUniqueInput>>;
    /** Update multiple UtmMappingParent documents */
    update?: InputMaybe<Array<UtmMappingParentUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple UtmMappingParent documents */
    upsert?: InputMaybe<Array<UtmMappingParentUpsertWithNestedWhereUniqueInput>>;
};

export type UtmMappingParentUpdateManyWithNestedWhereInput = {
    Campaign?: InputMaybe<CampaignUpdateManyWithNestedWhereInput>;
};

export type UtmMappingParentUpdateOneInlineInput = {
    /** Connect existing UtmMappingParent document */
    connect?: InputMaybe<UtmMappingParentWhereUniqueInput>;
    /** Create and connect one UtmMappingParent document */
    create?: InputMaybe<UtmMappingParentCreateInput>;
    /** Delete currently connected UtmMappingParent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected UtmMappingParent document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single UtmMappingParent document */
    update?: InputMaybe<UtmMappingParentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single UtmMappingParent document */
    upsert?: InputMaybe<UtmMappingParentUpsertWithNestedWhereUniqueInput>;
};

export type UtmMappingParentUpdateWithNestedWhereUniqueInput = {
    Campaign?: InputMaybe<CampaignUpdateWithNestedWhereUniqueInput>;
};

export type UtmMappingParentUpsertWithNestedWhereUniqueInput = {
    Campaign?: InputMaybe<CampaignUpsertWithNestedWhereUniqueInput>;
};

export type UtmMappingParentWhereInput = {
    Campaign?: InputMaybe<CampaignWhereInput>;
};

export type UtmMappingParentWhereUniqueInput = {
    Campaign?: InputMaybe<CampaignWhereUniqueInput>;
};

export type UtmMappingUpdateInput = {
    mappingValue?: InputMaybe<Scalars['String']['input']>;
    utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type UtmMappingUpdateManyInlineInput = {
    /** Create and connect multiple UtmMapping component instances */
    create?: InputMaybe<Array<UtmMappingCreateWithPositionInput>>;
    /** Delete multiple UtmMapping documents */
    delete?: InputMaybe<Array<UtmMappingWhereUniqueInput>>;
    /** Update multiple UtmMapping component instances */
    update?: InputMaybe<Array<UtmMappingUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple UtmMapping component instances */
    upsert?: InputMaybe<Array<UtmMappingUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type UtmMappingUpdateManyInput = {
    mappingValue?: InputMaybe<Scalars['String']['input']>;
    utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type UtmMappingUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: UtmMappingUpdateManyInput;
    /** Document search */
    where: UtmMappingWhereInput;
};

export type UtmMappingUpdateOneInlineInput = {
    /** Create and connect one UtmMapping document */
    create?: InputMaybe<UtmMappingCreateInput>;
    /** Delete currently connected UtmMapping document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single UtmMapping document */
    update?: InputMaybe<UtmMappingUpdateWithNestedWhereUniqueInput>;
    /** Upsert single UtmMapping document */
    upsert?: InputMaybe<UtmMappingUpsertWithNestedWhereUniqueInput>;
};

export type UtmMappingUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<UtmMappingUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: UtmMappingWhereUniqueInput;
};

export type UtmMappingUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: UtmMappingUpdateInput;
    /** Unique document search */
    where: UtmMappingWhereUniqueInput;
};

export type UtmMappingUpsertInput = {
    /** Create document if it didn't exist */
    create: UtmMappingCreateInput;
    /** Update document if it exists */
    update: UtmMappingUpdateInput;
};

export type UtmMappingUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<UtmMappingUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: UtmMappingWhereUniqueInput;
};

export type UtmMappingUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: UtmMappingUpsertInput;
    /** Unique document search */
    where: UtmMappingWhereUniqueInput;
};

/** Identifies documents */
export type UtmMappingWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<UtmMappingWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<UtmMappingWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<UtmMappingWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    mappingValue?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    mappingValue_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    mappingValue_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    mappingValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    mappingValue_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    mappingValue_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    mappingValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    mappingValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    mappingValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    mappingValue_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    utmTerm?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    utmTerm_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    utmTerm_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    utmTerm_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    utmTerm_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    utmTerm_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    utmTerm_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    utmTerm_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    utmTerm_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    utmTerm_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References UtmMapping record uniquely */
export type UtmMappingWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type Vehicle = Entity &
    Node & {
        __typename?: 'Vehicle';
        co2Class: Co2Class;
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Optional */
        displacement?: Maybe<Scalars['Int']['output']>;
        /** Get the document in other stages */
        documentInStages: Array<Vehicle>;
        envkv?: Maybe<VehicleenvkvUnion>;
        /** Optional */
        fuel?: Maybe<Scalars['String']['output']>;
        /** Kraftstoffart zur Steuerung von kraftstoffspezifischen Fussnoten */
        fuelType?: Maybe<FuelType>;
        /** Optional */
        generation?: Maybe<Scalars['String']['output']>;
        /** List of Vehicle versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        /** WICHTIG: Matcht das Trim mit dem Modell */
        model?: Maybe<Model>;
        /** Nur zum Suchen und Filtern. KEINE Funktionalität !!! */
        modelFromImportExcel?: Maybe<Scalars['String']['output']>;
        /** 4-stellige UID - Eig. "Trimcode" */
        modelcode?: Maybe<Scalars['String']['output']>;
        /** Optional */
        powerKw?: Maybe<Scalars['Int']['output']>;
        /** Optional */
        powerPs?: Maybe<Scalars['Int']['output']>;
        /** Optional */
        price?: Maybe<Scalars['Int']['output']>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        /** Komplette Trim-Bezeichnung. Nur für interne Zwecke! */
        trim: Scalars['String']['output'];
        /** Gesamtangabe des Trim-Namen + PKWEnVKV-Angaben */
        trimAndEnvkvString?: Maybe<Scalars['String']['output']>;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
        /** Optional */
        version?: Maybe<Scalars['String']['output']>;
    };

export type VehicleCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type VehicleDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type VehicleEnvkvArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type VehicleHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type VehicleModelArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type VehiclePublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type VehicleScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type VehicleUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type VehicleConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: VehicleWhereUniqueInput;
};

/** A connection to a list of items. */
export type VehicleConnection = {
    __typename?: 'VehicleConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<VehicleEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type VehicleCreateInput = {
    cmlv2otpj095n07usgs3n3f13?: InputMaybe<ModelCreateManyInlineInput>;
    co2Class: Co2Class;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    displacement?: InputMaybe<Scalars['Int']['input']>;
    envkv?: InputMaybe<VehicleenvkvUnionCreateOneInlineInput>;
    fuel?: InputMaybe<Scalars['String']['input']>;
    fuelType?: InputMaybe<FuelType>;
    generation?: InputMaybe<Scalars['String']['input']>;
    model?: InputMaybe<ModelCreateOneInlineInput>;
    modelFromImportExcel?: InputMaybe<Scalars['String']['input']>;
    modelcode?: InputMaybe<Scalars['String']['input']>;
    powerKw?: InputMaybe<Scalars['Int']['input']>;
    powerPs?: InputMaybe<Scalars['Int']['input']>;
    price?: InputMaybe<Scalars['Int']['input']>;
    trim: Scalars['String']['input'];
    trimAndEnvkvString?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    version?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleCreateManyInlineInput = {
    /** Connect multiple existing Vehicle documents */
    connect?: InputMaybe<Array<VehicleWhereUniqueInput>>;
    /** Create and connect multiple existing Vehicle documents */
    create?: InputMaybe<Array<VehicleCreateInput>>;
};

export type VehicleCreateOneInlineInput = {
    /** Connect one existing Vehicle document */
    connect?: InputMaybe<VehicleWhereUniqueInput>;
    /** Create and connect one Vehicle document */
    create?: InputMaybe<VehicleCreateInput>;
};

/** An edge in a connection. */
export type VehicleEdge = {
    __typename?: 'VehicleEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Vehicle;
};

/** Identifies documents */
export type VehicleManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<VehicleWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<VehicleWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<VehicleWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    co2Class?: InputMaybe<Co2Class>;
    /** All values that are contained in given list. */
    co2Class_in?: InputMaybe<Array<InputMaybe<Co2Class>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2Class_not?: InputMaybe<Co2Class>;
    /** All values that are not contained in given list. */
    co2Class_not_in?: InputMaybe<Array<InputMaybe<Co2Class>>>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    displacement?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than the given value. */
    displacement_gt?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than or equal the given value. */
    displacement_gte?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are contained in given list. */
    displacement_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    /** All values less than the given value. */
    displacement_lt?: InputMaybe<Scalars['Int']['input']>;
    /** All values less than or equal the given value. */
    displacement_lte?: InputMaybe<Scalars['Int']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    displacement_not?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are not contained in given list. */
    displacement_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    documentInStages_every?: InputMaybe<VehicleWhereStageInput>;
    documentInStages_none?: InputMaybe<VehicleWhereStageInput>;
    documentInStages_some?: InputMaybe<VehicleWhereStageInput>;
    /** All values in which the modular component is connected to the given models */
    envkv?: InputMaybe<VehicleenvkvUnionWhereInput>;
    /** All values in which the union is empty. */
    envkv_empty?: InputMaybe<Scalars['Boolean']['input']>;
    fuel?: InputMaybe<Scalars['String']['input']>;
    fuelType?: InputMaybe<FuelType>;
    /** All values that are contained in given list. */
    fuelType_in?: InputMaybe<Array<InputMaybe<FuelType>>>;
    /** Any other value that exists and is not equal to the given value. */
    fuelType_not?: InputMaybe<FuelType>;
    /** All values that are not contained in given list. */
    fuelType_not_in?: InputMaybe<Array<InputMaybe<FuelType>>>;
    /** All values containing the given string. */
    fuel_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    fuel_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    fuel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    fuel_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    fuel_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    fuel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    fuel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    fuel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    fuel_starts_with?: InputMaybe<Scalars['String']['input']>;
    generation?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    generation_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    generation_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    generation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    generation_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    generation_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    generation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    generation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    generation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    generation_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    model?: InputMaybe<ModelWhereInput>;
    modelFromImportExcel?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    modelFromImportExcel_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    modelFromImportExcel_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    modelFromImportExcel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    modelFromImportExcel_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    modelFromImportExcel_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    modelFromImportExcel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    modelFromImportExcel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    modelFromImportExcel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    modelFromImportExcel_starts_with?: InputMaybe<Scalars['String']['input']>;
    modelcode?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    modelcode_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    modelcode_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    modelcode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    modelcode_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    modelcode_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    modelcode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    modelcode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    modelcode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    modelcode_starts_with?: InputMaybe<Scalars['String']['input']>;
    powerKw?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than the given value. */
    powerKw_gt?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than or equal the given value. */
    powerKw_gte?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are contained in given list. */
    powerKw_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    /** All values less than the given value. */
    powerKw_lt?: InputMaybe<Scalars['Int']['input']>;
    /** All values less than or equal the given value. */
    powerKw_lte?: InputMaybe<Scalars['Int']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    powerKw_not?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are not contained in given list. */
    powerKw_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    powerPs?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than the given value. */
    powerPs_gt?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than or equal the given value. */
    powerPs_gte?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are contained in given list. */
    powerPs_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    /** All values less than the given value. */
    powerPs_lt?: InputMaybe<Scalars['Int']['input']>;
    /** All values less than or equal the given value. */
    powerPs_lte?: InputMaybe<Scalars['Int']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    powerPs_not?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are not contained in given list. */
    powerPs_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    price?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than the given value. */
    price_gt?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than or equal the given value. */
    price_gte?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are contained in given list. */
    price_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    /** All values less than the given value. */
    price_lt?: InputMaybe<Scalars['Int']['input']>;
    /** All values less than or equal the given value. */
    price_lte?: InputMaybe<Scalars['Int']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    price_not?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are not contained in given list. */
    price_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    trim?: InputMaybe<Scalars['String']['input']>;
    trimAndEnvkvString?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    trimAndEnvkvString_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    trimAndEnvkvString_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    trimAndEnvkvString_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    trimAndEnvkvString_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    trimAndEnvkvString_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    trimAndEnvkvString_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    trimAndEnvkvString_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    trimAndEnvkvString_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    trimAndEnvkvString_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    trim_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    trim_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    trim_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    trim_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    trim_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    trim_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    trim_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    trim_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    trim_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    version?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    version_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    version_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    version_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    version_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    version_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    version_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    version_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    version_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    version_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum VehicleOrderByInput {
    Co2ClassAsc = 'co2Class_ASC',
    Co2ClassDesc = 'co2Class_DESC',
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    DisplacementAsc = 'displacement_ASC',
    DisplacementDesc = 'displacement_DESC',
    FuelTypeAsc = 'fuelType_ASC',
    FuelTypeDesc = 'fuelType_DESC',
    FuelAsc = 'fuel_ASC',
    FuelDesc = 'fuel_DESC',
    GenerationAsc = 'generation_ASC',
    GenerationDesc = 'generation_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    ModelFromImportExcelAsc = 'modelFromImportExcel_ASC',
    ModelFromImportExcelDesc = 'modelFromImportExcel_DESC',
    ModelcodeAsc = 'modelcode_ASC',
    ModelcodeDesc = 'modelcode_DESC',
    PowerKwAsc = 'powerKw_ASC',
    PowerKwDesc = 'powerKw_DESC',
    PowerPsAsc = 'powerPs_ASC',
    PowerPsDesc = 'powerPs_DESC',
    PriceAsc = 'price_ASC',
    PriceDesc = 'price_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    TrimAndEnvkvStringAsc = 'trimAndEnvkvString_ASC',
    TrimAndEnvkvStringDesc = 'trimAndEnvkvString_DESC',
    TrimAsc = 'trim_ASC',
    TrimDesc = 'trim_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
    VersionAsc = 'version_ASC',
    VersionDesc = 'version_DESC',
}

export type VehicleUpdateInput = {
    cmlv2otpj095n07usgs3n3f13?: InputMaybe<ModelUpdateManyInlineInput>;
    co2Class?: InputMaybe<Co2Class>;
    displacement?: InputMaybe<Scalars['Int']['input']>;
    envkv?: InputMaybe<VehicleenvkvUnionUpdateOneInlineInput>;
    fuel?: InputMaybe<Scalars['String']['input']>;
    fuelType?: InputMaybe<FuelType>;
    generation?: InputMaybe<Scalars['String']['input']>;
    model?: InputMaybe<ModelUpdateOneInlineInput>;
    modelFromImportExcel?: InputMaybe<Scalars['String']['input']>;
    modelcode?: InputMaybe<Scalars['String']['input']>;
    powerKw?: InputMaybe<Scalars['Int']['input']>;
    powerPs?: InputMaybe<Scalars['Int']['input']>;
    price?: InputMaybe<Scalars['Int']['input']>;
    trim?: InputMaybe<Scalars['String']['input']>;
    trimAndEnvkvString?: InputMaybe<Scalars['String']['input']>;
    version?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleUpdateManyInlineInput = {
    /** Connect multiple existing Vehicle documents */
    connect?: InputMaybe<Array<VehicleConnectInput>>;
    /** Create and connect multiple Vehicle documents */
    create?: InputMaybe<Array<VehicleCreateInput>>;
    /** Delete multiple Vehicle documents */
    delete?: InputMaybe<Array<VehicleWhereUniqueInput>>;
    /** Disconnect multiple Vehicle documents */
    disconnect?: InputMaybe<Array<VehicleWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing Vehicle documents */
    set?: InputMaybe<Array<VehicleWhereUniqueInput>>;
    /** Update multiple Vehicle documents */
    update?: InputMaybe<Array<VehicleUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple Vehicle documents */
    upsert?: InputMaybe<Array<VehicleUpsertWithNestedWhereUniqueInput>>;
};

export type VehicleUpdateManyInput = {
    co2Class?: InputMaybe<Co2Class>;
    displacement?: InputMaybe<Scalars['Int']['input']>;
    fuel?: InputMaybe<Scalars['String']['input']>;
    fuelType?: InputMaybe<FuelType>;
    generation?: InputMaybe<Scalars['String']['input']>;
    modelFromImportExcel?: InputMaybe<Scalars['String']['input']>;
    powerKw?: InputMaybe<Scalars['Int']['input']>;
    powerPs?: InputMaybe<Scalars['Int']['input']>;
    price?: InputMaybe<Scalars['Int']['input']>;
    trim?: InputMaybe<Scalars['String']['input']>;
    trimAndEnvkvString?: InputMaybe<Scalars['String']['input']>;
    version?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: VehicleUpdateManyInput;
    /** Document search */
    where: VehicleWhereInput;
};

export type VehicleUpdateOneInlineInput = {
    /** Connect existing Vehicle document */
    connect?: InputMaybe<VehicleWhereUniqueInput>;
    /** Create and connect one Vehicle document */
    create?: InputMaybe<VehicleCreateInput>;
    /** Delete currently connected Vehicle document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected Vehicle document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Vehicle document */
    update?: InputMaybe<VehicleUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Vehicle document */
    upsert?: InputMaybe<VehicleUpsertWithNestedWhereUniqueInput>;
};

export type VehicleUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: VehicleUpdateInput;
    /** Unique document search */
    where: VehicleWhereUniqueInput;
};

export type VehicleUpsertInput = {
    /** Create document if it didn't exist */
    create: VehicleCreateInput;
    /** Update document if it exists */
    update: VehicleUpdateInput;
};

export type VehicleUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: VehicleUpsertInput;
    /** Unique document search */
    where: VehicleWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type VehicleWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type VehicleWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<VehicleWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<VehicleWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<VehicleWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    co2Class?: InputMaybe<Co2Class>;
    /** All values that are contained in given list. */
    co2Class_in?: InputMaybe<Array<InputMaybe<Co2Class>>>;
    /** Any other value that exists and is not equal to the given value. */
    co2Class_not?: InputMaybe<Co2Class>;
    /** All values that are not contained in given list. */
    co2Class_not_in?: InputMaybe<Array<InputMaybe<Co2Class>>>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    displacement?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than the given value. */
    displacement_gt?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than or equal the given value. */
    displacement_gte?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are contained in given list. */
    displacement_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    /** All values less than the given value. */
    displacement_lt?: InputMaybe<Scalars['Int']['input']>;
    /** All values less than or equal the given value. */
    displacement_lte?: InputMaybe<Scalars['Int']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    displacement_not?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are not contained in given list. */
    displacement_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    documentInStages_every?: InputMaybe<VehicleWhereStageInput>;
    documentInStages_none?: InputMaybe<VehicleWhereStageInput>;
    documentInStages_some?: InputMaybe<VehicleWhereStageInput>;
    /** All values in which the modular component is connected to the given models */
    envkv?: InputMaybe<VehicleenvkvUnionWhereInput>;
    /** All values in which the union is empty. */
    envkv_empty?: InputMaybe<Scalars['Boolean']['input']>;
    fuel?: InputMaybe<Scalars['String']['input']>;
    fuelType?: InputMaybe<FuelType>;
    /** All values that are contained in given list. */
    fuelType_in?: InputMaybe<Array<InputMaybe<FuelType>>>;
    /** Any other value that exists and is not equal to the given value. */
    fuelType_not?: InputMaybe<FuelType>;
    /** All values that are not contained in given list. */
    fuelType_not_in?: InputMaybe<Array<InputMaybe<FuelType>>>;
    /** All values containing the given string. */
    fuel_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    fuel_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    fuel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    fuel_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    fuel_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    fuel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    fuel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    fuel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    fuel_starts_with?: InputMaybe<Scalars['String']['input']>;
    generation?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    generation_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    generation_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    generation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    generation_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    generation_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    generation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    generation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    generation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    generation_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    model?: InputMaybe<ModelWhereInput>;
    modelFromImportExcel?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    modelFromImportExcel_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    modelFromImportExcel_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    modelFromImportExcel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    modelFromImportExcel_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    modelFromImportExcel_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    modelFromImportExcel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    modelFromImportExcel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    modelFromImportExcel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    modelFromImportExcel_starts_with?: InputMaybe<Scalars['String']['input']>;
    modelcode?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    modelcode_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    modelcode_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    modelcode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    modelcode_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    modelcode_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    modelcode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    modelcode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    modelcode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    modelcode_starts_with?: InputMaybe<Scalars['String']['input']>;
    powerKw?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than the given value. */
    powerKw_gt?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than or equal the given value. */
    powerKw_gte?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are contained in given list. */
    powerKw_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    /** All values less than the given value. */
    powerKw_lt?: InputMaybe<Scalars['Int']['input']>;
    /** All values less than or equal the given value. */
    powerKw_lte?: InputMaybe<Scalars['Int']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    powerKw_not?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are not contained in given list. */
    powerKw_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    powerPs?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than the given value. */
    powerPs_gt?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than or equal the given value. */
    powerPs_gte?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are contained in given list. */
    powerPs_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    /** All values less than the given value. */
    powerPs_lt?: InputMaybe<Scalars['Int']['input']>;
    /** All values less than or equal the given value. */
    powerPs_lte?: InputMaybe<Scalars['Int']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    powerPs_not?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are not contained in given list. */
    powerPs_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    price?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than the given value. */
    price_gt?: InputMaybe<Scalars['Int']['input']>;
    /** All values greater than or equal the given value. */
    price_gte?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are contained in given list. */
    price_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    /** All values less than the given value. */
    price_lt?: InputMaybe<Scalars['Int']['input']>;
    /** All values less than or equal the given value. */
    price_lte?: InputMaybe<Scalars['Int']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    price_not?: InputMaybe<Scalars['Int']['input']>;
    /** All values that are not contained in given list. */
    price_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    trim?: InputMaybe<Scalars['String']['input']>;
    trimAndEnvkvString?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    trimAndEnvkvString_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    trimAndEnvkvString_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    trimAndEnvkvString_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    trimAndEnvkvString_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    trimAndEnvkvString_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    trimAndEnvkvString_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    trimAndEnvkvString_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    trimAndEnvkvString_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    trimAndEnvkvString_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    trim_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    trim_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    trim_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    trim_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    trim_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    trim_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    trim_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    trim_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    trim_starts_with?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
    version?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    version_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    version_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    version_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    version_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    version_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    version_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    version_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    version_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    version_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type VehicleWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<VehicleWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<VehicleWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<VehicleWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<VehicleWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References Vehicle record uniquely */
export type VehicleWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
    modelcode?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleenvkvUnion = EnVkvElektro | EnVkvPlugInHybrid | EnVkvVerbrennerHybrid;

export type VehicleenvkvUnionConnectInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroConnectInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridConnectInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridConnectInput>;
};

export type VehicleenvkvUnionCreateInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroCreateInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridCreateInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridCreateInput>;
};

export type VehicleenvkvUnionCreateManyInlineInput = {
    /** Create and connect multiple existing VehicleenvkvUnion documents */
    create?: InputMaybe<Array<VehicleenvkvUnionCreateInput>>;
};

export type VehicleenvkvUnionCreateOneInlineInput = {
    /** Create and connect one VehicleenvkvUnion document */
    create?: InputMaybe<VehicleenvkvUnionCreateInput>;
};

export type VehicleenvkvUnionCreateWithPositionInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroCreateWithPositionInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridCreateWithPositionInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridCreateWithPositionInput>;
};

export type VehicleenvkvUnionUpdateInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroUpdateInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridUpdateInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridUpdateInput>;
};

export type VehicleenvkvUnionUpdateManyInlineInput = {
    /** Create and connect multiple VehicleenvkvUnion component instances */
    create?: InputMaybe<Array<VehicleenvkvUnionCreateWithPositionInput>>;
    /** Delete multiple VehicleenvkvUnion documents */
    delete?: InputMaybe<Array<VehicleenvkvUnionWhereUniqueInput>>;
    /** Update multiple VehicleenvkvUnion component instances */
    update?: InputMaybe<Array<VehicleenvkvUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple VehicleenvkvUnion component instances */
    upsert?: InputMaybe<Array<VehicleenvkvUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type VehicleenvkvUnionUpdateManyWithNestedWhereInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroUpdateManyWithNestedWhereInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridUpdateManyWithNestedWhereInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridUpdateManyWithNestedWhereInput>;
};

export type VehicleenvkvUnionUpdateOneInlineInput = {
    /** Create and connect one VehicleenvkvUnion document */
    create?: InputMaybe<VehicleenvkvUnionCreateInput>;
    /** Delete currently connected VehicleenvkvUnion document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single VehicleenvkvUnion document */
    update?: InputMaybe<VehicleenvkvUnionUpdateWithNestedWhereUniqueInput>;
    /** Upsert single VehicleenvkvUnion document */
    upsert?: InputMaybe<VehicleenvkvUnionUpsertWithNestedWhereUniqueInput>;
};

export type VehicleenvkvUnionUpdateWithNestedWhereUniqueAndPositionInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroUpdateWithNestedWhereUniqueAndPositionInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridUpdateWithNestedWhereUniqueAndPositionInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type VehicleenvkvUnionUpdateWithNestedWhereUniqueInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroUpdateWithNestedWhereUniqueInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridUpdateWithNestedWhereUniqueInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridUpdateWithNestedWhereUniqueInput>;
};

export type VehicleenvkvUnionUpsertWithNestedWhereUniqueAndPositionInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroUpsertWithNestedWhereUniqueAndPositionInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridUpsertWithNestedWhereUniqueAndPositionInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type VehicleenvkvUnionUpsertWithNestedWhereUniqueInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroUpsertWithNestedWhereUniqueInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridUpsertWithNestedWhereUniqueInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridUpsertWithNestedWhereUniqueInput>;
};

export type VehicleenvkvUnionWhereInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroWhereInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridWhereInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridWhereInput>;
};

export type VehicleenvkvUnionWhereUniqueInput = {
    EnVkvElektro?: InputMaybe<EnVkvElektroWhereUniqueInput>;
    EnVkvPlugInHybrid?: InputMaybe<EnVkvPlugInHybridWhereUniqueInput>;
    EnVkvVerbrennerHybrid?: InputMaybe<EnVkvVerbrennerHybridWhereUniqueInput>;
};

export type Version = {
    __typename?: 'Version';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    revision: Scalars['Int']['output'];
    stage: Stage;
};

export type VersionWhereInput = {
    id: Scalars['ID']['input'];
    revision: Scalars['Int']['input'];
    stage: Stage;
};

export type VertriebBusinessContent = Entity & {
    __typename?: 'VertriebBusinessContent';
    ctaType: CtaType;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    models: Array<Model>;
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VertriebBusinessContentModelsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<ModelOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ModelWhereInput>;
};

export type VertriebBusinessContentConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: VertriebBusinessContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type VertriebBusinessContentConnection = {
    __typename?: 'VertriebBusinessContentConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<VertriebBusinessContentEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type VertriebBusinessContentCreateInput = {
    ctaType: CtaType;
    models?: InputMaybe<ModelCreateManyInlineInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VertriebBusinessContentCreateManyInlineInput = {
    /** Create and connect multiple existing VertriebBusinessContent documents */
    create?: InputMaybe<Array<VertriebBusinessContentCreateInput>>;
};

export type VertriebBusinessContentCreateOneInlineInput = {
    /** Create and connect one VertriebBusinessContent document */
    create?: InputMaybe<VertriebBusinessContentCreateInput>;
};

export type VertriebBusinessContentCreateWithPositionInput = {
    /** Document to create */
    data: VertriebBusinessContentCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type VertriebBusinessContentEdge = {
    __typename?: 'VertriebBusinessContentEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: VertriebBusinessContent;
};

/** Identifies documents */
export type VertriebBusinessContentManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<VertriebBusinessContentWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<VertriebBusinessContentWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<VertriebBusinessContentWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    ctaType?: InputMaybe<CtaType>;
    /** All values that are contained in given list. */
    ctaType_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    /** Any other value that exists and is not equal to the given value. */
    ctaType_not?: InputMaybe<CtaType>;
    /** All values that are not contained in given list. */
    ctaType_not_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    models_every?: InputMaybe<ModelWhereInput>;
    models_none?: InputMaybe<ModelWhereInput>;
    models_some?: InputMaybe<ModelWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum VertriebBusinessContentOrderByInput {
    CtaTypeAsc = 'ctaType_ASC',
    CtaTypeDesc = 'ctaType_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type VertriebBusinessContentUpdateInput = {
    ctaType?: InputMaybe<CtaType>;
    models?: InputMaybe<ModelUpdateManyInlineInput>;
};

export type VertriebBusinessContentUpdateManyInlineInput = {
    /** Create and connect multiple VertriebBusinessContent component instances */
    create?: InputMaybe<Array<VertriebBusinessContentCreateWithPositionInput>>;
    /** Delete multiple VertriebBusinessContent documents */
    delete?: InputMaybe<Array<VertriebBusinessContentWhereUniqueInput>>;
    /** Update multiple VertriebBusinessContent component instances */
    update?: InputMaybe<Array<VertriebBusinessContentUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple VertriebBusinessContent component instances */
    upsert?: InputMaybe<Array<VertriebBusinessContentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type VertriebBusinessContentUpdateManyInput = {
    ctaType?: InputMaybe<CtaType>;
};

export type VertriebBusinessContentUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: VertriebBusinessContentUpdateManyInput;
    /** Document search */
    where: VertriebBusinessContentWhereInput;
};

export type VertriebBusinessContentUpdateOneInlineInput = {
    /** Create and connect one VertriebBusinessContent document */
    create?: InputMaybe<VertriebBusinessContentCreateInput>;
    /** Delete currently connected VertriebBusinessContent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single VertriebBusinessContent document */
    update?: InputMaybe<VertriebBusinessContentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single VertriebBusinessContent document */
    upsert?: InputMaybe<VertriebBusinessContentUpsertWithNestedWhereUniqueInput>;
};

export type VertriebBusinessContentUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<VertriebBusinessContentUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: VertriebBusinessContentWhereUniqueInput;
};

export type VertriebBusinessContentUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: VertriebBusinessContentUpdateInput;
    /** Unique document search */
    where: VertriebBusinessContentWhereUniqueInput;
};

export type VertriebBusinessContentUpsertInput = {
    /** Create document if it didn't exist */
    create: VertriebBusinessContentCreateInput;
    /** Update document if it exists */
    update: VertriebBusinessContentUpdateInput;
};

export type VertriebBusinessContentUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<VertriebBusinessContentUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: VertriebBusinessContentWhereUniqueInput;
};

export type VertriebBusinessContentUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: VertriebBusinessContentUpsertInput;
    /** Unique document search */
    where: VertriebBusinessContentWhereUniqueInput;
};

/** Identifies documents */
export type VertriebBusinessContentWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<VertriebBusinessContentWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<VertriebBusinessContentWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<VertriebBusinessContentWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    ctaType?: InputMaybe<CtaType>;
    /** All values that are contained in given list. */
    ctaType_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    /** Any other value that exists and is not equal to the given value. */
    ctaType_not?: InputMaybe<CtaType>;
    /** All values that are not contained in given list. */
    ctaType_not_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    models_every?: InputMaybe<ModelWhereInput>;
    models_none?: InputMaybe<ModelWhereInput>;
    models_some?: InputMaybe<ModelWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References VertriebBusinessContent record uniquely */
export type VertriebBusinessContentWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type VertriebPrivateContent = Entity & {
    __typename?: 'VertriebPrivateContent';
    ctaType: CtaType;
    /** The unique identifier */
    id: Scalars['ID']['output'];
    models: Array<Model>;
    /** System stage field */
    stage: Stage;
    /** System updatedAt field */
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VertriebPrivateContentModelsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<ModelOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ModelWhereInput>;
};

export type VertriebPrivateContentConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: VertriebPrivateContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type VertriebPrivateContentConnection = {
    __typename?: 'VertriebPrivateContentConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<VertriebPrivateContentEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type VertriebPrivateContentCreateInput = {
    ctaType: CtaType;
    models?: InputMaybe<ModelCreateManyInlineInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VertriebPrivateContentCreateManyInlineInput = {
    /** Create and connect multiple existing VertriebPrivateContent documents */
    create?: InputMaybe<Array<VertriebPrivateContentCreateInput>>;
};

export type VertriebPrivateContentCreateOneInlineInput = {
    /** Create and connect one VertriebPrivateContent document */
    create?: InputMaybe<VertriebPrivateContentCreateInput>;
};

export type VertriebPrivateContentCreateWithPositionInput = {
    /** Document to create */
    data: VertriebPrivateContentCreateInput;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type VertriebPrivateContentEdge = {
    __typename?: 'VertriebPrivateContentEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: VertriebPrivateContent;
};

/** Identifies documents */
export type VertriebPrivateContentManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<VertriebPrivateContentWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<VertriebPrivateContentWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<VertriebPrivateContentWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    ctaType?: InputMaybe<CtaType>;
    /** All values that are contained in given list. */
    ctaType_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    /** Any other value that exists and is not equal to the given value. */
    ctaType_not?: InputMaybe<CtaType>;
    /** All values that are not contained in given list. */
    ctaType_not_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    models_every?: InputMaybe<ModelWhereInput>;
    models_none?: InputMaybe<ModelWhereInput>;
    models_some?: InputMaybe<ModelWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum VertriebPrivateContentOrderByInput {
    CtaTypeAsc = 'ctaType_ASC',
    CtaTypeDesc = 'ctaType_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type VertriebPrivateContentUpdateInput = {
    ctaType?: InputMaybe<CtaType>;
    models?: InputMaybe<ModelUpdateManyInlineInput>;
};

export type VertriebPrivateContentUpdateManyInlineInput = {
    /** Create and connect multiple VertriebPrivateContent component instances */
    create?: InputMaybe<Array<VertriebPrivateContentCreateWithPositionInput>>;
    /** Delete multiple VertriebPrivateContent documents */
    delete?: InputMaybe<Array<VertriebPrivateContentWhereUniqueInput>>;
    /** Update multiple VertriebPrivateContent component instances */
    update?: InputMaybe<Array<VertriebPrivateContentUpdateWithNestedWhereUniqueAndPositionInput>>;
    /** Upsert multiple VertriebPrivateContent component instances */
    upsert?: InputMaybe<Array<VertriebPrivateContentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type VertriebPrivateContentUpdateManyInput = {
    ctaType?: InputMaybe<CtaType>;
};

export type VertriebPrivateContentUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: VertriebPrivateContentUpdateManyInput;
    /** Document search */
    where: VertriebPrivateContentWhereInput;
};

export type VertriebPrivateContentUpdateOneInlineInput = {
    /** Create and connect one VertriebPrivateContent document */
    create?: InputMaybe<VertriebPrivateContentCreateInput>;
    /** Delete currently connected VertriebPrivateContent document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single VertriebPrivateContent document */
    update?: InputMaybe<VertriebPrivateContentUpdateWithNestedWhereUniqueInput>;
    /** Upsert single VertriebPrivateContent document */
    upsert?: InputMaybe<VertriebPrivateContentUpsertWithNestedWhereUniqueInput>;
};

export type VertriebPrivateContentUpdateWithNestedWhereUniqueAndPositionInput = {
    /** Document to update */
    data?: InputMaybe<VertriebPrivateContentUpdateInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: VertriebPrivateContentWhereUniqueInput;
};

export type VertriebPrivateContentUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: VertriebPrivateContentUpdateInput;
    /** Unique document search */
    where: VertriebPrivateContentWhereUniqueInput;
};

export type VertriebPrivateContentUpsertInput = {
    /** Create document if it didn't exist */
    create: VertriebPrivateContentCreateInput;
    /** Update document if it exists */
    update: VertriebPrivateContentUpdateInput;
};

export type VertriebPrivateContentUpsertWithNestedWhereUniqueAndPositionInput = {
    /** Document to upsert */
    data?: InputMaybe<VertriebPrivateContentUpsertInput>;
    /** Position in the list of existing component instances, will default to appending at the end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Unique component instance search */
    where: VertriebPrivateContentWhereUniqueInput;
};

export type VertriebPrivateContentUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: VertriebPrivateContentUpsertInput;
    /** Unique document search */
    where: VertriebPrivateContentWhereUniqueInput;
};

/** Identifies documents */
export type VertriebPrivateContentWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<VertriebPrivateContentWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<VertriebPrivateContentWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<VertriebPrivateContentWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    ctaType?: InputMaybe<CtaType>;
    /** All values that are contained in given list. */
    ctaType_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    /** Any other value that exists and is not equal to the given value. */
    ctaType_not?: InputMaybe<CtaType>;
    /** All values that are not contained in given list. */
    ctaType_not_in?: InputMaybe<Array<InputMaybe<CtaType>>>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    models_every?: InputMaybe<ModelWhereInput>;
    models_none?: InputMaybe<ModelWhereInput>;
    models_some?: InputMaybe<ModelWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References VertriebPrivateContent record uniquely */
export type VertriebPrivateContentWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type Warranty = Entity &
    Node & {
        __typename?: 'Warranty';
        bulletlist: Array<IconText>;
        copy?: Maybe<Scalars['String']['output']>;
        /** The time the document was created */
        createdAt: Scalars['DateTime']['output'];
        /** User that created this document */
        createdBy?: Maybe<User>;
        /** Get the document in other stages */
        documentInStages: Array<Warranty>;
        downloadPdf?: Maybe<Asset>;
        headline?: Maybe<Scalars['String']['output']>;
        /** List of Warranty versions */
        history: Array<Version>;
        /** The unique identifier */
        id: Scalars['ID']['output'];
        image?: Maybe<Asset>;
        /** The time the document was published. Null on documents in draft stage. */
        publishedAt?: Maybe<Scalars['DateTime']['output']>;
        /** User that last published this document */
        publishedBy?: Maybe<User>;
        scheduledIn: Array<ScheduledOperation>;
        /** System stage field */
        stage: Stage;
        /** The time the document was updated */
        updatedAt: Scalars['DateTime']['output'];
        /** User that last updated this document */
        updatedBy?: Maybe<User>;
    };

export type WarrantyBulletlistArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    orderBy?: InputMaybe<IconTextOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IconTextWhereInput>;
};

export type WarrantyCreatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type WarrantyDocumentInStagesArgs = {
    includeCurrent?: Scalars['Boolean']['input'];
    inheritLocale?: Scalars['Boolean']['input'];
    stages?: Array<Stage>;
};

export type WarrantyDownloadPdfArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type WarrantyHistoryArgs = {
    limit?: Scalars['Int']['input'];
    skip?: Scalars['Int']['input'];
    stageOverride?: InputMaybe<Stage>;
};

export type WarrantyImageArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type WarrantyPublishedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type WarrantyScheduledInArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    locales?: InputMaybe<Array<Locale>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ScheduledOperationWhereInput>;
};

export type WarrantyUpdatedByArgs = {
    forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locales?: InputMaybe<Array<Locale>>;
};

export type WarrantyConnectInput = {
    /** Allow to specify document position in list of connected documents, will default to appending at end of list */
    position?: InputMaybe<ConnectPositionInput>;
    /** Document to connect */
    where: WarrantyWhereUniqueInput;
};

/** A connection to a list of items. */
export type WarrantyConnection = {
    __typename?: 'WarrantyConnection';
    aggregate: Aggregate;
    /** A list of edges. */
    edges: Array<WarrantyEdge>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type WarrantyCreateInput = {
    bulletlist?: InputMaybe<IconTextCreateManyInlineInput>;
    clxt1lfba0ylu07w36wo16id6?: InputMaybe<PageWarrantyCreateManyInlineInput>;
    clxt1nfnk0yne07w3cuhxgeq0?: InputMaybe<PageWarrantyCreateManyInlineInput>;
    clxt2f3zt0z5e07w3e006ebv5?: InputMaybe<PageBusinessCustomerCreateManyInlineInput>;
    clxt2fnz20z7p07w33ivf6fbk?: InputMaybe<PageBusinessCustomerCreateManyInlineInput>;
    copy?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    downloadPdf?: InputMaybe<AssetCreateOneInlineInput>;
    headline?: InputMaybe<Scalars['String']['input']>;
    image?: InputMaybe<AssetCreateOneInlineInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WarrantyCreateManyInlineInput = {
    /** Connect multiple existing Warranty documents */
    connect?: InputMaybe<Array<WarrantyWhereUniqueInput>>;
    /** Create and connect multiple existing Warranty documents */
    create?: InputMaybe<Array<WarrantyCreateInput>>;
};

export type WarrantyCreateOneInlineInput = {
    /** Connect one existing Warranty document */
    connect?: InputMaybe<WarrantyWhereUniqueInput>;
    /** Create and connect one Warranty document */
    create?: InputMaybe<WarrantyCreateInput>;
};

/** An edge in a connection. */
export type WarrantyEdge = {
    __typename?: 'WarrantyEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge. */
    node: Warranty;
};

/** Identifies documents */
export type WarrantyManyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<WarrantyWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<WarrantyWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<WarrantyWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    bulletlist_every?: InputMaybe<IconTextWhereInput>;
    bulletlist_none?: InputMaybe<IconTextWhereInput>;
    bulletlist_some?: InputMaybe<IconTextWhereInput>;
    copy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    copy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    copy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    copy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    copy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    copy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    copy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    copy_starts_with?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<WarrantyWhereStageInput>;
    documentInStages_none?: InputMaybe<WarrantyWhereStageInput>;
    documentInStages_some?: InputMaybe<WarrantyWhereStageInput>;
    downloadPdf?: InputMaybe<AssetWhereInput>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

export enum WarrantyOrderByInput {
    CopyAsc = 'copy_ASC',
    CopyDesc = 'copy_DESC',
    CreatedAtAsc = 'createdAt_ASC',
    CreatedAtDesc = 'createdAt_DESC',
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    PublishedAtAsc = 'publishedAt_ASC',
    PublishedAtDesc = 'publishedAt_DESC',
    UpdatedAtAsc = 'updatedAt_ASC',
    UpdatedAtDesc = 'updatedAt_DESC',
}

export type WarrantyUpdateInput = {
    bulletlist?: InputMaybe<IconTextUpdateManyInlineInput>;
    clxt1lfba0ylu07w36wo16id6?: InputMaybe<PageWarrantyUpdateManyInlineInput>;
    clxt1nfnk0yne07w3cuhxgeq0?: InputMaybe<PageWarrantyUpdateManyInlineInput>;
    clxt2f3zt0z5e07w3e006ebv5?: InputMaybe<PageBusinessCustomerUpdateManyInlineInput>;
    clxt2fnz20z7p07w33ivf6fbk?: InputMaybe<PageBusinessCustomerUpdateManyInlineInput>;
    copy?: InputMaybe<Scalars['String']['input']>;
    downloadPdf?: InputMaybe<AssetUpdateOneInlineInput>;
    headline?: InputMaybe<Scalars['String']['input']>;
    image?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type WarrantyUpdateManyInlineInput = {
    /** Connect multiple existing Warranty documents */
    connect?: InputMaybe<Array<WarrantyConnectInput>>;
    /** Create and connect multiple Warranty documents */
    create?: InputMaybe<Array<WarrantyCreateInput>>;
    /** Delete multiple Warranty documents */
    delete?: InputMaybe<Array<WarrantyWhereUniqueInput>>;
    /** Disconnect multiple Warranty documents */
    disconnect?: InputMaybe<Array<WarrantyWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing Warranty documents */
    set?: InputMaybe<Array<WarrantyWhereUniqueInput>>;
    /** Update multiple Warranty documents */
    update?: InputMaybe<Array<WarrantyUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple Warranty documents */
    upsert?: InputMaybe<Array<WarrantyUpsertWithNestedWhereUniqueInput>>;
};

export type WarrantyUpdateManyInput = {
    copy?: InputMaybe<Scalars['String']['input']>;
    headline?: InputMaybe<Scalars['String']['input']>;
};

export type WarrantyUpdateManyWithNestedWhereInput = {
    /** Update many input */
    data: WarrantyUpdateManyInput;
    /** Document search */
    where: WarrantyWhereInput;
};

export type WarrantyUpdateOneInlineInput = {
    /** Connect existing Warranty document */
    connect?: InputMaybe<WarrantyWhereUniqueInput>;
    /** Create and connect one Warranty document */
    create?: InputMaybe<WarrantyCreateInput>;
    /** Delete currently connected Warranty document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected Warranty document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single Warranty document */
    update?: InputMaybe<WarrantyUpdateWithNestedWhereUniqueInput>;
    /** Upsert single Warranty document */
    upsert?: InputMaybe<WarrantyUpsertWithNestedWhereUniqueInput>;
};

export type WarrantyUpdateWithNestedWhereUniqueInput = {
    /** Document to update */
    data: WarrantyUpdateInput;
    /** Unique document search */
    where: WarrantyWhereUniqueInput;
};

export type WarrantyUpsertInput = {
    /** Create document if it didn't exist */
    create: WarrantyCreateInput;
    /** Update document if it exists */
    update: WarrantyUpdateInput;
};

export type WarrantyUpsertWithNestedWhereUniqueInput = {
    /** Upsert data */
    data: WarrantyUpsertInput;
    /** Unique document search */
    where: WarrantyWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type WarrantyWhereComparatorInput = {
    /** This field can be used to request to check if the entry is outdated by internal comparison */
    outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type WarrantyWhereInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<WarrantyWhereInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<WarrantyWhereInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<WarrantyWhereInput>>;
    /** Contains search across all appropriate fields. */
    _search?: InputMaybe<Scalars['String']['input']>;
    bulletlist_every?: InputMaybe<IconTextWhereInput>;
    bulletlist_none?: InputMaybe<IconTextWhereInput>;
    bulletlist_some?: InputMaybe<IconTextWhereInput>;
    copy?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    copy_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    copy_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    copy_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    copy_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    copy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    copy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    copy_starts_with?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    createdBy?: InputMaybe<UserWhereInput>;
    documentInStages_every?: InputMaybe<WarrantyWhereStageInput>;
    documentInStages_none?: InputMaybe<WarrantyWhereStageInput>;
    documentInStages_some?: InputMaybe<WarrantyWhereStageInput>;
    downloadPdf?: InputMaybe<AssetWhereInput>;
    headline?: InputMaybe<Scalars['String']['input']>;
    /** All values containing the given string. */
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values ending with the given string. */
    headline_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are contained in given list. */
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    headline_not?: InputMaybe<Scalars['String']['input']>;
    /** All values not containing the given string. */
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    /** All values not ending with the given string */
    headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
    /** All values that are not contained in given list. */
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** All values not starting with the given string. */
    headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
    /** All values starting with the given string. */
    headline_starts_with?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    /** All values containing the given string. */
    id_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values ending with the given string. */
    id_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are contained in given list. */
    id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** Any other value that exists and is not equal to the given value. */
    id_not?: InputMaybe<Scalars['ID']['input']>;
    /** All values not containing the given string. */
    id_not_contains?: InputMaybe<Scalars['ID']['input']>;
    /** All values not ending with the given string */
    id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values that are not contained in given list. */
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    /** All values not starting with the given string. */
    id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
    /** All values starting with the given string. */
    id_starts_with?: InputMaybe<Scalars['ID']['input']>;
    image?: InputMaybe<AssetWhereInput>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedBy?: InputMaybe<UserWhereInput>;
    scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
    scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
    updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than the given value. */
    updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values greater than or equal the given value. */
    updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are contained in given list. */
    updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    /** All values less than the given value. */
    updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values less than or equal the given value. */
    updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Any other value that exists and is not equal to the given value. */
    updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    /** All values that are not contained in given list. */
    updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type WarrantyWhereStageInput = {
    /** Logical AND on all given filters. */
    AND?: InputMaybe<Array<WarrantyWhereStageInput>>;
    /** Logical NOT on all given filters combined by AND. */
    NOT?: InputMaybe<Array<WarrantyWhereStageInput>>;
    /** Logical OR on all given filters. */
    OR?: InputMaybe<Array<WarrantyWhereStageInput>>;
    /** This field contains fields which can be set as true or false to specify an internal comparison */
    compareWithParent?: InputMaybe<WarrantyWhereComparatorInput>;
    /** Specify the stage to compare with */
    stage?: InputMaybe<Stage>;
};

/** References Warranty record uniquely */
export type WarrantyWhereUniqueInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export enum _FilterKind {
    And = 'AND',
    Not = 'NOT',
    Or = 'OR',
    Contains = 'contains',
    ContainsAll = 'contains_all',
    ContainsNone = 'contains_none',
    ContainsSome = 'contains_some',
    DescendantsOf = 'descendants_of',
    EndsWith = 'ends_with',
    Eq = 'eq',
    EqNot = 'eq_not',
    Gt = 'gt',
    Gte = 'gte',
    In = 'in',
    JsonPathExists = 'json_path_exists',
    JsonValueRecursive = 'json_value_recursive',
    Lt = 'lt',
    Lte = 'lte',
    NotContains = 'not_contains',
    NotEndsWith = 'not_ends_with',
    NotIn = 'not_in',
    NotStartsWith = 'not_starts_with',
    RelationalEvery = 'relational_every',
    RelationalNone = 'relational_none',
    RelationalSingle = 'relational_single',
    RelationalSome = 'relational_some',
    Search = 'search',
    StartsWith = 'starts_with',
    UnionEmpty = 'union_empty',
    UnionEvery = 'union_every',
    UnionNone = 'union_none',
    UnionSingle = 'union_single',
    UnionSome = 'union_some',
}

export enum _MutationInputFieldKind {
    Enum = 'enum',
    Relation = 'relation',
    RichText = 'richText',
    RichTextWithEmbeds = 'richTextWithEmbeds',
    Scalar = 'scalar',
    Union = 'union',
    Virtual = 'virtual',
}

export enum _MutationKind {
    Create = 'create',
    Delete = 'delete',
    DeleteMany = 'deleteMany',
    Publish = 'publish',
    PublishMany = 'publishMany',
    SchedulePublish = 'schedulePublish',
    ScheduleUnpublish = 'scheduleUnpublish',
    Unpublish = 'unpublish',
    UnpublishMany = 'unpublishMany',
    Update = 'update',
    UpdateMany = 'updateMany',
    Upsert = 'upsert',
}

export enum _OrderDirection {
    Asc = 'asc',
    Desc = 'desc',
}

export enum _RelationInputCardinality {
    Many = 'many',
    One = 'one',
}

export enum _RelationInputKind {
    Create = 'create',
    Update = 'update',
}

export enum _RelationKind {
    Regular = 'regular',
    Union = 'union',
}

export enum _SystemDateTimeFieldVariation {
    Base = 'base',
    Combined = 'combined',
    Localization = 'localization',
}

export type SalesCampaignModelEnvkvDataSourceTeaser = Model | Vehicle;

export type SalesCampaignModelEnvkvDataSourceTeaserConnectInput = {
    Model?: InputMaybe<ModelConnectInput>;
    Vehicle?: InputMaybe<VehicleConnectInput>;
};

export type SalesCampaignModelEnvkvDataSourceTeaserCreateInput = {
    Model?: InputMaybe<ModelCreateInput>;
    Vehicle?: InputMaybe<VehicleCreateInput>;
};

export type SalesCampaignModelEnvkvDataSourceTeaserCreateManyInlineInput = {
    /** Connect multiple existing salesCampaignModelEnvkvDataSourceTeaser documents */
    connect?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceTeaserWhereUniqueInput>>;
    /** Create and connect multiple existing salesCampaignModelEnvkvDataSourceTeaser documents */
    create?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceTeaserCreateInput>>;
};

export type SalesCampaignModelEnvkvDataSourceTeaserCreateOneInlineInput = {
    /** Connect one existing salesCampaignModelEnvkvDataSourceTeaser document */
    connect?: InputMaybe<SalesCampaignModelEnvkvDataSourceTeaserWhereUniqueInput>;
    /** Create and connect one salesCampaignModelEnvkvDataSourceTeaser document */
    create?: InputMaybe<SalesCampaignModelEnvkvDataSourceTeaserCreateInput>;
};

export type SalesCampaignModelEnvkvDataSourceTeaserUpdateInput = {
    Model?: InputMaybe<ModelUpdateInput>;
    Vehicle?: InputMaybe<VehicleUpdateInput>;
};

export type SalesCampaignModelEnvkvDataSourceTeaserUpdateManyInlineInput = {
    /** Connect multiple existing salesCampaignModelEnvkvDataSourceTeaser documents */
    connect?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceTeaserConnectInput>>;
    /** Create and connect multiple salesCampaignModelEnvkvDataSourceTeaser documents */
    create?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceTeaserCreateInput>>;
    /** Delete multiple salesCampaignModelEnvkvDataSourceTeaser documents */
    delete?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceTeaserWhereUniqueInput>>;
    /** Disconnect multiple salesCampaignModelEnvkvDataSourceTeaser documents */
    disconnect?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceTeaserWhereUniqueInput>>;
    /** Override currently-connected documents with multiple existing salesCampaignModelEnvkvDataSourceTeaser documents */
    set?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceTeaserWhereUniqueInput>>;
    /** Update multiple salesCampaignModelEnvkvDataSourceTeaser documents */
    update?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceTeaserUpdateWithNestedWhereUniqueInput>>;
    /** Upsert multiple salesCampaignModelEnvkvDataSourceTeaser documents */
    upsert?: InputMaybe<Array<SalesCampaignModelEnvkvDataSourceTeaserUpsertWithNestedWhereUniqueInput>>;
};

export type SalesCampaignModelEnvkvDataSourceTeaserUpdateManyWithNestedWhereInput = {
    Model?: InputMaybe<ModelUpdateManyWithNestedWhereInput>;
    Vehicle?: InputMaybe<VehicleUpdateManyWithNestedWhereInput>;
};

export type SalesCampaignModelEnvkvDataSourceTeaserUpdateOneInlineInput = {
    /** Connect existing salesCampaignModelEnvkvDataSourceTeaser document */
    connect?: InputMaybe<SalesCampaignModelEnvkvDataSourceTeaserWhereUniqueInput>;
    /** Create and connect one salesCampaignModelEnvkvDataSourceTeaser document */
    create?: InputMaybe<SalesCampaignModelEnvkvDataSourceTeaserCreateInput>;
    /** Delete currently connected salesCampaignModelEnvkvDataSourceTeaser document */
    delete?: InputMaybe<Scalars['Boolean']['input']>;
    /** Disconnect currently connected salesCampaignModelEnvkvDataSourceTeaser document */
    disconnect?: InputMaybe<Scalars['Boolean']['input']>;
    /** Update single salesCampaignModelEnvkvDataSourceTeaser document */
    update?: InputMaybe<SalesCampaignModelEnvkvDataSourceTeaserUpdateWithNestedWhereUniqueInput>;
    /** Upsert single salesCampaignModelEnvkvDataSourceTeaser document */
    upsert?: InputMaybe<SalesCampaignModelEnvkvDataSourceTeaserUpsertWithNestedWhereUniqueInput>;
};

export type SalesCampaignModelEnvkvDataSourceTeaserUpdateWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpdateWithNestedWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleUpdateWithNestedWhereUniqueInput>;
};

export type SalesCampaignModelEnvkvDataSourceTeaserUpsertWithNestedWhereUniqueInput = {
    Model?: InputMaybe<ModelUpsertWithNestedWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleUpsertWithNestedWhereUniqueInput>;
};

export type SalesCampaignModelEnvkvDataSourceTeaserWhereInput = {
    Model?: InputMaybe<ModelWhereInput>;
    Vehicle?: InputMaybe<VehicleWhereInput>;
};

export type SalesCampaignModelEnvkvDataSourceTeaserWhereUniqueInput = {
    Model?: InputMaybe<ModelWhereUniqueInput>;
    Vehicle?: InputMaybe<VehicleWhereUniqueInput>;
};

export type CreateAuth0UserMutationVariables = Exact<{
    email: Scalars['String']['input'];
    dealerId: Scalars['String']['input'];
    isAdmin: Scalars['Boolean']['input'];
}>;

export type CreateAuth0UserMutation = {
    __typename?: 'Mutation';
    createAuth0User?: { __typename?: 'Auth0User'; id: string; email: string } | null;
};

export type GetPaginatedAuth0UsersQueryVariables = Exact<{
    first: Scalars['Int']['input'];
    skip: Scalars['Int']['input'];
}>;

export type GetPaginatedAuth0UsersQuery = {
    __typename?: 'Query';
    auth0Users: Array<{
        __typename?: 'Auth0User';
        id: string;
        email: string;
        isAdmin: boolean;
        dealer?: { __typename?: 'Dealer'; dealerId: string } | null;
    }>;
};

export type ImageFragment = {
    __typename?: 'Asset';
    url: string;
    width?: number | null;
    height?: number | null;
    alt?: string | null;
};

export type TeaserFragmentFragment = {
    __typename?: 'Campaign';
    id: string;
    slug: string;
    teaserCopy?: string | null;
    teaserHeadline: string;
    startDate?: unknown | null;
    title: string;
    endDate?: unknown | null;
    heroImageCaption?: string | null;
    heroImage: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    };
    modelForAnnouncement?: {
        __typename?: 'Model';
        slug: string;
        co2Class: string;
        name: string;
        envkv?:
            | {
                  __typename: 'EnVkvElektro';
                  consumptionCombined: string;
                  co2Combined: string;
                  rangeElectric: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvPlugInHybrid';
                  consumptionCombinedLitres: string;
                  consumptionCombinedElectric: string;
                  co2Combined: string;
                  consumptionCombinedDischargedBattery: string;
                  co2CombinedDischargedBattery: string;
                  co2ClassDischargedBattery: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvVerbrennerHybrid';
                  co2Combined: string;
                  consumptionCombined: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvWasserstoff';
                  energyCombined: string;
                  co2Combined: string;
                  range: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | null;
    } | null;
    content?:
        | { __typename: 'AfterSale'; minimumShortTitle: string }
        | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
        | {
              __typename: 'SalesCampaignContent';
              isBusinessCampaign?: boolean | null;
              highlightBannerHeadline?: string | null;
              highlightBannerHeadlinePersonalized?: string | null;
              highlightBannerSubheadline?: string | null;
              highlightBannerSubheadlinePersonalized?: string | null;
              minimumShortTitle: string;
          }
        | null;
};

export type ModelFragmentFragment = {
    __typename: 'Model';
    msrLink?: string | null;
    name: string;
    slug: string;
    formIdentifier?: string | null;
    vehicleMarketFilterParams?: string | null;
    disableTestdrive?: boolean | null;
    co2ClassText: string;
    envkv?:
        | {
              __typename: 'EnVkvElektro';
              consumptionCombined: string;
              co2Combined: string;
              rangeElectric: string;
              headline: string;
              additionalTransmissionPerformance?: string | null;
          }
        | {
              __typename: 'EnVkvPlugInHybrid';
              consumptionCombinedLitres: string;
              consumptionCombinedElectric: string;
              co2Combined: string;
              consumptionCombinedDischargedBattery: string;
              co2CombinedDischargedBattery: string;
              co2ClassDischargedBattery: string;
              headline: string;
              additionalTransmissionPerformance?: string | null;
          }
        | {
              __typename: 'EnVkvVerbrennerHybrid';
              co2Combined: string;
              consumptionCombined: string;
              headline: string;
              additionalTransmissionPerformance?: string | null;
          }
        | {
              __typename: 'EnVkvWasserstoff';
              energyCombined: string;
              co2Combined: string;
              range: string;
              headline: string;
              additionalTransmissionPerformance?: string | null;
          }
        | null;
};

export type VehicleFragmentFragment = {
    __typename: 'Vehicle';
    co2Class: Co2Class;
    trim: string;
    powerPs?: number | null;
    powerKw?: number | null;
    version?: string | null;
    trimAndEnvkvString?: string | null;
    fuelType?: FuelType | null;
    model?: {
        __typename?: 'Model';
        name: string;
        formIdentifier?: string | null;
        slug: string;
        vehicleMarketFilterParams?: string | null;
        disableTestdrive?: boolean | null;
    } | null;
    envkv?:
        | {
              __typename: 'EnVkvElektro';
              consumptionCombined: string;
              co2Combined: string;
              rangeElectric: string;
              headline: string;
              additionalTransmissionPerformance?: string | null;
          }
        | {
              __typename: 'EnVkvPlugInHybrid';
              consumptionCombinedLitres: string;
              consumptionCombinedElectric: string;
              co2Combined: string;
              consumptionCombinedDischargedBattery: string;
              co2CombinedDischargedBattery: string;
              co2ClassDischargedBattery: string;
              headline: string;
              additionalTransmissionPerformance?: string | null;
          }
        | {
              __typename: 'EnVkvVerbrennerHybrid';
              co2Combined: string;
              consumptionCombined: string;
              headline: string;
              additionalTransmissionPerformance?: string | null;
          }
        | null;
};

export type EnVkvElektroFragmentFragment = {
    __typename: 'EnVkvElektro';
    consumptionCombined: string;
    co2Combined: string;
    rangeElectric: string;
    headline: string;
    additionalTransmissionPerformance?: string | null;
};

export type EnVkvPlugInHybridFragmentFragment = {
    __typename: 'EnVkvPlugInHybrid';
    consumptionCombinedLitres: string;
    consumptionCombinedElectric: string;
    co2Combined: string;
    consumptionCombinedDischargedBattery: string;
    co2CombinedDischargedBattery: string;
    co2ClassDischargedBattery: string;
    headline: string;
    additionalTransmissionPerformance?: string | null;
};

export type EnVkvVerbrennerHybridFragmentFragment = {
    __typename: 'EnVkvVerbrennerHybrid';
    co2Combined: string;
    consumptionCombined: string;
    headline: string;
    additionalTransmissionPerformance?: string | null;
};

export type EnVkvWasserstoffFragmentFragment = {
    __typename: 'EnVkvWasserstoff';
    energyCombined: string;
    co2Combined: string;
    range: string;
    headline: string;
    additionalTransmissionPerformance?: string | null;
};

export type CampaignOverviewFragmentFragment = {
    __typename?: 'Campaign';
    id: string;
    slug: string;
    teaserCopy?: string | null;
    teaserHeadline: string;
    startDate?: unknown | null;
    title: string;
    endDate?: unknown | null;
    heroImageCaption?: string | null;
    heroImage: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    };
    modelForAnnouncement?: {
        __typename?: 'Model';
        slug: string;
        co2Class: string;
        name: string;
        envkv?:
            | {
                  __typename: 'EnVkvElektro';
                  consumptionCombined: string;
                  co2Combined: string;
                  rangeElectric: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvPlugInHybrid';
                  consumptionCombinedLitres: string;
                  consumptionCombinedElectric: string;
                  co2Combined: string;
                  consumptionCombinedDischargedBattery: string;
                  co2CombinedDischargedBattery: string;
                  co2ClassDischargedBattery: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvVerbrennerHybrid';
                  co2Combined: string;
                  consumptionCombined: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvWasserstoff';
                  energyCombined: string;
                  co2Combined: string;
                  range: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | null;
    } | null;
    content?:
        | { __typename: 'AfterSale'; minimumShortTitle: string }
        | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
        | {
              __typename: 'SalesCampaignContent';
              isBusinessCampaign?: boolean | null;
              highlightBannerHeadline?: string | null;
              highlightBannerHeadlinePersonalized?: string | null;
              highlightBannerSubheadline?: string | null;
              highlightBannerSubheadlinePersonalized?: string | null;
              minimumShortTitle: string;
          }
        | null;
};

export type HomeCampaignFragmentFragment = {
    __typename?: 'Campaign';
    id: string;
    slug: string;
    teaserCopy?: string | null;
    teaserHeadline: string;
    startDate?: unknown | null;
    title: string;
    endDate?: unknown | null;
    heroImageCaption?: string | null;
    heroImage: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    };
    modelForAnnouncement?: {
        __typename?: 'Model';
        slug: string;
        co2Class: string;
        name: string;
        envkv?:
            | {
                  __typename: 'EnVkvElektro';
                  consumptionCombined: string;
                  co2Combined: string;
                  rangeElectric: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvPlugInHybrid';
                  consumptionCombinedLitres: string;
                  consumptionCombinedElectric: string;
                  co2Combined: string;
                  consumptionCombinedDischargedBattery: string;
                  co2CombinedDischargedBattery: string;
                  co2ClassDischargedBattery: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvVerbrennerHybrid';
                  co2Combined: string;
                  consumptionCombined: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvWasserstoff';
                  energyCombined: string;
                  co2Combined: string;
                  range: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | null;
    } | null;
    content?:
        | { __typename: 'AfterSale'; minimumShortTitle: string }
        | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
        | {
              __typename: 'SalesCampaignContent';
              isBusinessCampaign?: boolean | null;
              highlightBannerHeadline?: string | null;
              highlightBannerHeadlinePersonalized?: string | null;
              highlightBannerSubheadline?: string | null;
              highlightBannerSubheadlinePersonalized?: string | null;
              minimumShortTitle: string;
          }
        | null;
};

export type BusinessCustomerCampaignFragmentFragment = {
    __typename?: 'Campaign';
    id: string;
    slug: string;
    teaserCopy?: string | null;
    teaserHeadline: string;
    startDate?: unknown | null;
    title: string;
    endDate?: unknown | null;
    heroImageCaption?: string | null;
    heroImage: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    };
    modelForAnnouncement?: {
        __typename?: 'Model';
        slug: string;
        co2Class: string;
        name: string;
        envkv?:
            | {
                  __typename: 'EnVkvElektro';
                  consumptionCombined: string;
                  co2Combined: string;
                  rangeElectric: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvPlugInHybrid';
                  consumptionCombinedLitres: string;
                  consumptionCombinedElectric: string;
                  co2Combined: string;
                  consumptionCombinedDischargedBattery: string;
                  co2CombinedDischargedBattery: string;
                  co2ClassDischargedBattery: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvVerbrennerHybrid';
                  co2Combined: string;
                  consumptionCombined: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvWasserstoff';
                  energyCombined: string;
                  co2Combined: string;
                  range: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | null;
    } | null;
    content?:
        | { __typename: 'AfterSale'; minimumShortTitle: string }
        | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
        | {
              __typename: 'SalesCampaignContent';
              isBusinessCampaign?: boolean | null;
              highlightBannerHeadline?: string | null;
              highlightBannerHeadlinePersonalized?: string | null;
              highlightBannerSubheadline?: string | null;
              highlightBannerSubheadlinePersonalized?: string | null;
              minimumShortTitle: string;
          }
        | null;
};

export type ModelForAnnouncementFragmentFragment = {
    __typename?: 'Model';
    name: string;
    slug: string;
    categories: Array<ModelCategory>;
    msrLink?: string | null;
    co2Class: string;
    contentHeadline?: string | null;
    cwModelUrl?: string | null;
    formModelId: string;
    formGenerationId: string;
    formBodyId: string;
    heroImage: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    };
    logoImages: Array<{
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    }>;
    contentImages: Array<{
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    }>;
    contentCopy?: { __typename?: 'RichText'; html: string } | null;
    keyFacts: Array<{ __typename?: 'KeyFact'; label: string; value: string; unit: string }>;
    legalTexts?: { __typename?: 'RichText'; html: string } | null;
    envkv?:
        | {
              __typename: 'EnVkvElektro';
              consumptionCombined: string;
              co2Combined: string;
              rangeElectric: string;
              headline: string;
              additionalTransmissionPerformance?: string | null;
          }
        | {
              __typename: 'EnVkvPlugInHybrid';
              consumptionCombinedLitres: string;
              consumptionCombinedElectric: string;
              co2Combined: string;
              consumptionCombinedDischargedBattery: string;
              co2CombinedDischargedBattery: string;
              co2ClassDischargedBattery: string;
              headline: string;
              additionalTransmissionPerformance?: string | null;
          }
        | {
              __typename: 'EnVkvVerbrennerHybrid';
              co2Combined: string;
              consumptionCombined: string;
              headline: string;
              additionalTransmissionPerformance?: string | null;
          }
        | {
              __typename: 'EnVkvWasserstoff';
              energyCombined: string;
              co2Combined: string;
              range: string;
              headline: string;
              additionalTransmissionPerformance?: string | null;
          }
        | null;
};

export type CampaignDetailFragmentFragment = {
    __typename?: 'Campaign';
    heroHeadline?: string | null;
    legalLines?: string | null;
    kmpCode?: string | null;
    metaDescriptionOverride?: string | null;
    id: string;
    slug: string;
    teaserCopy?: string | null;
    teaserHeadline: string;
    startDate?: unknown | null;
    title: string;
    endDate?: unknown | null;
    heroImageCaption?: string | null;
    modelForAnnouncement?: {
        __typename?: 'Model';
        slug: string;
        co2Class: string;
        name: string;
        categories: Array<ModelCategory>;
        msrLink?: string | null;
        contentHeadline?: string | null;
        cwModelUrl?: string | null;
        formModelId: string;
        formGenerationId: string;
        formBodyId: string;
        envkv?:
            | {
                  __typename: 'EnVkvElektro';
                  consumptionCombined: string;
                  co2Combined: string;
                  rangeElectric: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvPlugInHybrid';
                  consumptionCombinedLitres: string;
                  consumptionCombinedElectric: string;
                  co2Combined: string;
                  consumptionCombinedDischargedBattery: string;
                  co2CombinedDischargedBattery: string;
                  co2ClassDischargedBattery: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvVerbrennerHybrid';
                  co2Combined: string;
                  consumptionCombined: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvWasserstoff';
                  energyCombined: string;
                  co2Combined: string;
                  range: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | null;
        heroImage: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        };
        logoImages: Array<{
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        }>;
        contentImages: Array<{
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        }>;
        contentCopy?: { __typename?: 'RichText'; html: string } | null;
        keyFacts: Array<{ __typename?: 'KeyFact'; label: string; value: string; unit: string }>;
        legalTexts?: { __typename?: 'RichText'; html: string } | null;
    } | null;
    models: Array<{
        __typename?: 'Model';
        id: string;
        name: string;
        publishedAt?: string | null;
        contentHeadline?: string | null;
        formGenerationId: string;
        formBodyId: string;
        legalTexts?: { __typename?: 'RichText'; html: string } | null;
    }>;
    content?:
        | {
              __typename: 'AfterSale';
              minimumShortTitle: string;
              id: string;
              afterSalesServices: Array<{
                  __typename?: 'CampaignAfterSalesService';
                  id: string;
                  title?: string | null;
                  serviceId?: string | null;
                  longDescription?: string | null;
                  shortDescription?: string | null;
                  trackingName?: string | null;
                  serviceCheckout: boolean;
                  bulletlist: Array<{ __typename?: 'IconText'; text: string }>;
                  icon?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
                  image?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
                  footnote?: { __typename?: 'Footnote'; id: string } | null;
              }>;
              afterSalesAccesories: Array<{
                  __typename?: 'CampaignAfterSalesAccesory';
                  id: string;
                  title?: string | null;
                  articleNumber?: string | null;
                  shopSearchTerm?: string | null;
                  accesoryId?: string | null;
                  longDescription?: string | null;
                  shortDescription?: string | null;
                  utmCreativeFormatParam?: string | null;
                  mailToLink?: string | null;
                  highlightTeaserImage?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
                  bulletlist: Array<{ __typename?: 'IconText'; text: string }>;
                  icon?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
                  image?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
                  footnote?: { __typename?: 'Footnote'; id: string } | null;
              }>;
          }
        | {
              __typename: 'ModellAnkuendigungContent';
              minimumShortTitle: string;
              promotionInModellPalette?: boolean | null;
              warrantyLogo1?: {
                  __typename?: 'Asset';
                  url: string;
                  width?: number | null;
                  height?: number | null;
                  alt?: string | null;
              } | null;
              warrantyLogo2?: {
                  __typename?: 'Asset';
                  url: string;
                  width?: number | null;
                  height?: number | null;
                  alt?: string | null;
              } | null;
              warrantyLogo3?: {
                  __typename?: 'Asset';
                  url: string;
                  width?: number | null;
                  height?: number | null;
                  alt?: string | null;
              } | null;
          }
        | {
              __typename: 'SalesCampaignContent';
              isBusinessCampaign?: boolean | null;
              highlightBannerHeadline?: string | null;
              highlightBannerHeadlinePersonalized?: string | null;
              highlightBannerSubheadline?: string | null;
              highlightBannerSubheadlinePersonalized?: string | null;
              minimumShortTitle: string;
              testdriveUrlOverride?: string | null;
              offerformUrlOverride?: string | null;
              highlightModuleHeadline?: string | null;
              highlightModuleHeadlinePersonalized?: string | null;
              highlightModuleImageCaption?: string | null;
              highlightModuleBadge?: string | null;
              highlightModuleBadgePersonalized?: string | null;
              highlightModuleSubheadline?: string | null;
              highlightModuleSubheadlinePersonalized?: string | null;
              highlightModuleCopy?: string | null;
              highlightModuleCopyPersonalized?: string | null;
              highlightModuleCopy2?: string | null;
              highlightModuleCopy2Personalized?: string | null;
              salesCampaignSpecificModels: Array<{
                  __typename?: 'SalesCampaignModel';
                  id: string;
                  name: string;
                  mobileId: string;
                  leasingHeadline?: string | null;
                  leasingSubheadline?: string | null;
                  cashPriceHeadline?: string | null;
                  cashPriceSubheadline?: string | null;
                  financingHeadline?: string | null;
                  financingSubheadline?: string | null;
                  contentHeadline?: string | null;
                  contentCopy?: string | null;
                  imageCaption?: string | null;
                  contentImageCaption?: string | null;
                  disableEnvkvDataTeaser?: boolean | null;
                  deepLinkUtmCreativeValue?: string | null;
                  nationalLeasingRate?: string | null;
                  nationalLeasingSpecialPayment?: string | null;
                  nationalDuration?: string | null;
                  nationalTotalMileage?: string | null;
                  nationalPricesDisclaimer?: string | null;
                  nationalPricingType: CampaignPricingType;
                  nationalCashPrice?: string | null;
                  cashPriceCopy?: string | null;
                  nationalMonthlyRate?: string | null;
                  nationalFinalRate?: string | null;
                  nationalFixedDebitRate?: string | null;
                  nationalEffectiveAnnualRate?: string | null;
                  nationalDownPaymentFinance?: string | null;
                  nationalTotalAmount?: string | null;
                  nationalNetLoanAmount?: string | null;
                  nationalVehiclePriceFinance?: string | null;
                  offerImageCaption?: string | null;
                  highlightBadgePrefix?: string | null;
                  highlightBadgePrefixDealer?: string | null;
                  highlightBadgeValue?: string | null;
                  highlightBadgeUnit?: string | null;
                  highlightBadgeKurztext?: string | null;
                  contentImage?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
                  image: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  };
                  bankCodes: Array<{ __typename?: 'BankCode'; code?: string | null; footnoteContent?: string | null }>;
                  keyFact1?: { __typename?: 'KeyFact'; label: string; value: string; unit: string } | null;
                  keyFact2?: { __typename?: 'KeyFact'; label: string; value: string; unit: string } | null;
                  envkvDataSource?:
                      | {
                            __typename: 'Model';
                            msrLink?: string | null;
                            name: string;
                            slug: string;
                            formIdentifier?: string | null;
                            vehicleMarketFilterParams?: string | null;
                            disableTestdrive?: boolean | null;
                            co2ClassText: string;
                            envkv?:
                                | {
                                      __typename: 'EnVkvElektro';
                                      consumptionCombined: string;
                                      co2Combined: string;
                                      rangeElectric: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | {
                                      __typename: 'EnVkvPlugInHybrid';
                                      consumptionCombinedLitres: string;
                                      consumptionCombinedElectric: string;
                                      co2Combined: string;
                                      consumptionCombinedDischargedBattery: string;
                                      co2CombinedDischargedBattery: string;
                                      co2ClassDischargedBattery: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | {
                                      __typename: 'EnVkvVerbrennerHybrid';
                                      co2Combined: string;
                                      consumptionCombined: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | {
                                      __typename: 'EnVkvWasserstoff';
                                      energyCombined: string;
                                      co2Combined: string;
                                      range: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | null;
                        }
                      | {
                            __typename: 'Vehicle';
                            co2Class: Co2Class;
                            trim: string;
                            powerPs?: number | null;
                            powerKw?: number | null;
                            version?: string | null;
                            trimAndEnvkvString?: string | null;
                            fuelType?: FuelType | null;
                            model?: {
                                __typename?: 'Model';
                                name: string;
                                formIdentifier?: string | null;
                                slug: string;
                                vehicleMarketFilterParams?: string | null;
                                disableTestdrive?: boolean | null;
                            } | null;
                            envkv?:
                                | {
                                      __typename: 'EnVkvElektro';
                                      consumptionCombined: string;
                                      co2Combined: string;
                                      rangeElectric: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | {
                                      __typename: 'EnVkvPlugInHybrid';
                                      consumptionCombinedLitres: string;
                                      consumptionCombinedElectric: string;
                                      co2Combined: string;
                                      consumptionCombinedDischargedBattery: string;
                                      co2CombinedDischargedBattery: string;
                                      co2ClassDischargedBattery: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | {
                                      __typename: 'EnVkvVerbrennerHybrid';
                                      co2Combined: string;
                                      consumptionCombined: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | null;
                        }
                      | null;
                  envkvDataSourceTeaser?:
                      | {
                            __typename: 'Model';
                            msrLink?: string | null;
                            name: string;
                            slug: string;
                            formIdentifier?: string | null;
                            vehicleMarketFilterParams?: string | null;
                            disableTestdrive?: boolean | null;
                            co2ClassText: string;
                            envkv?:
                                | {
                                      __typename: 'EnVkvElektro';
                                      consumptionCombined: string;
                                      co2Combined: string;
                                      rangeElectric: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | {
                                      __typename: 'EnVkvPlugInHybrid';
                                      consumptionCombinedLitres: string;
                                      consumptionCombinedElectric: string;
                                      co2Combined: string;
                                      consumptionCombinedDischargedBattery: string;
                                      co2CombinedDischargedBattery: string;
                                      co2ClassDischargedBattery: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | {
                                      __typename: 'EnVkvVerbrennerHybrid';
                                      co2Combined: string;
                                      consumptionCombined: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | {
                                      __typename: 'EnVkvWasserstoff';
                                      energyCombined: string;
                                      co2Combined: string;
                                      range: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | null;
                        }
                      | {
                            __typename: 'Vehicle';
                            co2Class: Co2Class;
                            trim: string;
                            powerPs?: number | null;
                            powerKw?: number | null;
                            version?: string | null;
                            trimAndEnvkvString?: string | null;
                            fuelType?: FuelType | null;
                            model?: {
                                __typename?: 'Model';
                                name: string;
                                formIdentifier?: string | null;
                                slug: string;
                                vehicleMarketFilterParams?: string | null;
                                disableTestdrive?: boolean | null;
                            } | null;
                            envkv?:
                                | {
                                      __typename: 'EnVkvElektro';
                                      consumptionCombined: string;
                                      co2Combined: string;
                                      rangeElectric: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | {
                                      __typename: 'EnVkvPlugInHybrid';
                                      consumptionCombinedLitres: string;
                                      consumptionCombinedElectric: string;
                                      co2Combined: string;
                                      consumptionCombinedDischargedBattery: string;
                                      co2CombinedDischargedBattery: string;
                                      co2ClassDischargedBattery: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | {
                                      __typename: 'EnVkvVerbrennerHybrid';
                                      co2Combined: string;
                                      consumptionCombined: string;
                                      headline: string;
                                      additionalTransmissionPerformance?: string | null;
                                  }
                                | null;
                        }
                      | null;
                  nationalPriceFootnote?: { __typename?: 'Footnote'; id: string } | null;
                  nationalPriceFootnoteCash?: { __typename?: 'Footnote'; id: string } | null;
                  nationalPriceFootnoteFinance?: { __typename?: 'Footnote'; id: string } | null;
                  dealerPriceFootnoteLeasing?: {
                      __typename?: 'Footnote';
                      id: string;
                      content: { __typename?: 'RichText'; text: string };
                  } | null;
                  dealerPriceFootnoteCash?: {
                      __typename?: 'Footnote';
                      id: string;
                      content: { __typename?: 'RichText'; text: string };
                  } | null;
                  dealerPriceFootnoteFinance?: {
                      __typename?: 'Footnote';
                      id: string;
                      content: { __typename?: 'RichText'; text: string };
                  } | null;
                  offerImage?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
                  highlightBadgeUnitNationalFootnote?: { __typename?: 'Footnote'; id: string } | null;
                  highlightBadgeUnitDealerFootnote?: { __typename?: 'Footnote'; id: string } | null;
                  model?: {
                      __typename?: 'Model';
                      slug: string;
                      formIdentifier?: string | null;
                      vehicleMarketFilterParams?: string | null;
                      disableTestdrive?: boolean | null;
                  } | null;
              }>;
              warrantyLogo1?: {
                  __typename?: 'Asset';
                  url: string;
                  width?: number | null;
                  height?: number | null;
                  alt?: string | null;
              } | null;
              warrantyLogo2?: {
                  __typename?: 'Asset';
                  url: string;
                  width?: number | null;
                  height?: number | null;
                  alt?: string | null;
              } | null;
              warrantyLogo3?: {
                  __typename?: 'Asset';
                  url: string;
                  width?: number | null;
                  height?: number | null;
                  alt?: string | null;
              } | null;
              highlightModuleAsset?: {
                  __typename?: 'Asset';
                  url: string;
                  width?: number | null;
                  height?: number | null;
                  alt?: string | null;
              } | null;
          }
        | null;
    utmMapping: Array<{ __typename?: 'UtmMapping'; utmTerm?: string | null; mappingValue?: string | null }>;
    heroImage: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    };
};

export type SalesCampaignContentFragmentFragment = {
    __typename?: 'SalesCampaignContent';
    isBusinessCampaign?: boolean | null;
    minimumShortTitle: string;
    testdriveUrlOverride?: string | null;
    offerformUrlOverride?: string | null;
    highlightBannerHeadline?: string | null;
    highlightBannerHeadlinePersonalized?: string | null;
    highlightBannerSubheadline?: string | null;
    highlightBannerSubheadlinePersonalized?: string | null;
    highlightModuleHeadline?: string | null;
    highlightModuleHeadlinePersonalized?: string | null;
    highlightModuleImageCaption?: string | null;
    highlightModuleBadge?: string | null;
    highlightModuleBadgePersonalized?: string | null;
    highlightModuleSubheadline?: string | null;
    highlightModuleSubheadlinePersonalized?: string | null;
    highlightModuleCopy?: string | null;
    highlightModuleCopyPersonalized?: string | null;
    highlightModuleCopy2?: string | null;
    highlightModuleCopy2Personalized?: string | null;
    salesCampaignSpecificModels: Array<{
        __typename?: 'SalesCampaignModel';
        id: string;
        name: string;
        mobileId: string;
        leasingHeadline?: string | null;
        leasingSubheadline?: string | null;
        cashPriceHeadline?: string | null;
        cashPriceSubheadline?: string | null;
        financingHeadline?: string | null;
        financingSubheadline?: string | null;
        contentHeadline?: string | null;
        contentCopy?: string | null;
        imageCaption?: string | null;
        contentImageCaption?: string | null;
        disableEnvkvDataTeaser?: boolean | null;
        deepLinkUtmCreativeValue?: string | null;
        nationalLeasingRate?: string | null;
        nationalLeasingSpecialPayment?: string | null;
        nationalDuration?: string | null;
        nationalTotalMileage?: string | null;
        nationalPricesDisclaimer?: string | null;
        nationalPricingType: CampaignPricingType;
        nationalCashPrice?: string | null;
        cashPriceCopy?: string | null;
        nationalMonthlyRate?: string | null;
        nationalFinalRate?: string | null;
        nationalFixedDebitRate?: string | null;
        nationalEffectiveAnnualRate?: string | null;
        nationalDownPaymentFinance?: string | null;
        nationalTotalAmount?: string | null;
        nationalNetLoanAmount?: string | null;
        nationalVehiclePriceFinance?: string | null;
        offerImageCaption?: string | null;
        highlightBadgePrefix?: string | null;
        highlightBadgePrefixDealer?: string | null;
        highlightBadgeValue?: string | null;
        highlightBadgeUnit?: string | null;
        highlightBadgeKurztext?: string | null;
        contentImage?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        image: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        };
        bankCodes: Array<{ __typename?: 'BankCode'; code?: string | null; footnoteContent?: string | null }>;
        keyFact1?: { __typename?: 'KeyFact'; label: string; value: string; unit: string } | null;
        keyFact2?: { __typename?: 'KeyFact'; label: string; value: string; unit: string } | null;
        envkvDataSource?:
            | {
                  __typename: 'Model';
                  msrLink?: string | null;
                  name: string;
                  slug: string;
                  formIdentifier?: string | null;
                  vehicleMarketFilterParams?: string | null;
                  disableTestdrive?: boolean | null;
                  co2ClassText: string;
                  envkv?:
                      | {
                            __typename: 'EnVkvElektro';
                            consumptionCombined: string;
                            co2Combined: string;
                            rangeElectric: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | {
                            __typename: 'EnVkvPlugInHybrid';
                            consumptionCombinedLitres: string;
                            consumptionCombinedElectric: string;
                            co2Combined: string;
                            consumptionCombinedDischargedBattery: string;
                            co2CombinedDischargedBattery: string;
                            co2ClassDischargedBattery: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | {
                            __typename: 'EnVkvVerbrennerHybrid';
                            co2Combined: string;
                            consumptionCombined: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | {
                            __typename: 'EnVkvWasserstoff';
                            energyCombined: string;
                            co2Combined: string;
                            range: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | null;
              }
            | {
                  __typename: 'Vehicle';
                  co2Class: Co2Class;
                  trim: string;
                  powerPs?: number | null;
                  powerKw?: number | null;
                  version?: string | null;
                  trimAndEnvkvString?: string | null;
                  fuelType?: FuelType | null;
                  model?: {
                      __typename?: 'Model';
                      name: string;
                      formIdentifier?: string | null;
                      slug: string;
                      vehicleMarketFilterParams?: string | null;
                      disableTestdrive?: boolean | null;
                  } | null;
                  envkv?:
                      | {
                            __typename: 'EnVkvElektro';
                            consumptionCombined: string;
                            co2Combined: string;
                            rangeElectric: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | {
                            __typename: 'EnVkvPlugInHybrid';
                            consumptionCombinedLitres: string;
                            consumptionCombinedElectric: string;
                            co2Combined: string;
                            consumptionCombinedDischargedBattery: string;
                            co2CombinedDischargedBattery: string;
                            co2ClassDischargedBattery: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | {
                            __typename: 'EnVkvVerbrennerHybrid';
                            co2Combined: string;
                            consumptionCombined: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | null;
              }
            | null;
        envkvDataSourceTeaser?:
            | {
                  __typename: 'Model';
                  msrLink?: string | null;
                  name: string;
                  slug: string;
                  formIdentifier?: string | null;
                  vehicleMarketFilterParams?: string | null;
                  disableTestdrive?: boolean | null;
                  co2ClassText: string;
                  envkv?:
                      | {
                            __typename: 'EnVkvElektro';
                            consumptionCombined: string;
                            co2Combined: string;
                            rangeElectric: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | {
                            __typename: 'EnVkvPlugInHybrid';
                            consumptionCombinedLitres: string;
                            consumptionCombinedElectric: string;
                            co2Combined: string;
                            consumptionCombinedDischargedBattery: string;
                            co2CombinedDischargedBattery: string;
                            co2ClassDischargedBattery: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | {
                            __typename: 'EnVkvVerbrennerHybrid';
                            co2Combined: string;
                            consumptionCombined: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | {
                            __typename: 'EnVkvWasserstoff';
                            energyCombined: string;
                            co2Combined: string;
                            range: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | null;
              }
            | {
                  __typename: 'Vehicle';
                  co2Class: Co2Class;
                  trim: string;
                  powerPs?: number | null;
                  powerKw?: number | null;
                  version?: string | null;
                  trimAndEnvkvString?: string | null;
                  fuelType?: FuelType | null;
                  model?: {
                      __typename?: 'Model';
                      name: string;
                      formIdentifier?: string | null;
                      slug: string;
                      vehicleMarketFilterParams?: string | null;
                      disableTestdrive?: boolean | null;
                  } | null;
                  envkv?:
                      | {
                            __typename: 'EnVkvElektro';
                            consumptionCombined: string;
                            co2Combined: string;
                            rangeElectric: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | {
                            __typename: 'EnVkvPlugInHybrid';
                            consumptionCombinedLitres: string;
                            consumptionCombinedElectric: string;
                            co2Combined: string;
                            consumptionCombinedDischargedBattery: string;
                            co2CombinedDischargedBattery: string;
                            co2ClassDischargedBattery: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | {
                            __typename: 'EnVkvVerbrennerHybrid';
                            co2Combined: string;
                            consumptionCombined: string;
                            headline: string;
                            additionalTransmissionPerformance?: string | null;
                        }
                      | null;
              }
            | null;
        nationalPriceFootnote?: { __typename?: 'Footnote'; id: string } | null;
        nationalPriceFootnoteCash?: { __typename?: 'Footnote'; id: string } | null;
        nationalPriceFootnoteFinance?: { __typename?: 'Footnote'; id: string } | null;
        dealerPriceFootnoteLeasing?: {
            __typename?: 'Footnote';
            id: string;
            content: { __typename?: 'RichText'; text: string };
        } | null;
        dealerPriceFootnoteCash?: {
            __typename?: 'Footnote';
            id: string;
            content: { __typename?: 'RichText'; text: string };
        } | null;
        dealerPriceFootnoteFinance?: {
            __typename?: 'Footnote';
            id: string;
            content: { __typename?: 'RichText'; text: string };
        } | null;
        offerImage?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        highlightBadgeUnitNationalFootnote?: { __typename?: 'Footnote'; id: string } | null;
        highlightBadgeUnitDealerFootnote?: { __typename?: 'Footnote'; id: string } | null;
        model?: {
            __typename?: 'Model';
            slug: string;
            formIdentifier?: string | null;
            vehicleMarketFilterParams?: string | null;
            disableTestdrive?: boolean | null;
        } | null;
    }>;
    warrantyLogo1?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    warrantyLogo2?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    warrantyLogo3?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    highlightModuleAsset?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
};

export type ModellAnkuendigungContentFragmentFragment = {
    __typename: 'ModellAnkuendigungContent';
    promotionInModellPalette?: boolean | null;
    minimumShortTitle: string;
    warrantyLogo1?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    warrantyLogo2?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    warrantyLogo3?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
};

export type AfterSalesContentFragmentFragment = {
    __typename: 'AfterSale';
    id: string;
    minimumShortTitle: string;
    afterSalesServices: Array<{
        __typename?: 'CampaignAfterSalesService';
        id: string;
        title?: string | null;
        serviceId?: string | null;
        longDescription?: string | null;
        shortDescription?: string | null;
        trackingName?: string | null;
        serviceCheckout: boolean;
        bulletlist: Array<{ __typename?: 'IconText'; text: string }>;
        icon?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        image?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        footnote?: { __typename?: 'Footnote'; id: string } | null;
    }>;
    afterSalesAccesories: Array<{
        __typename?: 'CampaignAfterSalesAccesory';
        id: string;
        title?: string | null;
        articleNumber?: string | null;
        shopSearchTerm?: string | null;
        accesoryId?: string | null;
        longDescription?: string | null;
        shortDescription?: string | null;
        utmCreativeFormatParam?: string | null;
        mailToLink?: string | null;
        highlightTeaserImage?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        bulletlist: Array<{ __typename?: 'IconText'; text: string }>;
        icon?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        image?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        footnote?: { __typename?: 'Footnote'; id: string } | null;
    }>;
};

export type AfterSalesServiceFragmentFragment = {
    __typename?: 'CampaignAfterSalesService';
    id: string;
    title?: string | null;
    serviceId?: string | null;
    longDescription?: string | null;
    shortDescription?: string | null;
    trackingName?: string | null;
    serviceCheckout: boolean;
    bulletlist: Array<{ __typename?: 'IconText'; text: string }>;
    icon?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    image?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    footnote?: { __typename?: 'Footnote'; id: string } | null;
};

export type AfterSalesAccesoryFragmentFragment = {
    __typename?: 'CampaignAfterSalesAccesory';
    id: string;
    title?: string | null;
    articleNumber?: string | null;
    shopSearchTerm?: string | null;
    accesoryId?: string | null;
    longDescription?: string | null;
    shortDescription?: string | null;
    utmCreativeFormatParam?: string | null;
    mailToLink?: string | null;
    highlightTeaserImage?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    bulletlist: Array<{ __typename?: 'IconText'; text: string }>;
    icon?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    image?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    footnote?: { __typename?: 'Footnote'; id: string } | null;
};

export type SalesCampaignModelFragmentFragment = {
    __typename?: 'SalesCampaignModel';
    id: string;
    name: string;
    mobileId: string;
    leasingHeadline?: string | null;
    leasingSubheadline?: string | null;
    cashPriceHeadline?: string | null;
    cashPriceSubheadline?: string | null;
    financingHeadline?: string | null;
    financingSubheadline?: string | null;
    contentHeadline?: string | null;
    contentCopy?: string | null;
    imageCaption?: string | null;
    contentImageCaption?: string | null;
    disableEnvkvDataTeaser?: boolean | null;
    deepLinkUtmCreativeValue?: string | null;
    nationalLeasingRate?: string | null;
    nationalLeasingSpecialPayment?: string | null;
    nationalDuration?: string | null;
    nationalTotalMileage?: string | null;
    nationalPricesDisclaimer?: string | null;
    nationalPricingType: CampaignPricingType;
    nationalCashPrice?: string | null;
    cashPriceCopy?: string | null;
    nationalMonthlyRate?: string | null;
    nationalFinalRate?: string | null;
    nationalFixedDebitRate?: string | null;
    nationalEffectiveAnnualRate?: string | null;
    nationalDownPaymentFinance?: string | null;
    nationalTotalAmount?: string | null;
    nationalNetLoanAmount?: string | null;
    nationalVehiclePriceFinance?: string | null;
    offerImageCaption?: string | null;
    highlightBadgePrefix?: string | null;
    highlightBadgePrefixDealer?: string | null;
    highlightBadgeValue?: string | null;
    highlightBadgeUnit?: string | null;
    highlightBadgeKurztext?: string | null;
    contentImage?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    image: { __typename?: 'Asset'; url: string; width?: number | null; height?: number | null; alt?: string | null };
    bankCodes: Array<{ __typename?: 'BankCode'; code?: string | null; footnoteContent?: string | null }>;
    keyFact1?: { __typename?: 'KeyFact'; label: string; value: string; unit: string } | null;
    keyFact2?: { __typename?: 'KeyFact'; label: string; value: string; unit: string } | null;
    envkvDataSource?:
        | {
              __typename: 'Model';
              msrLink?: string | null;
              name: string;
              slug: string;
              formIdentifier?: string | null;
              vehicleMarketFilterParams?: string | null;
              disableTestdrive?: boolean | null;
              co2ClassText: string;
              envkv?:
                  | {
                        __typename: 'EnVkvElektro';
                        consumptionCombined: string;
                        co2Combined: string;
                        rangeElectric: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | {
                        __typename: 'EnVkvPlugInHybrid';
                        consumptionCombinedLitres: string;
                        consumptionCombinedElectric: string;
                        co2Combined: string;
                        consumptionCombinedDischargedBattery: string;
                        co2CombinedDischargedBattery: string;
                        co2ClassDischargedBattery: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | {
                        __typename: 'EnVkvVerbrennerHybrid';
                        co2Combined: string;
                        consumptionCombined: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | {
                        __typename: 'EnVkvWasserstoff';
                        energyCombined: string;
                        co2Combined: string;
                        range: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | null;
          }
        | {
              __typename: 'Vehicle';
              co2Class: Co2Class;
              trim: string;
              powerPs?: number | null;
              powerKw?: number | null;
              version?: string | null;
              trimAndEnvkvString?: string | null;
              fuelType?: FuelType | null;
              model?: {
                  __typename?: 'Model';
                  name: string;
                  formIdentifier?: string | null;
                  slug: string;
                  vehicleMarketFilterParams?: string | null;
                  disableTestdrive?: boolean | null;
              } | null;
              envkv?:
                  | {
                        __typename: 'EnVkvElektro';
                        consumptionCombined: string;
                        co2Combined: string;
                        rangeElectric: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | {
                        __typename: 'EnVkvPlugInHybrid';
                        consumptionCombinedLitres: string;
                        consumptionCombinedElectric: string;
                        co2Combined: string;
                        consumptionCombinedDischargedBattery: string;
                        co2CombinedDischargedBattery: string;
                        co2ClassDischargedBattery: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | {
                        __typename: 'EnVkvVerbrennerHybrid';
                        co2Combined: string;
                        consumptionCombined: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | null;
          }
        | null;
    envkvDataSourceTeaser?:
        | {
              __typename: 'Model';
              msrLink?: string | null;
              name: string;
              slug: string;
              formIdentifier?: string | null;
              vehicleMarketFilterParams?: string | null;
              disableTestdrive?: boolean | null;
              co2ClassText: string;
              envkv?:
                  | {
                        __typename: 'EnVkvElektro';
                        consumptionCombined: string;
                        co2Combined: string;
                        rangeElectric: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | {
                        __typename: 'EnVkvPlugInHybrid';
                        consumptionCombinedLitres: string;
                        consumptionCombinedElectric: string;
                        co2Combined: string;
                        consumptionCombinedDischargedBattery: string;
                        co2CombinedDischargedBattery: string;
                        co2ClassDischargedBattery: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | {
                        __typename: 'EnVkvVerbrennerHybrid';
                        co2Combined: string;
                        consumptionCombined: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | {
                        __typename: 'EnVkvWasserstoff';
                        energyCombined: string;
                        co2Combined: string;
                        range: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | null;
          }
        | {
              __typename: 'Vehicle';
              co2Class: Co2Class;
              trim: string;
              powerPs?: number | null;
              powerKw?: number | null;
              version?: string | null;
              trimAndEnvkvString?: string | null;
              fuelType?: FuelType | null;
              model?: {
                  __typename?: 'Model';
                  name: string;
                  formIdentifier?: string | null;
                  slug: string;
                  vehicleMarketFilterParams?: string | null;
                  disableTestdrive?: boolean | null;
              } | null;
              envkv?:
                  | {
                        __typename: 'EnVkvElektro';
                        consumptionCombined: string;
                        co2Combined: string;
                        rangeElectric: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | {
                        __typename: 'EnVkvPlugInHybrid';
                        consumptionCombinedLitres: string;
                        consumptionCombinedElectric: string;
                        co2Combined: string;
                        consumptionCombinedDischargedBattery: string;
                        co2CombinedDischargedBattery: string;
                        co2ClassDischargedBattery: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | {
                        __typename: 'EnVkvVerbrennerHybrid';
                        co2Combined: string;
                        consumptionCombined: string;
                        headline: string;
                        additionalTransmissionPerformance?: string | null;
                    }
                  | null;
          }
        | null;
    nationalPriceFootnote?: { __typename?: 'Footnote'; id: string } | null;
    nationalPriceFootnoteCash?: { __typename?: 'Footnote'; id: string } | null;
    nationalPriceFootnoteFinance?: { __typename?: 'Footnote'; id: string } | null;
    dealerPriceFootnoteLeasing?: {
        __typename?: 'Footnote';
        id: string;
        content: { __typename?: 'RichText'; text: string };
    } | null;
    dealerPriceFootnoteCash?: {
        __typename?: 'Footnote';
        id: string;
        content: { __typename?: 'RichText'; text: string };
    } | null;
    dealerPriceFootnoteFinance?: {
        __typename?: 'Footnote';
        id: string;
        content: { __typename?: 'RichText'; text: string };
    } | null;
    offerImage?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    highlightBadgeUnitNationalFootnote?: { __typename?: 'Footnote'; id: string } | null;
    highlightBadgeUnitDealerFootnote?: { __typename?: 'Footnote'; id: string } | null;
    model?: {
        __typename?: 'Model';
        slug: string;
        formIdentifier?: string | null;
        vehicleMarketFilterParams?: string | null;
        disableTestdrive?: boolean | null;
    } | null;
};

export type SalesCampaignModelOnlyModelFragmentFragment = {
    __typename?: 'SalesCampaignModel';
    id: string;
    modelCode?: string | null;
};

export type HomeCampaignQueryVariables = Exact<{
    dealerId: Scalars['String']['input'];
}>;

export type HomeCampaignQuery = {
    __typename?: 'Query';
    dealer?: {
        __typename?: 'Dealer';
        campaignsRegular: Array<{
            __typename?: 'Campaign';
            id: string;
            slug: string;
            teaserCopy?: string | null;
            teaserHeadline: string;
            startDate?: unknown | null;
            title: string;
            endDate?: unknown | null;
            heroImageCaption?: string | null;
            heroImage: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            };
            modelForAnnouncement?: {
                __typename?: 'Model';
                slug: string;
                co2Class: string;
                name: string;
                envkv?:
                    | {
                          __typename: 'EnVkvElektro';
                          consumptionCombined: string;
                          co2Combined: string;
                          rangeElectric: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvPlugInHybrid';
                          consumptionCombinedLitres: string;
                          consumptionCombinedElectric: string;
                          co2Combined: string;
                          consumptionCombinedDischargedBattery: string;
                          co2CombinedDischargedBattery: string;
                          co2ClassDischargedBattery: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvVerbrennerHybrid';
                          co2Combined: string;
                          consumptionCombined: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvWasserstoff';
                          energyCombined: string;
                          co2Combined: string;
                          range: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | null;
            } | null;
            content?:
                | { __typename: 'AfterSale'; minimumShortTitle: string }
                | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
                | {
                      __typename: 'SalesCampaignContent';
                      isBusinessCampaign?: boolean | null;
                      highlightBannerHeadline?: string | null;
                      highlightBannerHeadlinePersonalized?: string | null;
                      highlightBannerSubheadline?: string | null;
                      highlightBannerSubheadlinePersonalized?: string | null;
                      minimumShortTitle: string;
                  }
                | null;
        }>;
        campaignKey?: {
            __typename?: 'Campaign';
            id: string;
            slug: string;
            teaserCopy?: string | null;
            teaserHeadline: string;
            startDate?: unknown | null;
            title: string;
            endDate?: unknown | null;
            heroImageCaption?: string | null;
            heroImage: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            };
            modelForAnnouncement?: {
                __typename?: 'Model';
                slug: string;
                co2Class: string;
                name: string;
                envkv?:
                    | {
                          __typename: 'EnVkvElektro';
                          consumptionCombined: string;
                          co2Combined: string;
                          rangeElectric: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvPlugInHybrid';
                          consumptionCombinedLitres: string;
                          consumptionCombinedElectric: string;
                          co2Combined: string;
                          consumptionCombinedDischargedBattery: string;
                          co2CombinedDischargedBattery: string;
                          co2ClassDischargedBattery: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvVerbrennerHybrid';
                          co2Combined: string;
                          consumptionCombined: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvWasserstoff';
                          energyCombined: string;
                          co2Combined: string;
                          range: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | null;
            } | null;
            content?:
                | { __typename: 'AfterSale'; minimumShortTitle: string }
                | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
                | {
                      __typename: 'SalesCampaignContent';
                      isBusinessCampaign?: boolean | null;
                      highlightBannerHeadline?: string | null;
                      highlightBannerHeadlinePersonalized?: string | null;
                      highlightBannerSubheadline?: string | null;
                      highlightBannerSubheadlinePersonalized?: string | null;
                      minimumShortTitle: string;
                  }
                | null;
        } | null;
    } | null;
};

export type BusinessCustomerCampaignsQueryVariables = Exact<{
    dealerId: Scalars['String']['input'];
}>;

export type BusinessCustomerCampaignsQuery = {
    __typename?: 'Query';
    dealer?: {
        __typename?: 'Dealer';
        campaignsRegular: Array<{
            __typename?: 'Campaign';
            id: string;
            slug: string;
            teaserCopy?: string | null;
            teaserHeadline: string;
            startDate?: unknown | null;
            title: string;
            endDate?: unknown | null;
            heroImageCaption?: string | null;
            heroImage: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            };
            modelForAnnouncement?: {
                __typename?: 'Model';
                slug: string;
                co2Class: string;
                name: string;
                envkv?:
                    | {
                          __typename: 'EnVkvElektro';
                          consumptionCombined: string;
                          co2Combined: string;
                          rangeElectric: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvPlugInHybrid';
                          consumptionCombinedLitres: string;
                          consumptionCombinedElectric: string;
                          co2Combined: string;
                          consumptionCombinedDischargedBattery: string;
                          co2CombinedDischargedBattery: string;
                          co2ClassDischargedBattery: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvVerbrennerHybrid';
                          co2Combined: string;
                          consumptionCombined: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvWasserstoff';
                          energyCombined: string;
                          co2Combined: string;
                          range: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | null;
            } | null;
            content?:
                | { __typename: 'AfterSale'; minimumShortTitle: string }
                | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
                | {
                      __typename: 'SalesCampaignContent';
                      isBusinessCampaign?: boolean | null;
                      highlightBannerHeadline?: string | null;
                      highlightBannerHeadlinePersonalized?: string | null;
                      highlightBannerSubheadline?: string | null;
                      highlightBannerSubheadlinePersonalized?: string | null;
                      minimumShortTitle: string;
                  }
                | null;
        }>;
        campaignKey?: {
            __typename?: 'Campaign';
            id: string;
            slug: string;
            teaserCopy?: string | null;
            teaserHeadline: string;
            startDate?: unknown | null;
            title: string;
            endDate?: unknown | null;
            heroImageCaption?: string | null;
            heroImage: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            };
            modelForAnnouncement?: {
                __typename?: 'Model';
                slug: string;
                co2Class: string;
                name: string;
                envkv?:
                    | {
                          __typename: 'EnVkvElektro';
                          consumptionCombined: string;
                          co2Combined: string;
                          rangeElectric: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvPlugInHybrid';
                          consumptionCombinedLitres: string;
                          consumptionCombinedElectric: string;
                          co2Combined: string;
                          consumptionCombinedDischargedBattery: string;
                          co2CombinedDischargedBattery: string;
                          co2ClassDischargedBattery: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvVerbrennerHybrid';
                          co2Combined: string;
                          consumptionCombined: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvWasserstoff';
                          energyCombined: string;
                          co2Combined: string;
                          range: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | null;
            } | null;
            content?:
                | { __typename: 'AfterSale'; minimumShortTitle: string }
                | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
                | {
                      __typename: 'SalesCampaignContent';
                      isBusinessCampaign?: boolean | null;
                      highlightBannerHeadline?: string | null;
                      highlightBannerHeadlinePersonalized?: string | null;
                      highlightBannerSubheadline?: string | null;
                      highlightBannerSubheadlinePersonalized?: string | null;
                      minimumShortTitle: string;
                  }
                | null;
        } | null;
    } | null;
};

export type OverviewCampaignsQueryVariables = Exact<{
    dealerId: Scalars['String']['input'];
}>;

export type OverviewCampaignsQuery = {
    __typename?: 'Query';
    dealer?: {
        __typename?: 'Dealer';
        campaignsRegular: Array<{
            __typename?: 'Campaign';
            id: string;
            slug: string;
            teaserCopy?: string | null;
            teaserHeadline: string;
            startDate?: unknown | null;
            title: string;
            endDate?: unknown | null;
            heroImageCaption?: string | null;
            heroImage: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            };
            modelForAnnouncement?: {
                __typename?: 'Model';
                slug: string;
                co2Class: string;
                name: string;
                envkv?:
                    | {
                          __typename: 'EnVkvElektro';
                          consumptionCombined: string;
                          co2Combined: string;
                          rangeElectric: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvPlugInHybrid';
                          consumptionCombinedLitres: string;
                          consumptionCombinedElectric: string;
                          co2Combined: string;
                          consumptionCombinedDischargedBattery: string;
                          co2CombinedDischargedBattery: string;
                          co2ClassDischargedBattery: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvVerbrennerHybrid';
                          co2Combined: string;
                          consumptionCombined: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvWasserstoff';
                          energyCombined: string;
                          co2Combined: string;
                          range: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | null;
            } | null;
            content?:
                | { __typename: 'AfterSale'; minimumShortTitle: string }
                | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
                | {
                      __typename: 'SalesCampaignContent';
                      isBusinessCampaign?: boolean | null;
                      highlightBannerHeadline?: string | null;
                      highlightBannerHeadlinePersonalized?: string | null;
                      highlightBannerSubheadline?: string | null;
                      highlightBannerSubheadlinePersonalized?: string | null;
                      minimumShortTitle: string;
                  }
                | null;
        }>;
        campaignKey?: {
            __typename?: 'Campaign';
            id: string;
            slug: string;
            teaserCopy?: string | null;
            teaserHeadline: string;
            startDate?: unknown | null;
            title: string;
            endDate?: unknown | null;
            heroImageCaption?: string | null;
            heroImage: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            };
            modelForAnnouncement?: {
                __typename?: 'Model';
                slug: string;
                co2Class: string;
                name: string;
                envkv?:
                    | {
                          __typename: 'EnVkvElektro';
                          consumptionCombined: string;
                          co2Combined: string;
                          rangeElectric: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvPlugInHybrid';
                          consumptionCombinedLitres: string;
                          consumptionCombinedElectric: string;
                          co2Combined: string;
                          consumptionCombinedDischargedBattery: string;
                          co2CombinedDischargedBattery: string;
                          co2ClassDischargedBattery: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvVerbrennerHybrid';
                          co2Combined: string;
                          consumptionCombined: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvWasserstoff';
                          energyCombined: string;
                          co2Combined: string;
                          range: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | null;
            } | null;
            content?:
                | { __typename: 'AfterSale'; minimumShortTitle: string }
                | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
                | {
                      __typename: 'SalesCampaignContent';
                      isBusinessCampaign?: boolean | null;
                      highlightBannerHeadline?: string | null;
                      highlightBannerHeadlinePersonalized?: string | null;
                      highlightBannerSubheadline?: string | null;
                      highlightBannerSubheadlinePersonalized?: string | null;
                      minimumShortTitle: string;
                  }
                | null;
        } | null;
    } | null;
};

export type LatestAfterSalesCampaignQueryVariables = Exact<{
    dealerId: Scalars['String']['input'];
}>;

export type LatestAfterSalesCampaignQuery = {
    __typename?: 'Query';
    campaigns: Array<{
        __typename?: 'Campaign';
        id: string;
        content?:
            | {
                  __typename: 'AfterSale';
                  minimumShortTitle: string;
                  id: string;
                  afterSalesServices: Array<{
                      __typename?: 'CampaignAfterSalesService';
                      title?: string | null;
                      id: string;
                      shortDescription?: string | null;
                      longDescription?: string | null;
                      serviceId?: string | null;
                      trackingName?: string | null;
                      serviceCheckout: boolean;
                      bulletlist: Array<{ __typename?: 'IconText'; text: string }>;
                      icon?: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      } | null;
                      image?: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      } | null;
                      footnote?: { __typename?: 'Footnote'; id: string } | null;
                  }>;
              }
            | { __typename?: 'ModellAnkuendigungContent' }
            | { __typename?: 'SalesCampaignContent' }
            | null;
    }>;
};

export type OverviewTestCampaignsQueryVariables = Exact<{
    dealerId: Scalars['String']['input'];
}>;

export type OverviewTestCampaignsQuery = {
    __typename?: 'Query';
    dealer?: {
        __typename?: 'Dealer';
        campaignsRegular: Array<{
            __typename?: 'Campaign';
            id: string;
            slug: string;
            teaserCopy?: string | null;
            teaserHeadline: string;
            startDate?: unknown | null;
            title: string;
            endDate?: unknown | null;
            heroImageCaption?: string | null;
            heroImage: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            };
            modelForAnnouncement?: {
                __typename?: 'Model';
                slug: string;
                co2Class: string;
                name: string;
                envkv?:
                    | {
                          __typename: 'EnVkvElektro';
                          consumptionCombined: string;
                          co2Combined: string;
                          rangeElectric: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvPlugInHybrid';
                          consumptionCombinedLitres: string;
                          consumptionCombinedElectric: string;
                          co2Combined: string;
                          consumptionCombinedDischargedBattery: string;
                          co2CombinedDischargedBattery: string;
                          co2ClassDischargedBattery: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvVerbrennerHybrid';
                          co2Combined: string;
                          consumptionCombined: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvWasserstoff';
                          energyCombined: string;
                          co2Combined: string;
                          range: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | null;
            } | null;
            content?:
                | { __typename: 'AfterSale'; minimumShortTitle: string }
                | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
                | {
                      __typename: 'SalesCampaignContent';
                      isBusinessCampaign?: boolean | null;
                      highlightBannerHeadline?: string | null;
                      highlightBannerHeadlinePersonalized?: string | null;
                      highlightBannerSubheadline?: string | null;
                      highlightBannerSubheadlinePersonalized?: string | null;
                      minimumShortTitle: string;
                  }
                | null;
        }>;
        campaignKey?: {
            __typename?: 'Campaign';
            id: string;
            slug: string;
            teaserCopy?: string | null;
            teaserHeadline: string;
            startDate?: unknown | null;
            title: string;
            endDate?: unknown | null;
            heroImageCaption?: string | null;
            heroImage: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            };
            modelForAnnouncement?: {
                __typename?: 'Model';
                slug: string;
                co2Class: string;
                name: string;
                envkv?:
                    | {
                          __typename: 'EnVkvElektro';
                          consumptionCombined: string;
                          co2Combined: string;
                          rangeElectric: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvPlugInHybrid';
                          consumptionCombinedLitres: string;
                          consumptionCombinedElectric: string;
                          co2Combined: string;
                          consumptionCombinedDischargedBattery: string;
                          co2CombinedDischargedBattery: string;
                          co2ClassDischargedBattery: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvVerbrennerHybrid';
                          co2Combined: string;
                          consumptionCombined: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | {
                          __typename: 'EnVkvWasserstoff';
                          energyCombined: string;
                          co2Combined: string;
                          range: string;
                          headline: string;
                          additionalTransmissionPerformance?: string | null;
                      }
                    | null;
            } | null;
            content?:
                | { __typename: 'AfterSale'; minimumShortTitle: string }
                | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
                | {
                      __typename: 'SalesCampaignContent';
                      isBusinessCampaign?: boolean | null;
                      highlightBannerHeadline?: string | null;
                      highlightBannerHeadlinePersonalized?: string | null;
                      highlightBannerSubheadline?: string | null;
                      highlightBannerSubheadlinePersonalized?: string | null;
                      minimumShortTitle: string;
                  }
                | null;
        } | null;
    } | null;
};

export type CampaignDetailQueryVariables = Exact<{
    dealerId: Scalars['String']['input'];
    slug: Scalars['String']['input'];
}>;

export type CampaignDetailQuery = {
    __typename?: 'Query';
    campaigns: Array<{
        __typename?: 'Campaign';
        heroHeadline?: string | null;
        legalLines?: string | null;
        kmpCode?: string | null;
        metaDescriptionOverride?: string | null;
        id: string;
        slug: string;
        teaserCopy?: string | null;
        teaserHeadline: string;
        startDate?: unknown | null;
        title: string;
        endDate?: unknown | null;
        heroImageCaption?: string | null;
        modelForAnnouncement?: {
            __typename?: 'Model';
            slug: string;
            co2Class: string;
            name: string;
            categories: Array<ModelCategory>;
            msrLink?: string | null;
            contentHeadline?: string | null;
            cwModelUrl?: string | null;
            formModelId: string;
            formGenerationId: string;
            formBodyId: string;
            envkv?:
                | {
                      __typename: 'EnVkvElektro';
                      consumptionCombined: string;
                      co2Combined: string;
                      rangeElectric: string;
                      headline: string;
                      additionalTransmissionPerformance?: string | null;
                  }
                | {
                      __typename: 'EnVkvPlugInHybrid';
                      consumptionCombinedLitres: string;
                      consumptionCombinedElectric: string;
                      co2Combined: string;
                      consumptionCombinedDischargedBattery: string;
                      co2CombinedDischargedBattery: string;
                      co2ClassDischargedBattery: string;
                      headline: string;
                      additionalTransmissionPerformance?: string | null;
                  }
                | {
                      __typename: 'EnVkvVerbrennerHybrid';
                      co2Combined: string;
                      consumptionCombined: string;
                      headline: string;
                      additionalTransmissionPerformance?: string | null;
                  }
                | {
                      __typename: 'EnVkvWasserstoff';
                      energyCombined: string;
                      co2Combined: string;
                      range: string;
                      headline: string;
                      additionalTransmissionPerformance?: string | null;
                  }
                | null;
            heroImage: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            };
            logoImages: Array<{
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            }>;
            contentImages: Array<{
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            }>;
            contentCopy?: { __typename?: 'RichText'; html: string } | null;
            keyFacts: Array<{ __typename?: 'KeyFact'; label: string; value: string; unit: string }>;
            legalTexts?: { __typename?: 'RichText'; html: string } | null;
        } | null;
        models: Array<{
            __typename?: 'Model';
            id: string;
            name: string;
            publishedAt?: string | null;
            contentHeadline?: string | null;
            formGenerationId: string;
            formBodyId: string;
            legalTexts?: { __typename?: 'RichText'; html: string } | null;
        }>;
        content?:
            | {
                  __typename: 'AfterSale';
                  minimumShortTitle: string;
                  id: string;
                  afterSalesServices: Array<{
                      __typename?: 'CampaignAfterSalesService';
                      id: string;
                      title?: string | null;
                      serviceId?: string | null;
                      longDescription?: string | null;
                      shortDescription?: string | null;
                      trackingName?: string | null;
                      serviceCheckout: boolean;
                      bulletlist: Array<{ __typename?: 'IconText'; text: string }>;
                      icon?: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      } | null;
                      image?: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      } | null;
                      footnote?: { __typename?: 'Footnote'; id: string } | null;
                  }>;
                  afterSalesAccesories: Array<{
                      __typename?: 'CampaignAfterSalesAccesory';
                      id: string;
                      title?: string | null;
                      articleNumber?: string | null;
                      shopSearchTerm?: string | null;
                      accesoryId?: string | null;
                      longDescription?: string | null;
                      shortDescription?: string | null;
                      utmCreativeFormatParam?: string | null;
                      mailToLink?: string | null;
                      highlightTeaserImage?: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      } | null;
                      bulletlist: Array<{ __typename?: 'IconText'; text: string }>;
                      icon?: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      } | null;
                      image?: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      } | null;
                      footnote?: { __typename?: 'Footnote'; id: string } | null;
                  }>;
              }
            | {
                  __typename: 'ModellAnkuendigungContent';
                  minimumShortTitle: string;
                  promotionInModellPalette?: boolean | null;
                  warrantyLogo1?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
                  warrantyLogo2?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
                  warrantyLogo3?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
              }
            | {
                  __typename: 'SalesCampaignContent';
                  isBusinessCampaign?: boolean | null;
                  highlightBannerHeadline?: string | null;
                  highlightBannerHeadlinePersonalized?: string | null;
                  highlightBannerSubheadline?: string | null;
                  highlightBannerSubheadlinePersonalized?: string | null;
                  minimumShortTitle: string;
                  testdriveUrlOverride?: string | null;
                  offerformUrlOverride?: string | null;
                  highlightModuleHeadline?: string | null;
                  highlightModuleHeadlinePersonalized?: string | null;
                  highlightModuleImageCaption?: string | null;
                  highlightModuleBadge?: string | null;
                  highlightModuleBadgePersonalized?: string | null;
                  highlightModuleSubheadline?: string | null;
                  highlightModuleSubheadlinePersonalized?: string | null;
                  highlightModuleCopy?: string | null;
                  highlightModuleCopyPersonalized?: string | null;
                  highlightModuleCopy2?: string | null;
                  highlightModuleCopy2Personalized?: string | null;
                  salesCampaignSpecificModels: Array<{
                      __typename?: 'SalesCampaignModel';
                      id: string;
                      name: string;
                      mobileId: string;
                      leasingHeadline?: string | null;
                      leasingSubheadline?: string | null;
                      cashPriceHeadline?: string | null;
                      cashPriceSubheadline?: string | null;
                      financingHeadline?: string | null;
                      financingSubheadline?: string | null;
                      contentHeadline?: string | null;
                      contentCopy?: string | null;
                      imageCaption?: string | null;
                      contentImageCaption?: string | null;
                      disableEnvkvDataTeaser?: boolean | null;
                      deepLinkUtmCreativeValue?: string | null;
                      nationalLeasingRate?: string | null;
                      nationalLeasingSpecialPayment?: string | null;
                      nationalDuration?: string | null;
                      nationalTotalMileage?: string | null;
                      nationalPricesDisclaimer?: string | null;
                      nationalPricingType: CampaignPricingType;
                      nationalCashPrice?: string | null;
                      cashPriceCopy?: string | null;
                      nationalMonthlyRate?: string | null;
                      nationalFinalRate?: string | null;
                      nationalFixedDebitRate?: string | null;
                      nationalEffectiveAnnualRate?: string | null;
                      nationalDownPaymentFinance?: string | null;
                      nationalTotalAmount?: string | null;
                      nationalNetLoanAmount?: string | null;
                      nationalVehiclePriceFinance?: string | null;
                      offerImageCaption?: string | null;
                      highlightBadgePrefix?: string | null;
                      highlightBadgePrefixDealer?: string | null;
                      highlightBadgeValue?: string | null;
                      highlightBadgeUnit?: string | null;
                      highlightBadgeKurztext?: string | null;
                      contentImage?: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      } | null;
                      image: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      };
                      bankCodes: Array<{
                          __typename?: 'BankCode';
                          code?: string | null;
                          footnoteContent?: string | null;
                      }>;
                      keyFact1?: { __typename?: 'KeyFact'; label: string; value: string; unit: string } | null;
                      keyFact2?: { __typename?: 'KeyFact'; label: string; value: string; unit: string } | null;
                      envkvDataSource?:
                          | {
                                __typename: 'Model';
                                msrLink?: string | null;
                                name: string;
                                slug: string;
                                formIdentifier?: string | null;
                                vehicleMarketFilterParams?: string | null;
                                disableTestdrive?: boolean | null;
                                co2ClassText: string;
                                envkv?:
                                    | {
                                          __typename: 'EnVkvElektro';
                                          consumptionCombined: string;
                                          co2Combined: string;
                                          rangeElectric: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | {
                                          __typename: 'EnVkvPlugInHybrid';
                                          consumptionCombinedLitres: string;
                                          consumptionCombinedElectric: string;
                                          co2Combined: string;
                                          consumptionCombinedDischargedBattery: string;
                                          co2CombinedDischargedBattery: string;
                                          co2ClassDischargedBattery: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | {
                                          __typename: 'EnVkvVerbrennerHybrid';
                                          co2Combined: string;
                                          consumptionCombined: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | {
                                          __typename: 'EnVkvWasserstoff';
                                          energyCombined: string;
                                          co2Combined: string;
                                          range: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | null;
                            }
                          | {
                                __typename: 'Vehicle';
                                co2Class: Co2Class;
                                trim: string;
                                powerPs?: number | null;
                                powerKw?: number | null;
                                version?: string | null;
                                trimAndEnvkvString?: string | null;
                                fuelType?: FuelType | null;
                                model?: {
                                    __typename?: 'Model';
                                    name: string;
                                    formIdentifier?: string | null;
                                    slug: string;
                                    vehicleMarketFilterParams?: string | null;
                                    disableTestdrive?: boolean | null;
                                } | null;
                                envkv?:
                                    | {
                                          __typename: 'EnVkvElektro';
                                          consumptionCombined: string;
                                          co2Combined: string;
                                          rangeElectric: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | {
                                          __typename: 'EnVkvPlugInHybrid';
                                          consumptionCombinedLitres: string;
                                          consumptionCombinedElectric: string;
                                          co2Combined: string;
                                          consumptionCombinedDischargedBattery: string;
                                          co2CombinedDischargedBattery: string;
                                          co2ClassDischargedBattery: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | {
                                          __typename: 'EnVkvVerbrennerHybrid';
                                          co2Combined: string;
                                          consumptionCombined: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | null;
                            }
                          | null;
                      envkvDataSourceTeaser?:
                          | {
                                __typename: 'Model';
                                msrLink?: string | null;
                                name: string;
                                slug: string;
                                formIdentifier?: string | null;
                                vehicleMarketFilterParams?: string | null;
                                disableTestdrive?: boolean | null;
                                co2ClassText: string;
                                envkv?:
                                    | {
                                          __typename: 'EnVkvElektro';
                                          consumptionCombined: string;
                                          co2Combined: string;
                                          rangeElectric: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | {
                                          __typename: 'EnVkvPlugInHybrid';
                                          consumptionCombinedLitres: string;
                                          consumptionCombinedElectric: string;
                                          co2Combined: string;
                                          consumptionCombinedDischargedBattery: string;
                                          co2CombinedDischargedBattery: string;
                                          co2ClassDischargedBattery: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | {
                                          __typename: 'EnVkvVerbrennerHybrid';
                                          co2Combined: string;
                                          consumptionCombined: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | {
                                          __typename: 'EnVkvWasserstoff';
                                          energyCombined: string;
                                          co2Combined: string;
                                          range: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | null;
                            }
                          | {
                                __typename: 'Vehicle';
                                co2Class: Co2Class;
                                trim: string;
                                powerPs?: number | null;
                                powerKw?: number | null;
                                version?: string | null;
                                trimAndEnvkvString?: string | null;
                                fuelType?: FuelType | null;
                                model?: {
                                    __typename?: 'Model';
                                    name: string;
                                    formIdentifier?: string | null;
                                    slug: string;
                                    vehicleMarketFilterParams?: string | null;
                                    disableTestdrive?: boolean | null;
                                } | null;
                                envkv?:
                                    | {
                                          __typename: 'EnVkvElektro';
                                          consumptionCombined: string;
                                          co2Combined: string;
                                          rangeElectric: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | {
                                          __typename: 'EnVkvPlugInHybrid';
                                          consumptionCombinedLitres: string;
                                          consumptionCombinedElectric: string;
                                          co2Combined: string;
                                          consumptionCombinedDischargedBattery: string;
                                          co2CombinedDischargedBattery: string;
                                          co2ClassDischargedBattery: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | {
                                          __typename: 'EnVkvVerbrennerHybrid';
                                          co2Combined: string;
                                          consumptionCombined: string;
                                          headline: string;
                                          additionalTransmissionPerformance?: string | null;
                                      }
                                    | null;
                            }
                          | null;
                      nationalPriceFootnote?: { __typename?: 'Footnote'; id: string } | null;
                      nationalPriceFootnoteCash?: { __typename?: 'Footnote'; id: string } | null;
                      nationalPriceFootnoteFinance?: { __typename?: 'Footnote'; id: string } | null;
                      dealerPriceFootnoteLeasing?: {
                          __typename?: 'Footnote';
                          id: string;
                          content: { __typename?: 'RichText'; text: string };
                      } | null;
                      dealerPriceFootnoteCash?: {
                          __typename?: 'Footnote';
                          id: string;
                          content: { __typename?: 'RichText'; text: string };
                      } | null;
                      dealerPriceFootnoteFinance?: {
                          __typename?: 'Footnote';
                          id: string;
                          content: { __typename?: 'RichText'; text: string };
                      } | null;
                      offerImage?: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      } | null;
                      highlightBadgeUnitNationalFootnote?: { __typename?: 'Footnote'; id: string } | null;
                      highlightBadgeUnitDealerFootnote?: { __typename?: 'Footnote'; id: string } | null;
                      model?: {
                          __typename?: 'Model';
                          slug: string;
                          formIdentifier?: string | null;
                          vehicleMarketFilterParams?: string | null;
                          disableTestdrive?: boolean | null;
                      } | null;
                  }>;
                  warrantyLogo1?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
                  warrantyLogo2?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
                  warrantyLogo3?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
                  highlightModuleAsset?: {
                      __typename?: 'Asset';
                      url: string;
                      width?: number | null;
                      height?: number | null;
                      alt?: string | null;
                  } | null;
              }
            | null;
        utmMapping: Array<{ __typename?: 'UtmMapping'; utmTerm?: string | null; mappingValue?: string | null }>;
        heroImage: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        };
    }>;
};

export type CampaignIdByCodeQueryVariables = Exact<{
    importCode: Scalars['String']['input'];
}>;

export type CampaignIdByCodeQuery = {
    __typename?: 'Query';
    campaigns: Array<{
        __typename?: 'Campaign';
        id: string;
        content?:
            | { __typename: 'AfterSale' }
            | { __typename: 'ModellAnkuendigungContent' }
            | {
                  __typename: 'SalesCampaignContent';
                  salesCampaignSpecificModels: Array<{
                      __typename?: 'SalesCampaignModel';
                      id: string;
                      modelCode?: string | null;
                  }>;
              }
            | null;
    }>;
};

export type ModelIdByCodeQueryVariables = Exact<{
    modelCode: Scalars['String']['input'];
}>;

export type ModelIdByCodeQuery = { __typename?: 'Query'; model?: { __typename?: 'Model'; id: string } | null };

export type VehicleIdByCodeQueryVariables = Exact<{
    trimCode: Scalars['String']['input'];
}>;

export type VehicleIdByCodeQuery = { __typename?: 'Query'; vehicle?: { __typename?: 'Vehicle'; id: string } | null };

export type UpsertDealerMutationVariables = Exact<{
    dealerId: Scalars['String']['input'];
    dealer: DealerUpsertInput;
}>;

export type UpsertDealerMutation = {
    __typename?: 'Mutation';
    upsertDealer?: { __typename?: 'Dealer'; id: string; dealerId: string; name?: string | null } | null;
};

export type InsertDealerMutationVariables = Exact<{
    dealer: DealerCreateInput;
}>;

export type InsertDealerMutation = {
    __typename?: 'Mutation';
    createDealer?: { __typename?: 'Dealer'; id: string; dealerId: string; name?: string | null } | null;
};

export type UpdateDealerMutationVariables = Exact<{
    dealerId: Scalars['ID']['input'];
    dealer: DealerUpdateInput;
}>;

export type UpdateDealerMutation = {
    __typename?: 'Mutation';
    updateDealer?: { __typename?: 'Dealer'; id: string; dealerId: string; name?: string | null } | null;
};

export type AddParentDealerToDealerMutationVariables = Exact<{
    dealerId: Scalars['ID']['input'];
    parentDealerId: Scalars['ID']['input'];
}>;

export type AddParentDealerToDealerMutation = {
    __typename?: 'Mutation';
    updateDealer?: { __typename?: 'Dealer'; id: string; dealerId: string; name?: string | null } | null;
};

export type PublishDealersMutationVariables = Exact<{
    dealerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type PublishDealersMutation = {
    __typename?: 'Mutation';
    publishManyDealers: { __typename?: 'BatchPayload'; count: unknown };
};

export type OpeningFragment = {
    __typename?: 'Opening';
    from: Day;
    to: Day;
    ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
};

export type BaseDealerFieldsFragment = {
    __typename?: 'Dealer';
    dealerId: string;
    mobileSellerId?: string | null;
    sapId: string;
    dealerType: DealerType;
    name?: string | null;
    name2?: string | null;
    name3?: string | null;
    slug?: string | null;
    state: State;
    inseratMailRecipients: Array<string>;
    whatsappNumber?: string | null;
    socialFacebook?: string | null;
    socialInstagram?: string | null;
    socialX?: string | null;
    socialYouTube?: string | null;
    socialLinkedIn?: string | null;
    socialTikTok?: string | null;
    hPromise: boolean;
    partsStore: boolean;
    parentDealer?: { __typename?: 'Dealer'; dealerId: string; slug?: string | null; hasHws: boolean } | null;
    openingTimesService: Array<{
        __typename?: 'Opening';
        from: Day;
        to: Day;
        ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
    }>;
    openingTimesParts: Array<{
        __typename?: 'Opening';
        from: Day;
        to: Day;
        ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
    }>;
    openingTimesSales: Array<{
        __typename?: 'Opening';
        from: Day;
        to: Day;
        ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
    }>;
    contact?: { __typename?: 'Contact'; phone?: string | null; email?: string | null; fax?: string | null } | null;
    address?: {
        __typename?: 'Address';
        zip?: string | null;
        street?: string | null;
        city?: string | null;
        houseNumber?: string | null;
    } | null;
};

export type SubDealerFieldsFragment = {
    __typename?: 'Dealer';
    dealerId: string;
    mobileSellerId?: string | null;
    sapId: string;
    dealerType: DealerType;
    name?: string | null;
    name2?: string | null;
    name3?: string | null;
    slug?: string | null;
    state: State;
    inseratMailRecipients: Array<string>;
    whatsappNumber?: string | null;
    socialFacebook?: string | null;
    socialInstagram?: string | null;
    socialX?: string | null;
    socialYouTube?: string | null;
    socialLinkedIn?: string | null;
    socialTikTok?: string | null;
    hPromise: boolean;
    partsStore: boolean;
    parentDealer?: { __typename?: 'Dealer'; dealerId: string; slug?: string | null; hasHws: boolean } | null;
    openingTimesService: Array<{
        __typename?: 'Opening';
        from: Day;
        to: Day;
        ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
    }>;
    openingTimesParts: Array<{
        __typename?: 'Opening';
        from: Day;
        to: Day;
        ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
    }>;
    openingTimesSales: Array<{
        __typename?: 'Opening';
        from: Day;
        to: Day;
        ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
    }>;
    contact?: { __typename?: 'Contact'; phone?: string | null; email?: string | null; fax?: string | null } | null;
    address?: {
        __typename?: 'Address';
        zip?: string | null;
        street?: string | null;
        city?: string | null;
        houseNumber?: string | null;
    } | null;
};

export type MainDealerFieldsFragment = {
    __typename?: 'Dealer';
    hPromise: boolean;
    businessCenter: boolean;
    requireLogin: boolean;
    partsStore: boolean;
    regionsnummerDlv?: number | null;
    careerUrl?: string | null;
    managingDirector?: string | null;
    hasHws: boolean;
    dealerId: string;
    mobileSellerId?: string | null;
    sapId: string;
    dealerType: DealerType;
    name?: string | null;
    name2?: string | null;
    name3?: string | null;
    slug?: string | null;
    state: State;
    inseratMailRecipients: Array<string>;
    whatsappNumber?: string | null;
    socialFacebook?: string | null;
    socialInstagram?: string | null;
    socialX?: string | null;
    socialYouTube?: string | null;
    socialLinkedIn?: string | null;
    socialTikTok?: string | null;
    campaignKey?: {
        __typename?: 'Campaign';
        teaserHeadline: string;
        teaserCopy?: string | null;
        slug: string;
        campaignType: CampaignType;
        content?:
            | { __typename: 'AfterSale'; minimumShortTitle: string }
            | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
            | { __typename: 'SalesCampaignContent'; isBusinessCampaign?: boolean | null; minimumShortTitle: string }
            | null;
        modelForAnnouncement?: { __typename?: 'Model'; slug: string } | null;
    } | null;
    campaignsRegular: Array<{ __typename?: 'Campaign'; id: string }>;
    subDealers: Array<{
        __typename?: 'Dealer';
        dealerId: string;
        mobileSellerId?: string | null;
        sapId: string;
        dealerType: DealerType;
        name?: string | null;
        name2?: string | null;
        name3?: string | null;
        slug?: string | null;
        state: State;
        inseratMailRecipients: Array<string>;
        whatsappNumber?: string | null;
        socialFacebook?: string | null;
        socialInstagram?: string | null;
        socialX?: string | null;
        socialYouTube?: string | null;
        socialLinkedIn?: string | null;
        socialTikTok?: string | null;
        hPromise: boolean;
        partsStore: boolean;
        parentDealer?: { __typename?: 'Dealer'; dealerId: string; slug?: string | null; hasHws: boolean } | null;
        openingTimesService: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        openingTimesParts: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        openingTimesSales: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        contact?: { __typename?: 'Contact'; phone?: string | null; email?: string | null; fax?: string | null } | null;
        address?: {
            __typename?: 'Address';
            zip?: string | null;
            street?: string | null;
            city?: string | null;
            houseNumber?: string | null;
        } | null;
    }>;
    parentDealer?: { __typename?: 'Dealer'; dealerId: string; slug?: string | null; hasHws: boolean } | null;
    openingTimesService: Array<{
        __typename?: 'Opening';
        from: Day;
        to: Day;
        ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
    }>;
    openingTimesParts: Array<{
        __typename?: 'Opening';
        from: Day;
        to: Day;
        ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
    }>;
    openingTimesSales: Array<{
        __typename?: 'Opening';
        from: Day;
        to: Day;
        ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
    }>;
    contact?: { __typename?: 'Contact'; phone?: string | null; email?: string | null; fax?: string | null } | null;
    address?: {
        __typename?: 'Address';
        zip?: string | null;
        street?: string | null;
        city?: string | null;
        houseNumber?: string | null;
    } | null;
};

export type ExportBaseDealerFieldsFragment = {
    __typename?: 'Dealer';
    id: string;
    dealerId: string;
    mobileSellerId?: string | null;
    sapId: string;
    dealerType: DealerType;
    name?: string | null;
    name2?: string | null;
    name3?: string | null;
    slug?: string | null;
    state: State;
    inseratMailRecipients: Array<string>;
    socialFacebook?: string | null;
    socialInstagram?: string | null;
    socialX?: string | null;
    socialYouTube?: string | null;
    socialLinkedIn?: string | null;
    socialTikTok?: string | null;
    hPromise: boolean;
    partsStore: boolean;
    parentDealer?: { __typename?: 'Dealer'; dealerId: string } | null;
    openingTimesService: Array<{ __typename?: 'Opening'; id: string }>;
    openingTimesParts: Array<{ __typename?: 'Opening'; id: string }>;
    openingTimesSales: Array<{ __typename?: 'Opening'; id: string }>;
    contact?: { __typename?: 'Contact'; phone?: string | null; email?: string | null; fax?: string | null } | null;
    address?: {
        __typename?: 'Address';
        zip?: string | null;
        street?: string | null;
        city?: string | null;
        houseNumber?: string | null;
    } | null;
};

export type ExportDealerFieldsFragment = {
    __typename?: 'Dealer';
    hPromise: boolean;
    businessCenter: boolean;
    requireLogin: boolean;
    partsStore: boolean;
    careerUrl?: string | null;
    managingDirector?: string | null;
    hasHws: boolean;
    hasHcm?: boolean | null;
    oldSlugs: Array<string>;
    hwsOrderDate?: unknown | null;
    hwsStartDate?: unknown | null;
    hwsEndDate?: unknown | null;
    firstBillingMonth?: unknown | null;
    hcmUrl?: string | null;
    regionsnummerDlv?: number | null;
    id: string;
    dealerId: string;
    mobileSellerId?: string | null;
    sapId: string;
    dealerType: DealerType;
    name?: string | null;
    name2?: string | null;
    name3?: string | null;
    slug?: string | null;
    state: State;
    inseratMailRecipients: Array<string>;
    socialFacebook?: string | null;
    socialInstagram?: string | null;
    socialX?: string | null;
    socialYouTube?: string | null;
    socialLinkedIn?: string | null;
    socialTikTok?: string | null;
    campaignKey?: { __typename?: 'Campaign'; teaserHeadline: string } | null;
    campaignsRegular: Array<{ __typename?: 'Campaign'; id: string }>;
    subDealers: Array<{ __typename?: 'Dealer'; id: string; dealerId: string }>;
    auth0User: Array<{ __typename?: 'Auth0User'; email: string }>;
    parentDealer?: { __typename?: 'Dealer'; dealerId: string } | null;
    openingTimesService: Array<{ __typename?: 'Opening'; id: string }>;
    openingTimesParts: Array<{ __typename?: 'Opening'; id: string }>;
    openingTimesSales: Array<{ __typename?: 'Opening'; id: string }>;
    contact?: { __typename?: 'Contact'; phone?: string | null; email?: string | null; fax?: string | null } | null;
    address?: {
        __typename?: 'Address';
        zip?: string | null;
        street?: string | null;
        city?: string | null;
        houseNumber?: string | null;
    } | null;
};

export type DealerQueryVariables = Exact<{
    slug: Scalars['String']['input'];
}>;

export type DealerQuery = {
    __typename?: 'Query';
    dealer?: {
        __typename?: 'Dealer';
        hPromise: boolean;
        businessCenter: boolean;
        requireLogin: boolean;
        partsStore: boolean;
        regionsnummerDlv?: number | null;
        careerUrl?: string | null;
        managingDirector?: string | null;
        hasHws: boolean;
        dealerId: string;
        mobileSellerId?: string | null;
        sapId: string;
        dealerType: DealerType;
        name?: string | null;
        name2?: string | null;
        name3?: string | null;
        slug?: string | null;
        state: State;
        inseratMailRecipients: Array<string>;
        whatsappNumber?: string | null;
        socialFacebook?: string | null;
        socialInstagram?: string | null;
        socialX?: string | null;
        socialYouTube?: string | null;
        socialLinkedIn?: string | null;
        socialTikTok?: string | null;
        campaignKey?: {
            __typename?: 'Campaign';
            teaserHeadline: string;
            teaserCopy?: string | null;
            slug: string;
            campaignType: CampaignType;
            content?:
                | { __typename: 'AfterSale'; minimumShortTitle: string }
                | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
                | { __typename: 'SalesCampaignContent'; isBusinessCampaign?: boolean | null; minimumShortTitle: string }
                | null;
            modelForAnnouncement?: { __typename?: 'Model'; slug: string } | null;
        } | null;
        campaignsRegular: Array<{ __typename?: 'Campaign'; id: string }>;
        subDealers: Array<{
            __typename?: 'Dealer';
            dealerId: string;
            mobileSellerId?: string | null;
            sapId: string;
            dealerType: DealerType;
            name?: string | null;
            name2?: string | null;
            name3?: string | null;
            slug?: string | null;
            state: State;
            inseratMailRecipients: Array<string>;
            whatsappNumber?: string | null;
            socialFacebook?: string | null;
            socialInstagram?: string | null;
            socialX?: string | null;
            socialYouTube?: string | null;
            socialLinkedIn?: string | null;
            socialTikTok?: string | null;
            hPromise: boolean;
            partsStore: boolean;
            parentDealer?: { __typename?: 'Dealer'; dealerId: string; slug?: string | null; hasHws: boolean } | null;
            openingTimesService: Array<{
                __typename?: 'Opening';
                from: Day;
                to: Day;
                ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
            }>;
            openingTimesParts: Array<{
                __typename?: 'Opening';
                from: Day;
                to: Day;
                ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
            }>;
            openingTimesSales: Array<{
                __typename?: 'Opening';
                from: Day;
                to: Day;
                ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
            }>;
            contact?: {
                __typename?: 'Contact';
                phone?: string | null;
                email?: string | null;
                fax?: string | null;
            } | null;
            address?: {
                __typename?: 'Address';
                zip?: string | null;
                street?: string | null;
                city?: string | null;
                houseNumber?: string | null;
            } | null;
        }>;
        parentDealer?: { __typename?: 'Dealer'; dealerId: string; slug?: string | null; hasHws: boolean } | null;
        openingTimesService: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        openingTimesParts: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        openingTimesSales: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        contact?: { __typename?: 'Contact'; phone?: string | null; email?: string | null; fax?: string | null } | null;
        address?: {
            __typename?: 'Address';
            zip?: string | null;
            street?: string | null;
            city?: string | null;
            houseNumber?: string | null;
        } | null;
    } | null;
};

export type DealersQueryVariables = Exact<{ [key: string]: never }>;

export type DealersQuery = {
    __typename?: 'Query';
    dealers: Array<{
        __typename?: 'Dealer';
        hPromise: boolean;
        businessCenter: boolean;
        requireLogin: boolean;
        partsStore: boolean;
        regionsnummerDlv?: number | null;
        careerUrl?: string | null;
        managingDirector?: string | null;
        hasHws: boolean;
        dealerId: string;
        mobileSellerId?: string | null;
        sapId: string;
        dealerType: DealerType;
        name?: string | null;
        name2?: string | null;
        name3?: string | null;
        slug?: string | null;
        state: State;
        inseratMailRecipients: Array<string>;
        whatsappNumber?: string | null;
        socialFacebook?: string | null;
        socialInstagram?: string | null;
        socialX?: string | null;
        socialYouTube?: string | null;
        socialLinkedIn?: string | null;
        socialTikTok?: string | null;
        campaignKey?: {
            __typename?: 'Campaign';
            teaserHeadline: string;
            teaserCopy?: string | null;
            slug: string;
            campaignType: CampaignType;
            content?:
                | { __typename: 'AfterSale'; minimumShortTitle: string }
                | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
                | { __typename: 'SalesCampaignContent'; isBusinessCampaign?: boolean | null; minimumShortTitle: string }
                | null;
            modelForAnnouncement?: { __typename?: 'Model'; slug: string } | null;
        } | null;
        campaignsRegular: Array<{ __typename?: 'Campaign'; id: string }>;
        subDealers: Array<{
            __typename?: 'Dealer';
            dealerId: string;
            mobileSellerId?: string | null;
            sapId: string;
            dealerType: DealerType;
            name?: string | null;
            name2?: string | null;
            name3?: string | null;
            slug?: string | null;
            state: State;
            inseratMailRecipients: Array<string>;
            whatsappNumber?: string | null;
            socialFacebook?: string | null;
            socialInstagram?: string | null;
            socialX?: string | null;
            socialYouTube?: string | null;
            socialLinkedIn?: string | null;
            socialTikTok?: string | null;
            hPromise: boolean;
            partsStore: boolean;
            parentDealer?: { __typename?: 'Dealer'; dealerId: string; slug?: string | null; hasHws: boolean } | null;
            openingTimesService: Array<{
                __typename?: 'Opening';
                from: Day;
                to: Day;
                ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
            }>;
            openingTimesParts: Array<{
                __typename?: 'Opening';
                from: Day;
                to: Day;
                ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
            }>;
            openingTimesSales: Array<{
                __typename?: 'Opening';
                from: Day;
                to: Day;
                ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
            }>;
            contact?: {
                __typename?: 'Contact';
                phone?: string | null;
                email?: string | null;
                fax?: string | null;
            } | null;
            address?: {
                __typename?: 'Address';
                zip?: string | null;
                street?: string | null;
                city?: string | null;
                houseNumber?: string | null;
            } | null;
        }>;
        parentDealer?: { __typename?: 'Dealer'; dealerId: string; slug?: string | null; hasHws: boolean } | null;
        openingTimesService: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        openingTimesParts: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        openingTimesSales: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        contact?: { __typename?: 'Contact'; phone?: string | null; email?: string | null; fax?: string | null } | null;
        address?: {
            __typename?: 'Address';
            zip?: string | null;
            street?: string | null;
            city?: string | null;
            houseNumber?: string | null;
        } | null;
    }>;
};

export type SubDealersQueryVariables = Exact<{
    dealerId: Scalars['String']['input'];
}>;

export type SubDealersQuery = {
    __typename?: 'Query';
    dealer?: {
        __typename?: 'Dealer';
        subDealers: Array<{
            __typename?: 'Dealer';
            dealerId: string;
            mobileSellerId?: string | null;
            sapId: string;
            dealerType: DealerType;
            name?: string | null;
            name2?: string | null;
            name3?: string | null;
            slug?: string | null;
            state: State;
            inseratMailRecipients: Array<string>;
            whatsappNumber?: string | null;
            socialFacebook?: string | null;
            socialInstagram?: string | null;
            socialX?: string | null;
            socialYouTube?: string | null;
            socialLinkedIn?: string | null;
            socialTikTok?: string | null;
            hPromise: boolean;
            partsStore: boolean;
            parentDealer?: { __typename?: 'Dealer'; dealerId: string; slug?: string | null; hasHws: boolean } | null;
            openingTimesService: Array<{
                __typename?: 'Opening';
                from: Day;
                to: Day;
                ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
            }>;
            openingTimesParts: Array<{
                __typename?: 'Opening';
                from: Day;
                to: Day;
                ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
            }>;
            openingTimesSales: Array<{
                __typename?: 'Opening';
                from: Day;
                to: Day;
                ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
            }>;
            contact?: {
                __typename?: 'Contact';
                phone?: string | null;
                email?: string | null;
                fax?: string | null;
            } | null;
            address?: {
                __typename?: 'Address';
                zip?: string | null;
                street?: string | null;
                city?: string | null;
                houseNumber?: string | null;
            } | null;
        }>;
    } | null;
};

export type GetPaginatedDealerSlugsQueryVariables = Exact<{
    first: Scalars['Int']['input'];
    skip: Scalars['Int']['input'];
}>;

export type GetPaginatedDealerSlugsQuery = {
    __typename?: 'Query';
    dealers: Array<{ __typename?: 'Dealer'; id: string; dealerId: string; slug?: string | null }>;
};

export type GetPaginatedActiveDealerSlugsQueryVariables = Exact<{
    first: Scalars['Int']['input'];
    skip: Scalars['Int']['input'];
}>;

export type GetPaginatedActiveDealerSlugsQuery = {
    __typename?: 'Query';
    dealers: Array<{ __typename?: 'Dealer'; id: string; dealerId: string; slug?: string | null }>;
};

export type GetDealerSlugByDealerIdQueryVariables = Exact<{
    dealerId: Scalars['String']['input'];
}>;

export type GetDealerSlugByDealerIdQuery = {
    __typename?: 'Query';
    dealer?: { __typename?: 'Dealer'; slug?: string | null; hasHws: boolean } | null;
};

export type GetDealerDealerIdQueryVariables = Exact<{
    dealerId: Scalars['String']['input'];
}>;

export type GetDealerDealerIdQuery = {
    __typename?: 'Query';
    dealer?: {
        __typename?: 'Dealer';
        dealerId: string;
        mobileSellerId?: string | null;
        sapId: string;
        dealerType: DealerType;
        name?: string | null;
        name2?: string | null;
        name3?: string | null;
        slug?: string | null;
        state: State;
        inseratMailRecipients: Array<string>;
        whatsappNumber?: string | null;
        socialFacebook?: string | null;
        socialInstagram?: string | null;
        socialX?: string | null;
        socialYouTube?: string | null;
        socialLinkedIn?: string | null;
        socialTikTok?: string | null;
        hPromise: boolean;
        partsStore: boolean;
        subDealers: Array<{ __typename?: 'Dealer'; dealerId: string }>;
        parentDealer?: { __typename?: 'Dealer'; dealerId: string; slug?: string | null; hasHws: boolean } | null;
        openingTimesService: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        openingTimesParts: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        openingTimesSales: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        contact?: { __typename?: 'Contact'; phone?: string | null; email?: string | null; fax?: string | null } | null;
        address?: {
            __typename?: 'Address';
            zip?: string | null;
            street?: string | null;
            city?: string | null;
            houseNumber?: string | null;
        } | null;
    } | null;
};

export type GetPaginatedDealersQueryVariables = Exact<{
    first: Scalars['Int']['input'];
    skip: Scalars['Int']['input'];
}>;

export type GetPaginatedDealersQuery = {
    __typename?: 'Query';
    dealers: Array<{
        __typename?: 'Dealer';
        id: string;
        hPromise: boolean;
        businessCenter: boolean;
        requireLogin: boolean;
        partsStore: boolean;
        regionsnummerDlv?: number | null;
        careerUrl?: string | null;
        managingDirector?: string | null;
        hasHws: boolean;
        dealerId: string;
        mobileSellerId?: string | null;
        sapId: string;
        dealerType: DealerType;
        name?: string | null;
        name2?: string | null;
        name3?: string | null;
        slug?: string | null;
        state: State;
        inseratMailRecipients: Array<string>;
        whatsappNumber?: string | null;
        socialFacebook?: string | null;
        socialInstagram?: string | null;
        socialX?: string | null;
        socialYouTube?: string | null;
        socialLinkedIn?: string | null;
        socialTikTok?: string | null;
        campaignKey?: {
            __typename?: 'Campaign';
            teaserHeadline: string;
            teaserCopy?: string | null;
            slug: string;
            campaignType: CampaignType;
            content?:
                | { __typename: 'AfterSale'; minimumShortTitle: string }
                | { __typename: 'ModellAnkuendigungContent'; minimumShortTitle: string }
                | { __typename: 'SalesCampaignContent'; isBusinessCampaign?: boolean | null; minimumShortTitle: string }
                | null;
            modelForAnnouncement?: { __typename?: 'Model'; slug: string } | null;
        } | null;
        campaignsRegular: Array<{ __typename?: 'Campaign'; id: string }>;
        subDealers: Array<{
            __typename?: 'Dealer';
            dealerId: string;
            mobileSellerId?: string | null;
            sapId: string;
            dealerType: DealerType;
            name?: string | null;
            name2?: string | null;
            name3?: string | null;
            slug?: string | null;
            state: State;
            inseratMailRecipients: Array<string>;
            whatsappNumber?: string | null;
            socialFacebook?: string | null;
            socialInstagram?: string | null;
            socialX?: string | null;
            socialYouTube?: string | null;
            socialLinkedIn?: string | null;
            socialTikTok?: string | null;
            hPromise: boolean;
            partsStore: boolean;
            parentDealer?: { __typename?: 'Dealer'; dealerId: string; slug?: string | null; hasHws: boolean } | null;
            openingTimesService: Array<{
                __typename?: 'Opening';
                from: Day;
                to: Day;
                ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
            }>;
            openingTimesParts: Array<{
                __typename?: 'Opening';
                from: Day;
                to: Day;
                ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
            }>;
            openingTimesSales: Array<{
                __typename?: 'Opening';
                from: Day;
                to: Day;
                ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
            }>;
            contact?: {
                __typename?: 'Contact';
                phone?: string | null;
                email?: string | null;
                fax?: string | null;
            } | null;
            address?: {
                __typename?: 'Address';
                zip?: string | null;
                street?: string | null;
                city?: string | null;
                houseNumber?: string | null;
            } | null;
        }>;
        parentDealer?: { __typename?: 'Dealer'; dealerId: string; slug?: string | null; hasHws: boolean } | null;
        openingTimesService: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        openingTimesParts: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        openingTimesSales: Array<{
            __typename?: 'Opening';
            from: Day;
            to: Day;
            ranges: Array<{ __typename?: 'TimeRange'; start: string; end: string }>;
        }>;
        contact?: { __typename?: 'Contact'; phone?: string | null; email?: string | null; fax?: string | null } | null;
        address?: {
            __typename?: 'Address';
            zip?: string | null;
            street?: string | null;
            city?: string | null;
            houseNumber?: string | null;
        } | null;
    }>;
};

export type GetPaginatedActiveDealerExportQueryVariables = Exact<{
    first: Scalars['Int']['input'];
    skip: Scalars['Int']['input'];
}>;

export type GetPaginatedActiveDealerExportQuery = {
    __typename?: 'Query';
    dealers: Array<{
        __typename?: 'Dealer';
        id: string;
        dealerId: string;
        dealerType: DealerType;
        name?: string | null;
        name2?: string | null;
        name3?: string | null;
        slug?: string | null;
        address?: { __typename?: 'Address'; zip?: string | null; street?: string | null; city?: string | null } | null;
        contact?: { __typename?: 'Contact'; email?: string | null } | null;
    }>;
};

export type GetPaginatedDealersExportQueryVariables = Exact<{
    first: Scalars['Int']['input'];
    skip: Scalars['Int']['input'];
}>;

export type GetPaginatedDealersExportQuery = {
    __typename?: 'Query';
    dealers: Array<{
        __typename?: 'Dealer';
        id: string;
        hPromise: boolean;
        businessCenter: boolean;
        requireLogin: boolean;
        partsStore: boolean;
        careerUrl?: string | null;
        managingDirector?: string | null;
        hasHws: boolean;
        hasHcm?: boolean | null;
        oldSlugs: Array<string>;
        hwsOrderDate?: unknown | null;
        hwsStartDate?: unknown | null;
        hwsEndDate?: unknown | null;
        firstBillingMonth?: unknown | null;
        hcmUrl?: string | null;
        regionsnummerDlv?: number | null;
        dealerId: string;
        mobileSellerId?: string | null;
        sapId: string;
        dealerType: DealerType;
        name?: string | null;
        name2?: string | null;
        name3?: string | null;
        slug?: string | null;
        state: State;
        inseratMailRecipients: Array<string>;
        socialFacebook?: string | null;
        socialInstagram?: string | null;
        socialX?: string | null;
        socialYouTube?: string | null;
        socialLinkedIn?: string | null;
        socialTikTok?: string | null;
        campaignKey?: { __typename?: 'Campaign'; teaserHeadline: string } | null;
        campaignsRegular: Array<{ __typename?: 'Campaign'; id: string }>;
        subDealers: Array<{ __typename?: 'Dealer'; id: string; dealerId: string }>;
        auth0User: Array<{ __typename?: 'Auth0User'; email: string }>;
        parentDealer?: { __typename?: 'Dealer'; dealerId: string } | null;
        openingTimesService: Array<{ __typename?: 'Opening'; id: string }>;
        openingTimesParts: Array<{ __typename?: 'Opening'; id: string }>;
        openingTimesSales: Array<{ __typename?: 'Opening'; id: string }>;
        contact?: { __typename?: 'Contact'; phone?: string | null; email?: string | null; fax?: string | null } | null;
        address?: {
            __typename?: 'Address';
            zip?: string | null;
            street?: string | null;
            city?: string | null;
            houseNumber?: string | null;
        } | null;
    }>;
};

export type GetDealerSlugByOldSlugQueryVariables = Exact<{
    oldSlug: Scalars['String']['input'];
}>;

export type GetDealerSlugByOldSlugQuery = {
    __typename?: 'Query';
    dealers: Array<{ __typename?: 'Dealer'; slug?: string | null }>;
};

export type GetPaginatedHcmDealersQueryVariables = Exact<{
    first: Scalars['Int']['input'];
    skip: Scalars['Int']['input'];
}>;

export type GetPaginatedHcmDealersQuery = {
    __typename?: 'Query';
    dealers: Array<{
        __typename?: 'Dealer';
        id: string;
        slug?: string | null;
        dealerId: string;
        mobileSellerId?: string | null;
        name?: string | null;
        hasHws: boolean;
        hasHcm?: boolean | null;
        hPromise: boolean;
        parentDealer?: {
            __typename?: 'Dealer';
            id: string;
            name?: string | null;
            dealerId: string;
            mobileSellerId?: string | null;
            hasHws: boolean;
            hasHcm?: boolean | null;
            hPromise: boolean;
        } | null;
    }>;
};

export type GetDealersWithoutHcmAndHwsQueryVariables = Exact<{
    first?: InputMaybe<Scalars['Int']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetDealersWithoutHcmAndHwsQuery = {
    __typename?: 'Query';
    dealers: Array<{
        __typename?: 'Dealer';
        id: string;
        slug?: string | null;
        dealerId: string;
        mobileSellerId?: string | null;
        name?: string | null;
        hasHws: boolean;
        hasHcm?: boolean | null;
        parentDealer?: {
            __typename?: 'Dealer';
            id: string;
            name?: string | null;
            dealerId: string;
            mobileSellerId?: string | null;
            hasHws: boolean;
            hasHcm?: boolean | null;
            hPromise: boolean;
        } | null;
    }>;
};

export type GetPaginatedCarMarketDealerIdsQueryVariables = Exact<{
    first: Scalars['Int']['input'];
    skip: Scalars['Int']['input'];
}>;

export type GetPaginatedCarMarketDealerIdsQuery = {
    __typename?: 'Query';
    dealers: Array<{ __typename?: 'Dealer'; dealerId: string; mobileSellerId?: string | null }>;
};

export type FootnotesByIdsQueryVariables = Exact<{
    ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type FootnotesByIdsQuery = {
    __typename?: 'Query';
    footnotes: Array<{
        __typename?: 'Footnote';
        id: string;
        fixedSign?: string | null;
        content: { __typename?: 'RichText'; html: string };
    }>;
};

export type GeneralServicesFieldsFragment = {
    __typename?: 'GeneralService';
    id: string;
    headline: string;
    copy?: string | null;
    default: boolean;
    trackingName?: string | null;
    image: { __typename?: 'Asset'; url: string; width?: number | null; height?: number | null; alt?: string | null };
    icon?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        mimeType?: string | null;
        alt?: string | null;
    } | null;
    link?: { __typename?: 'Link'; url: string; title: string } | null;
};

export type GeneralServicesQueryVariables = Exact<{ [key: string]: never }>;

export type GeneralServicesQuery = {
    __typename?: 'Query';
    generalServices: Array<{
        __typename?: 'GeneralService';
        id: string;
        headline: string;
        copy?: string | null;
        default: boolean;
        trackingName?: string | null;
        image: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        };
        icon?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            mimeType?: string | null;
            alt?: string | null;
        } | null;
        link?: { __typename?: 'Link'; url: string; title: string } | null;
    }>;
};

export type SelectedGeneralServicesQueryVariables = Exact<{
    ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;

export type SelectedGeneralServicesQuery = {
    __typename?: 'Query';
    generalServices: Array<{
        __typename?: 'GeneralService';
        id: string;
        headline: string;
        copy?: string | null;
        default: boolean;
        trackingName?: string | null;
        image: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        };
        icon?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            mimeType?: string | null;
            alt?: string | null;
        } | null;
        link?: { __typename?: 'Link'; url: string; title: string } | null;
    }>;
};

export type HomeTeaserFieldsFragment = {
    __typename?: 'HomeTeaser';
    id: string;
    text: string;
    targetSlug: string;
    createdAt: string;
    image: { __typename?: 'Asset'; url: string; alt?: string | null };
};

export type GetHomeTeasersIgnoreDealerTypeQueryVariables = Exact<{
    partsStore: Scalars['Boolean']['input'];
    hPromise: Scalars['Boolean']['input'];
    businessCenter: Scalars['Boolean']['input'];
}>;

export type GetHomeTeasersIgnoreDealerTypeQuery = {
    __typename?: 'Query';
    homeTeasers: Array<{
        __typename?: 'HomeTeaser';
        id: string;
        text: string;
        targetSlug: string;
        createdAt: string;
        image: { __typename?: 'Asset'; url: string; alt?: string | null };
    }>;
};

export type GetHomeTeasersQueryVariables = Exact<{
    dealerType: DealerType;
    partsStore: Scalars['Boolean']['input'];
    hPromise: Scalars['Boolean']['input'];
    businessCenter: Scalars['Boolean']['input'];
}>;

export type GetHomeTeasersQuery = {
    __typename?: 'Query';
    homeTeasers: Array<{
        __typename?: 'HomeTeaser';
        id: string;
        text: string;
        targetSlug: string;
        createdAt: string;
        image: { __typename?: 'Asset'; url: string; alt?: string | null };
    }>;
};

export type ModelListQueryVariables = Exact<{ [key: string]: never }>;

export type ModelListQuery = {
    __typename?: 'Query';
    models: Array<{
        __typename?: 'Model';
        name: string;
        alternativerModelListName?: string | null;
        slug: string;
        categories: Array<ModelCategory>;
        order?: number | null;
        vehicleMarketFilterParams?: string | null;
        disableTestdrive?: boolean | null;
        image: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        };
        campaigns: Array<{ __typename?: 'Campaign'; id: string }>;
        modelAnnouncementCampaign?: { __typename?: 'Campaign'; slug: string } | null;
    }>;
};

export type ModelDetailQueryVariables = Exact<{
    slug: Scalars['String']['input'];
}>;

export type ModelDetailQuery = {
    __typename?: 'Query';
    model?: {
        __typename?: 'Model';
        name: string;
        alternativeModelDetailName?: string | null;
        heroImageCaption?: string | null;
        heroVideoUrl?: string | null;
        slug: string;
        categories: Array<ModelCategory>;
        msrLink?: string | null;
        co2Class: string;
        contentImagesCaption?: string | null;
        contentHeadline?: string | null;
        cwModelUrl?: string | null;
        formIdentifier?: string | null;
        vehicleMarketFilterParams?: string | null;
        disableTestdrive?: boolean | null;
        trimAndEnvkvString?: string | null;
        heroImage: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        };
        logoImages: Array<{
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        }>;
        contentImages: Array<{
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        }>;
        contentCopy?: { __typename?: 'RichText'; html: string } | null;
        keyFacts: Array<{ __typename?: 'KeyFact'; label: string; value: string; unit: string }>;
        legalTexts?: { __typename?: 'RichText'; html: string } | null;
        faq?: {
            __typename?: 'Faq';
            headline?: string | null;
            questions: Array<{
                __typename?: 'QuestionAnswer';
                id: string;
                question?: string | null;
                answer?: { __typename?: 'RichText'; html: string; text: string } | null;
            }>;
        } | null;
        alternativeEnvkvVehicle?: { __typename?: 'Vehicle'; trimAndEnvkvString?: string | null } | null;
        campaigns: Array<{
            __typename?: 'Campaign';
            teaserHeadline: string;
            teaserCopy?: string | null;
            slug: string;
            content?:
                | { __typename: 'AfterSale'; minimumShortTitle: string }
                | { __typename: 'ModellAnkuendigungContent' }
                | { __typename: 'SalesCampaignContent'; minimumShortTitle: string }
                | null;
        }>;
        modelAnnouncementCampaign?: {
            __typename?: 'Campaign';
            id: string;
            slug: string;
            teaserCopy?: string | null;
            teaserHeadline: string;
            startDate?: unknown | null;
            title: string;
            endDate?: unknown | null;
            kmpCode?: string | null;
            heroImage: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            };
            content?:
                | { __typename: 'AfterSale' }
                | {
                      __typename: 'ModellAnkuendigungContent';
                      promotionInModellPalette?: boolean | null;
                      warrantyLogo1?: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      } | null;
                      warrantyLogo2?: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      } | null;
                      warrantyLogo3?: {
                          __typename?: 'Asset';
                          url: string;
                          width?: number | null;
                          height?: number | null;
                          alt?: string | null;
                      } | null;
                  }
                | { __typename: 'SalesCampaignContent' }
                | null;
        } | null;
    } | null;
};

export type GetModelByNameQueryVariables = Exact<{
    modelName: Scalars['String']['input'];
}>;

export type GetModelByNameQuery = {
    __typename?: 'Query';
    models: Array<{ __typename?: 'Model'; id: string; name: string }>;
};

export type ModelEnvkvDropdownQueryVariables = Exact<{ [key: string]: never }>;

export type ModelEnvkvDropdownQuery = {
    __typename?: 'Query';
    models: Array<{
        __typename?: 'Model';
        name: string;
        id: string;
        slug: string;
        modelCode?: string | null;
        formIdentifier?: string | null;
    }>;
};

export type OverlayBatteryCertificateQueryVariables = Exact<{ [key: string]: never }>;

export type OverlayBatteryCertificateQuery = {
    __typename?: 'Query';
    overlayBatteryCertificates: Array<{
        __typename?: 'OverlayBatteryCertificate';
        heroText: string;
        heroSubheadline?: string | null;
        heroHeadline: string;
        contentHeadline: string;
        contentSubheadline?: string | null;
        boxHeadline: string;
        heroImage: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        };
        contentText?: { __typename?: 'RichText'; html: string } | null;
        contentImage: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        };
        legalLines?: { __typename?: 'RichText'; html: string } | null;
        contentList: Array<{ __typename?: 'HeadlineText'; headline?: string | null; text?: string | null }>;
        boxList: Array<{ __typename?: 'HeadlineText'; text?: string | null; headline?: string | null }>;
    }>;
};

export type PageAboutUsQueryVariables = Exact<{ [key: string]: never }>;

export type PageAboutUsQuery = {
    __typename?: 'Query';
    pageAboutUses: Array<{
        __typename?: 'PageAboutUs';
        jobsHeadline?: string | null;
        heroImage?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        employeePlaceholder?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
    }>;
};

export type JobsDefaultBulletsQueryVariables = Exact<{ [key: string]: never }>;

export type JobsDefaultBulletsQuery = {
    __typename?: 'Query';
    pageAboutUses: Array<{
        __typename?: 'PageAboutUs';
        jobsDefaultBullets: Array<{ __typename?: 'IconText'; id: string; text: string }>;
    }>;
};

export type BusinessWarrantyFragmentFragment = {
    __typename?: 'Warranty';
    headline?: string | null;
    copy?: string | null;
    image?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    bulletlist: Array<{
        __typename?: 'IconText';
        text: string;
        icon?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
    }>;
    downloadPdf?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
};

export type PageBusinessCustomersQueryVariables = Exact<{ [key: string]: never }>;

export type PageBusinessCustomersQuery = {
    __typename?: 'Query';
    pageBusinessCustomers: Array<{
        __typename?: 'PageBusinessCustomer';
        heroHeadline?: string | null;
        heroBulletListHeadline?: string | null;
        heroBulletListLinkText?: string | null;
        heroBulletListCtaText?: string | null;
        businessCenterBulletListHeadline?: string | null;
        businessCenterHighlight1Headline?: string | null;
        businessCenterHighlight1Copy?: string | null;
        businessCenterHighlight2Headline?: string | null;
        businessCenterHighlight2Copy?: string | null;
        heroImage?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        heroBulletList: Array<{
            __typename?: 'IconText';
            id: string;
            text: string;
            default: boolean;
            icon?: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            } | null;
        }>;
        businessCenterBulletList: Array<{
            __typename?: 'IconText';
            text: string;
            icon?: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            } | null;
        }>;
        businessCenterHighlight1Image?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        businessCenterHighlight2Image?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        legalLines?: { __typename?: 'RichText'; html: string } | null;
        warranty1?: {
            __typename?: 'Warranty';
            headline?: string | null;
            copy?: string | null;
            image?: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            } | null;
            bulletlist: Array<{
                __typename?: 'IconText';
                text: string;
                icon?: {
                    __typename?: 'Asset';
                    url: string;
                    width?: number | null;
                    height?: number | null;
                    alt?: string | null;
                } | null;
            }>;
            downloadPdf?: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            } | null;
        } | null;
        warranty2?: {
            __typename?: 'Warranty';
            headline?: string | null;
            copy?: string | null;
            image?: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            } | null;
            bulletlist: Array<{
                __typename?: 'IconText';
                text: string;
                icon?: {
                    __typename?: 'Asset';
                    url: string;
                    width?: number | null;
                    height?: number | null;
                    alt?: string | null;
                } | null;
            }>;
            downloadPdf?: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            } | null;
        } | null;
        faq?: {
            __typename?: 'Faq';
            headline?: string | null;
            questions: Array<{
                __typename?: 'QuestionAnswer';
                id: string;
                question?: string | null;
                answer?: { __typename?: 'RichText'; html: string; text: string } | null;
            }>;
        } | null;
    }>;
};

export type GetPageHomeQueryVariables = Exact<{ [key: string]: never }>;

export type GetPageHomeQuery = {
    __typename?: 'Query';
    pageHomes: Array<{
        __typename?: 'PageHome';
        hcmTeaserHeadline: string;
        hcmTeaserCopy: string;
        hcmTeaserCtaLabel: string;
        hcmTeaserImage: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        };
    }>;
};

export type PageHyundaiPromiseQueryVariables = Exact<{ [key: string]: never }>;

export type PageHyundaiPromiseQuery = {
    __typename?: 'Query';
    pageHyundaiPromises: Array<{
        __typename?: 'PageHyundaiPromise';
        heroHeadline?: string | null;
        heroBulletListHeadline?: string | null;
        heroBulletListLinkText?: string | null;
        heroCtaText?: string | null;
        heroCtaTarget?: string | null;
        contentHeadline?: string | null;
        contentCopy?: string | null;
        contentCtaText?: string | null;
        contentCtaTarget?: string | null;
        contentBulletListHeadline?: string | null;
        videoHeadline?: string | null;
        videoCtaText?: string | null;
        videoCtaTarget?: string | null;
        videoCopy?: string | null;
        heroImage?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        heroBulletListItems: Array<{
            __typename?: 'IconText';
            text: string;
            icon?: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            } | null;
        }>;
        faq?: {
            __typename?: 'Faq';
            headline?: string | null;
            questions: Array<{
                __typename?: 'QuestionAnswer';
                id: string;
                question?: string | null;
                answer?: { __typename?: 'RichText'; html: string; text: string } | null;
            }>;
        } | null;
        contentImage?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        contentBulletList: Array<{
            __typename?: 'IconText';
            text: string;
            icon?: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            } | null;
        }>;
        legalLines?: { __typename?: 'RichText'; html: string } | null;
        video?: { __typename?: 'Asset'; url: string } | null;
    }>;
};

export type PageServiceQueryVariables = Exact<{ [key: string]: never }>;

export type PageServiceQuery = {
    __typename?: 'Query';
    pageServices: Array<{
        __typename?: 'PageService';
        headline: string;
        subHeadline: string;
        heroImage: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        };
        defaultBullets: Array<{
            __typename?: 'IconText';
            id: string;
            text: string;
            default: boolean;
            icon?: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            } | null;
        }>;
        faq?: {
            __typename?: 'Faq';
            headline?: string | null;
            questions: Array<{
                __typename?: 'QuestionAnswer';
                id: string;
                question?: string | null;
                answer?: { __typename?: 'RichText'; html: string; text: string } | null;
            }>;
        } | null;
        partStoreTeaserImage: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        };
    }>;
};

export type WarrantyFragmentFragment = {
    __typename?: 'Warranty';
    headline?: string | null;
    copy?: string | null;
    image?: {
        __typename?: 'Asset';
        url: string;
        width?: number | null;
        height?: number | null;
        alt?: string | null;
    } | null;
    bulletlist: Array<{
        __typename?: 'IconText';
        text: string;
        icon?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
    }>;
    downloadPdf?: { __typename?: 'Asset'; url: string } | null;
};

export type PageWarrantyQueryVariables = Exact<{ [key: string]: never }>;

export type PageWarrantyQuery = {
    __typename?: 'Query';
    pageWarranties: Array<{
        __typename?: 'PageWarranty';
        heroHeadline: string;
        heroSubHeadline?: string | null;
        heroCopy?: string | null;
        warrantyHeadline?: string | null;
        heroImage?: {
            __typename?: 'Asset';
            url: string;
            width?: number | null;
            height?: number | null;
            alt?: string | null;
        } | null;
        warranty1?: {
            __typename?: 'Warranty';
            headline?: string | null;
            copy?: string | null;
            image?: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            } | null;
            bulletlist: Array<{
                __typename?: 'IconText';
                text: string;
                icon?: {
                    __typename?: 'Asset';
                    url: string;
                    width?: number | null;
                    height?: number | null;
                    alt?: string | null;
                } | null;
            }>;
            downloadPdf?: { __typename?: 'Asset'; url: string } | null;
        } | null;
        warranty2?: {
            __typename?: 'Warranty';
            headline?: string | null;
            copy?: string | null;
            image?: {
                __typename?: 'Asset';
                url: string;
                width?: number | null;
                height?: number | null;
                alt?: string | null;
            } | null;
            bulletlist: Array<{
                __typename?: 'IconText';
                text: string;
                icon?: {
                    __typename?: 'Asset';
                    url: string;
                    width?: number | null;
                    height?: number | null;
                    alt?: string | null;
                } | null;
            }>;
            downloadPdf?: { __typename?: 'Asset'; url: string } | null;
        } | null;
        legalLines?: { __typename?: 'RichText'; html: string } | null;
        faq?: {
            __typename?: 'Faq';
            headline?: string | null;
            questions: Array<{
                __typename?: 'QuestionAnswer';
                id: string;
                question?: string | null;
                answer?: { __typename?: 'RichText'; html: string; text: string } | null;
            }>;
        } | null;
    }>;
};

export type CreateVehicleMutationVariables = Exact<{
    vehicle: VehicleCreateInput;
}>;

export type CreateVehicleMutation = {
    __typename?: 'Mutation';
    createVehicle?: { __typename?: 'Vehicle'; id: string } | null;
};

export type UpdateVehicleMutationVariables = Exact<{
    vehicleId: Scalars['ID']['input'];
    vehicle: VehicleUpdateInput;
}>;

export type UpdateVehicleMutation = {
    __typename?: 'Mutation';
    updateVehicle?: { __typename?: 'Vehicle'; id: string } | null;
};

export type PublishVehiclesMutationVariables = Exact<{
    vehicleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type PublishVehiclesMutation = {
    __typename?: 'Mutation';
    publishManyVehiclesConnection: {
        __typename?: 'VehicleConnection';
        aggregate: { __typename?: 'Aggregate'; count: number };
    };
};

export type FindVehicleQueryVariables = Exact<{
    modelName: Scalars['String']['input'];
    generation: Scalars['String']['input'];
    trim: Scalars['String']['input'];
    fuel: Scalars['String']['input'];
    version: Scalars['String']['input'];
}>;

export type FindVehicleQuery = {
    __typename?: 'Query';
    vehicles: Array<{
        __typename?: 'Vehicle';
        id: string;
        generation?: string | null;
        trim: string;
        version?: string | null;
        model?: { __typename?: 'Model'; name: string } | null;
    }>;
};

export type FindVehicleByModelCodeQueryVariables = Exact<{
    modelcode: Scalars['String']['input'];
}>;

export type FindVehicleByModelCodeQuery = {
    __typename?: 'Query';
    vehicles: Array<{ __typename?: 'Vehicle'; id: string; modelcode?: string | null }>;
};

export type GetVehicleByIdQueryVariables = Exact<{
    hygraphId: Scalars['ID']['input'];
}>;

export type GetVehicleByIdQuery = {
    __typename?: 'Query';
    vehicle?: {
        __typename: 'Vehicle';
        co2Class: Co2Class;
        trim: string;
        powerPs?: number | null;
        powerKw?: number | null;
        version?: string | null;
        trimAndEnvkvString?: string | null;
        fuelType?: FuelType | null;
        model?: {
            __typename?: 'Model';
            name: string;
            formIdentifier?: string | null;
            slug: string;
            vehicleMarketFilterParams?: string | null;
            disableTestdrive?: boolean | null;
        } | null;
        envkv?:
            | {
                  __typename: 'EnVkvElektro';
                  consumptionCombined: string;
                  co2Combined: string;
                  rangeElectric: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvPlugInHybrid';
                  consumptionCombinedLitres: string;
                  consumptionCombinedElectric: string;
                  co2Combined: string;
                  consumptionCombinedDischargedBattery: string;
                  co2CombinedDischargedBattery: string;
                  co2ClassDischargedBattery: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | {
                  __typename: 'EnVkvVerbrennerHybrid';
                  co2Combined: string;
                  consumptionCombined: string;
                  headline: string;
                  additionalTransmissionPerformance?: string | null;
              }
            | null;
    } | null;
};

export type FindVehicleByModelCodeAndGenerationQueryVariables = Exact<{
    where: VehicleWhereInput;
}>;

export type FindVehicleByModelCodeAndGenerationQuery = {
    __typename?: 'Query';
    vehicles: Array<{
        __typename?: 'Vehicle';
        id: string;
        modelcode?: string | null;
        generation?: string | null;
        trimAndEnvkvString?: string | null;
        fuelType?: FuelType | null;
    }>;
};

export type FindGenerationsByModelCodeQueryVariables = Exact<{
    where: VehicleWhereInput;
}>;

export type FindGenerationsByModelCodeQuery = {
    __typename?: 'Query';
    vehicles: Array<{ __typename?: 'Vehicle'; generation?: string | null }>;
};

export const ImageFragmentDoc = gql`
    fragment Image on Asset {
        url
        width
        height
        alt
    }
`;
export const EnVkvVerbrennerHybridFragmentFragmentDoc = gql`
    fragment EnVkvVerbrennerHybridFragment on EnVkvVerbrennerHybrid {
        __typename
        co2Combined
        consumptionCombined
        headline
        additionalTransmissionPerformance
    }
`;
export const EnVkvElektroFragmentFragmentDoc = gql`
    fragment EnVkvElektroFragment on EnVkvElektro {
        __typename
        consumptionCombined
        co2Combined
        rangeElectric
        headline
        additionalTransmissionPerformance
    }
`;
export const EnVkvPlugInHybridFragmentFragmentDoc = gql`
    fragment EnVkvPlugInHybridFragment on EnVkvPlugInHybrid {
        __typename
        consumptionCombinedLitres
        consumptionCombinedElectric
        co2Combined
        consumptionCombinedDischargedBattery
        co2CombinedDischargedBattery
        co2ClassDischargedBattery
        headline
        additionalTransmissionPerformance
    }
`;
export const EnVkvWasserstoffFragmentFragmentDoc = gql`
    fragment EnVkvWasserstoffFragment on EnVkvWasserstoff {
        __typename
        energyCombined
        co2Combined
        range
        headline
        additionalTransmissionPerformance
    }
`;
export const TeaserFragmentFragmentDoc = gql`
    fragment TeaserFragment on Campaign {
        id
        slug
        teaserCopy
        teaserHeadline
        startDate
        title
        endDate
        heroImage {
            ...Image
        }
        heroImageCaption
        modelForAnnouncement {
            slug
            co2Class
            name
            envkv {
                __typename
                ... on EnVkvVerbrennerHybrid {
                    ...EnVkvVerbrennerHybridFragment
                }
                ... on EnVkvElektro {
                    ...EnVkvElektroFragment
                }
                ... on EnVkvPlugInHybrid {
                    ...EnVkvPlugInHybridFragment
                }
                ... on EnVkvWasserstoff {
                    ...EnVkvWasserstoffFragment
                }
            }
        }
        content {
            __typename
            ... on SalesCampaignContent {
                isBusinessCampaign
                highlightBannerHeadline
                highlightBannerHeadlinePersonalized
                highlightBannerSubheadline
                highlightBannerSubheadlinePersonalized
                minimumShortTitle
            }
            ... on AfterSale {
                minimumShortTitle
            }
            ... on ModellAnkuendigungContent {
                minimumShortTitle
            }
        }
    }
`;
export const CampaignOverviewFragmentFragmentDoc = gql`
    fragment CampaignOverviewFragment on Campaign {
        ...TeaserFragment
    }
`;
export const HomeCampaignFragmentFragmentDoc = gql`
    fragment HomeCampaignFragment on Campaign {
        ...TeaserFragment
    }
`;
export const BusinessCustomerCampaignFragmentFragmentDoc = gql`
    fragment BusinessCustomerCampaignFragment on Campaign {
        ...TeaserFragment
    }
`;
export const ModelForAnnouncementFragmentFragmentDoc = gql`
    fragment ModelForAnnouncementFragment on Model {
        name
        heroImage {
            ...Image
        }
        logoImages {
            ...Image
        }
        slug
        categories
        msrLink
        co2Class
        contentImages {
            ...Image
        }
        contentHeadline
        contentCopy {
            html
        }
        keyFacts {
            label
            value
            unit
        }
        cwModelUrl
        formModelId
        formGenerationId
        formBodyId
        legalTexts {
            html
        }
        envkv {
            __typename
            ... on EnVkvVerbrennerHybrid {
                ...EnVkvVerbrennerHybridFragment
            }
            ... on EnVkvElektro {
                ...EnVkvElektroFragment
            }
            ... on EnVkvPlugInHybrid {
                ...EnVkvPlugInHybridFragment
            }
            ... on EnVkvWasserstoff {
                ...EnVkvWasserstoffFragment
            }
        }
    }
`;
export const ModellAnkuendigungContentFragmentFragmentDoc = gql`
    fragment ModellAnkuendigungContentFragment on ModellAnkuendigungContent {
        __typename
        promotionInModellPalette
        warrantyLogo1 {
            ...Image
        }
        warrantyLogo2 {
            ...Image
        }
        warrantyLogo3 {
            ...Image
        }
        minimumShortTitle
    }
`;
export const AfterSalesServiceFragmentFragmentDoc = gql`
    fragment AfterSalesServiceFragment on CampaignAfterSalesService {
        id
        title
        serviceId
        longDescription
        shortDescription
        bulletlist {
            text
        }
        icon {
            ...Image
        }
        image {
            ...Image
        }
        footnote {
            id
        }
        trackingName
        serviceCheckout
    }
`;
export const AfterSalesAccesoryFragmentFragmentDoc = gql`
    fragment AfterSalesAccesoryFragment on CampaignAfterSalesAccesory {
        id
        title
        articleNumber
        shopSearchTerm
        accesoryId
        longDescription
        shortDescription
        utmCreativeFormatParam
        highlightTeaserImage {
            ...Image
        }
        bulletlist {
            text
        }
        icon {
            ...Image
        }
        image {
            ...Image
        }
        footnote {
            id
        }
        mailToLink
    }
`;
export const AfterSalesContentFragmentFragmentDoc = gql`
    fragment AfterSalesContentFragment on AfterSale {
        __typename
        id
        minimumShortTitle
        afterSalesServices(first: 100) {
            ...AfterSalesServiceFragment
        }
        afterSalesAccesories(first: 100) {
            ...AfterSalesAccesoryFragment
        }
    }
`;
export const ModelFragmentFragmentDoc = gql`
    fragment ModelFragment on Model {
        __typename
        msrLink
        name
        slug
        formIdentifier
        co2ClassText: co2Class
        envkv {
            __typename
            ... on EnVkvVerbrennerHybrid {
                ...EnVkvVerbrennerHybridFragment
            }
            ... on EnVkvElektro {
                ...EnVkvElektroFragment
            }
            ... on EnVkvPlugInHybrid {
                ...EnVkvPlugInHybridFragment
            }
            ... on EnVkvWasserstoff {
                ...EnVkvWasserstoffFragment
            }
        }
        vehicleMarketFilterParams
        disableTestdrive
    }
`;
export const VehicleFragmentFragmentDoc = gql`
    fragment VehicleFragment on Vehicle {
        __typename
        co2Class
        trim
        powerPs
        powerKw
        model {
            name
            formIdentifier
            slug
            vehicleMarketFilterParams
            disableTestdrive
        }
        version
        envkv {
            ...EnVkvElektroFragment
            ...EnVkvPlugInHybridFragment
            ...EnVkvVerbrennerHybridFragment
        }
        trimAndEnvkvString
        fuelType
    }
`;
export const SalesCampaignModelFragmentFragmentDoc = gql`
    fragment SalesCampaignModelFragment on SalesCampaignModel {
        id
        name
        mobileId
        leasingHeadline
        leasingSubheadline
        cashPriceHeadline
        cashPriceSubheadline
        financingHeadline
        financingSubheadline
        contentHeadline
        contentCopy
        contentImage {
            ...Image
        }
        imageCaption
        contentImageCaption
        image {
            ...Image
        }
        bankCodes {
            code
            footnoteContent
        }
        keyFact1 {
            label
            value
            unit
        }
        keyFact2 {
            label
            value
            unit
        }
        envkvDataSource {
            ...ModelFragment
            ...VehicleFragment
        }
        envkvDataSourceTeaser {
            ...ModelFragment
            ...VehicleFragment
        }
        disableEnvkvDataTeaser
        deepLinkUtmCreativeValue
        nationalLeasingRate
        nationalLeasingSpecialPayment
        nationalDuration
        nationalTotalMileage
        nationalPricesDisclaimer
        nationalPricingType
        nationalCashPrice
        cashPriceCopy
        nationalMonthlyRate
        nationalFinalRate
        nationalFixedDebitRate
        nationalEffectiveAnnualRate
        nationalDownPaymentFinance
        nationalTotalAmount
        nationalNetLoanAmount
        nationalVehiclePriceFinance
        nationalPriceFootnote {
            id
        }
        nationalPriceFootnoteCash {
            id
        }
        nationalPriceFootnoteFinance {
            id
        }
        dealerPriceFootnoteLeasing {
            id
            content {
                text
            }
        }
        dealerPriceFootnoteCash {
            id
            content {
                text
            }
        }
        dealerPriceFootnoteFinance {
            id
            content {
                text
            }
        }
        offerImage {
            ...Image
        }
        offerImageCaption
        highlightBadgePrefix
        highlightBadgePrefixDealer
        highlightBadgeValue
        highlightBadgeUnit
        highlightBadgeKurztext
        highlightBadgeUnitNationalFootnote {
            id
        }
        highlightBadgeUnitDealerFootnote {
            id
        }
        model {
            slug
            formIdentifier
            vehicleMarketFilterParams
            disableTestdrive
        }
    }
`;
export const SalesCampaignContentFragmentFragmentDoc = gql`
    fragment SalesCampaignContentFragment on SalesCampaignContent {
        isBusinessCampaign
        salesCampaignSpecificModels {
            ...SalesCampaignModelFragment
        }
        warrantyLogo1 {
            ...Image
        }
        warrantyLogo2 {
            ...Image
        }
        warrantyLogo3 {
            ...Image
        }
        minimumShortTitle
        testdriveUrlOverride
        offerformUrlOverride
        highlightBannerHeadline
        highlightBannerHeadlinePersonalized
        highlightBannerSubheadline
        highlightBannerSubheadlinePersonalized
        highlightModuleHeadline
        highlightModuleHeadlinePersonalized
        highlightModuleImageCaption
        highlightModuleBadge
        highlightModuleBadgePersonalized
        highlightModuleSubheadline
        highlightModuleSubheadlinePersonalized
        highlightModuleCopy
        highlightModuleCopyPersonalized
        highlightModuleCopy2
        highlightModuleCopy2Personalized
        highlightModuleAsset {
            ...Image
        }
    }
`;
export const CampaignDetailFragmentFragmentDoc = gql`
    fragment CampaignDetailFragment on Campaign {
        ...TeaserFragment
        heroHeadline
        legalLines
        kmpCode
        modelForAnnouncement {
            ...ModelForAnnouncementFragment
        }
        models {
            id
            name
            publishedAt
            contentHeadline
            contentHeadline
            legalTexts {
                html
            }
            formGenerationId
            formBodyId
        }
        metaDescriptionOverride
        content {
            ...ModellAnkuendigungContentFragment
            ...AfterSalesContentFragment
            ...SalesCampaignContentFragment
        }
        utmMapping {
            utmTerm
            mappingValue
        }
    }
`;
export const SalesCampaignModelOnlyModelFragmentFragmentDoc = gql`
    fragment SalesCampaignModelOnlyModelFragment on SalesCampaignModel {
        id
        modelCode
    }
`;
export const OpeningFragmentDoc = gql`
    fragment Opening on Opening {
        from
        to
        ranges {
            start
            end
        }
    }
`;
export const BaseDealerFieldsFragmentDoc = gql`
    fragment BaseDealerFields on Dealer {
        dealerId
        mobileSellerId
        sapId
        dealerType
        name
        name2
        name3
        slug
        state
        inseratMailRecipients
        parentDealer {
            dealerId
            slug
            hasHws
        }
        openingTimesService {
            ...Opening
        }
        openingTimesParts {
            ...Opening
        }
        openingTimesSales {
            ...Opening
        }
        contact {
            phone
            email
            fax
        }
        address {
            zip
            street
            city
            houseNumber
        }
        whatsappNumber
        socialFacebook
        socialInstagram
        socialX
        socialYouTube
        socialLinkedIn
        socialTikTok
        hPromise
        partsStore
    }
`;
export const SubDealerFieldsFragmentDoc = gql`
    fragment SubDealerFields on Dealer {
        ...BaseDealerFields
    }
`;
export const MainDealerFieldsFragmentDoc = gql`
    fragment MainDealerFields on Dealer {
        ...BaseDealerFields
        hPromise
        businessCenter
        requireLogin
        partsStore
        regionsnummerDlv
        campaignKey {
            teaserHeadline
            teaserCopy
            slug
            campaignType
            content {
                __typename
                ... on SalesCampaignContent {
                    isBusinessCampaign
                    minimumShortTitle
                }
                ... on ModellAnkuendigungContent {
                    minimumShortTitle
                }
                ... on AfterSale {
                    minimumShortTitle
                }
            }
            modelForAnnouncement {
                slug
            }
        }
        campaignsRegular(first: 1) {
            id
        }
        careerUrl
        managingDirector
        hasHws
        subDealers(first: 16) {
            ...SubDealerFields
        }
    }
`;
export const ExportBaseDealerFieldsFragmentDoc = gql`
    fragment ExportBaseDealerFields on Dealer {
        id
        dealerId
        mobileSellerId
        sapId
        dealerType
        name
        name2
        name3
        slug
        state
        inseratMailRecipients
        parentDealer {
            dealerId
        }
        openingTimesService {
            id
        }
        openingTimesParts {
            id
        }
        openingTimesSales {
            id
        }
        contact {
            phone
            email
            fax
        }
        address {
            zip
            street
            city
            houseNumber
        }
        socialFacebook
        socialInstagram
        socialX
        socialYouTube
        socialLinkedIn
        socialTikTok
        hPromise
        partsStore
    }
`;
export const ExportDealerFieldsFragmentDoc = gql`
    fragment ExportDealerFields on Dealer {
        ...ExportBaseDealerFields
        hPromise
        businessCenter
        requireLogin
        partsStore
        campaignKey {
            teaserHeadline
        }
        campaignsRegular {
            id
        }
        careerUrl
        managingDirector
        hasHws
        hasHcm
        subDealers(first: 16) {
            id
            dealerId
        }
        auth0User {
            email
        }
        oldSlugs
        hwsOrderDate
        hwsStartDate
        hwsEndDate
        firstBillingMonth
        hcmUrl
        regionsnummerDlv
    }
`;
export const GeneralServicesFieldsFragmentDoc = gql`
    fragment GeneralServicesFields on GeneralService {
        id
        image {
            ...Image
        }
        headline
        copy
        icon {
            url
            width
            height
            mimeType
            alt
        }
        link {
            url
            title
        }
        default
        trackingName
    }
`;
export const HomeTeaserFieldsFragmentDoc = gql`
    fragment HomeTeaserFields on HomeTeaser {
        id
        image {
            url
            alt
        }
        text
        targetSlug
        createdAt
    }
`;
export const BusinessWarrantyFragmentFragmentDoc = gql`
    fragment BusinessWarrantyFragment on Warranty {
        headline
        image {
            ...Image
        }
        copy
        bulletlist {
            text
            icon {
                ...Image
            }
        }
        downloadPdf {
            ...Image
        }
    }
`;
export const WarrantyFragmentFragmentDoc = gql`
    fragment WarrantyFragment on Warranty {
        headline
        image {
            ...Image
        }
        copy
        bulletlist {
            text
            icon {
                ...Image
            }
        }
        downloadPdf {
            url
        }
    }
`;
export const CreateAuth0UserDocument = gql`
    mutation CreateAuth0User($email: String!, $dealerId: String!, $isAdmin: Boolean!) {
        createAuth0User(data: { email: $email, dealer: { connect: { dealerId: $dealerId } }, isAdmin: $isAdmin }) {
            id
            email
        }
    }
`;
export const GetPaginatedAuth0UsersDocument = gql`
    query GetPaginatedAuth0Users($first: Int!, $skip: Int!) {
        auth0Users(first: $first, skip: $skip) {
            id
            dealer {
                dealerId
            }
            email
            isAdmin
        }
    }
`;
export const HomeCampaignDocument = gql`
    query HomeCampaign($dealerId: String!) {
        dealer(where: { dealerId: $dealerId }) {
            campaignsRegular(orderBy: startDate_DESC, first: 4, where: { content_empty: false }) {
                ...HomeCampaignFragment
            }
            campaignKey {
                ...HomeCampaignFragment
            }
        }
    }
    ${HomeCampaignFragmentFragmentDoc}
    ${TeaserFragmentFragmentDoc}
    ${ImageFragmentDoc}
    ${EnVkvVerbrennerHybridFragmentFragmentDoc}
    ${EnVkvElektroFragmentFragmentDoc}
    ${EnVkvPlugInHybridFragmentFragmentDoc}
    ${EnVkvWasserstoffFragmentFragmentDoc}
`;
export const BusinessCustomerCampaignsDocument = gql`
    query BusinessCustomerCampaigns($dealerId: String!) {
        dealer(where: { dealerId: $dealerId }) {
            campaignsRegular(
                orderBy: startDate_DESC
                first: 4
                where: { content: { SalesCampaignContent: { isBusinessCampaign: true } } }
            ) {
                ...BusinessCustomerCampaignFragment
            }
            campaignKey {
                ...BusinessCustomerCampaignFragment
            }
        }
    }
    ${BusinessCustomerCampaignFragmentFragmentDoc}
    ${TeaserFragmentFragmentDoc}
    ${ImageFragmentDoc}
    ${EnVkvVerbrennerHybridFragmentFragmentDoc}
    ${EnVkvElektroFragmentFragmentDoc}
    ${EnVkvPlugInHybridFragmentFragmentDoc}
    ${EnVkvWasserstoffFragmentFragmentDoc}
`;
export const OverviewCampaignsDocument = gql`
    query OverviewCampaigns($dealerId: String!) {
        dealer(where: { dealerId: $dealerId }) {
            campaignsRegular(orderBy: startDate_DESC, where: { content_empty: false }, last: 100) {
                ...CampaignOverviewFragment
            }
            campaignKey {
                ...CampaignOverviewFragment
            }
        }
    }
    ${CampaignOverviewFragmentFragmentDoc}
    ${TeaserFragmentFragmentDoc}
    ${ImageFragmentDoc}
    ${EnVkvVerbrennerHybridFragmentFragmentDoc}
    ${EnVkvElektroFragmentFragmentDoc}
    ${EnVkvPlugInHybridFragmentFragmentDoc}
    ${EnVkvWasserstoffFragmentFragmentDoc}
`;
export const LatestAfterSalesCampaignDocument = gql`
    query LatestAfterSalesCampaign($dealerId: String!) {
        campaigns(
            where: {
                OR: [
                    { dealersRegularCampaigns_some: { dealerId: $dealerId } }
                    { dealersKeyCampaigns_some: { dealerId: $dealerId } }
                ]
                content: { AfterSale: { id_not: "null" } }
            }
            first: 1
            orderBy: startDate_ASC
        ) {
            content {
                ... on AfterSale {
                    __typename
                    minimumShortTitle
                    afterSalesServices {
                        title
                        id
                        shortDescription
                        longDescription
                    }
                }
            }
        }
        campaigns(
            where: {
                OR: [
                    { dealersRegularCampaigns_some: { dealerId: $dealerId } }
                    { dealersKeyCampaigns_some: { dealerId: $dealerId } }
                ]
                content: { AfterSale: { id_not: "null" } }
            }
            first: 1
            orderBy: startDate_ASC
        ) {
            id
            content {
                ... on AfterSale {
                    __typename
                    minimumShortTitle
                    id
                    afterSalesServices {
                        ...AfterSalesServiceFragment
                    }
                }
            }
        }
    }
    ${AfterSalesServiceFragmentFragmentDoc}
    ${ImageFragmentDoc}
`;
export const OverviewTestCampaignsDocument = gql`
    query OverviewTESTCampaigns($dealerId: String!) {
        dealer(where: { dealerId: $dealerId }) {
            campaignsRegular(
                orderBy: startDate_DESC
                where: { content: { ModellAnkuendigungContent: { model: { id_not: "''" } } } }
            ) {
                ...CampaignOverviewFragment
            }
            campaignKey {
                ...CampaignOverviewFragment
            }
        }
    }
    ${CampaignOverviewFragmentFragmentDoc}
    ${TeaserFragmentFragmentDoc}
    ${ImageFragmentDoc}
    ${EnVkvVerbrennerHybridFragmentFragmentDoc}
    ${EnVkvElektroFragmentFragmentDoc}
    ${EnVkvPlugInHybridFragmentFragmentDoc}
    ${EnVkvWasserstoffFragmentFragmentDoc}
`;
export const CampaignDetailDocument = gql`
    query CampaignDetail($dealerId: String!, $slug: String!) {
        campaigns(
            where: {
                slug: $slug
                content_empty: false
                AND: {
                    OR: [
                        { dealersKeyCampaigns_some: { dealerId: $dealerId } }
                        { dealersRegularCampaigns_some: { dealerId: $dealerId } }
                    ]
                }
            }
        ) {
            ...CampaignDetailFragment
        }
    }
    ${CampaignDetailFragmentFragmentDoc}
    ${TeaserFragmentFragmentDoc}
    ${ImageFragmentDoc}
    ${EnVkvVerbrennerHybridFragmentFragmentDoc}
    ${EnVkvElektroFragmentFragmentDoc}
    ${EnVkvPlugInHybridFragmentFragmentDoc}
    ${EnVkvWasserstoffFragmentFragmentDoc}
    ${ModelForAnnouncementFragmentFragmentDoc}
    ${ModellAnkuendigungContentFragmentFragmentDoc}
    ${AfterSalesContentFragmentFragmentDoc}
    ${AfterSalesServiceFragmentFragmentDoc}
    ${AfterSalesAccesoryFragmentFragmentDoc}
    ${SalesCampaignContentFragmentFragmentDoc}
    ${SalesCampaignModelFragmentFragmentDoc}
    ${ModelFragmentFragmentDoc}
    ${VehicleFragmentFragmentDoc}
`;
export const CampaignIdByCodeDocument = gql`
    query CampaignIdByCode($importCode: String!) {
        campaigns(where: { importCode: $importCode, content_empty: false }) {
            id
            content {
                __typename
                ... on SalesCampaignContent {
                    salesCampaignSpecificModels {
                        ...SalesCampaignModelOnlyModelFragment
                    }
                }
            }
        }
    }
    ${SalesCampaignModelOnlyModelFragmentFragmentDoc}
`;
export const ModelIdByCodeDocument = gql`
    query ModelIdByCode($modelCode: String!) {
        model(where: { modelCode: $modelCode }) {
            id
        }
    }
`;
export const VehicleIdByCodeDocument = gql`
    query VehicleIdByCode($trimCode: String!) {
        vehicle(where: { modelcode: $trimCode }) {
            id
        }
    }
`;
export const UpsertDealerDocument = gql`
    mutation UpsertDealer($dealerId: String!, $dealer: DealerUpsertInput!) {
        upsertDealer(upsert: $dealer, where: { dealerId: $dealerId }) {
            id
            dealerId
            name
        }
    }
`;
export const InsertDealerDocument = gql`
    mutation InsertDealer($dealer: DealerCreateInput!) {
        createDealer(data: $dealer) {
            id
            dealerId
            name
        }
    }
`;
export const UpdateDealerDocument = gql`
    mutation updateDealer($dealerId: ID!, $dealer: DealerUpdateInput!) {
        updateDealer(where: { id: $dealerId }, data: $dealer) {
            id
            dealerId
            name
        }
    }
`;
export const AddParentDealerToDealerDocument = gql`
    mutation AddParentDealerToDealer($dealerId: ID!, $parentDealerId: ID!) {
        updateDealer(where: { id: $dealerId }, data: { parentDealer: { connect: { id: $parentDealerId } } }) {
            id
            dealerId
            name
        }
    }
`;
export const PublishDealersDocument = gql`
    mutation PublishDealers($dealerIds: [ID!]!) {
        publishManyDealers(where: { id_in: $dealerIds }, to: PUBLISHED) {
            count
        }
    }
`;
export const DealerDocument = gql`
    query Dealer($slug: String!) {
        dealer(where: { slug: $slug }) {
            ...MainDealerFields
        }
    }
    ${MainDealerFieldsFragmentDoc}
    ${BaseDealerFieldsFragmentDoc}
    ${OpeningFragmentDoc}
    ${SubDealerFieldsFragmentDoc}
`;
export const DealersDocument = gql`
    query Dealers {
        dealers {
            ...MainDealerFields
        }
    }
    ${MainDealerFieldsFragmentDoc}
    ${BaseDealerFieldsFragmentDoc}
    ${OpeningFragmentDoc}
    ${SubDealerFieldsFragmentDoc}
`;
export const SubDealersDocument = gql`
    query SubDealers($dealerId: String!) {
        dealer(where: { dealerId: $dealerId }) {
            subDealers(first: 16) {
                ...SubDealerFields
            }
        }
    }
    ${SubDealerFieldsFragmentDoc}
    ${BaseDealerFieldsFragmentDoc}
    ${OpeningFragmentDoc}
`;
export const GetPaginatedDealerSlugsDocument = gql`
    query GetPaginatedDealerSlugs($first: Int!, $skip: Int!) {
        dealers(first: $first, skip: $skip) {
            id
            dealerId
            slug
        }
    }
`;
export const GetPaginatedActiveDealerSlugsDocument = gql`
    query GetPaginatedActiveDealerSlugs($first: Int!, $skip: Int!) {
        dealers(where: { hasHws: true, requireLogin: false, dealerId_not: "1001" }, first: $first, skip: $skip) {
            id
            dealerId
            slug
        }
    }
`;
export const GetDealerSlugByDealerIdDocument = gql`
    query GetDealerSlugByDealerId($dealerId: String!) {
        dealer(where: { dealerId: $dealerId }) {
            slug
            hasHws
        }
    }
`;
export const GetDealerDealerIdDocument = gql`
    query GetDealerDealerId($dealerId: String!) {
        dealer(where: { dealerId: $dealerId }) {
            ...BaseDealerFields
            subDealers(first: 16) {
                dealerId
            }
        }
    }
    ${BaseDealerFieldsFragmentDoc}
    ${OpeningFragmentDoc}
`;
export const GetPaginatedDealersDocument = gql`
    query GetPaginatedDealers($first: Int!, $skip: Int!) {
        dealers(first: $first, skip: $skip) {
            id
            ...MainDealerFields
        }
    }
    ${MainDealerFieldsFragmentDoc}
    ${BaseDealerFieldsFragmentDoc}
    ${OpeningFragmentDoc}
    ${SubDealerFieldsFragmentDoc}
`;
export const GetPaginatedActiveDealerExportDocument = gql`
    query GetPaginatedActiveDealerExport($first: Int!, $skip: Int!) {
        dealers(where: { hasHws: true }, first: $first, skip: $skip) {
            id
            dealerId
            dealerType
            name
            name2
            name3
            slug
            address {
                zip
                street
                city
            }
            contact {
                email
            }
        }
    }
`;
export const GetPaginatedDealersExportDocument = gql`
    query GetPaginatedDealersExport($first: Int!, $skip: Int!) {
        dealers(first: $first, skip: $skip) {
            id
            ...ExportDealerFields
        }
    }
    ${ExportDealerFieldsFragmentDoc}
    ${ExportBaseDealerFieldsFragmentDoc}
`;
export const GetDealerSlugByOldSlugDocument = gql`
    query getDealerSlugByOldSlug($oldSlug: String!) {
        dealers(where: { oldSlugs_contains_some: [$oldSlug], hasHws: true, requireLogin: false }, first: 1) {
            slug
        }
    }
`;
export const GetPaginatedHcmDealersDocument = gql`
    query getPaginatedHCMDealers($first: Int!, $skip: Int!) {
        dealers(
            where: {
                dealerId_not: "1001"
                mobileSellerId_not: "no mobile.de account"
                OR: [{ hasHws: true }, { hasHcm: true }, { parentDealer: { hasHws: true } }]
            }
            first: $first
            skip: $skip
        ) {
            id
            slug
            dealerId
            mobileSellerId
            name
            hasHws
            hasHcm
            hPromise
            parentDealer {
                id
                name
                dealerId
                mobileSellerId
                hasHws
                hasHcm
                hPromise
            }
        }
    }
`;
export const GetDealersWithoutHcmAndHwsDocument = gql`
    query getDealersWithoutHCMAndHWS($first: Int, $skip: Int) {
        dealers(
            where: {
                AND: [
                    { hasHws: false }
                    { hasHcm: false }
                    { OR: [{ parentDealer: null }, { parentDealer: { hasHws: false, hasHcm: false } }] }
                ]
            }
            first: $first
            skip: $skip
        ) {
            id
            slug
            dealerId
            mobileSellerId
            name
            hasHws
            hasHcm
            parentDealer {
                id
                name
                dealerId
                mobileSellerId
                hasHws
                hasHcm
                hPromise
            }
        }
    }
`;
export const GetPaginatedCarMarketDealerIdsDocument = gql`
    query getPaginatedCarMarketDealerIds($first: Int!, $skip: Int!) {
        dealers(where: { hasHcm: true, mobileSellerId_not: "no mobile.de account" }, first: $first, skip: $skip) {
            dealerId
            mobileSellerId
        }
    }
`;
export const FootnotesByIdsDocument = gql`
    query FootnotesByIds($ids: [ID!]!) {
        footnotes(where: { id_in: $ids }) {
            id
            content {
                html
            }
            fixedSign
        }
    }
`;
export const GeneralServicesDocument = gql`
    query GeneralServices {
        generalServices(first: 100) {
            ...GeneralServicesFields
        }
    }
    ${GeneralServicesFieldsFragmentDoc}
    ${ImageFragmentDoc}
`;
export const SelectedGeneralServicesDocument = gql`
    query SelectedGeneralServices($ids: [ID]!) {
        generalServices(first: 100, where: { id_in: $ids }) {
            ...GeneralServicesFields
        }
    }
    ${GeneralServicesFieldsFragmentDoc}
    ${ImageFragmentDoc}
`;
export const GetHomeTeasersIgnoreDealerTypeDocument = gql`
    query GetHomeTeasersIgnoreDealerType($partsStore: Boolean!, $hPromise: Boolean!, $businessCenter: Boolean!) {
        homeTeasers(
            where: {
                AND: [
                    { OR: [{ partsStore: false }, { partsStore: $partsStore }] }
                    { OR: [{ hPromise: false }, { hPromise: $hPromise }] }
                    { OR: [{ businessCenter: false }, { businessCenter: $businessCenter }] }
                ]
            }
        ) {
            ...HomeTeaserFields
        }
    }
    ${HomeTeaserFieldsFragmentDoc}
`;
export const GetHomeTeasersDocument = gql`
    query GetHomeTeasers(
        $dealerType: DealerType!
        $partsStore: Boolean!
        $hPromise: Boolean!
        $businessCenter: Boolean!
    ) {
        homeTeasers(
            where: {
                AND: [
                    { OR: [{ dealerType: SalesService }, { dealerType: $dealerType }] }
                    { OR: [{ partsStore: false }, { partsStore: $partsStore }] }
                    { OR: [{ hPromise: false }, { hPromise: $hPromise }] }
                    { OR: [{ businessCenter: false }, { businessCenter: $businessCenter }] }
                ]
            }
        ) {
            ...HomeTeaserFields
        }
    }
    ${HomeTeaserFieldsFragmentDoc}
`;
export const ModelListDocument = gql`
    query ModelList {
        models(first: 100) {
            name
            alternativerModelListName
            image {
                ...Image
            }
            slug
            categories
            campaigns(first: 1) {
                id
            }
            modelAnnouncementCampaign {
                slug
            }
            order
            vehicleMarketFilterParams
            disableTestdrive
        }
    }
    ${ImageFragmentDoc}
`;
export const ModelDetailDocument = gql`
    query ModelDetail($slug: String!) {
        model(where: { slug: $slug }) {
            name
            alternativeModelDetailName
            heroImage {
                ...Image
            }
            heroImageCaption
            heroVideoUrl
            logoImages {
                ...Image
            }
            slug
            categories
            msrLink
            co2Class
            contentImages {
                ...Image
            }
            contentImagesCaption
            contentHeadline
            contentCopy {
                html
            }
            keyFacts {
                label
                value
                unit
            }
            cwModelUrl
            formIdentifier
            legalTexts {
                html
            }
            vehicleMarketFilterParams
            disableTestdrive
            faq {
                headline
                questions {
                    id
                    question
                    answer {
                        html
                        text
                    }
                }
            }
            trimAndEnvkvString
            alternativeEnvkvVehicle {
                trimAndEnvkvString
            }
            campaigns {
                teaserHeadline
                teaserCopy
                slug
                content {
                    __typename
                    ... on SalesCampaignContent {
                        minimumShortTitle
                    }
                    ... on AfterSale {
                        minimumShortTitle
                    }
                }
            }
            modelAnnouncementCampaign {
                id
                slug
                teaserCopy
                teaserHeadline
                startDate
                title
                endDate
                kmpCode
                heroImage {
                    ...Image
                }
                content {
                    __typename
                    ... on ModellAnkuendigungContent {
                        promotionInModellPalette
                        warrantyLogo1 {
                            ...Image
                        }
                        warrantyLogo2 {
                            ...Image
                        }
                        warrantyLogo3 {
                            ...Image
                        }
                    }
                }
            }
        }
    }
    ${ImageFragmentDoc}
`;
export const GetModelByNameDocument = gql`
    query GetModelByName($modelName: String!) {
        models(where: { name: $modelName }) {
            id
            name
        }
    }
`;
export const ModelEnvkvDropdownDocument = gql`
    query ModelEnvkvDropdown {
        models(first: 100, orderBy: name_ASC) {
            name
            id
            slug
            modelCode
            formIdentifier
        }
    }
`;
export const OverlayBatteryCertificateDocument = gql`
    query OverlayBatteryCertificate {
        overlayBatteryCertificates(first: 1, orderBy: publishedAt_DESC) {
            heroText
            heroSubheadline
            heroHeadline
            heroImage {
                ...Image
            }
            contentHeadline
            contentSubheadline
            contentText {
                html
            }
            contentImage {
                ...Image
            }
            boxHeadline
            legalLines {
                html
            }
            contentList {
                headline
                text
            }
            boxList {
                text
                headline
            }
        }
    }
    ${ImageFragmentDoc}
`;
export const PageAboutUsDocument = gql`
    query PageAboutUs {
        pageAboutUses(first: 1, orderBy: publishedAt_DESC) {
            heroImage {
                ...Image
            }
            employeePlaceholder {
                ...Image
            }
            jobsHeadline
        }
    }
    ${ImageFragmentDoc}
`;
export const JobsDefaultBulletsDocument = gql`
    query JobsDefaultBullets {
        pageAboutUses(first: 1, orderBy: publishedAt_DESC) {
            jobsDefaultBullets {
                id
                text
            }
        }
    }
`;
export const PageBusinessCustomersDocument = gql`
    query PageBusinessCustomers {
        pageBusinessCustomers(first: 1, orderBy: publishedAt_DESC) {
            heroHeadline
            heroImage {
                ...Image
            }
            heroBulletListHeadline
            heroBulletList {
                id
                icon {
                    ...Image
                }
                text
                default
            }
            heroBulletListLinkText
            heroBulletListCtaText
            businessCenterBulletListHeadline
            businessCenterBulletList {
                icon {
                    ...Image
                }
                text
            }
            businessCenterHighlight1Image {
                ...Image
            }
            businessCenterHighlight1Headline
            businessCenterHighlight1Copy
            businessCenterHighlight2Image {
                ...Image
            }
            businessCenterHighlight2Headline
            businessCenterHighlight2Copy
            legalLines {
                html
            }
            warranty1 {
                ...BusinessWarrantyFragment
            }
            warranty2 {
                ...BusinessWarrantyFragment
            }
            faq {
                headline
                questions {
                    id
                    question
                    answer {
                        html
                        text
                    }
                }
            }
        }
    }
    ${ImageFragmentDoc}
    ${BusinessWarrantyFragmentFragmentDoc}
`;
export const GetPageHomeDocument = gql`
    query GetPageHome {
        pageHomes(first: 1, orderBy: publishedAt_DESC) {
            hcmTeaserImage {
                ...Image
            }
            hcmTeaserHeadline
            hcmTeaserCopy
            hcmTeaserCtaLabel
        }
    }
    ${ImageFragmentDoc}
`;
export const PageHyundaiPromiseDocument = gql`
    query PageHyundaiPromise {
        pageHyundaiPromises(first: 1, orderBy: publishedAt_DESC) {
            heroHeadline
            heroImage {
                ...Image
            }
            heroBulletListHeadline
            heroBulletListItems {
                text
                icon {
                    ...Image
                }
            }
            faq {
                headline
                questions {
                    id
                    question
                    answer {
                        html
                        text
                    }
                }
            }
            heroBulletListLinkText
            heroCtaText
            heroCtaTarget
            contentHeadline
            contentImage {
                ...Image
            }
            contentCopy
            contentCtaText
            contentCtaTarget
            contentBulletListHeadline
            contentBulletList {
                text
                icon {
                    ...Image
                }
            }
            legalLines {
                html
            }
            video {
                url
            }
            videoHeadline
            videoCtaText
            videoCtaTarget
            videoCopy
        }
    }
    ${ImageFragmentDoc}
`;
export const PageServiceDocument = gql`
    query PageService {
        pageServices(first: 1, orderBy: publishedAt_DESC) {
            headline
            subHeadline
            heroImage {
                ...Image
            }
            defaultBullets(first: 100) {
                id
                icon {
                    ...Image
                }
                text
                default
            }
            faq {
                headline
                questions {
                    id
                    question
                    answer {
                        html
                        text
                    }
                }
            }
            partStoreTeaserImage {
                ...Image
            }
        }
    }
    ${ImageFragmentDoc}
`;
export const PageWarrantyDocument = gql`
    query PageWarranty {
        pageWarranties(first: 1, orderBy: publishedAt_DESC) {
            heroHeadline
            heroSubHeadline
            heroCopy
            heroImage {
                ...Image
            }
            warrantyHeadline
            warranty1 {
                ...WarrantyFragment
            }
            warranty2 {
                ...WarrantyFragment
            }
            legalLines {
                html
            }
            faq {
                headline
                questions {
                    id
                    question
                    answer {
                        html
                        text
                    }
                }
            }
        }
    }
    ${ImageFragmentDoc}
    ${WarrantyFragmentFragmentDoc}
`;
export const CreateVehicleDocument = gql`
    mutation CreateVehicle($vehicle: VehicleCreateInput!) {
        createVehicle(data: $vehicle) {
            id
        }
    }
`;
export const UpdateVehicleDocument = gql`
    mutation UpdateVehicle($vehicleId: ID!, $vehicle: VehicleUpdateInput!) {
        updateVehicle(where: { id: $vehicleId }, data: $vehicle) {
            id
        }
    }
`;
export const PublishVehiclesDocument = gql`
    mutation PublishVehicles($vehicleIds: [ID!]!) {
        publishManyVehiclesConnection(where: { id_in: $vehicleIds }, to: PUBLISHED) {
            aggregate {
                count
            }
        }
    }
`;
export const FindVehicleDocument = gql`
    query FindVehicle($modelName: String!, $generation: String!, $trim: String!, $fuel: String!, $version: String!) {
        vehicles(
            where: { model: { name: $modelName }, generation: $generation, trim: $trim, fuel: $fuel, version: $version }
        ) {
            id
            model {
                name
            }
            generation
            trim
            version
        }
    }
`;
export const FindVehicleByModelCodeDocument = gql`
    query FindVehicleByModelCode($modelcode: String!) {
        vehicles(where: { modelcode: $modelcode }) {
            id
            modelcode
        }
    }
`;
export const GetVehicleByIdDocument = gql`
    query GetVehicleById($hygraphId: ID!) {
        vehicle(where: { id: $hygraphId }) {
            __typename
            co2Class
            trim
            powerPs
            powerKw
            model {
                name
                formIdentifier
                slug
                vehicleMarketFilterParams
                disableTestdrive
            }
            version
            envkv {
                ...EnVkvElektroFragment
                ...EnVkvPlugInHybridFragment
                ...EnVkvVerbrennerHybridFragment
            }
            trimAndEnvkvString
            fuelType
        }
    }
    ${EnVkvElektroFragmentFragmentDoc}
    ${EnVkvPlugInHybridFragmentFragmentDoc}
    ${EnVkvVerbrennerHybridFragmentFragmentDoc}
`;
export const FindVehicleByModelCodeAndGenerationDocument = gql`
    query FindVehicleByModelCodeAndGeneration($where: VehicleWhereInput!) {
        vehicles(where: $where, last: 100) {
            id
            modelcode
            generation
            trimAndEnvkvString
            fuelType
        }
    }
`;
export const FindGenerationsByModelCodeDocument = gql`
    query FindGenerationsByModelCode($where: VehicleWhereInput!) {
        vehicles(where: $where, last: 100) {
            generation
        }
    }
`;

export type SdkFunctionWrapper = <T>(
    action: (requestHeaders?: Record<string, string>) => Promise<T>,
    operationName: string,
    operationType?: string,
    variables?: any,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
    return {
        CreateAuth0User(
            variables: CreateAuth0UserMutationVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<CreateAuth0UserMutation> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<CreateAuth0UserMutation>({
                        document: CreateAuth0UserDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'CreateAuth0User',
                'mutation',
                variables,
            );
        },
        GetPaginatedAuth0Users(
            variables: GetPaginatedAuth0UsersQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetPaginatedAuth0UsersQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetPaginatedAuth0UsersQuery>({
                        document: GetPaginatedAuth0UsersDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetPaginatedAuth0Users',
                'query',
                variables,
            );
        },
        HomeCampaign(
            variables: HomeCampaignQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<HomeCampaignQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<HomeCampaignQuery>({
                        document: HomeCampaignDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'HomeCampaign',
                'query',
                variables,
            );
        },
        BusinessCustomerCampaigns(
            variables: BusinessCustomerCampaignsQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<BusinessCustomerCampaignsQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<BusinessCustomerCampaignsQuery>({
                        document: BusinessCustomerCampaignsDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'BusinessCustomerCampaigns',
                'query',
                variables,
            );
        },
        OverviewCampaigns(
            variables: OverviewCampaignsQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<OverviewCampaignsQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<OverviewCampaignsQuery>({
                        document: OverviewCampaignsDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'OverviewCampaigns',
                'query',
                variables,
            );
        },
        LatestAfterSalesCampaign(
            variables: LatestAfterSalesCampaignQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<LatestAfterSalesCampaignQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<LatestAfterSalesCampaignQuery>({
                        document: LatestAfterSalesCampaignDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'LatestAfterSalesCampaign',
                'query',
                variables,
            );
        },
        OverviewTESTCampaigns(
            variables: OverviewTestCampaignsQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<OverviewTestCampaignsQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<OverviewTestCampaignsQuery>({
                        document: OverviewTestCampaignsDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'OverviewTESTCampaigns',
                'query',
                variables,
            );
        },
        CampaignDetail(
            variables: CampaignDetailQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<CampaignDetailQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<CampaignDetailQuery>({
                        document: CampaignDetailDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'CampaignDetail',
                'query',
                variables,
            );
        },
        CampaignIdByCode(
            variables: CampaignIdByCodeQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<CampaignIdByCodeQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<CampaignIdByCodeQuery>({
                        document: CampaignIdByCodeDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'CampaignIdByCode',
                'query',
                variables,
            );
        },
        ModelIdByCode(
            variables: ModelIdByCodeQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<ModelIdByCodeQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<ModelIdByCodeQuery>({
                        document: ModelIdByCodeDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'ModelIdByCode',
                'query',
                variables,
            );
        },
        VehicleIdByCode(
            variables: VehicleIdByCodeQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<VehicleIdByCodeQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<VehicleIdByCodeQuery>({
                        document: VehicleIdByCodeDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'VehicleIdByCode',
                'query',
                variables,
            );
        },
        UpsertDealer(
            variables: UpsertDealerMutationVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<UpsertDealerMutation> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<UpsertDealerMutation>({
                        document: UpsertDealerDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'UpsertDealer',
                'mutation',
                variables,
            );
        },
        InsertDealer(
            variables: InsertDealerMutationVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<InsertDealerMutation> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<InsertDealerMutation>({
                        document: InsertDealerDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'InsertDealer',
                'mutation',
                variables,
            );
        },
        updateDealer(
            variables: UpdateDealerMutationVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<UpdateDealerMutation> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<UpdateDealerMutation>({
                        document: UpdateDealerDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'updateDealer',
                'mutation',
                variables,
            );
        },
        AddParentDealerToDealer(
            variables: AddParentDealerToDealerMutationVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<AddParentDealerToDealerMutation> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<AddParentDealerToDealerMutation>({
                        document: AddParentDealerToDealerDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'AddParentDealerToDealer',
                'mutation',
                variables,
            );
        },
        PublishDealers(
            variables: PublishDealersMutationVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<PublishDealersMutation> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PublishDealersMutation>({
                        document: PublishDealersDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'PublishDealers',
                'mutation',
                variables,
            );
        },
        Dealer(
            variables: DealerQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<DealerQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<DealerQuery>({
                        document: DealerDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'Dealer',
                'query',
                variables,
            );
        },
        Dealers(
            variables?: DealersQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<DealersQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<DealersQuery>({
                        document: DealersDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'Dealers',
                'query',
                variables,
            );
        },
        SubDealers(
            variables: SubDealersQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<SubDealersQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<SubDealersQuery>({
                        document: SubDealersDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'SubDealers',
                'query',
                variables,
            );
        },
        GetPaginatedDealerSlugs(
            variables: GetPaginatedDealerSlugsQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetPaginatedDealerSlugsQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetPaginatedDealerSlugsQuery>({
                        document: GetPaginatedDealerSlugsDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetPaginatedDealerSlugs',
                'query',
                variables,
            );
        },
        GetPaginatedActiveDealerSlugs(
            variables: GetPaginatedActiveDealerSlugsQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetPaginatedActiveDealerSlugsQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetPaginatedActiveDealerSlugsQuery>({
                        document: GetPaginatedActiveDealerSlugsDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetPaginatedActiveDealerSlugs',
                'query',
                variables,
            );
        },
        GetDealerSlugByDealerId(
            variables: GetDealerSlugByDealerIdQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetDealerSlugByDealerIdQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetDealerSlugByDealerIdQuery>({
                        document: GetDealerSlugByDealerIdDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetDealerSlugByDealerId',
                'query',
                variables,
            );
        },
        GetDealerDealerId(
            variables: GetDealerDealerIdQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetDealerDealerIdQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetDealerDealerIdQuery>({
                        document: GetDealerDealerIdDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetDealerDealerId',
                'query',
                variables,
            );
        },
        GetPaginatedDealers(
            variables: GetPaginatedDealersQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetPaginatedDealersQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetPaginatedDealersQuery>({
                        document: GetPaginatedDealersDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetPaginatedDealers',
                'query',
                variables,
            );
        },
        GetPaginatedActiveDealerExport(
            variables: GetPaginatedActiveDealerExportQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetPaginatedActiveDealerExportQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetPaginatedActiveDealerExportQuery>({
                        document: GetPaginatedActiveDealerExportDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetPaginatedActiveDealerExport',
                'query',
                variables,
            );
        },
        GetPaginatedDealersExport(
            variables: GetPaginatedDealersExportQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetPaginatedDealersExportQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetPaginatedDealersExportQuery>({
                        document: GetPaginatedDealersExportDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetPaginatedDealersExport',
                'query',
                variables,
            );
        },
        getDealerSlugByOldSlug(
            variables: GetDealerSlugByOldSlugQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetDealerSlugByOldSlugQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetDealerSlugByOldSlugQuery>({
                        document: GetDealerSlugByOldSlugDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'getDealerSlugByOldSlug',
                'query',
                variables,
            );
        },
        getPaginatedHCMDealers(
            variables: GetPaginatedHcmDealersQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetPaginatedHcmDealersQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetPaginatedHcmDealersQuery>({
                        document: GetPaginatedHcmDealersDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'getPaginatedHCMDealers',
                'query',
                variables,
            );
        },
        getDealersWithoutHCMAndHWS(
            variables?: GetDealersWithoutHcmAndHwsQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetDealersWithoutHcmAndHwsQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetDealersWithoutHcmAndHwsQuery>({
                        document: GetDealersWithoutHcmAndHwsDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'getDealersWithoutHCMAndHWS',
                'query',
                variables,
            );
        },
        getPaginatedCarMarketDealerIds(
            variables: GetPaginatedCarMarketDealerIdsQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetPaginatedCarMarketDealerIdsQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetPaginatedCarMarketDealerIdsQuery>({
                        document: GetPaginatedCarMarketDealerIdsDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'getPaginatedCarMarketDealerIds',
                'query',
                variables,
            );
        },
        FootnotesByIds(
            variables: FootnotesByIdsQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<FootnotesByIdsQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<FootnotesByIdsQuery>({
                        document: FootnotesByIdsDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'FootnotesByIds',
                'query',
                variables,
            );
        },
        GeneralServices(
            variables?: GeneralServicesQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GeneralServicesQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GeneralServicesQuery>({
                        document: GeneralServicesDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GeneralServices',
                'query',
                variables,
            );
        },
        SelectedGeneralServices(
            variables: SelectedGeneralServicesQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<SelectedGeneralServicesQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<SelectedGeneralServicesQuery>({
                        document: SelectedGeneralServicesDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'SelectedGeneralServices',
                'query',
                variables,
            );
        },
        GetHomeTeasersIgnoreDealerType(
            variables: GetHomeTeasersIgnoreDealerTypeQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetHomeTeasersIgnoreDealerTypeQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetHomeTeasersIgnoreDealerTypeQuery>({
                        document: GetHomeTeasersIgnoreDealerTypeDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetHomeTeasersIgnoreDealerType',
                'query',
                variables,
            );
        },
        GetHomeTeasers(
            variables: GetHomeTeasersQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetHomeTeasersQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetHomeTeasersQuery>({
                        document: GetHomeTeasersDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetHomeTeasers',
                'query',
                variables,
            );
        },
        ModelList(
            variables?: ModelListQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<ModelListQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<ModelListQuery>({
                        document: ModelListDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'ModelList',
                'query',
                variables,
            );
        },
        ModelDetail(
            variables: ModelDetailQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<ModelDetailQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<ModelDetailQuery>({
                        document: ModelDetailDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'ModelDetail',
                'query',
                variables,
            );
        },
        GetModelByName(
            variables: GetModelByNameQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetModelByNameQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetModelByNameQuery>({
                        document: GetModelByNameDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetModelByName',
                'query',
                variables,
            );
        },
        ModelEnvkvDropdown(
            variables?: ModelEnvkvDropdownQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<ModelEnvkvDropdownQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<ModelEnvkvDropdownQuery>({
                        document: ModelEnvkvDropdownDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'ModelEnvkvDropdown',
                'query',
                variables,
            );
        },
        OverlayBatteryCertificate(
            variables?: OverlayBatteryCertificateQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<OverlayBatteryCertificateQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<OverlayBatteryCertificateQuery>({
                        document: OverlayBatteryCertificateDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'OverlayBatteryCertificate',
                'query',
                variables,
            );
        },
        PageAboutUs(
            variables?: PageAboutUsQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<PageAboutUsQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PageAboutUsQuery>({
                        document: PageAboutUsDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'PageAboutUs',
                'query',
                variables,
            );
        },
        JobsDefaultBullets(
            variables?: JobsDefaultBulletsQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<JobsDefaultBulletsQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<JobsDefaultBulletsQuery>({
                        document: JobsDefaultBulletsDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'JobsDefaultBullets',
                'query',
                variables,
            );
        },
        PageBusinessCustomers(
            variables?: PageBusinessCustomersQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<PageBusinessCustomersQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PageBusinessCustomersQuery>({
                        document: PageBusinessCustomersDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'PageBusinessCustomers',
                'query',
                variables,
            );
        },
        GetPageHome(
            variables?: GetPageHomeQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetPageHomeQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetPageHomeQuery>({
                        document: GetPageHomeDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetPageHome',
                'query',
                variables,
            );
        },
        PageHyundaiPromise(
            variables?: PageHyundaiPromiseQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<PageHyundaiPromiseQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PageHyundaiPromiseQuery>({
                        document: PageHyundaiPromiseDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'PageHyundaiPromise',
                'query',
                variables,
            );
        },
        PageService(
            variables?: PageServiceQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<PageServiceQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PageServiceQuery>({
                        document: PageServiceDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'PageService',
                'query',
                variables,
            );
        },
        PageWarranty(
            variables?: PageWarrantyQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<PageWarrantyQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PageWarrantyQuery>({
                        document: PageWarrantyDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'PageWarranty',
                'query',
                variables,
            );
        },
        CreateVehicle(
            variables: CreateVehicleMutationVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<CreateVehicleMutation> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<CreateVehicleMutation>({
                        document: CreateVehicleDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'CreateVehicle',
                'mutation',
                variables,
            );
        },
        UpdateVehicle(
            variables: UpdateVehicleMutationVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<UpdateVehicleMutation> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<UpdateVehicleMutation>({
                        document: UpdateVehicleDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'UpdateVehicle',
                'mutation',
                variables,
            );
        },
        PublishVehicles(
            variables: PublishVehiclesMutationVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<PublishVehiclesMutation> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PublishVehiclesMutation>({
                        document: PublishVehiclesDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'PublishVehicles',
                'mutation',
                variables,
            );
        },
        FindVehicle(
            variables: FindVehicleQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<FindVehicleQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<FindVehicleQuery>({
                        document: FindVehicleDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'FindVehicle',
                'query',
                variables,
            );
        },
        FindVehicleByModelCode(
            variables: FindVehicleByModelCodeQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<FindVehicleByModelCodeQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<FindVehicleByModelCodeQuery>({
                        document: FindVehicleByModelCodeDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'FindVehicleByModelCode',
                'query',
                variables,
            );
        },
        GetVehicleById(
            variables: GetVehicleByIdQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<GetVehicleByIdQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GetVehicleByIdQuery>({
                        document: GetVehicleByIdDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'GetVehicleById',
                'query',
                variables,
            );
        },
        FindVehicleByModelCodeAndGeneration(
            variables: FindVehicleByModelCodeAndGenerationQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<FindVehicleByModelCodeAndGenerationQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<FindVehicleByModelCodeAndGenerationQuery>({
                        document: FindVehicleByModelCodeAndGenerationDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'FindVehicleByModelCodeAndGeneration',
                'query',
                variables,
            );
        },
        FindGenerationsByModelCode(
            variables: FindGenerationsByModelCodeQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
            signal?: RequestInit['signal'],
        ): Promise<FindGenerationsByModelCodeQuery> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<FindGenerationsByModelCodeQuery>({
                        document: FindGenerationsByModelCodeDocument,
                        variables,
                        requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
                        signal,
                    }),
                'FindGenerationsByModelCode',
                'query',
                variables,
            );
        },
    };
}
export type Sdk = ReturnType<typeof getSdk>;
